import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useTheme, IconButton as IconButton$1, SvgIcon, Typography, Alert as Alert$1, Stack, Collapse, Button as Button$1, CircularProgress as CircularProgress$1, useMediaQuery, Tooltip, Link, Breadcrumbs, CardActionArea, Skeleton, List, Box, tooltipClasses, Chip, Popper, Fade, Paper, ClickAwayListener, Badge, Snackbar, FormControl, InputLabel, Divider, Dialog, DialogContent, DialogActions, MenuItem, Menu, ListSubheader, CardMedia as CardMedia$1, Slider, styled, Input, OutlinedInput, FormHelperText, alpha as alpha$1, Rating, MenuList, Checkbox, menuClasses, formControlClasses, DialogTitle, Accordion, AccordionSummary, AccordionDetails, Toolbar as Toolbar$1, Card as Card$1, CardContent as CardContent$1, CardActions, LinearProgress, FormControlLabel, Radio, RadioGroup, useForkRef, Stepper, Step, StepLabel, Switch, ToggleButton as ToggleButton$1, ToggleButtonGroup, Avatar, ListItemText, ListItemIcon, Drawer } from '@mui/material';
import { grey } from '@mui/material/colors';
import * as React from 'react';
import { forwardRef, useMemo, memo, useState, useCallback, useEffect, useRef, Children, useLayoutEffect, createContext, useContext, useId, cloneElement, Fragment as Fragment$1 } from 'react';
import '@fontsource/open-sans';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/700.css';
import { createTheme, alpha } from '@mui/material/styles';
import { isString, clamp, omit, range } from 'es-toolkit';
import Close from '@mui/icons-material/Close';
import { blend, decomposeColor, Stack as Stack$1, Box as Box$1 } from '@mui/system';
import { useInRouterContext, Link as Link$1 } from 'react-router-dom';
import MuiButton from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography$1 from '@mui/material/Typography';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import { removeExtension, assert, splitFileNameAndExtension, convertToDateTimeString, isImageFileExtension, isDocumentFileExtension, mayBeEmail, humanReadableBytes, EMPTY_ARRAY, includes } from '@faro-lotv/foundation';
export { convertToDateString, convertToDateTimeString, getFileExtension, removeExtension } from '@faro-lotv/foundation';
import { DatePicker as DatePicker$1, PickersDay, usePickerLayout, PickersLayoutRoot, PickersLayoutContentWrapper, pickersLayoutClasses } from '@mui/x-date-pickers';
import { DateTime } from 'luxon';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Draggable from 'react-draggable';
import MaterialAppBar from '@mui/material/AppBar';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useLexicalIsTextContentEmpty } from '@lexical/react/useLexicalIsTextContentEmpty';
import { LinkNode, AutoLinkNode } from '@lexical/link';
import { $convertFromMarkdownString, $convertToMarkdownString, LINK } from '@lexical/markdown';
import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { EditorRefPlugin } from '@lexical/react/LexicalEditorRefPlugin';
import { LexicalErrorBoundary } from '@lexical/react/LexicalErrorBoundary';
import { HistoryPlugin } from '@lexical/react/LexicalHistoryPlugin';
import { MarkdownShortcutPlugin } from '@lexical/react/LexicalMarkdownShortcutPlugin';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import { createAnchorPoint, DEFAULT_URL_REGEX, AnchorPointPlugin } from 'lexical-anchorpoint';
import { $trimTextContentFromAnchor } from '@lexical/selection';
import { $restoreEditorState } from '@lexical/utils';
import { RootNode, $getSelection, $isRangeSelection } from 'lexical';
import Box$2 from '@mui/material/Box';
import Toolbar$2 from '@mui/material/Toolbar';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { isValid } from '@faro-lotv/ielement-types';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { SnackbarProvider, useSnackbar } from 'notistack';

/** Blue color palette */
const blue = {
    50: "#EFF4FE",
    100: "#DEE8FD",
    200: "#AEC7F9",
    300: "#7EA7F6",
    400: "#4E86F3",
    500: "#1F65F0",
    600: "#0E4ECC",
    700: "#0B3C9D",
    800: "#082A6E",
    900: "#12213D",
};
/** Cyan color palette */
const cyan$1 = {
    50: "#F5F9FF",
    100: "#E6F1FF",
    200: "#BDDCFF",
    300: "#8AC0FF",
    400: "#57A5FF",
    500: "#3392FF",
    600: "#2B7BD6",
    700: "#215EA3",
    800: "#164070",
    900: "#12263D",
};
/** Green color palette */
const green = {
    50: "#E8FCF3",
    100: "#C7F9DE",
    200: "#99F5C2",
    300: "#6BF0A6",
    400: "#3DEB8A",
    500: "#17DE6F",
    600: "#12B058",
    700: "#0D8040",
    800: "#08532A",
    900: "#123B24",
};
/** Neutral color palette */
const neutral = {
    0: "#FFFFFF",
    50: "#F8F9FA",
    100: "#F0F2F5",
    200: "#E0E4EB",
    300: "#C2C9D6",
    400: "#A3AEC2",
    500: "#8592AD",
    600: "#667799",
    700: "#525F7A",
    800: "#363C4D",
    900: "#29303D",
    950: "#20252E",
    999: "#15191F",
    1000: "#000000",
};
/** Orange color palette */
const orange = {
    50: "#FFF2EB",
    100: "#FFD3B8",
    200: "#FFB485",
    300: "#FF9452",
    400: "#FF731E",
    500: "#F26005",
    600: "#D65504",
    700: "#A34103",
    800: "#702C02",
    900: "#3D2312",
};
/** Red color palette */
const red = {
    50: "#FFEBEB",
    100: "#FDB9B9",
    200: "#FC8787",
    300: "#FB5555",
    400: "#FA2424",
    500: "#E50505",
    600: "#B30404",
    700: "#820303",
    800: "#500202",
    900: "#330F0F",
};
/** Yellow color palette */
const yellow = {
    50: "#FFF8E5",
    100: "#FFE9B2",
    200: "#FFDB80",
    300: "#FFCC4C",
    400: "#FFBE19",
    500: "#E8A600",
    600: "#CC9200",
    700: "#805B00",
    800: "#4D3700",
    900: "#33280F",
};
/** Purple color palette */
const purple = {
    50: "#F4EBFF",
    100: "#EBD9FF",
    200: "#DDBFFF",
    300: "#C28CFF",
    400: "#A659FF",
    500: "#8B26FF",
    600: "#6F1FCC",
    700: "#531799",
    800: "#380F66",
    900: "#30174C",
};
/**
 * These colors are designed for views where datasets such as point clouds need to be visually inspected.
 * The colors were chosen so that they are easily distinguishable from each other, even if the user is color blind.
 * If only 2 colors are needed, primary and secondary should be used. If more colors are needed, any of other colors
 * can be used additionally.
 */
const dataComparisonColors = {
    // primary: cyan
    primary: "#3392FF",
    // secondary: orange
    secondary: "#FF731E",
    pink: "#E81CBF",
    teal: "#17DDE5",
    lime: "#C0DB29",
    violet: "#6C008E",
    brown: "#B1410F",
    purple: "#8B26FF",
    burgundy: "#960A76",
    deepGreen: "#20805B",
    blue: "#01426A",
};
/**
 * A sorted list of the data comparison colors, so that they can easily be accessed by index, if required.
 * Sorting order was suggested by design team
 */
const dataComparisonColorsSorted = [
    dataComparisonColors.primary,
    dataComparisonColors.secondary,
    dataComparisonColors.pink,
    dataComparisonColors.teal,
    dataComparisonColors.lime,
    dataComparisonColors.violet,
    dataComparisonColors.brown,
    dataComparisonColors.purple,
    dataComparisonColors.burgundy,
    dataComparisonColors.deepGreen,
    dataComparisonColors.blue,
];

const INPUT_LIGHT_COLORS = {
    text: neutral[800],
    textReadOnly: neutral[700],
    helpText: neutral[600],
    borderIdle: neutral[500],
    borderHover: neutral[800],
    borderFocused: blue[500],
    borderDisabled: "transparent",
    borderReadOnly: "transparent",
    backgroundOutlined: neutral[0],
    backgroundOutlinedReadOnly: neutral[100],
    backgroundOutlinedDisabled: neutral[100],
    error: red[500],
    placeholder: neutral[500],
};
const INPUT_DARK_COLORS = {
    text: neutral[0],
    textReadOnly: neutral[400],
    helpText: neutral[300],
    borderIdle: neutral[700],
    borderHover: neutral[100],
    borderFocused: cyan$1[400],
    borderDisabled: "transparent",
    borderReadOnly: "transparent",
    backgroundOutlined: neutral[999],
    backgroundOutlinedReadOnly: neutral[900],
    backgroundOutlinedDisabled: neutral[900],
    error: red[300],
    placeholder: neutral[500],
};

/**
 * @returns the css styles for a MuiOutlinedInput to match the design system
 * @param theme the (partial) theme to use to determine spacings
 * @param colors colors to use for the styles
 */
function createOutlinedInputStyles(theme, colors) {
    return {
        fontSize: "0.875rem",
        color: colors.text,
        background: colors.backgroundOutlined,
        ".MuiInputBase-input": {
            padding: `${theme.spacing(5 / 4)} ${theme.spacing(3 / 2)}`,
        },
        "input::placeholder, textarea::placeholder": {
            color: colors.placeholder,
            fontStyle: "italic",
        },
        "&:hover": {
            ".MuiOutlinedInput-notchedOutline": {
                borderColor: colors.borderHover,
            },
        },
        "&.Mui-focused": {
            ".MuiOutlinedInput-notchedOutline": {
                borderColor: colors.borderFocused,
            },
        },
        "&.Mui-readOnly": {
            color: colors.textReadOnly,
            background: colors.backgroundOutlinedReadOnly,
            ".MuiOutlinedInput-notchedOutline": {
                borderColor: colors.borderReadOnly,
            },
        },
        "&.Mui-error": {
            ".MuiOutlinedInput-notchedOutline": {
                borderColor: colors.error,
                borderWidth: 2,
            },
        },
        "&.Mui-disabled": {
            opacity: 0.5,
            background: colors.backgroundOutlinedDisabled,
            ".MuiOutlinedInput-notchedOutline": {
                borderColor: colors.borderDisabled,
            },
            ".MuiOutlinedInput-input": {
                color: colors.text,
                // This browser specific prop overrides the normal color prop in the default theme
                WebkitTextFillColor: colors.text,
                "::placeholder": {
                    color: colors.placeholder,
                    WebkitTextFillColor: colors.placeholder,
                    opacity: 1,
                },
            },
        },
        ".MuiOutlinedInput-notchedOutline": {
            borderColor: colors.borderIdle,
        },
        "&.MuiInputBase-multiline": {
            padding: 0,
            textarea: {
                fontSize: "0.75rem",
                lineHeight: "initial",
            },
        },
    };
}
/**
 * @returns the css styles for a UnderlinedInput to match the design system
 * @param theme the (partial) theme to use to determine spacings
 * @param colors colors to use for the styles
 */
function createUnderlinedInputStyles(theme, colors) {
    return {
        color: colors.text,
        fontSize: "0.875rem",
        ".MuiInputBase-input": {
            padding: `${theme.spacing(1 / 2)} ${theme.spacing(3 / 2)}`,
        },
        "input::placeholder, textarea::placeholder": {
            color: colors.placeholder,
            fontStyle: "italic",
        },
        "&.MuiInputBase-multiline": {
            padding: 0,
            "textarea, input": {
                fontSize: "0.75rem",
                lineHeight: "initial",
                "::placeholder": {
                    fontStyle: "italic",
                    color: colors.placeholder,
                    opacity: 1,
                },
            },
        },
        "&.MuiInput-underline": inputUnderlineStyle(colors.borderIdle),
        "&:hover": {
            "&.MuiInput-underline": inputUnderlineStyle(colors.borderHover, 1),
        },
        "&.Mui-focused": {
            "&.MuiInput-underline": inputUnderlineStyle(colors.borderFocused, 2),
        },
        "&.Mui-readOnly": {
            "&.MuiInput-underline": inputUnderlineStyle(colors.borderReadOnly),
        },
        "&.Mui-error": {
            "&.MuiInput-underline": inputUnderlineStyle(colors.error),
            "&.Mui-focused": {
                color: colors.text,
                "&.MuiInput-underline": inputUnderlineStyle(colors.error),
            },
        },
        "&.Mui-disabled": {
            opacity: 0.5,
            "&.MuiInput-underline": {
                ...inputUnderlineStyle(colors.borderDisabled),
                "&.Mui-error": inputUnderlineStyle(colors.error),
            },
            "textarea, input": {
                color: colors.text,
                // This browser specific prop overrides the normal color prop in the default theme
                WebkitTextFillColor: colors.text,
            },
        },
    };
}
/**
 * @returns the style rules for the underline of the Input
 * @param color the color to use for the underline
 * @param size optional size(px) of the underline
 */
function inputUnderlineStyle(color, size) {
    return {
        ":before, :after": {
            borderBottomColor: color,
            borderBottomStyle: "solid",
            ...(size && { borderBottomWidth: size }),
        },
    };
}

// Import all used variants of open-sans
/** All supported font weights by the theme font (open-sans) */
var FontWeights;
(function (FontWeights) {
    FontWeights[FontWeights["Regular"] = 400] = "Regular";
    FontWeights[FontWeights["SemiBold"] = 600] = "SemiBold";
    FontWeights[FontWeights["Bold"] = 700] = "Bold";
})(FontWeights || (FontWeights = {}));
/**
 * Also see if the design team has any specific naming for the colors once
 * the design is finalized
 *
 * The numbers in front of the name suggests the opacity percentage
 */
const faroBlue = "#01426A";
const cyan = "#00CCFF";
const driftBlue = "#0077B3";
const brightBlue = "#58BFFF";
const customBlue = "#3AABFB";
const customBlue10 = "#3AABFB1A";
const blue100 = "#DEE8FD";
const blue350 = "#6699FF";
const blue400 = "#4E86F3";
const blue500 = "#1F65F0";
const blue600 = "#0E4ECC";
const blue700 = "#0B3C9D";
const blue800 = "#082A6E";
const laserBlue = "#3454DB";
const darkBlueGrey80 = "#29303DCC";
const customGrey = "#F3F3F3";
const customGreyShade2 = "#A5A5A5";
const customGreyShade3 = "#6B6B6B";
const customGreyShade4 = "#C3C3C3";
const shadow = "#00000029";
const neutralGray = "#B3B3B3";
const whiteGray = "#F0F0F0";
const blackGray = "#252527";
const darkGrey = "#3A3C3E";
const darkGrey80 = "#3A3C3ECC";
const gray50 = "#F8F9FA";
const gray100 = "#F0F2F5";
const gray200 = "#E0E4EB";
const gray300 = "#C2C9D6";
const gray400 = "#A3AEC2";
const gray500 = "#8592AD";
const gray600 = "#667799";
const gray700 = "#525F7A";
const gray800 = "#363C4D";
const gray850 = "#363C4D";
const gray900 = "#29303D";
const gray950 = "#20252E";
const gray999 = "#15191F";
const bgColor = "#f9fbfc";
const lightBlue = "#E6F7FF";
const white = "#FFFFFF";
const white10 = "#FFFFFF1A";
const black = "#000000";
const black10 = "#0000001A";
const black40 = "#00000066";
const gridBackground = "#E6F5F0";
const gridLines = "#B4BFBB";
const gridBorder = "#B4BFBB";
const yellow100 = "#FFF8E5";
const yellow500 = "#FFBE19";
const yellow600 = "#E8A600";
const orange500 = "#FF731E";
const red100 = "#FFEBEB";
const red500 = "#FA2424";
const red600 = "#E50505";
const red700 = "#B30404";
const green100 = "#E1FAED";
const green500 = "#17DE6F";
const green700 = "#0D8040";
const magenta = "#e93dc8";
const userModuleBackground = "#212121";
/** CSS backdrop filter used for transparent elements in the 3D overlay */
const backdropFilter = "blur(4px) brightness(40%)";
/** The amount of transparency on disabled texts */
const DISABLED_TEXT_ALPHA = 0.4;
/**
 * Theme definition with the basic properties needed later to define component overrides
 *
 * Contains the palette, the spacing configuration, and the basic typography definition
 */
const BaseThemeOptions = {
    palette: {
        customBlue,
        customBlue10,
        cyan,
        driftBlue,
        customGrey,
        customGreyShade2,
        customGreyShade3,
        shadow,
        darkGrey,
        darkGrey80,
        darkBlueGrey80,
        gray50,
        gray100,
        gray200,
        gray300,
        gray400,
        gray500,
        gray600,
        gray700,
        gray800,
        gray850,
        gray900,
        gray950,
        gray999,
        neutralGray,
        whiteGray,
        blackGray,
        bgColor,
        lightBlue,
        white,
        white10,
        black,
        black10,
        black40,
        gridBackground,
        gridLines,
        gridBorder,
        laserBlue,
        yellow100,
        yellow500,
        yellow600,
        orange500,
        red100,
        red500,
        red600,
        red700,
        green100,
        green500,
        green700,
        blue100,
        blue350,
        blue400,
        blue500,
        blue600,
        blue700,
        blue800,
        magenta,
        userModuleBackground,
        primary: {
            main: blue500,
        },
        secondary: {
            main: faroBlue,
        },
        info: {
            main: "#1F65F0",
            light: "#EFF4FE",
            dark: blue600,
        },
        success: {
            main: "#0D8040",
            light: "#E8FCF3",
        },
        warning: {
            main: "#CC9200",
            light: "#FFF8E5",
        },
        error: {
            main: "#E51F04",
            light: "#FFEBEB",
            dark: red700,
        },
    },
    typography: {
        fontFamily: "Open Sans",
    },
    spacing: 8,
    transitions: {
        duration: {
            shorter: 200,
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
            xxl: 1920,
            // Make sure that the values reflect the same values as in the BreakpointOverrides interface
        },
    },
};
const BaseTheme = createTheme(BaseThemeOptions);
/**
 * Overrides of styles of MUI styles, adjusting them to our design
 */
const componentOverrides = {
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    WebkitFontSmoothing: "antialiased",
                    MozOsxFontSmoothing: "grayscale",
                },
                code: {
                    fontFamily: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace",
                },
                "::-webkit-scrollbar": {
                    width: "8px",
                    height: "8px",
                },
                // Define style only for chrome compatible browsers
                "@supports selector(::-webkit-scrollbar)": {
                    "::-webkit-scrollbar-thumb": {
                        backgroundColor: neutral[100],
                        "&:hover": {
                            backgroundColor: neutral[200],
                        },
                        "&:active": {
                            backgroundColor: neutral[300],
                        },
                    },
                    "::-webkit-scrollbar-track": {
                        backgroundColor: "transparent",
                    },
                },
                // Define style for non chrome browsers (if defined in chrome compatible browsers will break the expected style)
                "@supports not selector(::-webkit-scrollbar)": {
                    "*": {
                        scrollbarColor: `${neutral[100]} transparent`,
                        scrollbarWidth: "thin",
                    },
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                root: {
                    backdropFilter: "blur(5px)",
                    fontFamily: "Open Sans",
                },
                paper: {
                    padding: BaseTheme.spacing(2),
                    borderRadius: "5px",
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    fontWeight: FontWeights.SemiBold,
                    fontSize: "22px",
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: `${BaseTheme.spacing(2)} ${BaseTheme.spacing(3)}`,
                    gap: BaseTheme.spacing(3 / 2),
                    "& > :not(:first-of-type)": {
                        marginLeft: 0,
                    },
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    transform: "unset",
                    color: INPUT_LIGHT_COLORS.text,
                    fontSize: "0.75rem",
                    fontWeight: FontWeights.Bold,
                    "&.Mui-focused": {
                        color: INPUT_LIGHT_COLORS.text,
                    },
                    "&.Mui-disabled": {
                        color: INPUT_LIGHT_COLORS.text,
                    },
                    "&.Mui-error": {
                        color: INPUT_LIGHT_COLORS.error,
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: createOutlinedInputStyles(BaseTheme, INPUT_LIGHT_COLORS),
            },
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    padding: BaseTheme.spacing(3 / 2),
                    fontSize: "0.875rem",
                    "&.Mui-disabled": {
                        ".MuiOutlinedInput-notchedOutline": {
                            borderColor: gray500,
                        },
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                    fontWeight: FontWeights.SemiBold,
                },
                containedPrimary: {
                    "&.Mui-disabled": {
                        color: alpha(white, DISABLED_TEXT_ALPHA),
                        background: BaseTheme.palette.primary.main,
                    },
                },
                textError: {
                    color: red600,
                    "&:hover ": {
                        color: white,
                        background: red600,
                    },
                },
                text: {
                    paddingLeft: BaseTheme.spacing(2),
                    paddingRight: BaseTheme.spacing(2),
                },
            },
            variants: [
                {
                    props: { variant: "info" },
                    style: {
                        backgroundColor: customBlue,
                        color: white,
                        textTransform: "none",
                        py: 1,
                        px: 2,
                        "&:hover": {
                            backgroundColor: driftBlue,
                        },
                        "&:disabled": {
                            color: `${white}80`,
                        },
                    },
                },
                {
                    props: { variant: "gray" },
                    style: {
                        backgroundColor: whiteGray,
                        color: black,
                        textTransform: "none",
                        py: 1,
                        px: 2,
                        "&:hover": {
                            backgroundColor: grey[400],
                        },
                    },
                },
                {
                    props: { variant: "danger" },
                    style: {
                        backgroundColor: red600,
                        color: white,
                        textTransform: "none",
                        py: 1,
                        px: 2,
                        "&:hover": {
                            backgroundColor: red700,
                        },
                    },
                },
                {
                    props: { variant: "darkGray" },
                    style: {
                        textTransform: "none",
                        fontSize: "16px",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        backdropFilter,
                        color: white,
                        "&.Mui-selected": {
                            backgroundColor: BaseTheme.palette.primary.main,
                            color: white,
                        },
                        "&:hover, &.Mui-selected:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.4)",
                            color: white,
                        },
                        "&:disabled": {
                            color: "rgba(255, 255, 255, 0.5)",
                        },
                    },
                },
                {
                    props: { variant: "group" },
                    style: {
                        textTransform: "none",
                        fontSize: "16px",
                        backgroundColor: "transparent",
                        backdropFilter,
                        color: white,
                        borderRadius: "6px",
                        borderColor: white10,
                        width: "46px",
                        height: "46px",
                        py: 1,
                        px: 2,
                        "&.Mui-selected": {
                            backgroundColor: BaseTheme.palette.primary.main,
                            color: white,
                        },
                        "&:hover, &.Mui-selected:hover": {
                            backgroundColor: black40,
                            color: white,
                        },
                        "&:disabled": {
                            color: white,
                            opacity: 0.5,
                        },
                    },
                },
            ],
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                    fontSize: "16px",
                    backgroundColor: neutral[999],
                    "&:hover": {
                        backgroundColor: `color-mix(in srgb, ${neutral[999]}, ${neutral[500]} 25%)`,
                    },
                    backdropFilter,
                    color: white,
                    borderRadius: "6px",
                    borderColor: "rgba(255, 255, 255, 0.1)",
                    py: 1,
                    px: 2,
                    "&.Mui-selected": {
                        backgroundColor: BaseTheme.palette.primary.main,
                        color: white,
                    },
                    "&.Mui-selected:hover": {
                        backgroundColor: `color-mix(in srgb, ${BaseTheme.palette.primary.main}, ${neutral[500]} 25%)`,
                        color: white,
                    },
                    "&:disabled": {
                        color: "rgba(255, 255, 255, 0.5)",
                    },
                },
            },
        },
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    background: customGreyShade4,
                },
                bar: {
                    background: `repeating-linear-gradient(-70deg, ${brightBlue}, ${brightBlue}, 5px, ${BaseTheme.palette.primary.main} 5px, ${BaseTheme.palette.primary.main} 15px)`,
                },
            },
        },
        MuiCircularProgress: {
            styleOverrides: {
                root: {
                    color: BaseTheme.palette.primary.main,
                },
            },
        },
        MuiBadge: {
            styleOverrides: {
                badge: {
                    borderRadius: "50%",
                    height: "12px",
                    width: "12px",
                    minWidth: "unset",
                    padding: "0",
                    border: "1.5px solid white",
                    boxSizing: "content-box",
                },
            },
            variants: [
                {
                    props: { color: "default" },
                    style: {
                        "& .MuiBadge-badge": {
                            color: black,
                            backgroundColor: white,
                        },
                    },
                },
                {
                    props: { color: "warning" },
                    style: {
                        "& .MuiBadge-badge": {
                            color: black,
                            backgroundColor: yellow600,
                        },
                    },
                },
            ],
        },
        // TODO: This styling needs to be removed as FaroTooltip from flat ui contains the proper styling - https://faro01.atlassian.net/browse/SWEB-3367
        MuiTooltip: {
            defaultProps: {
                disableInteractive: true,
            },
            styleOverrides: {
                tooltip: {
                    padding: "0.5em 1em 0.5em 1em",
                    borderRadius: "0.25em",
                    maxWidth: "20.75em",
                    fontSize: "0.875em",
                    backgroundColor: gray950,
                    outline: `1px solid ${white}33`,
                    filter: `drop-shadow(0px 1px 1px ${black}29)`,
                    // Tooltips are dark-themed, so some colors need to be adjusted here
                    ".MuiLink-root": {
                        color: blue350,
                    },
                },
            },
        },
        MuiSnackbar: {
            styleOverrides: {
                root: {
                    border: `1px solid ${white10}`,
                    borderRadius: "6px",
                    backgroundColor: blackGray,
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    "&.Mui-selected": {
                        color: BaseTheme.palette.primary.main,
                        fontWeight: 600,
                    },
                    textTransform: "none",
                    textAlign: "left",
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    "& .MuiTabs-indicator": {
                        backgroundColor: BaseTheme.palette.primary.main,
                    },
                },
            },
        },
    },
};
/**
 * The theme object contains the default component styling used throughout the application.
 * Should be extended by individual apps and then passed to `createTheme`.
 */
const FaroThemeOptions = {
    ...BaseThemeOptions,
    ...componentOverrides,
};
/**
 * @deprecated Return of `createTheme` is not compatible as argument for `createTheme`.
 *   Instead, extend `FaroThemeOptions` and then pass to `createTheme`.
 */
createTheme(FaroThemeOptions);

const LIGHT_COLORS$b = {
    color: neutral[800],
    hoverColor: blue[500],
    rippleColor: neutral[500],
    focusColor: neutral[800],
    focusBorder: neutral[999],
};
const DARK_COLORS$b = {
    color: neutral[100],
    hoverColor: cyan$1[400],
    rippleColor: neutral[500],
    focusColor: neutral[100],
    focusBorder: neutral[0],
};
var FaroIconButtonSizes;
(function (FaroIconButtonSizes) {
    FaroIconButtonSizes["xs"] = "xs";
    FaroIconButtonSizes["s"] = "s";
    FaroIconButtonSizes["m"] = "m";
    FaroIconButtonSizes["l"] = "l";
    FaroIconButtonSizes["xl"] = "xl";
})(FaroIconButtonSizes || (FaroIconButtonSizes = {}));
const FaroIconButton = forwardRef(function FaroIconButton({ size = FaroIconButtonSizes.m, margin, children, color: externalColor, hoverColor: externalHoverColor, rippleColor: externalRippleColor, disabled = false, pressed = false, dark = false, sx, ...rest }, ref) {
    const theme = useTheme();
    const sizeStyles = SIZE_STYLE_MAP$2[size];
    // The default color for the button, if defined from outside, will be used.
    // If not, then the dark prop will be used to determine the default color.
    const colorVariant = useMemo(() => (dark ? DARK_COLORS$b : LIGHT_COLORS$b), [dark]);
    // The color used by the button in the idle state.
    // If the color prop is defined, it will be used.
    const color = useMemo(() => externalColor ?? colorVariant.color, [externalColor, colorVariant]);
    // The color used by the button when hovered or focused.
    // If the hoverColor prop is defined, it will be used.
    const hoverColor = useMemo(() => externalHoverColor ?? colorVariant.hoverColor, [externalHoverColor, colorVariant]);
    // The color used by the button when pressed.
    // If the rippleColor prop is defined, it will be used.
    const rippleColor = useMemo(() => externalRippleColor ?? colorVariant.rippleColor, [externalRippleColor, colorVariant]);
    // Take the ripple color from the theme, if available, otherwise use it directly and the add the opacity.
    // This allows to pass a value to this component with the type: string (hex or color in theme)
    // or function that returns a string (color in theme).
    const rippleColorWithOpacity = useMemo(() => {
        let color;
        // If the rippleColor prop is a function, use the theme to retrieve the color
        if (typeof rippleColor === "function") {
            color = rippleColor(theme);
        }
        else if (isString(rippleColor)) {
            // Check if the rippleColor is present in the theme's palette and take it from there if available
            const colorEntry = Object.entries(theme.palette).find((entry) => entry[0] === rippleColor);
            if (colorEntry) {
                color = colorEntry[1];
            }
        }
        // rippleColor was not part of the theme but it could still be valid
        return `${color ?? rippleColor}26`;
    }, [rippleColor, theme]);
    return (jsx(IconButton$1, { ref: ref, sx: [
            {
                display: "flex",
                p: 0,
                // Set the button opacity to half if the button is disabled
                opacity: disabled ? "50%" : "100%",
                // The first child will be the image
                [">:first-of-type"]: {
                    // Font size will affect the image container size, it's set to 0 so that the container it's the size of the image
                    fontSize: 0,
                    // Apply custom color of the image
                    color,
                    ...sizeStyles,
                    // Apply margin to the button
                    margin,
                },
                // Change background color on hover
                "&:hover": {
                    backgroundColor: rippleColorWithOpacity,
                    // The first child will be the image
                    [">:first-of-type"]: {
                        // Change the color of the image when hovering the button
                        color: hoverColor,
                    },
                },
                "&& .MuiTouchRipple-root": {
                    // Make the ripple effect as big as the button
                    width: "100%",
                    height: "100%",
                    margin: 0,
                },
                // Change ripple color when the button is pressed
                "&& .MuiTouchRipple-child": {
                    backgroundColor: `${rippleColor}3F`,
                },
                // Add a border when the button is focused
                "&:focus-visible": {
                    border: `solid 2px ${colorVariant.focusBorder}`,
                    // When the button is focused also change the color of the image
                    [">:first-of-type"]: {
                        color: colorVariant.focusColor,
                    },
                },
                backgroundColor: pressed ? rippleColorWithOpacity : undefined,
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ], ...rest, disabled: disabled, children: children }));
});
// Specific style for each button size as defined in the FARO Design System
const SIZE_STYLE_MAP$2 = {
    [FaroIconButtonSizes.xs]: {
        width: "1rem",
        height: "1rem",
        m: 0.5,
    },
    [FaroIconButtonSizes.s]: {
        width: "1.25rem",
        height: "1.25rem",
        m: 1,
    },
    [FaroIconButtonSizes.m]: {
        width: "1.5rem",
        height: "1.5rem",
        m: 1,
    },
    [FaroIconButtonSizes.l]: {
        width: "2rem",
        height: "2rem",
        m: 1.5,
    },
    [FaroIconButtonSizes.xl]: {
        width: "2.5rem",
        height: "2.5rem",
        m: 1.5,
    },
};

var _path$2s;
function _extends$31() { return _extends$31 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$31.apply(null, arguments); }
const Svg3DData = props => /*#__PURE__*/React.createElement("svg", _extends$31({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path$2s || (_path$2s = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m2.719 17.982-.559-.362.722-1.12.56.36a3.66 3.66 0 0 0 1.983.455c.429.006.855-.058 1.264-.189.338-.106.652-.277.925-.503.242-.205.436-.461.566-.75.139-.312.208-.65.203-.992a1.7 1.7 0 0 0-.13-.681c-.083-.2-.206-.38-.36-.531a1.9 1.9 0 0 0-.574-.383 2.7 2.7 0 0 0-.738-.225H4.618v-1.333h1.916a1.9 1.9 0 0 0 1.476-1.95 1.7 1.7 0 0 0-.15-.725 1.5 1.5 0 0 0-.407-.547 2 2 0 0 0-.679-.375c-.308-.099-.63-.147-.955-.143a3.85 3.85 0 0 0-2.002.495l-.57.34-.686-1.145.574-.342a5.16 5.16 0 0 1 2.686-.684c.47-.005.94.068 1.387.215.41.136.79.35 1.119.63.32.276.577.62.75 1.008.178.401.268.836.264 1.275a3.26 3.26 0 0 1-1.073 2.506q.301.187.557.432a2.98 2.98 0 0 1 .89 2.166 3.7 3.7 0 0 1-.324 1.548 3.45 3.45 0 0 1-.914 1.208 4.1 4.1 0 0 1-1.367.752 5.3 5.3 0 0 1-1.685.256 4.97 4.97 0 0 1-2.706-.666m8.625.662V6.648h3.611c4.125 0 6.3 2.025 6.3 5.865a5.9 5.9 0 0 1-1.77 4.448 6.48 6.48 0 0 1-4.65 1.682zm1.333-1.333h2.158a5.13 5.13 0 0 0 3.73-1.313 4.57 4.57 0 0 0 1.361-3.485c0-3.09-1.579-4.532-4.97-4.532h-2.279z"
})));
var _3dData = "data:image/svg+xml,%3Csvg%20%20width%3D%2224%22%20%20height%3D%2225%22%20%20viewBox%3D%220%200%2024%2025%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20d%3D%22M2.71891%2017.9819L2.16016%2017.6197L2.88166%2016.4992L3.44266%2016.8607C4.0472%2017.1964%204.73449%2017.354%205.42491%2017.3152C5.85359%2017.3207%206.28034%2017.2569%206.68866%2017.1262C7.02675%2017.0198%207.34103%2016.8489%207.61416%2016.6229C7.85632%2016.4182%208.04976%2016.1619%208.18041%2015.8729C8.31898%2015.561%208.38808%2015.2227%208.38291%2014.8814C8.3869%2014.6476%208.34247%2014.4155%208.25241%2014.1997C8.16969%2014.0001%208.04721%2013.8194%207.89241%2013.6687C7.72558%2013.5079%207.53125%2013.3783%207.31866%2013.2862C7.08462%2013.1765%206.83611%2013.1007%206.58066%2013.0612H4.61791V11.7284H6.53416C6.97069%2011.6295%207.35821%2011.3795%207.62828%2011.0225C7.89836%2010.6656%208.03361%2010.2247%208.01016%209.7777C8.01336%209.52817%207.96217%209.28094%207.86016%209.0532C7.76708%208.84274%207.6279%208.65589%207.45291%208.50645C7.25257%208.33942%207.0222%208.21214%206.77416%208.13145C6.4658%208.03214%206.14333%207.98376%205.81941%207.9882C5.11931%207.96797%204.42695%208.13911%203.81691%208.4832L3.24691%208.82295L2.56141%207.6777L3.13516%207.33645C3.95115%206.86739%204.87994%206.63059%205.82091%206.6517C6.2918%206.64732%206.76024%206.72003%207.20766%206.86695C7.61743%207.00329%207.99728%207.21689%208.32666%207.4962C8.64788%207.77312%208.90398%208.11758%209.07666%208.50495C9.25522%208.90605%209.34526%209.34092%209.34066%209.77995C9.35324%2010.2504%209.2639%2010.7179%209.07877%2011.1506C8.89365%2011.5832%208.61712%2011.9707%208.26816%2012.2864C8.46878%2012.4098%208.65538%2012.5547%208.82466%2012.7184C9.10307%2012.9918%209.32503%2013.3172%209.47791%2013.6762C9.63864%2014.0585%209.71954%2014.4697%209.71566%2014.8844C9.72137%2015.4177%209.61054%2015.9458%209.39091%2016.4317C9.1796%2016.8973%208.8673%2017.31%208.47666%2017.6399C8.07373%2017.9762%207.60977%2018.2316%207.11016%2018.3922C6.56585%2018.5677%205.99676%2018.654%205.42491%2018.6479C4.47782%2018.6888%203.53883%2018.4577%202.71891%2017.9819ZM11.3439%2018.6442V6.64795H14.9552C19.0802%206.64795%2021.2552%208.67295%2021.2552%2012.5129C21.2875%2013.3369%2021.1467%2014.1585%2020.8418%2014.9247C20.5369%2015.6909%2020.0748%2016.3847%2019.4852%2016.9612C18.2185%2018.1146%2016.5466%2018.7195%2014.8352%2018.6434L11.3439%2018.6442ZM12.6767%2017.3107H14.8352C15.5128%2017.3495%2016.1913%2017.2535%2016.8315%2017.0282C17.4718%2016.8029%2018.0609%2016.4528%2018.5649%2015.9982C19.0251%2015.5464%2019.3844%2015.0022%2019.6191%2014.4015C19.8537%2013.8007%2019.9584%2013.1571%2019.9262%2012.5129C19.9262%209.4222%2018.3474%207.98145%2014.9559%207.98145H12.6774L12.6767%2017.3107Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _style$1, _path$2r, _path2$10, _path3$l;
function _extends$30() { return _extends$30 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$30.apply(null, arguments); }
const SvgSphereXgLogoColorRgb = props => /*#__PURE__*/React.createElement("svg", _extends$30({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__Layer_1",
  width: "1em",
  height: "1em",
  x: 0,
  y: 0,
  viewBox: "0 0 355 162"
}, props), _style$1 || (_style$1 = /*#__PURE__*/React.createElement("style", null, ".Sphere_XG_Logo_-_Color_-_RGB_svg__sphere-logo-main{fill:#01426a}.Sphere_XG_Logo_-_Color_-_RGB_svg__sphere-logo-secondary{fill:#3455db}")), _path$2r || (_path$2r = /*#__PURE__*/React.createElement("path", {
  d: "M148.024 96.687q-4.107-1.106-6.688-2.843l4.107-7.793a22.8 22.8 0 0 0 5.95 2.712q3.16.922 6.319.921 3.002 0 4.66-.869t1.659-2.396q0-1.316-1.501-2.054t-4.66-1.58q-3.582-.948-5.95-1.922a10.6 10.6 0 0 1-4.081-2.975q-1.712-2-1.712-5.266 0-3.95 2.159-6.924t6.161-4.608q4.001-1.631 9.373-1.632 3.949 0 7.373.816 3.421.816 5.896 2.343l-3.791 7.741q-2.158-1.37-4.766-2.08c-2.608-.71-3.52-.711-5.345-.711q-3.107 0-4.871 1t-1.764 2.58q0 1.37 1.526 2.106 1.528.738 4.739 1.58 3.58.896 5.924 1.843c2.344.947 2.905 1.598 4.028 2.896q1.685 1.948 1.686 5.108 0 3.897-2.186 6.872t-6.213 4.608q-4.029 1.631-9.348 1.632-4.575.001-8.684-1.105M206.105 69.279q3.37 2.66 3.37 7.398 0 3.791-1.922 6.688t-5.477 4.502q-3.554 1.606-8.24 1.606h-5.371l-1.527 7.583h-10.163l6.056-30.436h13.744q6.16 0 9.53 2.659m-8.188 11.453q1.29-1.158 1.29-3.16 0-1.685-1.08-2.501t-3.08-.816h-3.581l-1.527 7.635h4.371q2.316 0 3.607-1.158M247.178 66.62l-6.108 30.436h-10.163l2.265-11.374h-10.005l-2.265 11.374h-10.163l6.056-30.436h10.163l-2.159 10.953h10.005l2.212-10.953zM262.552 74.097l-.789 4.002h13.164l-1.422 7.056h-13.164l-.896 4.423h15.534l-1.475 7.478h-25.539l6.056-30.436h24.96l-1.475 7.478zM309.155 83.681q-2.212 3.002-6.161 4.476l5.213 8.899h-10.584l-4.424-7.688h-2.843l-1.527 7.688h-10.163l6.056-30.436h13.849q6.055 0 9.426 2.633 3.37 2.634 3.37 7.319-.002 4.107-2.212 7.109m-9.19-8.583q-1.133-.843-3.08-.843h-3.528l-1.527 7.635h4.318q2.316 0 3.634-1.158 1.316-1.158 1.316-3.16 0-1.632-1.133-2.474M327.584 74.097l-.789 4.002h13.164l-1.422 7.056h-13.164l-.896 4.423h15.534l-1.475 7.478h-25.539l6.056-30.436h24.96l-1.475 7.478z",
  className: "Sphere_XG_Logo_-_Color_-_RGB_svg__sphere-logo-main"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_1_",
  x1: 123.679,
  x2: 15.596,
  y1: 158.143,
  y2: 158.143,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M90.334 158.151q.408-.006.816-.016l-.863.016z",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_1_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000122691939579634749710000016140102806956635832_",
  x1: 123.679,
  x2: 15.596,
  y1: 81.981,
  y2: 81.981,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M17.262 80.951c-.058 2.452.317 5.016 1.031 7.034 1.539 4.35 5.213 7.371 8.11 1.727 2.506-6.086 1.181-14.284-1.632-17.275-3.396-3.611-7.326.845-7.509 8.514",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000122691939579634749710000016140102806956635832_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000108281421602319004610000002935681579854070442_",
  x1: 123.679,
  x2: 15.596,
  y1: 67.155,
  y2: 67.155,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M25.277 70.681c.68 5.507 5.15 9.336 9.933 3.342 3.809-5.7 2.98-12.027 1.174-14.699-3.183-4.709-9.398-.924-10.903 6.64-.304 1.528-.38 3.291-.204 4.717",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000108281421602319004610000002935681579854070442_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000062899252350258803400000006452798929521711257_",
  x1: 123.679,
  x2: 15.596,
  y1: 96.788,
  y2: 96.788,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M26.477 98.879c1.892 6.079 7.925 10.902 11.233 4.936 2.306-5.49-.166-12.741-3.917-15.558-4.568-3.429-8.787.737-7.921 7.821.102.832.351 1.984.605 2.801",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000062899252350258803400000006452798929521711257_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000000199521709349947990000013169840349870900097_",
  x1: 123.679,
  x2: 15.596,
  y1: 66.937,
  y2: 66.937,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M18.503 73.862c2.378-4.995 3.129-13.57 1.411-16.097-1.614-2.373-4.542 1.657-5.803 7.985-.724 3.636-.73 7.313-.014 9.366.157.448 1.608 4.219 4.406-1.254",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000000199521709349947990000013169840349870900097_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000139986685407783468530000007711435610983319217_",
  x1: 123.679,
  x2: 15.596,
  y1: 96.883,
  y2: 96.883,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M21.692 103.91c.583-5.956-2.184-14.367-4.674-16.298-2.404-1.864-3.651 2.352-2.517 8.511.645 3.506 1.984 7.011 3.411 8.93.489.657 2.973 3.697 3.78-1.143",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000139986685407783468530000007711435610983319217_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000145767616473413220620000003275638393888781987_",
  x1: 123.679,
  x2: 15.596,
  y1: 81.945,
  y2: 81.945,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M33.872 81.119a15 15 0 0 0 .042 1.902c.696 7.403 7.609 11.961 12.435 5.951 2.975-4.11 2.589-10.936-.825-14.607-4.622-4.971-11.265-1.12-11.652 6.754",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000145767616473413220620000003275638393888781987_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000168828492323578885110000006331516876797389706_",
  x1: 123.679,
  x2: 15.596,
  y1: 52.795,
  y2: 52.795,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M27.721 58.891c3.849-5.183 4.466-11.175 3.432-13.508-1.531-3.452-6.284-.03-8.769 6.312-1.281 3.269-1.247 5.625-1.173 6.486.265 3.087 2.517 5.447 6.51.71",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000168828492323578885110000006331516876797389706_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000119825009282355398870000002427391825971570065_",
  x1: 123.679,
  x2: 15.596,
  y1: 110.833,
  y2: 110.833,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M33.085 117.046c.647-4.622-3.229-12.573-7.031-14.421-3.364-1.635-4.781 2.168-2.862 7.677a20.6 20.6 0 0 0 2.396 4.748c2.58 3.779 6.62 6.574 7.497 1.996",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000119825009282355398870000002427391825971570065_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000135687005885930954780000007562071303343076235_",
  x1: 123.679,
  x2: 15.596,
  y1: 81.891,
  y2: 81.891,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M10.99 80.892c.048 4.972.7 9.619 1.485 10.579.761.93 1.141-1.721 1.266-2.592.698-5.494.024-15.099-1.164-16.576-.9-1.119-1.642 2.895-1.587 8.589",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000135687005885930954780000007562071303343076235_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000027573844424622963070000005045413081647210387_",
  x1: 123.679,
  x2: 15.596,
  y1: 52.892,
  y2: 52.892,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M37.869 51.882a10.8 10.8 0 0 0-.573 3.147c-.136 5.589 4.837 8.404 9.919 3.521 3.084-3.214 4.138-8.407 2.35-11.576-2.601-4.611-9.488-1.721-11.696 4.908",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000027573844424622963070000005045413081647210387_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000137812898909728225410000000398060100545818550_",
  x1: 123.679,
  x2: 15.596,
  y1: 110.753,
  y2: 110.753,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M50.857 116.508c2.08-4.578-.768-10.544-4.704-12.819-4.774-2.76-8.827.795-7.479 6.558 1.427 6.099 8.774 11.834 12.183 6.261",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000137812898909728225410000000398060100545818550_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000036210321468949231540000007790552816983797179_",
  x1: 123.679,
  x2: 15.596,
  y1: 110.771,
  y2: 110.771,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M15.422 102.83c-.941-.445-.176 2.93 1.67 7.37 1.936 4.656 4.079 8.162 4.866 8.516.669.301.234-1.411.049-2.142-1.511-5.284-5.265-13.12-6.585-13.744",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000036210321468949231540000007790552816983797179_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000177472600690211122990000006503221024441719981_",
  x1: 123.679,
  x2: 15.596,
  y1: 52.666,
  y2: 52.666,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M16.092 58.384c2.658-5.291 4.872-12.708 4.368-13.744-.43-.883-2.388 2.377-4.19 6.977-1.627 4.156-2.631 8.213-2.237 9.044s1.648-1.508 2.059-2.277",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000177472600690211122990000006503221024441719981_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000043438139329708308660000015822744963709389210_",
  x1: 123.679,
  x2: 15.596,
  y1: 66.994,
  y2: 66.994,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M58.212 72.969c3.815-4.626 2.555-9.377 1.209-11.455-3.778-5.832-11.911-2.997-13.185 4.595a11 11 0 0 0-.14 1.636c-.017 6.744 6.596 10.788 12.116 5.224",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000043438139329708308660000015822744963709389210_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000050621569454675735740000001964733990937374595_",
  x1: 123.679,
  x2: 15.596,
  y1: 39.768,
  y2: 39.768,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M34.581 38.878c-.895 1.614-1.433 3.321-1.474 4.682-.097 3.153 2.497 5.114 6.941 1.145 3.144-2.99 5.064-7.943 4.109-10.599-1.291-3.587-6.809-.218-9.576 4.772",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000050621569454675735740000001964733990937374595_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000099660364721125034880000005073820371753241730_",
  x1: 123.679,
  x2: 15.596,
  y1: 96.814,
  y2: 96.814,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M59.624 102.808c3.407-4.899.778-10.218-1.679-12.42-4.923-4.412-11.586-1.028-11.317 5.747.256 6.459 7.766 12.644 12.996 6.673",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000099660364721125034880000005073820371753241730_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000152981512894964917610000006976944404649027202_",
  x1: 123.679,
  x2: 15.596,
  y1: 123.488,
  y2: 123.488,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M36.553 124.396c2.582 4.139 8.725 8.648 9.751 4.096.439-4.473-3.861-10.211-7.558-11.596-3.597-1.348-5.073 1.772-2.925 6.182.198.407.493.934.732 1.318",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000152981512894964917610000006976944404649027202_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000059298183092284374220000017110963526683306148_",
  x1: 123.679,
  x2: 15.596,
  y1: 123.457,
  y2: 123.457,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M32.139 130.087c1.842.979 1.322-.973 1.151-1.614-1.176-3.928-6.402-11.324-8.857-11.883-1.668-.38-1.061 2.63 1.299 6.442 2.188 3.534 4.934 6.272 6.407 7.055",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000059298183092284374220000017110963526683306148_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000052810101756662128740000009060811739823908506_",
  x1: 123.679,
  x2: 15.596,
  y1: 39.749,
  y2: 39.749,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M21.76 46.01c.065.579.527 2.193 3.733-1.324 3.764-4.472 6.025-10.117 5.654-11.595-.424-1.691-3.909 1.304-6.659 5.722-2.07 3.326-2.862 6.011-2.728 7.197",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000052810101756662128740000009060811739823908506_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000030467902775817769060000007710743212976295583_",
  x1: 123.679,
  x2: 15.596,
  y1: 81.895,
  y2: 81.895,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M71.645 87.645c3.656-4.4 1.938-9.254-.11-11.443-4.574-4.891-12.094-1.876-12.572 5.041-.016.233-.024.545-.02.778.123 6.594 7.362 10.868 12.702 5.624",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000030467902775817769060000007710743212976295583_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000180341006968639202810000003347100774493131935_",
  x1: 123.679,
  x2: 15.596,
  y1: 134.578,
  y2: 134.578,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M46.588 138.512c-1.533-3.849-7.232-9.348-9.679-9.34-1.608.005-.993 2.363 1.342 5.149 1.711 2.041 4.171 4.084 6.122 5.083 1.958 1.003 2.703.702 2.215-.892",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000180341006968639202810000003347100774493131935_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000172437836869410601830000017357335535451569809_",
  x1: 123.679,
  x2: 15.596,
  y1: 28.204,
  y2: 28.204,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M38.086 32.099c3.431-2.867 6.175-7.401 5.931-8.964-.292-1.871-4.604.931-7.49 4.313-1.621 1.899-2.673 3.795-2.816 5.073-.15 1.358.89 2.367 4.375-.422",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000172437836869410601830000017357335535451569809_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000078723697224134013200000007992507812905159567_",
  x1: 123.679,
  x2: 15.596,
  y1: 39.767,
  y2: 39.767,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M52.538 38.964a7.5 7.5 0 0 0-.587 2.414c-.293 4.756 4.812 6.382 8.811 2.805 3.517-3.419 3.196-6.951 2.452-8.499-2.152-4.476-8.565-1.784-10.676 3.28",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000078723697224134013200000007992507812905159567_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000163053878163007453100000004624683950133212288_",
  x1: 123.679,
  x2: 15.596,
  y1: 123.367,
  y2: 123.367,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M64.42 127.813c1.739-3.333-.444-7.607-3.574-9.508-4.426-2.689-8.503.005-7.151 4.724 1.318 4.602 7.808 8.962 10.725 4.784",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000163053878163007453100000004624683950133212288_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000028292862012794903440000011988512145044200613_",
  x1: 123.679,
  x2: 15.596,
  y1: 28.169,
  y2: 28.169,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M53.853 31.843c3.39-2.887 4.118-6.083 3.78-7.527-.748-3.191-5.932-.808-8.624 3.099-.915 1.328-1.248 2.384-1.367 3.035-.555 3.065 2.257 4.336 6.211 1.393",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000028292862012794903440000011988512145044200613_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000042718578562191629250000012247638859564900779_",
  x1: 123.679,
  x2: 15.596,
  y1: 134.599,
  y2: 134.599,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M59.872 138.295c.364-3.179-3.48-7.884-7.092-8.68-2.941-.648-3.994 1.629-2.168 4.687 2.289 3.831 8.313 7.468 9.26 3.993",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000042718578562191629250000012247638859564900779_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000132770191053423491140000007632210908060457144_",
  x1: 123.679,
  x2: 15.596,
  y1: 110.711,
  y2: 110.711,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M73.406 115.49c2.777-3.585.967-7.563-.926-9.363-4.373-4.156-11.013-1.592-10.604 4.094.404 5.614 7.25 9.648 11.53 5.269",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000132770191053423491140000007632210908060457144_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000163068424181906487300000009725152635015269520_",
  x1: 123.679,
  x2: 15.596,
  y1: 52.725,
  y2: 52.725,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M73.318 48.805c-2.912-5.088-10.739-3.064-12.137 3.14-.088.389-.16.918-.177 1.316-.233 5.396 5.77 8.606 10.814 4.187 3.897-4.137 1.757-8.194 1.5-8.643",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000163068424181906487300000009725152635015269520_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000034077442624591069820000009218002277992221871_",
  x1: 123.679,
  x2: 15.596,
  y1: 28.104,
  y2: 28.104,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M29.041 31.793c2.348-2.403 7.45-8.318 7.377-8.985-.37-.21-3 2.218-5.104 4.529-2.231 2.45-4.533 5.465-4.364 6.062.266.12 1.028-.555 2.091-1.606",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000034077442624591069820000009218002277992221871_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000157995984871680439450000004804474724353645455_",
  x1: 123.679,
  x2: 15.596,
  y1: 134.528,
  y2: 134.528,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M29.299 129.473c-.118.468 1.822 2.812 3.708 4.78 2.859 2.984 5.891 5.468 6.276 5.333.022-.162-.19-.471-.908-1.324-1.639-1.885-8.325-9.068-9.076-8.789",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000157995984871680439450000004804474724353645455_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000176037832161755113060000007618979071475921058_",
  x1: 123.679,
  x2: 15.596,
  y1: 96.739,
  y2: 96.739,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M74.46 96.234c-.313 6.102 7.031 9.453 11.39 5.196 3.174-3.475 1.715-7.141.352-8.76-3.971-4.718-11.433-2.453-11.742 3.564",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000176037832161755113060000007618979071475921058_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000113354167512336820520000006842766831457106848_",
  x1: 123.679,
  x2: 15.596,
  y1: 66.833,
  y2: 66.833,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M85.533 71.489c3.263-3.594 1.865-7.295.525-8.915-3.799-4.591-11.13-2.419-11.886 3.52a8 8 0 0 0-.05.635c-.163 5.125 6.054 9.595 11.411 4.76",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000113354167512336820520000006842766831457106848_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000064318501803466698530000000160626057362371239_",
  x1: 123.679,
  x2: 15.596,
  y1: 143.859,
  y2: 143.859,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M60.24 146.597c-1.377-2.7-6.292-6.448-8.481-6.467-1.472-.013-.959 1.655 1.1 3.571 1.382 1.286 3.303 2.556 5.014 3.314 1.398.619 2.944 1.05 2.367-.418",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000064318501803466698530000000160626057362371239_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000124135087498030474290000011655190472795675011_",
  x1: 123.679,
  x2: 15.596,
  y1: 143.823,
  y2: 143.823,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M51.62 146.579c-2.712-2.451-8.235-6.491-9.416-6.476-.724.01.487 1.539 3.19 3.571 2.987 2.246 6.651 4.168 6.977 3.827-.011-.179-.159-.36-.751-.922",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000124135087498030474290000011655190472795675011_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000107549470292331867980000014750780667726015912_",
  x1: 123.679,
  x2: 15.596,
  y1: 18.378,
  y2: 18.378,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M52.158 21.089c3.573-2.496 5.185-5.265 5.219-6.127.063-1.597-3.912.314-6.654 2.814-1.319 1.202-2.223 2.409-2.48 3.311-.365 1.275.608 2.119 3.915.002",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000107549470292331867980000014750780667726015912_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000102516119588716095730000007221224109596897212_",
  x1: 123.679,
  x2: 15.596,
  y1: 18.348,
  y2: 18.348,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M41.771 21.071c3.259-2.313 7.197-5.95 7.306-6.578.118-.677-3.094 1.111-5.825 3.243-2.488 1.943-3.962 3.621-4.131 4.275-.101.389.11.784 2.65-.94",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000102516119588716095730000007221224109596897212_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000128477840900087556850000015154316707693435269_",
  x1: 123.679,
  x2: 15.596,
  y1: 28.113,
  y2: 28.113,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M67.569 27.554c-.155.378-.297.9-.344 1.269-.458 3.569 3.712 4.982 6.864 2.326 2.759-2.561 1.886-5.064 1.684-5.54-1.412-3.308-6.548-2.09-8.204 1.945",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000128477840900087556850000015154316707693435269_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000056407624679554967980000016847754198413517485_",
  x1: 123.679,
  x2: 15.596,
  y1: 134.49,
  y2: 134.49,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M74.54 130.997c-3.026-1.686-6.541-.22-5.57 3.281.875 3.155 5.533 6.091 7.894 3.263 1.472-2.319-.013-5.256-2.324-6.544",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000056407624679554967980000016847754198413517485_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000167376588874201946570000018213694390410607493_",
  x1: 123.679,
  x2: 15.596,
  y1: 123.353,
  y2: 123.353,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M77.556 123.045c.134 4.011 5.118 6.818 8.584 3.708 1.845-1.84 1.723-4.839-.273-6.684-2.989-2.764-8.459-1.449-8.311 2.976",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000167376588874201946570000018213694390410607493_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000057112839509476852940000013562575419161609146_",
  x1: 123.679,
  x2: 15.596,
  y1: 39.61,
  y2: 39.61,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M76.713 39.016a6 6 0 0 0-.072.472c-.427 4.149 4.53 6.892 8.553 3.489 1.794-1.68 2.122-4.305.779-6.243-2.49-3.592-8.375-2.142-9.26 2.282",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000057112839509476852940000013562575419161609146_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000079460158622750419550000016549781586481150880_",
  x1: 123.679,
  x2: 15.596,
  y1: 143.871,
  y2: 143.871,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M72.233 146.265c.409-1.808-2.179-5.063-5.045-5.59-1.941-.357-3.059.905-1.593 3.067 1.625 2.394 5.936 4.681 6.638 2.523",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000079460158622750419550000016549781586481150880_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000070106482567904741890000001921094174100306831_",
  x1: 123.679,
  x2: 15.596,
  y1: 18.268,
  y2: 18.268,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M67.323 20.648c2.953-2.289 2.66-4.565 2.646-4.661-.348-2.4-4.307-.928-6.371 1.804-.664.879-.894 1.573-.97 2.001-.388 2.186 2.2 2.658 4.695.856",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000070106482567904741890000001921094174100306831_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000144295474034070890990000007817825231218805413_",
  x1: 123.679,
  x2: 15.596,
  y1: 10.544,
  y2: 10.544,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M56.163 12.244c2.093-1.071 6.31-3.769 6.292-4.203-.297-.222-2.941.851-5.143 2.087-2.184 1.226-3.442 2.301-3.555 2.729-.068.254.156.511 2.406-.613",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000144295474034070890990000007817825231218805413_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000127730992518369212560000004935042208330688432_",
  x1: 123.679,
  x2: 15.596,
  y1: 151.028,
  y2: 151.028,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M65.43 152.725c-1.761-1.124-7.401-4.208-8.257-3.955-.422.125.633 1.067 2.822 2.219 2.408 1.267 5.445 2.375 6.042 2.309l.033-.071c-.089-.124-.209-.218-.64-.502",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000127730992518369212560000004935042208330688432_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000110446295796125680660000011187903342483015593_",
  x1: 123.679,
  x2: 15.596,
  y1: 81.792,
  y2: 81.792,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M90.196 81.304c-.437 4.981 5.463 8.604 9.831 4.578 2.348-2.438 1.945-5.823.373-7.77-3.263-4.04-9.747-2.011-10.204 3.192",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000110446295796125680660000011187903342483015593_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000070807209349108861420000004662275095824104121_",
  x1: 123.679,
  x2: 15.596,
  y1: 110.639,
  y2: 110.639,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M90.731 110.315c-.396 3.95 4.417 6.805 8.162 3.666 1.813-1.673 2.106-4.419.666-6.254-2.627-3.346-8.403-1.653-8.828 2.588",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000070807209349108861420000004662275095824104121_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000181766665731215728440000002795684730232666788_",
  x1: 123.679,
  x2: 15.596,
  y1: 52.471,
  y2: 52.471,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M99.043 55.842c2.265-2.603 1.039-5.289-.043-6.466-2.95-3.207-8.273-1.594-8.63 2.616-.347 4.089 5.039 7.198 8.673 3.85",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000181766665731215728440000002795684730232666788_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000139254581274291156830000007336169736159569559_",
  x1: 123.679,
  x2: 15.596,
  y1: 151.053,
  y2: 151.053,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M66.552 148.974c-.805.114-.331 1 1.081 2.017 1.314.947 3.057 1.732 4.099 2.018 1.453.4 1.112-.186.983-.406-1.124-1.551-4.748-3.829-6.163-3.629",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000139254581274291156830000007336169736159569559_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000153672128272945661450000018077986166064404644_",
  x1: 123.679,
  x2: 15.596,
  y1: 10.508,
  y2: 10.508,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M65.932 12.085c2.36-1.378 3.698-3.055 3.753-3.568.098-.912-2.675.189-4.629 1.623-.954.7-1.643 1.427-1.842 1.945-.294.769.486 1.196 2.718 0",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000153672128272945661450000018077986166064404644_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000088813030132609527630000000840570861706508965_",
  x1: 123.679,
  x2: 15.596,
  y1: 96.663,
  y2: 96.663,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M106.561 96.369a4 4 0 0 0-.031.377c-.118 3.168 3.389 5.22 6.204 2.699 1.438-1.43 1.692-3.681.592-5.237-1.949-2.753-6.311-1.36-6.765 2.161",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000088813030132609527630000000840570861706508965_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000042003881320679131280000000817094036635403146_",
  x1: 123.679,
  x2: 15.596,
  y1: 66.618,
  y2: 66.618,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M106.502 66.213a5 5 0 0 0 0 .38c.149 3.308 3.995 5.476 6.612 2.804 1.353-1.541 1.222-4.049-.292-5.591-2.328-2.371-6.168-.909-6.32 2.407",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000042003881320679131280000000817094036635403146_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000170279427261400862440000004292432490584434101_",
  x1: 123.679,
  x2: 15.596,
  y1: 4.981,
  y2: 4.981,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M70.481 5.736c1.108-.401 4.023-1.624 4.311-1.849l.001-.037c-.255-.032-1.845.399-3.27.928-1.463.543-2.569 1.12-2.519 1.314.159.083.706-.082 1.477-.356",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000170279427261400862440000004292432490584434101_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000116941336711554308390000001645358138721819049_",
  x1: 123.679,
  x2: 15.596,
  y1: 18.186,
  y2: 18.186,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M85.104 19.81c1.372-1.34.782-2.594.568-2.947-1.145-1.89-3.975-.952-4.568 1.018a3 3 0 0 0-.09.445c-.188 1.879 2.145 3.047 4.09 1.484",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000116941336711554308390000001645358138721819049_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000051358159326764444480000009488012094096436618_",
  x1: 123.679,
  x2: 15.596,
  y1: 143.793,
  y2: 143.793,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M86.117 142.108c-1.694-1.197-3.838-.256-3.586 1.573.232 1.678 2.607 3.229 4.166 1.716.975-1.182.429-2.576-.58-3.289",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000051358159326764444480000009488012094096436618_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000114040064972220396600000017173229231029556104_",
  x1: 123.679,
  x2: 15.596,
  y1: 10.391,
  y2: 10.391,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M78.553 11.532c1.301-.976 1.249-1.93 1.226-2.111-.168-1.291-2.247-.628-3.251.739-.275.375-.365.682-.391.797-.238 1.057.935 1.543 2.416.575",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000114040064972220396600000017173229231029556104_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000077319424412082093350000011191704370380397242_",
  x1: 123.679,
  x2: 15.596,
  y1: 134.481,
  y2: 134.481,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M91.765 134.298c-.255 1.978 2.135 3.826 4.432 2.008 1.453-1.369 1-2.841.557-3.427-1.381-1.832-4.692-.891-4.989 1.419",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000077319424412082093350000011191704370380397242_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000153690920891616182350000006129345594591774860_",
  x1: 123.679,
  x2: 15.596,
  y1: 27.89,
  y2: 27.89,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M96.099 29.763c1.32-1.577.207-3.093-.029-3.381-1.682-2.048-4.881-1.276-5.033 1.215-.141 2.303 3.065 4.073 5.062 2.166",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000153690920891616182350000006129345594591774860_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000151545741716367953150000006428574012513285305_",
  x1: 123.679,
  x2: 15.596,
  y1: 151.083,
  y2: 151.083,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M79.591 149.604c-1.058-.178-1.485.511-.877 1.418.757 1.129 2.815 2.171 3.244 1.152.265-.813-.959-2.333-2.367-2.57",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000151545741716367953150000006428574012513285305_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000067958700782405560120000004250833630487242895_",
  x1: 123.679,
  x2: 15.596,
  y1: 123.315,
  y2: 123.315,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M105.067 123.116a4 4 0 0 0-.046.228c-.297 1.931 1.696 3.173 3.654 1.665 1.372-1.264 1.119-2.634.794-3.182-.918-1.548-3.837-1.001-4.402 1.289",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000067958700782405560120000004250833630487242895_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000102512024678794956260000011740393736788144049_",
  x1: 123.679,
  x2: 15.596,
  y1: 39.345,
  y2: 39.345,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M109.369 41.056c.753-.949.446-2.539-.67-3.471-1.699-1.418-3.941-.519-3.808 1.527.136 2.109 2.926 3.667 4.478 1.944",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000102512024678794956260000011740393736788144049_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000104674109392723083100000001383324520108186250_",
  x1: 123.679,
  x2: 15.596,
  y1: 4.922,
  y2: 4.922,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M77.734 5.486c.947-.452 1.686-1.063 1.759-1.268.118-.332-1.099.074-1.983.589-.487.284-.82.563-.889.746-.08.21.212.328 1.113-.067",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000104674109392723083100000001383324520108186250_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000097486671545370010930000015418153806677484168_",
  x1: 123.679,
  x2: 15.596,
  y1: 81.682,
  y2: 81.682,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M125.669 80.18c-1.065-1.389-3.061-.602-3.236 1.276a3 3 0 0 0-.006.423c.118 1.847 2.043 2.682 3.169 1.376a2.57 2.57 0 0 0 .073-3.075",
  style: {
    fill: "url(#Sphere_XG_Logo_-_Color_-_RGB_svg__SVGID_00000097486671545370010930000015418153806677484168_)"
  }
}), _path2$10 || (_path2$10 = /*#__PURE__*/React.createElement("path", {
  d: "m159.265 117.35 5.805 10.581h-7.678l-2.793-5.621-4.812 5.621h-8.45l10.177-10.948-5.474-10.287h7.568l2.719 5.4 4.739-5.4h8.046z",
  className: "Sphere_XG_Logo_-_Color_-_RGB_svg__sphere-logo-secondary"
})), _path3$l || (_path3$l = /*#__PURE__*/React.createElement("path", {
  d: "M182.521 116.945h6.283l-2.205 10.985h-4.445l.258-1.359q-2.242 1.837-5.621 1.837-2.646 0-4.832-1.157a8.8 8.8 0 0 1-3.472-3.288q-1.286-2.13-1.286-4.96 0-3.71 1.745-6.631 1.745-2.92 4.905-4.537 3.159-1.617 7.201-1.617 3.232 0 5.749 1.047t3.986 3.031l-5.106 3.931q-.992-1.286-2.223-1.837t-2.774-.551q-2.865 0-4.592 1.874-1.727 1.873-1.727 4.776 0 1.984 1.102 3.178t3.013 1.194q1.58 0 3.013-.845z",
  className: "Sphere_XG_Logo_-_Color_-_RGB_svg__sphere-logo-secondary"
})));

var _path$2q;
function _extends$2$() { return _extends$2$ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2$.apply(null, arguments); }
const SvgAlignIterative = props => /*#__PURE__*/React.createElement("svg", _extends$2$({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$2q || (_path$2q = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m15.627 7.333 1.1-1.1H9.334v-.666h7.393l-1.1-1.094L16.1 4 18 5.9l-1.9 1.907zm6.04-2.433a1 1 0 1 1-.707 1.707 1 1 0 0 1 .707-1.707m0-.667a1.666 1.666 0 1 0 0 3.333 1.666 1.666 0 1 0 0-3.333M7.334 5.851a1.667 1.667 0 1 1-3.332.1 1.667 1.667 0 0 1 3.332-.1m6.06 6.482-1.1 1.1.473.467 1.9-1.9-1.9-1.9-.473.467 1.1 1.1H6v.666zm3.333 6.1-1.1 1.094.473.473 1.9-1.9-1.9-1.907-.473.474 1.1 1.1H9.334v.666zm-9.394-.381a1.667 1.667 0 1 1-3.331.1 1.667 1.667 0 0 1 3.331-.1m-4.95-4.388a1.667 1.667 0 1 0-.1-3.332 1.667 1.667 0 0 0 .1 3.332M21.667 17.1a1 1 0 1 1-.707 1.707 1 1 0 0 1 .707-1.707m0-.667a1.666 1.666 0 1 0 0 3.333 1.666 1.666 0 1 0 0-3.333m-2.627-5.14a1 1 0 0 0-1.413 0 1 1 0 1 0 1.413 0m-1.886-.473a1.66 1.66 0 0 1 1.18-.487 1.666 1.666 0 1 1 0 3.333 1.666 1.666 0 0 1-1.18-2.847",
  clipRule: "evenodd"
})));

var _path$2p;
function _extends$2_() { return _extends$2_ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2_.apply(null, arguments); }
const SvgAlignToModel = props => /*#__PURE__*/React.createElement("svg", _extends$2_({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$2p || (_path$2p = /*#__PURE__*/React.createElement("path", {
  d: "M7.6 11.4v1h2.3L3 19.3l.8.7 6.8-6.9v2.4h1v-4.1zM20.6 24.4v1h2.3L16 32.3l.8.7 6.8-6.9v2.4h1v-4.1zM7.6 24.4v1h2.3L3 32.3l.8.7 6.8-6.9v2.4h1v-4.1zM34.6 6.4 25.2 1l-9.3 5.4v10.7l9.4 5.4 9.3-5.3zm-12.4 8.1L20.8 13l-2.9 1.7V8.5l6.4 3.6v7.4l-5.4-3.1zm4-7V3.9l5.3 3-6.2 3.6L19 6.9l5.2-3v3.6zm2 7 3.4 1.9-5.4 3.1v-7.4l6.4-3.6v6.2L29.7 13z"
})));

var _path$2o;
function _extends$2Z() { return _extends$2Z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2Z.apply(null, arguments); }
const SvgAlignToPointCloud = props => /*#__PURE__*/React.createElement("svg", _extends$2Z({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$2o || (_path$2o = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m16.053 32.259 6.836-6.835H20.56v-1h4.035v4.035h-1V26.13l-6.835 6.836Zm-13 0 6.835-6.835H7.561v-1h4.033v4.035h-1V26.13L3.76 32.966Zm0-13 6.835-6.836H7.561v-1h4.033v4.035h-1v-2.327L3.76 19.966Zm27.454-2.288a1.746 1.746 0 1 1 1.746 1.747 1.746 1.746 0 0 1-1.746-1.746Zm-6.753 0a1.746 1.746 0 1 1 1.747 1.747 1.746 1.746 0 0 1-1.748-1.746Zm-6.753 0a1.746 1.746 0 1 1 1.746 1.747 1.746 1.746 0 0 1-1.746-1.746Zm13.506-6.111a1.746 1.746 0 1 1 1.746 1.746 1.747 1.747 0 0 1-1.746-1.746m-6.753 0a1.746 1.746 0 1 1 1.747 1.746 1.747 1.747 0 0 1-1.748-1.746Zm-6.753 0a1.746 1.746 0 1 1 1.746 1.746 1.746 1.746 0 0 1-1.746-1.746m13.506-6.113a1.746 1.746 0 1 1 1.746 1.746 1.747 1.747 0 0 1-1.746-1.746m-6.753 0a1.746 1.746 0 1 1 1.747 1.746 1.747 1.747 0 0 1-1.748-1.746Zm-6.753 0a1.746 1.746 0 1 1 1.746 1.746 1.746 1.746 0 0 1-1.746-1.746",
  "data-name": "register-pointcloud"
})));

var _path$2n, _path2$$;
function _extends$2Y() { return _extends$2Y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2Y.apply(null, arguments); }
const SvgAlignToSheet = props => /*#__PURE__*/React.createElement("svg", _extends$2Y({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$2n || (_path$2n = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z"
})), _path2$$ || (_path2$$ = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.56 11.42v1h2.33l-6.84 6.84.71.71 6.84-6.84v2.33h1v-4.04zM20.56 24.42v1h2.33l-6.84 6.84.71.71 6.84-6.84v2.33h1v-4.04zM7.56 24.42v1h2.33l-6.84 6.84.71.71 6.84-6.84v2.33h1v-4.04zM15 2v11.32h8.68v6.11H35V2zm10.68 15.43v-8h-2v1.89H17V4h6.68v2.21h2V4H33v4.75h-3.5v2H33v6.68z"
})));

var _g$M, _defs$k;
function _extends$2X() { return _extends$2X = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2X.apply(null, arguments); }
const SvgAnalysisMarker = props => /*#__PURE__*/React.createElement("svg", _extends$2X({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _g$M || (_g$M = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#analysis-marker_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#29303D",
  stroke: "#fff",
  strokeWidth: 2,
  d: "M16 31c8.284 0 15-6.716 15-15S24.284 1 16 1 1 7.716 1 16s6.716 15 15 15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M10.5 12.75a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5m11-3a.749.749 0 1 1 0 1.5.749.749 0 1 1 0-1.5m0-1c-.965 0-1.75.785-1.75 1.75s.785 1.75 1.75 1.75 1.75-.785 1.75-1.75-.785-1.75-1.75-1.75M16 11.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5.5 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-4 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-7-6c.275 0 .5.225.5.5s-.225.5-.5.5a.5.5 0 0 1-.5-.5c0-.275.226-.5.5-.5m0-1c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5S12 16.83 12 16s-.67-1.5-1.5-1.5m1 7c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1m-3 0a2 2 0 1 1 4-.001 2 2 0 0 1-4 .001m15 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-6-5.5c0-.825-.674-1.5-1.5-1.5-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5c.826 0 1.5-.675 1.5-1.5m-4 0a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1-5 0",
  clipRule: "evenodd"
}))), _defs$k || (_defs$k = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "analysis-marker_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v32H0z"
})))));

var _path$2m;
function _extends$2W() { return _extends$2W = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2W.apply(null, arguments); }
const SvgAnchor = props => /*#__PURE__*/React.createElement("svg", _extends$2W({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 25 24"
}, props), _path$2m || (_path$2m = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.786 12c0-5.146-4.187-9.333-9.333-9.333-5.147 0-9.334 4.187-9.334 9.333 0 5.147 4.187 9.334 9.334 9.334s9.333-4.187 9.333-9.334m-20 0c0-5.893 4.773-10.666 10.667-10.666C18.346 1.334 23.12 6.107 23.12 12s-4.774 10.667-10.667 10.667C6.559 22.667 1.786 17.893 1.786 12m13.86 1.333.94-.94h.007l1.506 1.5c-.826 2.32-3.073 3.994-5.646 3.994s-4.78-1.647-5.627-3.94l1.547-1.554.94.94-.887.887a4.65 4.65 0 0 0 3.353 2.273v-7.52a1.85 1.85 0 0 1-1.166-1.706 1.832 1.832 0 1 1 3.666 0c0 .78-.486 1.44-1.166 1.706v7.52a4.67 4.67 0 0 0 3.38-2.313zm-2.693-6.06c0-.273-.227-.5-.5-.5-.274 0-.5.227-.5.5 0 .274.226.5.5.5.273 0 .5-.226.5-.5",
  clipRule: "evenodd"
})));

var _path$2l, _g$L, _defs$j;
function _extends$2V() { return _extends$2V = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2V.apply(null, arguments); }
const SvgAnnotation = props => /*#__PURE__*/React.createElement("svg", _extends$2V({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 28 28"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#annotation_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "annotation_svg__b",
  width: 28,
  height: 28,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path$2l || (_path$2l = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M28 0H0v28h28z"
}))), _g$L || (_g$L = /*#__PURE__*/React.createElement("g", {
  mask: "url(#annotation_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.123 25.067v-5.542h-.866A2.66 2.66 0 0 1 1.6 16.867V6.318a2.66 2.66 0 0 1 2.657-2.657h19.486A2.66 2.66 0 0 1 26.4 6.318v10.549a2.66 2.66 0 0 1-2.657 2.657H10.662zM4.257 5.432a.887.887 0 0 0-.886.886v10.549a.887.887 0 0 0 .886.886h2.638v3.034l3.034-3.034h13.814a.887.887 0 0 0 .886-.886V6.318a.887.887 0 0 0-.886-.886z"
})))), _defs$j || (_defs$j = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "annotation_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h28v28H0z"
})))));

var _path$2k;
function _extends$2U() { return _extends$2U = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2U.apply(null, arguments); }
const SvgAnnouncement = props => /*#__PURE__*/React.createElement("svg", _extends$2U({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$2k || (_path$2k = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M1.32 10.44c.12-2.148 2.004-3.768 4.152-3.768h3.036L20.64 1.308v18.72L9.588 15.156l2.304 5.688a1.332 1.332 0 0 1-1.236 1.836H9.168c-.54 0-1.032-.324-1.236-.828l-2.916-7.188c-2.136-.156-3.828-2.016-3.696-4.224m3.996-2.436a2.666 2.666 0 0 0-2.664 2.664 2.666 2.666 0 0 0 2.664 2.664H7.98V8.004zm1.164 6.66 2.616 6.456c.06.12.18.204.312.204h1.068a.13.13 0 0 0 .12-.18l-2.628-6.48zm2.844-1.104 9.996 4.416V3.348L9.324 7.764zm12.684-4.368V7.62A3.34 3.34 0 0 1 24 10.668a3.32 3.32 0 0 1-1.992 3.048v-1.572a1.978 1.978 0 0 0 0-2.952",
  clipRule: "evenodd"
})));

var _path$2j;
function _extends$2T() { return _extends$2T = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2T.apply(null, arguments); }
const SvgArea = props => /*#__PURE__*/React.createElement("svg", _extends$2T({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path$2j || (_path$2j = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m2.334 6.127 9.667-4.287v-.013l9.666 4.253v10.633l-1.333-.526v-8.84l-8.333 3.66L3.667 7.38v8.793l-1.333.527zm2.54.333 7.127 3.1 7.126-3.133-7.126-3.134zm12.38 11.353.493-1.24 3.907 1.54-1.54 3.914-1.24-.494.707-1.786L12 23.113 4.454 19.76l.693 1.773-1.24.494-1.54-3.914 3.914-1.54.486 1.24-1.806.714 6.373 2.833v-6.587l-1.36 1.367-.947-.947 2.974-2.966 2.973 2.966-.947.947-1.36-1.367v6.587l6.387-2.84z",
  clipRule: "evenodd"
})));
var area = "data:image/svg+xml,%3Csvg%20%20width%3D%2224%22%20%20height%3D%2225%22%20%20viewBox%3D%220%200%2024%2025%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M2.33398%206.12666L12.0007%201.83999V1.82666L21.6673%206.07999V16.7133L20.334%2016.1867V7.34666L12.0007%2011.0067L3.66732%207.37999V16.1733L2.33398%2016.7V6.12666ZM4.87398%206.45999L12.0007%209.55999L19.1273%206.42666L12.0007%203.29333L4.87398%206.45999ZM17.2539%2017.8134L17.7472%2016.5734L21.6539%2018.1134L20.1139%2022.0267L18.8739%2021.5334L19.5805%2019.7467L12.0005%2023.1134L4.45385%2019.7601L5.14719%2021.5334L3.90719%2022.0267L2.36719%2018.1134L6.28052%2016.5734L6.76719%2017.8134L4.96052%2018.5267L11.3339%2021.3601V14.7734L9.97385%2016.1401L9.02719%2015.1934L12.0005%2012.2267L14.9739%2015.1934L14.0272%2016.1401L12.6672%2014.7734V21.3601L19.0539%2018.5201L17.2539%2017.8134Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$2i, _path2$_;
function _extends$2S() { return _extends$2S = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2S.apply(null, arguments); }
const SvgArea2 = props => /*#__PURE__*/React.createElement("svg", _extends$2S({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path$2i || (_path$2i = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.2 2.565 3.73 6.2c.13.265.215.56.215.88 0 .445-.15.855-.4 1.185L10.08 14.8a1.98 1.98 0 0 1 1.445-.625c.22 0 .425.045.62.11l3.37-10.54c-.6-.17-1.09-.605-1.315-1.18",
  opacity: 0.4
})), _path2$_ || (_path2$_ = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.056 1.825a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-2.976.25c.045.345.175.66.37.93L3.9 6.67a2 2 0 0 0-.455-.9zm-3.613 12.402.003.003v-.005zm0 0L3.8 7.81c-.125.32-.34.595-.6.81l6.585 6.585c.165-.294.399-.548.682-.728m1.188-.292c.35.025.675.13.95.31L16.02 3.82a1.97 1.97 0 0 1-.96-.275l-3.4 10.64zm.87 1.99a1 1 0 1 1-2 0 1 1 0 0 1 2 0M1.945 8.08a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
  clipRule: "evenodd"
})));
var area2 = "data:image/svg+xml,%3Csvg%20%20width%3D%2218%22%20%20height%3D%2218%22%20%20viewBox%3D%220%200%2018%2018%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20opacity%3D%220.4%22%20%20%20%20d%3D%22M14.1999%202.56494L3.72992%206.19994C3.85992%206.46494%203.94492%206.75994%203.94492%207.07994C3.94492%207.52494%203.79492%207.93494%203.54492%208.26494L10.0799%2014.7999C10.4449%2014.4149%2010.9549%2014.1749%2011.5249%2014.1749C11.7449%2014.1749%2011.9499%2014.2199%2012.1449%2014.2849L15.5149%203.74494C14.9149%203.57494%2014.4249%203.13994%2014.1999%202.56494Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M17.0557%201.82471C17.0557%202.37699%2016.6079%202.82471%2016.0557%202.82471C15.5034%202.82471%2015.0557%202.37699%2015.0557%201.82471C15.0557%201.27242%2015.5034%200.824707%2016.0557%200.824707C16.6079%200.824707%2017.0557%201.27242%2017.0557%201.82471ZM14.0803%202.07471C14.1253%202.41971%2014.2553%202.73471%2014.4503%203.00471L3.90031%206.66971C3.83031%206.32971%203.66531%206.02471%203.44531%205.76971L14.0803%202.07471ZM10.4671%2014.4768L10.4702%2014.4798V14.4748L10.4671%2014.4768ZM10.4671%2014.4768L3.80019%207.80981C3.67519%208.12981%203.4602%208.40481%203.2002%208.61981L9.7852%2015.2048C9.9496%2014.9109%2010.1835%2014.6566%2010.4671%2014.4768ZM11.6553%2014.1847C12.0053%2014.2097%2012.3303%2014.3147%2012.6053%2014.4947L16.0203%203.81968C15.6703%203.81468%2015.3453%203.70968%2015.0603%203.54468L11.6603%2014.1847H11.6553ZM12.5254%2016.1748C12.5254%2016.7271%2012.0777%2017.1748%2011.5254%2017.1748C10.9731%2017.1748%2010.5254%2016.7271%2010.5254%2016.1748C10.5254%2015.6225%2010.9731%2015.1748%2011.5254%2015.1748C12.0777%2015.1748%2012.5254%2015.6225%2012.5254%2016.1748ZM1.94531%208.07959C2.4976%208.07959%202.94531%207.63187%202.94531%207.07959C2.94531%206.52731%202.4976%206.07959%201.94531%206.07959C1.39303%206.07959%200.945312%206.52731%200.945312%207.07959C0.945312%207.63187%201.39303%208.07959%201.94531%208.07959Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$2h, _path2$Z;
function _extends$2R() { return _extends$2R = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2R.apply(null, arguments); }
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends$2R({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$2h || (_path$2h = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z",
  "data-name": "Rettangolo 6305"
})), _path2$Z || (_path2$Z = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m27.818 11.71-9.778 9.808-9.808-9.777-1.412 1.416 11.224 11.189 11.19-11.224Z",
  "data-name": "Tracciato 4352"
})));
var arrowDown = "data:image/svg+xml,%3Csvg%20%20id%3D%22Down%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2236%22%20%20height%3D%2236%22%20%20viewBox%3D%220%200%2036%2036%22%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_6305%22%20%20%20%20data-name%3D%22Rettangolo%206305%22%20%20%20%20width%3D%2236%22%20%20%20%20height%3D%2236%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20id%3D%22Tracciato_4352%22%20%20%20%20data-name%3D%22Tracciato%204352%22%20%20%20%20d%3D%22M5647.818%2C431.71l-9.778%2C9.808-9.808-9.777-1.412%2C1.416%2C11.224%2C11.189%2C11.19-11.224Z%22%20%20%20%20transform%3D%22translate%28-5620%20-420%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$2g;
function _extends$2Q() { return _extends$2Q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2Q.apply(null, arguments); }
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends$2Q({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 12"
}, props), _path$2g || (_path$2g = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m9.406 11.954 5.967-5.974L9.406.014l-.946.94 4.366 4.36H.74v1.333h12.086L8.46 11.014z"
})));
var arrowRight = "data:image/svg+xml,%3Csvg%20%20viewBox%3D%220%200%2016%2012%22%20%20height%3D%2212%22%20%20width%3D%2216%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20d%3D%22M9.40623%2011.9537L15.3729%205.98034L9.40623%200.0136719L8.45956%200.953674L12.8262%205.31367H0.739563V6.64701H12.8262L8.45956%2011.0137L9.40623%2011.9537Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _g$K, _defs$i;
function _extends$2P() { return _extends$2P = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2P.apply(null, arguments); }
const SvgAttachment = props => /*#__PURE__*/React.createElement("svg", _extends$2P({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _g$K || (_g$K = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#attachment_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.081 16.096a3.5 3.5 0 0 1-2.475-5.975l7.778-7.778a1.504 1.504 0 0 1 2.122 0l1.414 1.414a1.5 1.5 0 0 1 0 2.12l-7.105 7.106a1.499 1.499 0 0 1-2.561-1.061 1.5 1.5 0 0 1 .44-1.06l5.324-5.324.706.706-5.323 5.324a.5.5 0 0 0 .706.707l7.106-7.105a.5.5 0 0 0 0-.707L12.8 3.05a.5.5 0 0 0-.708 0l-7.778 7.778a2.5 2.5 0 0 0 3.536 3.536l6.717-6.717.706.706-6.717 6.718a3.48 3.48 0 0 1-2.475 1.026"
}))), _defs$i || (_defs$i = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "attachment_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h18v18H0z"
})))));
var attachment = "data:image/svg+xml,%3Csvg%20%20width%3D%2218%22%20%20height%3D%2218%22%20%20viewBox%3D%220%200%2018%2018%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cg%20clip-path%3D%22url%28%23clip0_297_17868%29%22%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M6.08101%2016.0957C5.38873%2016.0958%204.71206%2015.8906%204.13643%2015.506C3.5608%2015.1214%203.11211%2014.5748%202.84718%2013.9352C2.58225%2013.2956%202.5127%2012.5919%202.64778%2011.9129C2.78286%2011.2339%203.11678%2010.6103%203.60634%2010.1208L11.3841%202.34258C11.6658%202.06188%2012.0477%201.9043%2012.4454%201.9043C12.8431%201.9043%2013.2244%202.06188%2013.5061%202.34258L14.9201%203.75673C15.2007%204.03825%2015.3584%204.41954%2015.3584%204.81705C15.3584%205.21455%2015.2007%205.59585%2014.9201%205.87737L7.81465%2012.9828C7.67533%2013.1222%207.50998%2013.2326%207.32795%2013.308C7.14593%2013.3834%206.95094%2013.4223%206.75392%2013.4223C6.5569%2013.4223%206.36191%2013.3834%206.17988%2013.308C5.99786%2013.2326%205.83251%2013.1222%205.69319%2012.9828C5.55387%2012.8435%205.44284%2012.6781%205.36744%2012.4961C5.29205%2012.3141%205.25374%2012.119%205.25374%2011.922C5.25374%2011.725%205.29205%2011.5298%205.36744%2011.3478C5.44284%2011.1658%205.55387%2011.0004%205.69319%2010.8611L11.0177%205.53761L11.7241%206.2441L6.40071%2011.5676C6.31465%2011.6628%206.26844%2011.7874%206.27162%2011.9157C6.2748%2012.044%206.32706%2012.1662%206.41774%2012.257C6.50841%2012.3478%206.63057%2012.4003%206.75886%2012.4037C6.88716%2012.4071%207.01179%2012.3611%207.10713%2012.2752L14.2125%205.16971C14.2589%205.12332%2014.2956%205.06827%2014.3208%205.00766C14.3459%204.94705%2014.3587%204.88204%2014.3587%204.81643C14.3587%204.75082%2014.3459%204.68588%2014.3208%204.62527C14.2956%204.56466%2014.2589%204.5096%2014.2125%204.46322L12.7997%203.04907C12.7058%202.9553%2012.5786%202.90261%2012.4459%202.90261C12.3133%202.90261%2012.186%202.9553%2012.0922%203.04907L4.31386%2010.8273C3.84497%2011.2962%203.58162%2011.9322%203.58162%2012.5953C3.58162%2013.2584%203.84497%2013.8943%204.31386%2014.3632C4.78274%2014.8321%205.41845%2015.0955%206.08156%2015.0955C6.74466%2015.0955%207.38092%2014.8321%207.84981%2014.3632L14.5668%207.64582L15.2733%208.35231L8.55623%2015.0697C8.23203%2015.3959%207.84618%2015.6545%207.42134%2015.8306C6.9965%2016.0067%206.5409%2016.0968%206.08101%2016.0957Z%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cdefs%3E%20%20%20%20%3CclipPath%20id%3D%22clip0_297_17868%22%3E%20%20%20%20%20%20%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%20%2F%3E%20%20%20%20%3C%2FclipPath%3E%20%20%3C%2Fdefs%3E%3C%2Fsvg%3E";

var _path$2f;
function _extends$2O() { return _extends$2O = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2O.apply(null, arguments); }
const SvgAutoClipCurrentView = props => /*#__PURE__*/React.createElement("svg", _extends$2O({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _path$2f || (_path$2f = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 10H2V2h8v2H4zm16.93-3.85L7 11.84v14.28l8.07 3.73L29 24.16V9.88l-8.07-3.72zm.5 2.43 4.22 1.95-4.22 1.62V8.58m-1 3.94-5.24 2.01-4.82-1.92 10.06-4.1zm0 7.17-4.37 1.82v-5.17l4.37-1.67zm-6.37-3.46v6.11l-5.07 2.11V14.22zm0 7.19v3.75L9.79 25.2zm2-.83 4.86-2.02 5.47 2.48-10.33 4.22zm5.37-2.89v-5.42L27 12.15v10.08zM32 10h2V2h-8v2h6zM10 34H2v-8h2v6h6zm16 0h8v-8h-2v6h-6z",
  clipRule: "evenodd"
})));

var _path$2e;
function _extends$2N() { return _extends$2N = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2N.apply(null, arguments); }
const SvgAutodeskLogo = props => /*#__PURE__*/React.createElement("svg", _extends$2N({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path$2e || (_path$2e = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m2.148 25.53 17.15-10.62h8.89c.27 0 .52.22.52.52 0 .25-.11.35-.25.44l-8.43 5.03c-.55.32-.74.98-.74 1.47v3.17h10.7V7.12c0-.35-.27-.65-.69-.65h-10.2L1.988 17.05v8.5h.15z"
})));

var _circle$6, _path$2d;
function _extends$2M() { return _extends$2M = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2M.apply(null, arguments); }
const SvgBaseAvatar = props => /*#__PURE__*/React.createElement("svg", _extends$2M({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _circle$6 || (_circle$6 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  fill: "#363C4D"
})), _path$2d || (_path$2d = /*#__PURE__*/React.createElement("path", {
  fill: "#F0F2F5",
  d: "M32 33.852c10.022 0 18.322 7.132 20 16.512A25 25 0 0 1 49.386 53C48.928 43.961 41.325 36.722 32 36.722s-16.928 7.217-17.386 16.277c-.915-.835-1.808-1.692-2.614-2.635 1.678-9.38 9.978-16.512 20-16.512M32 11c5.62 0 10.174 4.476 10.174 10.002S37.62 31.004 32 31.004s-10.175-4.476-10.175-10.002S26.38 11 32 11m0 2.87c-3.987 0-7.255 3.213-7.255 7.132 0 3.92 3.268 7.132 7.255 7.132s7.255-3.213 7.255-7.132c0-3.92-3.246-7.132-7.255-7.132"
})));

var _g$J, _path$2c;
function _extends$2L() { return _extends$2L = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2L.apply(null, arguments); }
const SvgBlendData = props => /*#__PURE__*/React.createElement("svg", _extends$2L({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Blend Data",
  viewBox: "0 0 21 21"
}, props), _g$J || (_g$J = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 12179"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  d: "M2 12.575A6.375 6.375 0 0 1 6.45 6.5a6.356 6.356 0 1 1 7.981 7.934A6.353 6.353 0 0 1 2 12.575Zm1.059 0a5.294 5.294 0 0 0 10.15 2.117 6.355 6.355 0 0 1-7.036-6.327q0-.322.032-.636a5.31 5.31 0 0 0-3.146 4.846Zm4.173-4.21a5.3 5.3 0 0 0 6.325 5.2 5.3 5.3 0 0 0-6.232-6.2 5.3 5.3 0 0 0-.094 1Zm7.476 4.21q0 .322-.031.636a5.3 5.3 0 1 0-7-6.964 6.355 6.355 0 0 1 7.036 6.328Z",
  "data-name": "Union 9"
}))), _path$2c || (_path$2c = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h21v21H0z",
  "data-name": "Rectangle 13880"
})));

var _path$2b;
function _extends$2K() { return _extends$2K = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2K.apply(null, arguments); }
const SvgBuildingElevation = props => /*#__PURE__*/React.createElement("svg", _extends$2K({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _path$2b || (_path$2b = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.334 1.334H2.667v1.333h18.667zm0 20H2.667v1.333h18.667zm-8.667-14.78v10.893l2.2-2.2.94.947L12 20l-3.806-3.806.94-.947 2.2 2.2V6.554l-2.2 2.2-.94-.947L12 4l3.807 3.807-.94.947z",
  clipRule: "evenodd"
})));
var buildingElevation = "data:image/svg+xml,%3Csvg%20%20width%3D%2224%22%20%20height%3D%2224%22%20%20viewBox%3D%220%200%2024%2024%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M21.3337%201.3335H2.66699V2.66683H21.3337V1.3335ZM21.3337%2021.3335H2.66699V22.6668H21.3337V21.3335ZM12.667%206.5535V17.4468L14.867%2015.2468L15.807%2016.1935L12.0004%2020.0002L8.19368%2016.1935L9.13368%2015.2468L11.3337%2017.4468V6.5535L9.13368%208.7535L8.19368%207.80683L12.0004%204.00016L15.807%207.80683L14.867%208.7535L12.667%206.5535Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$2a;
function _extends$2J() { return _extends$2J = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2J.apply(null, arguments); }
const SvgCadSmall = props => /*#__PURE__*/React.createElement("svg", _extends$2J({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18"
}, props), _path$2a || (_path$2a = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m2.5 5.787 5.968 3.331v6.964L3 12.9l2.94-1.659-.734-.734L2.5 12.038Zm6.968 3.362L15.5 5.787v6.254l-2.722-1.521-.736.735 2.946 1.645-5.52 3.213Zm0-3.972v-3.3l5.432 3.1L9 8.267 3.1 4.975l5.368-3.066v3.268ZM1.5 4.734v8.447L9 17.546l7.5-4.365V4.734L9 .456Z",
  "data-name": "cad-small"
})));

var _g$I, _defs$h;
function _extends$2I() { return _extends$2I = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2I.apply(null, arguments); }
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends$2I({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g$I || (_g$I = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#calendar_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.666 2h2v1.333h6.668V2h2v1.333h2c.733 0 1.333.6 1.333 1.334V22H3.334V4.667c0-.734.6-1.334 1.333-1.334h1.999zm2 2.667h6.668V6h2V4.667h1.667a.33.33 0 0 1 .333.333v2.333H4.667V5a.33.33 0 0 1 .334-.333h1.665V6h2zm-3.999 16v-12h14.667v12zm10.667-8h2v2h-2zm-2 4h-2v2h2zm2 0h2v2h-2z",
  clipRule: "evenodd"
}))), _defs$h || (_defs$h = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "calendar_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h24v24H0z"
})))));

var _path$29;
function _extends$2H() { return _extends$2H = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2H.apply(null, arguments); }
const SvgCameraOrthographic = props => /*#__PURE__*/React.createElement("svg", _extends$2H({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 25 24"
}, props), _path$29 || (_path$29 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.814 1.334V4.24L23.161 2v8.774l-3.347-2.24v2.906h-3.32v-1.333h1.987v-7.44h-7.654a.33.33 0 0 0-.333.333v3.667H9.161v-4.04c0-.713.6-1.293 1.333-1.293zm.113 5.673 1.9 1.267V4.5l-1.9 1.267zM.494 8h11.2l3.467 3.467v11.2H3.96L.494 19.2zm4.02 3.08h8.373l-1.746-1.746H2.767zm-.94.94-1.747-1.746v8.373l1.747 1.747zm1.333.394v8.92h8.92v-8.92z",
  clipRule: "evenodd"
})));
var cameraOrthographic = "data:image/svg+xml,%3Csvg%20%20width%3D%2225%22%20%20height%3D%2224%22%20%20viewBox%3D%220%200%2025%2024%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M19.8141%201.3335V4.24016L23.1608%202.00016V10.7735L19.8141%208.5335V11.4402H16.4941V10.1068H18.4808V2.66683H10.8275C10.6408%202.66683%2010.4941%202.8135%2010.4941%203.00016V6.66683H9.16081V2.62683C9.16081%201.9135%209.76081%201.3335%2010.4941%201.3335H19.8141ZM19.9275%207.00683L21.8275%208.2735V4.50016L19.9275%205.76683V7.00683ZM0.494141%208.00016H11.6941L15.1608%2011.4668V22.6668H3.96081L0.494141%2019.2002V8.00016ZM4.51414%2011.0802H12.8875L11.1408%209.3335H2.76747L4.51414%2011.0802ZM3.57414%2012.0202L1.82747%2010.2735V18.6468L3.57414%2020.3935V12.0202ZM4.90747%2012.4135V21.3335H13.8275V12.4135H4.90747Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$28;
function _extends$2G() { return _extends$2G = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2G.apply(null, arguments); }
const SvgCameraPerspective = props => /*#__PURE__*/React.createElement("svg", _extends$2G({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$28 || (_path$28 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.32 1.334V4.24h.007L22.673 2v8.774l-3.346-2.24v2.906h-3.32v-1.333h1.98v-7.44h-7.654A.33.33 0 0 0 10 3v4.987l-1.333-.534V2.628c0-.713.6-1.293 1.333-1.293zm.113 5.673 1.9 1.267V4.5l-1.9 1.267zM0 8h6.44l8.227 3.294v11.373H3.3l-3.247-8.06zm4.027 3.08h6.52l-4.36-1.746h-3.9zm-.94.94-1.734-1.733.034 4.053 1.7 4.22zm1.326.394v8.92h8.92v-8.92z",
  clipRule: "evenodd"
})));
var cameraPerspective = "data:image/svg+xml,%3Csvg%20%20width%3D%2224%22%20%20height%3D%2224%22%20%20viewBox%3D%220%200%2024%2024%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M19.32%201.3335V4.24016H19.3267L22.6733%202.00016V10.7735L19.3267%208.5335V11.4402H16.0067V10.1068H17.9867V2.66683H10.3333C10.1467%202.66683%2010%202.8135%2010%203.00016V7.98683L8.66667%207.4535V2.62683C8.66667%201.9135%209.26667%201.3335%2010%201.3335H19.32ZM19.4333%207.00683L21.3333%208.2735V4.50016L19.4333%205.76683V7.00683ZM0%208.00016H6.44L14.6667%2011.2935V22.6668H3.3L0.0533346%2014.6068L0%208.00016ZM4.02667%2011.0802H10.54H10.5467L6.18667%209.3335H2.28667L4.02667%2011.0802ZM3.08666%2012.0202L1.35333%2010.2868L1.38667%2014.3402L3.08666%2018.5602V12.0202ZM4.41334%2012.4135V21.3335H13.3333V12.4135H4.41334Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$27;
function _extends$2F() { return _extends$2F = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2F.apply(null, arguments); }
const SvgCameraVideoTrajectorySmall = props => /*#__PURE__*/React.createElement("svg", _extends$2F({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18"
}, props), _path$27 || (_path$27 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.955 18c0-1.2 1.41-1.754 2.773-2.289.837-.328 1.984-.777 1.984-1.192 0-.48-1.255-.97-2.172-1.327-1.391-.542-2.7-1.052-2.7-2.147 0-1.194 1.349-1.713 2.653-2.214.963-.371 2.056-.79 2.056-1.331h1c0 1.229-1.372 1.755-2.7 2.265-.944.362-2.013.773-2.013 1.281 0 .411 1.242.895 2.064 1.216 1.382.537 2.809 1.094 2.809 2.258 0 1.1-1.33 1.619-2.618 2.123-.954.374-2.14.838-2.14 1.357Zm-6.287-3.206v-3.286L.5 14.294V4.1l4.168 2.786V3.6h10.559a1.253 1.253 0 0 1 1.272 1.229v.928h-1v-.928a.255.255 0 0 0-.273-.229H5.667v9.195h2.3a6.5 6.5 0 0 0 1.5.962l-.07.038Zm-3.169-2.371 3.169-2.117V8.089L1.499 5.972Z",
  "data-name": "camera-video-trajectory-small"
})));

var _path$26;
function _extends$2E() { return _extends$2E = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2E.apply(null, arguments); }
const SvgChat = props => /*#__PURE__*/React.createElement("svg", _extends$2E({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 15"
}, props), _path$26 || (_path$26 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.444 14.73v-4.396h-.556A1.667 1.667 0 0 1 .222 8.667V2.001A1.667 1.667 0 0 1 1.888.334h12.223a1.667 1.667 0 0 1 1.666 1.667v6.666a1.667 1.667 0 0 1-1.666 1.667H6.84zM1.888 1.446a.555.555 0 0 0-.555.556v6.666a.555.555 0 0 0 .555.556h1.667v2.825l2.826-2.825h7.73a.556.556 0 0 0 .555-.556V2.001a.556.556 0 0 0-.555-.556zm10.556 4.722H3.555v.556h8.889zM3.555 3.945h8.889v.556H3.555z",
  clipRule: "evenodd"
})));
var chat = "data:image/svg+xml,%3Csvg%20%20width%3D%2216%22%20%20height%3D%2215%22%20%20viewBox%3D%220%200%2016%2015%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M2.4439%2014.7306V10.334H1.88835C1.44632%2010.334%201.02252%2010.1583%200.709961%209.84577C0.3974%209.53321%200.22168%209.10935%200.22168%208.66732V2.00065C0.22168%201.55862%200.3974%201.13469%200.709961%200.82213C1.02252%200.509569%201.44632%200.333984%201.88835%200.333984H14.1106C14.5526%200.333984%2014.9764%200.509569%2015.289%200.82213C15.6015%201.13469%2015.7772%201.55862%2015.7772%202.00065V8.66732C15.7772%209.10935%2015.6015%209.53321%2015.289%209.84577C14.9764%2010.1583%2014.5526%2010.334%2014.1106%2010.334H6.8406L2.4439%2014.7306ZM1.88835%201.4451C1.741%201.4451%201.59974%201.5036%201.49555%201.60779C1.39136%201.71197%201.33279%201.85331%201.33279%202.00065V8.66732C1.33279%208.81466%201.39136%208.95593%201.49555%209.06011C1.59974%209.1643%201.741%209.22287%201.88835%209.22287H3.55501V12.0484L6.38053%209.22287H14.1106C14.2579%209.22287%2014.3992%209.1643%2014.5034%209.06011C14.6075%208.95593%2014.6661%208.81466%2014.6661%208.66732V2.00065C14.6661%201.85331%2014.6075%201.71197%2014.5034%201.60779C14.3992%201.5036%2014.2579%201.4451%2014.1106%201.4451H1.88835ZM12.4439%206.16732H3.55501V6.72287H12.4439V6.16732ZM3.55501%203.94508H12.4439V4.50063H3.55501V3.94508Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _g$H;
function _extends$2D() { return _extends$2D = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2D.apply(null, arguments); }
const SvgCheckmark2 = props => /*#__PURE__*/React.createElement("svg", _extends$2D({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _g$H || (_g$H = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 15646"
}, /*#__PURE__*/React.createElement("path", {
  d: "m8.88 15.071-4.068-4.01.825-.884 3.007 3.007 5.542-8.254 1 .707Z",
  "data-name": "Path 12433"
}))));
var checkmark2 = "data:image/svg+xml,%3Csvg%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2220%22%20%20height%3D%2220%22%20%20viewBox%3D%220%200%2020%2020%22%3E%20%20%3Cg%20id%3D%22Group_15646%22%20data-name%3D%22Group%2015646%22%20transform%3D%22translate%2818493%203032%29%22%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22Path_12433%22%20%20%20%20%20%20data-name%3D%22Path%2012433%22%20%20%20%20%20%20d%3D%22M12.468%2C19.841%2C8.4%2C15.831l.825-.884%2C3.007%2C3.007L17.774%2C9.7l1%2C.707Z%22%20%20%20%20%20%20transform%3D%22translate%28-18496.588%20-3036.77%29%22%20%20%20%20%20%20stroke-width%3D%221%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _path$25, _path2$Y;
function _extends$2C() { return _extends$2C = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2C.apply(null, arguments); }
const SvgCheckmark3 = props => /*#__PURE__*/React.createElement("svg", _extends$2C({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Trailing Icon",
  viewBox: "0 0 16 16"
}, props), _path$25 || (_path$25 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h16v16H0z",
  "data-name": "Rectangle 6163"
})), _path2$Y || (_path2$Y = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.5,
  d: "M6.729 12.014 2.702 8.096l.62-.637 3.281 3.193 4.724-6.69.727.513Z",
  "data-name": "Path 4183"
})));

var _path$24, _path2$X;
function _extends$2B() { return _extends$2B = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2B.apply(null, arguments); }
const SvgCheckmark4 = props => /*#__PURE__*/React.createElement("svg", _extends$2B({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Trailing Icon",
  viewBox: "0 0 16 16"
}, props), _path$24 || (_path$24 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h16v16H0z",
  "data-name": "Rectangle 6163"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  style: {
    fill: "#dee8fd"
  }
}), _path2$X || (_path2$X = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.5,
  d: "M6.729 12.014 2.702 8.096l.62-.637 3.281 3.193 4.724-6.69.727.513Z",
  "data-name": "Path 4183"
})));

var _g$G;
function _extends$2A() { return _extends$2A = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2A.apply(null, arguments); }
const SvgCheckmarkCircleFill = props => /*#__PURE__*/React.createElement("svg", _extends$2A({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _g$G || (_g$G = /*#__PURE__*/React.createElement("g", {
  "data-name": "checkmark-circle-fill"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18 34A16.02 16.02 0 0 1 2 18 16.02 16.02 0 0 1 18 2a16.02 16.02 0 0 1 16 16 16.02 16.02 0 0 1-16 16m-7-16.867-2.417 2.589 7.753 7.639 11.063-16.546-2.91-2.053-8.781 13.078z",
  "data-name": "checkmark"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z",
  "data-name": "container"
}))));
var checkmarkCircleFill = "data:image/svg+xml,%3Csvg%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2236%22%20%20height%3D%2236%22%20%20viewBox%3D%220%200%2036%2036%22%3E%20%20%3Cg%20%20%20%20id%3D%22checkmark-circle-fill%22%20%20%20%20data-name%3D%22checkmark-circle-fill%22%20%20%20%20transform%3D%22translate%28-182%20-198.846%29%22%20%20%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22checkmark%22%20%20%20%20%20%20data-name%3D%22checkmark%22%20%20%20%20%20%20d%3D%22M2832-86.154a16.018%2C16.018%2C0%2C0%2C1-16-16%2C16.018%2C16.018%2C0%2C0%2C1%2C16-16%2C16.018%2C16.018%2C0%2C0%2C1%2C16%2C16A16.018%2C16.018%2C0%2C0%2C1%2C2832-86.154Zm-7-16.867h0l-2.417%2C2.589%2C7.753%2C7.639%2C11.063-16.546-2.91-2.053-8.781%2C13.078L2825-103.021Z%22%20%20%20%20%20%20transform%3D%22translate%28-2632%20319%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%20%20%3Crect%20%20%20%20%20%20id%3D%22container%22%20%20%20%20%20%20data-name%3D%22container%22%20%20%20%20%20%20width%3D%2236%22%20%20%20%20%20%20height%3D%2236%22%20%20%20%20%20%20transform%3D%22translate%28182%20198.846%29%22%20%20%20%20%20%20fill%3D%22none%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _g$F;
function _extends$2z() { return _extends$2z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2z.apply(null, arguments); }
const SvgCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends$2z({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _g$F || (_g$F = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 15646"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.312 15.563 4 11.313l.875-.937 3.187 3.187 5.875-8.75 1.063.75Z",
  "data-name": "Path 6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 1.25A8.75 8.75 0 1 1 1.25 10 8.776 8.776 0 0 1 10 1.25M10 0a10 10 0 1 0 10 10A10.03 10.03 0 0 0 10 0",
  "data-name": "Path 7"
}))));

var _path$23;
function _extends$2y() { return _extends$2y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2y.apply(null, arguments); }
const SvgClipboxExport = props => /*#__PURE__*/React.createElement("svg", _extends$2y({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$23 || (_path$23 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.353 19.62 12 18.946h.007v1.44l-2.314.947L3.34 18.4V7.147l10.98-4.48L20.673 5.6v7.82l-1.06-1.06-.273-.274V7.173l-4.687 1.793v4.414l1.414.64-.507.507-1.254-.567-3.953 1.646zM18.5 6.066l-3.854-1.78V7.54zm-8.14 8.814 3.62-1.507V9.22l-3.62 1.386zm-5.2 2.887 3.867 1.786V16.16zm-.487-.514 4.354-1.813v-4.907L4.673 8.8zM13.987 4.24 5.512 7.7h.007L9.8 9.4l4.186-1.607zm4.68 9.067 2.713 2.713-.94.947-1.107-1.107v5.473H18V15.86l-1.087 1.087-.02.02-.94-.947zM13.333 24H24v-6.414h-1.333v5.08h-8v-5.08h-1.334z",
  clipRule: "evenodd"
})));

var _path$22, _path2$W;
function _extends$2x() { return _extends$2x = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2x.apply(null, arguments); }
const SvgClippingBox = props => /*#__PURE__*/React.createElement("svg", _extends$2x({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Clipping Box",
  viewBox: "0 0 36 36"
}, props), _path$22 || (_path$22 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z",
  "data-name": "Rectangle 10138"
})), _path2$W || (_path2$W = /*#__PURE__*/React.createElement("path", {
  d: "M21.467 4 5 10.72V27.6l9.533 4.4L31 25.28V8.4Zm.5 2.433 5.782 2.668-5.782 2.214Zm-1 5.265-6.281 2.406-6.424-2.555 12.705-5.185Zm0 8.369-5.434 2.261V15.92l5.434-2.081Zm-7.434-4.269v7.362L7 25.878V13.2Zm0 8.446v5.091l-5.8-2.679Zm2-.832 5.926-2.465 7.039 3.194-12.965 5.291Zm6.434-3.333v-6.623L29 10.763V23.27Z",
  "data-name": "Path 6794"
})));

var _path$21;
function _extends$2w() { return _extends$2w = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2w.apply(null, arguments); }
const SvgClockSmall = props => /*#__PURE__*/React.createElement("svg", _extends$2w({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18"
}, props), _path$21 || (_path$21 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2 9a7 7 0 0 1 7-7 7 7 0 0 1 7 7 7 7 0 0 1-7 7 7 7 0 0 1-7-7m1 0a6.006 6.006 0 0 0 6 6 6.007 6.007 0 0 0 6-6 6.01 6.01 0 0 0-6-6 6.007 6.007 0 0 0-6 6m5.5.2V5.986h1v2.807l2.473 2.529-.715.7Z",
  "data-name": "clock-small"
})));

var _path$20, _path2$V, _path3$k;
function _extends$2v() { return _extends$2v = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2v.apply(null, arguments); }
const SvgCloseCancelError = props => /*#__PURE__*/React.createElement("svg", _extends$2v({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Close - Cancel - Error",
  viewBox: "0 0 26 26"
}, props), _path$20 || (_path$20 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h26v26H0z",
  "data-name": "Rectangle 6160"
})), _path2$V || (_path2$V = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m6.331 18.571 12.24-12.24 1.018 1.018L7.35 19.59z",
  "data-name": "Rectangle 6161"
})), _path3$k || (_path3$k = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m6.331 7.349 1.018-1.018 12.24 12.24-1.018 1.018z",
  "data-name": "Rectangle 6162"
})));
var closeCancelError = "data:image/svg+xml,%3Csvg%20%20id%3D%22Close_-_Cancel_-_Error%22%20%20data-name%3D%22Close%20-%20Cancel%20-%20Error%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2226%22%20%20height%3D%2226%22%20%20viewBox%3D%220%200%2026%2026%22%3E%20%20%3Crect%20%20%20%20id%3D%22Rectangle_6160%22%20%20%20%20data-name%3D%22Rectangle%206160%22%20%20%20%20width%3D%2226%22%20%20%20%20height%3D%2226%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%20%20%3Crect%20%20%20%20id%3D%22Rectangle_6161%22%20%20%20%20data-name%3D%22Rectangle%206161%22%20%20%20%20width%3D%2217.31%22%20%20%20%20height%3D%221.44%22%20%20%20%20transform%3D%22translate%286.331%2018.571%29%20rotate%28-45%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Crect%20%20%20%20id%3D%22Rectangle_6162%22%20%20%20%20data-name%3D%22Rectangle%206162%22%20%20%20%20width%3D%221.44%22%20%20%20%20height%3D%2217.31%22%20%20%20%20transform%3D%22translate%286.331%207.349%29%20rotate%28-45%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$1$, _path2$U, _path3$j;
function _extends$2u() { return _extends$2u = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2u.apply(null, arguments); }
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends$2u({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Splitscreen - Close",
  viewBox: "0 0 36 36"
}, props), _path$1$ || (_path$1$ = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z",
  "data-name": "Rettangolo 6160"
})), _path2$U || (_path2$U = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m8.793 25.793 17-17 1.414 1.414-17 17z",
  "data-name": "Rettangolo 6161"
})), _path3$j || (_path3$j = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m8.793 10.207 1.414-1.414 17 17-1.414 1.414z",
  "data-name": "Rettangolo 6162"
})));
var close = "data:image/svg+xml,%3Csvg%20%20id%3D%22Splitscreen%20-%20Close%22%20%20data-name%3D%22Splitscreen%20-%20Close%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2236%22%20%20height%3D%2236%22%20%20viewBox%3D%220%200%2036%2036%22%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_6160%22%20%20%20%20data-name%3D%22Rettangolo%206160%22%20%20%20%20width%3D%2236%22%20%20%20%20height%3D%2236%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_6161%22%20%20%20%20data-name%3D%22Rettangolo%206161%22%20%20%20%20width%3D%2224.042%22%20%20%20%20height%3D%222%22%20%20%20%20transform%3D%22translate%288.793%2025.793%29%20rotate%28-45%29%22%20%20%20%20fill%3D%22currentColor%20%22%20%20%2F%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_6162%22%20%20%20%20data-name%3D%22Rettangolo%206162%22%20%20%20%20width%3D%222%22%20%20%20%20height%3D%2224.042%22%20%20%20%20transform%3D%22translate%288.793%2010.207%29%20rotate%28-45%29%22%20%20%20%20fill%3D%22currentColor%20%22%20%20%2F%3E%3C%2Fsvg%3E";

var _g$E;
function _extends$2t() { return _extends$2t = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2t.apply(null, arguments); }
const SvgCloudProcessingGraphic = props => /*#__PURE__*/React.createElement("svg", _extends$2t({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 241 233"
}, props), _g$E || (_g$E = /*#__PURE__*/React.createElement("g", {
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M120.451 232.419c66.523 0 120.451-52.029 120.451-116.21S186.974 0 120.451 0 0 52.029 0 116.209s53.928 116.21 120.451 116.21"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4E86F3",
  fillRule: "evenodd",
  d: "M117.837 111.901h4.334v30.477a6.51 6.51 0 0 1 4.327 6.125A6.504 6.504 0 0 1 120 155a6.504 6.504 0 0 1-6.497-6.497 6.51 6.51 0 0 1 4.334-6.128zm0 36.594c0-1.192.971-2.163 2.163-2.163s2.164.971 2.164 2.163a2.17 2.17 0 0 1-2.164 2.164 2.167 2.167 0 0 1-2.163-2.164m-24.754-2.163a6.504 6.504 0 0 1-6.498-6.498 6.504 6.504 0 0 1 6.498-6.497 6.51 6.51 0 0 1 6.125 4.326h5.501v-15.165h4.334v19.5H99.21a6.51 6.51 0 0 1-6.127 4.334m0-8.669a2.167 2.167 0 0 0-2.164 2.164c0 1.192.972 2.163 2.164 2.163a2.167 2.167 0 0 0 2.163-2.163 2.167 2.167 0 0 0-2.163-2.164m47.71-2.163h-5.509v-13.002h-4.334v17.336h9.84a6.51 6.51 0 0 0 6.127 4.334 6.504 6.504 0 0 0 6.498-6.497 6.504 6.504 0 0 0-6.498-6.498 6.51 6.51 0 0 0-6.124 4.327m6.124 0a2.166 2.166 0 0 0-2.163 2.163c0 1.193.971 2.164 2.163 2.164a2.167 2.167 0 0 0 2.164-2.164 2.167 2.167 0 0 0-2.164-2.163",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#679",
  d: "M154.666 110.165c0-7.756-5.46-14.15-12.767-15.402-.5-9.882-8.558-17.763-18.396-17.763-7.447 0-14.048 4.496-16.925 11.362-5.232.066-9.617 3.73-10.802 8.8-6.137 1.752-10.442 7.418-10.442 14.033 0 4.01 1.656 7.888 4.489 10.589l6.483 6.608v-6.189l-3.437-3.502a10.27 10.27 0 0 1-3.2-7.499c0-5.033 3.517-9.286 8.373-10.11l1.634-.28.154-1.648c.354-3.687 3.319-6.461 6.895-6.461.302 0 .596.051.994.11l1.832.273.559-1.766c1.884-5.968 7.263-9.978 13.4-9.978 7.763 0 14.084 6.46 14.084 14.407 0 .192-.014.383-.029.574l-.147 2.495 2.222.066c5.997.192 10.692 5.144 10.692 11.281a11.34 11.34 0 0 1-2.877 7.557s-2.355 2.421-4.489 4.606v6.204c1.692-1.73 7.601-7.793 7.645-7.845a15.7 15.7 0 0 0 4.048-10.522z"
}))));

var _path$1_;
function _extends$2s() { return _extends$2s = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2s.apply(null, arguments); }
const SvgCloudUpload = props => /*#__PURE__*/React.createElement("svg", _extends$2s({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path$1_ || (_path$1_ = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.08 1.834c3.027 0 5.507 2.426 5.66 5.466h-.006c2.247.387 3.927 2.353 3.927 4.74 0 1.2-.44 2.347-1.247 3.24l-.21.217c-.487.5-1.678 1.726-2.09 2.143l-.193.2h-4.914v-1.333h4.354l2.08-2.14c.566-.627.886-1.46.886-2.327 0-1.893-1.446-3.413-3.293-3.473l-.687-.02.047-.767q.009-.081.007-.173c0-2.447-1.947-4.433-4.334-4.433-1.886 0-3.54 1.233-4.12 3.073l-.173.54-.56-.087a2 2 0 0 0-.307-.033c-1.1 0-2.013.853-2.12 1.986l-.046.507-.5.087c-1.494.253-2.574 1.566-2.574 3.113 0 .88.354 1.7.987 2.307l1.8 1.833h4.533v1.334H4.894l-2.18-2.22a4.53 4.53 0 0 1-1.38-3.26c0-2.04 1.327-3.78 3.213-4.32.367-1.56 1.72-2.687 3.327-2.707.88-2.107 2.913-3.493 5.207-3.493M8.275 14.127l-.94-.96L12.001 8.5l4.666 4.667-.94.96-3.046-3.04v12.08h-1.36v-12.08z",
  clipRule: "evenodd"
})));

var _path$1Z, _path2$T, _path3$i, _path4$7;
function _extends$2r() { return _extends$2r = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2r.apply(null, arguments); }
const SvgCloud = props => /*#__PURE__*/React.createElement("svg", _extends$2r({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$1Z || (_path$1Z = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z",
  "data-name": "Rectangle 12678"
})), _path2$T || (_path2$T = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18 4A14 14 0 1 1 4 18 14.015 14.015 0 0 1 18 4m0-2a16 16 0 1 0 16 16A16 16 0 0 0 18 2",
  "data-name": "Path 9132"
})), _path3$i || (_path3$i = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0Z",
  "data-name": "Path 10309"
})), _path4$7 || (_path4$7 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.965 11.864a3.557 3.557 0 0 1 3.5 3.2l.156 1.378 1.346.337a2.73 2.73 0 0 1 2.03 2.676 2.78 2.78 0 0 1-.7 1.837l-1.759 1.8H12.282l-1.494-1.523-.024-.024-.024-.023a2.5 2.5 0 0 1-.747-1.787 2.46 2.46 0 0 1 1.618-2.336l.951-.333.3-.963a1.55 1.55 0 0 1 1.327-1.1l1.124-.109.488-1.017a3.49 3.49 0 0 1 3.159-2.009m0-2a5.5 5.5 0 0 0-4.963 3.144 3.55 3.55 0 0 0-3.046 2.5 4.45 4.45 0 0 0-2.956 4.223 4.5 4.5 0 0 0 1.367 3.235l2.083 2.122h12.939l2.377-2.44a4.77 4.77 0 0 0 1.234-3.2 4.72 4.72 0 0 0-3.544-4.616 5.57 5.57 0 0 0-5.491-4.97Z",
  "data-name": "Path 9133"
})));

var _path$1Y;
function _extends$2q() { return _extends$2q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2q.apply(null, arguments); }
const SvgCompassGoTo = props => /*#__PURE__*/React.createElement("svg", _extends$2q({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$1Y || (_path$1Y = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.333 12c0-5.146-4.187-9.333-9.333-9.333-5.147 0-9.334 4.187-9.334 9.333 0 5.147 4.187 9.334 9.334 9.334s9.333-4.187 9.333-9.334m-20 0C1.333 6.107 6.106 1.334 12 1.334c5.893 0 10.666 4.773 10.666 10.666S17.893 22.667 12 22.667 1.333 17.893 1.333 12m8.526 2.107 2.067 5.053L17.06 6.887 4.76 12.02zm1.027-1.02-2.633-1.08h.006l6.327-2.64-2.64 6.307z",
  clipRule: "evenodd"
})));

var _path$1X;
function _extends$2p() { return _extends$2p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2p.apply(null, arguments); }
const SvgCoordinatesGear = props => /*#__PURE__*/React.createElement("svg", _extends$2p({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$1X || (_path$1X = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.334 3.913v7.96c.213-.054.433-.094.666-.094s.454.04.667.094v-7.96l1.86 1.86.94-.94-3.474-3.474L8.52 4.833l.94.94 1.86-1.86zm-1.46 12.126a2.7 2.7 0 0 1-.507-1.233l-7.247 3 1.007-2.433-1.233-.514-1.88 4.547 4.533 1.88.513-1.233-2.433-1.007 7.247-3zm9.273-.62-.1-.686-.06-.4-.007.006h-1.193l-.053.394-.1.686-.62.314a3 3 0 0 0-.314.18l-.586.386-.647-.26-.367-.146-.6 1.033.314.247.553.433-.04.7v.353l.04.7-.553.434-.307.24.593 1.026.354-.146.653-.267.587.387q.151.099.313.18l.62.313.1.687.06.4h1.193l.054-.394.1-.693.62-.313c.106-.054.213-.114.313-.18l.587-.387.646.26.367.147.6-1.034-.313-.246-.554-.434.047-.7v-.353l-.04-.7.553-.433.307-.24-.593-1.027-.36.147-.647.266-.587-.386a3 3 0 0 0-.313-.18zM16.64 13h3.5v.014l.227 1.54q.228.12.447.26l.466-.194.967-.4 1.233 2.14.514.907-1.22.947c.006.086.006.18.006.26l-.003.121-.003.132 1.22.953-.514.907-1.233 2.14-1.44-.58c-.14.093-.293.18-.447.26l-.22 1.533h-3.5l-.226-1.54c-.154-.08-.3-.166-.447-.26l-1.433.594-1.234-2.14-.513-.907 1.22-.953q-.009-.13-.007-.26 0-.066.004-.13l.003-.13-1.22-.954.513-.906 1.234-2.14 1.44.58c.14-.094.293-.18.446-.26zm1.754 7.334a1.832 1.832 0 1 1 0-3.667 1.832 1.832 0 1 1 0 3.667m0-3c-.64 0-1.167.526-1.167 1.166s.527 1.167 1.167 1.167 1.166-.527 1.166-1.167-.526-1.166-1.166-1.166m-6.254-1.567q-.07.012-.14.013c-.733 0-1.333-.6-1.333-1.333s.6-1.333 1.333-1.333c.54 0 1.007.32 1.214.786l-1.074 1.854z",
  clipRule: "evenodd"
})));

var _path$1W;
function _extends$2o() { return _extends$2o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2o.apply(null, arguments); }
const SvgCoordinatesGlobal = props => /*#__PURE__*/React.createElement("svg", _extends$2o({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path$1W || (_path$1W = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.5 2.936v5.967a1.8 1.8 0 0 1 1 0V2.936l1.396 1.396.707-.707L9 1.023 6.396 3.626l.708.707zM7.405 12.031a2 2 0 0 1-.38-.925l-5.436 2.25.756-1.824-.924-.382-1.41 3.4 3.4 1.41.384-.925-1.825-.756zM8.35 11.589a5.5 5.5 0 0 1 1-1.688.99.99 0 0 0-.926.11.996.996 0 0 0-.077 1.578zM13.5 9a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m3.488 4.25h-1.45a7.3 7.3 0 0 0-.3-1.915q.402-.099.786-.256c.565.589.906 1.357.963 2.171m-3.045 3.719q-.22.03-.443.031-.207-.001-.412-.026a2.6 2.6 0 0 1-.612-.898 6.5 6.5 0 0 1 2.071.004 2.6 2.6 0 0 1-.604.889m1.111-.8q.271.061.52.143-.384.282-.828.454.179-.286.308-.597m-2.768.608a3.5 3.5 0 0 1-.86-.465q.268-.089.543-.15.132.322.317.616m1.214-1.283a8 8 0 0 0-1.207.104 6.8 6.8 0 0 1-.304-1.85h3.05a6.8 6.8 0 0 1-.306 1.85 7.7 7.7 0 0 0-1.233-.104m-1.511-2.245a6.9 6.9 0 0 1 .293-1.817c.814.142 1.646.14 2.46-.003.18.59.278 1.203.294 1.82zm1.1-3.223q.426-.055.854.005c.268.26.48.573.619.92a6.5 6.5 0 0 1-2.1.003c.14-.35.353-.667.626-.928m-1.132.84a6 6 0 0 1-.562-.156 3.5 3.5 0 0 1 .892-.489q-.195.308-.33.646m2.79-.633c.307.117.596.278.858.477a5 5 0 0 1-.539.15 4 4 0 0 0-.32-.627m-3.768.846q.394.162.809.261a7.3 7.3 0 0 0-.3 1.91h-1.476c.057-.815.4-1.583.966-2.17zm-.966 2.67h1.476a7.3 7.3 0 0 0 .309 1.94q-.408.098-.797.255a3.5 3.5 0 0 1-.989-2.194zM16 15.945a5.5 5.5 0 0 0-.774-.25 7.3 7.3 0 0 0 .31-1.946h1.45A3.5 3.5 0 0 1 16 15.945"
})));

var _path$1V, _path2$S;
function _extends$2n() { return _extends$2n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2n.apply(null, arguments); }
const SvgCoordinatesX = props => /*#__PURE__*/React.createElement("svg", _extends$2n({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path$1V || (_path$1V = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.5 2.935v5.97c.16-.04.325-.07.5-.07s.34.03.5.07v-5.97l1.395 1.395.705-.705L8.995 1.02 6.39 3.625l.705.705L8.49 2.935zm.5 8.9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-1.598.191.003.004v-.005zm-.377-.921c.05.343.179.657.377.921L1.97 14.275l1.825.755-.385.925-3.4-1.41 1.41-3.4.925.385-.755 1.825z",
  clipRule: "evenodd",
  opacity: 0.4
})), _path2$S || (_path2$S = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m16.575 11.15-.925.385.755 1.825-5.435-2.25c-.05.345-.18.66-.38.925l5.435 2.25-1.825.755.385.925 3.4-1.41-1.41-3.4z"
})));
var coordinatesX = "data:image/svg+xml,%3Csvg%20%20width%3D%2218%22%20%20height%3D%2218%22%20%20viewBox%3D%220%200%2018%2018%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20opacity%3D%220.4%22%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M8.49965%202.93502V8.90502C8.65965%208.86502%208.82465%208.83502%208.99965%208.83502C9.17465%208.83502%209.33965%208.86502%209.49965%208.90502V2.93502L10.8946%204.33002L11.5996%203.62502L8.99465%201.02002L6.38965%203.62502L7.09465%204.33002L8.48965%202.93502H8.49965ZM8.99976%2011.835C9.55204%2011.835%209.99976%2011.3872%209.99976%2010.835C9.99976%2010.2827%209.55204%209.83496%208.99976%209.83496C8.44747%209.83496%207.99976%2010.2827%207.99976%2010.835C7.99976%2011.3872%208.44747%2011.835%208.99976%2011.835ZM7.4019%2012.0262C7.40285%2012.0274%207.40381%2012.0287%207.40477%2012.03V12.025L7.4019%2012.0262ZM7.02477%2011.105C7.07453%2011.4483%207.20352%2011.762%207.4019%2012.0262L1.96977%2014.275L3.79477%2015.03L3.40977%2015.955L0.00976562%2014.545L1.41977%2011.145L2.34477%2011.53L1.58977%2013.355L7.02477%2011.105Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M16.5748%2011.1499L15.6498%2011.5349L16.4048%2013.3599L10.9698%2011.1099C10.9198%2011.4549%2010.7898%2011.7699%2010.5898%2012.0349L16.0248%2014.2849L14.1998%2015.0399L14.5848%2015.9649L17.9848%2014.5549L16.5748%2011.1549V11.1499Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$1U, _path2$R;
function _extends$2m() { return _extends$2m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2m.apply(null, arguments); }
const SvgCoordinatesY = props => /*#__PURE__*/React.createElement("svg", _extends$2m({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path$1U || (_path$1U = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.5 8.905v-5.97h-.01L7.097 4.33l-.705-.705L8.996 1.02 11.6 3.625l-.705.705L9.5 2.935v5.97c-.16-.04-.325-.07-.5-.07s-.34.03-.5.07m.5 2.93a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7.576-.686-.925.385.755 1.825-5.435-2.25c-.05.345-.18.66-.38.925l5.435 2.25-1.825.755.385.925 3.4-1.41-1.41-3.4z",
  clipRule: "evenodd",
  opacity: 0.4
})), _path2$R || (_path2$R = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.405 12.03c-.2-.265-.33-.58-.38-.925l-5.435 2.25.755-1.825-.925-.385-1.41 3.41 3.4 1.41.385-.925-1.825-.755 5.435-2.25z"
})));
var coordinatesY = "data:image/svg+xml,%3Csvg%20%20width%3D%2218%22%20%20height%3D%2218%22%20%20viewBox%3D%220%200%2018%2018%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20opacity%3D%220.4%22%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M8.50063%208.90453V2.93453H8.49062L7.09562%204.32953L6.39062%203.62453L8.99563%201.01953L11.6006%203.62453L10.8956%204.32953L9.50063%202.93453V8.90453C9.34063%208.86453%209.17563%208.83453%209.00063%208.83453C8.82563%208.83453%208.66063%208.86453%208.50063%208.90453ZM9.00073%2011.8345C9.55302%2011.8345%2010.0007%2011.3868%2010.0007%2010.8345C10.0007%2010.2822%209.55302%209.83447%209.00073%209.83447C8.44845%209.83447%208.00073%2010.2822%208.00073%2010.8345C8.00073%2011.3868%208.44845%2011.8345%209.00073%2011.8345ZM16.5758%2011.1494L15.6508%2011.5344L16.4058%2013.3594L10.9708%2011.1094C10.9208%2011.4544%2010.7908%2011.7694%2010.5908%2012.0344L16.0258%2014.2844L14.2008%2015.0394L14.5858%2015.9644L17.9858%2014.5544L16.5758%2011.1544V11.1494Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M7.40477%2012.03C7.20477%2011.765%207.07477%2011.45%207.02477%2011.105L1.58977%2013.355L2.34477%2011.53L1.41977%2011.145L0.00976562%2014.555L3.40977%2015.965L3.79477%2015.04L1.96977%2014.285L7.40477%2012.035V12.03Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$1T, _path2$Q;
function _extends$2l() { return _extends$2l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2l.apply(null, arguments); }
const SvgCoordinatesZ = props => /*#__PURE__*/React.createElement("svg", _extends$2l({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path$1T || (_path$1T = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9 11.835a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7.575-.685-.925.385.755 1.825-5.435-2.25c-.05.345-.18.66-.38.925l5.435 2.25-1.825.755.385.925 3.4-1.41-1.41-3.4zm-9.173.876.003.004v-.005zm-.377-.921c.05.343.179.657.377.921L1.97 14.275l1.825.755-.385.925-3.4-1.41 1.41-3.4.925.385-.755 1.825z",
  clipRule: "evenodd",
  opacity: 0.4
})), _path2$Q || (_path2$Q = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.5 2.936v5.97c.16-.04.326-.07.5-.07.176 0 .34.03.5.07v-5.97l1.396 1.395.705-.705L8.996 1.02 6.39 3.626l.705.705L8.49 2.936z"
})));
var coordinatesZ = "data:image/svg+xml,%3Csvg%20%20width%3D%2218%22%20%20height%3D%2218%22%20%20viewBox%3D%220%200%2018%2018%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20opacity%3D%220.4%22%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M8.99976%2011.835C9.55204%2011.835%209.99976%2011.3872%209.99976%2010.835C9.99976%2010.2827%209.55204%209.83496%208.99976%209.83496C8.44747%209.83496%207.99976%2010.2827%207.99976%2010.835C7.99976%2011.3872%208.44747%2011.835%208.99976%2011.835ZM16.575%2011.1501L15.65%2011.5351L16.405%2013.3601L10.97%2011.1101C10.92%2011.4551%2010.79%2011.7701%2010.59%2012.0351L16.025%2014.2851L14.2%2015.0401L14.585%2015.9651L17.985%2014.5551L16.575%2011.1551V11.1501ZM7.40189%2012.0262C7.40285%2012.0274%207.4038%2012.0287%207.40476%2012.03V12.025L7.40189%2012.0262ZM7.02477%2011.105C7.07453%2011.4483%207.20352%2011.762%207.40189%2012.0262L1.96976%2014.275L3.79476%2015.03L3.40977%2015.955L0.00976562%2014.545L1.41976%2011.145L2.34476%2011.53L1.58976%2013.355L7.02477%2011.105Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M8.50063%202.93551V8.90551C8.66063%208.86551%208.82563%208.83551%209.00063%208.83551C9.17563%208.83551%209.34063%208.86551%209.50063%208.90551V2.93551L10.8956%204.33051L11.6006%203.62551L8.99563%201.02051L6.39062%203.62551L7.09563%204.33051L8.49062%202.93551H8.50063Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _circle$5, _g$D;
function _extends$2k() { return _extends$2k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2k.apply(null, arguments); }
const SvgCoordinates = props => /*#__PURE__*/React.createElement("svg", _extends$2k({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _circle$5 || (_circle$5 = /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2,
  fill: "currentColor",
  transform: "translate(15.995 19.667)"
})), _g$D || (_g$D = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "m33.148 22.3-1.847.765 1.511 3.649-10.872-4.5a3.95 3.95 0 0 1-.76 1.85l10.867 4.5-3.65 1.512.766 1.848 6.8-2.819ZM17 5.872v11.935a3.6 3.6 0 0 1 2 0V5.872l2.793 2.793 1.414-1.414L18 2.044l-5.207 5.207 1.414 1.414ZM14.81 24.063a3.95 3.95 0 0 1-.76-1.85l-10.872 4.5 1.511-3.649-1.847-.765-2.819 6.8 6.8 2.819.766-1.848-3.65-1.512Z"
}))));

var _path$1S, _g$C, _g2$2;
function _extends$2j() { return _extends$2j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2j.apply(null, arguments); }
const SvgCopyFile = props => /*#__PURE__*/React.createElement("svg", _extends$2j({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Copy File",
  viewBox: "0 0 24 24"
}, props), _path$1S || (_path$1S = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 7748"
})), _g$C || (_g$C = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 16171"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#b3b3b3",
  d: "M6.952 6.319v15.018h12.431v-10.66l-3.724-4.358Z",
  "data-name": "Path 9895"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.5 4.998H7.331a1.167 1.167 0 0 0-1.167 1.167v15.171h14V9.666Zm.242 2.128 2.79 2.79h-2.79ZM7.498 20.002V6.665a.334.334 0 0 1 .333-.333h6.577v4.918h4.426v8.748Z",
  "data-name": "Path 5180"
}))), _g2$2 || (_g2$2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6013"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4.499 18.335v-14.5a.5.5 0 0 1 .5-.5h8.836l-.667-.667H4.999a1.17 1.17 0 0 0-1.167 1.167v15.171h.667Z",
  "data-name": "Path 5181"
}))));
var copyFile = "data:image/svg+xml,%3Csvg%20%20id%3D%22Copy_File%22%20%20data-name%3D%22Copy%20File%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2224%22%20%20height%3D%2224%22%20%20viewBox%3D%220%200%2024%2024%22%3E%20%20%3Crect%20%20%20%20id%3D%22Rectangle_7748%22%20%20%20%20data-name%3D%22Rectangle%207748%22%20%20%20%20width%3D%2224%22%20%20%20%20height%3D%2224%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%20%20%3Cg%20%20%20%20id%3D%22Group_16171%22%20%20%20%20data-name%3D%22Group%2016171%22%20%20%20%20transform%3D%22translate%286.164%204.998%29%22%20%20%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22Path_9895%22%20%20%20%20%20%20data-name%3D%22Path%209895%22%20%20%20%20%20%20d%3D%22M0%2C0V15.018H12.431V4.358L8.707%2C0Z%22%20%20%20%20%20%20transform%3D%22translate%280.788%201.321%29%22%20%20%20%20%20%20fill%3D%22%23b3b3b3%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22Path_5180%22%20%20%20%20%20%20data-name%3D%22Path%205180%22%20%20%20%20%20%20d%3D%22M4314.335%2C335.5h-8.169a1.167%2C1.167%2C0%2C0%2C0-1.167%2C1.167v15.171h14v-11.67Zm.242%2C2.128%2C2.79%2C2.79h-2.79Zm-8.244%2C12.876V337.167a.334.334%2C0%2C0%2C1%2C.333-.333h6.577v4.918h4.426V350.5Z%22%20%20%20%20%20%20transform%3D%22translate%28-4304.999%20-335.5%29%22%20%20%20%20%20%20fill%3D%22%23fff%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22Group_6013%22%20data-name%3D%22Group%206013%22%20transform%3D%22translate%283.832%202.664%29%22%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22Path_5181%22%20%20%20%20%20%20data-name%3D%22Path%205181%22%20%20%20%20%20%20d%3D%22M4302.166%2C347.671v-14.5a.5.5%2C0%2C0%2C1%2C.5-.5h8.836l-.667-.667h-8.169a1.168%2C1.168%2C0%2C0%2C0-1.167%2C1.167v15.171h.667Z%22%20%20%20%20%20%20transform%3D%22translate%28-4301.499%20-332%29%22%20%20%20%20%20%20fill%3D%22%23fff%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _path$1R;
function _extends$2i() { return _extends$2i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2i.apply(null, arguments); }
const SvgCopy = props => /*#__PURE__*/React.createElement("svg", _extends$2i({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$1R || (_path$1R = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 16.22h3.333l-.006.007v1.333H2.66V3.113C2.66 2.5 3.16 2 3.773 2h11.114C15.5 2 16 2.5 16 3.113v2h-1.333V3.667a.33.33 0 0 0-.333-.334h-10A.33.33 0 0 0 4 3.667zm6 4.447h10.667V8.113a.33.33 0 0 0-.334-.333h-10a.33.33 0 0 0-.333.333zm-.227-14.22h11.114l-.007-.007c.614 0 1.114.5 1.114 1.113v14.454H8.66V7.56c0-.613.5-1.113 1.113-1.113",
  clipRule: "evenodd"
})));
var copy = "data:image/svg+xml,%3Csvg%20%20width%3D%2224%22%20%20height%3D%2224%22%20%20viewBox%3D%220%200%2024%2024%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M4.00016%2016.22H7.33349L7.32682%2016.2267V17.56H2.66016V3.11333C2.66016%202.5%203.16016%202%203.77349%202H14.8868C15.5002%202%2016.0002%202.5%2016.0002%203.11333V5.11333H14.6668V3.66667C14.6668%203.48%2014.5202%203.33333%2014.3335%203.33333H4.33349C4.14682%203.33333%204.00016%203.48%204.00016%203.66667V16.22ZM10.0002%2020.6666H20.6668V8.11328C20.6668%207.92661%2020.5202%207.77994%2020.3335%207.77994H10.3335C10.1468%207.77994%2010.0002%207.92661%2010.0002%208.11328V20.6666ZM9.77349%206.44661H20.8868L20.8802%206.43994C21.4935%206.43994%2021.9935%206.93994%2021.9935%207.55327V22.0066H8.66016V7.55994C8.66016%206.94661%209.16016%206.44661%209.77349%206.44661Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$1Q;
function _extends$2h() { return _extends$2h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2h.apply(null, arguments); }
const SvgCrop = props => /*#__PURE__*/React.createElement("svg", _extends$2h({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path$1Q || (_path$1Q = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M22.222 9.777v12.445H9.777V9.777zM9.777 2.666H8v5.333H2.666v1.778h5.333V24h14.223v5.334h1.777v-5.334h5.334v-1.777h-5.334V7.999H9.777z"
})));

var _path$1P, _path2$P;
function _extends$2g() { return _extends$2g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2g.apply(null, arguments); }
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends$2g({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18"
}, props), _path$1P || (_path$1P = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h18v18H0z",
  "data-name": "Rettangolo 6250"
})), _path2$P || (_path2$P = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16 4h-3.916l-2-2h-2.15L5.929 4H2v1h1.226l1.633 11h8.19l1.633-11H16ZM8.348 3h1.323l1 1H7.345Zm1.877 2-.491 10H8.267L7.776 5ZM4.238 5h2.537l.491 10H5.722Zm7.949 10h-1.451l.491-10h2.444Z",
  "data-name": "Tracciato 4280"
})));
var _delete = "data:image/svg+xml,%3Csvg%20%20id%3D%22Delete%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2218%22%20%20height%3D%2218%22%20%20viewBox%3D%220%200%2018%2018%22%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_6250%22%20%20%20%20data-name%3D%22Rettangolo%206250%22%20%20%20%20width%3D%2218%22%20%20%20%20height%3D%2218%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20id%3D%22Tracciato_4280%22%20%20%20%20data-name%3D%22Tracciato%204280%22%20%20%20%20d%3D%22M5638%2C986h-3.916l-2-2h-2.15l-2.005%2C2H5624v1h1.226l1.633%2C11h8.19l1.633-11H5638Zm-7.652-1h1.323l1%2C1h-3.326Zm1.877%2C2-.491%2C10h-1.467l-.491-10Zm-5.987%2C0h2.537l.491%2C10h-1.544Zm7.949%2C10h-1.451l.491-10h2.444Z%22%20%20%20%20transform%3D%22translate%28-5622%20-982%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$1O;
function _extends$2f() { return _extends$2f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2f.apply(null, arguments); }
const SvgDeviationLabel = props => /*#__PURE__*/React.createElement("svg", _extends$2f({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$1O || (_path$1O = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m20 18.573-1.467-.306a12 12 0 0 0-2.354-.234c-1.533 0-3.04.293-4.473.874a10.3 10.3 0 0 1-5.927.553l-1.68-.34-.1-.02V5.333A.33.33 0 0 1 4.333 5h15.333a.33.33 0 0 1 .333.333zm.16-14.907H3.832c-.647 0-1.167.56-1.167 1.26v15.267l1.167.233 1.68.34c.76.154 1.533.234 2.3.234 1.493 0 2.98-.287 4.386-.86 1.28-.514 2.627-.78 3.974-.78.7 0 1.4.067 2.086.207l1.9.4 1.167.246V4.927c0-.694-.52-1.26-1.167-1.26m-5.366 6.168h-2.46v-2.46h-.667v2.46h-2.46v.666h2.46v2.46h.667V10.5h2.46zM9.207 15h5.587v.667H9.207z",
  clipRule: "evenodd"
})));

var _g$B, _path$1N;
function _extends$2e() { return _extends$2e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2e.apply(null, arguments); }
const SvgDisabled = props => /*#__PURE__*/React.createElement("svg", _extends$2e({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36.007"
}, props), _g$B || (_g$B = /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 10989"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.999 3.999a14 14 0 1 0 14 14 14 14 0 0 0-14-14m-12 14a11.986 11.986 0 0 1 19.739-9.155L8.844 25.739a11.94 11.94 0 0 1-2.845-7.74m12 12a11.94 11.94 0 0 1-7.74-2.845l16.894-16.895a11.986 11.986 0 0 1-9.154 19.74",
  "data-name": "Tracciato 9171"
}))), _path$1N || (_path$1N = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36.007H0z",
  "data-name": "Rettangolo 12713"
})));
var disabled = "data:image/svg+xml,%3Csvg%20%20id%3D%22Disable%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2236%22%20%20height%3D%2236.007%22%20%20viewBox%3D%220%200%2036%2036.007%22%3E%20%20%3Cg%20%20%20%20id%3D%22Raggruppa_10989%22%20%20%20%20data-name%3D%22Raggruppa%2010989%22%20%20%20%20transform%3D%22translate%284%204%29%22%20%20%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22Tracciato_9171%22%20%20%20%20%20%20data-name%3D%22Tracciato%209171%22%20%20%20%20%20%20d%3D%22M1270%2C264a14%2C14%2C0%2C1%2C0%2C14%2C14A14%2C14%2C0%2C0%2C0%2C1270%2C264Zm-12%2C14a11.986%2C11.986%2C0%2C0%2C1%2C19.739-9.155l-16.894%2C16.895A11.941%2C11.941%2C0%2C0%2C1%2C1258%2C278Zm12%2C12a11.941%2C11.941%2C0%2C0%2C1-7.74-2.845l16.894-16.895A11.986%2C11.986%2C0%2C0%2C1%2C1270%2C290Z%22%20%20%20%20%20%20transform%3D%22translate%28-1256.001%20-264.001%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_12713%22%20%20%20%20data-name%3D%22Rettangolo%2012713%22%20%20%20%20width%3D%2236%22%20%20%20%20height%3D%2236.007%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$1M, _path2$O, _path3$h, _path4$6, _image, _path5$5;
function _extends$2d() { return _extends$2d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2d.apply(null, arguments); }
const SvgDistanceColoring = props => /*#__PURE__*/React.createElement("svg", _extends$2d({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em",
  "data-name": "Distance Coloring",
  viewBox: "0 0 36 36"
}, props), _path$1M || (_path$1M = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z",
  "data-name": "Rectangle 330"
})), _path2$O || (_path2$O = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6 25h24v2H6z",
  "data-name": "Rectangle 331"
})), _path3$h || (_path3$h = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2 18h2v16H2z",
  "data-name": "Rectangle 332"
})), _path4$6 || (_path4$6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M32 18h2v16h-2z",
  "data-name": "Rectangle 333"
})), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAADKADAAQAAAABAAAADAAAAAAwxNhnAAABhklEQVQoFU2Sz0ojQRDGfz3TmRijSUhWQRQi4oJBEPTiHvcFvOzRN/Dms3jwIF49+RSeBMGLh11EQTcSiH9i1AnMTMxMW9OTCRZ0f0XXV19VdbcyxpCbOsU0r+F3F371Yfsf1AWbd6ic4+SOusCoGB7n8hOIirDURgLJRNUmqA72wKyAGoe8T9i4AidJGJY6RNMPNqJVKORpUV2U1YGgkVVYvoepUIKOIZy5IZi9Jl7zjcbLCJTGWBc8kzkuAxI3oLt6KOptqZx1r+040iuJrFT9GY6PXoUs/thGXi93UUU/6w1HS9JIlGLcyOeg/4ddHhn+LxPeVojfPSJBmcEHV+P6XfRA7lPs5/2JbOKsDGzHykvLg9ccoIMfLVX7e2qcOKLSu6IcdpnXcvliYexSXf1AFbKEtIqdxAtfJuRq0qNVebMJd/6sRd0ILdZ22somPG3tqVS5ZAYsFN5o1QNLGCYO758FnJkRxWXfvrb6/jVS1v75plksRzRKI9ZrfbbnniffIo1/AW7dlHtlUTm0AAAAAElFTkSuQmCC",
  width: 12,
  height: 12,
  "data-name": "Rectangle 334",
  transform: "translate(21 3)"
})), _path5$5 || (_path5$5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M27 3.879a5 5 0 1 1-5 5 5.006 5.006 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7.007 7.007 0 0 0-7-7",
  "data-name": "Path 204"
})));

var _path$1L;
function _extends$2c() { return _extends$2c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2c.apply(null, arguments); }
const SvgDistanceHorizontal = props => /*#__PURE__*/React.createElement("svg", _extends$2c({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path$1L || (_path$1L = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.773 8.364a1 1 0 1 1-1.542 1.272 1 1 0 0 1 1.542-1.272m13.866 1.41a1 1 0 1 0-1.272-1.543 1 1 0 0 0 1.272 1.543M14.071 8.5H3.93c.04.16.07.325.07.5s-.03.34-.07.5h10.14c-.04-.16-.07-.325-.07-.5s.03-.34.07-.5",
  clipRule: "evenodd"
})));
var distanceHorizontal = "data:image/svg+xml,%3Csvg%20%20width%3D%2218%22%20%20height%3D%2218%22%20%20viewBox%3D%220%200%2018%2018%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M2.77349%208.36382C3.12487%208.78991%203.06429%209.42017%202.63819%209.77154C2.2121%2010.1229%201.58184%2010.0623%201.23047%209.63624C0.879097%209.21015%200.939673%208.57989%201.36577%208.22851C1.79186%207.87714%202.42212%207.93772%202.77349%208.36382ZM16.6392%209.77447C17.0653%209.4231%2017.1258%208.79284%2016.7745%208.36674C16.4231%207.94065%2015.7928%207.88007%2015.3667%208.23144C14.9406%208.58281%2014.8801%209.21308%2015.2314%209.63917C15.5828%2010.0653%2016.2131%2010.1258%2016.6392%209.77447ZM14.0707%208.49998H3.93068C3.97068%208.65998%204.00068%208.82498%204.00068%208.99998C4.00068%209.17498%203.97068%209.33998%203.93068%209.49998H14.0707C14.0307%209.33998%2014.0007%209.17498%2014.0007%208.99998C14.0007%208.82498%2014.0307%208.65998%2014.0707%208.49998Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$1K;
function _extends$2b() { return _extends$2b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2b.apply(null, arguments); }
const SvgDistanceVertical = props => /*#__PURE__*/React.createElement("svg", _extends$2b({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path$1K || (_path$1K = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.861 2.51a1 1 0 1 0-1.718-1.023A1 1 0 0 0 9.861 2.51m-1.36 1.42v10.14c.16-.04.325-.07.5-.07s.34.03.5.07V3.93c-.16.04-.325.07-.5.07s-.34-.03-.5-.07m1.014 11.213a1 1 0 1 1-1.025 1.718 1 1 0 0 1 1.025-1.718",
  clipRule: "evenodd"
})));
var distanceVertical = "data:image/svg+xml,%3Csvg%20%20width%3D%2218%22%20%20height%3D%2218%22%20%20viewBox%3D%220%200%2018%2018%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M9.86107%202.51073C10.1439%202.03634%209.98854%201.42252%209.51415%201.13973C9.03976%200.856936%208.42594%201.01226%208.14315%201.48665C7.86035%201.96104%208.01567%202.57486%208.49006%202.85765C8.96445%203.14044%209.57827%202.98512%209.86107%202.51073ZM8.50073%203.93008V14.0701C8.66073%2014.0301%208.82573%2014.0001%209.00073%2014.0001C9.17573%2014.0001%209.34073%2014.0301%209.50073%2014.0701V3.93008C9.34073%203.97008%209.17573%204.00008%209.00073%204.00008C8.82573%204.00008%208.66073%203.97008%208.50073%203.93008ZM9.51464%2015.1431C9.98903%2015.4259%2010.1443%2016.0398%209.86156%2016.5141C9.57876%2016.9885%208.96494%2017.1439%208.49055%2016.8611C8.01616%2016.5783%207.86084%2015.9645%208.14364%2015.4901C8.42643%2015.0157%209.04025%2014.8604%209.51464%2015.1431Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$1J;
function _extends$2a() { return _extends$2a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2a.apply(null, arguments); }
const SvgDollhouse = props => /*#__PURE__*/React.createElement("svg", _extends$2a({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Livello 2",
  viewBox: "0 0 36 36"
}, props), _path$1J || (_path$1J = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.014 5.88 36 14.488v12.374l-9.674 4.258-10.293-4.867-6.38 2.743L.06 24.747 0 12.357zm-.023 2.167L3.539 13.083l6.121 2.776 6.409-2.67 10.293 4.775 6.163-2.795zm1.051 16.472 8.298 3.922v-8.747l-8.298-3.849zm-2-8.733-4.383 1.823v8.778l4.383-1.885zm18.948.914-6.65 3.016v8.768l6.65-2.926zM8.66 26.369V17.6l-6.65-3.016.043 8.858z"
})));
var dollhouse = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20%20id%3D%22Livello_2%22%20%20data-name%3D%22Livello%202%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2236%22%20%20height%3D%2236%22%20%20viewBox%3D%220%200%2036%2036%22%3E%20%20%3Cpath%20%20%20%20fill%3D%22currentColor%22%20%20%20%20d%3D%22M16.013995118%2C5.8804719284l19.986004882%2C8.6079739626v12.3739625712l-9.6742066721%2C4.2571196094-10.2932465419-4.8663954435-6.3788445891%2C2.7432058584L.0595606184%2C24.7470301058l-.0595606184-12.3895850285L16.013995118%2C5.8804719284Zm-.0234336859%2C2.1666395443L3.5391578519%2C13.0826688365l6.1211960944%2C2.7761594793%2C6.4083028264-2.6691838006%2C10.2931414373%2C4.7740047933%2C6.1628763222-2.7950162734L15.9905614321%2C8.0471114727Zm1.0515866558%2C16.4714401953l8.2974776241%2C3.9229454841v-8.7474165989l-8.2974776241-3.8489218877v8.6733930024Zm-1.9996745321-8.7325264443l-4.3830756713%2C1.8228844589v8.7777461351l4.3830756713-1.884825061V15.7860252238Zm18.9475996745%2C.9136696501l-6.6507729862%2C3.0164157852v8.7678600488l6.6507997559-2.9260374288-.0000267697-8.8582384052ZM8.6597233523%2C26.3686533767v-8.767921074l-6.6498576078-3.0159886086%2C.0435109845%2C8.8578112286%2C6.6063466233%2C2.926098454Z%22%20%20%2F%3E%3C%2Fsvg%3E";

var _g$A, _path$1I;
function _extends$29() { return _extends$29 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$29.apply(null, arguments); }
const SvgDollhouseWarning = props => /*#__PURE__*/React.createElement("svg", _extends$29({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _g$A || (_g$A = /*#__PURE__*/React.createElement("g", {
  fill: "#FFCC4C"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 30.6,
  r: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 21.6h2v6.5h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27 19.6c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7m0-2c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9"
}))), _path$1I || (_path$1I = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16 25.9c.1-1.4.4-2.7 1-3.9v-6.5l4.1 1.9c.7-.5 1.5-.8 2.3-1.1L16 12.9l-6.4 2.7-6.1-2.8 12.5-5 16.5 7.1-2.7 1.1c.9.2 1.8.6 2.5 1l1.6-.7v1.8c.8.6 1.4 1.4 2 2.2v-6.2L16 5.5 0 12v12.4l9.6 4.2zm-7.4.1L2 23.1v-8.9l6.6 3zm6.4-1.8L10.6 26v-8.8l4.4-1.8z",
  opacity: 0.3
})));

var _circle$4, _circle2$3, _circle3$3, _g$z;
function _extends$28() { return _extends$28 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$28.apply(null, arguments); }
const SvgDotsVertical = props => /*#__PURE__*/React.createElement("svg", _extends$28({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Dots Vertical",
  viewBox: "0 0 18 18"
}, props), _circle$4 || (_circle$4 = /*#__PURE__*/React.createElement("circle", {
  cx: 1,
  cy: 1,
  r: 1,
  fill: "currentColor",
  "data-name": "Ellipse 1468",
  transform: "translate(8 12)"
})), _circle2$3 || (_circle2$3 = /*#__PURE__*/React.createElement("circle", {
  cx: 1,
  cy: 1,
  r: 1,
  fill: "currentColor",
  "data-name": "Ellipse 1469",
  transform: "translate(8 8)"
})), _circle3$3 || (_circle3$3 = /*#__PURE__*/React.createElement("circle", {
  cx: 1,
  cy: 1,
  r: 1,
  fill: "currentColor",
  "data-name": "Ellipse 1470",
  transform: "translate(8 4)"
})), _g$z || (_g$z = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4589"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4588"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 18V0h18v18z",
  "data-name": "Rectangle 6196"
})))));
var dots_vertical = "data:image/svg+xml,%3Csvg%20%20id%3D%22Dots_Vertical%22%20%20data-name%3D%22Dots%20Vertical%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2218%22%20%20height%3D%2218%22%20%20viewBox%3D%220%200%2018%2018%22%3E%20%20%3Ccircle%20%20%20%20id%3D%22Ellipse_1468%22%20%20%20%20data-name%3D%22Ellipse%201468%22%20%20%20%20cx%3D%221%22%20%20%20%20cy%3D%221%22%20%20%20%20r%3D%221%22%20%20%20%20transform%3D%22translate%288%2012%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Ccircle%20%20%20%20id%3D%22Ellipse_1469%22%20%20%20%20data-name%3D%22Ellipse%201469%22%20%20%20%20cx%3D%221%22%20%20%20%20cy%3D%221%22%20%20%20%20r%3D%221%22%20%20%20%20transform%3D%22translate%288%208%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Ccircle%20%20%20%20id%3D%22Ellipse_1470%22%20%20%20%20data-name%3D%22Ellipse%201470%22%20%20%20%20cx%3D%221%22%20%20%20%20cy%3D%221%22%20%20%20%20r%3D%221%22%20%20%20%20transform%3D%22translate%288%204%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cg%20id%3D%22Group_4589%22%20data-name%3D%22Group%204589%22%20transform%3D%22translate%280%200%29%22%3E%20%20%20%20%3Cg%20id%3D%22Group_4588%22%20data-name%3D%22Group%204588%22%3E%20%20%20%20%20%20%3Crect%20%20%20%20%20%20%20%20id%3D%22Rectangle_6196%22%20%20%20%20%20%20%20%20data-name%3D%22Rectangle%206196%22%20%20%20%20%20%20%20%20width%3D%2218%22%20%20%20%20%20%20%20%20height%3D%2218%22%20%20%20%20%20%20%20%20transform%3D%22translate%280%2018%29%20rotate%28-90%29%22%20%20%20%20%20%20%20%20fill%3D%22none%22%20%20%20%20%20%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _path$1H;
function _extends$27() { return _extends$27 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$27.apply(null, arguments); }
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends$27({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), _path$1H || (_path$1H = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.556 28.582V13.471h1.778v13.332h21.333V13.471h1.778v15.111ZM16 23.248l-6.222-6.222 1.25-1.282 4.067 4.049v-16.1h1.811v16.1l4.067-4.051 1.25 1.282-6.222 6.223Z",
  "data-name": "download"
})));
var download = "data:image/svg+xml,%3Csvg%20%20id%3D%22download%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20%20width%3D%2232%22%20%20height%3D%2232%22%20%20viewBox%3D%220%200%2032%2032%22%3E%20%20%3Cg%20id%3D%22download-2%22%20data-name%3D%22download%22%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22vector%22%20%20%20%20%20%20d%3D%22M0%2C24.889V9.778H1.778V23.11H23.111V9.778h1.778V24.889Zm12.444-5.334h0L6.222%2C13.333l1.25-1.282L11.539%2C16.1V0H13.35V16.1l4.067-4.051%2C1.25%2C1.282-6.222%2C6.223Z%22%20%20%20%20%20%20transform%3D%22translate%283.556%203.693%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _path$1G, _path2$N;
function _extends$26() { return _extends$26 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$26.apply(null, arguments); }
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends$26({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$1G || (_path$1G = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z"
})), _path2$N || (_path2$N = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m31.58 7.33-2.95-2.94a1.993 1.993 0 0 0-2.82.01L8.06 22.14 4 32l9.86-4.1 17.73-17.74c.77-.78.77-2.05-.01-2.83M12.72 26.21 7.69 28.3l2.07-5.03 13.25-13.25 2.94 2.95zm14.65-14.66L24.42 8.6l2.44-2.44c.19-.2.51-.2.71 0l2.24 2.23c.2.2.2.51 0 .71z"
})));
var edit = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20%20version%3D%221.1%22%20%20id%3D%22Layer_1%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20%20x%3D%220px%22%20%20y%3D%220px%22%20%20width%3D%2236px%22%20%20height%3D%2236px%22%20%20viewBox%3D%220%200%2036%2036%22%20%20enable-background%3D%22new%200%200%2036%2036%22%20%20xml%3Aspace%3D%22preserve%22%3E%20%20%3Crect%20y%3D%220%22%20fill%3D%22none%22%20width%3D%2236%22%20height%3D%2236%22%20%2F%3E%20%20%3Cpath%20%20%20%20fill%3D%22currentColor%22%20%20%20%20d%3D%22M31.58%2C7.33l-2.95-2.94c-0.39-0.39-0.9-0.58-1.41-0.58c-0.51%2C0-1.02%2C0.2-1.41%2C0.59L8.06%2C22.14L4%2C32l9.86-4.1%20l17.73-17.74C32.36%2C9.38%2C32.36%2C8.11%2C31.58%2C7.33z%20M12.72%2C26.21L7.69%2C28.3l2.07-5.03l13.25-13.25l2.94%2C2.95L12.72%2C26.21z%20M27.37%2C11.55%20L24.42%2C8.6l2.44-2.44c0.19-0.2%2C0.51-0.2%2C0.71%2C0l2.24%2C2.23c0.2%2C0.2%2C0.2%2C0.51%2C0%2C0.71L27.37%2C11.55z%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$1F, _path2$M, _path3$g, _path4$5, _path5$4;
function _extends$25() { return _extends$25 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$25.apply(null, arguments); }
const SvgEmailSent = props => /*#__PURE__*/React.createElement("svg", _extends$25({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 385.292 293.5"
}, props), _path$1F || (_path$1F = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M-1-1h802v602H-1z"
})), _path2$M || (_path2$M = /*#__PURE__*/React.createElement("path", {
  fill: "#01426a",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  d: "M228.954 254.493H.5V21.667A21.135 21.135 0 0 1 21.612.5H317.2a21.134 21.134 0 0 1 21.112 21.167v137.354H317.2V26.959a5.29 5.29 0 0 0-5.275-5.293H26.891a5.29 5.29 0 0 0-5.279 5.293v206.369h207.342v21.165z"
})), _path3$g || (_path3$g = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M246.734 154.942h138.558V293.5H246.734z"
})), _path4$5 || (_path4$5 = /*#__PURE__*/React.createElement("path", {
  fill: "#0af",
  d: "m305.035 258.35-34.729-33.795 5.347-5.5 28.3 27.536 40.743-57.7 6.258 4.425z"
})), _path5$4 || (_path5$4 = /*#__PURE__*/React.createElement("path", {
  fill: "#01426a",
  d: "M167.465 137.094 21.845 39.836v23.94l145.191 96.972.428.265.425-.265 149.086-99.572v-23.94z"
})));
var email_sent = "data:image/svg+xml,%3Csvg%20%20width%3D%22385.292%22%20%20height%3D%22293.5%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20viewBox%3D%220%200%20385.292%20293.5%22%3E%20%20%3Cg%3E%20%20%20%20%3Ctitle%3Ebackground%3C%2Ftitle%3E%20%20%20%20%3Crect%20%20%20%20%20%20fill%3D%22none%22%20%20%20%20%20%20id%3D%22canvas_background%22%20%20%20%20%20%20height%3D%22602%22%20%20%20%20%20%20width%3D%22802%22%20%20%20%20%20%20y%3D%22-1%22%20%20%20%20%20%20x%3D%22-1%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%3E%20%20%20%20%3Ctitle%3ELayer%201%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Raggruppa_12601%22%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20stroke-miterlimit%3D%2210%22%20%20%20%20%20%20%20%20stroke%3D%22rgba%280%2C0%2C0%2C0%29%22%20%20%20%20%20%20%20%20fill%3D%22%2301426a%22%20%20%20%20%20%20%20%20d%3D%22m228.954%2C254.493l-228.454%2C0l0%2C-232.826a21.135%2C21.135%200%200%201%2021.112%2C-21.167l295.588%2C0a21.134%2C21.134%200%200%201%2021.112%2C21.167l0%2C137.354l-21.112%2C0l0%2C-132.062a5.29%2C5.29%200%200%200%20-5.275%2C-5.293l-285.034%2C0a5.292%2C5.292%200%200%200%20-5.279%2C5.293l0%2C206.369l207.342%2C0l0%2C21.164l0%2C0.001z%22%20%20%20%20%20%20%20%20id%3D%22Sottrazione_2%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Cg%20id%3D%22Confirm_-_Success_-_Check%22%3E%20%20%20%20%20%20%20%20%3Crect%20%20%20%20%20%20%20%20%20%20x%3D%22246.733978%22%20%20%20%20%20%20%20%20%20%20y%3D%22154.942001%22%20%20%20%20%20%20%20%20%20%20fill%3D%22none%22%20%20%20%20%20%20%20%20%20%20height%3D%22138.558%22%20%20%20%20%20%20%20%20%20%20width%3D%22138.558%22%20%20%20%20%20%20%20%20%20%20id%3D%22Rettangolo_6163%22%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20%20fill%3D%22%230af%22%20%20%20%20%20%20%20%20%20%20d%3D%22m305.035189%2C258.350017l-34.729%2C-33.795l5.347%2C-5.5l28.3%2C27.536l40.743%2C-57.7l6.258%2C4.425l-45.919%2C65.034z%22%20%20%20%20%20%20%20%20%20%20id%3D%22Tracciato_4183%22%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20fill%3D%22%2301426a%22%20%20%20%20%20%20%20%20d%3D%22m167.465149%2C137.094011l-145.621%2C-97.258l0%2C23.94l145.192%2C96.972l0.428%2C0.265l0.425%2C-0.265l149.086%2C-99.572l0%2C-23.94l-149.51%2C99.858z%22%20%20%20%20%20%20%20%20id%3D%22Tracciato_4259%22%20%20%20%20%20%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _path$1E, _path2$L;
function _extends$24() { return _extends$24 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$24.apply(null, arguments); }
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends$24({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _path$1E || (_path$1E = /*#__PURE__*/React.createElement("path", {
  d: "M10 1.25A8.75 8.75 0 1 1 1.25 10 8.76 8.76 0 0 1 10 1.25M10 0a10 10 0 1 0 10 10A10 10 0 0 0 10 0",
  "data-name": "Path 9150"
})), _path2$L || (_path2$L = /*#__PURE__*/React.createElement("path", {
  d: "m14.817 6.067-.884-.884L10 9.116 6.067 5.183l-.884.884L9.116 10l-3.933 3.933.884.884L10 10.884l3.933 3.933.884-.884L10.884 10Z",
  "data-name": "Path 9151"
})));

var _g$y;
function _extends$23() { return _extends$23 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$23.apply(null, arguments); }
const SvgErrorPage = props => /*#__PURE__*/React.createElement("svg", _extends$23({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 335.711 292.598"
}, props), _g$y || (_g$y = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11495"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#01426a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M295 0H25A25.03 25.03 0 0 0 0 25v235h320V25a25.03 25.03 0 0 0-25-25M25 20h270a5.01 5.01 0 0 1 5.006 5v38.9H20V25a5.007 5.007 0 0 1 4.994-5Zm-5 220V73.9h280V240Z",
  "data-name": "Path 2641"
}), /*#__PURE__*/React.createElement("path", {
  d: "M269.808 39.891h10v10h-10z",
  "data-name": "Rectangle 3730"
}), /*#__PURE__*/React.createElement("path", {
  d: "M248.47 39.891h10v10h-10z",
  "data-name": "Rectangle 3731"
}), /*#__PURE__*/React.createElement("path", {
  d: "M227.132 39.891h10v10h-10z",
  "data-name": "Rectangle 3732"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#f1f4f6",
  d: "m210.733 228.069-33.877 52.332h-16.855l50.732-83.855Z",
  "data-name": "Path 10073"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f1f4f6",
  d: "m292.135 225.501 36.246 54.9v-37.069l-43.14-57.472Z",
  "data-name": "Path 10074"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f1f4f6",
  d: "M210.732 238.473h81.838l15.815 24.885H196.361Z",
  "data-name": "Path 10075"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#0af",
  "data-name": "Elevated Warning"
}, /*#__PURE__*/React.createElement("path", {
  d: "m252.546 177.813 64.525 104.395-129.056-.036Zm0-19.761L169.381 292.55l166.33.047Z",
  "data-name": "Path 9574"
}), /*#__PURE__*/React.createElement("path", {
  d: "M260.342 264.492a7.8 7.8 0 1 1-7.8-7.788 7.8 7.8 0 0 1 7.8 7.788",
  "data-name": "Path 9575"
}), /*#__PURE__*/React.createElement("path", {
  d: "M247.54 204.781h10.396v41.537H247.54z",
  "data-name": "Rectangle 13369"
})))));
var error_page = "data:image/svg+xml,%3Csvg%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%22335.711%22%20%20height%3D%22292.598%22%20%20viewBox%3D%220%200%20335.711%20292.598%22%3E%20%20%3Cg%20%20%20%20id%3D%22Group_11495%22%20%20%20%20data-name%3D%22Group%2011495%22%20%20%20%20transform%3D%22translate%28-877.472%20-435.667%29%22%20%20%3E%20%20%20%20%3Cg%20id%3D%22App%22%20transform%3D%22translate%28877.472%20435.667%29%22%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20id%3D%22Path_2641%22%20%20%20%20%20%20%20%20data-name%3D%22Path%202641%22%20%20%20%20%20%20%20%20d%3D%22M8869%2C954h-270A25.028%2C25.028%2C0%2C0%2C0%2C8574%2C979v235h320V979A25.028%2C25.028%2C0%2C0%2C0%2C8869%2C954Zm-270%2C20h270a5.01%2C5.01%2C0%2C0%2C1%2C5.006%2C5v38.9H8594V979A5.007%2C5.007%2C0%2C0%2C1%2C8598.994%2C974Zm-5%2C220V1027.9H8874V1194Z%22%20%20%20%20%20%20%20%20transform%3D%22translate%28-8574%20-954%29%22%20%20%20%20%20%20%20%20fill%3D%22%2301426a%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Crect%20%20%20%20%20%20%20%20id%3D%22Rectangle_3730%22%20%20%20%20%20%20%20%20data-name%3D%22Rectangle%203730%22%20%20%20%20%20%20%20%20width%3D%2210%22%20%20%20%20%20%20%20%20height%3D%2210%22%20%20%20%20%20%20%20%20transform%3D%22translate%28269.808%2039.891%29%22%20%20%20%20%20%20%20%20fill%3D%22%2301426a%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Crect%20%20%20%20%20%20%20%20id%3D%22Rectangle_3731%22%20%20%20%20%20%20%20%20data-name%3D%22Rectangle%203731%22%20%20%20%20%20%20%20%20width%3D%2210%22%20%20%20%20%20%20%20%20height%3D%2210%22%20%20%20%20%20%20%20%20transform%3D%22translate%28248.47%2039.891%29%22%20%20%20%20%20%20%20%20fill%3D%22%2301426a%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Crect%20%20%20%20%20%20%20%20id%3D%22Rectangle_3732%22%20%20%20%20%20%20%20%20data-name%3D%22Rectangle%203732%22%20%20%20%20%20%20%20%20width%3D%2210%22%20%20%20%20%20%20%20%20height%3D%2210%22%20%20%20%20%20%20%20%20transform%3D%22translate%28227.132%2039.891%29%22%20%20%20%20%20%20%20%20fill%3D%22%2301426a%22%20%20%20%20%20%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22Path_10073%22%20%20%20%20%20%20data-name%3D%22Path%2010073%22%20%20%20%20%20%20d%3D%22M795.595-107.525%2C761.718-55.193H744.863l50.732-83.855Z%22%20%20%20%20%20%20transform%3D%22translate%28292.61%20771.261%29%22%20%20%20%20%20%20fill%3D%22%23f1f4f6%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22Path_10074%22%20%20%20%20%20%20data-name%3D%22Path%2010074%22%20%20%20%20%20%20d%3D%22M815.969-106.312l36.246%2C54.9V-88.481l-43.14-57.472Z%22%20%20%20%20%20%20transform%3D%22translate%28353.638%20767.48%29%22%20%20%20%20%20%20fill%3D%22%23f1f4f6%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22Path_10075%22%20%20%20%20%20%20data-name%3D%22Path%2010075%22%20%20%20%20%20%20d%3D%22M778.747-117.085h81.838L876.4-92.2H764.376Z%22%20%20%20%20%20%20transform%3D%22translate%28309.457%20791.225%29%22%20%20%20%20%20%20fill%3D%22%23f1f4f6%22%20%20%20%20%2F%3E%20%20%20%20%3Cg%20%20%20%20%20%20id%3D%22Elevated_Warning%22%20%20%20%20%20%20data-name%3D%22Elevated%20Warning%22%20%20%20%20%20%20transform%3D%22translate%281046.853%20593.719%29%22%20%20%20%20%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20id%3D%22Path_9574%22%20%20%20%20%20%20%20%20data-name%3D%22Path%209574%22%20%20%20%20%20%20%20%20d%3D%22M85.165%2C23.825%2C149.69%2C128.22l-129.056-.036Zm0-19.761L2%2C138.562l166.33.047Z%22%20%20%20%20%20%20%20%20transform%3D%22translate%28-2%20-4.064%29%22%20%20%20%20%20%20%20%20fill%3D%22%230af%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20id%3D%22Path_9575%22%20%20%20%20%20%20%20%20data-name%3D%22Path%209575%22%20%20%20%20%20%20%20%20d%3D%22M32.093%2C30.852a7.8%2C7.8%2C0%2C1%2C1-7.8-7.788%2C7.8%2C7.8%2C0%2C0%2C1%2C7.8%2C7.788%22%20%20%20%20%20%20%20%20transform%3D%22translate%2858.868%2075.588%29%22%20%20%20%20%20%20%20%20fill%3D%22%230af%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Crect%20%20%20%20%20%20%20%20id%3D%22Rectangle_13369%22%20%20%20%20%20%20%20%20data-name%3D%22Rectangle%2013369%22%20%20%20%20%20%20%20%20width%3D%2210.396%22%20%20%20%20%20%20%20%20height%3D%2241.537%22%20%20%20%20%20%20%20%20transform%3D%22translate%2878.159%2046.729%29%22%20%20%20%20%20%20%20%20fill%3D%22%230af%22%20%20%20%20%20%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _g$x, _g2$1;
function _extends$22() { return _extends$22 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$22.apply(null, arguments); }
const SvgExchangeArrows = props => /*#__PURE__*/React.createElement("svg", _extends$22({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), _g$x || (_g$x = /*#__PURE__*/React.createElement("g", {
  "data-name": "Export - Upload"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m23.222 27.222-1.282-1.25 4.052-4.067h-16.1v-1.811h16.1l-4.052-4.068 1.282-1.248L29.444 21Z",
  "data-name": "Path 5103"
}))), _g2$1 || (_g2$1 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Export - Upload"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m7.778 2.778 1.282 1.25-4.052 4.067h16.1v1.811h-16.1l4.052 4.068-1.282 1.248L1.556 9Z",
  "data-name": "Path 5103"
}))));

var _g$w;
function _extends$21() { return _extends$21 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$21.apply(null, arguments); }
const SvgExclamationMarkCircleFill = props => /*#__PURE__*/React.createElement("svg", _extends$21({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _g$w || (_g$w = /*#__PURE__*/React.createElement("g", {
  "data-name": "exclamation-mark-circle-fill"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z",
  "data-name": "container"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18 34A16.02 16.02 0 0 1 2 18 16.02 16.02 0 0 1 18 2a16.02 16.02 0 0 1 16 16 16.02 16.02 0 0 1-16 16m0-10.933a2.4 2.4 0 0 0-2.4 2.4 2.4 2.4 0 0 0 2.4 2.4 2.4 2.4 0 0 0 2.4-2.4 2.4 2.4 0 0 0-2.4-2.399ZM16.173 6.534v14.4h3.734v-14.4Z",
  "data-name": "exclamation-mark"
}))));
var exclamationMarkCircleFill = "data:image/svg+xml,%3Csvg%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2236%22%20%20height%3D%2236%22%20%20viewBox%3D%220%200%2036%2036%22%3E%20%20%3Cg%20%20%20%20id%3D%22exclamation-mark-circle-fill%22%20%20%20%20data-name%3D%22exclamation-mark-circle-fill%22%20%20%20%20transform%3D%22translate%28-182%20-198.846%29%22%20%20%3E%20%20%20%20%3Crect%20%20%20%20%20%20id%3D%22container%22%20%20%20%20%20%20data-name%3D%22container%22%20%20%20%20%20%20width%3D%2236%22%20%20%20%20%20%20height%3D%2236%22%20%20%20%20%20%20transform%3D%22translate%28182%20198.846%29%22%20%20%20%20%20%20fill%3D%22none%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22exclamation-mark%22%20%20%20%20%20%20data-name%3D%22exclamation-mark%22%20%20%20%20%20%20d%3D%22M2832-86.154a16.018%2C16.018%2C0%2C0%2C1-16-16%2C16.018%2C16.018%2C0%2C0%2C1%2C16-16%2C16.018%2C16.018%2C0%2C0%2C1%2C16%2C16A16.018%2C16.018%2C0%2C0%2C1%2C2832-86.154Zm0-10.933a2.4%2C2.4%2C0%2C0%2C0-2.4%2C2.4%2C2.4%2C2.4%2C0%2C0%2C0%2C2.4%2C2.4%2C2.4%2C2.4%2C0%2C0%2C0%2C2.4-2.4A2.4%2C2.4%2C0%2C0%2C0%2C2832-97.086Zm-1.827-16.533v14.4h3.734v-14.4Z%22%20%20%20%20%20%20transform%3D%22translate%28-2632%20319%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _g$v;
function _extends$20() { return _extends$20 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$20.apply(null, arguments); }
const SvgExclamationmark = props => /*#__PURE__*/React.createElement("svg", _extends$20({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 12"
}, props), _g$v || (_g$v = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 17160"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 10392",
  transform: "translate(5.471 2.891)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.532,
  cy: 0.532,
  r: 0.532,
  "data-name": "Ellipse 3062",
  transform: "translate(0 5.697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.177 0h.709v4.032H.177z",
  "data-name": "Rectangle 12686"
})), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h12v12H0z",
  "data-name": "Rectangle 12687"
}))));
var exclamationmark = "data:image/svg+xml,%3Csvg%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2212%22%20%20height%3D%2212%22%20%20viewBox%3D%220%200%2012%2012%22%3E%20%20%3Cg%20%20%20%20id%3D%22Group_17160%22%20%20%20%20data-name%3D%22Group%2017160%22%20%20%20%20transform%3D%22translate%289314.02%2015465%29%22%20%20%3E%20%20%20%20%3Cg%20id%3D%22Warning%22%20transform%3D%22translate%28-9314.02%20-15465%29%22%3E%20%20%20%20%20%20%3Cg%20%20%20%20%20%20%20%20id%3D%22Group_10392%22%20%20%20%20%20%20%20%20data-name%3D%22Group%2010392%22%20%20%20%20%20%20%20%20transform%3D%22translate%285.471%202.891%29%22%20%20%20%20%20%20%3E%20%20%20%20%20%20%20%20%3Ccircle%20%20%20%20%20%20%20%20%20%20id%3D%22Ellipse_3062%22%20%20%20%20%20%20%20%20%20%20data-name%3D%22Ellipse%203062%22%20%20%20%20%20%20%20%20%20%20cx%3D%220.532%22%20%20%20%20%20%20%20%20%20%20cy%3D%220.532%22%20%20%20%20%20%20%20%20%20%20r%3D%220.532%22%20%20%20%20%20%20%20%20%20%20transform%3D%22translate%280%205.697%29%22%20%20%20%20%20%20%20%20%20%20stroke-width%3D%220.5%22%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%20%20%3Crect%20%20%20%20%20%20%20%20%20%20id%3D%22Rectangle_12686%22%20%20%20%20%20%20%20%20%20%20data-name%3D%22Rectangle%2012686%22%20%20%20%20%20%20%20%20%20%20width%3D%220.709%22%20%20%20%20%20%20%20%20%20%20height%3D%224.032%22%20%20%20%20%20%20%20%20%20%20transform%3D%22translate%280.177%29%22%20%20%20%20%20%20%20%20%20%20stroke-width%3D%220.5%22%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%3Crect%20%20%20%20%20%20%20%20id%3D%22Rectangle_12687%22%20%20%20%20%20%20%20%20data-name%3D%22Rectangle%2012687%22%20%20%20%20%20%20%20%20width%3D%2212%22%20%20%20%20%20%20%20%20height%3D%2212%22%20%20%20%20%20%20%20%20fill%3D%22none%22%20%20%20%20%20%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _rect$3, _g$u;
function _extends$1$() { return _extends$1$ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1$.apply(null, arguments); }
const SvgExitFullScreen = props => /*#__PURE__*/React.createElement("svg", _extends$1$({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Exit Full screen",
  viewBox: "0 0 52 52"
}, props), _rect$3 || (_rect$3 = /*#__PURE__*/React.createElement("rect", {
  width: 52,
  height: 52,
  fill: "currentColor",
  "data-name": "Rettangolo 13753",
  rx: 5
})), _g$u || (_g$u = /*#__PURE__*/React.createElement("g", {
  "data-name": "Leave Fullscreen"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M10.999 9h31v31h-31z",
  "data-name": "Rettangolo 1366"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.443 31.389h5.167v5.167h1.722v-6.889h-6.889Z",
  "data-name": "Tracciato 880"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.443 17.611h5.167v-5.167h1.722v6.889h-6.889Z",
  "data-name": "Tracciato 881"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M38.555 31.389h-5.167v5.167h-1.722v-6.889h6.889Z",
  "data-name": "Tracciato 882"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M38.555 17.611h-5.167v-5.167h-1.722v6.889h6.889Z",
  "data-name": "Tracciato 883"
}))));

var _g$t, _defs$g;
function _extends$1_() { return _extends$1_ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1_.apply(null, arguments); }
const SvgExpand = props => /*#__PURE__*/React.createElement("svg", _extends$1_({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g$t || (_g$t = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#expand_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 20H4v-8H2.667v9.333H12zM12 4.003h8v8h1.333V2.67H12zM4 9.334V4.958l4.755 4.74.941-.944L4.928 4h4.405V2.667H2.667v6.667zM20 14.666v4.376l-4.755-4.74-.942.944L19.073 20h-4.407v1.333h6.667v-6.667z"
}))), _defs$g || (_defs$g = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "expand_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h24v24H0z"
})))));
var expand = "data:image/svg+xml,%3Csvg%20%20width%3D%2224%22%20%20height%3D%2224%22%20%20viewBox%3D%220%200%2024%2024%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cg%20clip-path%3D%22url%28%23clip0_384_689%29%22%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M11.9998%2020H3.99984V12H2.6665V21.3333H11.9998V20Z%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M11.9997%204.00293L19.9997%204.00293V12.0029H21.333V2.6696L11.9997%202.6696V4.00293Z%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M3.99984%209.33366V4.95764L8.75505%209.69832L9.69645%208.75431L4.92757%204.00033H9.33317V2.66699H2.6665V9.33366H3.99984Z%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M19.9998%2014.6664V19.0424L15.2446%2014.3018L14.3032%2015.2458L19.0721%2019.9998H14.6665V21.3331H21.3332V14.6664H19.9998Z%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cdefs%3E%20%20%20%20%3CclipPath%20id%3D%22clip0_384_689%22%3E%20%20%20%20%20%20%3Crect%20width%3D%2224%22%20height%3D%2224%22%20fill%3D%22currentColor%22%20%2F%3E%20%20%20%20%3C%2FclipPath%3E%20%20%3C%2Fdefs%3E%3C%2Fsvg%3E";

var _path$1D;
function _extends$1Z() { return _extends$1Z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1Z.apply(null, arguments); }
const SvgExperimental = props => /*#__PURE__*/React.createElement("svg", _extends$1Z({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 14 22"
}, props), _path$1D || (_path$1D = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.02 1.528a1.004 1.004 0 0 0 1.174.786 1 1 0 0 0 .64-.426c.147-.227.2-.494.147-.754a1 1 0 1 0-1.96.394M6.935 1H7V.994c.154 0 .294.107.327.267.02.093 0 .18-.046.253a.36.36 0 0 1-.214.14.335.335 0 0 1-.393-.26c-.02-.093 0-.18.046-.253a.36.36 0 0 1 .214-.14m1.893 3.833h.007zm-.64-.193a1.19 1.19 0 0 0 .873.173 1.169 1.169 0 0 0 .42-2.113 1.16 1.16 0 0 0-.873-.173 1.169 1.169 0 0 0-.42 2.113m.547-1.467c.033-.006.1-.006.1-.006V3.16a.51.51 0 0 1 .486.407.5.5 0 1 1-.586-.394m-2.567 3.16a1.004 1.004 0 0 1-.193-1.986 1 1 0 0 1 1.173.786 1 1 0 0 1-.98 1.2m0-1.333H6.1a.36.36 0 0 0-.213.14.335.335 0 0 0 .347.513.36.36 0 0 0 .213-.14.33.33 0 0 0 .047-.253.334.334 0 0 0-.327-.267zm7.407 13.56-4.26-6.046v-4.16h1.013V7.02H3.66v1.334h1.014v4.16l-4.267 6.06a2 2 0 0 0-.1 2.053 2 2 0 0 0 1.767 1.06h9.847c.74 0 1.413-.407 1.766-1.06a1.99 1.99 0 0 0-.113-2.067m-7.56-5.626v-4.58h1.973v4.58L9.234 14.7c-1.254-.006-1.934.307-2.54.6l-.03.015c-.48.227-.87.411-1.517.385a6.6 6.6 0 0 1-1.007-.1l1.88-2.666zm.706 3.213a.31.31 0 0 1 .214-.14H7a.34.34 0 0 1 .327.267c.02.086 0 .173-.047.253a.338.338 0 0 1-.607-.12.34.34 0 0 1 .047-.253zm5.794 3.853a.65.65 0 0 1-.587.354H2.08A.65.65 0 0 1 1.494 20c-.054-.106-.167-.386.026-.673l2.207-3.14c.333.087.78.16 1.4.18h.113c.294 0 .54-.04.774-.1 0 .087 0 .173.013.26.093.473.513.807.98.807.067 0 .127 0 .193-.02.26-.054.487-.2.64-.427.147-.22.2-.487.147-.753a.94.94 0 0 0-.307-.534c.487-.173 1.094-.286 2.034-.22l2.766 3.934c.2.3.094.58.034.686m-3.183-.5a1.158 1.158 0 0 1-1.137-.933 1.17 1.17 0 0 1 .913-1.374 1.158 1.158 0 0 1 1.367.913 1.17 1.17 0 0 1-.914 1.374c-.078.013-.15.02-.23.02m0 0h.003-.007zm.003-1.667s-.067 0-.1.007a.5.5 0 1 0 .373.073.5.5 0 0 0-.273-.086z",
  clipRule: "evenodd"
})));

var _path$1C, _path2$K, _path3$f, _g$s, _rect$2, _g2, _rect2, _g3, _rect3, _rect4, _rect5, _path4$4, _path5$3;
function _extends$1Y() { return _extends$1Y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1Y.apply(null, arguments); }
const SvgExportPointCloud = props => /*#__PURE__*/React.createElement("svg", _extends$1Y({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Export Point Cloud",
  viewBox: "0 0 18 18"
}, props), _path$1C || (_path$1C = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h18v18H0z",
  "data-name": "Rettangolo 10182",
  opacity: 0.1
})), _path2$K || (_path2$K = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.488 11.894V16h1v-4.106l.829.829.707-.707-2.036-2.036-2.04 2.04.707.707Z",
  "data-name": "Tracciato 6910"
})), _path3$f || (_path3$f = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.988 13.192V17h-6v-3.808h-1V18h8v-4.808Z",
  "data-name": "Tracciato 6911"
})), _g$s || (_g$s = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  "data-name": "Raggruppa 8021",
  transform: "translate(1 8.25)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  "data-name": "Rettangolo 10183",
  rx: 0.75,
  transform: "rotate(-180 .75 2.063)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  "data-name": "Rettangolo 10184",
  rx: 0.75,
  transform: "rotate(-180 .75 .75)"
}))), _rect$2 || (_rect$2 = /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  fill: "currentColor",
  "data-name": "Rettangolo 10185",
  rx: 0.75,
  transform: "rotate(180 8.5 4.875)"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  "data-name": "Raggruppa 8022",
  transform: "translate(3.9 5.625)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  "data-name": "Rettangolo 10186",
  rx: 0.75,
  transform: "rotate(180 .75 3.375)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  "data-name": "Rettangolo 10187",
  rx: 0.75,
  transform: "rotate(180 .75 2.063)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  "data-name": "Rettangolo 10188",
  rx: 0.75,
  transform: "rotate(180 .75 .75)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  "data-name": "Rettangolo 10189",
  rx: 0.75,
  transform: "rotate(180 .75 4.688)"
}))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  fill: "currentColor",
  "data-name": "Rettangolo 10190",
  rx: 0.75,
  transform: "rotate(180 7.05 3.563)"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  "data-name": "Raggruppa 8023",
  transform: "translate(6.8 3)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  "data-name": "Rettangolo 10191",
  rx: 0.75,
  transform: "rotate(180 .75 4.688)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  "data-name": "Rettangolo 10192",
  rx: 0.75,
  transform: "rotate(-180 .75 3.375)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  "data-name": "Rettangolo 10193",
  rx: 0.75,
  transform: "rotate(180 .75 2.063)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  "data-name": "Rettangolo 10194",
  rx: 0.75,
  transform: "rotate(180 .75 6)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  "data-name": "Rettangolo 10195",
  rx: 0.75,
  transform: "rotate(180 .75 .75)"
}))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  fill: "currentColor",
  "data-name": "Rettangolo 10196",
  rx: 0.75,
  transform: "rotate(180 5.6 4.875)"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  fill: "currentColor",
  "data-name": "Rettangolo 10197",
  rx: 0.75,
  transform: "rotate(-180 5.6 3.562)"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 1.5,
  fill: "currentColor",
  "data-name": "Rettangolo 10198",
  rx: 0.75,
  transform: "rotate(180 5.6 2.25)"
})), _path4$4 || (_path4$4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m12.938 9.625.355-.355.683-.683a.749.749 0 1 0-1.038 1.038",
  "data-name": "Tracciato 6912"
})), _path5$3 || (_path5$3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.962 12.19h.412l.687-.687.1-.1a.748.748 0 1 0-1.2.788Z",
  "data-name": "Tracciato 6913"
})));
var exportPointCloud = "data:image/svg+xml,%3Csvg%20%20id%3D%22Export_Point_Cloud%22%20%20data-name%3D%22Export%20Point%20Cloud%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2218%22%20%20height%3D%2218%22%20%20viewBox%3D%220%200%2018%2018%22%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_10182%22%20%20%20%20data-name%3D%22Rettangolo%2010182%22%20%20%20%20width%3D%2218%22%20%20%20%20height%3D%2218%22%20%20%20%20fill%3D%22none%22%20%20%20%20opacity%3D%220.1%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20id%3D%22Tracciato_6910%22%20%20%20%20data-name%3D%22Tracciato%206910%22%20%20%20%20d%3D%22M3849.44%2C1821.874v4.106h1v-4.106l.829.829.707-.707-2.036-2.036L3847.9%2C1822l.707.707Z%22%20%20%20%20transform%3D%22translate%28-3835.952%20-1809.98%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20id%3D%22Tracciato_6911%22%20%20%20%20data-name%3D%22Tracciato%206911%22%20%20%20%20d%3D%22M3850.976%2C1826.384v3.808h-6v-3.808h-1v4.808h8v-4.808Z%22%20%20%20%20transform%3D%22translate%28-3833.988%20-1813.192%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cg%20%20%20%20id%3D%22Raggruppa_8021%22%20%20%20%20data-name%3D%22Raggruppa%208021%22%20%20%20%20transform%3D%22translate%281%208.25%29%22%20%20%3E%20%20%20%20%3Crect%20%20%20%20%20%20id%3D%22Rettangolo_10183%22%20%20%20%20%20%20data-name%3D%22Rettangolo%2010183%22%20%20%20%20%20%20width%3D%221.5%22%20%20%20%20%20%20height%3D%221.5%22%20%20%20%20%20%20rx%3D%220.75%22%20%20%20%20%20%20transform%3D%22translate%281.5%204.125%29%20rotate%28-180%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%20%20%3Crect%20%20%20%20%20%20id%3D%22Rettangolo_10184%22%20%20%20%20%20%20data-name%3D%22Rettangolo%2010184%22%20%20%20%20%20%20width%3D%221.5%22%20%20%20%20%20%20height%3D%221.5%22%20%20%20%20%20%20rx%3D%220.75%22%20%20%20%20%20%20transform%3D%22translate%281.5%201.5%29%20rotate%28-180%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_10185%22%20%20%20%20data-name%3D%22Rettangolo%2010185%22%20%20%20%20width%3D%221.5%22%20%20%20%20height%3D%221.5%22%20%20%20%20rx%3D%220.75%22%20%20%20%20transform%3D%22translate%2817%209.75%29%20rotate%28180%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cg%20%20%20%20id%3D%22Raggruppa_8022%22%20%20%20%20data-name%3D%22Raggruppa%208022%22%20%20%20%20transform%3D%22translate%283.9%205.625%29%22%20%20%3E%20%20%20%20%3Crect%20%20%20%20%20%20id%3D%22Rettangolo_10186%22%20%20%20%20%20%20data-name%3D%22Rettangolo%2010186%22%20%20%20%20%20%20width%3D%221.5%22%20%20%20%20%20%20height%3D%221.5%22%20%20%20%20%20%20rx%3D%220.75%22%20%20%20%20%20%20transform%3D%22translate%281.5%206.75%29%20rotate%28180%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%20%20%3Crect%20%20%20%20%20%20id%3D%22Rettangolo_10187%22%20%20%20%20%20%20data-name%3D%22Rettangolo%2010187%22%20%20%20%20%20%20width%3D%221.5%22%20%20%20%20%20%20height%3D%221.5%22%20%20%20%20%20%20rx%3D%220.75%22%20%20%20%20%20%20transform%3D%22translate%281.5%204.125%29%20rotate%28180%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%20%20%3Crect%20%20%20%20%20%20id%3D%22Rettangolo_10188%22%20%20%20%20%20%20data-name%3D%22Rettangolo%2010188%22%20%20%20%20%20%20width%3D%221.5%22%20%20%20%20%20%20height%3D%221.5%22%20%20%20%20%20%20rx%3D%220.75%22%20%20%20%20%20%20transform%3D%22translate%281.5%201.5%29%20rotate%28180%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%20%20%3Crect%20%20%20%20%20%20id%3D%22Rettangolo_10189%22%20%20%20%20%20%20data-name%3D%22Rettangolo%2010189%22%20%20%20%20%20%20width%3D%221.5%22%20%20%20%20%20%20height%3D%221.5%22%20%20%20%20%20%20rx%3D%220.75%22%20%20%20%20%20%20transform%3D%22translate%281.5%209.375%29%20rotate%28180%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_10190%22%20%20%20%20data-name%3D%22Rettangolo%2010190%22%20%20%20%20width%3D%221.5%22%20%20%20%20height%3D%221.5%22%20%20%20%20rx%3D%220.75%22%20%20%20%20transform%3D%22translate%2814.1%207.125%29%20rotate%28180%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cg%20%20%20%20id%3D%22Raggruppa_8023%22%20%20%20%20data-name%3D%22Raggruppa%208023%22%20%20%20%20transform%3D%22translate%286.8%203%29%22%20%20%3E%20%20%20%20%3Crect%20%20%20%20%20%20id%3D%22Rettangolo_10191%22%20%20%20%20%20%20data-name%3D%22Rettangolo%2010191%22%20%20%20%20%20%20width%3D%221.5%22%20%20%20%20%20%20height%3D%221.5%22%20%20%20%20%20%20rx%3D%220.75%22%20%20%20%20%20%20transform%3D%22translate%281.5%209.375%29%20rotate%28180%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%20%20%3Crect%20%20%20%20%20%20id%3D%22Rettangolo_10192%22%20%20%20%20%20%20data-name%3D%22Rettangolo%2010192%22%20%20%20%20%20%20width%3D%221.5%22%20%20%20%20%20%20height%3D%221.5%22%20%20%20%20%20%20rx%3D%220.75%22%20%20%20%20%20%20transform%3D%22translate%281.5%206.75%29%20rotate%28-180%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%20%20%3Crect%20%20%20%20%20%20id%3D%22Rettangolo_10193%22%20%20%20%20%20%20data-name%3D%22Rettangolo%2010193%22%20%20%20%20%20%20width%3D%221.5%22%20%20%20%20%20%20height%3D%221.5%22%20%20%20%20%20%20rx%3D%220.75%22%20%20%20%20%20%20transform%3D%22translate%281.5%204.125%29%20rotate%28180%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%20%20%3Crect%20%20%20%20%20%20id%3D%22Rettangolo_10194%22%20%20%20%20%20%20data-name%3D%22Rettangolo%2010194%22%20%20%20%20%20%20width%3D%221.5%22%20%20%20%20%20%20height%3D%221.5%22%20%20%20%20%20%20rx%3D%220.75%22%20%20%20%20%20%20transform%3D%22translate%281.5%2012%29%20rotate%28180%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%20%20%3Crect%20%20%20%20%20%20id%3D%22Rettangolo_10195%22%20%20%20%20%20%20data-name%3D%22Rettangolo%2010195%22%20%20%20%20%20%20width%3D%221.5%22%20%20%20%20%20%20height%3D%221.5%22%20%20%20%20%20%20rx%3D%220.75%22%20%20%20%20%20%20transform%3D%22translate%281.5%201.5%29%20rotate%28180%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_10196%22%20%20%20%20data-name%3D%22Rettangolo%2010196%22%20%20%20%20width%3D%221.5%22%20%20%20%20height%3D%221.5%22%20%20%20%20rx%3D%220.75%22%20%20%20%20transform%3D%22translate%2811.2%209.75%29%20rotate%28180%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_10197%22%20%20%20%20data-name%3D%22Rettangolo%2010197%22%20%20%20%20width%3D%221.5%22%20%20%20%20height%3D%221.5%22%20%20%20%20rx%3D%220.75%22%20%20%20%20transform%3D%22translate%2811.2%207.125%29%20rotate%28-180%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_10198%22%20%20%20%20data-name%3D%22Rettangolo%2010198%22%20%20%20%20width%3D%221.5%22%20%20%20%20height%3D%221.5%22%20%20%20%20rx%3D%220.75%22%20%20%20%20transform%3D%22translate%2811.2%204.5%29%20rotate%28180%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20id%3D%22Tracciato_6912%22%20%20%20%20data-name%3D%22Tracciato%206912%22%20%20%20%20d%3D%22M3849.538%2C1817.875l.355-.355.683-.683a.749.749%2C0%2C1%2C0-1.038%2C1.038Z%22%20%20%20%20transform%3D%22translate%28-3836.6%20-1808.25%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20id%3D%22Tracciato_6913%22%20%20%20%20data-name%3D%22Tracciato%206913%22%20%20%20%20d%3D%22M3843.662%2C1823.065h.412l.687-.687.1-.1a.748.748%2C0%2C1%2C0-1.2.788Z%22%20%20%20%20transform%3D%22translate%28-3833.7%20-1810.875%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _g$r;
function _extends$1X() { return _extends$1X = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1X.apply(null, arguments); }
const SvgExport = props => /*#__PURE__*/React.createElement("svg", _extends$1X({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), _g$r || (_g$r = /*#__PURE__*/React.createElement("g", {
  "data-name": "Export - Upload"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.446 28.444H3.556V13.333h1.778v13.333h21.333V13.333h1.778Z",
  "data-name": "Path 5102"
}), /*#__PURE__*/React.createElement("path", {
  d: "m22.222 9.778-1.25 1.282-4.067-4.052v16.1h-1.811v-16.1l-4.068 4.052-1.248-1.282L16 3.556Z",
  "data-name": "Path 5103"
}))));

var _path$1B, _path2$J;
function _extends$1W() { return _extends$1W = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1W.apply(null, arguments); }
const SvgExtractCrossSection = props => /*#__PURE__*/React.createElement("svg", _extends$1W({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$1B || (_path$1B = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M31.3 22.3H36l-8.1-10h-2.7l1.2 2h.5l4.9 6H4.2l4.9-6h.5l1.2-2H8.1L0 22.3zM30.5 24.3h-1.2l3 4.8H18.7l3-4.8h-1.2l-2.4 3.9-2.4-3.9h-1.2l3 4.8H3.9l3-4.8H5.7l-3.6 5.8h32z"
})), _path2$J || (_path2$J = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m26.7 18.2-8.6-14-8.6 14zM18.1 6.1l6.8 11.1H11.3z"
})));

var _defs$f, _g$q;
function _extends$1V() { return _extends$1V = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1V.apply(null, arguments); }
const SvgFaroLogoCompact = props => /*#__PURE__*/React.createElement("svg", _extends$1V({
  xmlns: "http://www.w3.org/2000/svg",
  id: "faro-logo-compact_svg__Individual_Logos_Icons",
  width: "1em",
  height: "1em",
  "data-name": "Individual Logos & Icons",
  viewBox: "0 0 250 250"
}, props), _defs$f || (_defs$f = /*#__PURE__*/React.createElement("defs", {
  id: "faro-logo-compact_svg__defs50"
}, /*#__PURE__*/React.createElement("radialGradient", {
  id: "faro-logo-compact_svg__New_Gradient_Swatch_7",
  cx: 167.73,
  cy: 87.4,
  r: 129.06,
  gradientTransform: "translate(.2)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo-compact_svg__stop21",
  offset: 0,
  stopColor: "#009cde"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo-compact_svg__stop23",
  offset: 0.09,
  stopColor: "#0694de"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo-compact_svg__stop25",
  offset: 0.23,
  stopColor: "#167edd"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo-compact_svg__stop27",
  offset: 0.41,
  stopColor: "#305bdb"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo-compact_svg__stop29",
  offset: 0.43,
  stopColor: "#3455db"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo-compact_svg__stop31",
  offset: 0.46,
  stopColor: "#2f53cf"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo-compact_svg__stop33",
  offset: 0.58,
  stopColor: "#1b4ca4"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo-compact_svg__stop35",
  offset: 0.69,
  stopColor: "#0d4684"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo-compact_svg__stop37",
  offset: 0.77,
  stopColor: "#044371"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo-compact_svg__stop39",
  offset: 0.84,
  stopColor: "#01426a"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo-compact_svg__stop41",
  offset: 0.86,
  stopColor: "#064475"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo-compact_svg__stop43",
  offset: 0.91,
  stopColor: "#134993"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo-compact_svg__stop45",
  offset: 0.97,
  stopColor: "#2951c2"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo-compact_svg__stop47",
  offset: 1,
  stopColor: "#3455db"
})), /*#__PURE__*/React.createElement("style", {
  id: "style2"
}, ".faro-logo-compact_svg__faro-logo-compact-4{fill:#fff}"))), _g$q || (_g$q = /*#__PURE__*/React.createElement("g", {
  id: "faro-logo-compact_svg__g1",
  transform: "translate(-150 -60)scale(1.45)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "faro-logo-compact_svg__circle74",
  cx: 187.87,
  cy: 125.6,
  r: 83.41,
  fill: "url(#faro-logo-compact_svg__New_Gradient_Swatch_7)"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo-compact_svg__path76",
  d: "M258.64 127.38c0-6.86-4.84-11.06-11.1-11.06-6.5 0-11.38 4.59-11.38 11 0 5.69 3.88 10 10 10.82h.51l.6.05h1.06c3.85 0 6.82-1.19 8.8-3.45l-1.57-1.7-1.72-1.87a7.2 7.2 0 0 1-5.35 2.06 8 8 0 0 1-1-.06c-.21 0-.41-.06-.6-.09l-.44-.1a5 5 0 0 1-.53-.16l-.42-.15-.46-.22c-.13-.07-.26-.14-.38-.22a4 4 0 0 1-.39-.26l-.35-.3c-.11-.1-.22-.2-.31-.3a8 8 0 0 1-.55-.71 4 4 0 0 1-.27-.52 3 3 0 0 1-.15-.28 6.4 6.4 0 0 1-.28-.88h16.13c.07-.46.15-1.13.15-1.6m-16.36-1.95a5.34 5.34 0 0 1 10.53 0z",
  className: "faro-logo-compact_svg__faro-logo-compact-4"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo-compact_svg__path78",
  d: "M247.67 138.26",
  className: "faro-logo-compact_svg__faro-logo-compact-4"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo-compact_svg__path80",
  d: "M206.51 116.32c-6.5 0-11.38 4.59-11.38 11 0 5.69 3.88 10 10 10.82h.51l.6.05h1.06c3.85 0 6.82-1.19 8.8-3.45l-3.29-3.57a7.2 7.2 0 0 1-5.35 2.06 8 8 0 0 1-1-.06c-.21 0-.41-.06-.6-.09l-.44-.1a5 5 0 0 1-.53-.16 4 4 0 0 1-.42-.15l-.46-.22c-.13-.07-.26-.14-.38-.22a4 4 0 0 1-.39-.26l-.35-.3c-.11-.1-.22-.2-.31-.3a8 8 0 0 1-.55-.71 4 4 0 0 1-.27-.52 3 3 0 0 1-.15-.28 6.4 6.4 0 0 1-.28-.88h16.13c0-.52.12-1.19.12-1.66.03-6.8-4.81-11-11.07-11m-5.26 9.11a5.34 5.34 0 0 1 10.53 0z",
  className: "faro-logo-compact_svg__faro-logo-compact-4"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo-compact_svg__path82",
  d: "M126.47 120.6c-1.48-.54-2.46-1.28-2.46-2.54 0-1.74 1.47-3.17 5.27-3.17a14.3 14.3 0 0 1 4.38.72 17.8 17.8 0 0 1 3.31 1.46l2-4.88a18.7 18.7 0 0 0-9.64-2.45h-.66a18 18 0 0 0-1.88.14c-6.17.76-9.15 4.31-9.15 8.49 0 7.42 8.37 7.65 13.05 9.13l.21.07a7 7 0 0 1 1.79.84l.16.12a2.17 2.17 0 0 1 .92 1.77c0 1.7-1.54 3-5.35 3a16.3 16.3 0 0 1-4.44-.65 15.4 15.4 0 0 1-4.72-2.24l-2.18 4.84c2.46 1.9 6.9 3.21 11.3 3.21h.87c.42 0 .83 0 1.23-.08 6.51-.64 9.68-4.3 9.68-8.51-.01-7.71-9.16-7.6-13.69-9.27",
  className: "faro-logo-compact_svg__faro-logo-compact-4"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo-compact_svg__path84",
  d: "M155.92 116.32a8.31 8.31 0 0 0-6.7 2.77v-2.46h-5.9v29h6.18v-10a8.27 8.27 0 0 0 6.42 2.58 10.35 10.35 0 0 0 10.63-11c0-6.61-4.64-10.89-10.63-10.89m-1.07 16.88c-3.09 0-5.43-2.22-5.43-5.9v-.5a5.43 5.43 0 0 1 3.15-5 8.7 8.7 0 0 1 1.84-.44h.42c3.1 0 5.43 2.22 5.43 5.91s-2.26 5.93-5.41 5.93",
  className: "faro-logo-compact_svg__faro-logo-compact-4"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo-compact_svg__path86",
  d: "M182.84 116.32a9.4 9.4 0 0 0-6.78 2.53v-10.3h-6.18V138h6.18v-10.58c0-2.87 1.15-4.61 2.92-5.34a10 10 0 0 1 2.26-.41c2.69 0 4.26 1.61 4.26 5V138h6.18v-12.25c0-6.5-3.8-9.43-8.84-9.43",
  className: "faro-logo-compact_svg__faro-logo-compact-4"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo-compact_svg__path88",
  d: "M226.85 119.45v-2.82h-5.91V138h6.19v-10.88c.27-3.55 2.45-5.17 5.63-5.17.48 0 .88 0 1.39.07v-5.7c-3.26 0-5.8 1.07-7.3 3.13",
  className: "faro-logo-compact_svg__faro-logo-compact-4"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo-compact_svg__path90",
  d: "M206.64 138.26",
  className: "faro-logo-compact_svg__faro-logo-compact-4"
}))));

var _defs$e, _g$p;
function _extends$1U() { return _extends$1U = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1U.apply(null, arguments); }
const SvgFaroLogo = props => /*#__PURE__*/React.createElement("svg", _extends$1U({
  xmlns: "http://www.w3.org/2000/svg",
  id: "faro-logo_svg__Individual_Logos_Icons",
  width: "1em",
  height: "1em",
  "data-name": "Individual Logos & Icons",
  viewBox: "0 0 400 250"
}, props), _defs$e || (_defs$e = /*#__PURE__*/React.createElement("defs", {
  id: "faro-logo_svg__defs50"
}, /*#__PURE__*/React.createElement("radialGradient", {
  id: "faro-logo_svg__New_Gradient_Swatch_7",
  cx: 367.73,
  cy: 87.4,
  r: 129.06,
  gradientTransform: "translate(.2)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop21",
  offset: 0,
  stopColor: "#009cde"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop23",
  offset: 0.09,
  stopColor: "#0694de"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop25",
  offset: 0.23,
  stopColor: "#167edd"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop27",
  offset: 0.41,
  stopColor: "#305bdb"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop29",
  offset: 0.43,
  stopColor: "#3455db"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop31",
  offset: 0.46,
  stopColor: "#2f53cf"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop33",
  offset: 0.58,
  stopColor: "#1b4ca4"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop35",
  offset: 0.69,
  stopColor: "#0d4684"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop37",
  offset: 0.77,
  stopColor: "#044371"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop39",
  offset: 0.84,
  stopColor: "#01426a"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop41",
  offset: 0.86,
  stopColor: "#064475"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop43",
  offset: 0.91,
  stopColor: "#134993"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop45",
  offset: 0.97,
  stopColor: "#2951c2"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop47",
  offset: 1,
  stopColor: "#3455db"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "faro-logo_svg__New_Gradient_Swatch_8",
  x1: 345.52,
  x2: 431.03,
  y1: 7.98,
  y2: 242.92,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop4",
  offset: 0,
  stopColor: "#009cde"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop6",
  offset: 0.38,
  stopColor: "#3455db"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop8",
  offset: 0.52,
  stopColor: "#3354d8"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop10",
  offset: 0.64,
  stopColor: "#2e53ce"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop12",
  offset: 0.74,
  stopColor: "#2650bd"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop14",
  offset: 0.84,
  stopColor: "#1c4ca5"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop16",
  offset: 0.93,
  stopColor: "#0e4787"
}), /*#__PURE__*/React.createElement("stop", {
  id: "faro-logo_svg__stop18",
  offset: 1,
  stopColor: "#01426a"
})), /*#__PURE__*/React.createElement("style", {
  id: "style2"
}, ".faro-logo_svg__faro-logo-2{fill:#01426a}.faro-logo_svg__faro-logo-4{fill:#fff}"))), _g$p || (_g$p = /*#__PURE__*/React.createElement("g", {
  id: "faro-logo_svg__g117",
  transform: "translate(24.166 39.088)scale(.68402)"
}, /*#__PURE__*/React.createElement("path", {
  id: "faro-logo_svg__path52",
  fill: "url(#faro-logo_svg__New_Gradient_Swatch_8)",
  d: "M387.88.6a125.11 125.11 0 0 0-110.22 66.07h8.91a117.22 117.22 0 1 1-1.7 114.83h-8.77A125 125 0 1 0 387.88.6"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo_svg__polygon54",
  d: "M63.02 135.98V113.9H27.71v-5.51l35.32-.01-.01-22.07H1.22v75.05h26.49v-25.38z",
  className: "faro-logo_svg__faro-logo-2"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo_svg__polygon56",
  d: "M109.38 161.36h27.59l-11.2-33.12h-23.75z",
  className: "faro-logo_svg__faro-logo-2"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo_svg__polygon58",
  d: "m86.2 161.36 8.1-33.11-23.38-.01-11.21 33.12z",
  className: "faro-logo_svg__faro-logo-2"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo_svg__polygon60",
  d: "M73.15 121.62h22.76l2.43-9.92 2.21 9.92h22.98l-11.95-35.31H85.1z",
  className: "faro-logo_svg__faro-logo-2"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo_svg__polygon62",
  d: "M169.08 161.36v-33.11h-26.59v33.1l14.43.01z",
  className: "faro-logo_svg__faro-logo-2"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo_svg__polygon64",
  d: "m184.68 161.29 31.86.07-20.41-33.11h-27.05z",
  className: "faro-logo_svg__faro-logo-2"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo_svg__path66",
  d: "M169.08 121.62v-13.23c8.83 0 14.34-.18 14.34 7.22 0 3.93-2.09 5.45-4.91 6h26.42a17.7 17.7 0 0 0 1.75-8.23c0-13.72-7.88-27.09-29.36-27.09h-34.83v35.31h26.59z",
  className: "faro-logo_svg__faro-logo-2"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo_svg__path68",
  d: "M248.52 85A38.59 38.59 0 0 0 210 121.62h24.12a14.82 14.82 0 1 1 .28 6.62h-24.18A38.57 38.57 0 1 0 248.52 85",
  className: "faro-logo_svg__faro-logo-2"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo_svg__path70",
  d: "M282.46 151.71a4.82 4.82 0 1 0 4.78 4.82 4.81 4.81 0 0 0-4.78-4.82m0 8.68a3.86 3.86 0 1 1 3.79-3.86 3.82 3.82 0 0 1-3.8 3.86z",
  className: "faro-logo_svg__faro-logo-2"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo_svg__path72",
  d: "M283.63 156.68a1.28 1.28 0 0 0 1-1.34c0-1.5-1.6-1.5-1.94-1.5h-2.3v5.51h.94v-2.21h1.11c.94.08 1.12.32 1.16 1.19 0 .69.06.86.16 1h.94c-.13-.22-.13-.34-.18-1.27 0-.71-.14-1.16-.89-1.38m-1.15-.44h-1.13v-1.53h1.25c.47 0 1 .07 1.1.65 0 .88-.84.88-1.22.88",
  className: "faro-logo_svg__faro-logo-2"
}), /*#__PURE__*/React.createElement("circle", {
  id: "faro-logo_svg__circle74",
  cx: 387.87,
  cy: 125.6,
  r: 83.41,
  fill: "url(#faro-logo_svg__New_Gradient_Swatch_7)"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo_svg__path76",
  d: "M458.64 127.38c0-6.86-4.84-11.06-11.1-11.06-6.5 0-11.38 4.59-11.38 11 0 5.69 3.88 10 10 10.82h.51l.6.05h1.06c3.85 0 6.82-1.19 8.8-3.45l-1.57-1.7-1.72-1.87a7.2 7.2 0 0 1-5.35 2.06 8 8 0 0 1-1-.06c-.21 0-.41-.06-.6-.09l-.44-.1a5 5 0 0 1-.53-.16l-.42-.15-.46-.22c-.13-.07-.26-.14-.38-.22a4 4 0 0 1-.39-.26l-.35-.3c-.11-.1-.22-.2-.31-.3a8 8 0 0 1-.55-.71 4 4 0 0 1-.27-.52 3 3 0 0 1-.15-.28 6.4 6.4 0 0 1-.28-.88h16.13c.07-.46.15-1.13.15-1.6m-16.36-1.95a5.34 5.34 0 0 1 10.53 0z",
  className: "faro-logo_svg__faro-logo-4"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo_svg__path78",
  d: "M447.67 138.26",
  className: "faro-logo_svg__faro-logo-4"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo_svg__path80",
  d: "M406.51 116.32c-6.5 0-11.38 4.59-11.38 11 0 5.69 3.88 10 10 10.82h.51l.6.05h1.06c3.85 0 6.82-1.19 8.8-3.45l-3.29-3.57a7.2 7.2 0 0 1-5.35 2.06 8 8 0 0 1-1-.06c-.21 0-.41-.06-.6-.09l-.44-.1a5 5 0 0 1-.53-.16 4 4 0 0 1-.42-.15l-.46-.22c-.13-.07-.26-.14-.38-.22a4 4 0 0 1-.39-.26l-.35-.3c-.11-.1-.22-.2-.31-.3a8 8 0 0 1-.55-.71 4 4 0 0 1-.27-.52 3 3 0 0 1-.15-.28 6.4 6.4 0 0 1-.28-.88h16.13c0-.52.12-1.19.12-1.66.03-6.8-4.81-11-11.07-11m-5.26 9.11a5.34 5.34 0 0 1 10.53 0z",
  className: "faro-logo_svg__faro-logo-4"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo_svg__path82",
  d: "M326.47 120.6c-1.48-.54-2.46-1.28-2.46-2.54 0-1.74 1.47-3.17 5.27-3.17a14.3 14.3 0 0 1 4.38.72 17.8 17.8 0 0 1 3.31 1.46l2-4.88a18.7 18.7 0 0 0-9.64-2.45h-.66a18 18 0 0 0-1.88.14c-6.17.76-9.15 4.31-9.15 8.49 0 7.42 8.37 7.65 13.05 9.13l.21.07a7 7 0 0 1 1.79.84l.16.12a2.17 2.17 0 0 1 .92 1.77c0 1.7-1.54 3-5.35 3a16.3 16.3 0 0 1-4.44-.65 15.4 15.4 0 0 1-4.72-2.24l-2.18 4.84c2.46 1.9 6.9 3.21 11.3 3.21h.87c.42 0 .83 0 1.23-.08 6.51-.64 9.68-4.3 9.68-8.51-.01-7.71-9.16-7.6-13.69-9.27",
  className: "faro-logo_svg__faro-logo-4"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo_svg__path84",
  d: "M355.92 116.32a8.31 8.31 0 0 0-6.7 2.77v-2.46h-5.9v29h6.18v-10a8.27 8.27 0 0 0 6.42 2.58 10.35 10.35 0 0 0 10.63-11c0-6.61-4.64-10.89-10.63-10.89m-1.07 16.88c-3.09 0-5.43-2.22-5.43-5.9v-.5a5.43 5.43 0 0 1 3.15-5 8.7 8.7 0 0 1 1.84-.44h.42c3.1 0 5.43 2.22 5.43 5.91s-2.26 5.93-5.41 5.93",
  className: "faro-logo_svg__faro-logo-4"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo_svg__path86",
  d: "M382.84 116.32a9.4 9.4 0 0 0-6.78 2.53v-10.3h-6.18V138h6.18v-10.58c0-2.87 1.15-4.61 2.92-5.34a10 10 0 0 1 2.26-.41c2.69 0 4.26 1.61 4.26 5V138h6.18v-12.25c0-6.5-3.8-9.43-8.84-9.43",
  className: "faro-logo_svg__faro-logo-4"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo_svg__path88",
  d: "M426.85 119.45v-2.82h-5.91V138h6.19v-10.88c.27-3.55 2.45-5.17 5.63-5.17.48 0 .88 0 1.39.07v-5.7c-3.26 0-5.8 1.07-7.3 3.13",
  className: "faro-logo_svg__faro-logo-4"
}), /*#__PURE__*/React.createElement("path", {
  id: "faro-logo_svg__path90",
  d: "M406.64 138.26",
  className: "faro-logo_svg__faro-logo-4"
}))));
var faroLogo = "data:image/svg+xml,%3Csvg%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20height%3D%22250%22%20%20width%3D%22400%22%20%20version%3D%221.1%22%20%20viewBox%3D%220%200%20400.00002%20250%22%20%20data-name%3D%22Individual%20Logos%20%26amp%3B%20Icons%22%20%20id%3D%22Individual_Logos_Icons%22%3E%20%20%3Cdefs%20id%3D%22defs50%22%3E%20%20%20%20%3CradialGradient%20%20%20%20%20%20gradientUnits%3D%22userSpaceOnUse%22%20%20%20%20%20%20gradientTransform%3D%22translate%28.2%29%22%20%20%20%20%20%20r%3D%22129.06%22%20%20%20%20%20%20cy%3D%2287.400002%22%20%20%20%20%20%20cx%3D%22367.73001%22%20%20%20%20%20%20id%3D%22New_Gradient_Swatch_7%22%20%20%20%20%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop21%22%20stop-color%3D%22%23009cde%22%20offset%3D%220%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop23%22%20stop-color%3D%22%230694de%22%20offset%3D%22.09%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop25%22%20stop-color%3D%22%23167edd%22%20offset%3D%22.23%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop27%22%20stop-color%3D%22%23305bdb%22%20offset%3D%22.41%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop29%22%20stop-color%3D%22%233455db%22%20offset%3D%22.43%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop31%22%20stop-color%3D%22%232f53cf%22%20offset%3D%22.46%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop33%22%20stop-color%3D%22%231b4ca4%22%20offset%3D%22.58%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop35%22%20stop-color%3D%22%230d4684%22%20offset%3D%22.69%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop37%22%20stop-color%3D%22%23044371%22%20offset%3D%22.77%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop39%22%20stop-color%3D%22%2301426a%22%20offset%3D%22.84%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop41%22%20stop-color%3D%22%23064475%22%20offset%3D%22.86%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop43%22%20stop-color%3D%22%23134993%22%20offset%3D%22.91%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop45%22%20stop-color%3D%22%232951c2%22%20offset%3D%22.97%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop47%22%20stop-color%3D%22%233455db%22%20offset%3D%221%22%20%2F%3E%20%20%20%20%3C%2FradialGradient%3E%20%20%20%20%3ClinearGradient%20%20%20%20%20%20gradientUnits%3D%22userSpaceOnUse%22%20%20%20%20%20%20y2%3D%22242.92%22%20%20%20%20%20%20x2%3D%22431.03%22%20%20%20%20%20%20y1%3D%227.98%22%20%20%20%20%20%20x1%3D%22345.51999%22%20%20%20%20%20%20id%3D%22New_Gradient_Swatch_8%22%20%20%20%20%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop4%22%20stop-color%3D%22%23009cde%22%20offset%3D%220%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop6%22%20stop-color%3D%22%233455db%22%20offset%3D%22.38%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop8%22%20stop-color%3D%22%233354d8%22%20offset%3D%22.52%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop10%22%20stop-color%3D%22%232e53ce%22%20offset%3D%22.64%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop12%22%20stop-color%3D%22%232650bd%22%20offset%3D%22.74%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop14%22%20stop-color%3D%22%231c4ca5%22%20offset%3D%22.84%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop16%22%20stop-color%3D%22%230e4787%22%20offset%3D%22.93%22%20%2F%3E%20%20%20%20%20%20%3Cstop%20id%3D%22stop18%22%20stop-color%3D%22%2301426a%22%20offset%3D%221%22%20%2F%3E%20%20%20%20%3C%2FlinearGradient%3E%20%20%20%20%3Cstyle%20id%3D%22style2%22%3E%20%20%20%20%20%20.faro-logo-2%20%7B%20%20%20%20%20%20%20%20fill%3A%20%2301426a%3B%20%20%20%20%20%20%7D%20%20%20%20%20%20.faro-logo-4%20%7B%20%20%20%20%20%20%20%20fill%3A%20%23fff%3B%20%20%20%20%20%20%7D%20%20%20%20%3C%2Fstyle%3E%20%20%3C%2Fdefs%3E%20%20%3Cg%20transform%3D%22matrix%28.68402%200%200%20.68402%2024.165501%2039.087592%29%22%20id%3D%22g117%22%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M387.88.6a125.11%20125.11%200%200%200-110.22%2066.07h8.91a117.22%20117.22%200%201%201-1.7%20114.83h-8.77A125%20125%200%201%200%20387.88.6Z%22%20%20%20%20%20%20id%3D%22path52%22%20%20%20%20%20%20fill%3D%22url%28%23New_Gradient_Swatch_8%29%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20class%3D%22faro-logo-2%22%20%20%20%20%20%20id%3D%22polygon54%22%20%20%20%20%20%20d%3D%22M63.02%20135.98V113.9H27.71v-5.51l35.32-.01-.01-22.07H1.22v75.05h26.49v-25.38z%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20class%3D%22faro-logo-2%22%20%20%20%20%20%20id%3D%22polygon56%22%20%20%20%20%20%20d%3D%22M109.38%20161.36h27.59l-11.2-33.12h-23.75z%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20class%3D%22faro-logo-2%22%20%20%20%20%20%20id%3D%22polygon58%22%20%20%20%20%20%20d%3D%22m86.2%20161.36%208.1-33.11-23.38-.01-11.21%2033.12z%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20class%3D%22faro-logo-2%22%20%20%20%20%20%20id%3D%22polygon60%22%20%20%20%20%20%20d%3D%22M73.15%20121.62h22.76l2.43-9.92%202.21%209.92h22.98l-11.95-35.31H85.1z%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20class%3D%22faro-logo-2%22%20%20%20%20%20%20id%3D%22polygon62%22%20%20%20%20%20%20d%3D%22M169.08%20161.36v-33.11h-26.59v33.1l14.43.01z%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20class%3D%22faro-logo-2%22%20%20%20%20%20%20id%3D%22polygon64%22%20%20%20%20%20%20d%3D%22m184.68%20161.29%2031.86.07-20.41-33.11h-27.05z%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20class%3D%22faro-logo-2%22%20%20%20%20%20%20d%3D%22M169.08%20121.62v-13.23c8.83%200%2014.34-.18%2014.34%207.22%200%203.93-2.09%205.45-4.91%206h26.42a17.69%2017.69%200%200%200%201.75-8.23c0-13.72-7.88-27.09-29.36-27.09h-34.83v35.31h26.59z%22%20%20%20%20%20%20id%3D%22path66%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20class%3D%22faro-logo-2%22%20%20%20%20%20%20d%3D%22M248.52%2085A38.59%2038.59%200%200%200%20210%20121.62h24.12a14.82%2014.82%200%201%201%20.28%206.62h-24.18A38.57%2038.57%200%201%200%20248.52%2085Z%22%20%20%20%20%20%20id%3D%22path68%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20class%3D%22faro-logo-2%22%20%20%20%20%20%20d%3D%22M282.46%20151.71a4.82%204.82%200%201%200%204.78%204.82%204.81%204.81%200%200%200-4.78-4.82zm0%208.68a3.86%203.86%200%201%201%203.79-3.86%203.82%203.82%200%200%201-3.8%203.86z%22%20%20%20%20%20%20id%3D%22path70%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20class%3D%22faro-logo-2%22%20%20%20%20%20%20d%3D%22M283.63%20156.68a1.28%201.28%200%200%200%201-1.34c0-1.5-1.6-1.5-1.94-1.5h-2.3v5.51h.94v-2.21h1.11c.94.08%201.12.32%201.16%201.19%200%20.69.06.86.16%201h.94c-.13-.22-.13-.34-.18-1.27%200-.71-.14-1.16-.89-1.38zm-1.15-.44h-1.13v-1.53h1.25c.47%200%201%20.07%201.1.65%200%20.88-.84.88-1.22.88z%22%20%20%20%20%20%20id%3D%22path72%22%20%20%20%20%2F%3E%20%20%20%20%3Ccircle%20%20%20%20%20%20cx%3D%22387.87%22%20%20%20%20%20%20cy%3D%22125.6%22%20%20%20%20%20%20id%3D%22circle74%22%20%20%20%20%20%20r%3D%2283.410004%22%20%20%20%20%20%20fill%3D%22url%28%23New_Gradient_Swatch_7%29%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20class%3D%22faro-logo-4%22%20%20%20%20%20%20d%3D%22M458.64%20127.38c0-6.86-4.84-11.06-11.1-11.06-6.5%200-11.38%204.59-11.38%2011%200%205.69%203.88%2010%2010%2010.82h.51l.6.05h1.06c3.85%200%206.82-1.19%208.8-3.45l-1.57-1.7-1.72-1.87a7.2%207.2%200%200%201-5.35%202.06%207.54%207.54%200%200%201-1-.06c-.21%200-.41-.06-.6-.09l-.44-.1a4.64%204.64%200%200%201-.53-.16l-.42-.15-.46-.22c-.13-.07-.26-.14-.38-.22a3.77%203.77%200%200%201-.39-.26l-.35-.3c-.11-.1-.22-.2-.31-.3-.09-.1-.22-.26-.32-.39s-.16-.21-.23-.32a4.25%204.25%200%200%201-.27-.52%202.49%202.49%200%200%201-.15-.28%206.44%206.44%200%200%201-.28-.88h16.13c.07-.46.15-1.13.15-1.6zm-16.36-1.95a5.34%205.34%200%200%201%2010.53%200z%22%20%20%20%20%20%20id%3D%22path76%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20class%3D%22faro-logo-4%22%20d%3D%22M447.67%20138.26Z%22%20id%3D%22path78%22%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20class%3D%22faro-logo-4%22%20%20%20%20%20%20d%3D%22M406.51%20116.32c-6.5%200-11.38%204.59-11.38%2011%200%205.69%203.88%2010%2010%2010.82h.51l.6.05h1.06c3.85%200%206.82-1.19%208.8-3.45l-3.29-3.57a7.2%207.2%200%200%201-5.35%202.06%207.54%207.54%200%200%201-1-.06c-.21%200-.41-.06-.6-.09l-.44-.1a4.64%204.64%200%200%201-.53-.16%203.52%203.52%200%200%201-.42-.15l-.46-.22c-.13-.07-.26-.14-.38-.22a3.77%203.77%200%200%201-.39-.26l-.35-.3c-.11-.1-.22-.2-.31-.3-.09-.1-.22-.26-.32-.39s-.16-.21-.23-.32a4.25%204.25%200%200%201-.27-.52%202.49%202.49%200%200%201-.15-.28%206.44%206.44%200%200%201-.28-.88h16.13c0-.52.12-1.19.12-1.66.03-6.8-4.81-11-11.07-11zm-5.26%209.11a5.34%205.34%200%200%201%2010.53%200z%22%20%20%20%20%20%20id%3D%22path80%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20class%3D%22faro-logo-4%22%20%20%20%20%20%20d%3D%22M326.47%20120.6c-1.48-.54-2.46-1.28-2.46-2.54%200-1.74%201.47-3.17%205.27-3.17a14.28%2014.28%200%200%201%204.38.72%2017.78%2017.78%200%200%201%203.31%201.46l2-4.88a18.69%2018.69%200%200%200-9.64-2.45h-.66a18.22%2018.22%200%200%200-1.88.14c-6.17.76-9.15%204.31-9.15%208.49%200%207.42%208.37%207.65%2013.05%209.13l.21.07a7.09%207.09%200%200%201%201.79.84l.16.12a2.17%202.17%200%200%201%20.92%201.77c0%201.7-1.54%203-5.35%203a16.28%2016.28%200%200%201-4.44-.65%2015.4%2015.4%200%200%201-4.72-2.24l-2.18%204.84c2.46%201.9%206.9%203.21%2011.3%203.21h.87c.42%200%20.83%200%201.23-.08%206.51-.64%209.68-4.3%209.68-8.51-.01-7.71-9.16-7.6-13.69-9.27z%22%20%20%20%20%20%20id%3D%22path82%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20class%3D%22faro-logo-4%22%20%20%20%20%20%20d%3D%22M355.92%20116.32a8.31%208.31%200%200%200-6.7%202.77v-2.46h-5.9v29h6.18v-10a8.27%208.27%200%200%200%206.42%202.58%2010.35%2010.35%200%200%200%2010.63-11c0-6.61-4.64-10.89-10.63-10.89zm-1.07%2016.88c-3.09%200-5.43-2.22-5.43-5.9v-.5a5.43%205.43%200%200%201%203.15-5%208.67%208.67%200%200%201%201.84-.44h.42c3.1%200%205.43%202.22%205.43%205.91s-2.26%205.93-5.41%205.93z%22%20%20%20%20%20%20id%3D%22path84%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20class%3D%22faro-logo-4%22%20%20%20%20%20%20d%3D%22M382.84%20116.32a9.41%209.41%200%200%200-6.78%202.53v-10.3h-6.18V138h6.18v-10.58c0-2.87%201.15-4.61%202.92-5.34a9.91%209.91%200%200%201%202.26-.41c2.69%200%204.26%201.61%204.26%205V138h6.18v-12.25c0-6.5-3.8-9.43-8.84-9.43z%22%20%20%20%20%20%20id%3D%22path86%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20class%3D%22faro-logo-4%22%20%20%20%20%20%20d%3D%22M426.85%20119.45v-2.82h-5.91V138h6.19V127.12c.27-3.55%202.45-5.17%205.63-5.17.48%200%20.88%200%201.39.07v-5.7c-3.26%200-5.8%201.07-7.3%203.13z%22%20%20%20%20%20%20id%3D%22path88%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20class%3D%22faro-logo-4%22%20d%3D%22M406.64%20138.26Z%22%20id%3D%22path90%22%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _g$o;
function _extends$1T() { return _extends$1T = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1T.apply(null, arguments); }
const SvgFeedback = props => /*#__PURE__*/React.createElement("svg", _extends$1T({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 80 80"
}, props), _g$o || (_g$o = /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 12603"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0-.001h80v80H0z",
  "data-name": "Rettangolo 13632"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.513 24.433a7.24 7.24 0 1 1-7.24 7.24 7.25 7.25 0 0 1 7.24-7.24m0-4.455a11.7 11.7 0 1 0 11.7 11.7 11.7 11.7 0 0 0-11.7-11.7",
  "data-name": "Tracciato 11272"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.513 52.278a18.95 18.95 0 0 1 18.4 14.462H7.103a18.97 18.97 0 0 1 18.4-14.462m0-4.455A23.493 23.493 0 0 0 2.126 71.195l46.781.018v-.018a23.493 23.493 0 0 0-23.39-23.372Z",
  "data-name": "Tracciato 11273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.027 38.85V27.901h-.169a4.63 4.63 0 0 1-4.631-4.624V8.884a4.633 4.633 0 0 1 4.627-4.629h26.389a4.63 4.63 0 0 1 4.627 4.629v14.393a4.63 4.63 0 0 1-4.627 4.627H57.972ZM47.8 8.71a1.114 1.114 0 0 0-1.114 1.114v12.51a1.114 1.114 0 0 0 1.114 1.114h3.682v4.647l4.647-4.647h16.175a1.114 1.114 0 0 0 1.114-1.114V9.824a1.114 1.114 0 0 0-1.114-1.114Z",
  "data-name": "Tracciato 11274"
}))));
var feedback = "data:image/svg+xml,%3Csvg%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2280%22%20%20height%3D%2280%22%20%20viewBox%3D%220%200%2080%2080%22%3E%20%20%3Cg%20%20%20%20id%3D%22Raggruppa_12603%22%20%20%20%20data-name%3D%22Raggruppa%2012603%22%20%20%20%20transform%3D%22translate%28-476.098%20-120.098%29%22%20%20%3E%20%20%20%20%3Crect%20%20%20%20%20%20id%3D%22Rettangolo_13632%22%20%20%20%20%20%20data-name%3D%22Rettangolo%2013632%22%20%20%20%20%20%20width%3D%2280%22%20%20%20%20%20%20height%3D%2280%22%20%20%20%20%20%20transform%3D%22translate%28476.098%20120.097%29%22%20%20%20%20%20%20fill%3D%22none%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22Tracciato_11272%22%20%20%20%20%20%20data-name%3D%22Tracciato%2011272%22%20%20%20%20%20%20d%3D%22M492.942%2C133.467a7.24%2C7.24%2C0%2C1%2C1-7.24%2C7.24%2C7.248%2C7.248%2C0%2C0%2C1%2C7.24-7.24m0-4.455a11.7%2C11.7%2C0%2C1%2C0%2C11.7%2C11.7%2C11.7%2C11.7%2C0%2C0%2C0-11.7-11.7Z%22%20%20%20%20%20%20transform%3D%22translate%288.669%2011.064%29%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22Tracciato_11273%22%20%20%20%20%20%20data-name%3D%22Tracciato%2011273%22%20%20%20%20%20%20d%3D%22M499.387%2C145.967a18.948%2C18.948%2C0%2C0%2C1%2C18.4%2C14.462h-36.81a18.967%2C18.967%2C0%2C0%2C1%2C18.4-14.462m0-4.455A23.493%2C23.493%2C0%2C0%2C0%2C476%2C164.884l46.781.018v-.018a23.493%2C23.493%2C0%2C0%2C0-23.39-23.372Z%22%20%20%20%20%20%20transform%3D%22translate%282.224%2026.409%29%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22Tracciato_11274%22%20%20%20%20%20%20data-name%3D%22Tracciato%2011274%22%20%20%20%20%20%20d%3D%22M499.8%2C156.549V145.6h-.169A4.631%2C4.631%2C0%2C0%2C1%2C495%2C140.976V126.583a4.633%2C4.633%2C0%2C0%2C1%2C4.627-4.629h26.389a4.632%2C4.632%2C0%2C0%2C1%2C4.627%2C4.629v14.393a4.63%2C4.63%2C0%2C0%2C1-4.627%2C4.627H510.745Zm.773-30.14a1.114%2C1.114%2C0%2C0%2C0-1.114%2C1.114v12.51a1.114%2C1.114%2C0%2C0%2C0%2C1.114%2C1.114h3.682v4.647l4.647-4.647h16.175a1.114%2C1.114%2C0%2C0%2C0%2C1.114-1.114v-12.51a1.114%2C1.114%2C0%2C0%2C0-1.114-1.114Z%22%20%20%20%20%20%20transform%3D%22translate%2823.325%202.399%29%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _path$1A;
function _extends$1S() { return _extends$1S = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1S.apply(null, arguments); }
const SvgFileDocument = props => /*#__PURE__*/React.createElement("svg", _extends$1S({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$1A || (_path$1A = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.667 2.666H5.333C4.6 2.666 4 3.266 4 3.999v17.334h16V7.999zm3.446 5.333h-3.446V4.553zm.554 12H5.333V4.333a.33.33 0 0 1 .334-.334h7.666v5.334h5.334z"
})));

var _path$1z;
function _extends$1R() { return _extends$1R = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1R.apply(null, arguments); }
const SvgFileImage = props => /*#__PURE__*/React.createElement("svg", _extends$1R({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 18 14"
}, props), _path$1z || (_path$1z = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M1.111 0h15.556c.61 0 1.11.5 1.11 1.111v12.222H0V1.111C0 .5.5 0 1.111 0m15.556 8.294V1.39h-.006a.275.275 0 0 0-.278-.278h-15a.275.275 0 0 0-.277.278v5.889L3.25 5.85l3.794 2.528 2.462-1.322 3.633 1.95zM1.11 7.944v4.273h15.561V8.86l-3.61.728-3.55-1.906-2.495 1.34-3.761-2.506zM15 4.445a1.111 1.111 0 1 1-2.222 0 1.111 1.111 0 0 1 2.222 0",
  clipRule: "evenodd"
})));

var _path$1y;
function _extends$1Q() { return _extends$1Q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1Q.apply(null, arguments); }
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends$1Q({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$1y || (_path$1y = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.335 6.02H2.668v1.333h18.667zm-2.668 5.333H5.334v1.333h13.333zM8 16.686h8v1.334H8z",
  clipRule: "evenodd"
})));

var _path$1x;
function _extends$1P() { return _extends$1P = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1P.apply(null, arguments); }
const SvgFindCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends$1P({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _path$1x || (_path$1x = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m21.42 19.96 10.79 10.83-1.42 1.41-10.78-10.82a9.73 9.73 0 0 1-6.21 2.22c-5.41 0-9.8-4.39-9.8-9.8S8.39 4 13.8 4s9.8 4.39 9.8 9.8c0 2.33-.82 4.48-2.18 6.16M6 13.81c0 4.3 3.5 7.8 7.8 7.8s7.8-3.5 7.8-7.8-3.5-7.8-7.8-7.8S6 9.51 6 13.81m2.97 1.18 3.65 3.63 5.35-8.01-1.66-1.11-4 5.99-1.93-1.92z"
})));

var _path$1w;
function _extends$1O() { return _extends$1O = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1O.apply(null, arguments); }
const SvgFlagSmall = props => /*#__PURE__*/React.createElement("svg", _extends$1O({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path$1w || (_path$1w = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.995 7 4 2v14h1v-4.42zM5 10.495V3.5L13.395 7 5 10.5z"
})));

var _path$1v;
function _extends$1N() { return _extends$1N = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1N.apply(null, arguments); }
const SvgFolderSmall = props => /*#__PURE__*/React.createElement("svg", _extends$1N({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18"
}, props), _path$1v || (_path$1v = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m4.961 3.25 2.457 2.457.293.293H16v8.75H2V3.25Zm.414-1h-3.5A.875.875 0 0 0 1 3.125V15.75h16V5H8.125Z",
  "data-name": "folder-small"
})));

var _g$n;
function _extends$1M() { return _extends$1M = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1M.apply(null, arguments); }
const SvgFullScreen = props => /*#__PURE__*/React.createElement("svg", _extends$1M({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 38 38"
}, props), _g$n || (_g$n = /*#__PURE__*/React.createElement("g", {
  "data-name": "Full screen",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 38,
  height: 38,
  fill: "currentColor",
  "data-name": "Rettangolo 13753",
  rx: 5,
  transform: "translate(-1 -1)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M6 6h24v24H6z",
  "data-name": "Rettangolo 1365"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.108 26.276h-4.055v-4.055H8.702v5.407h5.406Z",
  "data-name": "Tracciato 876"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.108 10.056h-4.055v4.055H8.702V8.704h5.406Z",
  "data-name": "Tracciato 877"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M22.223 26.276h4.056v-4.055h1.352v5.407h-5.408Z",
  "data-name": "Tracciato 878"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M22.223 10.056h4.056v4.055h1.352V8.704h-5.408Z",
  "data-name": "Tracciato 879"
}))));

var _path$1u;
function _extends$1L() { return _extends$1L = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1L.apply(null, arguments); }
const SvgGenericConnectionCloud = props => /*#__PURE__*/React.createElement("svg", _extends$1L({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 25 24"
}, props), _path$1u || (_path$1u = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.426 20H5.393l-2.18-2.22a4.53 4.53 0 0 1-1.38-3.26c0-2.033 1.327-3.78 3.213-4.32.367-1.56 1.714-2.687 3.327-2.707C9.26 5.38 11.286 4 13.58 4c3.026 0 5.506 2.427 5.66 5.467 2.246.386 3.926 2.353 3.926 4.74a4.83 4.83 0 0 1-1.246 3.24l-2.494 2.56zM5.953 18.667h12.913c.667-.68 2.08-2.14 2.08-2.14.567-.627.887-1.46.887-2.327 0-1.887-1.447-3.413-3.293-3.473l-.687-.02.047-.767c0-.06.006-.12.006-.173 0-2.447-1.946-4.434-4.333-4.434-1.887 0-3.547 1.234-4.12 3.074l-.173.54-.56-.087a2 2 0 0 0-.307-.033c-1.1 0-2.013.853-2.12 1.986l-.047.507-.5.087c-1.493.253-2.573 1.56-2.573 3.113 0 .887.347 1.7.987 2.307l1.8 1.833z"
})));

var _path$1t;
function _extends$1K() { return _extends$1K = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1K.apply(null, arguments); }
const SvgGeoReference = props => /*#__PURE__*/React.createElement("svg", _extends$1K({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 11 11"
}, props), _path$1t || (_path$1t = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.213.5H5.187v.972a4.264 4.264 0 0 0-3.714 3.715H.5v1.025h.972a4.26 4.26 0 0 0 3.715 3.715v.973h1.026v-.972a4.26 4.26 0 0 0 3.714-3.715h.973V5.188h-.973a4.26 4.26 0 0 0-3.714-3.716zm-.87 4.843V2.487a3.24 3.24 0 0 0-2.856 2.856zm.713 0V2.487a3.24 3.24 0 0 1 2.858 2.856zM3.415 7.985a3.24 3.24 0 0 1-.928-1.929h2.857v2.857a3.24 3.24 0 0 1-1.93-.928m2.641.928V6.056h2.858a3.236 3.236 0 0 1-2.858 2.857",
  clipRule: "evenodd"
})));

var _path$1s, _path2$I;
function _extends$1J() { return _extends$1J = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1J.apply(null, arguments); }
const SvgGrid = props => /*#__PURE__*/React.createElement("svg", _extends$1J({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$1s || (_path$1s = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M32 10V8h-4V4h-2v4h-7V4h-2v4h-7V4H8v4H4v2h4v7H4v2h4v7H4v2h4v4h2v-4h7v4h2v-4h7v4h2v-4h4v-2h-4v-7h4v-2h-4v-7zm-22 0h7v7h-7zm0 16v-7h7v7zm16 0h-7v-7h7zm0-9h-7v-7h7z"
})), _path2$I || (_path2$I = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z"
})));
var grid = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20%20version%3D%221.1%22%20%20id%3D%22Layer_1%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20%20x%3D%220px%22%20%20y%3D%220px%22%20%20width%3D%2236px%22%20%20height%3D%2236px%22%20%20viewBox%3D%220%200%2036%2036%22%20%20enable-background%3D%22new%200%200%2036%2036%22%20%20xml%3Aspace%3D%22preserve%22%3E%20%20%3Cg%3E%20%20%20%20%3Cpath%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20d%3D%22M32%2C10V8h-4V4h-2v4h-7V4h-2v4h-7V4H8v4H4v2h4v7H4v2h4v7H4v2h4v4h2v-4h7v4h2v-4h7v4h2v-4h4v-2h-4v-7h4v-2h-4%20%20v-7H32z%20M10%2C10h7v7h-7V10z%20M10%2C26v-7h7v7H10z%20M26%2C26h-7v-7h7V26z%20M26%2C17h-7v-7h7V17z%22%20%20%20%20%2F%3E%20%20%20%20%3Crect%20fill%3D%22none%22%20width%3D%2236%22%20height%3D%2236%22%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _g$m;
function _extends$1I() { return _extends$1I = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1I.apply(null, arguments); }
const SvgHamburgerMenu = props => /*#__PURE__*/React.createElement("svg", _extends$1I({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _g$m || (_g$m = /*#__PURE__*/React.createElement("g", {
  "data-name": "Artboard \\u2013 1"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Hamburger Menu Simple - Horizontal Stripes"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  "data-name": "Group 12180"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.001 11h14v1h-14z",
  "data-name": "Rectangle 13881"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.001 16h14v1h-14z",
  "data-name": "Rectangle 13882"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.001 7h14v1h-14z",
  "data-name": "Rectangle 13883"
})), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 13884"
})))));

var _path$1r;
function _extends$1H() { return _extends$1H = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1H.apply(null, arguments); }
const SvgHappyFace44Px = props => /*#__PURE__*/React.createElement("svg", _extends$1H({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 44 44"
}, props), _path$1r || (_path$1r = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1 22A21 21 0 0 1 22 1a21 21 0 0 1 21 21 21 21 0 0 1-21 21A21 21 0 0 1 1 22m3 0a18.02 18.02 0 0 0 18 18 18.02 18.02 0 0 0 18-18A18.02 18.02 0 0 0 22 4 18.02 18.02 0 0 0 4 22m18 13.271a11.54 11.54 0 0 1-10.325-6.327 1.5 1.5 0 0 1 .656-2.019 1.5 1.5 0 0 1 2.018.657A8.44 8.44 0 0 0 22 32.27a8.44 8.44 0 0 0 7.648-4.688 1.5 1.5 0 0 1 2.018-.657 1.5 1.5 0 0 1 .656 2.019A11.53 11.53 0 0 1 22 35.27Zm-5.133-16.247a6.54 6.54 0 0 0-4.235 0 1.5 1.5 0 0 1-1.915-.911 1.5 1.5 0 0 1 .912-1.915 9.6 9.6 0 0 1 6.242 0 1.5 1.5 0 0 1 .911 1.915 1.5 1.5 0 0 1-1.413 1 1.5 1.5 0 0 1-.501-.089Zm8.348-.912a1.5 1.5 0 0 1 .912-1.915 9.6 9.6 0 0 1 6.243 0 1.5 1.5 0 0 1 .911 1.915 1.5 1.5 0 0 1-1.413 1 1.5 1.5 0 0 1-.5-.087 6.53 6.53 0 0 0-4.236 0 1.5 1.5 0 0 1-.505.088 1.5 1.5 0 0 1-1.41-1.001Z"
})));

var _g$l, _defs$d;
function _extends$1G() { return _extends$1G = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1G.apply(null, arguments); }
const SvgHblogoBlacktext = props => /*#__PURE__*/React.createElement("svg", _extends$1G({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 201 68"
}, props), _g$l || (_g$l = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#hblogo_blacktext_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M73.88 38.953c1.993 1.083 3.168 3.25 3.066 5.52 0 3.56-2.861 6.501-6.438 6.501h-5.364c-.511.052-1.022-.31-1.073-.825V30.44c-.051-.517.306-1.033.817-1.084h5.62c2.913-.052 5.314 2.321 5.365 5.262v.155a5.08 5.08 0 0 1-1.993 4.179m-7.663-7.43v6.501h4.291c1.789 0 3.22-1.444 3.22-3.25s-1.431-3.25-3.22-3.25zm0 8.617v8.667h4.291c2.35 0 4.292-1.96 4.292-4.334s-1.941-4.333-4.292-4.333zM100.04 30.44v14.085c-.102 3.612-3.065 6.398-6.59 6.294-3.424-.103-6.132-2.889-6.234-6.294V30.44c0-.62.46-1.083 1.073-1.083s1.073.464 1.073 1.083v14.085c-.102 2.373 1.788 4.386 4.138 4.489s4.343-1.806 4.445-4.18V30.44c0-.62.46-1.083 1.073-1.083s1.022.464 1.022 1.083M111.383 50.974c-.511.052-.971-.31-1.073-.825V30.44c-.051-.62.409-1.136 1.022-1.136s1.124.413 1.124 1.032v19.605c.051.516-.307 1.032-.818 1.084-.051-.052-.153-.052-.255-.052M122.725 30.44c0-.62.46-1.083 1.073-1.083.614 0 1.073.464 1.073 1.083v18.367h7.511a1.024 1.024 0 0 1 1.124 1.032c.051.62-.409 1.135-1.022 1.135h-8.737c-.511.052-1.022-.31-1.073-.825V30.44zM143.725 30.44c-.051-.516.306-1.032.817-1.083h6.6930000000000005c2.913-.052 5.314 2.321 5.365 5.262v10.938c0 2.992-2.401 5.417-5.314 5.417h-6.437c-.511.052-1.022-.31-1.073-.825V30.44zm2.146 1.083V48.86h5.364c1.789 0 3.219-1.445 3.219-3.25V34.774c0-1.806-1.43-3.25-3.219-3.25zM166.87 49.89V30.44c-.051-.516.306-1.032.817-1.083h8.891c.613 0 1.072.464 1.072 1.083 0 .62-.459 1.083-1.072 1.083h-7.511v6.501h5.365a1.024 1.024 0 0 1 1.124 1.032c.051.62-.409 1.135-1.022 1.135h-5.518v8.668h7.51a1.024 1.024 0 0 1 1.124 1.032c.052.619-.408 1.135-1.021 1.135h-8.686c-.511.051-1.022-.31-1.073-.826zM196.81 41.842l3.73 7.533c.102.155.153.361.102.516 0 .567-.459 1.083-1.073 1.083-.408 0-.817-.206-.97-.619l-3.935-7.997h-4.7v7.584c.051.62-.409 1.135-1.022 1.135s-1.124-.412-1.124-1.032V30.441c-.051-.517.307-1.033.818-1.084h5.62c3.525 0 6.437 2.889 6.437 6.449v.051c0 2.941-1.328 4.953-3.883 5.985m-6.846-10.318v8.667h4.292c2.35 0 4.292-1.96 4.292-4.334s-1.942-4.334-4.292-4.334zM64.07 21.05V1.548c-.05-.62.41-1.135 1.023-1.135a1.024 1.024 0 0 1 1.124 1.032v7.739H74.8V1.548c-.05-.62.409-1.135 1.022-1.135a1.024 1.024 0 0 1 1.124 1.032V21.05c.051.62-.409 1.135-1.022 1.135a1.024 1.024 0 0 1-1.124-1.032V11.3h-8.583v9.751c.05.62-.41 1.135-1.022 1.135a1.024 1.024 0 0 1-1.124-1.032zM100.04 15.633c0 3.56-2.861 6.5-6.437 6.5-3.526 0-6.438-2.889-6.438-6.5V6.965c0-3.56 2.86-6.5 6.438-6.5 3.525 0 6.437 2.889 6.437 6.5zm-2.146 0V6.965c0-2.373-1.941-4.334-4.291-4.334s-4.292 1.96-4.292 4.334v8.668c0 2.373 1.941 4.334 4.291 4.334 2.402 0 4.292-1.96 4.292-4.334M110.31 1.548c0-.62.46-1.084 1.073-1.084s1.073.465 1.073 1.084v18.367h7.51c.614 0 1.073.464 1.073 1.084 0 .619-.459 1.083-1.073 1.083h-8.583c-.511.052-1.022-.31-1.073-.826V1.549M144.185 15.633c-.103 3.611-3.066 6.397-6.591 6.294-3.424-.103-6.132-2.89-6.234-6.294V6.965c-.102-3.611 2.708-6.552 6.234-6.655 3.576-.104 6.488 2.734 6.591 6.294v9.029m-2.146 0V6.965c.102-2.373-1.789-4.385-4.139-4.489-2.35-.103-4.343 1.806-4.445 4.18v8.977c-.102 2.373 1.788 4.385 4.139 4.488s4.342-1.805 4.445-4.179z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hblogo_blacktext_svg__b)",
  d: "M42.05.98h-.154c-4.598 0-10.627 2.425-16.86 6.759v36.528a67 67 0 0 0 9.86-8.358C47.415 23.217 53.189 8.513 47.722 2.992 46.393 1.651 44.4.98 42.05.98"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE601",
  d: "M2.35 3.044c-5.416 5.469.307 20.225 12.876 32.865a73 73 0 0 0 9.86 8.307V7.686C15.533 1.135 6.439-1.083 2.35 3.044"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hblogo_blacktext_svg__c)",
  d: "M25.087 7.687c-3.577 2.477-6.847 5.263-9.861 8.307C2.656 28.686-3.066 43.39 2.35 48.91c1.38 1.392 3.372 2.063 5.774 2.063 4.598 0 10.678-2.425 16.912-6.758z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hblogo_blacktext_svg__d)",
  d: "M25.087 7.687A72.8 72.8 0 0 0 7 25.951a73 73 0 0 0 8.226 9.958 73 73 0 0 0 9.86 8.307z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE601",
  d: "M34.948 15.994c-3.015-3.096-6.336-5.83-9.861-8.307v36.528c9.554 6.604 18.649 8.771 22.685 4.644 5.467-5.469-.306-20.173-12.824-32.865"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m68.873 65.678-.817-2.063H65.45l-.817 2.063h-.767l2.555-6.604h.613l2.555 6.604zm-1.021-2.786-.767-2.012a10 10 0 0 1-.306-.929c-.051.31-.154.62-.256.93l-.766 2.011zM73.676 65.678h-.766v-6.552h3.627v.67h-2.86v2.425h2.707v.671h-2.708zM81.749 65.678l-.818-2.063h-2.605l-.818 2.063h-.766l2.554-6.604h.613l2.555 6.604zm-1.073-2.786-.767-2.012a10 10 0 0 1-.306-.929 6 6 0 0 1-.255.93l-.767 2.011zM84.15 62.944v2.734h-.766v-6.552h1.788c.818 0 1.38.155 1.788.464.358.31.562.774.562 1.393 0 .877-.46 1.445-1.328 1.755l1.788 2.94h-.92l-1.583-2.734zm0-.67h1.022c.511 0 .92-.104 1.175-.31.256-.207.358-.516.358-.98 0-.413-.102-.723-.358-.93q-.383-.309-1.226-.309h-.97zM94.675 62.376q0 1.548-.766 2.477c-.51.619-1.277.928-2.197.928-.97 0-1.686-.31-2.197-.877-.51-.567-.766-1.444-.766-2.528q0-1.625.766-2.476c.51-.568 1.277-.877 2.248-.877.92 0 1.686.31 2.197.877.46.567.715 1.393.715 2.476m-5.16 0c0 .877.204 1.548.562 2.012.358.465.92.671 1.635.671s1.277-.206 1.635-.67.562-1.136.562-2.013-.204-1.547-.562-2.012c-.358-.464-.92-.67-1.635-.67s-1.277.206-1.635.67c-.409.465-.562 1.135-.562 2.012M95.493 60.674c0-.361.102-.671.255-.98.154-.31.41-.568.716-.723s.613-.258.97-.258c.358 0 .665.103.971.258.307.155.562.413.716.723.153.309.255.619.255.98 0 .36-.102.67-.255.98s-.41.567-.716.722c-.306.207-.613.258-.97.258-.358 0-.665-.103-.971-.258a1.62 1.62 0 0 1-.716-.722c-.153-.31-.255-.62-.255-.98m.306 0c0 .31.051.567.205.825q.23.387.613.62c.255.154.562.206.817.206.307 0 .562-.052.818-.207a1.8 1.8 0 0 0 .613-.619c.153-.258.204-.567.204-.825 0-.31-.05-.568-.204-.826a1.8 1.8 0 0 0-.613-.619 1.6 1.6 0 0 0-.818-.206c-.306 0-.562.051-.817.206a1.8 1.8 0 0 0-.613.62c-.154.257-.205.515-.205.825m2.453-.465c0 .155-.051.258-.102.362a.53.53 0 0 1-.307.258l.613 1.031h-.46l-.562-.928h-.357v.928h-.409V59.54h.664q.46 0 .613.154c.256.104.307.258.307.516m-1.124.362h.255c.154 0 .256-.052.358-.104.102-.051.102-.154.102-.258 0-.154-.05-.206-.102-.258-.051-.051-.204-.103-.358-.103h-.255zM104.945 65.678h-.766v-5.881h-2.044v-.671h4.854v.67h-2.044zM109.901 65.73c-.715 0-1.277-.207-1.686-.67q-.613-.697-.613-1.858c0-.774.204-1.445.562-1.91.409-.464.92-.721 1.584-.721.613 0 1.073.206 1.43.619.358.412.511.928.511 1.6v.463h-3.372c0 .568.154 1.032.409 1.342s.664.464 1.175.464q.766 0 1.533-.31v.671c-.256.103-.511.207-.766.258-.154.052-.409.052-.767.052m-.204-4.489c-.409 0-.716.103-.92.361-.255.258-.358.62-.409 1.084h2.555q0-.697-.307-1.084a1.26 1.26 0 0 0-.919-.36M114.908 65.73c-.715 0-1.277-.207-1.635-.67-.408-.465-.562-1.084-.562-1.858 0-.826.205-1.445.613-1.91s.971-.67 1.686-.67c.256 0 .46 0 .716.052.255.051.408.103.562.154l-.205.62c-.153-.052-.357-.104-.511-.155-.204-.052-.357-.052-.51-.052-.971 0-1.482.62-1.482 1.91 0 .618.102 1.083.357 1.392q.384.465 1.073.465c.409 0 .818-.104 1.227-.258v.67c-.409.258-.818.31-1.329.31M120.631 65.678V62.48c0-.413-.103-.723-.256-.878-.204-.206-.46-.31-.868-.31-.511 0-.869.156-1.124.414s-.358.722-.358 1.393v2.58h-.715v-6.966h.715v2.115c0 .258 0 .465-.051.62h.051c.153-.258.358-.413.613-.568s.562-.206.92-.206c.613 0 1.022.154 1.328.413.307.31.46.722.46 1.34v3.2h-.715zM126.251 65.678V62.48c0-.413-.102-.723-.256-.878-.204-.206-.459-.31-.868-.31-.511 0-.869.156-1.124.414s-.358.722-.358 1.393v2.58h-.715v-4.902h.613l.102.67h.051c.154-.257.358-.412.613-.567.256-.155.562-.206.92-.206.562 0 1.022.154 1.328.413.307.31.46.722.46 1.392v3.2zM132.689 63.202q0 1.237-.614 1.857c-.408.465-.97.67-1.634.67-.46 0-.818-.102-1.176-.309a1.8 1.8 0 0 1-.766-.877c-.204-.36-.255-.825-.255-1.341q0-1.239.613-1.858c.408-.464.97-.67 1.635-.67.664 0 1.226.206 1.635.67.357.465.562 1.084.562 1.858m-3.73 0c0 .619.102 1.083.357 1.444.256.31.614.516 1.125.516.51 0 .868-.154 1.124-.516.255-.31.357-.825.357-1.444 0-.62-.102-1.084-.357-1.445-.256-.31-.614-.464-1.124-.464-.46 0-.869.155-1.073.464-.256.31-.409.774-.409 1.445M134.732 65.678h-.715v-6.965h.715zM140.506 63.202q0 1.237-.613 1.857c-.409.465-.971.67-1.635.67a2.2 2.2 0 0 1-1.175-.309 1.8 1.8 0 0 1-.767-.877c-.204-.36-.255-.825-.255-1.341q0-1.239.613-1.858c.409-.464.971-.67 1.635-.67s1.226.206 1.635.67c.357.465.562 1.084.562 1.858m-3.73 0c0 .619.102 1.083.358 1.444.255.31.613.516 1.124.516.46 0 .868-.154 1.124-.516.255-.31.357-.825.357-1.444 0-.62-.102-1.084-.357-1.445-.256-.31-.613-.464-1.124-.464-.46 0-.869.155-1.073.464-.256.31-.409.774-.409 1.445M145.768 60.725v.465l-.919.103c.102.103.153.258.204.413s.102.36.102.567c0 .464-.153.877-.511 1.135-.306.31-.766.413-1.328.413-.153 0-.307 0-.409-.052q-.46.232-.46.62 0 .231.154.309c.102.052.306.103.562.103h.868c.511 0 .92.103 1.226.361.307.207.409.568.409.98 0 .568-.204.98-.664 1.239-.409.31-1.073.413-1.89.413-.614 0-1.124-.104-1.482-.361-.358-.259-.511-.568-.511-1.032q0-.465.307-.774c.204-.207.459-.361.817-.465-.102-.051-.204-.154-.307-.258-.102-.103-.102-.258-.102-.412 0-.155.051-.362.154-.465.102-.154.255-.258.459-.412a1.2 1.2 0 0 1-.613-.516 1.6 1.6 0 0 1-.255-.877c0-.516.153-.98.46-1.239.306-.31.766-.412 1.379-.412.256 0 .46.051.715.103h1.635zm-3.883 5.779c0 .258.103.464.358.619.204.155.562.206.971.206.613 0 1.073-.103 1.379-.258a.85.85 0 0 0 .46-.774c0-.258-.102-.464-.255-.567q-.23-.155-.92-.155h-.869c-.357 0-.613.103-.766.258-.255.103-.358.361-.358.67m.409-4.18q0 .543.307.775c.204.154.46.258.817.258q1.073 0 1.073-1.084c0-.722-.358-1.135-1.073-1.135-.357 0-.613.103-.817.258-.205.258-.307.516-.307.929M146.739 59.384c0-.155.051-.31.102-.361.103-.103.205-.103.307-.103s.204.051.307.103a.47.47 0 0 1 .153.36c0 .156-.051.31-.153.362-.103.103-.205.103-.307.103s-.204-.051-.307-.103c-.051-.051-.102-.206-.102-.361m.767 6.294h-.716v-4.901h.716zM151.133 65.73c-.715 0-1.277-.207-1.686-.67q-.613-.697-.613-1.858c0-.774.204-1.445.562-1.91.409-.464.92-.721 1.584-.721.613 0 1.073.206 1.431.619.357.412.51.928.51 1.6v.463h-3.372c0 .568.154 1.032.409 1.342.256.31.664.464 1.175.464q.766 0 1.533-.31v.671c-.255.103-.511.207-.766.258-.154.052-.409.052-.767.052m-.153-4.489c-.409 0-.715.103-.92.361-.255.258-.357.62-.408 1.084h2.554q0-.697-.306-1.084c-.256-.206-.562-.36-.92-.36M157.367 64.285c0 .465-.154.826-.511 1.084-.358.258-.818.36-1.431.36q-.996 0-1.533-.309v-.67c.256.103.511.206.767.258.255.051.511.103.766.103.409 0 .664-.052.869-.207.204-.154.306-.31.306-.567 0-.207-.102-.361-.255-.516s-.511-.31-.971-.464-.766-.31-.971-.465-.357-.258-.409-.413a1.05 1.05 0 0 1-.153-.567q0-.619.46-.929c.307-.206.766-.36 1.328-.36q.766 0 1.533.309l-.255.619c-.511-.207-.92-.31-1.329-.31q-.536 0-.766.155a.54.54 0 0 0-.256.464c0 .155.052.258.103.361a.52.52 0 0 0 .306.259c.153.103.409.206.869.36.562.207.971.413 1.175.62.255.258.358.516.358.825M163.804 59.694c-.715 0-1.277.257-1.686.722s-.613 1.135-.613 1.96q0 1.316.613 2.012c.409.465.971.723 1.686.723.46 0 .971-.103 1.533-.258v.67a5.3 5.3 0 0 1-1.686.258c-.971 0-1.686-.31-2.197-.877s-.766-1.444-.766-2.476c0-.67.102-1.29.357-1.754a3.4 3.4 0 0 1 1.073-1.187c.46-.258 1.022-.413 1.686-.413s1.278.104 1.789.361l-.307.671c-.46-.31-.971-.413-1.482-.413M170.855 63.202q0 1.237-.613 1.857c-.409.465-.971.67-1.635.67-.46 0-.817-.102-1.175-.309a1.82 1.82 0 0 1-.767-.877c-.204-.36-.255-.825-.255-1.341q0-1.239.613-1.858c.409-.464.971-.67 1.635-.67s1.226.206 1.635.67.562 1.084.562 1.858m-3.679 0c0 .619.103 1.083.358 1.444.256.31.613.516 1.124.516.46 0 .869-.154 1.124-.516.256-.31.358-.825.358-1.444 0-.62-.102-1.084-.358-1.445-.255-.31-.613-.464-1.124-.464-.46 0-.868.155-1.073.464-.306.31-.409.774-.409 1.445M178.366 65.678v-3.25c0-.413-.102-.67-.256-.877q-.23-.31-.766-.31c-.46 0-.818.155-1.022.413q-.306.387-.306 1.238v2.735h-.716v-3.2c0-.412-.102-.67-.255-.876q-.23-.31-.767-.31c-.459 0-.817.155-1.022.413q-.306.387-.306 1.393v2.58h-.766v-4.902h.613l.102.671h.051c.153-.258.358-.413.613-.568.256-.154.562-.206.869-.206.766 0 1.277.258 1.481.826h.051q.23-.387.614-.62c.255-.154.613-.206.919-.206.562 0 .971.155 1.226.413.256.31.409.722.409 1.393v3.199h-.766zM182.913 65.73c-.306 0-.613-.052-.869-.155-.255-.103-.459-.31-.664-.567h-.051c.051.31.051.567.051.825v2.012h-.715v-7.12h.613l.102.671h.051c.205-.258.409-.464.665-.568.255-.103.562-.154.868-.154.664 0 1.124.206 1.482.67s.511 1.084.511 1.858c0 .825-.153 1.444-.511 1.909-.358.464-.92.619-1.533.619m-.102-4.437c-.511 0-.869.155-1.073.413s-.358.722-.358 1.341v.155c0 .67.102 1.186.358 1.496.204.31.613.464 1.124.464.409 0 .766-.154.971-.516.255-.36.357-.825.357-1.444 0-.62-.102-1.084-.357-1.393-.256-.361-.613-.516-1.022-.516M189.249 65.678l-.154-.722h-.051c-.255.31-.511.516-.715.62a2.5 2.5 0 0 1-.92.154c-.46 0-.868-.103-1.124-.361-.255-.258-.409-.62-.409-1.084 0-.98.767-1.496 2.351-1.547l.817-.052v-.31c0-.36-.102-.67-.255-.877s-.409-.258-.767-.258c-.408 0-.868.103-1.379.361l-.205-.567q.384-.232.767-.31c.306-.051.562-.103.868-.103.562 0 1.022.155 1.278.413.255.258.409.67.409 1.238v3.354h-.511zm-1.686-.567c.459 0 .817-.103 1.072-.361s.409-.62.409-1.084v-.464l-.715.051c-.562 0-1.022.104-1.277.258-.256.155-.409.413-.409.774a.86.86 0 0 0 .255.62c.154.154.358.206.665.206M194.613 65.678V62.48c0-.413-.102-.723-.255-.878-.204-.206-.46-.31-.869-.31-.511 0-.868.156-1.124.414-.255.258-.357.722-.357 1.393v2.58h-.716v-4.902h.613l.103.67h.051c.153-.257.357-.412.613-.567.255-.155.562-.206.919-.206.563 0 1.022.154 1.329.413.306.31.46.722.46 1.392v3.2zM196.095 60.725h.766l1.073 2.786c.256.62.358 1.084.46 1.393h.051c.051-.154.103-.412.256-.773q.153-.543 1.226-3.406h.766l-2.094 5.624c-.205.567-.46.929-.716 1.187a1.64 1.64 0 0 1-1.022.36c-.204 0-.459 0-.664-.05v-.62c.154.052.358.052.562.052.511 0 .869-.31 1.073-.877l.256-.723z"
}))), _defs$d || (_defs$d = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hblogo_blacktext_svg__b",
  x1: 2.307,
  x2: 47.974,
  y1: 50.928,
  y2: 3.858,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#505050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#595959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#82817F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hblogo_blacktext_svg__c",
  x1: 2.442,
  x2: 48.103,
  y1: 48.73,
  y2: 1.667,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#484848"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#605E5E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#82817F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hblogo_blacktext_svg__d",
  x1: 2.46,
  x2: 48.12,
  y1: 48.747,
  y2: 1.684,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#464627"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#55542E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7F7C3F"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "hblogo_blacktext_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h201v68H0z"
})))));
var hblogo_blacktext = "665f555efaf3cbc6.svg";

var _g$k, _defs$c;
function _extends$1F() { return _extends$1F = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1F.apply(null, arguments); }
const SvgHelpCenter = props => /*#__PURE__*/React.createElement("svg", _extends$1F({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, props), _g$k || (_g$k = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#help-center_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.858 5.516H8.442v1.108h6.416zM14.858 7.816H8.442v1.109h6.416z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.442 1.107a2.225 2.225 0 0 0-2.225 2.225v13.475-.016a2.235 2.235 0 0 0 2.225 2.1h13.333v-1.109c-.617 0-1.108-.5-1.108-1.108V16.6c0-.617.5-1.108 1.108-1.108V1.107zm2.166 1.117h10.059v12.15H6.608zM3.333 3.332c0-.616.5-1.108 1.109-1.108h1.05v12.15h-1.05a2.17 2.17 0 0 0-1.109.308zm12.525 14.442H4.442c-.617 0-1.109-.5-1.109-1.108v-.075c0-.617.5-1.109 1.109-1.109H15.85a2.2 2.2 0 0 0-.308 1.109v.075c0 .408.116.783.308 1.108z"
}))), _defs$c || (_defs$c = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "help-center_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
})))));

var _path$1q, _path2$H, _g$j;
function _extends$1E() { return _extends$1E = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1E.apply(null, arguments); }
const SvgHelp = props => /*#__PURE__*/React.createElement("svg", _extends$1E({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$1q || (_path$1q = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z",
  "data-name": "Rettangolo 12689"
})), _path2$H || (_path2$H = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18 4A14 14 0 1 1 4 18 14.015 14.015 0 0 1 18 4m0-2a16 16 0 1 0 16 16A16 16 0 0 0 18 2",
  "data-name": "Tracciato 9143"
})), _g$j || (_g$j = /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 10401"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 10399"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 10398",
  transform: "translate(-1024 -50)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  fill: "currentColor",
  "data-name": "Ellisse 3064",
  transform: "translate(1040.75 74.25)"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 10400"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.224 22.25h-2v-1.61a3.7 3.7 0 0 1 .228-1.318 4.5 4.5 0 0 1 .552-1.027 6.3 6.3 0 0 1 .722-.832q.347-.337.709-.675.333-.313.658-.651a4 4 0 0 0 .483-.617 3 3 0 0 0 .321-.692 2.6 2.6 0 0 0 .115-.817 3.1 3.1 0 0 0-.115-.858 3.3 3.3 0 0 0-.329-.781 3.26 3.26 0 0 0-3.676-1.507 3.3 3.3 0 0 0-.784.329 3.3 3.3 0 0 0-.661.513 3.2 3.2 0 0 0-.514.663 3.3 3.3 0 0 0-.329.781 3.2 3.2 0 0 0-.116.86h-2a5.2 5.2 0 0 1 .19-1.4 5.262 5.262 0 0 1 9.616-1.251 5.2 5.2 0 0 1 .529 1.251 5.2 5.2 0 0 1 .189 1.4 4.6 4.6 0 0 1-.213 1.436 5 5 0 0 1-.536 1.147 6 6 0 0 1-.727.928q-.36.375-.733.725c-.373.35-.462.436-.687.653a4.3 4.3 0 0 0-.489.565 2.4 2.4 0 0 0-.3.568 1.7 1.7 0 0 0-.1.607Z",
  "data-name": "Tracciato 9144"
})))));
var help = "data:image/svg+xml,%3Csvg%20%20id%3D%22help%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2236%22%20%20height%3D%2236%22%20%20viewBox%3D%220%200%2036%2036%22%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_12689%22%20%20%20%20data-name%3D%22Rettangolo%2012689%22%20%20%20%20width%3D%2236%22%20%20%20%20height%3D%2236%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20id%3D%22Tracciato_9143%22%20%20%20%20data-name%3D%22Tracciato%209143%22%20%20%20%20d%3D%22M1042%2C54a14%2C14%2C0%2C1%2C1-14%2C14%2C14.015%2C14.015%2C0%2C0%2C1%2C14-14m0-2a16%2C16%2C0%2C1%2C0%2C16%2C16%2C16%2C16%2C0%2C0%2C0-16-16Z%22%20%20%20%20transform%3D%22translate%28-1024%20-50%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cg%20%20%20%20id%3D%22Raggruppa_10401%22%20%20%20%20data-name%3D%22Raggruppa%2010401%22%20%20%20%20transform%3D%22translate%28-1024%20-50%29%22%20%20%3E%20%20%20%20%3Cg%20id%3D%22Raggruppa_10399%22%20data-name%3D%22Raggruppa%2010399%22%3E%20%20%20%20%20%20%3Cg%20id%3D%22Raggruppa_10398%22%20data-name%3D%22Raggruppa%2010398%22%3E%20%20%20%20%20%20%20%20%3Ccircle%20%20%20%20%20%20%20%20%20%20id%3D%22Ellisse_3064%22%20%20%20%20%20%20%20%20%20%20data-name%3D%22Ellisse%203064%22%20%20%20%20%20%20%20%20%20%20cx%3D%221.5%22%20%20%20%20%20%20%20%20%20%20cy%3D%221.5%22%20%20%20%20%20%20%20%20%20%20r%3D%221.5%22%20%20%20%20%20%20%20%20%20%20transform%3D%22translate%281040.75%2074.25%29%22%20%20%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%20%20%20%20%3Cg%20id%3D%22Raggruppa_10400%22%20data-name%3D%22Raggruppa%2010400%22%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20id%3D%22Tracciato_9144%22%20%20%20%20%20%20%20%20data-name%3D%22Tracciato%209144%22%20%20%20%20%20%20%20%20d%3D%22M1043.224%2C72.25h-2V70.64a3.7%2C3.7%2C0%2C0%2C1%2C.228-1.318%2C4.475%2C4.475%2C0%2C0%2C1%2C.552-1.027%2C6.265%2C6.265%2C0%2C0%2C1%2C.722-.832c.232-.225.467-.449.709-.675q.333-.313.658-.651a4.023%2C4.023%2C0%2C0%2C0%2C.483-.617%2C2.993%2C2.993%2C0%2C0%2C0%2C.321-.692%2C2.62%2C2.62%2C0%2C0%2C0%2C.115-.817%2C3.134%2C3.134%2C0%2C0%2C0-.115-.858%2C3.29%2C3.29%2C0%2C0%2C0-.329-.781%2C3.257%2C3.257%2C0%2C0%2C0-3.676-1.507%2C3.316%2C3.316%2C0%2C0%2C0-.784.329%2C3.257%2C3.257%2C0%2C0%2C0-.661.513%2C3.225%2C3.225%2C0%2C0%2C0-.514.663%2C3.308%2C3.308%2C0%2C0%2C0-.329.781%2C3.186%2C3.186%2C0%2C0%2C0-.116.86h-2a5.173%2C5.173%2C0%2C0%2C1%2C.19-1.4%2C5.262%2C5.262%2C0%2C0%2C1%2C9.616-1.251%2C5.244%2C5.244%2C0%2C0%2C1%2C.529%2C1.251%2C5.184%2C5.184%2C0%2C0%2C1%2C.189%2C1.4%2C4.633%2C4.633%2C0%2C0%2C1-.213%2C1.436%2C4.955%2C4.955%2C0%2C0%2C1-.536%2C1.147%2C5.922%2C5.922%2C0%2C0%2C1-.727.928c-.241.25-.484.491-.733.725s-.462.436-.687.653a4.262%2C4.262%2C0%2C0%2C0-.489.565%2C2.389%2C2.389%2C0%2C0%2C0-.3.568%2C1.712%2C1.712%2C0%2C0%2C0-.1.607Z%22%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _path$1p, _path2$G;
function _extends$1D() { return _extends$1D = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1D.apply(null, arguments); }
const SvgHistoryRedo = props => /*#__PURE__*/React.createElement("svg", _extends$1D({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Layer 1",
  viewBox: "0 0 36 36"
}, props), _path$1p || (_path$1p = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.78 12v-.03h9.1l-4.54-4.54 1.41-1.41 6.96 6.96-6.96 6.96-1.41-1.41 4.54-4.54h-8.59c-3.86 0-7 3.14-7 7s3.14 7 7 7v2c-4.96 0-9-4.04-9-9s3.77-8.71 8.49-8.97Z"
})), _path2$G || (_path2$G = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M36 36H0V0h36z"
})));

var _path$1o, _path2$F, _path3$e;
function _extends$1C() { return _extends$1C = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1C.apply(null, arguments); }
const SvgHistoryUndo = props => /*#__PURE__*/React.createElement("svg", _extends$1C({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Layer 1",
  viewBox: "0 0 36 36"
}, props), _path$1o || (_path$1o = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z"
})), _path2$F || (_path2$F = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.51 12.03V12h-9.1l4.54-4.54-1.41-1.41-6.96 6.96 6.96 6.96 1.41-1.41-4.54-4.54H19c3.86 0 7 3.14 7 7s-3.14 7-7 7v2c4.96 0 9-4.04 9-9s-3.77-8.71-8.49-8.97Z"
})), _path3$e || (_path3$e = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z"
})));

var _path$1n;
function _extends$1B() { return _extends$1B = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1B.apply(null, arguments); }
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends$1B({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$1n || (_path$1n = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M30 31.95H6V16.03L18.03 4 30 15.97zm-22-2h20V16.79l-9.97-9.97L8 16.86z"
})));
var home = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20%20version%3D%221.1%22%20%20id%3D%22IconDesign%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20%20x%3D%220px%22%20%20y%3D%220px%22%20%20width%3D%2236px%22%20%20height%3D%2236px%22%20%20viewBox%3D%220%200%2036%2036%22%20%20enable-background%3D%22new%200%200%2036%2036%22%20%20xml%3Aspace%3D%22preserve%22%3E%20%20%3Cpath%20%20%20%20fill%3D%22currentColor%22%20%20%20%20d%3D%22M30%2C31.95H6V16.03L18.03%2C4L30%2C15.97V31.95z%20M8%2C29.95h20V16.79l-9.97-9.97L8%2C16.86V29.95z%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$1m;
function _extends$1A() { return _extends$1A = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1A.apply(null, arguments); }
const SvgImage360Small = props => /*#__PURE__*/React.createElement("svg", _extends$1A({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18"
}, props), _path$1m || (_path$1m = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.489 16.131a7 7 0 0 0-.229-.09c-2.186-.8-2.275-2.064-2.278-2.207v-9.2h.011c0-.033-.01-.067-.01-.1 0-1.989 2.189-2.972 2.283-3.013l.7-.307v5.039a14.8 14.8 0 0 0 5.016.785 14 14 0 0 0 5.016-.91v-4.9l.7.294c.093.039 2.288.993 2.288 3.016 0 .034-.006.067-.007.1h.007l-.007 9.271c-.009.061-.275 1.514-2.452 2.311l-.129.05a14.6 14.6 0 0 1-5.417.944 14.2 14.2 0 0 1-5.492-1.083m.115-1.028q.102.036.255.1a13.2 13.2 0 0 0 5.122 1.011 13.6 13.6 0 0 0 5.058-.88l.138-.051c1.458-.536 1.76-1.354 1.8-1.512v-7.6a5.2 5.2 0 0 1-1.13.694l-.06.025a14.9 14.9 0 0 1-5.811 1.151 15.3 15.3 0 0 1-5.68-.968 5.8 5.8 0 0 1-1.321-.877v7.632s.124.722 1.629 1.275M1.981 4.534c0 .294.482.8.983 1.174V2.869a2.2 2.2 0 0 0-.983 1.665m13.015 1.12c.494-.325.984-.792.984-1.12a2.19 2.19 0 0 0-.984-1.674Zm-4.036 6.985-2.258 1.212-3.371-2.247-2.011 1.341v-1.2l2.011-1.341 3.426 2.284 2.2-1.183 3.194 1.716v1.135Zm1.429-2.886a1 1 0 0 1 1-1 1 1 0 0 1 1 1 1 1 0 0 1-1 1 1 1 0 0 1-.998-1Z",
  "data-name": "image-360-small"
})));

var _g$i;
function _extends$1z() { return _extends$1z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1z.apply(null, arguments); }
const SvgInfoCircleFill = props => /*#__PURE__*/React.createElement("svg", _extends$1z({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _g$i || (_g$i = /*#__PURE__*/React.createElement("g", {
  "data-name": "info-circle-fill"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z",
  "data-name": "container"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18 34A16.02 16.02 0 0 1 2 18 16.02 16.02 0 0 1 18 2a16.02 16.02 0 0 1 16 16 16.02 16.02 0 0 1-16 16m-3.8-20.01v3.6h2v8.2a2.8 2.8 0 0 0 2.8 2.8h3.8v-3.6h-3v-8.2a2.8 2.8 0 0 0-2.8-2.8ZM17 7.413a2.3 2.3 0 0 0-2.3 2.3 2.3 2.3 0 0 0 2.3 2.3 2.3 2.3 0 0 0 2.3-2.3 2.3 2.3 0 0 0-2.3-2.3",
  "data-name": "info"
}))));
var infoCircleFill = "data:image/svg+xml,%3Csvg%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2236%22%20%20height%3D%2236%22%20%20viewBox%3D%220%200%2036%2036%22%3E%20%20%3Cg%20%20%20%20id%3D%22info-circle-fill%22%20%20%20%20data-name%3D%22info-circle-fill%22%20%20%20%20transform%3D%22translate%28-182%20-198.846%29%22%20%20%3E%20%20%20%20%3Crect%20%20%20%20%20%20id%3D%22container%22%20%20%20%20%20%20data-name%3D%22container%22%20%20%20%20%20%20width%3D%2236%22%20%20%20%20%20%20height%3D%2236%22%20%20%20%20%20%20transform%3D%22translate%28182%20198.846%29%22%20%20%20%20%20%20fill%3D%22none%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22info%22%20%20%20%20%20%20data-name%3D%22info%22%20%20%20%20%20%20d%3D%22M2832-86.154a16.018%2C16.018%2C0%2C0%2C1-16-16%2C16.018%2C16.018%2C0%2C0%2C1%2C16-16%2C16.018%2C16.018%2C0%2C0%2C1%2C16%2C16A16.018%2C16.018%2C0%2C0%2C1%2C2832-86.154Zm-3.8-20.01v3.6h2v8.2a2.8%2C2.8%2C0%2C0%2C0%2C2.8%2C2.8h3.8v-3.6h-3v-8.2a2.8%2C2.8%2C0%2C0%2C0-2.8-2.8Zm2.8-6.577a2.3%2C2.3%2C0%2C0%2C0-2.3%2C2.3%2C2.3%2C2.3%2C0%2C0%2C0%2C2.3%2C2.3%2C2.3%2C2.3%2C0%2C0%2C0%2C2.3-2.3A2.3%2C2.3%2C0%2C0%2C0%2C2831-112.741Z%22%20%20%20%20%20%20transform%3D%22translate%28-2632%20319%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _path$1l;
function _extends$1y() { return _extends$1y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1y.apply(null, arguments); }
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends$1y({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$1l || (_path$1l = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.334 12c0-5.147-4.187-9.334-9.334-9.334S2.667 6.853 2.667 12 6.854 21.333 12 21.333c5.147 0 9.334-4.187 9.334-9.333m-20 0C1.334 6.106 6.107 1.333 12 1.333S22.667 6.106 22.667 12c0 5.893-4.774 10.666-10.667 10.666S1.334 17.893 1.334 12m10-4.32a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3.333 9.986h-2c-.733 0-1.333-.6-1.333-1.333v-5.667a.33.33 0 0 0-.334-.333h-1V9h1.334c.733 0 1.333.6 1.333 1.333v5.673c0 .187.146.327.333.327h1.667z",
  clipRule: "evenodd"
})));
var info = "data:image/svg+xml,%3Csvg%20%20width%3D%2224%22%20%20height%3D%2224%22%20%20viewBox%3D%220%200%2024%2024%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M21.3335%2011.9997C21.3335%206.85301%2017.1468%202.66634%2012.0002%202.66634C6.8535%202.66634%202.66683%206.85301%202.66683%2011.9997C2.66683%2017.1463%206.8535%2021.333%2012.0002%2021.333C17.1468%2021.333%2021.3335%2017.1463%2021.3335%2011.9997ZM1.3335%2011.9997C1.3335%206.10634%206.10683%201.33301%2012.0002%201.33301C17.8935%201.33301%2022.6668%206.10634%2022.6668%2011.9997C22.6668%2017.893%2017.8935%2022.6663%2012.0002%2022.6663C6.10683%2022.6663%201.3335%2017.893%201.3335%2011.9997ZM11.3335%207.67969C11.8858%207.67969%2012.3335%207.23197%2012.3335%206.67969C12.3335%206.1274%2011.8858%205.67969%2011.3335%205.67969C10.7812%205.67969%2010.3335%206.1274%2010.3335%206.67969C10.3335%207.23197%2010.7812%207.67969%2011.3335%207.67969ZM14.6668%2017.6663H12.6668C11.9335%2017.6663%2011.3335%2017.0663%2011.3335%2016.333V10.6663C11.3335%2010.4797%2011.1868%2010.333%2011.0002%2010.333H10.0002V8.99967H11.3335C12.0668%208.99967%2012.6668%209.59967%2012.6668%2010.333V16.0063C12.6668%2016.193%2012.8135%2016.333%2013.0002%2016.333H14.6668V17.6663Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$1k, _g$h;
function _extends$1x() { return _extends$1x = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1x.apply(null, arguments); }
const SvgInprogress = props => /*#__PURE__*/React.createElement("svg", _extends$1x({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16"
}, props), _path$1k || (_path$1k = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h16v16H0z"
})), _g$h || (_g$h = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 17991"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  stroke: "currentColor",
  "data-name": "Ellipse 3499",
  transform: "translate(3 3)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 4.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13 8a5 5 0 0 1-5 5V3a5 5 0 0 1 5 5",
  "data-name": "Intersection 1"
}))));
var inprogress = "data:image/svg+xml,%3Csvg%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2216%22%20%20height%3D%2216%22%20%20viewBox%3D%220%200%2016%2016%22%3E%20%20%3Cg%20id%3D%22inprogress%22%20transform%3D%22translate%28-3025%204788%29%22%3E%20%20%20%20%3Crect%20%20%20%20%20%20id%3D%22Rectangle%22%20%20%20%20%20%20width%3D%2216%22%20%20%20%20%20%20height%3D%2216%22%20%20%20%20%20%20transform%3D%22translate%283025%20-4788%29%22%20%20%20%20%20%20fill%3D%22none%22%20%20%20%20%2F%3E%20%20%20%20%3Cg%20%20%20%20%20%20id%3D%22Group_17991%22%20%20%20%20%20%20data-name%3D%22Group%2017991%22%20%20%20%20%20%20transform%3D%22translate%282703%20-712.5%29%22%20%20%20%20%3E%20%20%20%20%20%20%3Cg%20%20%20%20%20%20%20%20id%3D%22Ellipse_3499%22%20%20%20%20%20%20%20%20data-name%3D%22Ellipse%203499%22%20%20%20%20%20%20%20%20transform%3D%22translate%28325%20-4072.5%29%22%20%20%20%20%20%20%20%20fill%3D%22%23fff%22%20%20%20%20%20%20%20%20stroke%3D%22currentColor%22%20%20%20%20%20%20%20%20stroke-width%3D%221%22%20%20%20%20%20%20%3E%20%20%20%20%20%20%20%20%3Ccircle%20cx%3D%225%22%20cy%3D%225%22%20r%3D%225%22%20stroke%3D%22none%22%20%2F%3E%20%20%20%20%20%20%20%20%3Ccircle%20cx%3D%225%22%20cy%3D%225%22%20r%3D%224.5%22%20fill%3D%22none%22%20%2F%3E%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20id%3D%22Intersection_1%22%20%20%20%20%20%20%20%20data-name%3D%22Intersection%201%22%20%20%20%20%20%20%20%20d%3D%22M0%2C7.5a5%2C5%2C0%2C0%2C1%2C5-5v10A5%2C5%2C0%2C0%2C1%2C0%2C7.5Z%22%20%20%20%20%20%20%20%20transform%3D%22translate%28335%20-4060%29%20rotate%28180%29%22%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _path$1j;
function _extends$1w() { return _extends$1w = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1w.apply(null, arguments); }
const SvgIntensityPano = props => /*#__PURE__*/React.createElement("svg", _extends$1w({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path$1j || (_path$1j = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.989 4.54c0-2.02-2.2-2.98-2.29-3.02l-.7-.29v4.9c-1.6.61-3.3.92-5.02.91-1.7.03-3.4-.24-5.02-.78V1.21l-.7.31c-.09.04-2.28 1.02-2.28 3.01v.1h-.01v9.2c0 .14.09 1.41 2.28 2.21.06.02.14.05.23.09 1.74.72 3.61 1.09 5.49 1.08 1.85.03 3.69-.29 5.42-.94l.13-.05c2.18-.8 2.44-2.25 2.45-2.31V4.54zM2.959 2.87v2.84c-.5-.37-.98-.88-.98-1.17.05-.68.42-1.29.98-1.67m.9 12.33c-.1-.04-.19-.08-.25-.1-1.5-.55-1.63-1.27-1.63-1.27V6.2c.4.35.84.65 1.32.88a15.3 15.3 0 0 0 5.68.97v8.17c-1.76 0-3.5-.34-5.12-1.01z"
})));

var _path$1i, _path2$E, _path3$d;
function _extends$1v() { return _extends$1v = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1v.apply(null, arguments); }
const SvgLayers = props => /*#__PURE__*/React.createElement("svg", _extends$1v({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 36 37"
}, props), _path$1i || (_path$1i = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m29 10.108-10.81 4.73a.5.5 0 0 1-.4 0l-10.809-4.73 10.809-4.73a.5.5 0 0 1 .4 0zm-27 0 15.2 6.65a2 2 0 0 0 1.6 0l15.2-6.65-15.2-6.65a2 2 0 0 0-1.6 0z"
})), _path2$E || (_path2$E = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m24.643 16.2 4.353 1.9-10.811 4.73a.5.5 0 0 1-.4 0L6.974 18.1l4.373-1.913-2.489-1.09-6.862 3 15.2 6.65a2 2 0 0 0 1.6 0l15.2-6.65-6.853-3z"
})), _path3$d || (_path3$d = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m24.643 24.3 4.353 1.9-10.811 4.73a.5.5 0 0 1-.4 0L6.974 26.2l4.373-1.913-2.489-1.089-6.862 3 15.2 6.65a2 2 0 0 0 1.6 0l15.2-6.65-6.853-3z"
})));

var _path$1h;
function _extends$1u() { return _extends$1u = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1u.apply(null, arguments); }
const SvgLayoutSheetSmall = props => /*#__PURE__*/React.createElement("svg", _extends$1u({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18"
}, props), _path$1h || (_path$1h = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1.5 2.5v8.25h6.75v4.75h8.25v-13Zm14 5.25h-3v1h3v5.75H9.25V8h-1v1.75H2.5V3.5h5.75v2h1v-2h6.25Z",
  "data-name": "layout-sheet-small"
})));

var _path$1g;
function _extends$1t() { return _extends$1t = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1t.apply(null, arguments); }
const SvgLength = props => /*#__PURE__*/React.createElement("svg", _extends$1t({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path$1g || (_path$1g = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 5H1v8h1zm15 0h-1v8h1zM3 8.5h12v1H3z",
  clipRule: "evenodd"
})));
var length = "data:image/svg+xml,%3Csvg%20%20width%3D%2218%22%20%20height%3D%2218%22%20%20viewBox%3D%220%200%2018%2018%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M2%205.00049H1V13.0005H2V5.00049ZM17%205.00049H16V13.0005H17V5.00049ZM3%208.50049H15V9.50049H3V8.50049Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _g$g, _path$1f;
function _extends$1s() { return _extends$1s = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1s.apply(null, arguments); }
const SvgLinkiconHorizontal = props => /*#__PURE__*/React.createElement("svg", _extends$1s({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Raggruppa 11821",
  viewBox: "0 0 36 36"
}, props), _g$g || (_g$g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Force Correspondence"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  "data-name": "Raggruppa 10159"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 16v5a2.006 2.006 0 0 0 2 2h7.856a3.96 3.96 0 0 1-.556-2H6.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5H19a.5.5 0 0 1 .5.5V19h2v-3a2.006 2.006 0 0 0-2-2H6a2.006 2.006 0 0 0-2 2",
  "data-name": "Tracciato 8881"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.3 16a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H17.8a.5.5 0 0 1-.5-.5V18h-2v3a2.006 2.006 0 0 0 2 2h13.5a2.006 2.006 0 0 0 2-2v-5a2.006 2.006 0 0 0-2-2h-7.856a3.96 3.96 0 0 1 .556 2Z",
  "data-name": "Tracciato 8882"
})))), _path$1f || (_path$1f = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z",
  "data-name": "Rettangolo 13860"
})));
var linkiconHorizontal = "data:image/svg+xml,%3Csvg%20%20id%3D%22Raggruppa_11821%22%20%20data-name%3D%22Raggruppa%2011821%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2236%22%20%20height%3D%2236%22%20%20viewBox%3D%220%200%2036%2036%22%3E%20%20%3Cg%20%20%20%20id%3D%22Force_Correspondence%22%20%20%20%20data-name%3D%22Force%20Correspondence%22%20%20%20%20transform%3D%22translate%284%2023%29%20rotate%28-90%29%22%20%20%3E%20%20%20%20%3Cg%20id%3D%22Raggruppa_10159%22%20data-name%3D%22Raggruppa%2010159%22%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20id%3D%22Tracciato_8881%22%20%20%20%20%20%20%20%20data-name%3D%22Tracciato%208881%22%20%20%20%20%20%20%20%20d%3D%22M7%2C0H2A2.006%2C2.006%2C0%2C0%2C0%2C0%2C2V9.856A3.958%2C3.958%2C0%2C0%2C1%2C2%2C9.3V2.5A.5.5%2C0%2C0%2C1%2C2.5%2C2h4a.5.5%2C0%2C0%2C1%2C.5.5V15a.5.5%2C0%2C0%2C1-.5.5H4v2H7a2.006%2C2.006%2C0%2C0%2C0%2C2-2V2A2.006%2C2.006%2C0%2C0%2C0%2C7%2C0Z%22%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20id%3D%22Tracciato_8882%22%20%20%20%20%20%20%20%20data-name%3D%22Tracciato%208882%22%20%20%20%20%20%20%20%20d%3D%22M7%2C15a.5.5%2C0%2C0%2C1-.5.5h-4A.5.5%2C0%2C0%2C1%2C2%2C15V2.5A.5.5%2C0%2C0%2C1%2C2.5%2C2H5V0H2A2.006%2C2.006%2C0%2C0%2C0%2C0%2C2V15.5a2.006%2C2.006%2C0%2C0%2C0%2C2%2C2H7a2.006%2C2.006%2C0%2C0%2C0%2C2-2V7.644A3.959%2C3.959%2C0%2C0%2C1%2C7%2C8.2Z%22%20%20%20%20%20%20%20%20transform%3D%22translate%280%2011.3%29%22%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_13860%22%20%20%20%20data-name%3D%22Rettangolo%2013860%22%20%20%20%20width%3D%2236%22%20%20%20%20height%3D%2236%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$1e;
function _extends$1r() { return _extends$1r = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1r.apply(null, arguments); }
const SvgLocationMap = props => /*#__PURE__*/React.createElement("svg", _extends$1r({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path$1e || (_path$1e = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m8 10.031-.342-.413-.012-.015C7.483 9.4 5.938 7.478 4.924 5.009c-.56-1.36-.506-2.693.143-3.658C5.653.48 6.684 0 7.964 0h.076c1.28 0 2.307.48 2.893 1.347.65.964.702 2.297.142 3.657-1.053 2.56-2.666 4.53-2.733 4.61L8 10.026zM7.969.89c-1 0-1.747.329-2.17.955-.48.712-.501 1.743-.057 2.823.716 1.742 1.733 3.226 2.253 3.937.525-.71 1.538-2.195 2.254-3.937.444-1.08.422-2.111-.058-2.823C9.769 1.218 9.022.89 8.031.89zM8 4.969a1.557 1.557 0 0 1-1.555-1.556c0-.857.697-1.555 1.555-1.555s1.556.698 1.556 1.555c0 .858-.698 1.556-1.556 1.556m0-2.222A.666.666 0 1 0 8 4.08a.666.666 0 1 0 0-1.333m4.631 3.484a.89.89 0 0 1 .871.72v-.004l1.6 8.169H.893l1.6-8.17a.886.886 0 0 1 .871-.72h1.13q.219.462.453.89h-1.4a.224.224 0 0 0-.218.177l-1.285 6.574 4.036-.81 1.204-1.804H9.52l1.973-2.96 1.427.29-.253-1.285a.224.224 0 0 0-.218-.178h-1.4c.151-.284.306-.582.453-.889zm-5.107 5.471-1.173 1.76-3.835.77h11.51l-1.013-5.174-1.315-.262-1.938 2.906z",
  clipRule: "evenodd"
})));
var locationMap = "data:image/svg+xml,%3Csvg%20%20width%3D%2216%22%20%20height%3D%2216%22%20%20viewBox%3D%220%200%2016%2016%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M7.99989%2010.0311L7.65766%209.61778L7.64575%209.60291L7.64574%209.6029C7.48276%209.40015%205.93792%207.47844%204.92433%205.00889C4.36433%203.64889%204.41766%202.31556%205.06655%201.35111C5.65322%200.48%206.68433%200%207.96433%200H8.03989C9.31989%200%2010.3466%200.48%2010.9332%201.34667C11.5821%202.31111%2011.6354%203.64444%2011.0754%205.00444C10.0221%207.56444%208.40878%209.53333%208.34211%209.61333L7.99989%2010.0267V10.0311ZM7.96878%200.888889C6.96878%200.888889%206.22211%201.21778%205.79989%201.84444C5.31989%202.55556%205.29766%203.58667%205.74211%204.66667C6.45766%206.40889%207.47544%207.89333%207.99544%208.60444C8.51989%207.89333%209.53322%206.40889%2010.2488%204.66667C10.6932%203.58667%2010.671%202.55556%2010.191%201.84444C9.76878%201.21778%209.02211%200.888889%208.031%200.888889H7.96878ZM8.00008%204.96889C7.1423%204.96889%206.44453%204.27111%206.44453%203.41333C6.44453%202.55555%207.1423%201.85777%208.00008%201.85777C8.85786%201.85777%209.55564%202.55555%209.55564%203.41333C9.55564%204.27111%208.85786%204.96889%208.00008%204.96889ZM8.00008%202.74666C7.63119%202.74666%207.33342%203.04444%207.33342%203.41333C7.33342%203.78222%207.63119%204.08%208.00008%204.08C8.36897%204.08%208.66675%203.78222%208.66675%203.41333C8.66675%203.04444%208.36897%202.74666%208.00008%202.74666ZM12.6311%206.23112C13.0533%206.23112%2013.4222%206.53334%2013.5022%206.95112V6.94667L15.1022%2015.1156H0.893311L2.49331%206.94667C2.57331%206.52889%202.93776%206.22667%203.36442%206.22667H4.49331C4.63998%206.53334%204.79109%206.83112%204.94664%207.11556H3.54664C3.43998%207.11556%203.35109%207.19112%203.32887%207.29334L2.04442%2013.8667L6.07998%2013.0578L7.28442%2011.2533H9.51998L11.4933%208.29334L12.92%208.58223L12.6666%207.29778C12.6444%207.19556%2012.5555%207.12%2012.4489%207.12H11.0489C11.2%206.83556%2011.3555%206.53778%2011.5022%206.23112H12.6311ZM7.52442%2011.7022L6.35109%2013.4622L2.51553%2014.2311H14.0266L13.0133%209.05778L11.6978%208.79556L9.75998%2011.7022H7.52442Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$1d, _path2$D;
function _extends$1q() { return _extends$1q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1q.apply(null, arguments); }
const SvgLockRotation = props => /*#__PURE__*/React.createElement("svg", _extends$1q({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$1d || (_path$1d = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.78 9.633h-.013l-.007-.006c-.06.166-.12.333-.167.506H4.22C5.053 6.6 8.213 3.967 12 3.967c2.78 0 5.213 1.42 6.647 3.573V3.58h1.333v6.56h-6.56V8.807h4.413A6.66 6.66 0 0 0 12 5.347c-2.84 0-5.26 1.786-6.22 4.286m.386 5.554A6.66 6.66 0 0 0 12 18.647v.006c.46 0 .907-.053 1.34-.14v1.4a8 8 0 0 1-1.34.114c-2.78 0-5.213-1.42-6.646-3.574v3.96H4.02v-6.56h6.56v1.334z",
  clipRule: "evenodd",
  opacity: 0.4
})), _path2$D || (_path2$D = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M23.334 16.167H22.06v-.774a2.73 2.73 0 0 0-2.727-2.726 2.734 2.734 0 0 0-2.727 2.726v.774h-1.266c-.367 0-.667.3-.667.666V24H24v-7.167c0-.366-.3-.666-.667-.666m-5.393-.774c0-.766.626-1.393 1.393-1.393s1.393.627 1.393 1.393v.774h-2.786zm4.726 7.274h-6.66V17.5h6.66z"
})));

var _defs$b, _g$f;
function _extends$1p() { return _extends$1p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1p.apply(null, arguments); }
const SvgMapLarge = props => /*#__PURE__*/React.createElement("svg", _extends$1p({
  xmlns: "http://www.w3.org/2000/svg",
  id: "map-large_svg__Livello_2",
  width: "1em",
  height: "1em",
  "data-name": "Livello 2",
  viewBox: "0 0 36 36"
}, props), _defs$b || (_defs$b = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".map-large_svg__map-large-1{fill:none}.map-large_svg__map-large-2{fill:currentColor}"))), _g$f || (_g$f = /*#__PURE__*/React.createElement("g", {
  id: "map-large_svg__FinalDesign"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.256.869h33.466v33.466H1.256z",
  className: "map-large_svg__map-large-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.368 6.855 30 9.305v17.098l-7.034-2.26-.887-.285-.788.494-7.682 4.82L6 27.075V9.957l7.097 1.951.848.234.745-.468zm-.274-2.188L13.627 9.98 4 7.333V28.6l9.927 2.733 8.427-5.286 9.646 3.1v-21.3z",
  className: "map-large_svg__map-large-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h36v36H0z",
  className: "map-large_svg__map-large-1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 14,
  r: 2.5,
  className: "map-large_svg__map-large-2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 22,
  r: 2.5,
  className: "map-large_svg__map-large-2"
}))));
var mapLarge = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20%20id%3D%22Livello_2%22%20%20data-name%3D%22Livello%202%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2236%22%20%20height%3D%2236%22%20%20viewBox%3D%220%200%2036%2036%22%3E%20%20%3Cdefs%3E%20%20%20%20%3Cstyle%3E%20%20%20%20%20%20.map-large-1%20%7B%20%20%20%20%20%20%20%20fill%3A%20none%3B%20%20%20%20%20%20%7D%20%20%20%20%20%20.map-large-2%20%7B%20%20%20%20%20%20%20%20fill%3A%20currentColor%3B%20%20%20%20%20%20%7D%20%20%20%20%3C%2Fstyle%3E%20%20%3C%2Fdefs%3E%20%20%3Cg%20id%3D%22FinalDesign%22%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%3Crect%20%20%20%20%20%20%20%20class%3D%22map-large-1%22%20%20%20%20%20%20%20%20x%3D%221.2564102564%22%20%20%20%20%20%20%20%20y%3D%22.8688844904%22%20%20%20%20%20%20%20%20width%3D%2233.466393104%22%20%20%20%20%20%20%20%20height%3D%2233.466393104%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20class%3D%22map-large-2%22%20%20%20%20%20%20%20%20d%3D%22M22.3681640625%2C6.8554000854l7.6318359375%2C2.449760437V26.403213501l-7.0341796875-2.2606506348-.88671875-.2848052979-.7880859375%2C.4947052002-7.681640625%2C4.8190155029-7.609375-2.095199585V9.9573822021l7.0966796875%2C1.9510650635%2C.8486328125%2C.2331848145%2C.7451171875-.4675750732%2C7.677734375-4.8186569214m-.2744140625-2.1887435913l-8.466796875%2C5.3133392334L4%2C7.3333435059V28.6000061035l9.9267578125%2C2.7333221436%2C8.4267578125-5.2866668701%2C9.646484375%2C3.1000061035V7.8466567993l-9.90625-3.1800003052h0Z%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Crect%20class%3D%22map-large-1%22%20width%3D%2236%22%20height%3D%2236%22%20%2F%3E%20%20%20%20%20%20%3Ccircle%20class%3D%22map-large-2%22%20cx%3D%2223%22%20cy%3D%2214%22%20r%3D%222.5%22%20%2F%3E%20%20%20%20%20%20%3Ccircle%20class%3D%22map-large-2%22%20cx%3D%2212%22%20cy%3D%2222%22%20r%3D%222.5%22%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _path$1c, _path2$C, _path3$c;
function _extends$1o() { return _extends$1o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1o.apply(null, arguments); }
const SvgMapPlaceholderDefault = props => /*#__PURE__*/React.createElement("svg", _extends$1o({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 300 300"
}, props), _path$1c || (_path$1c = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M150 300c82.843 0 150-67.157 150-150S232.843 0 150 0 0 67.157 0 150s67.157 150 150 150"
})), _path2$C || (_path2$C = /*#__PURE__*/React.createElement("path", {
  fill: "#1F65F0",
  d: "M150 276c69.588 0 126-56.412 126-126S219.588 24 150 24 24 80.412 24 150s56.412 126 126 126"
})), _path3$c || (_path3$c = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M150 190c22.091 0 40-17.909 40-40s-17.909-40-40-40-40 17.909-40 40 17.909 40 40 40"
})));
var mapPlaceholderDefault = "data:image/svg+xml,%3Csvg%20%20width%3D%22300%22%20%20height%3D%22300%22%20%20viewBox%3D%220%200%20300%20300%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20d%3D%22M150%20300C232.843%20300%20300%20232.843%20300%20150C300%2067.1573%20232.843%200%20150%200C67.1573%200%200%2067.1573%200%20150C0%20232.843%2067.1573%20300%20150%20300Z%22%20%20%20%20fill%3D%22white%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M150%20276C219.588%20276%20276%20219.588%20276%20150C276%2080.4121%20219.588%2024%20150%2024C80.4121%2024%2024%2080.4121%2024%20150C24%20219.588%2080.4121%20276%20150%20276Z%22%20%20%20%20fill%3D%22%231F65F0%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M150%20190C172.091%20190%20190%20172.091%20190%20150C190%20127.909%20172.091%20110%20150%20110C127.909%20110%20110%20127.909%20110%20150C110%20172.091%20127.909%20190%20150%20190Z%22%20%20%20%20fill%3D%22white%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$1b, _path2$B, _path3$b;
function _extends$1n() { return _extends$1n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1n.apply(null, arguments); }
const SvgMapPlaceholderHover = props => /*#__PURE__*/React.createElement("svg", _extends$1n({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 300 300"
}, props), _path$1b || (_path$1b = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M150 300c82.843 0 150-67.157 150-150S232.843 0 150 0 0 67.157 0 150s67.157 150 150 150"
})), _path2$B || (_path2$B = /*#__PURE__*/React.createElement("path", {
  fill: "#082A6E",
  d: "M150 276c69.588 0 126-56.412 126-126S219.588 24 150 24 24 80.412 24 150s56.412 126 126 126"
})), _path3$b || (_path3$b = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M150 190c22.091 0 40-17.909 40-40s-17.909-40-40-40-40 17.909-40 40 17.909 40 40 40"
})));
var mapPlaceholderHover = "data:image/svg+xml,%3Csvg%20%20width%3D%22300%22%20%20height%3D%22300%22%20%20viewBox%3D%220%200%20300%20300%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20d%3D%22M150%20300C232.843%20300%20300%20232.843%20300%20150C300%2067.1573%20232.843%200%20150%200C67.1573%200%200%2067.1573%200%20150C0%20232.843%2067.1573%20300%20150%20300Z%22%20%20%20%20fill%3D%22white%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M150%20276C219.588%20276%20276%20219.588%20276%20150C276%2080.4121%20219.588%2024%20150%2024C80.4121%2024%2024%2080.4121%2024%20150C24%20219.588%2080.4121%20276%20150%20276Z%22%20%20%20%20fill%3D%22%23082A6E%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M150%20190C172.091%20190%20190%20172.091%20190%20150C190%20127.909%20172.091%20110%20150%20110C127.909%20110%20110%20127.909%20110%20150C110%20172.091%20127.909%20190%20150%20190Z%22%20%20%20%20fill%3D%22white%22%20%20%2F%3E%3C%2Fsvg%3E";

var _circle$3, _circle2$2, _circle3$2;
function _extends$1m() { return _extends$1m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1m.apply(null, arguments); }
const SvgMapPlaceholderSelectedHover = props => /*#__PURE__*/React.createElement("svg", _extends$1m({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 1101.4 1101.4"
}, props), _circle$3 || (_circle$3 = /*#__PURE__*/React.createElement("circle", {
  cx: 550.7,
  cy: 550.7,
  r: 550,
  fill: "#FFF"
})), _circle2$2 || (_circle2$2 = /*#__PURE__*/React.createElement("circle", {
  cx: 550.7,
  cy: 550.7,
  r: 450,
  fill: "#0077b3"
})), _circle3$2 || (_circle3$2 = /*#__PURE__*/React.createElement("circle", {
  cx: 550.7,
  cy: 550.7,
  r: 265,
  fill: "#FFF"
})));
var mapPlaceholderSelectedHover = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20%20version%3D%221.1%22%20%20id%3D%22Layer_1%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20%20x%3D%220px%22%20%20y%3D%220px%22%20%20height%3D%221101.4%22%20%20width%3D%221101.4%22%20%20viewBox%3D%220%200%201101.4%201101.4%22%20%20style%3D%22enable-background%3A%20new%200%200%201101.4%201101.4%22%20%20xml%3Aspace%3D%22preserve%22%3E%20%20%3Cg%20fill%3D%22%23FFFFFF%22%3E%20%20%20%20%3Ccircle%20cx%3D%22550.7%22%20cy%3D%22550.7%22%20r%3D%22550%22%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%20fill%3D%22%230077b3%22%3E%20%20%20%20%3Ccircle%20cx%3D%22550.7%22%20cy%3D%22550.7%22%20r%3D%22450%22%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%20fill%3D%22%23FFFFFF%22%3E%20%20%20%20%3Ccircle%20cx%3D%22550.7%22%20cy%3D%22550.7%22%20r%3D%22265%22%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _circle$2, _circle2$1, _circle3$1;
function _extends$1l() { return _extends$1l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1l.apply(null, arguments); }
const SvgMapPlaceholderSelected = props => /*#__PURE__*/React.createElement("svg", _extends$1l({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 1101.4 1101.4"
}, props), _circle$2 || (_circle$2 = /*#__PURE__*/React.createElement("circle", {
  cx: 550.7,
  cy: 550.7,
  r: 550,
  fill: "#FFF"
})), _circle2$1 || (_circle2$1 = /*#__PURE__*/React.createElement("circle", {
  cx: 550.7,
  cy: 550.7,
  r: 450,
  fill: "#01426a"
})), _circle3$1 || (_circle3$1 = /*#__PURE__*/React.createElement("circle", {
  cx: 550.7,
  cy: 550.7,
  r: 265,
  fill: "#FFF"
})));
var mapPlaceholderSelected = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20%20version%3D%221.1%22%20%20id%3D%22Layer_1%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20%20x%3D%220px%22%20%20y%3D%220px%22%20%20width%3D%221101.4%22%20%20height%3D%221101.4%22%20%20viewBox%3D%220%200%201101.4%201101.4%22%20%20style%3D%22enable-background%3A%20new%200%200%201101.4%201101.4%22%20%20xml%3Aspace%3D%22preserve%22%3E%20%20%3Cg%20fill%3D%22%23FFFFFF%22%3E%20%20%20%20%3Ccircle%20cx%3D%22550.7%22%20cy%3D%22550.7%22%20r%3D%22550%22%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%20fill%3D%22%2301426a%22%3E%20%20%20%20%3Ccircle%20cx%3D%22550.7%22%20cy%3D%22550.7%22%20r%3D%22450%22%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%20fill%3D%22%23FFFFFF%22%3E%20%20%20%20%3Ccircle%20cx%3D%22550.7%22%20cy%3D%22550.7%22%20r%3D%22265%22%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _path$1a, _path2$A, _path3$a;
function _extends$1k() { return _extends$1k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1k.apply(null, arguments); }
const SvgMarkupPolygon = props => /*#__PURE__*/React.createElement("svg", _extends$1k({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 28 29"
}, props), _path$1a || (_path$1a = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.533 28.128a2.89 2.89 0 0 1-2.885-2.875l-.047-10.59a14 14 0 0 1-.024-.803c0-3.548 1.382-6.883 3.89-9.392A13.2 13.2 0 0 1 13.86.578c3.548 0 6.883 1.382 9.392 3.89a13.2 13.2 0 0 1 3.89 9.392c0 3.493-1.345 6.792-3.788 9.289a13.2 13.2 0 0 1-9.162 3.989c-.696.066-1.572.131-2.603.193-2.654.16-7.7.774-7.751.78l-.006.001h-.006q-.146.016-.292.016"
})), _path2$A || (_path2$A = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3.533 27.55q.115 0 .234-.012s5.084-.62 7.787-.784a75 75 0 0 0 2.603-.194c6.879-.158 12.407-5.784 12.407-12.7 0-7.017-5.688-12.705-12.705-12.705-7.016 0-12.704 5.688-12.704 12.704q0 .396.024.785l.047 10.606a2.31 2.31 0 0 0 2.307 2.3m0 1.154A3.47 3.47 0 0 1 .07 25.255L.024 14.681A14 14 0 0 1 0 13.86c0-3.702 1.442-7.182 4.06-9.8A13.77 13.77 0 0 1 13.86 0c3.701 0 7.182 1.442 9.8 4.06a13.77 13.77 0 0 1 4.059 9.8c0 3.645-1.404 7.087-3.954 9.692a13.78 13.78 0 0 1-9.538 4.162c-.7.066-1.576.131-2.604.193-2.636.159-7.665.77-7.716.777l-.024.003a4 4 0 0 1-.35.017"
})), _path3$a || (_path3$a = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.5 21a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15"
})));
var markupPolygon = "data:image/svg+xml,%3Csvg%20%20width%3D%2228%22%20%20height%3D%2229%22%20%20viewBox%3D%220%200%2028%2029%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20d%3D%22M3.53253%2028.1275C1.94931%2028.1276%200.655341%2026.8381%200.648088%2025.253L0.601383%2014.6636C0.585462%2014.3973%200.577393%2014.127%200.577393%2013.8599C0.577393%2010.3123%201.95895%206.9769%204.46755%204.46829C6.97616%201.95968%2010.3115%200.578125%2013.8592%200.578125C17.4069%200.578125%2020.7423%201.95968%2023.2509%204.46829C25.7595%206.9769%2027.141%2010.3123%2027.141%2013.8599C27.141%2017.3533%2025.7956%2020.652%2023.3525%2023.1485C20.9183%2025.636%2017.6656%2027.0521%2014.1915%2027.1376C13.4952%2027.2041%2012.6195%2027.2691%2011.5882%2027.3309C8.93421%2027.4912%203.88768%2028.1053%203.83702%2028.1115L3.83092%2028.1122L3.82481%2028.1128C3.72787%2028.1226%203.62952%2028.1275%203.53253%2028.1275Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M3.53261%2027.5494C3.61004%2027.5494%203.68832%2027.5455%203.76714%2027.5376C3.76714%2027.5376%208.85116%2026.9171%2011.5538%2026.7539C12.7787%2026.6804%2013.612%2026.6125%2014.1573%2026.5602C21.0358%2026.4016%2026.5636%2020.7759%2026.5636%2013.8593C26.5636%206.84291%2020.8757%201.15496%2013.8593%201.15496C6.84291%201.15496%201.15496%206.84291%201.15496%2013.8593C1.15496%2014.1231%201.16302%2014.3846%201.17888%2014.6444L1.22565%2025.2498C1.23152%2026.5333%202.27755%2027.5494%203.53261%2027.5494ZM3.53264%2028.7044C3.53265%2028.7044%203.53262%2028.7044%203.53264%2028.7044C1.63247%2028.7044%200.079404%2027.1571%200.0706953%2025.255L0.0240718%2014.6814C0.0080935%2014.4088%200%2014.1324%200%2013.8593C0%2010.1574%201.44162%206.67699%204.05931%204.05931C6.67699%201.44162%2010.1574%200%2013.8593%200C17.5612%200%2021.0416%201.44162%2023.6593%204.05931C26.277%206.67699%2027.7186%2010.1574%2027.7186%2013.8593C27.7186%2017.5045%2026.3146%2020.9467%2023.7653%2023.5518C21.2302%2026.1424%2017.8441%2027.6195%2014.2265%2027.7138C13.5267%2027.7802%2012.6511%2027.8451%2011.6229%2027.9068C8.98653%2028.0659%203.95757%2028.6779%203.90707%2028.6841L3.88266%2028.6868C3.76661%2028.6985%203.64884%2028.7044%203.53264%2028.7044Z%22%20%20%20%20fill%3D%22white%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M13.5%2021C17.6421%2021%2021%2017.6421%2021%2013.5C21%209.35786%2017.6421%206%2013.5%206C9.35786%206%206%209.35786%206%2013.5C6%2017.6421%209.35786%2021%2013.5%2021Z%22%20%20%20%20fill%3D%22white%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$19;
function _extends$1j() { return _extends$1j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1j.apply(null, arguments); }
const SvgMeasurePoint = props => /*#__PURE__*/React.createElement("svg", _extends$1j({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 25 24"
}, props), _path$19 || (_path$19 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.77 12c0-4.414-3.587-8-8-8s-8 3.586-8 8 3.587 8 8 8 8-3.587 8-8M3.437 12c0-5.154 4.18-9.334 9.333-9.334s9.333 4.18 9.333 9.333-4.18 9.334-9.333 9.334-9.333-4.18-9.333-9.334m10.668 0a1.335 1.335 0 1 1-2.67 0 1.335 1.335 0 0 1 2.67 0",
  clipRule: "evenodd"
})));

var _path$18;
function _extends$1i() { return _extends$1i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1i.apply(null, arguments); }
const SvgMeasureShowAxes = props => /*#__PURE__*/React.createElement("svg", _extends$1i({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$18 || (_path$18 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 2.666a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.667 0m.954 1.347 15.033 15.033a2.65 2.65 0 0 0-.94.94L4.014 4.953c.386-.227.713-.553.94-.94m-1.62 2.5v1.333H2.001V6.513zm0 5.333v1.334H2.001v-1.334zm0 2.667v1.333H2.001v-1.333zM9.474 22v-1.334H8.141V22zm2.667-1.334V22h-1.334v-1.334zm-5.36 0H3.334v-3.46H2.001V22h4.78zm8.026 0V22h-1.333v-1.334zM17.474 22v-1.334h-1.333V22zM3.334 10.513V9.18H2.001v1.333zm18 12.153a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666",
  clipRule: "evenodd"
})));
var measureShowAxes = "data:image/svg+xml,%3Csvg%20%20width%3D%2224%22%20%20height%3D%2224%22%20%20viewBox%3D%220%200%2024%2024%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M4.00065%202.66634C4.00065%203.40272%203.4037%203.99967%202.66732%203.99967C1.93094%203.99967%201.33398%203.40272%201.33398%202.66634C1.33398%201.92996%201.93094%201.33301%202.66732%201.33301C3.4037%201.33301%204.00065%201.92996%204.00065%202.66634ZM4.95366%204.01302L19.987%2019.0464C19.6003%2019.273%2019.2737%2019.5997%2019.047%2019.9864L4.01367%204.95302C4.40034%204.72635%204.727%204.39969%204.95366%204.01302ZM3.33398%206.51302V7.84635H2.00065V6.51302H3.33398ZM3.33398%2011.8464V13.1797H2.00065V11.8464H3.33398ZM3.33398%2014.513V15.8464H2.00065V14.513H3.33398ZM9.47396%2021.9997V20.6663H8.14063V21.9997H9.47396ZM12.1406%2020.6663V21.9997H10.8073V20.6663H12.1406ZM6.78065%2020.6664H3.33398V17.2064H2.00065V21.9997H6.78065V20.6664ZM14.8073%2020.6663V21.9997H13.474V20.6663H14.8073ZM17.474%2021.9997V20.6663H16.1406V21.9997H17.474ZM3.33398%2010.513V9.17969H2.00065V10.513H3.33398ZM21.334%2022.6663C22.0704%2022.6663%2022.6673%2022.0694%2022.6673%2021.333C22.6673%2020.5966%2022.0704%2019.9997%2021.334%2019.9997C20.5976%2019.9997%2020.0007%2020.5966%2020.0007%2021.333C20.0007%2022.0694%2020.5976%2022.6663%2021.334%2022.6663Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _rect$1, _path$17, _g$e, _defs$a;
function _extends$1h() { return _extends$1h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1h.apply(null, arguments); }
const SvgMeasurementIcon = props => /*#__PURE__*/React.createElement("svg", _extends$1h({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _rect$1 || (_rect$1 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "#e93dc8",
  rx: 4
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#measurement-icon_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "measurement-icon_svg__b",
  width: 16,
  height: 16,
  x: 2,
  y: 2,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path$17 || (_path$17 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.5 2.5h-15v15h15z"
}))), _g$e || (_g$e = /*#__PURE__*/React.createElement("g", {
  mask: "url(#measurement-icon_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "F0F2F5",
  d: "M13.454 2.97 3.437 12.989l3.535 3.535L16.99 6.506zM4.615 12.989l1.498-1.497.79.79.295-.295-.79-.79L7.5 10.103l1.179 1.179.294-.295L7.795 9.81l1.093-1.093.79.79.294-.294-.79-.791 1.093-1.093 1.178 1.179.295-.295-1.178-1.178 1.093-1.093.79.79.294-.294-.79-.79 1.497-1.498 2.357 2.357-8.839 8.839z"
})))), _defs$a || (_defs$a = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "measurement-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2.5 2.5h15v15h-15z"
})))));

var _circle$1, _path$16, _g$d, _defs$9;
function _extends$1g() { return _extends$1g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1g.apply(null, arguments); }
const SvgMeasurementMarker = props => /*#__PURE__*/React.createElement("svg", _extends$1g({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _circle$1 || (_circle$1 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15,
  fill: "#29303D",
  stroke: "#fff",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#measurement-marker_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "measurement-marker_svg__b",
  width: 20,
  height: 20,
  x: 6,
  y: 6,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path$16 || (_path$16 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M26 6H6v20h20z"
}))), _g$d || (_g$d = /*#__PURE__*/React.createElement("g", {
  mask: "url(#measurement-marker_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F0F2F5",
  d: "M20.606 6.627 7.249 19.983l4.714 4.714L25.32 11.34zM8.82 19.983l1.996-1.996 1.054 1.054.393-.393-1.054-1.054 1.457-1.457 1.571 1.571.393-.392-1.572-1.571 1.458-1.458 1.054 1.054.392-.393-1.054-1.054 1.458-1.457 1.571 1.571.393-.392-1.572-1.572 1.459-1.457 1.053 1.054.392-.393-1.054-1.053 1.997-1.997 3.142 3.143-11.785 11.785z"
})))), _defs$9 || (_defs$9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "measurement-marker_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6 6h20v20H6z"
})))));

var _path$15, _path2$z;
function _extends$1f() { return _extends$1f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1f.apply(null, arguments); }
const SvgMeasures = props => /*#__PURE__*/React.createElement("svg", _extends$1f({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$15 || (_path$15 = /*#__PURE__*/React.createElement("path", {
  fill: "#363C4D",
  fillRule: "evenodd",
  d: "M4.667 22A2.666 2.666 0 0 1 2 19.333V12C2 6.487 6.487 2 12 2s10 4.487 10 10-4.487 10-10 10z",
  clipRule: "evenodd"
})), _path2$z || (_path2$z = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M21.334 11.999c0-5.147-4.187-9.334-9.333-9.334-5.147 0-9.334 4.187-9.334 9.334v7.333c0 1.1.9 2 2 2h7.334c5.146 0 9.333-4.187 9.333-9.333m-20 0c0-5.88 4.787-10.667 10.667-10.667s10.666 4.787 10.666 10.667-4.786 10.666-10.666 10.666H4.667a3.335 3.335 0 0 1-3.333-3.333zm4.667 3 3 3 .006-.007 9-9-3-3-.986.987.746.753-.746.747-.754-.747-.82.82 1.5 1.5-.746.747-1.5-1.5-.82.82.746.753-.746.747-.754-.747-.82.82 1.5 1.5-.746.747-1.5-1.5-.82.82.746.753-.746.747-.754-.747z",
  clipRule: "evenodd"
})));
var measures = "data:image/svg+xml,%3Csvg%20%20width%3D%2224%22%20%20height%3D%2224%22%20%20viewBox%3D%220%200%2024%2024%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M4.66667%2022C3.19333%2022%202%2020.8067%202%2019.3333V12C2%206.48667%206.48667%202%2012%202C17.5133%202%2022%206.48667%2022%2012C22%2017.5133%2017.5133%2022%2012%2022H4.66667Z%22%20%20%20%20fill%3D%22%23363C4D%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M21.334%2011.9987C21.334%206.85203%2017.1473%202.66536%2012.0007%202.66536C6.85398%202.66536%202.66732%206.85203%202.66732%2011.9987V19.332C2.66732%2020.432%203.56732%2021.332%204.66732%2021.332H12.0007C17.1473%2021.332%2021.334%2017.1454%2021.334%2011.9987ZM1.33398%2011.9987C1.33398%206.1187%206.12065%201.33203%2012.0007%201.33203C17.8807%201.33203%2022.6673%206.1187%2022.6673%2011.9987C22.6673%2017.8787%2017.8807%2022.6654%2012.0007%2022.6654H4.66732C2.82732%2022.6654%201.33398%2021.172%201.33398%2019.332V11.9987ZM6.00065%2014.9989L9.00065%2017.9989L9.00732%2017.9922L18.0073%208.99219L15.0073%205.99219L14.0207%206.97885L14.7673%207.73219L14.0207%208.47885L13.2673%207.73219L12.4473%208.55219L13.9473%2010.0522L13.2007%2010.7989L11.7007%209.29885L10.8807%2010.1189L11.6273%2010.8722L10.8807%2011.6189L10.1273%2010.8722L9.30732%2011.6922L10.8073%2013.1922L10.0607%2013.9389L8.56065%2012.4389L7.74065%2013.2589L8.48732%2014.0122L7.74065%2014.7589L6.98732%2014.0122L6.00065%2014.9989Z%22%20%20%20%20fill%3D%22white%22%20%20%2F%3E%3C%2Fsvg%3E";

var _defs$8, _path$14;
function _extends$1e() { return _extends$1e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1e.apply(null, arguments); }
const SvgModelDollhouse = props => /*#__PURE__*/React.createElement("svg", _extends$1e({
  xmlns: "http://www.w3.org/2000/svg",
  id: "model-dollhouse_svg__Livello_2",
  width: "1em",
  height: "1em",
  "data-name": "Livello 2",
  viewBox: "0 0 36 36"
}, props), _defs$8 || (_defs$8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".model-dollhouse_svg__model-dollhouse-2{fill:currentColor}"))), /*#__PURE__*/React.createElement("g", {
  id: "model-dollhouse_svg__FinalDesign"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h36v36H0z",
  style: {
    fill: "none"
  }
}), _path$14 || (_path$14 = /*#__PURE__*/React.createElement("path", {
  d: "M20 29.83v2.02c6.12-.88 10.96-5.72 11.84-11.84h-2.02c-.85 5.02-4.81 8.98-9.82 9.83ZM6.17 20H4.15c.88 6.12 5.72 10.96 11.84 11.84v-2.02c-5.02-.85-8.98-4.81-9.83-9.82ZM16 4.16C9.88 5.04 5.04 9.88 4.16 16h2.02c.85-5.02 4.81-8.98 9.82-9.83V4.15ZM20 4.16v2.02c5.01.85 8.97 4.81 9.82 9.83h2.02C30.96 9.89 26.12 5.05 20 4.17Z",
  className: "model-dollhouse_svg__model-dollhouse-2"
}))));

var _path$13;
function _extends$1d() { return _extends$1d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1d.apply(null, arguments); }
const SvgMoveElement = props => /*#__PURE__*/React.createElement("svg", _extends$1d({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path$13 || (_path$13 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 2.667H2.221v1.778h1.777zm1.333.444h8.444v.89H5.333zm9.769 7.09L11.99 7.088 8.88 10.2l.626.64 2.031-2.027V14.2h.907V8.813l2.036 2.027zm-4.8-2.645h-4.97v.889h4.08zm-8.08-.445h1.777V8.89H2.222z",
  clipRule: "evenodd"
})));

var _defs$7, _path$12, _path2$y;
function _extends$1c() { return _extends$1c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1c.apply(null, arguments); }
const SvgNonVisible = props => /*#__PURE__*/React.createElement("svg", _extends$1c({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _defs$7 || (_defs$7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".non-visible_svg__b{fill:currentColor}"))), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h36v36H0z",
  style: {
    fill: "none"
  }
}), _path$12 || (_path$12 = /*#__PURE__*/React.createElement("path", {
  d: "m3.532 31.053 27.52-27.52 1.414 1.414-27.52 27.52zM7.779 23.978l1.443-1.444A22.5 22.5 0 0 1 4.422 18a23.7 23.7 0 0 1 9.142-7.022A10.35 10.35 0 0 1 17.785 10h.42400000000000004a9.7 9.7 0 0 1 3.027.519l1.548-1.548A12.2 12.2 0 0 0 18.209 8h-.424a12.4 12.4 0 0 0-5.038 1.153C5.047 12.599 1.997 18 1.997 18a21.4 21.4 0 0 0 5.782 5.978M28.221 12.022l-1.443 1.444a22.5 22.5 0 0 1 4.8 4.534 23.7 23.7 0 0 1-9.142 7.022 10.35 10.35 0 0 1-4.221.978h-.42400000000000004a9.7 9.7 0 0 1-3.027-.519l-1.548 1.548a12.2 12.2 0 0 0 4.575.971h.424a12.4 12.4 0 0 0 5.038-1.153c7.7-3.446 10.75-8.847 10.75-8.847a21.4 21.4 0 0 0-5.782-5.978",
  className: "non-visible_svg__b"
})), _path2$y || (_path2$y = /*#__PURE__*/React.createElement("path", {
  d: "M14.513 17.244a3.58 3.58 0 0 1 2.732-2.731l1.951-1.952a5.563 5.563 0 0 0-6.636 6.635ZM21.487 18.756a3.58 3.58 0 0 1-2.732 2.731l-1.951 1.952a5.563 5.563 0 0 0 6.636-6.635Z",
  className: "non-visible_svg__b"
})));

var _path$11, _path2$x;
function _extends$1b() { return _extends$1b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1b.apply(null, arguments); }
const SvgOpenLink = props => /*#__PURE__*/React.createElement("svg", _extends$1b({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$11 || (_path$11 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M30 30H6V6h8.09V4H4v28h28V21.91h-2z"
})), _path2$x || (_path2$x = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m22.1 4-.03 2.01 6.46.02-12.81 12.81 1.44 1.44L29.97 7.47l.02 6.46L32 13.9V4z"
})));

var _path$10, _path2$w, _path3$9;
function _extends$1a() { return _extends$1a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1a.apply(null, arguments); }
const SvgPcZAxis = props => /*#__PURE__*/React.createElement("svg", _extends$1a({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$10 || (_path$10 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19 22V6.83l3.29 3.29 1.41-1.41L18 3l-5.71 5.71 1.41 1.41L17 6.83V22z"
})), _path2$w || (_path2$w = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z"
})), _path3$9 || (_path3$9 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M25 19.44c1.52 0 2.75-.64 2.75-1.44s-1.23-1.44-2.75-1.44-2.75.64-2.75 1.44c0 .79 1.23 1.44 2.75 1.44M32 23.44c1.52 0 2.75-.64 2.75-1.44s-1.23-1.44-2.75-1.44-2.75.64-2.75 1.44c0 .79 1.23 1.44 2.75 1.44M25 27.44c1.52 0 2.75-.64 2.75-1.44s-1.23-1.44-2.75-1.44-2.75.64-2.75 1.44c0 .79 1.23 1.44 2.75 1.44M11 19.44c1.52 0 2.75-.64 2.75-1.44s-1.23-1.44-2.75-1.44-2.75.64-2.75 1.44c0 .79 1.23 1.44 2.75 1.44M4 23.44c1.52 0 2.75-.64 2.75-1.44S5.52 20.56 4 20.56 1.25 21.2 1.25 22c0 .79 1.23 1.44 2.75 1.44M10.98 27.44c1.52 0 2.75-.64 2.75-1.44s-1.23-1.44-2.75-1.44-2.75.64-2.75 1.44c0 .79 1.23 1.44 2.75 1.44M18 31.44c1.52 0 2.75-.64 2.75-1.44s-1.23-1.44-2.75-1.44-2.75.64-2.75 1.44c0 .79 1.23 1.44 2.75 1.44"
})));

var _path$$;
function _extends$19() { return _extends$19 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$19.apply(null, arguments); }
const SvgPerimeter = props => /*#__PURE__*/React.createElement("svg", _extends$19({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path$$ || (_path$$ = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.056 1.825a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-2.976.25c.045.345.175.66.37.93L3.9 6.67a2 2 0 0 0-.455-.9zm-3.613 12.402.003.003v-.005zm0 0L3.8 7.81c-.125.32-.34.595-.6.81l6.585 6.585c.165-.294.399-.548.682-.728m1.188-.292c.35.025.675.13.95.31L16.02 3.82a1.97 1.97 0 0 1-.96-.275l-3.4 10.64zm.87 1.99a1 1 0 1 1-2 0 1 1 0 0 1 2 0M1.945 8.08a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
  clipRule: "evenodd"
})));
var perimeter = "data:image/svg+xml,%3Csvg%20%20width%3D%2218%22%20%20height%3D%2218%22%20%20viewBox%3D%220%200%2018%2018%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M17.0557%201.82471C17.0557%202.37699%2016.6079%202.82471%2016.0557%202.82471C15.5034%202.82471%2015.0557%202.37699%2015.0557%201.82471C15.0557%201.27242%2015.5034%200.824707%2016.0557%200.824707C16.6079%200.824707%2017.0557%201.27242%2017.0557%201.82471ZM14.0803%202.07471C14.1253%202.41971%2014.2553%202.73471%2014.4503%203.00471L3.90031%206.66971C3.83031%206.32971%203.66531%206.02471%203.44531%205.76971L14.0803%202.07471ZM10.4671%2014.4768L10.4702%2014.4798V14.4748L10.4671%2014.4768ZM10.4671%2014.4768L3.80019%207.80981C3.67519%208.12981%203.4602%208.40481%203.2002%208.61981L9.7852%2015.2048C9.9496%2014.9109%2010.1835%2014.6566%2010.4671%2014.4768ZM11.6553%2014.1847C12.0053%2014.2097%2012.3303%2014.3147%2012.6053%2014.4947L16.0203%203.81968C15.6703%203.81468%2015.3453%203.70968%2015.0603%203.54468L11.6603%2014.1847H11.6553ZM12.5254%2016.1748C12.5254%2016.7271%2012.0777%2017.1748%2011.5254%2017.1748C10.9731%2017.1748%2010.5254%2016.7271%2010.5254%2016.1748C10.5254%2015.6225%2010.9731%2015.1748%2011.5254%2015.1748C12.0777%2015.1748%2012.5254%2015.6225%2012.5254%2016.1748ZM1.94531%208.07959C2.4976%208.07959%202.94531%207.63187%202.94531%207.07959C2.94531%206.52731%202.4976%206.07959%201.94531%206.07959C1.39303%206.07959%200.945312%206.52731%200.945312%207.07959C0.945312%207.63187%201.39303%208.07959%201.94531%208.07959Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$_, _path2$v;
function _extends$18() { return _extends$18 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$18.apply(null, arguments); }
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends$18({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _path$_ || (_path$_ = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.386 20.352a5.63 5.63 0 0 1-4.007-1.66l-7.071-7.071a5.673 5.673 0 0 1 0-8.014l.707-.707a2 2 0 0 1 2.829 0l2.062 2.062a2 2 0 0 1 0 2.829l-1.18 1.178 5.3 5.3 1.179-1.178a2.05 2.05 0 0 1 2.829 0l2.062 2.062a2 2 0 0 1 0 2.829l-.707.707a5.63 5.63 0 0 1-4.003 1.663m-8.957-16.7a.66.66 0 0 0-.472.195l-.708.707a4.34 4.34 0 0 0 0 6.129l7.071 7.071a4.334 4.334 0 0 0 6.129 0l.707-.707a.667.667 0 0 0 0-.943l-2.062-2.062a.68.68 0 0 0-.942 0l-2.122 2.121-7.188-7.189 2.121-2.121a.67.67 0 0 0 0-.943L7.901 3.848a.66.66 0 0 0-.471-.2Z",
  "data-name": "Tracciato 4267"
})), _path2$v || (_path2$v = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z",
  "data-name": "Rettangolo 6241"
})));
var phone = "data:image/svg+xml,%3Csvg%20%20id%3D%22Phone%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2224%22%20%20height%3D%2224%22%20%20viewBox%3D%220%200%2024%2024%22%3E%20%20%3Cpath%20%20%20%20id%3D%22Tracciato_4267%22%20%20%20%20data-name%3D%22Tracciato%204267%22%20%20%20%20d%3D%22M6094.211%2C1141.51a5.627%2C5.627%2C0%2C0%2C1-4.007-1.66l-7.071-7.071a5.673%2C5.673%2C0%2C0%2C1%2C0-8.014l.707-.707a2%2C2%2C0%2C0%2C1%2C2.829%2C0l2.062%2C2.062a2%2C2%2C0%2C0%2C1%2C0%2C2.829l-1.18%2C1.178%2C5.3%2C5.3%2C1.179-1.178a2.049%2C2.049%2C0%2C0%2C1%2C2.829%2C0l2.062%2C2.062a2%2C2%2C0%2C0%2C1%2C0%2C2.829l-.707.707A5.628%2C5.628%2C0%2C0%2C1%2C6094.211%2C1141.51Zm-8.957-16.7a.662.662%2C0%2C0%2C0-.472.195l-.708.707a4.339%2C4.339%2C0%2C0%2C0%2C0%2C6.129l7.071%2C7.071a4.334%2C4.334%2C0%2C0%2C0%2C6.129%2C0l.707-.707a.667.667%2C0%2C0%2C0%2C0-.943l-2.062-2.062a.681.681%2C0%2C0%2C0-.942%2C0l-2.122%2C2.121-7.188-7.189%2C2.121-2.121a.668.668%2C0%2C0%2C0%2C0-.943l-2.062-2.062A.663.663%2C0%2C0%2C0%2C6085.255%2C1124.806Z%22%20%20%20%20transform%3D%22translate%28-6077.825%20-1121.158%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_6241%22%20%20%20%20data-name%3D%22Rettangolo%206241%22%20%20%20%20width%3D%2224%22%20%20%20%20height%3D%2224%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$Z;
function _extends$17() { return _extends$17 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$17.apply(null, arguments); }
const SvgPin = props => /*#__PURE__*/React.createElement("svg", _extends$17({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$Z || (_path$Z = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m20.274 7.5-3.78-3.78a1.33 1.33 0 0 0-2.174.433l-.566 1.374-3.5 3.5h-2.82l-2.247 2.24L8.46 14.54l-4.48 4.48-1.32 2.313 2.26-1.366 4.48-4.48 3.327 3.326 2.246-2.246v-2.82l3.494-3.5 1.373-.567a1.33 1.33 0 0 0 .433-2.173zM17.96 9.013l-.247.1-.186.187-3.5 3.5-.393.393v.554l.006 2.266-.913.914-5.66-5.66.913-.914h2.267l.553.007.393-.393 3.5-3.5.187-.187.1-.247.567-1.373 3.78 3.78-1.374.567z"
})));
var pin = "data:image/svg+xml,%3Csvg%20%20width%3D%2224%22%20%20height%3D%2224%22%20%20viewBox%3D%220%200%2024%2024%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20d%3D%22M20.2735%207.49996L16.4935%203.71996C15.8202%203.04663%2014.6802%203.27329%2014.3202%204.15329L13.7535%205.52663L10.2535%209.02663H7.43349L5.18682%2011.2666L8.46016%2014.54L3.98016%2019.02L2.66016%2021.3333L4.92016%2019.9666L9.40016%2015.4866L12.7268%2018.8133L14.9735%2016.5666V13.7466L18.4668%2010.2466L19.8402%209.67996C20.7202%209.31329%2020.9468%208.17996%2020.2735%207.50663V7.49996ZM17.9602%209.01329L17.7135%209.11329L17.5268%209.29996L14.0268%2012.8L13.6335%2013.1933V13.7466L13.6402%2016.0133L12.7268%2016.9266L7.06682%2011.2666L7.98016%2010.3533H10.2468L10.8002%2010.36L11.1935%209.96663L14.6935%206.46663L14.8802%206.27996L14.9802%206.03329L15.5468%204.65996L19.3268%208.43996L17.9535%209.00663L17.9602%209.01329Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$Y, _path2$u, _path3$8;
function _extends$16() { return _extends$16 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$16.apply(null, arguments); }
const SvgPinColored = props => /*#__PURE__*/React.createElement("svg", _extends$16({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 29 29"
}, props), _path$Y || (_path$Y = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M27.485 6.482c1.374 1.497.85 3.914-1.046 4.704l-.003.002-1.818.75-4.661 4.67v3.698a1 1 0 0 1-.293.707l-3.276 3.277a1 1 0 0 1-1.415 0l-4.144-4.145-5.826 5.827a1 1 0 0 1-.19.148l-3.296 1.993a1 1 0 0 1-1.386-1.351l1.925-3.374a1 1 0 0 1 .162-.211l5.826-5.826-4.066-4.067a1 1 0 0 1 0-1.415l3.277-3.267a1 1 0 0 1 .706-.292h3.698l4.67-4.67.75-1.815v-.002c.798-1.947 3.318-2.442 4.802-.959l5.512 5.513a1 1 0 0 1 .092.105m-9.48-4.279C18.528.92 20.191.59 21.173 1.572l5.512 5.512v.01a1.94 1.94 0 0 1-.632 3.17l-2.003.826-5.094 5.104v4.112l-3.276 3.277-4.852-4.852-6.533 6.534L1 27.258l1.925-3.374 6.533-6.533-4.773-4.774L7.96 9.31h4.113l5.104-5.104zm.816 3.102-5.95 5.95-.807-.01H8.758l-1.332 1.332 8.255 8.254 1.332-1.332-.01-3.305v-.807l5.95-5.95.36-.146-.01-.01 2.003-.826-5.513-5.513-.826 2.003zm1.325-.596-.253.612-.002.006-.143.354a1 1 0 0 1-.22.33l-.272.273-5.678 5.678a1 1 0 0 1-.72.293l-.8-.01H9.173l-.332.332 6.84 6.84.33-.33-.008-2.893v-.807a1 1 0 0 1 .293-.707l5.95-5.95a1 1 0 0 1 .331-.22l.208-.084a1 1 0 0 1 .136-.07l.618-.254z",
  clipRule: "evenodd"
})), _path2$u || (_path2$u = /*#__PURE__*/React.createElement("path", {
  fill: "#F26005",
  d: "m26.171 8.63-6.533-6.533-1.216 2.936-5.745 5.746-4.113-.01-1.818 1.808 8.945 8.945 1.818-1.818-.02-4.123 5.746-5.736z"
})), _path3$8 || (_path3$8 = /*#__PURE__*/React.createElement("path", {
  fill: "#29303D",
  d: "m26.686 7.084-5.512-5.512c-.982-.982-2.645-.652-3.17.631l-.826 2.003-5.104 5.104H7.96l-3.276 3.267 4.773 4.774-6.533 6.533L1 27.258l3.296-1.993 6.533-6.534 4.852 4.852 3.276-3.277v-4.112l5.094-5.104 2.003-.827a1.94 1.94 0 0 0 .632-3.17zm-3.373 2.207-.36.146-.272.272-5.105 5.104-.573.574v.807l.01 3.305-1.332 1.332-8.255-8.254 1.332-1.332h3.306l.807.01.573-.574 5.105-5.104.272-.272.146-.36.826-2.003 5.513 5.513-2.003.826z"
})));
var pin_colored = "data:image/svg+xml,%3Csvg%20%20width%3D%2229%22%20%20height%3D%2229%22%20%20viewBox%3D%220%200%2029%2029%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M27.4846%206.48193C28.8594%207.97946%2028.3346%2010.3963%2026.4388%2011.1862L26.4356%2011.1876L24.6178%2011.9376L19.957%2016.6074V20.3062C19.957%2020.5714%2019.8516%2020.8258%2019.6641%2021.0133L16.3877%2024.2897C15.9972%2024.6802%2015.364%2024.6802%2014.9735%2024.2897L10.8292%2020.1454L5.00297%2025.9717C4.94597%2026.0287%204.8823%2026.0786%204.81332%2026.1203L1.51749%2028.1133C1.12777%2028.349%200.62804%2028.2916%200.301942%2027.9736C-0.0241561%2027.6557%20-0.0942373%2027.1576%200.131476%2026.762L2.05648%2023.3884C2.10063%2023.311%202.15492%2023.2399%202.21792%2023.1769L8.04415%2017.3507L3.97764%2013.2842C3.78992%2013.0964%203.68455%2012.8418%203.68475%2012.5763C3.68495%2012.3108%203.7907%2012.0563%203.97869%2011.8689L7.25508%208.60224C7.44253%208.41534%207.69644%208.3104%207.96114%208.3104H11.6594L16.3295%203.64027L17.0786%201.82482C17.0788%201.82434%2017.079%201.82385%2017.0792%201.82337C17.8772%20-0.12439%2020.3972%20-0.61918%2021.8807%200.8644L27.3932%206.3769C27.4263%206.40994%2027.4568%206.44505%2027.4846%206.48193ZM18.0042%202.20345C18.5292%200.920118%2020.1917%200.589562%2021.1736%201.57151L26.6861%207.08401V7.09373C27.6681%208.07567%2027.3375%209.72845%2026.0542%2010.2632L24.0514%2011.0896L18.957%2016.1937V20.3062L15.6806%2023.5826L10.8292%2018.7312L4.29586%2025.2646L1.00003%2027.2576L2.92503%2023.884L9.45836%2017.3507L4.68475%2012.5771L7.96114%209.3104H12.0736L17.1778%204.20623L18.0042%202.20345ZM18.8209%205.30484L12.8709%2011.2548L12.0639%2011.2451H8.75836L7.42642%2012.5771L15.6806%2020.8312L17.0125%2019.4993L17.0028%2016.1937V15.3868L22.9528%209.43678L23.3125%209.29095L23.3028%209.28123L25.3056%208.45484L19.7931%202.94234L18.9667%204.94512L18.8209%205.30484ZM20.1458%204.70927L19.8934%205.32082L19.8911%205.32655L19.7476%205.68054C19.6973%205.8046%2019.6226%205.91729%2019.528%206.01195L19.2557%206.28417L13.578%2011.9619C13.3875%2012.1524%2013.1282%2012.258%2012.8588%2012.2548L12.058%2012.2451H9.17257L8.84063%2012.5771L15.6806%2019.417L16.0113%2019.0863L16.0028%2016.1937L16.0028%2015.3868C16.0028%2015.1216%2016.1082%2014.8672%2016.2957%2014.6797L22.2457%208.72968C22.3404%208.63502%2022.453%208.56034%2022.5771%208.51004L22.7848%208.42586C22.8281%208.3996%2022.8737%208.37648%2022.9214%208.35683L23.5387%208.10213L20.1458%204.70927Z%22%20%20%20%20fill%3D%22white%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M26.1711%208.63001L19.6378%202.09668L18.4225%205.03279L12.6766%2010.7786L8.56415%2010.7689L6.74609%2012.5772L15.6905%2021.5217L17.5086%2019.7036L17.4892%2015.5814L23.235%209.84529L26.1711%208.63001Z%22%20%20%20%20fill%3D%22%23F26005%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M26.6861%207.08405L21.1736%201.57155C20.1917%200.589604%2018.5292%200.920159%2018.0042%202.20349L17.1778%204.20627L12.0736%209.31044H7.96111L4.68472%2012.5771L9.45833%2017.3507L2.925%2023.884L1%2027.2577L4.29583%2025.2646L10.8292%2018.7313L15.6806%2023.5827L18.9569%2020.3063V16.1938L24.0514%2011.0896L26.0542%2010.2632C27.3375%209.72849%2027.6681%208.07572%2026.6861%207.09377V7.08405ZM23.3125%209.29099L22.9528%209.43683L22.6806%209.70905L17.5764%2014.8132L17.0028%2015.3868V16.1938L17.0125%2019.4993L15.6806%2020.8313L7.42639%2012.5771L8.75833%2011.2452H12.0639L12.8708%2011.2549L13.4444%2010.6813L18.5486%205.5771L18.8208%205.30488L18.9667%204.94516L19.7931%202.94238L25.3056%208.45488L23.3028%209.28127L23.3125%209.29099Z%22%20%20%20%20fill%3D%22%2329303D%22%20%20%2F%3E%3C%2Fsvg%3E";

var _rect, _g$c, _defs$6;
function _extends$15() { return _extends$15 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$15.apply(null, arguments); }
const SvgPlusCircle = props => /*#__PURE__*/React.createElement("svg", _extends$15({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "currentColor",
  rx: 20
})), _g$c || (_g$c = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#plus-circle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3392FF",
  d: "M27 19.334h-6.333V13h-1.334v6.334H13v1.333h6.333V27h1.334v-6.333H27z"
}))), _defs$6 || (_defs$6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "plus-circle_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8 8h24v24H8z"
})))));
var plusCircle = "data:image/svg+xml,%3Csvg%20%20width%3D%2240%22%20%20height%3D%2240%22%20%20viewBox%3D%220%200%2040%2040%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Crect%20width%3D%2240%22%20height%3D%2240%22%20rx%3D%2220%22%20fill%3D%22currentColor%22%20%2F%3E%20%20%3Cg%20clip-path%3D%22url%28%23clip0_1733_15406%29%22%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M27.0004%2019.3336H20.667V13H19.3334V19.3336H13V20.6668H19.3334V27.0004H20.667V20.6668H27.0004V19.3336Z%22%20%20%20%20%20%20fill%3D%22%233392FF%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cdefs%3E%20%20%20%20%3CclipPath%20id%3D%22clip0_1733_15406%22%3E%20%20%20%20%20%20%3Crect%20width%3D%2224%22%20height%3D%2224%22%20fill%3D%22white%22%20transform%3D%22translate%288%208%29%22%20%2F%3E%20%20%20%20%3C%2FclipPath%3E%20%20%3C%2Fdefs%3E%3C%2Fsvg%3E";

var _g$b, _defs$5;
function _extends$14() { return _extends$14 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$14.apply(null, arguments); }
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends$14({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g$b || (_g$b = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#plus_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19 11.333h-6.333V5h-1.334v6.333H5v1.334h6.333V19h1.334v-6.333H19z"
}))), _defs$5 || (_defs$5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "plus_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h24v24H0z"
})))));

var _path$X;
function _extends$13() { return _extends$13 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$13.apply(null, arguments); }
const SvgPointCloudAnalysisColormapRange = props => /*#__PURE__*/React.createElement("svg", _extends$13({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$X || (_path$X = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.146 17.507c-1.44 0-2.653-1.087-3.593-3.22-.368-.833-1.233-2.96-1.638-3.96a.667.667 0 1 1 .616-.258c.403.992 1.272 3.125 1.635 3.95l.055.123a.667.667 0 1 1 .422.822c.727 1.249 1.57 1.882 2.51 1.882 1.173 0 2.038-1.104 2.768-2.65q.032-.15.123-.268c.473-1.057.891-2.29 1.304-3.508l.005-.014v-.002c1.147-3.386 2.334-6.89 4.833-6.89 2.24 0 3.4 2.86 4.487 6.053l1.408 4.104a.667.667 0 1 1-.616.264L20.04 9.78c-.967-2.833-2.054-5.6-3.854-5.6-2.017 0-3.123 3.264-4.195 6.427l-.005.013v.002c-.36 1.062-.723 2.135-1.13 3.108a.667.667 0 0 1-.56 1.21c-.793 1.515-1.77 2.573-3.143 2.573zM22 9a.667.667 0 1 1 0 1.333A.667.667 0 0 1 22 9m-16.474.666a.667.667 0 1 0-1.333 0 .667.667 0 0 0 1.333 0M7.713 9a.667.667 0 1 1 0 1.333.667.667 0 0 1 0-1.333m3.527.666a.667.667 0 1 0-1.333 0 .667.667 0 0 0 1.333 0M13.426 9a.667.667 0 1 1 0 1.333.667.667 0 0 1 0-1.333m3.527.666a.667.667 0 1 0-1.334 0 .667.667 0 0 0 1.334 0M19.14 9a.667.667 0 1 1 0 1.333.667.667 0 0 1 0-1.333M2.666 14.333a.667.667 0 1 0-1.333 0 .667.667 0 0 0 1.333 0m5.047-.667a.667.667 0 1 1 0 1.334.667.667 0 0 1 0-1.334m5.713 0a.667.667 0 1 1 0 1.334.667.667 0 0 1 0-1.334m3.527.667a.667.667 0 1 0-1.334 0 .667.667 0 0 0 1.334 0m2.187-.667a.667.667 0 1 1 0 1.334.667.667 0 0 1 0-1.334",
  clipRule: "evenodd"
})));

var _path$W;
function _extends$12() { return _extends$12 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$12.apply(null, arguments); }
const SvgPointCloudAnalysisReferencePlane = props => /*#__PURE__*/React.createElement("svg", _extends$12({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$W || (_path$W = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.254 12.667c.805 2.321 1.991 4.84 4.027 4.84v.006c1.885 0 2.975-2.225 3.887-4.846h11.5v-1.333h-2.104l-.302-.957c-1.067-3.401-2.156-6.87-4.495-6.87-2.364 0-3.477 3.498-4.556 6.888l-.004.012-.004.014q-.145.457-.293.913H1.334v1.333zm.709 0c1.03 2.883 2.061 4.173 3.318 4.173 1.426 0 2.369-1.884 3.18-4.173zm7.648-1.333h8.247l-.197-.627C18.654 7.5 17.607 4.18 15.767 4.18s-2.92 3.274-3.926 6.434l-.004.011z",
  clipRule: "evenodd"
})));

var _path$V;
function _extends$11() { return _extends$11 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$11.apply(null, arguments); }
const SvgPointCloudAnalysis = props => /*#__PURE__*/React.createElement("svg", _extends$11({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$V || (_path$V = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.668 7.667a3 3 0 1 0 0-6 3 3 0 0 0 0 6m14.667-4c.553 0 1 .447 1 1s-.447 1-1 1c-.554 0-1-.447-1-1s.446-1 1-1m0-1.333A2.336 2.336 0 0 0 17 4.667 2.336 2.336 0 0 0 19.335 7a2.336 2.336 0 0 0 2.333-2.333 2.336 2.336 0 0 0-2.333-2.333M12 6a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666m7.334 7.334a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667m-5.334 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-9.333-8c.367 0 .667.3.667.666s-.3.667-.667.667A.67.67 0 0 1 4.001 12c0-.366.3-.666.667-.666m0-1.334c-1.107 0-2 .894-2 2 0 1.107.893 2 2 2s2-.893 2-2-.893-2-2-2m1.333 9.334c0-.734-.6-1.334-1.333-1.334s-1.333.6-1.333 1.334c0 .733.6 1.333 1.333 1.333s1.333-.6 1.333-1.333m-4 0a2.666 2.666 0 1 1 5.334 0 2.666 2.666 0 1 1-5.334 0m20 0a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0m-8-7.334c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2m-5.333 0a3.335 3.335 0 0 1 6.667 0A3.335 3.335 0 0 1 12 15.334 3.335 3.335 0 0 1 8.668 12",
  clipRule: "evenodd"
})));

var _path$U;
function _extends$10() { return _extends$10 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$10.apply(null, arguments); }
const SvgPointCloudFlashSmall = props => /*#__PURE__*/React.createElement("svg", _extends$10({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path$U || (_path$U = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.78 12.94c-.71 0-1.28.58-1.28 1.28 0 .71.57 1.28 1.28 1.28s1.28-.58 1.28-1.28c0-.71-.58-1.28-1.28-1.28m0-5.22C3.07 7.72 2.5 8.3 2.5 9c0 .71.57 1.28 1.28 1.28S5.06 9.7 5.06 9c0-.71-.57-1.28-1.28-1.28M14.23 2.5c-.71 0-1.28.57-1.28 1.28s.57 1.28 1.28 1.28 1.28-.57 1.28-1.28-.58-1.28-1.28-1.28m-5.22 0c-.71 0-1.28.57-1.28 1.28s.58 1.28 1.28 1.28c.71 0 1.28-.58 1.28-1.28 0-.71-.57-1.28-1.28-1.28m-5.22 0c-.71 0-1.28.58-1.28 1.28.01.71.58 1.28 1.28 1.28.71 0 1.28-.58 1.28-1.28 0-.71-.57-1.28-1.28-1.28m6.5 6.5c0 .71-.58 1.28-1.28 1.28-.71 0-1.28-.57-1.28-1.28s.57-1.28 1.28-1.28 1.28.57 1.28 1.28m5.21 1.82 2-4.82-7.18 7.18h2.5l-2 4.82L18 10.82z",
  clipRule: "evenodd"
})));

var _path$T;
function _extends$$() { return _extends$$ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$$.apply(null, arguments); }
const SvgPointCloudImageSmall = props => /*#__PURE__*/React.createElement("svg", _extends$$({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18"
}, props), _path$T || (_path$T = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7 17.5V7h10.5v10.5Zm1-1h8.5v-1.417l-2.257-1.213-1.884 1.012-2.8-1.867-1.552 1.033v-.008Zm8.5-2.552V8H8v4.85l1.557-1.037 2.858 1.906 1.829-.982Zm-14 .275a1.28 1.28 0 0 1 1.276-1.278 1.28 1.28 0 0 1 1.278 1.278 1.277 1.277 0 0 1-1.278 1.276A1.277 1.277 0 0 1 2.5 14.223m10.959-3.8a.927.927 0 0 1 .927-.927.93.93 0 0 1 .926.927.927.927 0 0 1-.926.926.926.926 0 0 1-.927-.922ZM2.5 9a1.277 1.277 0 0 1 1.276-1.276A1.277 1.277 0 0 1 5.054 9a1.277 1.277 0 0 1-1.278 1.276A1.277 1.277 0 0 1 2.5 9m10.446-5.223a1.277 1.277 0 0 1 1.277-1.276 1.277 1.277 0 0 1 1.276 1.276 1.277 1.277 0 0 1-1.276 1.276 1.277 1.277 0 0 1-1.277-1.276m-5.223 0A1.277 1.277 0 0 1 9 2.5a1.277 1.277 0 0 1 1.278 1.276A1.277 1.277 0 0 1 9 5.052a1.277 1.277 0 0 1-1.277-1.275m-5.223 0a1.277 1.277 0 0 1 1.276-1.276 1.277 1.277 0 0 1 1.278 1.276 1.277 1.277 0 0 1-1.278 1.276A1.277 1.277 0 0 1 2.5 3.777",
  "data-name": "point-cloud-image-small"
})));

var _path$S;
function _extends$_() { return _extends$_ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$_.apply(null, arguments); }
const SvgPointCloudSmall = props => /*#__PURE__*/React.createElement("svg", _extends$_({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18"
}, props), _path$S || (_path$S = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.945 14.362a1.277 1.277 0 0 1 1.277-1.276 1.276 1.276 0 0 1 1.277 1.276 1.276 1.276 0 0 1-1.277 1.277 1.277 1.277 0 0 1-1.277-1.277m-5.223 0a1.277 1.277 0 0 1 1.277-1.276 1.276 1.276 0 0 1 1.277 1.276A1.276 1.276 0 0 1 9 15.64a1.277 1.277 0 0 1-1.277-1.278Zm-5.223 0a1.277 1.277 0 0 1 1.277-1.276 1.277 1.277 0 0 1 1.277 1.276 1.277 1.277 0 0 1-1.277 1.277A1.277 1.277 0 0 1 2.5 14.362Zm10.445-5.223a1.28 1.28 0 0 1 1.277-1.277A1.277 1.277 0 0 1 15.5 9.14a1.276 1.276 0 0 1-1.277 1.277 1.277 1.277 0 0 1-1.278-1.277Zm-5.223 0a1.28 1.28 0 0 1 1.277-1.277 1.277 1.277 0 0 1 1.277 1.277 1.276 1.276 0 0 1-1.277 1.277A1.277 1.277 0 0 1 7.723 9.14Zm-5.223 0a1.28 1.28 0 0 1 1.277-1.277 1.28 1.28 0 0 1 1.277 1.277 1.277 1.277 0 0 1-1.277 1.277A1.277 1.277 0 0 1 2.5 9.14Zm10.445-5.223a1.28 1.28 0 0 1 1.277-1.277 1.277 1.277 0 0 1 1.277 1.277 1.276 1.276 0 0 1-1.277 1.277 1.277 1.277 0 0 1-1.275-1.276Zm-5.223 0A1.28 1.28 0 0 1 9 2.64a1.277 1.277 0 0 1 1.277 1.277A1.276 1.276 0 0 1 9 5.194a1.277 1.277 0 0 1-1.277-1.277Zm-5.223 0a1.28 1.28 0 0 1 1.277-1.277 1.28 1.28 0 0 1 1.277 1.277 1.277 1.277 0 0 1-1.277 1.277A1.277 1.277 0 0 1 2.5 3.917Z",
  "data-name": "point-cloud-small"
})));

var _path$R;
function _extends$Z() { return _extends$Z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$Z.apply(null, arguments); }
const SvgPointCloudTrajectorySmall = props => /*#__PURE__*/React.createElement("svg", _extends$Z({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18"
}, props), _path$R || (_path$R = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.544 18c0-1.2 1.41-1.754 2.774-2.288.836-.329 1.985-.778 1.985-1.192 0-.48-1.256-.97-2.172-1.326-1.39-.541-2.7-1.053-2.7-2.147 0-1.195 1.349-1.712 2.654-2.214.963-.372 2.056-.79 2.056-1.331h1c0 1.228-1.372 1.755-2.7 2.264-.944.362-2.012.773-2.012 1.281 0 .411 1.243.895 2.065 1.215 1.381.538 2.81 1.094 2.81 2.258 0 1.1-1.331 1.619-2.619 2.123-.954.374-2.14.838-2.14 1.357ZM2.5 14.223a1.277 1.277 0 0 1 1.277-1.276 1.277 1.277 0 0 1 1.277 1.276A1.28 1.28 0 0 1 3.777 15.5 1.28 1.28 0 0 1 2.5 14.223M2.5 9a1.28 1.28 0 0 1 1.277-1.277A1.28 1.28 0 0 1 5.054 9a1.28 1.28 0 0 1-1.277 1.277A1.28 1.28 0 0 1 2.5 9m10.446-5.223A1.277 1.277 0 0 1 14.223 2.5a1.277 1.277 0 0 1 1.276 1.277 1.277 1.277 0 0 1-1.276 1.277 1.277 1.277 0 0 1-1.277-1.277m-5.223 0A1.277 1.277 0 0 1 9 2.5a1.28 1.28 0 0 1 1.277 1.277A1.28 1.28 0 0 1 9 5.054a1.277 1.277 0 0 1-1.276-1.277Zm-5.224 0A1.28 1.28 0 0 1 3.776 2.5a1.28 1.28 0 0 1 1.277 1.277 1.28 1.28 0 0 1-1.277 1.277A1.28 1.28 0 0 1 2.5 3.777Z",
  "data-name": "point-cloud-trajectory-small"
})));

var _g$a;
function _extends$Y() { return _extends$Y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$Y.apply(null, arguments); }
const SvgPointCloudWarningSmall = props => /*#__PURE__*/React.createElement("svg", _extends$Y({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18"
}, props), _g$a || (_g$a = /*#__PURE__*/React.createElement("g", {
  "data-name": "point-cloud-warning-small"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.5 14.223a1.277 1.277 0 0 1 1.277-1.277 1.277 1.277 0 0 1 1.277 1.277A1.28 1.28 0 0 1 3.777 15.5 1.28 1.28 0 0 1 2.5 14.223M2.5 9a1.277 1.277 0 0 1 1.277-1.277A1.277 1.277 0 0 1 5.054 9a1.28 1.28 0 0 1-1.277 1.277A1.28 1.28 0 0 1 2.5 9m10.446-5.223A1.277 1.277 0 0 1 14.223 2.5 1.276 1.276 0 0 1 15.5 3.777a1.277 1.277 0 0 1-1.277 1.277 1.28 1.28 0 0 1-1.277-1.277m-5.223 0A1.277 1.277 0 0 1 9 2.5a1.276 1.276 0 0 1 1.277 1.277A1.277 1.277 0 0 1 9 5.054a1.28 1.28 0 0 1-1.277-1.277m-5.223 0A1.277 1.277 0 0 1 3.777 2.5a1.277 1.277 0 0 1 1.277 1.277 1.28 1.28 0 0 1-1.277 1.277A1.28 1.28 0 0 1 2.5 3.777",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffcc4c",
  d: "M11.717 16.238a4.5 4.5 0 1 1 4.5-4.5 4.5 4.5 0 0 1-4.5 4.5m0-2.759a.676.676 0 1 0 .675.676.676.676 0 0 0-.675-.676m-.513-.916h1.05v-4.05H11.2Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.042 14.153a.674.674 0 0 1 .675-.674.674.674 0 0 1 .674.674.674.674 0 0 1-.674.675.675.675 0 0 1-.675-.675m.163-1.591V8.513h1.049v4.049Z"
}))));

var _defs$4, _path$Q;
function _extends$X() { return _extends$X = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$X.apply(null, arguments); }
const SvgPointCloud = props => /*#__PURE__*/React.createElement("svg", _extends$X({
  xmlns: "http://www.w3.org/2000/svg",
  id: "point-cloud_svg__Livello_2",
  width: "1em",
  height: "1em",
  "data-name": "Livello 2",
  viewBox: "0 0 36 36"
}, props), _defs$4 || (_defs$4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".point-cloud_svg__point-cloud-2{fill:currentColor}"))), /*#__PURE__*/React.createElement("g", {
  id: "point-cloud_svg__FinalDesign"
}, /*#__PURE__*/React.createElement("g", {
  id: "point-cloud_svg__PointCloud_Simplified"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h36v36H0z",
  style: {
    fill: "none"
  }
}), _path$Q || (_path$Q = /*#__PURE__*/React.createElement("path", {
  d: "M29.18 31.02c1.6 0 2.89-1.3 2.89-2.89s-1.3-2.89-2.89-2.89-2.89 1.29-2.89 2.89 1.3 2.89 2.89 2.89M29.18 20.89c1.6 0 2.89-1.3 2.89-2.89s-1.3-2.89-2.89-2.89-2.89 1.29-2.89 2.89 1.3 2.89 2.89 2.89M29.18 10.77c1.6 0 2.89-1.3 2.89-2.89s-1.3-2.89-2.89-2.89-2.89 1.29-2.89 2.89 1.3 2.89 2.89 2.89M6.82 31.02c1.6 0 2.89-1.3 2.89-2.89s-1.3-2.89-2.89-2.89-2.89 1.29-2.89 2.89 1.3 2.89 2.89 2.89M6.82 20.89c1.6 0 2.89-1.3 2.89-2.89s-1.3-2.89-2.89-2.89S3.93 16.4 3.93 18s1.3 2.89 2.89 2.89M6.82 10.77c1.6 0 2.89-1.3 2.89-2.89s-1.3-2.89-2.89-2.89-2.89 1.29-2.89 2.89 1.3 2.89 2.89 2.89M18 31.02c1.6 0 2.89-1.3 2.89-2.89s-1.3-2.89-2.89-2.89-2.89 1.29-2.89 2.89 1.3 2.89 2.89 2.89M18 20.89c1.6 0 2.89-1.3 2.89-2.89s-1.3-2.89-2.89-2.89-2.89 1.29-2.89 2.89 1.3 2.89 2.89 2.89M18 10.77c1.6 0 2.89-1.3 2.89-2.89S19.59 4.99 18 4.99s-2.89 1.29-2.89 2.89 1.3 2.89 2.89 2.89",
  className: "point-cloud_svg__point-cloud-2"
})))));
var pointCloud = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20%20id%3D%22Livello_2%22%20%20data-name%3D%22Livello%202%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2236%22%20%20height%3D%2236%22%20%20viewBox%3D%220%200%2036%2036%22%3E%20%20%3Cdefs%3E%20%20%20%20%3Cstyle%3E%20%20%20%20%20%20.point-cloud-1%20%7B%20%20%20%20%20%20%20%20fill%3A%20none%3B%20%20%20%20%20%20%7D%20%20%20%20%20%20.point-cloud-2%20%7B%20%20%20%20%20%20%20%20fill%3A%20currentColor%3B%20%20%20%20%20%20%7D%20%20%20%20%3C%2Fstyle%3E%20%20%3C%2Fdefs%3E%20%20%3Cg%20id%3D%22FinalDesign%22%3E%20%20%20%20%3Cg%20id%3D%22PointCloud_Simplified%22%3E%20%20%20%20%20%20%3Crect%20class%3D%22point-cloud-1%22%20width%3D%2236%22%20height%3D%2236%22%20%2F%3E%20%20%20%20%20%20%3Cg%3E%20%20%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20%20class%3D%22point-cloud-2%22%20%20%20%20%20%20%20%20%20%20d%3D%22M29.18%2C31.02h0c1.6%2C0%2C2.89-1.3%2C2.89-2.89s-1.3-2.89-2.89-2.89-2.89%2C1.29-2.89%2C2.89%2C1.3%2C2.89%2C2.89%2C2.89%22%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20%20class%3D%22point-cloud-2%22%20%20%20%20%20%20%20%20%20%20d%3D%22M29.18%2C20.89h0c1.6%2C0%2C2.89-1.3%2C2.89-2.89s-1.3-2.89-2.89-2.89-2.89%2C1.29-2.89%2C2.89%2C1.3%2C2.89%2C2.89%2C2.89%22%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20%20class%3D%22point-cloud-2%22%20%20%20%20%20%20%20%20%20%20d%3D%22M29.18%2C10.77h0c1.6%2C0%2C2.89-1.3%2C2.89-2.89s-1.3-2.89-2.89-2.89-2.89%2C1.29-2.89%2C2.89%2C1.3%2C2.89%2C2.89%2C2.89%22%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20%20class%3D%22point-cloud-2%22%20%20%20%20%20%20%20%20%20%20d%3D%22M6.82%2C31.02h0c1.6%2C0%2C2.89-1.3%2C2.89-2.89s-1.3-2.89-2.89-2.89-2.89%2C1.29-2.89%2C2.89%2C1.3%2C2.89%2C2.89%2C2.89%22%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20%20class%3D%22point-cloud-2%22%20%20%20%20%20%20%20%20%20%20d%3D%22M6.82%2C20.89h0c1.6%2C0%2C2.89-1.3%2C2.89-2.89s-1.3-2.89-2.89-2.89-2.89%2C1.29-2.89%2C2.89%2C1.3%2C2.89%2C2.89%2C2.89%22%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20%20class%3D%22point-cloud-2%22%20%20%20%20%20%20%20%20%20%20d%3D%22M6.82%2C10.77h0c1.6%2C0%2C2.89-1.3%2C2.89-2.89s-1.3-2.89-2.89-2.89-2.89%2C1.29-2.89%2C2.89%2C1.3%2C2.89%2C2.89%2C2.89%22%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20%20class%3D%22point-cloud-2%22%20%20%20%20%20%20%20%20%20%20d%3D%22M18%2C31.02h0c1.6%2C0%2C2.89-1.3%2C2.89-2.89s-1.3-2.89-2.89-2.89-2.89%2C1.29-2.89%2C2.89%2C1.3%2C2.89%2C2.89%2C2.89%22%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20%20class%3D%22point-cloud-2%22%20%20%20%20%20%20%20%20%20%20d%3D%22M18%2C20.89h0c1.6%2C0%2C2.89-1.3%2C2.89-2.89s-1.3-2.89-2.89-2.89-2.89%2C1.29-2.89%2C2.89%2C1.3%2C2.89%2C2.89%2C2.89%22%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20%20class%3D%22point-cloud-2%22%20%20%20%20%20%20%20%20%20%20d%3D%22M18%2C10.77h0c1.6%2C0%2C2.89-1.3%2C2.89-2.89s-1.3-2.89-2.89-2.89-2.89%2C1.29-2.89%2C2.89%2C1.3%2C2.89%2C2.89%2C2.89%22%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _path$P, _path2$t;
function _extends$W() { return _extends$W = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$W.apply(null, arguments); }
const SvgProcoreLogo = props => /*#__PURE__*/React.createElement("svg", _extends$W({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path$P || (_path$P = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M23.27 4.69H8.6c-2.76 0-4.66 1.9-4.66 4.66v13.47c0 2.76 1.9 4.66 4.66 4.66h14.68c2.76 0 4.66-1.9 4.66-4.66v-3.8h-5.53l-2.42 4.14H11.7l-4.14-7.07 4.14-7.08h8.29l2.42 4.14h5.53v-3.8c0-2.76-1.9-4.66-4.66-4.66z"
})), _path2$t || (_path2$t = /*#__PURE__*/React.createElement("path", {
  fill: "#FF5200",
  d: "m13.78 12.11-2.25 3.98 2.25 3.79h4.48l2.25-3.79-2.25-3.98z"
})));

var _path$O, _path2$s, _g$9;
function _extends$V() { return _extends$V = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$V.apply(null, arguments); }
const SvgQuestionMarkInCircle = props => /*#__PURE__*/React.createElement("svg", _extends$V({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$O || (_path$O = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z",
  "data-name": "Rectangle 12689"
})), _path2$s || (_path2$s = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18 4A14 14 0 1 1 4 18 14.015 14.015 0 0 1 18 4m0-2a16 16 0 1 0 16 16A16 16 0 0 0 18 2",
  "data-name": "Path 9143"
})), _g$9 || (_g$9 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 10401"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 10399"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 10398",
  transform: "translate(-1024 -50)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  fill: "currentColor",
  "data-name": "Ellipse 3064",
  transform: "translate(1040.75 74.25)"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 10400"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.224 22.25h-2v-1.61a3.7 3.7 0 0 1 .228-1.318 4.5 4.5 0 0 1 .552-1.027 6.3 6.3 0 0 1 .722-.832q.347-.337.709-.675.333-.313.658-.651a4 4 0 0 0 .483-.617 3 3 0 0 0 .321-.692 2.6 2.6 0 0 0 .115-.817 3.1 3.1 0 0 0-.115-.858 3.3 3.3 0 0 0-.329-.781 3.26 3.26 0 0 0-3.676-1.507 3.3 3.3 0 0 0-.784.329 3.3 3.3 0 0 0-.661.513 3.2 3.2 0 0 0-.514.663 3.3 3.3 0 0 0-.329.781 3.2 3.2 0 0 0-.116.86h-2a5.2 5.2 0 0 1 .19-1.4 5.262 5.262 0 0 1 9.616-1.251 5.2 5.2 0 0 1 .529 1.251 5.2 5.2 0 0 1 .189 1.4 4.6 4.6 0 0 1-.213 1.436 5 5 0 0 1-.536 1.147 6 6 0 0 1-.727.928q-.36.375-.733.725c-.373.35-.462.436-.687.653a4.3 4.3 0 0 0-.489.565 2.4 2.4 0 0 0-.3.568 1.7 1.7 0 0 0-.1.607Z",
  "data-name": "Path 9144"
})))));
var questionMarkInCircle = "data:image/svg+xml,%3Csvg%20%20id%3D%22Help%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2236%22%20%20height%3D%2236%22%20%20viewBox%3D%220%200%2036%2036%22%3E%20%20%3Crect%20%20%20%20id%3D%22Rectangle_12689%22%20%20%20%20data-name%3D%22Rectangle%2012689%22%20%20%20%20width%3D%2236%22%20%20%20%20height%3D%2236%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20id%3D%22Path_9143%22%20%20%20%20data-name%3D%22Path%209143%22%20%20%20%20d%3D%22M1042%2C54a14%2C14%2C0%2C1%2C1-14%2C14%2C14.015%2C14.015%2C0%2C0%2C1%2C14-14m0-2a16%2C16%2C0%2C1%2C0%2C16%2C16%2C16%2C16%2C0%2C0%2C0-16-16Z%22%20%20%20%20transform%3D%22translate%28-1024%20-50%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cg%20id%3D%22Group_10401%22%20data-name%3D%22Group%2010401%22%20transform%3D%22translate%28-1024%20-50%29%22%3E%20%20%20%20%3Cg%20id%3D%22Group_10399%22%20data-name%3D%22Group%2010399%22%3E%20%20%20%20%20%20%3Cg%20id%3D%22Group_10398%22%20data-name%3D%22Group%2010398%22%3E%20%20%20%20%20%20%20%20%3Ccircle%20%20%20%20%20%20%20%20%20%20id%3D%22Ellipse_3064%22%20%20%20%20%20%20%20%20%20%20data-name%3D%22Ellipse%203064%22%20%20%20%20%20%20%20%20%20%20cx%3D%221.5%22%20%20%20%20%20%20%20%20%20%20cy%3D%221.5%22%20%20%20%20%20%20%20%20%20%20r%3D%221.5%22%20%20%20%20%20%20%20%20%20%20transform%3D%22translate%281040.75%2074.25%29%22%20%20%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%20%20%20%20%3Cg%20id%3D%22Group_10400%22%20data-name%3D%22Group%2010400%22%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20id%3D%22Path_9144%22%20%20%20%20%20%20%20%20data-name%3D%22Path%209144%22%20%20%20%20%20%20%20%20d%3D%22M1043.224%2C72.25h-2V70.64a3.7%2C3.7%2C0%2C0%2C1%2C.228-1.318%2C4.475%2C4.475%2C0%2C0%2C1%2C.552-1.027%2C6.265%2C6.265%2C0%2C0%2C1%2C.722-.832c.232-.225.467-.449.709-.675q.333-.313.658-.651a4.023%2C4.023%2C0%2C0%2C0%2C.483-.617%2C2.993%2C2.993%2C0%2C0%2C0%2C.321-.692%2C2.62%2C2.62%2C0%2C0%2C0%2C.115-.817%2C3.134%2C3.134%2C0%2C0%2C0-.115-.858%2C3.29%2C3.29%2C0%2C0%2C0-.329-.781%2C3.257%2C3.257%2C0%2C0%2C0-3.676-1.507%2C3.316%2C3.316%2C0%2C0%2C0-.784.329%2C3.257%2C3.257%2C0%2C0%2C0-.661.513%2C3.225%2C3.225%2C0%2C0%2C0-.514.663%2C3.308%2C3.308%2C0%2C0%2C0-.329.781%2C3.186%2C3.186%2C0%2C0%2C0-.116.86h-2a5.173%2C5.173%2C0%2C0%2C1%2C.19-1.4%2C5.262%2C5.262%2C0%2C0%2C1%2C9.616-1.251%2C5.244%2C5.244%2C0%2C0%2C1%2C.529%2C1.251%2C5.184%2C5.184%2C0%2C0%2C1%2C.189%2C1.4%2C4.633%2C4.633%2C0%2C0%2C1-.213%2C1.436%2C4.955%2C4.955%2C0%2C0%2C1-.536%2C1.147%2C5.922%2C5.922%2C0%2C0%2C1-.727.928c-.241.25-.484.491-.733.725s-.462.436-.687.653a4.262%2C4.262%2C0%2C0%2C0-.489.565%2C2.389%2C2.389%2C0%2C0%2C0-.3.568%2C1.712%2C1.712%2C0%2C0%2C0-.1.607Z%22%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _g$8;
function _extends$U() { return _extends$U = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$U.apply(null, arguments); }
const SvgRecenterView = props => /*#__PURE__*/React.createElement("svg", _extends$U({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), _g$8 || (_g$8 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Recenter PointCloud"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 12327"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Recenter View"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.999 15.112V12h-3.111V3.556h-1.777V12H12v3.111H3.554v1.778h8.443V20h3.111v8.444h1.777V20h3.111v-3.111h8.445v-1.777Zm-1.777 3.111h-4.445v-4.445h4.445v4.444Z",
  "data-name": "Path 923"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z",
  "data-name": "Rectangle 1376"
}))))));

var _path$N;
function _extends$T() { return _extends$T = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$T.apply(null, arguments); }
const SvgRegistrationInteractive = props => /*#__PURE__*/React.createElement("svg", _extends$T({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$N || (_path$N = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M28.747 23.445a2.5 2.5 0 0 0-.221.27l-3.7-1.748 4.867-8.236a2.455 2.455 0 1 0-.941-4.055c-.016.016-.026.034-.041.05l-8.686-5.404a2.454 2.454 0 1 0-4.608.133l-8.7 5.294c-.022-.023-.036-.049-.058-.071a2.459 2.459 0 1 0-2.23 4.145v8.954a2.458 2.458 0 1 0 2.229 4.144q.02-.023.038-.047l8.677 5.427a2.451 2.451 0 1 0 4.671.033l8.671-5.455q.018.022.034.042a2.459 2.459 0 1 0 0-3.476m0-10.291c.03.03.065.05.1.078l-4.921 8.315-7.77-3.667a2.45 2.45 0 0 0-.647-2.3 2.4 2.4 0 0 0-.559-.406l.96-3.264h12.167a2.44 2.44 0 0 0 .668 1.246m-.562-2.59a3 3 0 0 0-.107.361H16.196l1.447-4.923a2.45 2.45 0 0 0 1.8-.715c.034-.035.059-.076.091-.112ZM15.958 5.277v.012a2.4 2.4 0 0 0 .722.492l-1.512 5.146H7.324a2.4 2.4 0 0 0-.1-.337Zm-9.3 7.877a2.45 2.45 0 0 0 .669-1.246h7.559l-.873 2.973a2.441 2.441 0 0 0-2.355 3.68l-1.28 1.128-3.82-6.458c.03-.028.065-.048.094-.078m-.264 10.073a2.4 2.4 0 0 0-.979-.449v-8.955a3 3 0 0 0 .306-.09l3.915 6.624Zm9.57 8.086c-.04.04-.07.089-.107.132l-8.64-5.4a2.45 2.45 0 0 0-.176-2.08l3.1-2.744 5.923 10.015c-.03.028-.065.048-.094.078m.941-.578-6.017-10.181 1.429-1.265a2.45 2.45 0 0 0 3.189-.235 2.4 2.4 0 0 0 .231-.283l7.688 3.626-4.927 8.337a2.45 2.45 0 0 0-1.6 0m2.665.736c-.044-.052-.08-.109-.129-.157-.029-.03-.064-.05-.094-.078l4.978-8.416 3.786 1.785a2.45 2.45 0 0 0 .085 1.444Z",
  "data-name": "registration-interactive"
})));

var _path$M;
function _extends$S() { return _extends$S = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$S.apply(null, arguments); }
const SvgRegularFace44Px = props => /*#__PURE__*/React.createElement("svg", _extends$S({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 44 44"
}, props), _path$M || (_path$M = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1 22A21 21 0 0 1 22 1a21 21 0 0 1 21 21 21 21 0 0 1-21 21A21 21 0 0 1 1 22m3 0a18.02 18.02 0 0 0 18 18 18.02 18.02 0 0 0 18-18A18.02 18.02 0 0 0 22 4 18.02 18.02 0 0 0 4 22m10.541 9.019a1.5 1.5 0 0 1-.963-1.891 1.5 1.5 0 0 1 1.891-.963 21 21 0 0 0 13.062 0 1.5 1.5 0 0 1 1.892.963 1.5 1.5 0 0 1-.963 1.891A24.1 24.1 0 0 1 22 32.208a24.1 24.1 0 0 1-7.459-1.189m-1.289-11.226a1.5 1.5 0 0 1-1.5-1.5 1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5Zm14.5 0a1.5 1.5 0 0 1-1.5-1.5 1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5Z"
})));

var _path$L, _path2$r, _path3$7, _path4$3, _path5$2;
function _extends$R() { return _extends$R = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$R.apply(null, arguments); }
const SvgResetScale = props => /*#__PURE__*/React.createElement("svg", _extends$R({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Reset Scale",
  viewBox: "0 0 32 32"
}, props), _path$L || (_path$L = /*#__PURE__*/React.createElement("path", {
  fill: "#currentColor",
  d: "M16.001 5.334A10.667 10.667 0 1 1 5.333 16.001 10.68 10.68 0 0 1 16.001 5.334m0-1.778A12.444 12.444 0 1 0 28.444 16 12.445 12.445 0 0 0 16.001 3.556",
  "data-name": "Path 1137"
})), _path2$r || (_path2$r = /*#__PURE__*/React.createElement("path", {
  fill: "#currentColor",
  d: "M15.402 14.538v-1.943h1.2v1.943Zm0 4.868v-1.952h1.2v1.952Z",
  "data-name": "Path 1138"
})), _path3$7 || (_path3$7 = /*#__PURE__*/React.createElement("path", {
  fill: "#currentColor",
  d: "M10.959 20.445V13.53a5.7 5.7 0 0 1-1.684.518v-1.276a3.87 3.87 0 0 0 1.965-1.216h1.2v8.889Z",
  "data-name": "Path 1139"
})), _path4$3 || (_path4$3 = /*#__PURE__*/React.createElement("path", {
  fill: "#currentColor",
  d: "M20.776 20.445V13.53a5.7 5.7 0 0 1-1.682.518v-1.276a3.87 3.87 0 0 0 1.963-1.216h1.2v8.889Z",
  "data-name": "Path 1140"
})), _path5$2 || (_path5$2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z",
  "data-name": "Rectangle 1527"
})));

var _path$K, _path2$q;
function _extends$Q() { return _extends$Q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$Q.apply(null, arguments); }
const SvgReset = props => /*#__PURE__*/React.createElement("svg", _extends$Q({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), _path$K || (_path$K = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z",
  "data-name": "Rectangle 6204"
})), _path2$q || (_path2$q = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.896 26.667a8 8 0 0 0 0-16H8.74l4.037 4.037-1.257 1.257-6.187-6.183 6.184-6.183 1.257 1.257-4.037 4.037h8.156a9.778 9.778 0 1 1-9.778 9.778h1.778a8.01 8.01 0 0 0 8.003 8",
  "data-name": "Path 4223"
})));

var _path$J, _path2$p, _path3$6, _path4$2, _path5$1;
function _extends$P() { return _extends$P = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$P.apply(null, arguments); }
const SvgRevit = props => /*#__PURE__*/React.createElement("svg", _extends$P({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Layer 1",
  viewBox: "0 0 250 250"
}, props), _path$J || (_path$J = /*#__PURE__*/React.createElement("path", {
  fill: "#679ae7",
  d: "M12.948 41.164c11.792-6.985 23.441-14.234 35.277-21.12.11 58.531 0 117.062 0 175.604-5.786 3.52-11.616 6.963-17.391 10.505-6.974 4.136-13.86 8.448-20.9 12.496V43.441a10.7 10.7 0 0 1 3.014-2.277"
})), _path2$p || (_path2$p = /*#__PURE__*/React.createElement("path", {
  fill: "#186bff",
  d: "M48.225 20.044q83.479-.077 166.969 0c6.6-.33 12.925 5.5 12.892 12.1v163.471H48.291c-.066-58.509.044-117.04-.066-175.571m54.846 136.642c8.184.077 16.379 0 24.574 0v-35.09c3.443 0 6.886 0 10.329-.055 3.674 7.007 7.04 14.19 10.604 21.263 2.684 6.138 6.6 12.551 13.365 14.762a26.47 26.47 0 0 0 18.194-.847v-14.641c-2.013-.253-4.191-.22-5.951-1.375a9.7 9.7 0 0 1-3.3-3.949q-5.379-10.197-10.802-20.361c5.5-2.948 10.791-7.084 13.42-12.947 2.651-5.5 1.881-11.847 1.947-17.798a23.5 23.5 0 0 0-7.524-17.468c-6.908-6.259-16.5-8.591-25.575-8.899h-39.215c-.099 32.461-.022 64.944-.066 97.405"
})), _path3$6 || (_path3$6 = /*#__PURE__*/React.createElement("path", {
  fill: "#186bff",
  d: "M127.645 76.166c4.895.187 9.9-.429 14.696.396 4.026.803 7.7 3.883 8.316 8.063a86 86 0 0 1 .198 10.417 10.34 10.34 0 0 1-6.985 9.537c-5.225 1.705-10.813.737-16.214 1.001q-.022-14.696-.011-29.414"
})), _path4$2 || (_path4$2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M103.071 156.686V59.281h39.215c9.108.319 18.7 2.651 25.575 8.899a23.5 23.5 0 0 1 7.524 17.468c-.055 5.951.704 12.254-1.947 17.798-2.629 5.863-7.876 9.999-13.42 12.947q5.412 10.164 10.802 20.361a9.7 9.7 0 0 0 3.3 3.949c1.76 1.1 3.949 1.1 5.951 1.375v14.641a26.47 26.47 0 0 1-18.194.847c-6.71-2.2-10.67-8.635-13.365-14.762-3.564-7.073-6.93-14.3-10.604-21.263-3.443.11-6.886 0-10.329.055v35.09c-8.129.011-16.346.077-24.508 0m24.574-80.52v29.414c5.39-.253 11 .704 16.214-1.001a10.34 10.34 0 0 0 6.985-9.537 86 86 0 0 0-.198-10.417c-.649-4.18-4.29-7.26-8.316-8.063-4.829-.88-9.79-.198-14.685-.396"
})), _path5$1 || (_path5$1 = /*#__PURE__*/React.createElement("path", {
  fill: "#0c3d91",
  d: "M228.086 59.468h17.347v175.296H42.659a13.5 13.5 0 0 1-9.9-6.028 12.2 12.2 0 0 1-1.903-7.326v-15.257c5.775-3.531 11.605-6.985 17.391-10.505h179.795q.088-68.09.044-136.18"
})));

var _path$I;
function _extends$O() { return _extends$O = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$O.apply(null, arguments); }
const SvgRotateCw = props => /*#__PURE__*/React.createElement("svg", _extends$O({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path$I || (_path$I = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.913 24.639a9 9 0 0 0 .986-.293l.622 1.67a21 21 0 0 1-1.715.445c-.231.036-.693.107-.925.125-.213.018-.87.044-.87.044-5.894 0-10.667-4.773-10.667-10.666S10.117 5.297 16.01 5.297c3.707 0 6.951 1.893 8.863 4.764v-5.28h1.777v8.747h-8.746V11.75h5.902c-1.502-2.782-4.427-4.675-7.805-4.675-4.897 0-8.888 3.99-8.888 8.888s3.99 8.89 8.889 8.89c.657 0 1.297-.08 1.91-.214m2.32-.915a9.6 9.6 0 0 0 1.217-.845l1.13 1.369c-.463.382-1.174.871-1.458 1.013zm4.239-5.814c-.107.48-.249.96-.436 1.413l1.654.658c.15-.39.373-.986.515-1.698zm-1.963 3.929c.32-.373.613-.773.87-1.191l1.52.924c-.061.196-.897 1.298-1.048 1.431z",
  clipRule: "evenodd"
})));

var _path$H;
function _extends$N() { return _extends$N = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$N.apply(null, arguments); }
const SvgRuler = props => /*#__PURE__*/React.createElement("svg", _extends$N({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 33 33"
}, props), _path$H || (_path$H = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m23.235 1.916-21.37 21.37 7.54 7.54 21.38-21.36-7.54-7.54zm-18.85 21.37 3.19-3.19 1.69 1.69.63-.63-1.69-1.69 2.33-2.33 2.51 2.51.63-.63-2.51-2.51 2.33-2.33 1.69 1.69.63-.63-1.69-1.69 2.33-2.33 2.51 2.51.63-.63-2.51-2.51 2.33-2.33 1.69 1.69.63-.63-1.69-1.69 3.19-3.19 5.03 5.03-18.85 18.85z"
})));

var _defs$3, _path$G, _path2$o;
function _extends$M() { return _extends$M = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$M.apply(null, arguments); }
const SvgRunning = props => /*#__PURE__*/React.createElement("svg", _extends$M({
  xmlns: "http://www.w3.org/2000/svg",
  id: "running_svg__Livello_2",
  width: "1em",
  height: "1em",
  "data-name": "Livello 2",
  viewBox: "0 0 36 36"
}, props), _defs$3 || (_defs$3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".running_svg__running-2{fill:currentColor}"))), /*#__PURE__*/React.createElement("g", {
  id: "running_svg__Layer_1",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h36v36H0z",
  style: {
    fill: "none"
  }
}), _path$G || (_path$G = /*#__PURE__*/React.createElement("path", {
  d: "M28.591 34h-2c0-5.236-2.155-6.216-4.65-7.35-2.41-1.096-5.141-2.338-5.141-7.43h2c0 3.804 1.664 4.561 3.968 5.61 2.595 1.178 5.823 2.646 5.823 9.17M15.749 23.942C15.637 28.403 11.98 32 7.494 32c-.03 0-.057-.004-.085-.004v2c.028 0 .056.004.085.004 4.806 0 8.829-3.307 9.946-7.767a7.6 7.6 0 0 1-1.691-2.29",
  className: "running_svg__running-2"
})), _path2$o || (_path2$o = /*#__PURE__*/React.createElement("path", {
  d: "m10.912 21.038 4.578-8.31.89-1.834c.693.174 1.556.478 2.188.765 3.71 1.688 6.27 5.232 6.27 9.65h-2c0-3.723-2.21-6.64-5.383-7.957q-.033-.013-.067-.025l-4.706 8.641zM20.722 4c1.164 0 2.11.946 2.11 2.11s-.946 2.109-2.11 2.109a2.11 2.11 0 0 1-2.11-2.11c0-1.163.947-2.109 2.11-2.109m0-2a4.11 4.11 0 1 0 0 8.219 4.11 4.11 0 0 0 0-8.219",
  className: "running_svg__running-2"
}))));
var running = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20%20id%3D%22Livello_2%22%20%20data-name%3D%22Livello%202%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2235.9999978936%22%20%20height%3D%2235.9999978936%22%20%20viewBox%3D%220%200%2035.9999978936%2035.9999978936%22%3E%20%20%3Cdefs%3E%20%20%20%20%3Cstyle%3E%20%20%20%20%20%20.running-1%20%7B%20%20%20%20%20%20%20%20fill%3A%20none%3B%20%20%20%20%20%20%7D%20%20%20%20%20%20.running-2%20%7B%20%20%20%20%20%20%20%20fill%3A%20currentColor%3B%20%20%20%20%20%20%7D%20%20%20%20%3C%2Fstyle%3E%20%20%3C%2Fdefs%3E%20%20%3Cg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%3Crect%20class%3D%22running-1%22%20width%3D%2235.9999978936%22%20height%3D%2235.9999978936%22%20%2F%3E%20%20%20%20%20%20%3Cg%3E%20%20%20%20%20%20%20%20%3Cg%3E%20%20%20%20%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20%20%20%20class%3D%22running-2%22%20%20%20%20%20%20%20%20%20%20%20%20d%3D%22M28.5913931518%2C33.9999980106h-1.999999883c0-5.2363278186-2.1552733114-6.2158199488-4.6506344935-7.3505855074-2.4099119684-1.0957030609-5.1411129804-2.3369139257-5.1411129804-7.4296870653h1.999999883c0%2C3.8046872774%2C1.6647948245%2C4.5615231706%2C3.9687497678%2C5.6093746718%2C2.5942381295%2C1.1787108685%2C5.8229977062%2C2.6464842201%2C5.8229977062%2C9.1708979009Z%22%20%20%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20%20%20%20class%3D%22running-2%22%20%20%20%20%20%20%20%20%20%20%20%20d%3D%22M15.7489362851%2C23.9422329028c-.1123046809%2C4.4611203444-3.7675779046%2C8.0577387863-8.2553706107%2C8.0577387863-.0288085921%2C0-.0561523405-.0039672849-.0849609325-.0042724607v1.999999883c.0288085921%2C.0002441406%2C.0561523405%2C.0042724607%2C.0849609325%2C.0042724607%2C4.8061520625%2C0%2C8.8291010459-3.3071897479%2C9.9467767617-7.7666621432-.6464843372-.6022948866-1.2353514902-1.3449095893-1.691406151-2.2910765261Z%22%20%20%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3Cg%3E%20%20%20%20%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20%20%20%20class%3D%22running-2%22%20%20%20%20%20%20%20%20%20%20%20%20d%3D%22M10.9118964767%2C21.0383867014l4.5778899339-8.3107973566h0l.890624948-1.8335570216c.692382772%2C.1741332906%2C1.5556639714%2C.4779052455%2C2.187499872%2C.7654418498%2C3.7094724391%2C1.6872557608%2C6.2695308829%2C5.2312619012%2C6.2695308827%2C9.6488031467h-1.999999883c.0000000002-3.7227170674-2.2094725267-6.6400142601-5.3823239035-7.9562983629-.0224609362-.0093383783-.0444335911-.0161743155-.0668945273-.0254516587l-4.705819614%2C8.6415468489-1.7705077089-.9296874457Z%22%20%20%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20%20%20%20class%3D%22running-2%22%20%20%20%20%20%20%20%20%20%20%20%20d%3D%22M20.7222867506%2C4.0000049724c1.1635771797%2C0%2C2.1098686503%2C.9462914706%2C2.1098686503%2C2.109624509%2C0%2C1.1630888973-.9462914706%2C2.1093803678-2.1098686503%2C2.1093803678-1.1630888972%2C0-2.1093803678-.9462914705-2.1093803678-2.1093803678%2C0-1.1633330385%2C.9462914706-2.109624509%2C2.1093803678-2.109624509m0-2.0000050894c-2.2695370253%2C0-4.1093854572%2C1.8398484319-4.1093854572%2C4.1096295985%2C0%2C2.2695370253%2C1.8398484319%2C4.1093854573%2C4.1093854572%2C4.1093854572%2C2.2695370254%2C0%2C4.1098737397-1.8398484319%2C4.1098737397-4.1093854572%2C0-2.2697811666-1.8403367144-4.1096295985-4.1098737397-4.1096295985h0Z%22%20%20%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _path$F;
function _extends$L() { return _extends$L = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$L.apply(null, arguments); }
const SvgScanCluster = props => /*#__PURE__*/React.createElement("svg", _extends$L({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$F || (_path$F = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.82 12a5 5 0 0 0 2.514-4.333c0-2.76-2.24-5-5-5A5 5 0 0 0 12 5.18a5 5 0 0 0-4.333-2.513c-2.76 0-5 2.24-5 5A5 5 0 0 0 5.18 12a5 5 0 0 0-2.513 4.333c0 2.76 2.24 5 5 5A5 5 0 0 0 12 18.82a5 5 0 0 0 4.334 2.513c2.76 0 5-2.24 5-5A5 5 0 0 0 18.82 12m-2.486 8a3.673 3.673 0 0 1-3.667-3.667h-1.333A3.673 3.673 0 0 1 7.667 20 3.673 3.673 0 0 1 4 16.333a3.673 3.673 0 0 1 3.667-3.666v-1.334A3.673 3.673 0 0 1 4 7.667 3.673 3.673 0 0 1 7.667 4a3.673 3.673 0 0 1 3.667 3.667h1.333A3.673 3.673 0 0 1 16.334 4 3.673 3.673 0 0 1 20 7.667a3.673 3.673 0 0 1-3.666 3.666v1.333A3.673 3.673 0 0 1 20 16.334 3.673 3.673 0 0 1 16.334 20"
})));

var _path$E;
function _extends$K() { return _extends$K = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$K.apply(null, arguments); }
const SvgScan = props => /*#__PURE__*/React.createElement("svg", _extends$K({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$E || (_path$E = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.666 2.773a9.33 9.33 0 0 0-7.893 7.894H4.12a8.02 8.02 0 0 1 6.546-6.554zm-7.9 10.56h1.34a8.02 8.02 0 0 0 6.554 6.547v1.347a9.33 9.33 0 0 1-7.893-7.894m10.567 7.9v-1.34a8.02 8.02 0 0 0 6.547-6.553h1.346a9.33 9.33 0 0 1-7.893 7.893m0-17.113V2.78a9.33 9.33 0 0 1 7.893 7.893H19.88a8.02 8.02 0 0 0-6.547-6.553",
  clipRule: "evenodd"
})));

var _path$D, _g$7;
function _extends$J() { return _extends$J = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$J.apply(null, arguments); }
const SvgSchool = props => /*#__PURE__*/React.createElement("svg", _extends$J({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$D || (_path$D = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M33.9 14 19.182 7.259a2.8 2.8 0 0 0-2.364.005L2.1 14.068l5.9 2.67V26.5c0 2.763 6.286 3.5 10 3.5s10-.737 10-3.5v-9.793l1.5-.688V24h2v-8.9ZM26 26.43c-.356.488-3.028 1.57-8 1.57s-7.644-1.082-8-1.57v-8.788l6.869 3.106a2.82 2.82 0 0 0 2.341-.006L26 17.625Zm-7.624-7.5a.83.83 0 0 1-.684 0L6.9 14.049l10.752-4.972a.82.82 0 0 1 .691 0L29.1 14Z",
  "data-name": "Tracciato 3753"
})), _g$7 || (_g$7 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 3775"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z",
  "data-name": "Rettangolo 5178"
}))));
var school = "data:image/svg+xml,%3Csvg%20%20id%3D%22school%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2236%22%20%20height%3D%2236%22%20%20viewBox%3D%220%200%2036%2036%22%3E%20%20%3Cpath%20%20%20%20id%3D%22Tracciato_3753%22%20%20%20%20data-name%3D%22Tracciato%203753%22%20%20%20%20d%3D%22M6505.9%2C64l-14.718-6.741a2.808%2C2.808%2C0%2C0%2C0-2.364.005L6474.1%2C64.068l5.9%2C2.67V76.5c0%2C2.763%2C6.286%2C3.5%2C10%2C3.5s10-.737%2C10-3.5V66.707l1.5-.688V74h2V65.1ZM6498%2C76.43c-.356.488-3.028%2C1.57-8%2C1.57s-7.644-1.082-8-1.57V67.642l6.869%2C3.106h0a2.824%2C2.824%2C0%2C0%2C0%2C2.341-.006L6498%2C67.625Zm-7.624-7.5a.825.825%2C0%2C0%2C1-.684%2C0h0L6478.9%2C64.049l10.752-4.972a.815.815%2C0%2C0%2C1%2C.691%2C0L6501.1%2C64Z%22%20%20%20%20transform%3D%22translate%28-6472%20-50%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cg%20%20%20%20id%3D%22Raggruppa_3775%22%20%20%20%20data-name%3D%22Raggruppa%203775%22%20%20%20%20transform%3D%22translate%28-6472%20-50%29%22%20%20%3E%20%20%20%20%3Crect%20%20%20%20%20%20id%3D%22Rettangolo_5178%22%20%20%20%20%20%20data-name%3D%22Rettangolo%205178%22%20%20%20%20%20%20width%3D%2236%22%20%20%20%20%20%20height%3D%2236%22%20%20%20%20%20%20transform%3D%22translate%286472%2050%29%22%20%20%20%20%20%20fill%3D%22none%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _path$C, _path2$n;
function _extends$I() { return _extends$I = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$I.apply(null, arguments); }
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends$I({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$C || (_path$C = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z"
})), _path2$n || (_path2$n = /*#__PURE__*/React.createElement("path", {
  d: "M32.208 30.794 21.423 19.968a9.785 9.785 0 1 0-1.408 1.419l10.777 10.819zm-18.4-9.187a7.8 7.8 0 1 1 7.8-7.8 7.81 7.81 0 0 1-7.808 7.8z"
})));
var search = "data:image/svg+xml,%3Csvg%20%20width%3D%2236%22%20%20height%3D%2236%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20viewBox%3D%220%200%2036%2036%22%3E%20%20%3Cg%3E%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%220%22%20fill%3D%22none%22%20height%3D%2236%22%20width%3D%2236%22%20id%3D%22Rettangolo_6253%22%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20fill%3D%22%22%20%20%20%20%20%20d%3D%22m32.208%2C30.794l-10.785%2C-10.826a9.785%2C9.785%200%201%200%20-1.408%2C1.419l10.777%2C10.819l1.416%2C-1.412zm-18.4%2C-9.187a7.8%2C7.8%200%201%201%207.8%2C-7.8a7.812%2C7.812%200%200%201%20-7.808%2C7.8l0.008%2C0z%22%20%20%20%20%20%20id%3D%22Tracciato_4291%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _path$B;
function _extends$H() { return _extends$H = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$H.apply(null, arguments); }
const SvgSettings = props => /*#__PURE__*/React.createElement("svg", _extends$H({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$B || (_path$B = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.227 14.133a.33.33 0 0 0-.247.22h-.013c-.1.3-.214.58-.347.86a.32.32 0 0 0 .02.327l1.233 1.847-2.42 2.42-1.78-1.194a.33.33 0 0 0-.333-.02q-.482.25-.993.42a.33.33 0 0 0-.22.247l-.414 2.067H10.28l-.413-2.067a.33.33 0 0 0-.22-.247 8 8 0 0 1-.994-.42.33.33 0 0 0-.333.02l-1.78 1.194-2.42-2.42 1.233-1.847a.32.32 0 0 0 .02-.327 8 8 0 0 1-.346-.86.32.32 0 0 0-.247-.22l-2.113-.42v-3.426l2.166-.434c.114-.02.207-.1.247-.213.107-.313.24-.62.387-.913a.32.32 0 0 0-.014-.327L4.287 6.593l2.393-2.4 1.853 1.24c.094.067.22.074.327.02.307-.146.62-.28.947-.38l.48-2.406h3.433l.48 2.406q.489.16.947.38a.32.32 0 0 0 .326-.02l1.854-1.24 2.393 2.4L18.553 8.4c-.06.1-.066.22-.013.327.147.293.28.6.387.913.04.107.133.193.246.213l2.167.434v3.426zM17.3 18.087l.873-.874h.014L17 15.44c.5-.707.847-1.527 1-2.42l2.027-.4v-1.24L18 10.98a6 6 0 0 0-1.067-2.52l1.12-1.68-.873-.873-1.707 1.14a6 6 0 0 0-2.413-.96L12.647 4H11.4l-.413 2.087a5.95 5.95 0 0 0-2.414.96l-1.706-1.14-.874.873 1.12 1.68a6 6 0 0 0-1.066 2.52l-2.027.4v1.24l2.027.4c.153.887.5 1.713 1 2.42L5.86 17.213l.873.874L8.507 16.9c.72.507 1.56.86 2.473 1.007l.413 2.086h1.247l.413-2.086a6 6 0 0 0 2.474-1.007zm-8.62-6.093a3.335 3.335 0 1 1 3.333 3.333 3.335 3.335 0 0 1-3.333-3.333m1.333 0c0 1.106.893 2 2 2s2-.894 2-2c0-1.107-.893-2-2-2s-2 .893-2 2",
  clipRule: "evenodd"
})));

var _path$A, _path2$m;
function _extends$G() { return _extends$G = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$G.apply(null, arguments); }
const SvgShareLink = props => /*#__PURE__*/React.createElement("svg", _extends$G({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$A || (_path$A = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M26.399 22.886a4.39 4.39 0 0 0-3.449 1.691l-9.048-5.223a4.03 4.03 0 0 0 0-2.741l9.048-5.223a4.39 4.39 0 1 0-.964-2.722 4.4 4.4 0 0 0 .108.95l-9.193 5.308a4.413 4.413 0 1 0 0 6.115l9.193 5.31a4.411 4.411 0 1 0 4.305-3.463m0-16.671a2.451 2.451 0 1 1-2.452 2.45 2.454 2.454 0 0 1 2.452-2.452M9.728 20.431a2.452 2.452 0 1 1 2.45-2.452 2.453 2.453 0 0 1-2.45 2.452m16.671 9.32a2.452 2.452 0 1 1 2.452-2.452 2.454 2.454 0 0 1-2.452 2.452",
  "data-name": "Path 117695"
})), _path2$m || (_path2$m = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z",
  "data-name": "Rectangle 17352"
})));

var _path$z;
function _extends$F() { return _extends$F = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$F.apply(null, arguments); }
const SvgSheetNew = props => /*#__PURE__*/React.createElement("svg", _extends$F({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$z || (_path$z = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.673 18.333v.047h-3.62v-5.433H1.34v-9.62h17.333v9.34H17.34V10.66h-3.333V9.327h3.333V4.66h-6.953v2.193H9.053V4.66h-6.38v6.953h6.38v-1.9h1.333v7.334h2.287zm6.994 0H24v1.334h-4.333V24h-1.334v-4.333H14v-1.334h4.333V14h1.334z",
  clipRule: "evenodd"
})));

var _path$y, _path2$l, _path3$5;
function _extends$E() { return _extends$E = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$E.apply(null, arguments); }
const SvgSheetSaturationToggle = props => /*#__PURE__*/React.createElement("svg", _extends$E({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$y || (_path$y = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z"
})), _path2$l || (_path2$l = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.04 26.29c.04-.69.15-1.35.32-2h-1.82v-12h-2v3.18H2V4h10.54v3.64h2V4H26v7.75h-5.5v2H26v2.3c.33-.03.66-.05 1-.05s.67.02 1 .05V2H0v15.46h12.54v8.82h3.5z"
})), _path3$5 || (_path3$5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M36 27v-.04a8.99 8.99 0 0 0-8.11-8.91c-.3-.03-.59-.05-.89-.05s-.6.02-.9.05a9.007 9.007 0 0 0-8.1 8.91V27a9 9 0 0 0 18 0m-9 7c-3.86 0-7-3.14-7-7s3.14-7 7-7z"
})));

var _path$x, _path2$k, _path3$4, _g$6;
function _extends$D() { return _extends$D = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$D.apply(null, arguments); }
const SvgShieldWarning = props => /*#__PURE__*/React.createElement("svg", _extends$D({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Shield Warning",
  viewBox: "0 0 24 24"
}, props), _path$x || (_path$x = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z",
  "data-name": "Rettangolo 12673"
})), _path2$k || (_path2$k = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 2.666a9.333 9.333 0 1 1-9.333 9.333A9.344 9.344 0 0 1 12 2.666m0-1.333A10.667 10.667 0 1 0 22.667 12 10.666 10.666 0 0 0 12 1.333",
  "data-name": "Tracciato 9126"
})), _path3$4 || (_path3$4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m12 19.303-.421-.343c-.075-.061-1.851-1.51-2.449-2.037-3.635-3.208-2.785-8.775-2.747-9.01l.06-.371 5.558-2.241 5.558 2.241.06.371c.037.235.888 5.8-2.747 9.01-.6.527-2.374 1.976-2.449 2.037ZM7.657 8.488c-.109 1.211-.239 5.145 2.356 7.434.4.357 1.411 1.187 1.987 1.659.576-.472 1.584-1.3 1.987-1.659 2.6-2.29 2.465-6.224 2.356-7.435L12 6.736Z",
  "data-name": "Tracciato 9127"
})), _g$6 || (_g$6 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 10379"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 10377",
  transform: "translate(11.333 14)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.667,
  cy: 0.667,
  r: 0.667,
  fill: "currentColor",
  "data-name": "Ellisse 3060"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 10378"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.347 8.667h1.333V13h-1.333z",
  "data-name": "Rettangolo 12674"
})))));
var shieldWarning = "data:image/svg+xml,%3Csvg%20%20id%3D%22Shield_Warning%22%20%20data-name%3D%22Shield%20Warning%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2224%22%20%20height%3D%2224%22%20%20viewBox%3D%220%200%2024%2024%22%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_12673%22%20%20%20%20data-name%3D%22Rettangolo%2012673%22%20%20%20%20width%3D%2224%22%20%20%20%20height%3D%2224%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20id%3D%22Tracciato_9126%22%20%20%20%20data-name%3D%22Tracciato%209126%22%20%20%20%20d%3D%22M808.667%2C193.333a9.333%2C9.333%2C0%2C1%2C1-9.333%2C9.333%2C9.344%2C9.344%2C0%2C0%2C1%2C9.333-9.333m0-1.333a10.667%2C10.667%2C0%2C1%2C0%2C10.667%2C10.667A10.666%2C10.666%2C0%2C0%2C0%2C808.667%2C192Z%22%20%20%20%20transform%3D%22translate%28-796.667%20-190.667%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20id%3D%22Tracciato_9127%22%20%20%20%20data-name%3D%22Tracciato%209127%22%20%20%20%20d%3D%22M811.135%2C211.953l-.421-.343c-.075-.061-1.851-1.51-2.449-2.037-3.635-3.208-2.785-8.775-2.747-9.01l.06-.371%2C5.558-2.241%2C5.558%2C2.241.06.371c.037.235.888%2C5.8-2.747%2C9.01-.6.527-2.374%2C1.976-2.449%2C2.037Zm-4.343-10.815c-.109%2C1.211-.239%2C5.145%2C2.356%2C7.434.4.357%2C1.411%2C1.187%2C1.987%2C1.659.576-.472%2C1.584-1.3%2C1.987-1.659%2C2.6-2.29%2C2.465-6.224%2C2.356-7.435l-4.343-1.751Z%22%20%20%20%20transform%3D%22translate%28-799.135%20-192.65%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cg%20%20%20%20id%3D%22Raggruppa_10379%22%20%20%20%20data-name%3D%22Raggruppa%2010379%22%20%20%20%20transform%3D%22translate%2811.333%208.667%29%22%20%20%3E%20%20%20%20%3Cg%20%20%20%20%20%20id%3D%22Raggruppa_10377%22%20%20%20%20%20%20data-name%3D%22Raggruppa%2010377%22%20%20%20%20%20%20transform%3D%22translate%280%205.333%29%22%20%20%20%20%3E%20%20%20%20%20%20%3Ccircle%20%20%20%20%20%20%20%20id%3D%22Ellisse_3060%22%20%20%20%20%20%20%20%20data-name%3D%22Ellisse%203060%22%20%20%20%20%20%20%20%20cx%3D%220.667%22%20%20%20%20%20%20%20%20cy%3D%220.667%22%20%20%20%20%20%20%20%20r%3D%220.667%22%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%20%20%3Cg%20%20%20%20%20%20id%3D%22Raggruppa_10378%22%20%20%20%20%20%20data-name%3D%22Raggruppa%2010378%22%20%20%20%20%20%20transform%3D%22translate%280.014%29%22%20%20%20%20%3E%20%20%20%20%20%20%3Crect%20%20%20%20%20%20%20%20id%3D%22Rettangolo_12674%22%20%20%20%20%20%20%20%20data-name%3D%22Rettangolo%2012674%22%20%20%20%20%20%20%20%20width%3D%221.333%22%20%20%20%20%20%20%20%20height%3D%224.333%22%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _path$w, _path2$j;
function _extends$C() { return _extends$C = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$C.apply(null, arguments); }
const SvgSliderHandler = props => /*#__PURE__*/React.createElement("svg", _extends$C({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16"
}, props), _path$w || (_path$w = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2.38 8c0 3.11 2.52 5.62 5.62 5.62S13.62 11.1 13.62 8 11.1 2.38 8 2.38C4.89 2.38 2.38 4.89 2.38 8M.5 8C.5 3.86 3.86.5 8 .5s7.5 3.36 7.5 7.5-3.36 7.5-7.5 7.5S.5 12.14.5 8"
})), _path2$j || (_path2$j = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M.5 8c0 4.14 3.36 7.5 7.5 7.5s7.5-3.36 7.5-7.5S12.14.5 8 .5.5 3.86.5 8m13.12 0c0 3.1-2.52 5.62-5.62 5.62S2.38 11.1 2.38 8 4.9 2.38 8 2.38 13.62 4.9 13.62 8M0 8c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8-8-3.59-8-8m13.12 0c0-2.83-2.3-5.12-5.12-5.12S2.88 5.18 2.88 8 5.17 13.12 8 13.12s5.12-2.29 5.12-5.12",
  opacity: 0.8
})));
var sliderHandler = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20%20version%3D%221.1%22%20%20id%3D%22Layer_1%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20%20x%3D%220px%22%20%20y%3D%220px%22%20%20width%3D%2216px%22%20%20height%3D%2216px%22%20%20viewBox%3D%220%200%2016%2016%22%20%20enable-background%3D%22new%200%200%2016%2016%22%20%20xml%3Aspace%3D%22preserve%22%3E%20%20%3Cg%20id%3D%22Switch%22%20transform%3D%22translate%280.5%2015.5%29%20rotate%28-90%29%22%3E%20%20%20%20%3Cpath%20%20%20%20%20%20fill%3D%22%23fff%22%20%20%20%20%20%20d%3D%22M7.5%2C1.88c-3.11%2C0-5.62%2C2.52-5.62%2C5.62s2.52%2C5.62%2C5.62%2C5.62s5.62-2.52%2C5.62-5.62%20%20C13.12%2C4.39%2C10.61%2C1.88%2C7.5%2C1.88%20M7.5%2C0C11.64%2C0%2C15%2C3.36%2C15%2C7.5S11.64%2C15%2C7.5%2C15S0%2C11.64%2C0%2C7.5S3.36%2C0%2C7.5%2C0z%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20opacity%3D%220.8%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20d%3D%22M7.5%2C0C3.36%2C0%2C0%2C3.36%2C0%2C7.5S3.36%2C15%2C7.5%2C15S15%2C11.64%2C15%2C7.5S11.64%2C0%2C7.5%2C0%20M7.5%2C13.12%20%20c-3.1%2C0-5.62-2.52-5.62-5.62S4.4%2C1.88%2C7.5%2C1.88s5.62%2C2.52%2C5.62%2C5.62S10.6%2C13.12%2C7.5%2C13.12%20M7.5-0.5c4.41%2C0%2C8%2C3.59%2C8%2C8s-3.59%2C8-8%2C8%20%20s-8-3.59-8-8S3.09-0.5%2C7.5-0.5z%20M7.5%2C12.62c2.83%2C0%2C5.12-2.3%2C5.12-5.12s-2.3-5.12-5.12-5.12S2.38%2C4.67%2C2.38%2C7.5%20%20S4.67%2C12.62%2C7.5%2C12.62z%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _path$v;
function _extends$B() { return _extends$B = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$B.apply(null, arguments); }
const SvgSortDown = props => /*#__PURE__*/React.createElement("svg", _extends$B({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path$v || (_path$v = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m14.484 10.458.627.64L12 14.208l-3.111-3.11.626-.64 2.031 2.026v-9.83h.907v9.83zM.89 2.667h3.555v.889H.89zm0 2.666h5.333v.89H.889zM.889 8v.889h7.11V8z",
  clipRule: "evenodd"
})));

var _path$u;
function _extends$A() { return _extends$A = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$A.apply(null, arguments); }
const SvgSortUp = props => /*#__PURE__*/React.createElement("svg", _extends$A({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path$u || (_path$u = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m14.484 6.413.627-.644L12 2.658l-3.111 3.11.626.645 2.031-2.026v9.826h.907V4.387zM.89 2.667h3.555v.888H.89zm0 2.666h5.333v.89H.889zM.889 8v.889h7.11v-.89z",
  clipRule: "evenodd"
})));

var _path$t;
function _extends$z() { return _extends$z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$z.apply(null, arguments); }
const SvgSort = props => /*#__PURE__*/React.createElement("svg", _extends$z({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path$t || (_path$t = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.427 2.573v10.854l2.017-2.018.627.627-3.089 3.093-3.093-3.093.626-.627 2.023 2.018V2.573L9.515 4.591l-.626-.627L11.982.871l3.089 3.093-.627.627zM.889 4h3.555v.889H.89zm0 2.667h5.333v.889H.889zm0 2.666v.89h7.11v-.89z",
  clipRule: "evenodd"
})));

var _style, _path$s, _path2$i;
function _extends$y() { return _extends$y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$y.apply(null, arguments); }
const SvgSphereXgLogo = props => /*#__PURE__*/React.createElement("svg", _extends$y({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "sphere-xg-logo_svg__Layer_1",
  width: "1em",
  height: "1em",
  x: 0,
  y: 0,
  viewBox: "0 0 432 432"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".sphere-xg-logo_svg__st0{fill:#fff}")), _path$s || (_path$s = /*#__PURE__*/React.createElement("path", {
  d: "M96.3 221.5c-.1 5.7.7 11.7 2.4 16.4 3.6 10.1 12.2 17.2 18.9 4 5.8-14.2 2.8-33.3-3.8-40.3-7.9-8.3-17.1 2.1-17.5 19.9",
  className: "sphere-xg-logo_svg__st0"
})), _path2$i || (_path2$i = /*#__PURE__*/React.createElement("path", {
  d: "M115 197.6c1.6 12.8 12 21.8 23.2 7.8 8.9-13.3 7-28.1 2.7-34.3-7.4-11-21.9-2.2-25.4 15.5-.7 3.5-.9 7.7-.5 11M117.8 263.4c4.4 14.2 18.5 25.4 26.2 11.5 5.4-12.8-.4-29.7-9.1-36.3-10.7-8-20.5 1.7-18.5 18.2.2 2 .8 4.7 1.4 6.6M99.2 205c5.5-11.7 7.3-31.7 3.3-37.6-3.8-5.5-10.6 3.9-13.5 18.6-1.7 8.5-1.7 17.1 0 21.9.3 1.1 3.7 9.9 10.2-2.9M106.6 275.1c1.4-13.9-5.1-33.5-10.9-38-5.6-4.3-8.5 5.5-5.9 19.9 1.5 8.2 4.6 16.4 8 20.8 1.2 1.5 7 8.6 8.8-2.7M135.1 221.9c-.1 1.3 0 3.1.1 4.4 1.6 17.3 17.8 27.9 29 13.9 6.9-9.6 6-25.5-1.9-34.1-10.8-11.5-26.3-2.5-27.2 15.8M120.7 170.1c9-12.1 10.4-26.1 8-31.5-3.6-8.1-14.7-.1-20.5 14.7-3 7.6-2.9 13.1-2.7 15.1.6 7.2 5.9 12.7 15.2 1.7M133.2 305.8c1.5-10.8-7.5-29.3-16.4-33.6-7.8-3.8-11.2 5.1-6.7 17.9 1.3 3.9 3.3 7.7 5.6 11.1 6 8.7 15.5 15.2 17.5 4.6M81.7 221.4c.1 11.6 1.6 22.4 3.5 24.7 1.8 2.2 2.7-4 3-6 1.6-12.8.1-35.2-2.7-38.7-2.2-2.6-4 6.7-3.8 20M144.4 153.7c-.8 2.5-1.3 5-1.3 7.3-.3 13 11.3 19.6 23.1 8.2 7.2-7.5 9.7-19.6 5.5-27-6.1-10.7-22.2-3.9-27.3 11.5M174.7 304.5c4.9-10.7-1.8-24.6-11-29.9-11.1-6.4-20.6 1.9-17.4 15.3 3.3 14.2 20.4 27.6 28.4 14.6M92 272.6c-2.2-1-.4 6.8 3.9 17.2 4.5 10.9 9.5 19 11.4 19.9 1.6.7.5-3.3.1-5-3.6-12.4-12.3-30.7-15.4-32.1M93.6 168.9c6.2-12.3 11.4-29.6 10.2-32.1-1-2.1-5.6 5.5-9.8 16.3-3.8 9.7-6.1 19.2-5.2 21.1s3.8-3.5 4.8-5.3M191.8 202.9c8.9-10.8 6-21.9 2.8-26.7-8.8-13.6-27.8-7-30.8 10.7-.2 1.1-.3 2.7-.3 3.8 0 15.8 15.5 25.2 28.3 12.2M136.7 123.4c-2.1 3.8-3.3 7.7-3.4 10.9-.2 7.4 5.8 11.9 16.2 2.7 7.3-7 11.8-18.5 9.6-24.7-3.1-8.4-15.9-.6-22.4 11.1M195.1 272.5c7.9-11.4 1.8-23.8-3.9-29-11.5-10.3-27-2.4-26.4 13.4.6 15.1 18.1 29.6 30.3 15.6M141.3 322.9c6 9.7 20.4 20.2 22.7 9.6 1-10.4-9-23.8-17.6-27.1-8.4-3.1-11.8 4.1-6.8 14.4.5 1 1.2 2.2 1.7 3.1M131 336.2c4.3 2.3 3.1-2.3 2.7-3.8-2.7-9.2-14.9-26.4-20.7-27.7-3.9-.9-2.5 6.1 3 15 5.2 8.3 11.6 14.7 15 16.5M106.8 140c.2 1.4 1.2 5.1 8.7-3.1 8.8-10.4 14.1-23.6 13.2-27.1-1-3.9-9.1 3-15.5 13.3-4.9 7.9-6.7 14.2-6.4 16.9M223.2 237.2c8.5-10.3 4.5-21.6-.3-26.7-10.7-11.4-28.2-4.4-29.3 11.8 0 .5-.1 1.3 0 1.8.2 15.3 17.1 25.3 29.6 13.1M164.7 355.8c-3.6-9-16.9-21.8-22.6-21.8-3.8 0-2.3 5.5 3.1 12 4 4.8 9.7 9.5 14.3 11.9s6.4 1.7 5.2-2.1M144.9 107.6c8-6.7 14.4-17.3 13.8-20.9-.7-4.4-10.7 2.2-17.5 10.1-3.8 4.4-6.2 8.9-6.6 11.8-.3 3.1 2.2 5.5 10.3-1M178.6 123.6c-.8 1.9-1.3 3.8-1.4 5.6-.7 11.1 11.2 14.9 20.6 6.5 8.2-8 7.5-16.2 5.7-19.8-5-10.4-20-4.1-24.9 7.7M206.3 330.9c4.1-7.8-1-17.7-8.3-22.2-10.3-6.3-19.8 0-16.7 11 3.1 10.8 18.2 20.9 25 11.2M181.7 107c7.9-6.7 9.6-14.2 8.8-17.6-1.7-7.4-13.8-1.9-20.1 7.2-2.1 3.1-2.9 5.6-3.2 7.1-1.3 7.2 5.2 10.1 14.5 3.3M195.7 355.3c.9-7.4-8.1-18.4-16.5-20.3-6.9-1.5-9.3 3.8-5.1 10.9 5.4 9.1 19.4 17.5 21.6 9.4M227.3 302.1c6.5-8.4 2.3-17.6-2.2-21.8-10.2-9.7-25.7-3.7-24.7 9.6.9 13 16.9 22.4 26.9 12.2M227.1 146.5c-6.8-11.9-25.1-7.1-28.3 7.3-.2.9-.4 2.1-.4 3.1-.5 12.6 13.5 20.1 25.2 9.8 9.1-9.6 4.1-19.1 3.5-20.2M123.8 106.9c5.5-5.6 17.4-19.4 17.2-21-.9-.5-7 5.2-11.9 10.6-5.2 5.7-10.6 12.7-10.2 14.1.6.3 2.4-1.3 4.9-3.7M124.4 334.7c-.3 1.1 4.3 6.6 8.7 11.2 6.7 7 13.7 12.8 14.6 12.4.1-.4-.4-1.1-2.1-3.1-3.9-4.3-19.5-21.1-21.2-20.5M229.8 257.2c-.7 14.2 16.4 22.1 26.6 12.1 7.4-8.1 4-16.7.8-20.4-9.3-11-26.7-5.7-27.4 8.3M255.6 199.5c7.6-8.4 4.4-17 1.2-20.8-8.9-10.7-26-5.6-27.7 8.2-.1.4-.1 1-.1 1.5-.4 11.9 14.1 22.3 26.6 11.1M196.6 374.7c-3.2-6.3-14.7-15-19.8-15.1-3.4 0-2.2 3.9 2.6 8.3 3.2 3 7.7 6 11.7 7.7 3.2 1.5 6.8 2.5 5.5-.9M176.5 374.7c-6.3-5.7-19.2-15.1-22-15.1-1.7 0 1.1 3.6 7.4 8.3 7 5.2 15.5 9.7 16.3 8.9 0-.4-.4-.8-1.7-2.1M177.7 81.9c8.3-5.8 12.1-12.3 12.2-14.3.1-3.7-9.1.7-15.5 6.6-3.1 2.8-5.2 5.6-5.8 7.7-.9 3 1.4 4.9 9.1 0M153.5 81.8c7.6-5.4 16.8-13.9 17-15.3.3-1.6-7.2 2.6-13.6 7.6-5.8 4.5-9.2 8.4-9.6 10-.2.8.3 1.8 6.2-2.3M213.7 97c-.4.9-.7 2.1-.8 3-1.1 8.3 8.7 11.6 16 5.4 6.4-6 4.4-11.8 3.9-12.9-3.3-7.8-15.3-4.9-19.1 4.5M229.9 338.3c-7.1-3.9-15.3-.5-13 7.7 2 7.4 12.9 14.2 18.4 7.6 3.5-5.4 0-12.3-5.4-15.3M237 319.8c.3 9.4 11.9 15.9 20 8.7 4.3-4.3 4-11.3-.6-15.6-7-6.5-19.8-3.5-19.4 6.9M235 123.7c-.1.3-.1.8-.2 1.1-1 9.7 10.6 16.1 20 8.1 4.2-3.9 4.9-10 1.8-14.6-5.8-8.3-19.5-4.9-21.6 5.4M224.6 373.9c1-4.2-5.1-11.8-11.8-13-4.5-.8-7.1 2.1-3.7 7.2 3.8 5.5 13.8 10.9 15.5 5.8M213.1 80.9c6.9-5.3 6.2-10.7 6.2-10.9-.8-5.6-10-2.2-14.9 4.2-1.5 2.1-2.1 3.7-2.3 4.7-.9 5.1 5.2 6.2 11 2M187.1 61.2c4.9-2.5 14.7-8.8 14.7-9.8-.7-.5-6.9 2-12 4.9s-8 5.4-8.3 6.4c-.2.6.3 1.2 5.6-1.5M208.7 389c-4.1-2.6-17.3-9.8-19.3-9.2-1 .3 1.5 2.5 6.6 5.2 5.6 3 12.7 5.5 14.1 5.4 0 0 .1-.1.1-.2-.2-.3-.5-.5-1.5-1.2M266.5 222.4c-1 11.6 12.7 20.1 22.9 10.7 5.5-5.7 4.5-13.6.9-18.1-7.6-9.5-22.8-4.8-23.8 7.4M267.7 290.1c-.9 9.2 10.3 15.9 19 8.6 4.2-3.9 4.9-10.3 1.6-14.6-6.1-7.9-19.6-3.9-20.6 6M287.1 163c5.3-6.1 2.4-12.3-.1-15.1-6.9-7.5-19.3-3.7-20.1 6.1-.8 9.5 11.7 16.8 20.2 9M211.3 380.2c-1.9.3-.8 2.3 2.5 4.7 3.1 2.2 7.1 4 9.6 4.7 3.4.9 2.6-.4 2.3-.9-2.6-3.6-11.1-8.9-14.4-8.5M209.9 60.9c5.5-3.2 8.6-7.1 8.8-8.3.2-2.1-6.2.4-10.8 3.8-2.2 1.6-3.8 3.3-4.3 4.5-.8 1.8 1 2.8 6.3 0M304.6 257.5c0 .3-.1.6-.1.9-.3 7.4 7.9 12.2 14.5 6.3 3.4-3.3 3.9-8.6 1.4-12.2-4.5-6.4-14.7-3.2-15.8 5M304.5 187.2v.9c.3 7.7 9.3 12.8 15.4 6.5 3.2-3.6 2.9-9.4-.7-13-5.4-5.6-14.3-2.2-14.7 5.6M220.5 46.1c2.6-.9 9.4-3.8 10.1-4.3v-.1c-.6-.1-4.3.9-7.6 2.2-3.4 1.3-6 2.6-5.9 3.1.3.1 1.6-.3 3.4-.9M254.6 78.9c3.2-3.1 1.8-6.1 1.3-6.9-2.7-4.4-9.3-2.2-10.7 2.4-.1.3-.2.7-.2 1-.4 4.4 5 7.1 9.6 3.5M256.9 364.2c-4-2.8-9-.6-8.4 3.7.5 3.9 6.1 7.5 9.7 4 2.4-2.8 1.1-6-1.3-7.7M239.3 59.6c3-2.3 2.9-4.5 2.9-4.9-.4-3-5.2-1.5-7.6 1.7-.6.9-.9 1.6-.9 1.9-.6 2.4 2.1 3.5 5.6 1.3M270.1 346c-.6 4.6 5 8.9 10.3 4.7 3.4-3.2 2.3-6.6 1.3-8-3.2-4.3-10.9-2.1-11.6 3.3M280.2 102.1c3.1-3.7.5-7.2-.1-7.9-3.9-4.8-11.4-3-11.7 2.8-.3 5.4 7.2 9.6 11.8 5.1M241.7 381.7c-2.5-.4-3.5 1.2-2 3.3 1.8 2.6 6.6 5.1 7.6 2.7.6-1.9-2.3-5.4-5.6-6M301.2 319.9c0 .2-.1.4-.1.5-.7 4.5 4 7.4 8.5 3.9 3.2-3 2.6-6.1 1.9-7.4-2.2-3.6-9-2.3-10.3 3M311.2 128.5c1.8-2.2 1-5.9-1.6-8.1-4-3.3-9.2-1.2-8.9 3.6.4 4.9 6.9 8.5 10.5 4.5M237.4 45.5c2.2-1.1 3.9-2.5 4.1-3 .3-.8-2.6.2-4.6 1.4-1.1.7-1.9 1.3-2.1 1.7-.2.5.5.8 2.6-.1M349.2 219.7c-2.5-3.2-7.1-1.4-7.6 3v1c.3 4.3 4.8 6.3 7.4 3.2 2.1-2.7 1.3-5.8.2-7.2",
  className: "sphere-xg-logo_svg__st0"
})));

var _path$r, _path2$h, _path3$3, _path4$1, _path5, _path6, _path7, _path8;
function _extends$x() { return _extends$x = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$x.apply(null, arguments); }
const SvgSplitscreenStart = props => /*#__PURE__*/React.createElement("svg", _extends$x({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Divide Window Vertical",
  viewBox: "0 0 36 36"
}, props), _path$r || (_path$r = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.983 8.992h1v1h-1z",
  "data-name": "Rettangolo 1470"
})), _path2$h || (_path2$h = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.851 8.992h1v1h-1z",
  "data-name": "Rettangolo 1471"
})), _path3$3 || (_path3$3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.717 8.992h1v1h-1z",
  "data-name": "Rettangolo 1472"
})), _path4$1 || (_path4$1 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M28.978 8.992h1v1h-1z",
  "data-name": "Rettangolo 1473"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M26.845 8.992h1v1h-1z",
  "data-name": "Rettangolo 1474"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M24.711 8.992h1v1h-1z",
  "data-name": "Rettangolo 1475"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M32 5H4a2 2 0 0 0-2 2v24h32V7a2 2 0 0 0-2-2M4.5 7H17v22H4V7.5a.5.5 0 0 1 .5-.5M32 29H19V7h12.5a.5.5 0 0 1 .5.5Z",
  "data-name": "Tracciato 1082"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z",
  "data-name": "Rettangolo 1476"
})));
var splitscreenStart = "data:image/svg+xml,%3Csvg%20%20id%3D%22Divide_Window_Vertical%22%20%20data-name%3D%22Divide%20Window%20Vertical%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2236%22%20%20height%3D%2236%22%20%20viewBox%3D%220%200%2036%2036%22%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_1470%22%20%20%20%20data-name%3D%22Rettangolo%201470%22%20%20%20%20width%3D%221%22%20%20%20%20height%3D%221%22%20%20%20%20transform%3D%22translate%2813.983%208.992%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_1471%22%20%20%20%20data-name%3D%22Rettangolo%201471%22%20%20%20%20width%3D%221%22%20%20%20%20height%3D%221%22%20%20%20%20transform%3D%22translate%2811.851%208.992%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_1472%22%20%20%20%20data-name%3D%22Rettangolo%201472%22%20%20%20%20width%3D%221%22%20%20%20%20height%3D%221%22%20%20%20%20transform%3D%22translate%289.717%208.992%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_1473%22%20%20%20%20data-name%3D%22Rettangolo%201473%22%20%20%20%20width%3D%221%22%20%20%20%20height%3D%221%22%20%20%20%20transform%3D%22translate%2828.978%208.992%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_1474%22%20%20%20%20data-name%3D%22Rettangolo%201474%22%20%20%20%20width%3D%221%22%20%20%20%20height%3D%221%22%20%20%20%20transform%3D%22translate%2826.845%208.992%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_1475%22%20%20%20%20data-name%3D%22Rettangolo%201475%22%20%20%20%20width%3D%221%22%20%20%20%20height%3D%221%22%20%20%20%20transform%3D%22translate%2824.711%208.992%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20id%3D%22Tracciato_1082%22%20%20%20%20data-name%3D%22Tracciato%201082%22%20%20%20%20d%3D%22M11480%2C335h-28a2%2C2%2C0%2C0%2C0-2%2C2v24h32V337A2%2C2%2C0%2C0%2C0%2C11480%2C335Zm-27.5%2C2h12.5v22h-13V337.5A.5.5%2C0%2C0%2C1%2C11452.5%2C337Zm27.5%2C22h-13V337h12.5a.5.5%2C0%2C0%2C1%2C.5.5Z%22%20%20%20%20transform%3D%22translate%28-11448%20-330%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_1476%22%20%20%20%20data-name%3D%22Rettangolo%201476%22%20%20%20%20width%3D%2236%22%20%20%20%20height%3D%2236%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%3C%2Fsvg%3E";

var _g$5;
function _extends$w() { return _extends$w = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$w.apply(null, arguments); }
const SvgSwatchTransparency = props => /*#__PURE__*/React.createElement("svg", _extends$w({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Layer 2",
  viewBox: "0 0 36 36"
}, props), _g$5 || (_g$5 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 18"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z",
  "data-name": "Rectangle 20254"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18 32v-2c1.26 0 2.51-.2 3.7-.59l.62 1.9c-1.39.45-2.85.69-4.32.69m-4.32-.68c-1.4-.45-2.71-1.12-3.9-1.99l1.18-1.62c1.02.74 2.15 1.31 3.34 1.7l-.62 1.9Zm12.55-2-1.18-1.62c1.02-.74 1.92-1.63 2.66-2.65l1.62 1.17a14 14 0 0 1-3.09 3.1M6.69 26.24c-.87-1.19-1.54-2.5-2-3.9l1.89-.62c.39 1.2.97 2.32 1.72 3.34zm24.63-3.93-1.9-.61c.39-1.2.58-2.45.58-3.71l2-.05v.05c0 1.47-.23 2.93-.68 4.32M3.98 18.03V18c0-1.46.23-2.91.67-4.3l1.9.61c-.38 1.19-.58 2.44-.58 3.69zm25.4-3.78a11.7 11.7 0 0 0-1.72-3.33l1.61-1.19c.87 1.18 1.55 2.5 2 3.89l-1.9.63ZM8.25 10.97 6.63 9.8c.86-1.19 1.9-2.23 3.09-3.1l1.18 1.61c-1.02.74-1.91 1.64-2.65 2.66M25 8.27c-1.02-.74-2.15-1.31-3.34-1.7l.61-1.9c1.4.45 2.71 1.12 3.9 1.98L25 8.28ZM14.24 6.6l-.62-1.9c1.39-.46 2.85-.69 4.32-.69v2c-1.26 0-2.51.2-3.7.59",
  "data-name": "Path 117966"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M27.98 18c0 5.52-4.48 10-10 10s-10-4.48-10-10 4.48-10 10-10 10 4.48 10 10",
  "data-name": "Path 117967"
}))));

var _path$q, _path2$g;
function _extends$v() { return _extends$v = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$v.apply(null, arguments); }
const SvgSyncCamerasOnWaypoint = props => /*#__PURE__*/React.createElement("svg", _extends$v({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$q || (_path$q = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.22 4.073c0-.773-.634-1.406-1.407-1.406s-1.407.633-1.407 1.406c0 .774.634 1.407 1.407 1.407s1.407-.633 1.407-1.407m-4.147 0a2.74 2.74 0 1 1 5.48 0 2.74 2.74 0 0 1-5.48 0m-3.8 9.954 3.053-5.54.593-1.22c.46.113 1.04.32 1.46.513 2.474 1.127 4.18 3.487 4.18 6.433h-1.333c0-2.48-1.473-4.426-3.587-5.306q-.01 0-.023-.01l-.023-.01-3.14 5.76zm10.454 8.64h1.333c0-4.346-2.152-5.327-3.879-6.113h-.001c-1.54-.7-2.647-1.207-2.647-3.74H11.2c0 3.389 1.816 4.217 3.42 4.95l.007.003c1.66.753 3.1 1.407 3.1 4.9M4.993 21.333c2.993 0 5.433-2.4 5.506-5.373a4.9 4.9 0 0 0 1.127 1.527c-.746 2.973-3.427 5.18-6.633 5.18h-.054v-1.334z",
  clipRule: "evenodd",
  opacity: 0.4
})), _path2$g || (_path2$g = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m3.653 10.227-1.1 1.107h4.68L6.5 12.667H2.553l1.1 1.107-.94.94L0 12l2.713-2.713zm16.694 0 .94-.94L24.001 12l-2.714 2.714-.94-.94 1.107-1.107h-3.7c-.087-.46-.207-.9-.36-1.333h4.06z",
  clipRule: "evenodd"
})));

var _path$p;
function _extends$u() { return _extends$u = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$u.apply(null, arguments); }
const SvgTagsAdd = props => /*#__PURE__*/React.createElement("svg", _extends$u({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 25 24"
}, props), _path$p || (_path$p = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m10.272 20.78-5.627-5.627L17.1 2.667l5.16.493.493 5.16-4.353 4.346h1.886l3.407-3.4c.28-.28.427-.673.386-1.073l-.493-5.16a1.336 1.336 0 0 0-1.2-1.2l-5.16-.493h-.127c-.353 0-.693.14-.946.393L2.758 15.153l7.514 7.513 3.04-3.033v-1.886l-3.033 3.026zM9.559 6.453l-7.087 4.373 1.04 1.687-.973.967-1.9-3.087 12.993-8.026zM20.305 14v4.333h4.334v1.334h-4.334V24h-1.333v-4.333h-4.333v-1.334h4.333V14zm-2.273-7.94c0-.733.6-1.333 1.333-1.333.734 0 1.334.6 1.334 1.333s-.6 1.333-1.334 1.333c-.733 0-1.333-.6-1.333-1.333m.667 0c0 .367.3.667.666.667s.667-.3.667-.667-.3-.667-.667-.667c-.366 0-.666.3-.666.667",
  clipRule: "evenodd"
})));

var _path$o;
function _extends$t() { return _extends$t = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$t.apply(null, arguments); }
const SvgTagsDelete = props => /*#__PURE__*/React.createElement("svg", _extends$t({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$o || (_path$o = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m9.633 20.773-5.627-5.62L16.46 2.667l5.16.493.493 5.16-3.5 3.493H20.5l2.553-2.546c.28-.28.427-.674.387-1.074l-.494-5.16a1.336 1.336 0 0 0-1.2-1.2l-5.16-.493h-.126c-.354 0-.694.14-.947.393L2.12 15.153l7.513 7.513 3.66-3.66-.246-1.64zm9.094-16.046c.733 0 1.333.6 1.333 1.333s-.6 1.333-1.333 1.333c-.734 0-1.334-.6-1.334-1.333s.6-1.333 1.334-1.333M18.06 6.06c0 .367.3.667.667.667.366 0 .666-.3.666-.667s-.3-.667-.666-.667-.667.3-.667.667m1.36 7.087 1.547 1.54H24v1.333h-.967L21.847 24h-6.46L14.2 16.02h-.867v-1.333h3l1.547-1.54zm-.273.666h-.994l-.873.874h2.747zm-2.614 8.853H20.7l.987-6.646h-6.14zm1.354-5.306.193 3.973h-.667l-.193-3.973zm2.193-.006h-.666l-.2 3.98h.673zM8.92 6.454l-7.087 4.373 1.04 1.686-.973.967L0 10.393l12.993-8.026z",
  clipRule: "evenodd"
})));

var _path$n;
function _extends$s() { return _extends$s = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$s.apply(null, arguments); }
const SvgTagsManage = props => /*#__PURE__*/React.createElement("svg", _extends$s({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$n || (_path$n = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.637 20.76H9.63l-5.625-5.617L16.455 2.66l5.158.493.493 5.158-3.419 3.413h1.886l2.473-2.466c.28-.28.427-.673.387-1.073l-.494-5.159a1.336 1.336 0 0 0-1.2-1.2l-5.158-.493h-.126c-.354 0-.693.14-.947.394L2.12 15.143l7.511 7.51 2.093-2.085-.687-1.207-1.4 1.393zM18.72 4.72c.733 0 1.333.6 1.333 1.333s-.6 1.333-1.333 1.333-1.333-.6-1.333-1.333.6-1.333 1.333-1.333m-.666 1.333c0 .366.3.666.666.666s.667-.3.667-.666-.3-.667-.667-.667c-.366 0-.666.3-.666.667m4.732 12.47q.002-.13-.007-.26l1.22-.946-.513-.907-1.233-2.14-.967.4-.466.194a6 6 0 0 0-.447-.26l-.226-1.54h-3.5l-.22 1.534a5 5 0 0 0-.446.26l-1.44-.58-1.232 2.139-.514.906 1.22.953q0 .066-.003.13-.004.066-.004.13-.002.13.007.26l-1.22.953.514.907 1.233 2.139 1.433-.593q.218.14.446.26L16.65 24h3.499l.22-1.534c.153-.08.306-.166.446-.26l1.44.58 1.233-2.139.513-.906-1.22-.954q0-.066.003-.131.003-.062.004-.122zm-1.42-.74a3.1 3.1 0 0 1-.007 1.48l-.02.086.927.727-.593 1.033-1.093-.44-.06.06c-.36.346-.8.6-1.28.74l-.08.026-.173 1.167h-1.193l-.173-1.167-.08-.026a3.1 3.1 0 0 1-1.287-.74l-.06-.06-1.093.44-.593-1.033.927-.727-.02-.086a2.93 2.93 0 0 1 0-1.48l.02-.087-.927-.726.593-1.033 1.093.44.06-.06c.36-.347.807-.6 1.287-.74l.08-.027.173-1.166h1.193l.173 1.167.08.026c.48.14.927.393 1.287.74l.06.06 1.092-.44.594 1.033-.927.726.02.08zm-2.98-1.093a1.832 1.832 0 1 0 0 3.665 1.832 1.832 0 1 0 0-3.665m0 2.999c-.64 0-1.166-.527-1.166-1.167s.527-1.166 1.167-1.166 1.166.526 1.166 1.166-.526 1.167-1.166 1.167M8.918 6.445l-7.084 4.372 1.04 1.686-.974.966L0 10.384 12.99 2.36z",
  clipRule: "evenodd"
})));

var _g$4;
function _extends$r() { return _extends$r = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$r.apply(null, arguments); }
const SvgTags = props => /*#__PURE__*/React.createElement("svg", _extends$r({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g$4 || (_g$4 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "m4.094 10.462-.935-2.257 5.46-2.27 1.03-1.029-7.215 3 1.234 2.982zM14.996 7.244a1.112 1.112 0 1 0 0-2.223 1.112 1.112 0 0 0 0 2.223m0-1.667a.556.556 0 1 1 0 1.112.556.556 0 0 1 0-1.112"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.667 3.348-3.41-.014h-.005a1.1 1.1 0 0 0-.785.326l-8.6 8.6 5.01 5.01 8.57-8.549a1.1 1.1 0 0 0 .326-.786V4.46a1.11 1.11 0 0 0-1.106-1.112M8.878 15.7l-3.44-3.44 7.733-7.733a.28.28 0 0 1 .197-.081l3.017.012a.28.28 0 0 1 .278.278V7.82a.28.28 0 0 1-.082.196z"
}))));

var _path$m;
function _extends$q() { return _extends$q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$q.apply(null, arguments); }
const SvgTimeDistance = props => /*#__PURE__*/React.createElement("svg", _extends$q({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$m || (_path$m = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 1.333a7.34 7.34 0 0 1 7.334 7.334A7.34 7.34 0 0 1 12 16a7.34 7.34 0 0 1-7.333-7.333A7.34 7.34 0 0 1 12 1.333M12 0a8.666 8.666 0 0 0-8.666 8.667A8.666 8.666 0 0 0 12 17.333a8.666 8.666 0 0 0 8.667-8.666A8.666 8.666 0 0 0 12 0M2.862 21.903a1.333 1.333 0 1 0-1.723-2.036 1.333 1.333 0 0 0 1.723 2.036m8.472-12.976V5.333h1.333v3.04l2.76 2.767-.94.94zm8.093 11.287H4.574c.053.213.093.433.093.666s-.04.454-.093.667h14.853a2.7 2.7 0 0 1-.093-.667c0-.233.04-.453.093-.666m3.593-.194a1.333 1.333 0 1 1-2.036 1.722 1.333 1.333 0 0 1 2.036-1.722",
  clipRule: "evenodd"
})));

var _path$l, _path2$f;
function _extends$p() { return _extends$p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$p.apply(null, arguments); }
const SvgTool = props => /*#__PURE__*/React.createElement("svg", _extends$p({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$l || (_path$l = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z",
  "data-name": "Rectangle 3738"
})), _path2$f || (_path2$f = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.537 34a3.66 3.66 0 0 1-2.595-1.072l-.87-.871a3.673 3.673 0 0 1 0-5.189l13.535-13.534a8.36 8.36 0 0 1 .7-6.539 9.2 9.2 0 0 1 3.727-3.725 8.4 8.4 0 0 1 7.154-.5l1.464.542-5.331 5.331 3.229 3.23 5.332-5.331.541 1.463a8.4 8.4 0 0 1-.5 7.156 9.2 9.2 0 0 1-3.726 3.725 8.37 8.37 0 0 1-6.538.705L9.125 32.926A3.66 3.66 0 0 1 6.537 34M16.57 16.2 4.486 28.283a1.67 1.67 0 0 0 0 2.361l.871.87a1.67 1.67 0 0 0 2.359 0L22.14 17.09l.6.222a6.4 6.4 0 0 0 5.518-.386 7.16 7.16 0 0 0 2.906-2.906 6.4 6.4 0 0 0 .786-3.912l-4.4 4.4-6.058-6.059 4.4-4.4a6.4 6.4 0 0 0-3.912.786 7.16 7.16 0 0 0-2.905 2.907 6.4 6.4 0 0 0-.386 5.516l.222.6Z",
  "data-name": "Path 2646"
})));

var _path$k, _path2$e, _path3$2, _path4;
function _extends$o() { return _extends$o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$o.apply(null, arguments); }
const SvgTrajectoryAlign = props => /*#__PURE__*/React.createElement("svg", _extends$o({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z"
})), _path2$e || (_path2$e = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m34.09 26.65-1.65 1.65.71.7L36 26.15l-2.85-2.85-.71.7 1.65 1.65H21.86v1zM34.09 10.35 32.44 12l.71.71L36 9.85 33.15 7l-.71.71 1.65 1.65H21.86v1zM26.45 15.15l-.71.71 1.65 1.65h-7.85c.07.33.07.67 0 1h7.85l-1.65 1.65.71.71L29.3 18zM5.21 11.07c.73 0 1.32.59 1.32 1.32s-.59 1.32-1.32 1.32-1.32-.59-1.32-1.32c-.01-.73.59-1.32 1.32-1.32m0-.88c-1.22 0-2.21.99-2.2 2.21s.99 2.21 2.21 2.2c1.22 0 2.2-.99 2.21-2.21-.02-1.22-1-2.2-2.22-2.2"
})), _path3$2 || (_path3$2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.18 20.81c-.67-2.12-3.71-3.31-6.91-4.56-2.09-.81-4.57-1.78-5.59-2.89-.32.48-.86.8-1.47.8-.17 0-.33-.03-.49-.08 1.14 1.81 4.01 2.94 6.82 4.03 1.87.73 4.07 1.59 5.13 2.52a1.74 1.74 0 0 1 2.51.18M17.84 23.71c-.53 0-.99-.24-1.32-.6-1.04.9-2.96 1.64-4.84 2.36-3.46 1.33-7.04 2.7-7.04 5.77h2c0-1.69 2.92-2.81 5.75-3.9 2.69-1.03 5.45-2.1 6.49-3.98-.28.21-.64.35-1.04.35M5.21 10.63c.61 0 1.15.32 1.47.79.93-.96 3.11-1.81 5.09-2.59C15.33 7.44 19.01 6 19.01 3h-2c0 1.63-3.17 2.87-5.97 3.97-2.71 1.06-5.3 2.08-6.34 3.74.16-.05.33-.08.51-.08"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.84 20.62c.73 0 1.32.59 1.33 1.32 0 .73-.59 1.32-1.32 1.33-.73 0-1.32-.59-1.33-1.32 0-.74.59-1.33 1.32-1.33m0-.88c-1.22 0-2.21.99-2.2 2.21 0 1.22.99 2.21 2.21 2.2 1.22 0 2.2-.99 2.2-2.21s-.99-2.2-2.21-2.2"
})));

var _path$j, _path2$d, _path3$1;
function _extends$n() { return _extends$n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$n.apply(null, arguments); }
const SvgTrajectoryCorrection = props => /*#__PURE__*/React.createElement("svg", _extends$n({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z"
})), _path2$d || (_path2$d = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M29.62 36h-.92c-1.66 0-3-1.34-3-3V18.8a6.52 6.52 0 0 1-3.08-3.91 7.1 7.1 0 0 1 0-4.09 6.54 6.54 0 0 1 3.66-4.21l1.42-.65v5.79h2.92V5.94l1.42.65c1.79.79 3.13 2.33 3.66 4.21.4 1.34.4 2.76 0 4.09a6.48 6.48 0 0 1-3.08 3.91V33c0 1.65-1.34 3-3 3m-5.09-24.62c-.29.96-.29 1.98 0 2.93a4.58 4.58 0 0 0 2.58 2.97l.58.27V33c0 .55.45 1 1 1h.92c.55 0 1-.45 1-1V17.55l.58-.27a4.53 4.53 0 0 0 2.58-2.97c.29-.96.29-1.98 0-2.93-.21-.76-.61-1.45-1.17-2.01v4.35h-6.92V9.37c-.53.56-.93 1.25-1.15 2.01M4.93 10.2c.49.1.92.34 1.26.68.07.07.13.15.19.23 1.22-.97 3.41-1.83 5.42-2.62 3.99-1.56 8.12-3.18 8.12-6.49h-2c0 1.94-3.64 3.37-6.85 4.63-2.66 1.04-5.22 2.05-6.6 3.52.16 0 .31.02.46.05M11.66 19c2.01.78 4.18 1.63 5.47 2.57.19-.16.4-.31.64-.41.3-.13.63-.2.97-.2.28 0 .54.06.79.14-1.31-1.69-4.17-2.81-7.15-3.97-2.25-.88-4.7-1.83-6.01-2.94-.06.07-.11.15-.18.21-.34.34-.78.58-1.26.68-.15.03-.3.04-.45.05 1.5 1.66 4.37 2.78 7.18 3.87M18.74 25.97c-.69 0-1.32-.28-1.77-.73-.01-.01-.02-.03-.03-.04-1.25.9-3.21 1.65-5.13 2.39-3.87 1.49-7.88 3.03-7.88 6.41h2c0-2.01 3.36-3.3 6.61-4.55 2.55-.98 5.15-1.99 6.6-3.53-.13.03-.26.05-.4.05"
})), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.43 11.15c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5m0-1a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 0 0-5M18.74 21.97c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5m0-1a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 0 0-5"
})));

var _path$i;
function _extends$m() { return _extends$m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$m.apply(null, arguments); }
const SvgUnhappyFace44Px = props => /*#__PURE__*/React.createElement("svg", _extends$m({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 44 44"
}, props), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1 22A21 21 0 0 1 22 1a21 21 0 0 1 21 21 21 21 0 0 1-21 21A21 21 0 0 1 1 22m3 0a18.02 18.02 0 0 0 18 18 18.02 18.02 0 0 0 18-18A18.02 18.02 0 0 0 22 4 18.02 18.02 0 0 0 4 22m8.33 10.769a1.5 1.5 0 0 1-.653-2.019A11.54 11.54 0 0 1 22 24.424a11.54 11.54 0 0 1 10.323 6.327 1.5 1.5 0 0 1-.656 2.019 1.5 1.5 0 0 1-.679.163 1.5 1.5 0 0 1-1.338-.819 8.44 8.44 0 0 0-7.65-4.69 8.44 8.44 0 0 0-7.654 4.69 1.5 1.5 0 0 1-1.337.819 1.5 1.5 0 0 1-.679-.165Zm-.7-15.442a1.5 1.5 0 0 1-.913-1.915 1.5 1.5 0 0 1 1.915-.913 6.56 6.56 0 0 0 4.238 0 1.5 1.5 0 0 1 1.914.913 1.5 1.5 0 0 1-.914 1.914 9.4 9.4 0 0 1-3.119.526 9.4 9.4 0 0 1-3.12-.526Zm14.5 0a1.5 1.5 0 0 1-.912-1.916 1.5 1.5 0 0 1 1.916-.913 6.52 6.52 0 0 0 4.237 0 1.5 1.5 0 0 1 1.914.914 1.5 1.5 0 0 1-.913 1.915 9.4 9.4 0 0 1-3.122.519 9.4 9.4 0 0 1-3.123-.521Z"
})));

var _path$h, _path2$c;
function _extends$l() { return _extends$l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$l.apply(null, arguments); }
const SvgUpdate360Transformation = props => /*#__PURE__*/React.createElement("svg", _extends$l({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.334 7.44a.41.41 0 0 0-.067.487l3.134 5.42c.033.06.086.113.146.146l5.42 3.134c.16.093.36.066.487-.067a.41.41 0 0 0 .067-.487l-3.134-5.42a.4.4 0 0 0-.146-.146L7.82 7.373a.394.394 0 0 0-.487.067M12.7 12c0 .447-.36.807-.807.807a.805.805 0 0 1-.807-.807c0-.447.36-.807.807-.807s.807.36.807.807"
})), _path2$c || (_path2$c = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.026 7.443v-2.79h1.333v5.334h-5.333V8.653h3.125C17.88 5.908 15.105 4 11.892 4 8.232 4 5.152 6.473 4.2 9.827H2.826c.98-4.107 4.666-7.16 9.066-7.16a9.32 9.32 0 0 1 8.134 4.776M2.633 14.44v-.007h5.333v1.334h-3.13A8.01 8.01 0 0 0 11.885 20c3.563-.003 6.58-2.342 7.613-5.56h1.387c-1.074 3.967-4.694 6.893-9 6.893a9.31 9.31 0 0 1-7.92-4.407v2.847H2.633V14.44",
  clipRule: "evenodd",
  opacity: 0.4
})));

var _path$g, _path2$b, _path3;
function _extends$k() { return _extends$k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$k.apply(null, arguments); }
const SvgUpload = props => /*#__PURE__*/React.createElement("svg", _extends$k({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Export - Upload",
  viewBox: "0 0 22 22"
}, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.555 19.556H2.443V9.167h1.222v9.167h14.667V9.167h1.223Z",
  "data-name": "Tracciato 5102"
})), _path2$b || (_path2$b = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m15.278 6.723-.856.881-2.8-2.785v11.07h-1.244V4.819L7.581 7.605l-.859-.882L11 2.445Z",
  "data-name": "Tracciato 5103"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M22 22H0V0h22z",
  "data-name": "Rettangolo 7699"
})));
var upload = "data:image/svg+xml,%3Csvg%20%20id%3D%22Export_-_Upload%22%20%20data-name%3D%22Export%20-%20Upload%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2222%22%20%20height%3D%2222%22%20%20viewBox%3D%220%200%2022%2022%22%3E%20%20%3Cpath%20%20%20%20id%3D%22Tracciato_5102%22%20%20%20%20data-name%3D%22Tracciato%205102%22%20%20%20%20d%3D%22M4393.112%2C145.389H4376V135h1.222v9.167h14.667V135h1.223Z%22%20%20%20%20transform%3D%22translate%28-4373.557%20-125.833%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20id%3D%22Tracciato_5103%22%20%20%20%20data-name%3D%22Tracciato%205103%22%20%20%20%20d%3D%22M8.556%2C4.278%2C7.7%2C5.159%2C4.9%2C2.374V13.444H3.656V2.374L.859%2C5.16%2C0%2C4.278%2C4.278%2C0h0Z%22%20%20%20%20transform%3D%22translate%286.722%202.445%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_7699%22%20%20%20%20data-name%3D%22Rettangolo%207699%22%20%20%20%20width%3D%2222%22%20%20%20%20height%3D%2222%22%20%20%20%20transform%3D%22translate%2822%2022%29%20rotate%28180%29%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$f, _circle, _circle2, _circle3;
function _extends$j() { return _extends$j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$j.apply(null, arguments); }
const SvgUserLocation = props => /*#__PURE__*/React.createElement("svg", _extends$j({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 4059.9 4059.9"
}, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
  fill: "#0AF",
  d: "M3464.8 3448c3.4-3.3 6.8-6.7 10.1-10.1 780.8-780.8 780.8-2046.7 0-2827.4L2051.1 2034.3z",
  opacity: 0.3
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 2029.9,
  cy: 2029.9,
  r: 725,
  fill: "#FFF"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 2029.9,
  cy: 2029.9,
  r: 660.5,
  fill: "#082A6E"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 2029.9,
  cy: 2029.9,
  r: 330,
  fill: "#FFF"
})));
var userLocation = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20%20version%3D%221.1%22%20%20id%3D%22Layer_1%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20%20x%3D%220px%22%20%20y%3D%220px%22%20%20width%3D%224059.9%22%20%20height%3D%224059.9%22%20%20viewBox%3D%220%200%204059.9%204059.9%22%20%20style%3D%22enable-background%3A%20new%200%200%204059.9%204059.9%22%20%20xml%3Aspace%3D%22preserve%22%3E%20%20%3Cg%20opacity%3D%220.3%22%20fill%3D%22%2300AAFF%22%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M3464.8%2C3448c3.4-3.3%2C6.8-6.7%2C10.1-10.1c780.8-780.8%2C780.8-2046.7%2C0-2827.4L2051.1%2C2034.3L3464.8%2C3448z%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%20fill%3D%22%23FFFFFF%22%3E%20%20%20%20%3Ccircle%20cx%3D%222029.9%22%20cy%3D%222029.9%22%20r%3D%22725%22%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%20fill%3D%22%23082A6E%22%3E%20%20%20%20%3Ccircle%20cx%3D%222029.9%22%20cy%3D%222029.9%22%20r%3D%22660.5%22%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%20fill%3D%22%23FFFFFF%22%3E%20%20%20%20%3Ccircle%20cx%3D%222029.9%22%20cy%3D%222029.9%22%20r%3D%22330%22%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _path$e, _path2$a;
function _extends$i() { return _extends$i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$i.apply(null, arguments); }
const SvgVideoCamera = props => /*#__PURE__*/React.createElement("svg", _extends$i({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Camera Right",
  viewBox: "0 0 18 18"
}, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z",
  "data-name": "Rectangle 1407"
})), _path2$a || (_path2$a = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m15.332 5-3.165 2.115V4.5H3.774a1.09 1.09 0 0 0-1.107 1.071v6.857A1.09 1.09 0 0 0 3.774 13.5h8.393v-2.615L15.332 13Zm-4.165 7.5h-7.25a.25.25 0 0 1-.249-.25v-6.5a.25.25 0 0 1 .249-.25h7.25Zm3.165-1.371-2.165-1.447V8.317l2.165-1.447Z",
  "data-name": "Path 1001"
})));
var videoCamera = "data:image/svg+xml,%3Csvg%20%20id%3D%22Camera_Right%22%20%20data-name%3D%22Camera%20Right%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2236%22%20%20height%3D%2236%22%20%20viewBox%3D%220%200%2018%2018%22%3E%20%20%3Crect%20%20%20%20id%3D%22Rectangle_1407%22%20%20%20%20data-name%3D%22Rectangle%201407%22%20%20%20%20width%3D%2236%22%20%20%20%20height%3D%2236%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20id%3D%22Path_1001%22%20%20%20%20data-name%3D%22Path%201001%22%20%20%20%20d%3D%22M11314%2C969.5l-3.165%2C2.115V969h-8.393a1.091%2C1.091%2C0%2C0%2C0-1.107%2C1.071v6.857a1.091%2C1.091%2C0%2C0%2C0%2C1.107%2C1.072h8.393v-2.615L11314%2C977.5Zm-4.165%2C7.5h-7.25a.249.249%2C0%2C0%2C1-.249-.25v-6.5a.249.249%2C0%2C0%2C1%2C.249-.25h7.25Zm3.165-1.371-2.165-1.447v-1.365l2.165-1.447Z%22%20%20%20%20transform%3D%22translate%28-11298.668%20-964.5%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _g$3, _defs$2;
function _extends$h() { return _extends$h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$h.apply(null, arguments); }
const SvgVideo = props => /*#__PURE__*/React.createElement("svg", _extends$h({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, props), _g$3 || (_g$3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#video_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 4.442a2.78 2.78 0 0 1 2.775 2.775v5.559A2.78 2.78 0 0 1 15 15.55H5a2.78 2.78 0 0 1-2.775-2.775V7.217A2.78 2.78 0 0 1 5 4.442zm0-1.108H5a3.89 3.89 0 0 0-3.892 3.892v5.558A3.89 3.89 0 0 0 5 16.676h10a3.89 3.89 0 0 0 3.892-3.892V7.226A3.89 3.89 0 0 0 15 3.334"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.85 9.935 7.9 12.743V7.26z"
}))), _defs$2 || (_defs$2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "video_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));

var _path$d;
function _extends$g() { return _extends$g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$g.apply(null, arguments); }
const SvgViewOptions = props => /*#__PURE__*/React.createElement("svg", _extends$g({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.04 26h.17c.198 0 .401-.017.602-.035L17 25.95v2l-.213.017c-.195.017-.386.033-.577.033h-.42c-1.59 0-3.3-.37-5.04-1.15C3.05 23.4 0 18 0 18s3.05-5.4 10.75-8.85C12.49 8.37 14.2 8 15.79 8h.42c1.59 0 3.3.37 5.04 1.15C28.95 12.6 32 18 32 18s-.35.61-1.09 1.54h-2.66c.56-.59 1-1.12 1.32-1.54-1.21-1.59-4.1-4.76-9.14-7.02-1.45-.65-2.87-.98-4.22-.98h-.42c-1.35 0-2.77.33-4.22.98-5.04 2.25-7.92 5.43-9.14 7.02 1.21 1.59 4.1 4.76 9.14 7.02 1.45.65 2.87.98 4.22.98h.25M36 27.04h-3.61c-.39-.88-1.27-1.5-2.29-1.5s-1.9.62-2.29 1.5h-8.82v2h8.82c.39.88 1.27 1.5 2.29 1.5s1.9-.62 2.29-1.5H36zm-5.89 2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m5.89 3h-9.01c-.38-.9-1.27-1.54-2.31-1.54s-1.93.64-2.31 1.54H19v2h3.41c.4.86 1.26 1.46 2.27 1.46s1.87-.6 2.27-1.46H36zM24.68 35c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5M16 21.57c-1.97 0-3.57-1.6-3.57-3.57s1.6-3.57 3.57-3.57 3.57 1.6 3.57 3.57c0 .55-.14 1.07-.36 1.54h2.14c.14-.49.22-1 .22-1.54 0-3.07-2.5-5.57-5.57-5.57s-5.57 2.5-5.57 5.57 2.5 5.57 5.57 5.57c.34 0 .68-.04 1-.09v-2.07c-.32.09-.65.16-1 .16m10.95-.03H36v2h-9.01c-.38.9-1.27 1.54-2.31 1.54s-1.93-.64-2.31-1.54H19v-2h3.41c.4-.86 1.26-1.46 2.27-1.46s1.87.6 2.27 1.46m-3.77 1.04c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5-1.5.67-1.5 1.5",
  clipRule: "evenodd"
})));

var _path$c, _path2$9;
function _extends$f() { return _extends$f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$f.apply(null, arguments); }
const SvgViewPredefinedBack = props => /*#__PURE__*/React.createElement("svg", _extends$f({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.778 2.223h-8.89v8.889h8.89z",
  opacity: 0.4
})), _path2$9 || (_path2$9 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m4.706 1.777-2.929 2.93v9.515h9.516l2.929-2.93V1.778zm.405 3.556h5.555v5.556H5.111zm5.818-.889H5.11V2.666h7.595zm-6.263 0H3.293l1.373-1.373zm0 .889v5.684l-2 2V5.333zm.316 6h5.684v2H2.982zm6.573 0h1.374l-1.374 1.373zm0-.444V5.07l1.778-1.778v7.596z"
})));
var viewPredefinedBack = "data:image/svg+xml,%3Csvg%20%20width%3D%2216%22%20%20height%3D%2216%22%20%20viewBox%3D%220%200%2016%2016%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20opacity%3D%220.4%22%20%20%20%20d%3D%22M13.7776%202.22266H4.88867V11.1115H13.7776V2.22266Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M4.70623%201.77734L1.77734%204.70623V14.2218H11.2929L14.2218%2011.2929V1.77734H4.70623ZM5.11068%205.3329H10.6662V10.8885H5.11068V5.3329ZM10.9285%204.44401H5.11068V2.66623H12.7062L10.9285%204.44401ZM4.66623%204.44401H3.2929L4.66623%203.07068V4.44401ZM4.66623%205.3329V11.0173L2.66623%2013.0173V5.3329H4.66623ZM4.98179%2011.3329H10.6662V13.3329H2.98179L4.98179%2011.3329ZM11.5551%2011.3329H12.9285L11.5551%2012.7062V11.3329ZM11.5551%2010.8885V5.07068L13.3329%203.2929V10.8885H11.5551Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$b, _path2$8;
function _extends$e() { return _extends$e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$e.apply(null, arguments); }
const SvgViewPredefinedBottom = props => /*#__PURE__*/React.createElement("svg", _extends$e({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m2.223 13.778 2.666-2.667h8.89l-2.668 2.667z",
  opacity: 0.4
})), _path2$8 || (_path2$8 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m4.706 1.777-2.929 2.93v9.515h9.516l2.929-2.93V1.778zm.405 3.556h5.555v5.556H5.111zm5.818-.889H5.11V2.666h7.595zm-6.263 0H3.293l1.373-1.373zm0 .889v5.684l-2 2V5.333zm.316 6h5.684v2H2.982zm6.573 0h1.374l-1.374 1.373zm0-.444V5.07l1.778-1.778v7.596z"
})));
var viewPredefinedBottom = "data:image/svg+xml,%3Csvg%20%20width%3D%2216%22%20%20height%3D%2216%22%20%20viewBox%3D%220%200%2016%2016%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20opacity%3D%220.4%22%20%20%20%20d%3D%22M2.22266%2013.778L4.88932%2011.1113H13.7782L11.1115%2013.778H2.22266Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M4.70623%201.77734L1.77734%204.70623V14.2218H11.2929L14.2218%2011.2929V1.77734H4.70623ZM5.11068%205.3329H10.6662V10.8885H5.11068V5.3329ZM10.9285%204.44401H5.11068V2.66623H12.7062L10.9285%204.44401ZM4.66623%204.44401H3.2929L4.66623%203.07068V4.44401ZM4.66623%205.3329V11.0173L2.66623%2013.0173V5.3329H4.66623ZM4.98179%2011.3329H10.6662V13.3329H2.98179L4.98179%2011.3329ZM11.5551%2011.3329H12.9285L11.5551%2012.7062V11.3329ZM11.5551%2010.8885V5.07068L13.3329%203.2929V10.8885H11.5551Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$a, _path2$7;
function _extends$d() { return _extends$d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d.apply(null, arguments); }
const SvgViewPredefinedFront = props => /*#__PURE__*/React.createElement("svg", _extends$d({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.112 4.889h-8.89v8.889h8.89z",
  opacity: 0.4
})), _path2$7 || (_path2$7 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m4.706 1.778-2.929 2.93v9.515h9.516l2.929-2.93V1.779zm.405 3.556h5.555v5.555H5.111zm5.818-.889H5.11V2.667h7.595zm-6.263 0H3.293l1.373-1.373zm0 .889v5.684l-2 2V5.334zm.316 6h5.684v2H2.982zm6.573 0h1.374l-1.374 1.373zm0-.445V5.072l1.778-1.778v7.595z"
})));
var viewPredefinedFront = "data:image/svg+xml,%3Csvg%20%20width%3D%2216%22%20%20height%3D%2216%22%20%20viewBox%3D%220%200%2016%2016%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20opacity%3D%220.4%22%20%20%20%20d%3D%22M11.1115%204.88867H2.22266V13.7776H11.1115V4.88867Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M4.70623%201.77832L1.77734%204.70721V14.2228H11.2929L14.2218%2011.2939V1.77832H4.70623ZM5.11068%205.33388H10.6662V10.8894H5.11068V5.33388ZM10.9285%204.44499H5.11068V2.66721H12.7062L10.9285%204.44499ZM4.66623%204.44499H3.2929L4.66623%203.07165V4.44499ZM4.66623%205.33388V11.0183L2.66623%2013.0183V5.33388H4.66623ZM4.98179%2011.3339H10.6662V13.3339H2.98179L4.98179%2011.3339ZM11.5551%2011.3339H12.9285L11.5551%2012.7072V11.3339ZM11.5551%2010.8894V5.07165L13.3329%203.29388V10.8894H11.5551Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$9, _path2$6;
function _extends$c() { return _extends$c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c.apply(null, arguments); }
const SvgViewPredefinedLeft = props => /*#__PURE__*/React.createElement("svg", _extends$c({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.89 2.223v8.889l-2.667 2.666V4.89z",
  opacity: 0.4
})), _path2$6 || (_path2$6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m4.706 1.777-2.929 2.93v9.515h9.516l2.929-2.93V1.778zm-.04 1.294v1.373H3.293zm0 2.262v5.684l-2 2V5.333zm6 8H2.982l2-2h5.684zm0-2.444H5.111V5.333h5.555zm.262-6.445H5.111V2.666h7.595zm.627 8.262v-1.373h1.374zm1.778-1.817h-1.778V5.07l1.778-1.778z"
})));
var viewPredefinedLeft = "data:image/svg+xml,%3Csvg%20%20width%3D%2216%22%20%20height%3D%2216%22%20%20viewBox%3D%220%200%2016%2016%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20opacity%3D%220.4%22%20%20%20%20d%3D%22M4.88932%202.22266V11.1115L2.22266%2013.7782V4.88932L4.88932%202.22266Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M4.70623%201.77734L1.77734%204.70623V14.2218H11.2929L14.2218%2011.2929V1.77734H4.70623ZM4.66623%203.07068V4.44401H3.2929L4.66623%203.07068ZM4.66623%205.3329V11.0173L2.66623%2013.0173V5.3329H4.66623ZM10.6662%2013.3329H2.98178L4.98178%2011.3329H10.6662V13.3329ZM10.6662%2010.8885H5.11068V5.3329H10.6662V10.8885ZM10.9285%204.44401H5.11068V2.66623H12.7062L10.9285%204.44401ZM11.5551%2012.7062V11.3329H12.9285L11.5551%2012.7062ZM13.3329%2010.8885H11.5551V5.07068L13.3329%203.2929V10.8885Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$8, _path2$5;
function _extends$b() { return _extends$b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b.apply(null, arguments); }
const SvgViewPredefinedRight = props => /*#__PURE__*/React.createElement("svg", _extends$b({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m1.777 4.706 2.93-2.929h9.515v9.516l-2.93 2.929H1.778zm3.334-2.04v1.778h5.813l1.778-1.778zm-.445 1.778V3.071L3.293 4.444zm0 .889v5.684l-2 2.004V5.333zm-1.687 8h7.687v-2H4.982zm7.687-2.444H5.111V5.333h5.555zm.89.444v1.369l1.368-1.37zm1.777-.444h-1.778V5.07l1.778-1.778z",
  clipRule: "evenodd"
})), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.778 2.223v8.889l-2.667 2.666V4.89z",
  opacity: 0.4
})));
var viewPredefinedRight = "data:image/svg+xml,%3Csvg%20%20width%3D%2216%22%20%20height%3D%2216%22%20%20viewBox%3D%220%200%2016%2016%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M1.77734%204.70623L4.70623%201.77734H14.2218V11.2929L11.2929%2014.2218H1.77734V4.70623ZM5.11085%202.66623V4.44401H10.924L12.7018%202.66623H5.11085ZM4.66641%204.44401V3.0705L3.2929%204.44401H4.66641ZM4.66641%205.3329V11.0173L2.66623%2013.0209V5.3329H4.66641ZM2.97855%2013.3329H10.6662V11.3329H4.98196L2.97855%2013.3329ZM10.6662%2010.8885H5.11085V5.3329H10.6662V10.8885ZM11.5551%2011.3329V12.7018L12.924%2011.3329H11.5551ZM13.3329%2010.8885H11.5551V5.07068L13.3329%203.2929V10.8885Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20opacity%3D%220.4%22%20%20%20%20d%3D%22M13.778%202.22266V11.1115L11.1113%2013.7782V4.88932L13.778%202.22266Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$7, _path2$4;
function _extends$a() { return _extends$a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a.apply(null, arguments); }
const SvgViewPredefinedTop = props => /*#__PURE__*/React.createElement("svg", _extends$a({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m1.777 4.706 2.93-2.929h9.515v9.516l-2.93 2.929H1.778zm3.334-2.04v1.778h5.813l1.778-1.778zm-.445 1.778V3.071L3.293 4.444zm0 .889v5.684l-2 2.004V5.333zm-1.687 8h7.687v-2H4.982zm7.687-2.444H5.111V5.333h5.555zm.89.444v1.369l1.368-1.37zm1.777-.444h-1.778V5.07l1.778-1.778z",
  clipRule: "evenodd"
})), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m2.223 4.89 2.666-2.667h8.89L11.11 4.889z",
  opacity: 0.4
})));
var viewPredefinedTop = "data:image/svg+xml,%3Csvg%20%20width%3D%2216%22%20%20height%3D%2216%22%20%20viewBox%3D%220%200%2016%2016%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M1.77734%204.70623L4.70623%201.77734H14.2218V11.2929L11.2929%2014.2218H1.77734V4.70623ZM5.11085%202.66623V4.44401H10.924L12.7018%202.66623H5.11085ZM4.66641%204.44401V3.0705L3.2929%204.44401H4.66641ZM4.66641%205.3329V11.0173L2.66623%2013.0209V5.3329H4.66641ZM2.97855%2013.3329H10.6662V11.3329H4.98196L2.97855%2013.3329ZM10.6662%2010.8885H5.11085V5.3329H10.6662V10.8885ZM11.5551%2011.3329V12.7018L12.924%2011.3329H11.5551ZM13.3329%2010.8885H11.5551V5.07068L13.3329%203.2929V10.8885Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20opacity%3D%220.4%22%20%20%20%20d%3D%22M2.22266%204.88932L4.88932%202.22266H13.7782L11.1115%204.88932H2.22266Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _path$6;
function _extends$9() { return _extends$9 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9.apply(null, arguments); }
const SvgViews = props => /*#__PURE__*/React.createElement("svg", _extends$9({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.293 2 2 5.293V16h10.707L16 12.707V2zm.457 4H12v6.25H5.75zm6.543-1H5.75V3h8.543zM5.25 5H3.707L5.25 3.457zm0 1v6.397L3 14.647V6zm.354 6.75H12V15H3.354zm7.396 0h1.543L13 14.293zm0-.5V5.707l2-2v8.543z"
})));
var views = "data:image/svg+xml,%3Csvg%20%20width%3D%2218%22%20%20height%3D%2218%22%20%20viewBox%3D%220%200%2018%2018%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20d%3D%22M5.29297%202L2%205.29297V16H12.707L16%2012.707V2H5.29297ZM5.75%206H12V12.25H5.75V6ZM12.293%205H5.75V3H14.293L12.293%205ZM5.25%205H3.70703L5.25%203.45697V5ZM5.25%206V12.3965L3%2014.6465V6H5.25ZM5.60352%2012.75H12V15H3.35352L5.60352%2012.75ZM13%2012.75H14.543L13%2014.293V12.75ZM13%2012.25V5.70697L15%203.70697V12.25H13Z%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var _defs$1, _path$5, _path2$3;
function _extends$8() { return _extends$8 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8.apply(null, arguments); }
const SvgVisible = props => /*#__PURE__*/React.createElement("svg", _extends$8({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _defs$1 || (_defs$1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".visible_svg__b{fill:currentColor}"))), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h36v36H0z",
  style: {
    fill: "none"
  }
}), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.788 10h.424a10.35 10.35 0 0 1 4.221.978A23.7 23.7 0 0 1 31.575 18a23.7 23.7 0 0 1-9.142 7.022 10.35 10.35 0 0 1-4.221.978h-.424a10.35 10.35 0 0 1-4.221-.978A23.7 23.7 0 0 1 4.425 18a23.7 23.7 0 0 1 9.142-7.022A10.35 10.35 0 0 1 17.788 10m.424-2h-.424a12.4 12.4 0 0 0-5.038 1.153C5.05 12.599 2 18 2 18s3.049 5.4 10.75 8.847A12.4 12.4 0 0 0 17.788 28h.424a12.4 12.4 0 0 0 5.038-1.153C30.95 23.401 34 18 34 18s-3.049-5.4-10.75-8.847A12.4 12.4 0 0 0 18.212 8",
  className: "visible_svg__b"
})), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
  d: "M18 23.571A5.571 5.571 0 1 1 23.571 18 5.577 5.577 0 0 1 18 23.571m0-9.142A3.571 3.571 0 1 0 21.571 18 3.576 3.576 0 0 0 18 14.429",
  className: "visible_svg__b"
})));

var _g$2, _path$4, _path2$2;
function _extends$7() { return _extends$7 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7.apply(null, arguments); }
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends$7({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  "data-name": "Raggruppa 10392"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 10390",
  transform: "translate(11 15.666)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1,
  cy: 1,
  r: 1,
  "data-name": "Ellisse 3062"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 10391"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.358 6.333h1.333v8h-1.333z",
  "data-name": "Rettangolo 12686"
})))), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 2.666a9.333 9.333 0 1 1-9.333 9.333A9.343 9.343 0 0 1 12 2.666m0-1.333A10.667 10.667 0 1 0 22.667 12 10.666 10.666 0 0 0 12 1.333",
  "data-name": "Tracciato 9140"
})), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z",
  "data-name": "Rettangolo 12687"
})));
var warning = "data:image/svg+xml,%3Csvg%20%20id%3D%22Warning%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2224%22%20%20height%3D%2224%22%20%20viewBox%3D%220%200%2024%2024%22%3E%20%20%3Cg%20%20%20%20id%3D%22Raggruppa_10392%22%20%20%20%20data-name%3D%22Raggruppa%2010392%22%20%20%20%20transform%3D%22translate%2811%206.333%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%3E%20%20%20%20%3Cg%20%20%20%20%20%20id%3D%22Raggruppa_10390%22%20%20%20%20%20%20data-name%3D%22Raggruppa%2010390%22%20%20%20%20%20%20transform%3D%22translate%280%209.333%29%22%20%20%20%20%3E%20%20%20%20%20%20%3Ccircle%20id%3D%22Ellisse_3062%22%20data-name%3D%22Ellisse%203062%22%20cx%3D%221%22%20cy%3D%221%22%20r%3D%221%22%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%20%20%3Cg%20%20%20%20%20%20id%3D%22Raggruppa_10391%22%20%20%20%20%20%20data-name%3D%22Raggruppa%2010391%22%20%20%20%20%20%20transform%3D%22translate%280.358%200%29%22%20%20%20%20%3E%20%20%20%20%20%20%3Crect%20%20%20%20%20%20%20%20id%3D%22Rettangolo_12686%22%20%20%20%20%20%20%20%20data-name%3D%22Rettangolo%2012686%22%20%20%20%20%20%20%20%20width%3D%221.333%22%20%20%20%20%20%20%20%20height%3D%228%22%20%20%20%20%20%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%20%3Cpath%20%20%20%20id%3D%22Tracciato_9140%22%20%20%20%20data-name%3D%22Tracciato%209140%22%20%20%20%20d%3D%22M808.667%2C53.333a9.333%2C9.333%2C0%2C1%2C1-9.333%2C9.333%2C9.343%2C9.343%2C0%2C0%2C1%2C9.333-9.333m0-1.333a10.667%2C10.667%2C0%2C1%2C0%2C10.667%2C10.667A10.666%2C10.666%2C0%2C0%2C0%2C808.667%2C52Z%22%20%20%20%20transform%3D%22translate%28-796.667%20-50.667%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_12687%22%20%20%20%20data-name%3D%22Rettangolo%2012687%22%20%20%20%20width%3D%2224%22%20%20%20%20height%3D%2224%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%3C%2Fsvg%3E";

var _g$1;
function _extends$6() { return _extends$6 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6.apply(null, arguments); }
const SvgXmarkCircleFill = props => /*#__PURE__*/React.createElement("svg", _extends$6({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
  "data-name": "xmark-circle-fill"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h36v36H0z",
  "data-name": "container"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18 34A16.02 16.02 0 0 1 2 18 16.02 16.02 0 0 1 18 2a16.02 16.02 0 0 1 16 16 16.02 16.02 0 0 1-16 16m0-13.456 6.292 6.293 2.545-2.546-6.292-6.293 6.292-6.293-2.545-2.546L18 15.454l-6.292-6.293-2.546 2.546L15.455 18l-6.293 6.293 2.546 2.546L18 20.546Z",
  "data-name": "xmark"
}))));
var xmarkCircleFill = "data:image/svg+xml,%3Csvg%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2236%22%20%20height%3D%2236%22%20%20viewBox%3D%220%200%2036%2036%22%3E%20%20%3Cg%20%20%20%20id%3D%22xmark-circle-fill%22%20%20%20%20data-name%3D%22xmark-circle-fill%22%20%20%20%20transform%3D%22translate%28-182%20-198.846%29%22%20%20%3E%20%20%20%20%3Crect%20%20%20%20%20%20id%3D%22container%22%20%20%20%20%20%20data-name%3D%22container%22%20%20%20%20%20%20width%3D%2236%22%20%20%20%20%20%20height%3D%2236%22%20%20%20%20%20%20transform%3D%22translate%28182%20198.846%29%22%20%20%20%20%20%20fill%3D%22none%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22xmark%22%20%20%20%20%20%20data-name%3D%22xmark%22%20%20%20%20%20%20d%3D%22M2832-86.154a16.018%2C16.018%2C0%2C0%2C1-16-16%2C16.018%2C16.018%2C0%2C0%2C1%2C16-16%2C16.018%2C16.018%2C0%2C0%2C1%2C16%2C16A16.018%2C16.018%2C0%2C0%2C1%2C2832-86.154Zm0-13.456h0l6.292%2C6.293%2C2.545-2.546-6.292-6.293%2C6.292-6.293-2.545-2.546L2832-104.7l-6.292-6.293-2.546%2C2.546%2C6.293%2C6.293-6.293%2C6.293%2C2.546%2C2.546L2832-99.608Z%22%20%20%20%20%20%20transform%3D%22translate%28-2632%20319%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _path$3;
function _extends$5() { return _extends$5 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5.apply(null, arguments); }
const SvgZoomAll = props => /*#__PURE__*/React.createElement("svg", _extends$5({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.007 21.388a9.787 9.787 0 0 1-13.447-.986 9.79 9.79 0 0 1 .3-13.48 9.79 9.79 0 0 1 13.474-.392 9.787 9.787 0 0 1 1.081 13.44l10.786 10.826-1.417 1.412ZM5.999 13.807a7.8 7.8 0 0 0 7.8 7.8 7.81 7.81 0 0 0 7.8-7.8 7.8 7.8 0 0 0-7.8-7.8 7.8 7.8 0 0 0-7.8 7.8m9.3 3.993v-1h1.5v-1.5h1v2.5Zm-5.5 0v-2.5h1v1.5h1.5v1Zm7-5.5v-1.5h-1.5v-1h2.5v2.5Zm-7 0V9.8h2.5v1h-1.5v1.5Z",
  "data-name": "zoom-all"
})));

/** @returns Wrapper for SVG icons */
function FaroSvgIcon({ source, ...rest }) {
    const inheritViewBox = rest.inheritViewBox ?? !rest.viewBox;
    return (jsx(SvgIcon, { component: source, inheritViewBox: inheritViewBox, ...rest }));
}

/**
 * @param props to forward to the underlying icon
 * @returns an icon to close, cancel operations (X)
 */
function CloseCancelErrorIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCloseCancelError, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns arrow-down icon
 */
function ArrowDownIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgArrowDown, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns crop icon
 */
function CropIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCrop, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Rotate clockwise icon
 */
function RotateClockwiseIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgRotateCw, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns icon for the markup polygon in the 3d scene
 */
function MarkupPolygonIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgMarkupPolygon, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Second version of arrow-down icon
 */
function ArrowDown2Icon(props) {
    return jsx(FaroSvgIcon, { source: SvgArrowDown, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns clock icon
 */
function ClockSmallIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgClockSmall, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon to show world coordinates
 */
function WorldCoordinateIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCoordinatesGlobal, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns dollhouse icon
 */
function DollhouseIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgDollhouse, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns dollhouse warning icon
 */
function DollhouseWarningIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgDollhouseWarning, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Download Point Cloud Icon
 */
function DownloadIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgDownload, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns faro-logo icon
 */
function FaroLogoIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgFaroLogo, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns faro-logo icon compact version
 */
function FaroLogoCompactIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgFaroLogoCompact, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns revit icon
 */
function RevitIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgRevit, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns exchange arrows icon
 */
function ExchangeArrowsIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgExchangeArrows, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns home icon
 */
function HomeIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgHome, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns help icon
 */
function HelpIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgHelp, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns map icon
 */
function LayoutSheetSmallIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgLayoutSheetSmall, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns larger version of the map icon
 */
function MapLargeIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgMapLarge, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns cad model icon
 */
function CadSmallIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCadSmall, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns show/visible icon (opposite of NonVisibleIcon)
 */
function VisibleIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgVisible, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns no-show/hide icon (opposite of VisibleIcon)
 */
function NonVisibleIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgNonVisible, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns cad model icon
 */
function ModelDollhouseIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgModelDollhouse, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns panorama icon
 */
function Img360SmallIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgImage360Small, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns close icon
 */
function CloseIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgClose, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns splitscreen-start icon
 */
function SplitscreenStartIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgSplitscreenStart, ...props });
}
/**
 *
 * @param props to forward to the underlying icon
 * @returns splitscreen sync camera on waypoint icon
 */
function SyncCamerasOnWaypointIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgSyncCamerasOnWaypoint, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Horizontal link icon
 */
function LinkHorizontalIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgLinkiconHorizontal, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Enter Full Screen icon
 */
function FullScreenIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgFullScreen, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Exit Full Screen link icon
 */
function ExitFullScreenIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgExitFullScreen, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for the user location on a minimap
 */
function UserLocationIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgUserLocation, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Running Icon
 */
function RunningIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgRunning, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns School Icon
 */
function SchoolIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgSchool, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns PointCloud Icon
 */
function PointCloudIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgPointCloud, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns BaseAvatar Icon
 */
function BaseAvatarIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgBaseAvatar, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Placeholder for a location on a map
 */
function MapPlaceholderDefaultIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgMapPlaceholderDefault, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Placeholder for a selected over location on a map
 */
function MapPlaceholderSelectedIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgMapPlaceholderSelected, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Placeholder for a hovered over location on a map
 */
function MapPlaceholderHoveredIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgMapPlaceholderHover, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Placeholder for a selected and hovered over location on a map
 */
function MapPlaceholderSelectedHoveredIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgMapPlaceholderSelectedHover, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Shield Warning Icon
 */
function ShieldWarningIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgShieldWarning, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Phone Icon
 */
function PhoneIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgPhone, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Pin Icon
 */
function PinIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgPin, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Colored Pin Icon
 */
function PinColoredIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgPinColored, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Sheet New Icon
 */
function SheetNewIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgSheetNew, ...props });
}
/**
 * @returns Icon for feedback
 * @param props to forward to the underlying icon
 */
function FeedbackIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgFeedback, ...props });
}
/**
 * @returns Icon for a cloud
 * @param props to forward to the underlying icon
 */
function CloudIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCloud, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for Disabled elements
 */
function DisabledIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgDisabled, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Shield Warning Icon
 */
function WarningIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgWarning, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Spyglass Search Icon
 */
function SearchIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgSearch, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Lock Icon
 */
function LockRotationIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgLockRotation, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Update360Transformation Icon
 */
function Update360TransformationIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgUpdate360Transformation, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Upload Icon
 */
function UploadIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgUpload, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Delete Icon
 */
function DeleteIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgDelete, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Export PointCloud Icon
 */
function ExportPointCloudIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgExportPointCloud, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Annotation Icon
 */
function AnnotationIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgAnnotation, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Ruler Icon
 */
function RulerIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgRuler, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Clipping Box Icon
 */
function ClippingBoxIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgClippingBox, ...props });
}
/**
 *
 * @param props to forward to the underlying icon
 * @returns Clipping Box Export Icon
 */
function ClipboxExportIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgClipboxExport, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Align Icon
 */
function AlignIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgAlignIterative, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Align PointCloud Icon
 */
function AlignToPointCloudIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgAlignToPointCloud, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Align to CAD Icon
 */
function AlignToModelIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgAlignToModel, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Align to Sheet Icon
 */
function AlignToSheetIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgAlignToSheet, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns coordinates system Icon
 */
function CoordinatesIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCoordinates, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns coordinates system with gear Icon
 */
function CoordinatesGearIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCoordinatesGear, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Error Icon
 */
function ErrorIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgError, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Info Icon
 */
function InfoIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgInfo, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Chat Icon
 */
function ChatIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgChat, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Checkmark Icon
 */
function CheckmarkIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCheckmark, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Second version of the checkmark Icon
 */
function Checkmark2Icon(props) {
    return jsx(FaroSvgIcon, { source: SvgCheckmark2, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Third version of the checkmark Icon
 */
function Checkmark3Icon(props) {
    return jsx(FaroSvgIcon, { source: SvgCheckmark3, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Fourth version of the checkmark Icon
 */
function Checkmark4Icon(props) {
    return jsx(FaroSvgIcon, { source: SvgCheckmark4, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Generic export icon
 */
function ExportIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgExport, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Generic export icon
 */
function FlagSmallIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgFlagSmall, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Reset icon
 */
function ResetIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgReset, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Three dots Icon
 */
function ThreeDotsIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgDotsVertical, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Measurement marker icon
 */
function MeasurementMarkerIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgMeasurementMarker, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Copy Icon
 */
function CopyIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCopy, ...props });
}
/**
 * @deprecated Use {@link CopyIcon} instead
 * @param props to forward to the underlying icon
 * @returns Copy File Icon
 */
function CopyFileIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCopyFile, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns HB Logo with black text Icon
 */
function HBLogoBlackTextIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgHblogoBlacktext, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Sphere XG Logo with text Icon
 */
function SphereXGTextIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgSphereXgLogoColorRgb, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns ExclamationMark Icon
 */
function ExclamationMarkIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgExclamationmark, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns  GeoReference Icon
 */
function GeoReferenceIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgGeoReference, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Open Link Icon
 */
function OpenLinkIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgOpenLink, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Reset scale Icon
 */
function ResetScaleIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgResetScale, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Recenter Icon
 */
function RecenterViewIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgRecenterView, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Video camera Icon
 */
function VideoCameraIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgVideoCamera, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Sheet color mode Icon
 */
function SheetSaturationToggleIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgSheetSaturationToggle, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Opacity settings button icon
 */
function OpacitySettingsIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgSwatchTransparency, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Heatmap button icon
 */
function HeatmapIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgDistanceColoring, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Circled Checkmark Icon
 */
function CheckmarkCircleFillIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCheckmarkCircleFill, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Measure distance with horizontal and vertical components Checkmark Icon
 */
function MeasureShowAxesIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgMeasureShowAxes, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns "measure point" icon
 */
function MeasurePointIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgMeasurePoint, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns 3D mark Icon
 */
function Data3dIcon(props) {
    return jsx(FaroSvgIcon, { source: Svg3DData, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Circled Exclamation Mark Icon
 */
function ExclamationMarkCircleFillIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgExclamationMarkCircleFill, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Circled Info Icon
 */
function InfoCircleFillIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgInfoCircleFill, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Circled X Icon
 */
function XMarkCircleFillIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgXmarkCircleFill, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns In progress icon
 */
function InProgressIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgInprogress, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Tool Icon
 */
function ToolIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgTool, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Path Alignment Tool Icon
 */
function TrajectoryAlignIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgTrajectoryAlign, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Path Adjustment Tool Icon
 */
function TrajectoryCorrectionIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgTrajectoryCorrection, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for the slider handler
 */
function SliderHandlerIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgSliderHandler, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for the history undo
 */
function HistoryUndoIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgHistoryUndo, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for the history redo
 */
function HistoryRedoIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgHistoryRedo, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for the folder
 */
function FolderSmallIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgFolderSmall, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for question mark inside a circle
 */
function QuestionMarkInCircleIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgQuestionMarkInCircle, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for editing actions
 */
function EditIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgEdit, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for video trajectory sessions
 */
function CameraVideoTrajectorySmallIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCameraVideoTrajectorySmall, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for a pointcloud session with 360 images
 */
function PointCloudImageSmallIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgPointCloudImageSmall, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for a small pointcloud
 */
function PointCloudSmallIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgPointCloudSmall, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for a pointcloud session with a trajectory
 */
function PointCloudTrajectorySmallIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgPointCloudTrajectorySmall, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for flash point clouds in an Orbis dataset
 */
function PointCloudFlashSmallIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgPointCloudFlashSmall, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for a small pointcloud with a warning
 */
function PointCloudWarningSmallIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgPointCloudWarningSmall, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon representing a point cloud with its z-axis
 */
function PointCloudZAxisIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgPcZAxis, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for sharing a link
 */
function ShareLinkIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgShareLink, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for the interactive registration (alignment) of multiple point clouds
 */
function RegistrationInteractiveIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgRegistrationInteractive, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for sharing a link
 */
function GridIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgGrid, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for overlay different data
 */
function OverlayDataIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgBlendData, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for responsive menu different data
 */
function HamburgerMenuIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgHamburgerMenu, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for the calendar
 */
function CalendarIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCalendar, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for expanding something
 */
function ExpandIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgExpand, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for attachments
 */
function AttachmentIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgAttachment, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for measurement annotations
 */
function MeasurementIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgMeasurementIcon, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for arrow right
 */
function ArrowRightIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgArrowRight, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns extract-cross-section icon
 */
function ExtractCrossSectionIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgExtractCrossSection, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon with a circle and a plus symbol
 */
function PlusCircleIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgPlusCircle, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon with a plus symbol
 */
function PlusIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgPlus, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns a file icon for documents
 */
function FileDocumentIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgFileDocument, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns a file icon for images
 */
function FileImageIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgFileImage, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon indicating an auto clipping of the current view
 */
function AutoClipCurrentViewIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgAutoClipCurrentView, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon depicting a checkmark in a magnifier
 */
function FindCheckmarkIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgFindCheckmark, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon depicting a filtering funnel
 */
function FilterIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgFilter, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon depicting a cloud processing
 */
function CloudProcessingGraphicIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCloudProcessingGraphic, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon depicting an intensity panorama image
 */
function IntensityPanoIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgIntensityPano, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon depicting a cloud connection
 */
function CloudConnectionIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgGenericConnectionCloud, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon depicting a list of layers
 */
function LayersIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgLayers, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon for application settings
 */
function SettingsIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgSettings, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon for application view options
 */
function ViewOptionsIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgViewOptions, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon depicting a set of tags
 */
function TagsIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgTags, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon representing the action of adding a new tag
 */
function TagsAddIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgTagsAdd, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon representing the action of deleting a tag
 */
function TagsDeleteIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgTagsDelete, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon representing the action of managing tags
 */
function TagsManageIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgTagsManage, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an anchor icon
 */
function AnchorIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgAnchor, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon showing a 3D cube with none of the faces filled
 */
function ViewsIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgViews, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon showing a 3D cube with the front face filled
 */
function ViewPredefinedFrontIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgViewPredefinedFront, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon showing a 3D cube with the right face filled
 */
function ViewPredefinedRightIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgViewPredefinedRight, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon showing a 3D cube with the back face filled
 */
function ViewPredefinedBackIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgViewPredefinedBack, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon showing a 3D cube with the bottom face filled
 */
function ViewPredefinedBottomIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgViewPredefinedBottom, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon showing a 3D cube with the left face filled
 */
function ViewPredefinedLeftIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgViewPredefinedLeft, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon showing a 3D cube with the top face filled
 */
function ViewPredefinedTopIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgViewPredefinedTop, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon for representing the elevation of elements
 */
function BuildingElevationIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgBuildingElevation, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon to describe the colorization by capture date of a set of panos
 */
function TimeDistanceIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgTimeDistance, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon depicting the action of moving an element in a tree
 */
function MoveElementIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgMoveElement, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon for representing the videos
 */
function VideoIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgVideo, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon for representing the help center
 */
function HelpCenterIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgHelpCenter, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon for a single scan
 */
function ScanIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgScan, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon for a cluster of scans
 */
function ScanClusterIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgScanCluster, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns PointCloud analysis button icon
 */
function PointCloudAnalysisIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgPointCloudAnalysis, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns AnalysisMarker icon
 */
function AnalysisMarkerIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgAnalysisMarker, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns PointCloud analysis colormap option button icon
 */
function PointCloudAnalysisColormapIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgPointCloudAnalysisColormapRange, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns PointCloud analysis reference plane setting button icon
 */
function PointCloudAnalysisReferencePlaneIcon(props) {
    return (jsx(FaroSvgIcon, { source: SvgPointCloudAnalysisReferencePlane, ...props }));
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon for representing the bi-directional sorting
 */
function SortIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgSort, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon for representing the ascending sorting
 */
function SortUpIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgSortUp, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon for representing the descending sorting
 */
function SortDownIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgSortDown, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon indicating a zoom on everything
 */
function ZoomAllIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgZoomAll, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns an icon indicating a go to action
 */
function CompassGoToIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCompassGoTo, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns The Sphere XG logo
 */
function SphereXGIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgSphereXgLogo, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns The Autodesk logo
 */
function AutodeskIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgAutodeskLogo, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns The Procore logo
 */
function ProcoreIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgProcoreLogo, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Add label Icon
 */
function AddLabelIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgDeviationLabel, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Location Map Icon
 */
function LocationMapIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgLocationMap, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Cloud upload Icon
 */
function CloudUploadIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCloudUpload, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Happy Face Icon
 */
function HappyFaceIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgHappyFace44Px, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Regular Face Icon
 */
function RegularFaceIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgRegularFace44Px, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Unhappy Face Icon
 */
function UnhappyFaceIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgUnhappyFace44Px, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for an Area
 */
function AreaIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgArea, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for an Area
 */
function OrthographicCameraIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCameraOrthographic, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for an Area
 */
function PerspectiveCameraIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCameraPerspective, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for an project's Measurement
 */
function MeasuresIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgMeasures, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for announcements
 */
function AnnouncementIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgAnnouncement, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for coordinates X
 */
function CoordinatesXIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCoordinatesX, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for coordinates Y
 */
function CoordinatesYIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCoordinatesY, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for coordinates Z
 */
function CoordinatesZIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgCoordinatesZ, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for length measurement
 */
function LengthIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgLength, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for horizontal distance measurement
 */
function DistanceHorizontalIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgDistanceHorizontal, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for vertical distance measurement
 */
function DistanceVerticalIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgDistanceVertical, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for area measurement
 */
function Area2Icon(props) {
    return jsx(FaroSvgIcon, { source: SvgArea2, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for perimeter measurement
 */
function PerimeterIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgPerimeter, ...props });
}
/**
 * @param props to forward to the underlying icon
 * @returns Icon for experimental features
 */
function ExperimentalIcon(props) {
    return jsx(FaroSvgIcon, { source: SvgExperimental, ...props });
}

/** Available variants of the faro text inline with the design */
var FaroTextVariant;
(function (FaroTextVariant) {
    FaroTextVariant["heading50"] = "heading50";
    FaroTextVariant["heading32"] = "heading32";
    FaroTextVariant["heading24"] = "heading24";
    FaroTextVariant["heading20"] = "heading20";
    FaroTextVariant["heading16"] = "heading16";
    FaroTextVariant["heading14"] = "heading14";
    FaroTextVariant["heading12"] = "heading12";
    FaroTextVariant["bodyL"] = "bodyL";
    FaroTextVariant["bodyM"] = "bodyM";
    FaroTextVariant["bodyS"] = "bodyS";
    FaroTextVariant["bodyXS"] = "bodyXS";
    FaroTextVariant["hyperLink"] = "hyperLink";
    FaroTextVariant["buttonL"] = "buttonL";
    FaroTextVariant["buttonM"] = "buttonM";
    FaroTextVariant["buttonS"] = "buttonS";
    FaroTextVariant["inlineError"] = "inlineError";
    FaroTextVariant["helpText"] = "helpText";
    FaroTextVariant["labelL"] = "labelL";
    FaroTextVariant["labelM"] = "labelM";
    FaroTextVariant["labelS"] = "labelS";
    FaroTextVariant["placeholder"] = "placeholder";
})(FaroTextVariant || (FaroTextVariant = {}));
var FaroTextVariantResponsive;
(function (FaroTextVariantResponsive) {
    FaroTextVariantResponsive["xs"] = "xs";
    FaroTextVariantResponsive["sm"] = "sm";
    FaroTextVariantResponsive["md"] = "md";
    FaroTextVariantResponsive["lg"] = "lg";
    FaroTextVariantResponsive["xl"] = "xl";
})(FaroTextVariantResponsive || (FaroTextVariantResponsive = {}));
/**
 * custom text component with predefined variants which are in line with faro design
 *
 * @returns A custom text component with predefined variants which are in line with faro design
 */
const FaroText = memo(function FaroText({ variant, children, component = "span", sx, fontSize, fontWeight, lineHeight, color, shouldElide, dark, ...rest }) {
    const theme = useTheme();
    // Construct the variant style based on the variant prop
    // If the variant is a string, use the corresponding style from the map
    // Else, construct the style based on the responsive variant map
    const variantSx = typeof variant === "string"
        ? mapVariantToCss(variant, dark)
        : {
            ...(variant.xs && {
                [theme.breakpoints.down("xs")]: mapVariantToCss(variant.xs, dark),
            }),
            ...(variant.sm && {
                [theme.breakpoints.up("sm")]: mapVariantToCss(variant.sm, dark),
            }),
            ...(variant.md && {
                [theme.breakpoints.up("md")]: mapVariantToCss(variant.md, dark),
            }),
            ...(variant.lg && {
                [theme.breakpoints.up("lg")]: mapVariantToCss(variant.lg, dark),
            }),
            ...(variant.xl && {
                [theme.breakpoints.up("xl")]: mapVariantToCss(variant.xl, dark),
            }),
        };
    // Props that would otherwise be overwritten by the variantSx
    const propSx = {
        ...(color ? { color } : undefined),
        ...(fontSize ? { fontSize } : undefined),
        ...(fontWeight ? { fontWeight } : undefined),
        ...(lineHeight ? { lineHeight } : undefined),
    };
    return (jsx(Typography, { className: `FaroText-${variant}`, component: component, sx: {
            ...variantSx,
            ...propSx,
            ...(shouldElide && {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
            }),
            ...sx,
        }, ...rest, children: children }));
});
const LIGHT_COLORS$a = {
    heading: neutral[800],
    body: neutral[800],
    link: blue[500],
    button: blue[500],
    error: red[500],
    help: neutral[600],
    label: neutral[800],
    placeholder: neutral[600],
};
const DARK_COLORS$a = {
    heading: neutral[100],
    body: neutral[100],
    link: cyan$1[400],
    button: cyan$1[400],
    error: red[300],
    help: neutral[300],
    label: neutral[100],
    placeholder: neutral[300],
};
function mapVariantToCss(variant, dark) {
    switch (variant) {
        default:
            throw Error(`Variant ${variant} not supported by FaroText`);
        case FaroTextVariant.heading50:
            return {
                fontSize: "3.125rem",
                fontWeight: FontWeights.Bold,
                lineHeight: "3.875rem",
                color: dark ? DARK_COLORS$a.heading : LIGHT_COLORS$a.heading,
            };
        case FaroTextVariant.heading32:
            return {
                fontSize: "2rem",
                fontWeight: FontWeights.Bold,
                lineHeight: "2.75rem",
                color: dark ? DARK_COLORS$a.heading : LIGHT_COLORS$a.heading,
            };
        case FaroTextVariant.heading24:
            return {
                fontSize: "1.5rem",
                fontWeight: FontWeights.SemiBold,
                lineHeight: "2.25rem",
                color: dark ? DARK_COLORS$a.heading : LIGHT_COLORS$a.heading,
            };
        case FaroTextVariant.heading20:
            return {
                fontSize: "1.25rem",
                fontWeight: FontWeights.SemiBold,
                lineHeight: "1.875rem",
                color: dark ? DARK_COLORS$a.heading : LIGHT_COLORS$a.heading,
            };
        case FaroTextVariant.heading16:
            return {
                fontSize: "1rem",
                fontWeight: FontWeights.SemiBold,
                lineHeight: "1.5rem",
                color: dark ? DARK_COLORS$a.heading : LIGHT_COLORS$a.heading,
            };
        case FaroTextVariant.heading14:
            return {
                fontSize: "0.875rem",
                fontWeight: FontWeights.SemiBold,
                lineHeight: "1.25rem",
                color: dark ? DARK_COLORS$a.heading : LIGHT_COLORS$a.heading,
            };
        case FaroTextVariant.heading12:
            return {
                fontSize: "0.75rem",
                fontWeight: FontWeights.Bold,
                lineHeight: "1rem",
                color: dark ? DARK_COLORS$a.heading : LIGHT_COLORS$a.heading,
            };
        case FaroTextVariant.bodyL:
            return {
                fontSize: "1rem",
                fontWeight: FontWeights.Regular,
                lineHeight: "1.5rem",
                color: dark ? DARK_COLORS$a.body : LIGHT_COLORS$a.body,
            };
        case FaroTextVariant.bodyM:
            return {
                fontSize: "0.875rem",
                fontWeight: FontWeights.Regular,
                lineHeight: "1.25rem",
                color: dark ? DARK_COLORS$a.body : LIGHT_COLORS$a.body,
            };
        case FaroTextVariant.bodyS:
            return {
                fontSize: "0.75rem",
                fontWeight: FontWeights.Regular,
                lineHeight: "1rem",
                color: dark ? DARK_COLORS$a.body : LIGHT_COLORS$a.body,
            };
        case FaroTextVariant.bodyXS:
            return {
                fontSize: "0.625rem",
                fontWeight: FontWeights.Regular,
                lineHeight: "0.75rem",
                color: dark ? DARK_COLORS$a.body : LIGHT_COLORS$a.body,
            };
        case FaroTextVariant.hyperLink:
            return {
                fontSize: "0.875rem",
                fontWeight: FontWeights.SemiBold,
                lineHeight: "1.25rem",
                color: dark ? DARK_COLORS$a.link : LIGHT_COLORS$a.link,
                textDecoration: "underline",
            };
        case FaroTextVariant.buttonL:
            return {
                fontSize: "1rem",
                fontWeight: FontWeights.SemiBold,
                lineHeight: "1.5rem",
                color: dark ? DARK_COLORS$a.button : LIGHT_COLORS$a.button,
            };
        case FaroTextVariant.buttonM:
            return {
                fontSize: "0.875rem",
                fontWeight: FontWeights.SemiBold,
                lineHeight: "1.5rem",
                color: dark ? DARK_COLORS$a.button : LIGHT_COLORS$a.button,
            };
        case FaroTextVariant.buttonS:
            return {
                fontSize: "0.75rem",
                fontWeight: FontWeights.SemiBold,
                lineHeight: "1.5rem",
                color: dark ? DARK_COLORS$a.button : LIGHT_COLORS$a.button,
            };
        case FaroTextVariant.inlineError:
            return {
                fontSize: "0.75rem",
                fontWeight: FontWeights.Regular,
                lineHeight: "1.125rem",
                color: dark ? DARK_COLORS$a.error : LIGHT_COLORS$a.error,
            };
        case FaroTextVariant.helpText:
            return {
                fontSize: "0.75rem",
                fontWeight: FontWeights.Regular,
                lineHeight: "1.125rem",
                color: dark ? DARK_COLORS$a.help : LIGHT_COLORS$a.help,
            };
        case FaroTextVariant.labelL:
            return {
                fontSize: "0.875rem",
                fontWeight: FontWeights.Regular,
                lineHeight: "1.5rem",
                color: dark ? DARK_COLORS$a.label : LIGHT_COLORS$a.label,
            };
        case FaroTextVariant.labelM:
            return {
                fontSize: "0.75rem",
                fontWeight: FontWeights.Bold,
                lineHeight: "1.125rem",
                color: dark ? DARK_COLORS$a.label : LIGHT_COLORS$a.label,
            };
        case FaroTextVariant.labelS:
            return {
                fontSize: "0.625rem",
                fontWeight: FontWeights.Bold,
                lineHeight: "1rem",
                color: dark ? DARK_COLORS$a.label : LIGHT_COLORS$a.label,
            };
        case FaroTextVariant.placeholder:
            return {
                fontSize: "0.875rem",
                fontWeight: FontWeights.Regular,
                lineHeight: "1rem",
                color: dark ? DARK_COLORS$a.placeholder : LIGHT_COLORS$a.placeholder,
            };
    }
}

/** All different style variants for the FARO Button */
var AlertVariants;
(function (AlertVariants) {
    /** Used to notify users of a successfully completed flow, or part of it. */
    AlertVariants["success"] = "success";
    /** Used to give information about a specific tool, workflow, or any task-related information worth knowing. */
    AlertVariants["info"] = "info";
    /** Used to warn users of a possibly negative and undesirable outcome in their flow. */
    AlertVariants["warning"] = "warning";
    /** Used to alert that something has gone wrong in the task. */
    AlertVariants["error"] = "error";
    /** Used to highlight an important piece of information that does not fall under any other alert category. */
    AlertVariants["neutral"] = "neutral";
})(AlertVariants || (AlertVariants = {}));
/** The icon for each variant */
const VARIANT_ICON_MAP = {
    [AlertVariants.success]: CheckmarkCircleFillIcon,
    [AlertVariants.info]: InfoCircleFillIcon,
    [AlertVariants.warning]: ExclamationMarkCircleFillIcon,
    [AlertVariants.error]: XMarkCircleFillIcon,
    [AlertVariants.neutral]: false,
};
/** The colors for the dark variant */
const DARK_COLORS$9 = {
    backgroundColor: {
        [AlertVariants.success]: green[900],
        [AlertVariants.info]: cyan$1[900],
        [AlertVariants.warning]: yellow[900],
        [AlertVariants.error]: red[900],
        [AlertVariants.neutral]: grey[900],
    },
    iconColor: {
        [AlertVariants.success]: green[400],
        [AlertVariants.info]: cyan$1[500],
        [AlertVariants.warning]: yellow[400],
        [AlertVariants.error]: red[300],
        [AlertVariants.neutral]: grey[400],
    },
    textColor: neutral[0],
    arrowColor: neutral[0],
};
/** The colors for the dark variant */
const LIGHT_COLORS$9 = {
    backgroundColor: {
        [AlertVariants.success]: green[50],
        [AlertVariants.info]: blue[50],
        [AlertVariants.warning]: yellow[50],
        [AlertVariants.error]: red[50],
        [AlertVariants.neutral]: blue[50],
    },
    iconColor: {
        [AlertVariants.success]: green[700],
        [AlertVariants.info]: blue[500],
        [AlertVariants.warning]: yellow[500],
        [AlertVariants.error]: red[500],
        [AlertVariants.neutral]: grey[500],
    },
    textColor: undefined,
    arrowColor: neutral[800],
};
/**
 * @returns an alert following the FARO Design
 */
function Alert({ title, description, variant = "neutral", isCollapsible = false, action, sx, dark = false, children, }) {
    const [isOpen, setIsOpen] = useState(!isCollapsible);
    const colors = dark ? DARK_COLORS$9 : LIGHT_COLORS$9;
    const VariantIcon = VARIANT_ICON_MAP[variant];
    return (jsxs(Alert$1, { sx: {
            backgroundColor: colors.backgroundColor[variant],
            cursor: `${isCollapsible ? "pointer" : "default"}`,
            [".MuiAlert-message"]: { width: "100%" },
            ...sx,
        }, icon: false, onClick: () => isCollapsible && setIsOpen(!isOpen), action: action, children: [jsxs(Stack, { direction: "row", gap: 1, alignItems: "flex-start", children: [VariantIcon && (jsx(VariantIcon, { sx: {
                            color: colors.iconColor[variant],
                            height: "20px",
                            width: "20px",
                        } })), jsx(FaroText, { variant: "bodyM", sx: { fontWeight: FontWeights.SemiBold }, color: colors.textColor, children: title }), isCollapsible && (jsx(FaroIconButton, { size: FaroIconButtonSizes.s, sx: {
                            ml: "auto",
                            [">:first-of-type"]: {
                                m: 0,
                                color: colors.arrowColor,
                            },
                        }, children: jsx(ArrowDownIcon, { sx: {
                                transform: `${isOpen ? "rotate(180deg)" : ""}`,
                            } }) }))] }), description && (jsx(Collapse, { in: isOpen, unmountOnExit: true, sx: { mt: 2 }, children: jsx(FaroText, { variant: "bodyM", color: colors.textColor, children: description }) })), children] }));
}

/** All different style variants for the FARO Button */
var FaroButtonVariants;
(function (FaroButtonVariants) {
    /** Highlights the main action on the page. Each page can only have one primary button.  */
    FaroButtonVariants["primary"] = "primary";
    /** For less prominent actions. Can be used in isolation or as part of a button group.  */
    FaroButtonVariants["secondary"] = "secondary";
    /** For the least pronounced actions or as “Cancel” button next to a Primary Button. */
    FaroButtonVariants["ghost"] = "ghost";
    /** Represents main actions that are destructive and irreversible, such as “Delete Account”. */
    FaroButtonVariants["destructive"] = "destructive";
    /** Used when the destructive action is part of a busy interface, and/or is not the main action. */
    FaroButtonVariants["destructiveGhost"] = "destructiveGhost";
})(FaroButtonVariants || (FaroButtonVariants = {}));
var FaroButtonSizes;
(function (FaroButtonSizes) {
    /** Only for ghost button, for extremely crowded environments, such as a tight tree list */
    FaroButtonSizes["xs"] = "xs";
    /** Used when space does not allow for any other size. Any other use case is highly discouraged. */
    FaroButtonSizes["s"] = "s";
    /** Standard size for web applications. It should always be the default choice. */
    FaroButtonSizes["m"] = "m";
    /** Used for mobile applications, touch interfaces as well as our devices’ firmware UI.  */
    FaroButtonSizes["l"] = "l";
})(FaroButtonSizes || (FaroButtonSizes = {}));
/** @returns the properly styled Button following the FARO Design System */
const FaroButton = forwardRef(function FaroButton({ variant = FaroButtonVariants.primary, dark = false, size = FaroButtonSizes.m, icon, isLoading = false, children, disabled, sx, ...rest }, ref) {
    const sizeStyles = SIZE_STYLE_MAP$1[size];
    const styleOverrides = computeStyleOverrides(variant, dark);
    return (jsx(Button$1, { disabled: isLoading || disabled, ref: ref, sx: [
            sizeStyles,
            styleOverrides,
            {
                // required to make the icon appear in line with the text
                lineHeight: 1,
                "&.MuiButton-root": {
                    boxShadow: "none",
                },
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ], disableRipple: true, ...rest, children: jsxs(Stack, { direction: "row", gap: 1, alignItems: "center", children: [isLoading && (jsx(CircularProgress$1, { size: "1em", sx: {
                        color: "inherit",
                        position: "relative",
                    } })), icon, children] }) }));
});
const COLOR_MAP_LIGHT = {
    [FaroButtonVariants.primary]: {
        text: neutral[0],
        border: blue[600],
        idle: blue[500],
        hover: blue[600],
        pressed: blue[700],
    },
    [FaroButtonVariants.secondary]: {
        text: blue[500],
        border: blue[500],
        idle: neutral[0],
        hover: `${neutral[500]}26`,
        pressed: `${neutral[500]}40`,
    },
    [FaroButtonVariants.ghost]: {
        text: blue[500],
        border: "transparent",
        idle: "transparent",
        hover: `${neutral[500]}26`,
        pressed: `${neutral[500]}40`,
    },
    [FaroButtonVariants.destructive]: {
        text: neutral[0],
        border: red[600],
        idle: red[500],
        hover: red[600],
        pressed: red[700],
    },
    [FaroButtonVariants.destructiveGhost]: {
        text: red[500],
        border: "transparent",
        idle: "transparent",
        hover: `${neutral[500]}26`,
        pressed: `${neutral[500]}40`,
    },
};
// Map each FARO button variants to the color to use from the MUI FaroTheme
const COLOR_MAP_DARK = {
    [FaroButtonVariants.primary]: {
        text: neutral[950],
        border: cyan$1[300],
        idle: cyan$1[400],
        hover: cyan$1[300],
        pressed: cyan$1[200],
    },
    [FaroButtonVariants.secondary]: {
        text: cyan$1[400],
        border: cyan$1[400],
        idle: neutral[999],
        hover: `${neutral[500]}26`,
        pressed: `${neutral[500]}40`,
    },
    [FaroButtonVariants.ghost]: {
        text: cyan$1[400],
        border: "transparent",
        idle: "transparent",
        hover: `${neutral[500]}26`,
        pressed: `${neutral[500]}40`,
    },
    [FaroButtonVariants.destructive]: {
        text: neutral[999],
        border: red[200],
        idle: red[300],
        hover: red[200],
        pressed: red[500],
    },
    [FaroButtonVariants.destructiveGhost]: {
        text: red[300],
        border: "transparent",
        idle: "transparent",
        hover: `${neutral[500]}26`,
        pressed: `${neutral[500]}40`,
    },
};
/**
 * @returns Style overrides on top of MuiButton style required for the FARO Design
 * @param variant the button variant to compute the overrides for
 * @param dark whether to use dark colors
 */
function computeStyleOverrides(variant, dark) {
    const colors = dark ? COLOR_MAP_DARK[variant] : COLOR_MAP_LIGHT[variant];
    const focusedBorderColor = dark ? neutral[0] : neutral[999];
    const focusedInnerShadowColor = dark ? neutral[950] : neutral[0];
    // Only the secondary button has its border visible in all states
    const borderIdle = `1px solid ${colors.border}`;
    const borderNonIdle = variant === "secondary" ? borderIdle : "1px solid transparent";
    return {
        color: colors.text,
        border: borderIdle,
        backgroundColor: colors.idle,
        "&:after": {
            background: "red",
        },
        "&:hover": {
            // Some hover colors are defined as transparent overlays. This mixes them with the idle background.
            backgroundColor: blendColors(colors.idle, colors.hover),
            border: borderNonIdle,
        },
        "&:active": {
            // Some hover colors are defined as transparent overlays. This mixes them with the idle background.
            backgroundColor: blendColors(colors.idle, colors.pressed),
            border: borderNonIdle,
        },
        "&.MuiButton-root:focus-visible": {
            outline: `2px solid ${focusedBorderColor}`,
            boxShadow: `inset 0px 0px 0px 1.5px ${focusedInnerShadowColor}`,
        },
        "&.Mui-disabled": {
            opacity: 0.5,
            color: colors.text,
            border: borderNonIdle,
        },
        transition: "none",
    };
}
/**
 * @returns a blended color that adds the overlayColor on top of the baseColor. The result is slightly different to a css color-mix().
 * @param baseColor color in the background
 * @param overlayColor color on top
 */
function blendColors(baseColor, overlayColor) {
    if (baseColor === "transparent") {
        // The Mui helper doesn't deal with transparency correctly
        return overlayColor;
    }
    return blend(baseColor, overlayColor, decomposeColor(overlayColor).values[3] ?? 1);
}
// Specific style for each button size as defined in the FARO Design System
const SIZE_STYLE_MAP$1 = {
    [FaroButtonSizes.xs]: {
        fontSize: "0.625rem",
        height: "1.125rem",
        px: 0.5,
        py: 0.25,
        "&.MuiButton-root .MuiSvgIcon-root, &.MuiButton-root .MuiIcon-root": {
            fontSize: "0.625rem",
        },
    },
    [FaroButtonSizes.s]: {
        fontSize: "0.75rem",
        minWidth: "4.5rem",
        height: "1.875rem",
        px: 1.25,
        pb: 0.875,
        pt: 0.75,
        "&.MuiButton-root .MuiSvgIcon-root, &.MuiButton-root .MuiIcon-root": {
            fontSize: "0.75rem",
        },
    },
    [FaroButtonSizes.m]: {
        fontSize: "0.875rem",
        minWidth: "5.5rem",
        height: "2.25rem",
        px: 2,
        pb: 1.125,
        pt: 1,
        "&.MuiButton-root .MuiSvgIcon-root, &.MuiButton-root .MuiIcon-root": {
            fontSize: "0.875rem",
        },
    },
    [FaroButtonSizes.l]: {
        fontSize: "1rem",
        minWidth: "6.25rem",
        height: "2.70rem",
        px: 2.27,
        py: 1.135,
        "&.MuiButton-root .MuiSvgIcon-root, &.MuiButton-root .MuiIcon-root": {
            fontSize: "1rem",
        },
    },
};

/**
 * @returns IconButton according to Faro designs
 */
const IconButton = forwardRef(function IconButton({ children, variant, sx, ...props }, ref) {
    return (jsx(IconButton$1, { ref: ref, sx: [
            {
                ...(variant === "MenuBarIcon" && {
                    height: "48px",
                    width: "48px",
                }),
                ["> *"]: {
                    height: "24px",
                    width: "24px",
                },
            },
            // Appending any additional style used, where the component is initialised
            ...(Array.isArray(sx) ? sx : [sx]),
        ], ...props, children: children }));
});

/** @returns the desired icon based on the banner variant */
function BannerIcon({ variant, sx, }) {
    switch (variant) {
        case "success":
            return jsx(CheckmarkCircleFillIcon, { sx: { color: "success.main", ...sx } });
        case "info":
            return jsx(InfoCircleFillIcon, { sx: { color: "info.main", ...sx } });
        case "warning":
            return (jsx(ExclamationMarkCircleFillIcon, { sx: { color: "warning.main", ...sx } }));
        case "error":
            return jsx(XMarkCircleFillIcon, { sx: { color: "error.main", ...sx } });
    }
}
/** @returns the properly configured action button based on the Banner action props */
function BannerAction({ action, }) {
    const href = typeof action.action === "string" ? action.action : undefined;
    const callback = typeof action.action === "string" ? undefined : action.action;
    return (jsx(FaroButton, { role: "action-button", variant: "ghost", href: href, onClick: callback, children: action.label }));
}
/**
 * @returns a dismissible notification bar spanning the full width of the parent component with an optional action
 */
function Banner({ variant, title, children, sx, action, onClose, }) {
    return (jsxs(Stack, { direction: "row", spacing: 2, alignItems: "center", role: "banner", sx: {
            p: 1,
            color: "darkGrey",
            minHeight: "40px",
            border: ({ palette }) => `1px solid ${palette.black10}`,
            background: ({ palette }) => palette[variant].light,
            ...sx,
        }, children: [jsx(BannerIcon, { variant: variant, sx: { ml: 1 } }), title && (jsx(Typography, { component: "span", role: "title", fontStyle: "inherit", fontWeight: FontWeights.SemiBold, children: title })), jsx(Typography, { component: "span", role: "message", fontStyle: "inherit", sx: {
                    flexGrow: 1,
                }, children: children }), action?.action && jsx(BannerAction, { action: action }), onClose && (jsx(IconButton, { role: "close-button", onClick: onClose, children: jsx(Close, { sx: { width: "20px", height: "20px" } }) }))] }));
}

/**
 * @returns whether the theme's breakpoint xs (or higher) matches
 */
function useBreakpointXsUp() {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.up("xs"));
}
/**
 * @returns whether the theme's breakpoint sm (or higher) matches
 */
function useBreakpointSmUp() {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.up("sm"));
}
/**
 * @returns whether the theme's breakpoint md (or higher) matches
 */
function useBreakpointMdUp() {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.up("md"));
}
/**
 * @returns whether the theme's breakpoint lg (or higher) matches
 */
function useBreakpointLgUp() {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.up("lg"));
}
/**
 * @returns whether the theme's breakpoint xl (or higher) matches
 */
function useBreakpointXlUp() {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.up("xl"));
}
/**
 * @returns whether the theme's breakpoint xxl (or higher) matches
 */
function useBreakpointXXlUp() {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.up("xxl"));
}

/**
 * Hook that can be used to track an element to check if it's content is overflowing the element
 *
 * @returns a boolean and a callback that can be used to track the element overflow
 */
function useCheckForOverflow() {
    const [hasOverflown, setHasOverflown] = useState(false);
    const checkForOverflow = useCallback((currentTarget) => {
        setHasOverflown(hasOverflow(currentTarget));
    }, []);
    return {
        hasOverflown,
        checkForOverflow,
    };
}
/**
 * Function to recursively check if an element is overflowing its content
 *
 * @param element HTML element to check
 * @returns true if any of the element's children are overflowing
 */
function hasOverflow(element) {
    if (element.scrollWidth > element.clientWidth)
        return true;
    for (const child of element.children) {
        if (hasOverflow(child)) {
            return true;
        }
    }
    return false;
}

var RotationCursor = "data:image/svg+xml,%3Csvg%20%20width%3D%2224%22%20%20height%3D%2224%22%20%20viewBox%3D%220%200%2024%2024%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M18.3098%205.69007C18.4298%205.80007%2018.5298%205.91007%2018.6298%206.03007L20.5798%204.08007V9.27007H15.3998L17.2998%207.36007C17.1998%207.24007%2017.0998%207.12007%2016.9898%207.01007C15.6498%205.68007%2013.8798%204.94007%2011.9898%204.94007C10.0998%204.94007%208.3198%205.68007%206.9898%207.01007C5.6598%208.35007%204.9198%2010.1201%204.9198%2012.0101C4.9198%2012.6101%204.9998%2013.1901%205.1398%2013.7501H3.2198C3.1098%2013.1801%203.0498%2012.6001%203.0498%2012.0101C3.0498%209.62007%203.9798%207.38007%205.6698%205.69007C7.35981%204.00007%209.5998%203.07007%2011.9898%203.07007C14.3798%203.07007%2016.6198%204.00007%2018.3098%205.69007ZM18.8402%2010.26H20.7602L20.7702%2010.27C20.8802%2010.84%2020.9402%2011.43%2020.9402%2012.02C20.9402%2014.41%2020.0102%2016.65%2018.3202%2018.34C16.6302%2020.03%2014.3902%2020.96%2012.0002%2020.96C9.61016%2020.96%207.37016%2020.03%205.68016%2018.34C5.60825%2018.2681%205.54061%2018.1919%205.47166%2018.1143C5.43514%2018.0731%205.39825%2018.0316%205.36016%2017.99L3.41016%2019.94V14.75H8.58016L6.68016%2016.65C6.70383%2016.6784%206.72751%2016.7074%206.75131%2016.7365C6.82807%2016.8304%206.9062%2016.9261%206.99016%2017.01C8.33016%2018.34%2010.1002%2019.08%2011.9902%2019.08C13.8802%2019.08%2015.6602%2018.34%2016.9902%2017.01C18.3202%2015.67%2019.0602%2013.9%2019.0602%2012.01C19.0602%2011.41%2018.9802%2010.82%2018.8402%2010.26Z%22%20%20%20%20fill%3D%22black%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M21.7503%2010.0699L21.6003%209.28991V1.65991L19.8903%203.36991L18.6403%204.61991C16.8203%202.97991%2014.4803%202.07991%2012.0003%202.07991C9.35031%202.07991%206.85031%203.10991%204.98031%204.98991C3.10031%206.86991%202.07031%209.35991%202.07031%2012.0099C2.07031%2012.6499%202.13031%2013.2999%202.26031%2013.9399L2.41031%2014.7199V22.3499L4.12031%2020.6399L5.36031%2019.3999C7.19031%2021.0499%209.53031%2021.9499%2012.0003%2021.9499C14.6503%2021.9499%2017.1503%2020.9199%2019.0203%2019.0399C20.9003%2017.1599%2021.9303%2014.6699%2021.9303%2012.0199C21.9303%2011.3699%2021.8703%2010.7199%2021.7403%2010.0799L21.7503%2010.0699ZM5.68031%205.68991C7.37031%203.99991%209.61031%203.06991%2012.0003%203.06991C14.3903%203.06991%2016.6303%203.99991%2018.3203%205.68991C18.4303%205.79991%2018.5303%205.91991%2018.6403%206.02991L20.6003%204.06991V9.25991H15.4203L17.3203%207.34991C17.2203%207.22991%2017.1203%207.10991%2017.0103%206.99991C15.6803%205.66991%2013.9003%204.92991%2012.0103%204.92991C10.1203%204.92991%208.35031%205.66991%207.01031%206.99991C5.67031%208.32991%204.94031%2010.1099%204.94031%2011.9999C4.94031%2012.5899%205.02031%2013.1699%205.16031%2013.7399H3.24031C3.13031%2013.1699%203.07031%2012.5899%203.07031%2011.9999C3.07031%209.60991%204.00031%207.36991%205.69031%205.67991L5.68031%205.68991ZM17.8703%2010.5099C18.0003%2011.0199%2018.0603%2011.5199%2018.0603%2012.0099C18.0603%2013.6299%2017.4303%2015.1499%2016.2803%2016.2999C15.1303%2017.4499%2013.6103%2018.0799%2011.9903%2018.0799C10.5503%2018.0799%209.18031%2017.5799%208.09031%2016.6599L9.29031%2015.4599L11.0003%2013.7499H6.18031L6.12031%2013.4999C5.99031%2012.9999%205.93031%2012.4899%205.93031%2012.0099C5.93031%2010.3899%206.56031%208.86991%207.71031%207.71991C8.86031%206.56991%2010.3803%205.93991%2012.0003%205.93991C13.4403%205.93991%2014.8103%206.43991%2015.9003%207.35991L14.7003%208.55991L12.9903%2010.2699H17.8103L17.8703%2010.5199V10.5099ZM18.3103%2018.3299C16.6203%2020.0199%2014.3803%2020.9499%2011.9903%2020.9499C9.60031%2020.9499%207.36031%2020.0199%205.67031%2018.3299C5.56031%2018.2199%205.45031%2018.0999%205.35031%2017.9799L3.40031%2019.9299V14.7399H8.58031L6.68031%2016.6399C6.78031%2016.7599%206.88031%2016.8899%206.99031%2016.9999C8.32031%2018.3299%2010.1003%2019.0699%2011.9903%2019.0699C13.8803%2019.0699%2015.6503%2018.3299%2016.9903%2016.9999C18.3303%2015.6699%2019.0603%2013.8899%2019.0603%2011.9999C19.0603%2011.3999%2018.9803%2010.8199%2018.8403%2010.2499H20.7603C20.8703%2010.8199%2020.9303%2011.3999%2020.9303%2011.9999C20.9303%2014.3899%2020.0003%2016.6299%2018.3103%2018.3199V18.3299Z%22%20%20%20%20fill%3D%22white%22%20%20%2F%3E%3C%2Fsvg%3E";

var ScaleCursor = "data:image/svg+xml,%3Csvg%20%20width%3D%2224%22%20%20height%3D%2224%22%20%20viewBox%3D%220%200%2024%2024%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20d%3D%22M3.68005%2020.32V15.1L5.64005%2017.06L11.0201%2011.67L9.06005%209.71004L9.71005%209.06004L11.6701%2011.02L17.0501%205.63004L15.0901%203.67004H20.3101V8.89004L18.3501%206.94004L12.9701%2012.32L14.9301%2014.28L14.2801%2014.93L12.3201%2012.97L6.93005%2018.36L8.89005%2020.32H3.68005Z%22%20%20%20%20fill%3D%22black%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M20.32%202.75H12.87L14.45%204.33L15.76%205.64L11.68%209.72L10.37%208.41L9.72002%207.76L9.07002%208.41L8.42002%209.06L7.77002%209.71L8.42002%2010.36L9.73002%2011.67L5.65002%2015.75L4.35002%2014.44L2.77002%2012.86V21.23H11.14L9.56002%2019.65L8.25002%2018.35L12.33%2014.27L13.64%2015.58L14.29%2016.23L14.94%2015.58L15.59%2014.93L16.24%2014.28L15.59%2013.63L14.28%2012.32L18.36%208.24L19.66%209.55L21.24%2011.13V2.75H20.32ZM6.94002%2018.36L8.90002%2020.32H3.68002V15.1L5.64002%2017.06L10.37%2012.33L11.68%2013.64L6.95002%2018.37L6.94002%2018.36ZM14.94%2014.28L14.29%2014.93L12.33%2012.97L11.02%2011.66L10.37%2011.01L9.06002%209.7L9.71002%209.05L14.93%2014.27L14.94%2014.28ZM20.32%208.9L18.36%206.94L13.63%2011.67L12.32%2010.36L17.05%205.63L15.09%203.67H20.31V8.89L20.32%208.9Z%22%20%20%20%20fill%3D%22white%22%20%20%2F%3E%3C%2Fsvg%3E";

var TranslationCursor = "data:image/svg+xml,%3Csvg%20%20width%3D%2224%22%20%20height%3D%2224%22%20%20viewBox%3D%220%200%2024%2024%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20d%3D%22M22.3801%2012.0001L18.6901%208.31012V11.0801H12.9201V5.31012H15.6901L12.0001%201.62012L8.31012%205.31012H11.0801V11.0801H5.31012V8.31012L1.62012%2012.0001L5.31012%2015.6901V12.9201H11.0801V18.6901H8.31012L12.0001%2022.3801L15.6901%2018.6901H12.9201V12.9201H18.6901V15.6901L22.3801%2012.0001Z%22%20%20%20%20fill%3D%22black%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M6.30996%2015.6899V13.9199H10.08V17.6899H6.30996V15.6899ZM13.93%2013.9199H17.7V17.6899H13.93V13.9199ZM6.30996%208.29994V6.29994H10.08V10.0699H6.30996V8.29994ZM13.93%206.29994H17.7V10.0699H13.93V6.29994ZM12.01%201.60994L15.7%205.29994H12.93V11.0699H18.7V8.29994L22.39%2011.9899L18.7%2015.6799V12.9099H12.93V18.6799H15.7L12.01%2022.3699L8.31996%2018.6799H11.09V12.9099H5.31996V15.6799L1.62996%2011.9899L5.31996%208.29994V11.0699H11.09V5.29994H8.31996L12.01%201.60994ZM11.3%200.899941L7.60996%204.58994L6.31996%205.87994L4.60996%207.58994L0.919961%2011.2799L0.209961%2011.9899L0.919961%2012.6999L4.60996%2016.3899L6.10996%2017.8899L7.60996%2019.3899L11.3%2023.0799L12.01%2023.7899L12.72%2023.0799L16.41%2019.3899L17.91%2017.8899L19.41%2016.3899L23.1%2012.6999L23.81%2011.9899L23.1%2011.2799L19.41%207.58994L17.7%205.87994L16.41%204.58994L12.72%200.899941L12.01%200.189941L11.3%200.899941Z%22%20%20%20%20fill%3D%22white%22%20%20%2F%3E%3C%2Fsvg%3E";

/** The size as specified in the SVG images. */
const CURSOR_ICON_SIZE = 24;
/** Center the icon on the cursor. */
const CURSOR_COORDINATES = `${CURSOR_ICON_SIZE / 2} ${CURSOR_ICON_SIZE / 2}`;
/**
 * An enum to decide the cursor style based on the hover and operation
 */
var CursorStyle;
(function (CursorStyle) {
    /** Initial state */
    CursorStyle["default"] = "Default";
    /** Cursor style to indicate a click operation */
    CursorStyle["pointer"] = "Pointer";
    /** Cursor style to indicate a rotation operation */
    CursorStyle["rotation"] = "Rotation";
    /** Cursor style to indicate a translation operation */
    CursorStyle["translation"] = "Translation";
    /** Cursor style to indicate a scale operation */
    CursorStyle["scale"] = "Scale";
})(CursorStyle || (CursorStyle = {}));
/**
 * Hook to override the cursor on a dom-element with one of the predefined styles.
 */
function useCustomCursor({ enable = true, cursorToShow, domElement = document.body, }) {
    useEffect(() => {
        if (enable) {
            const oldCursor = domElement.style.cursor;
            switch (cursorToShow) {
                case CursorStyle.rotation:
                    domElement.style.cursor = `url("${RotationCursor}") ${CURSOR_COORDINATES}, auto`;
                    break;
                case CursorStyle.translation:
                    domElement.style.cursor = `url("${TranslationCursor}") ${CURSOR_COORDINATES}, auto`;
                    break;
                case CursorStyle.scale:
                    domElement.style.cursor = `url("${ScaleCursor}") ${CURSOR_COORDINATES}, auto`;
                    break;
                case CursorStyle.pointer:
                    domElement.style.cursor = "pointer";
                    break;
                case CursorStyle.default:
                    domElement.style.cursor = "default";
            }
            return () => {
                domElement.style.cursor = oldCursor;
            };
        }
    }, [domElement, enable, cursorToShow]);
}

/**
 * Hook that allows to adjust the width of an element via dragging of the mouse
 *
 * @returns {UseResizeReturn} the provided enableResize method should be attached to the onMouseDown handler of the element
 * that can be dragged by the user
 */
function useHorizontalResize({ handleSide = "right", initialWidth, minWidth, maxWidth = Number.MAX_SAFE_INTEGER, }) {
    const [isResizing, setIsResizing] = useState(false);
    const [width, setWidth] = useState(initialWidth);
    const [widthAtResizeStart, setWidthAtResizeStart] = useState(initialWidth);
    const [clientXAtResizeStart, setClientXAtResizeStart] = useState(0);
    const handleRef = useRef(null);
    const startResizing = useCallback((e) => {
        e.stopPropagation();
        if (!handleRef.current)
            return;
        handleRef.current.setPointerCapture(e.pointerId);
        setWidthAtResizeStart(width);
        setClientXAtResizeStart(e.clientX);
        setIsResizing(true);
    }, [width]);
    const stopResizing = useCallback((e) => {
        e.stopPropagation();
        if (!handleRef.current)
            return;
        handleRef.current.releasePointerCapture(e.pointerId);
        setIsResizing(false);
    }, []);
    const resize = useCallback((e) => {
        if (handleRef.current && isResizing) {
            e.stopPropagation();
            const directionFactor = handleSide === "right" ? 1 : -1;
            const newWidth = widthAtResizeStart +
                (e.clientX - clientXAtResizeStart) * directionFactor;
            setWidth(clamp(newWidth, minWidth, maxWidth));
        }
    }, [
        isResizing,
        handleSide,
        widthAtResizeStart,
        clientXAtResizeStart,
        minWidth,
        maxWidth,
    ]);
    // Setup necessary event listeners for mouse actions, and remove them on unmount
    useEffect(() => {
        if (!handleRef.current)
            return;
        const handle = handleRef.current;
        handle.addEventListener("pointerdown", startResizing);
        handle.addEventListener("pointermove", resize);
        handle.addEventListener("pointerup", stopResizing);
        return () => {
            handle.removeEventListener("pointerdown", startResizing);
            handle.removeEventListener("pointermove", resize);
            handle.removeEventListener("pointerup", stopResizing);
        };
    }, [stopResizing, resize, startResizing]);
    return { width, isResizing, handleRef };
}

/** Style used to shorten the breadcrumb if it's too long */
const SHORT_BREADCRUMB_ITEM_STYLE = {
    // Make ellipse work for long labels. The parent component needs to specify a maxWidth
    display: "inline-block",
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    justifyContent: "center",
};
/** Common style to both the breadcrumb link and text */
const BREADCRUMB_ITEM_STYLE = {
    ...SHORT_BREADCRUMB_ITEM_STYLE,
    // Properly style the label text
    letterSpacing: "0.5px",
    textTransform: "uppercase",
    fontSize: "0.625rem",
    fontWeight: 800,
    color: neutral[600],
};
/**
 * @returns a styled link or text, that can be used in the FaroBreadcrumbs component
 */
function BreadcrumbItem({ label, link, isDisabled = false, openInNewTab = false, sx, className, onClickLink, }) {
    const isTextLabel = typeof label === "string";
    const isInRouterContext = useInRouterContext();
    // Apply the custom style for the text, only if the label is a string.
    // Otherwise, use the component's style and only add the shortening logic.
    const commonStyle = useMemo(() => isTextLabel
        ? [BREADCRUMB_ITEM_STYLE, ...(Array.isArray(sx) ? sx : [sx])]
        : [SHORT_BREADCRUMB_ITEM_STYLE, ...(Array.isArray(sx) ? sx : [sx])], [isTextLabel, sx]);
    // The styling props for the link element in the breadcrumbs item.
    const linkSx = useMemo(() => [
        {
            pointerEvents: isDisabled ? "none" : "auto",
            opacity: isDisabled ? "0.5" : "1",
            "&:hover": {
                color: neutral[800],
            },
        },
        ...commonStyle,
    ], [isDisabled, commonStyle]);
    const { hasOverflown, checkForOverflow } = useCheckForOverflow();
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);
    return (jsx(Tooltip, { title: label, open: isTooltipOpen && hasOverflown, disableHoverListener: !hasOverflown, onClose: () => setIsTooltipOpen(false), className: className, children: link ? (jsx(Link, { "aria-label": "breadcrumb-link", ...(isInRouterContext
                ? { component: Link$1, to: link }
                : { href: link }), target: openInNewTab ? "_blank" : "_self", rel: "noopener noreferrer", underline: "none", onClick: onClickLink, onMouseEnter: (ev) => {
                checkForOverflow(ev.currentTarget);
                setIsTooltipOpen(true);
            }, sx: linkSx, children: label })) : (jsx(Typography, { "aria-label": "breadcrumb-text", component: isTextLabel ? "p" : "div", onMouseEnter: (ev) => {
                checkForOverflow(ev.currentTarget);
                setIsTooltipOpen(true);
            }, sx: commonStyle, children: label })) }));
}

/**
 * @returns a styled list of links with a separator between each of them.
 * The link must be passed as a children of this component and should preferably use BreadcrumbsItem
 */
function FaroBreadcrumbs({ showFullLabels = false, sx, children, ...rest }) {
    const numberOfChildren = Children.count(children);
    return (jsx(Breadcrumbs, { "aria-label": "breadcrumbs", sx: {
            ">ol": {
                // Make the breadcrumbs stay on one line
                flexWrap: "nowrap",
                // Set the width of the parent container to be the minimum width,
                // so that the width of the children (li) will be calculated properly
                width: "min-content",
                // Add space between the separator and the labels
                gap: 2,
                ">li": {
                    display: "flex",
                    whiteSpace: "nowrap",
                    // Set the items length as a percentage of the parent
                    maxWidth: showFullLabels
                        ? "100%"
                        : `calc(100% / ${numberOfChildren})`,
                },
            },
            ...sx,
        }, ...rest, children: children }));
}

/**
 * @returns Primary UI component for user interaction
 */
function Button({ label, onClick, variant, color, isDisabled, href, size, sx, }) {
    return (jsx(MuiButton, { variant: variant, color: color, onClick: onClick, href: href, size: size, sx: sx, disabled: isDisabled, children: label }));
}

/** Style to apply when the card is expanded (expanded === true). */
const expandedStyle = {
    width: "100%",
};
/** Style to apply when the card is collapsed (expanded === false). */
const collapsedStyle = {
    height: "60px",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
};
// Default height of the skeleton placeholder
const expandedImgStyle = { minHeight: "9.375rem" };
// The style of image contained in the card is changed to make it smaller.
const collapsedImgStyle = {
    width: "60px",
    height: "36px",
    objectFit: "cover",
    margin: 2,
    marginRight: "0px",
    borderRadius: "6px",
};
function CardThumbnail({ imgSrc, expanded }) {
    return imgSrc ? (jsx(CardMedia, { component: "img", image: imgSrc, sx: expanded ? expandedImgStyle : collapsedImgStyle })) : (jsx(Skeleton, { variant: "rectangular", sx: expanded ? expandedImgStyle : collapsedImgStyle }));
}
/**
 * @returns a component that renders a card that displays an image, title and date of a project.
 */
function CardItem({ imgSrc, title, creationDate, expanded, collapsedHeight = "60px", onClick, }) {
    return (jsx(Card, { sx: {
            borderRadius: "6px",
            border: ({ palette }) => expanded ? `2px solid ${palette.customBlue}` : "none",
        }, onClick: onClick, children: jsxs(CardActionArea, { sx: expanded
                ? expandedStyle
                : { ...collapsedStyle, height: collapsedHeight }, children: [jsx(CardThumbnail, { imgSrc: imgSrc, expanded: expanded }), jsxs(CardContent, { children: [jsx(Typography$1, { gutterBottom: true, sx: { fontSize: "12px", fontWeight: 600 }, component: "div", children: title }), jsx(Typography$1, { sx: { fontSize: "10px", fontWeight: 600 }, color: "text.secondary", children: creationDate })] })] }) }));
}

/**
 * @returns a component that renders a projects list.
 */
function CardList({ projects, selected, sx, onClicked, }) {
    // Render the projects list.
    return (jsx(List, { sx: {
            // The card needs it's own margin a little bit for the shadow to show.
            marginX: 0.5,
            // All cards in the list must have some space under them.
            "> *": {
                marginBottom: 1,
            },
            ...sx,
        }, children: projects.map((project) => (jsx(CardItem, { expanded: project.id === selected, onClick: () => onClicked?.(project.id), ...project }, project.id))) }));
}

/**
 * @returns A circular spinner in the FARO Theme
 * @param spinnerProps props of the underlying mui component
 * @param spinnerProps.showPercentage Whether to show a percentage label in the center of the circular progress
 * @param spinnerProps.size size of the spinner
 * @param spinnerProps.sx Styles applied to the root container component
 */
function CircularProgress({ sx, showPercentage, size = 40, ...spinnerProps }) {
    return (jsxs(Stack, { role: "loading", sx: {
            position: "relative",
            width: size,
            height: size,
            ...sx,
        }, children: [jsx(CircularProgress$1, { ...spinnerProps, variant: "determinate", value: 100, size: size, sx: {
                    color: "black",
                    opacity: 0.15,
                } }), jsx(CircularProgress$1, { disableShrink: spinnerProps.variant === "indeterminate", ...spinnerProps, size: size, sx: {
                    color: "currentcolor",
                    position: "absolute",
                    left: 0,
                } }), showPercentage && spinnerProps.value !== undefined && (jsx(Box, { component: "div", sx: {
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)",
                }, children: jsx(FaroText, { variant: "bodyM", sx: { color: "currentcolor" }, children: `${Math.round(spinnerProps.value)}%` }) }))] }));
}

/**
 * @returns A light-themed variant of a Tooltip
 */
function TooltipLight({ sx, ...rest }) {
    return (jsx(Tooltip, { sx: { boxShadow: 3, ...sx }, componentsProps: {
            tooltip: {
                sx: {
                    color: (theme) => theme.palette.darkGrey,
                    backgroundColor: (theme) => theme.palette.white,
                    fontSize: "14px",
                    padding: 2,
                    maxWidth: 500,
                    boxShadow: 3,
                },
            },
        }, ...rest }));
}
/**
 * @returns A Tooltip following the FARO Design
 */
function FaroTooltip({ children, icon, title, disableInteractive = true, sx, tooltipSx, ...rest }) {
    // Mui is passing fullWidth to the child element i.e to span, which is not a valid prop
    // Hence there is a warning in the console. To avoid that, the fullWidth prop is discarded here.
    if ("fullWidth" in rest) {
        delete rest.fullWidth;
    }
    return (jsx(Tooltip, { title: 
        // Add the FaroText only if we have a title
        title ? (jsxs(FaroText, { variant: "bodyS", fontWeight: FontWeights.SemiBold, color: neutral[100], sx: {
                display: "flex",
                alignItems: "center",
                gap: 0.75,
                [".MuiSvgIcon-root"]: {
                    fontSize: "1rem",
                },
            }, children: [icon, title] })) : undefined, componentsProps: {
            tooltip: {
                sx: {
                    backgroundColor: neutral[950],
                    py: 0.75,
                    px: 1.5,
                    maxWidth: 260,
                    lineHeight: "1.1rem",
                    border: ({ palette }) => `1px solid ${palette.white}33`,
                    borderRadius: 1,
                    [`&.${tooltipClasses.tooltip}`]: {
                        [`&.${tooltipClasses.tooltipPlacementTop}`]: {
                            mb: 1,
                        },
                        [`&.${tooltipClasses.tooltipPlacementBottom}`]: {
                            mt: 1,
                        },
                        [`&.${tooltipClasses.tooltipPlacementRight}`]: {
                            ml: 1,
                        },
                        [`&.${tooltipClasses.tooltipPlacementLeft}`]: {
                            mr: 1,
                        },
                    },
                    ...tooltipSx,
                },
            },
        }, disableInteractive: disableInteractive, enterDelay: 500, enterNextDelay: 500, leaveDelay: 200, sx: { ...sx }, ...rest, children: jsx(Box, { component: "span", children: children }) }));
}

/**
 * Renders a tag/chip with a tooltip
 *
 * @returns JSX.Element - A tag/chip
 */
function FaroChip({ label, color, borderColor, backgroundColor, tooltip, variant = "filled", size = "small", icon, textTransform = "uppercase", sx, showSpinner, className, disabled, onClick, onDelete, }) {
    /* Chip uses ButtonBase underneath only when callbacks are defined, but does not expose the properties (i.e. disableRipple) */
    const disableRipple = onClick ?? onDelete ? { disableRipple: true } : {};
    return (jsx(FaroTooltip, { title: tooltip, enterDelay: 1000, children: jsx(Chip, { "data-testid": "sphere-status-chip", label: label, icon: icon, variant: variant, onClick: onClick, 
            /** Define the onDelete function anyway, so that the spinner is shown */
            onDelete: showSpinner ? () => { } : onDelete, deleteIcon: showSpinner ? (jsx(CircularProgress, { size: 16, sx: { pointerEvents: "none" } })) : (jsx(CloseCancelErrorIcon, { sx: { width: "16px", height: "16px" } })), sx: [
                {
                    backgroundColor,
                    color,
                    borderColor: `${borderColor ?? color}`,
                    fontSize: "0.625rem",
                    fontWeight: FontWeights.Bold,
                    lineHeight: "0.875rem",
                    letterSpacing: "0.5px",
                    textTransform,
                    "& .MuiChip-icon": {
                        marginLeft: 1,
                        marginRight: 0,
                        color,
                    },
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ], size: size, disabled: disabled, ...disableRipple, className: className }) }));
}

const DARK_COLORS$8 = {
    backgroundColor: neutral[999],
    color: neutral[300],
    borderColor: neutral[300],
    focusColor: cyan$1[400],
    selectedBackground: neutral[500],
    selectedText: cyan$1[400],
};
const LIGHT_COLORS$8 = {
    backgroundColor: neutral[0],
    color: neutral[600],
    borderColor: neutral[999],
    focusColor: blue[500],
    selectedBackground: neutral[500],
    selectedText: blue[500],
};
/** @returns a specialized chip to be used for filters */
function FaroChipFilter({ label, count, showCheckmark = false, dark = false, disabled = false, selected = false, onClick, }) {
    const colors = dark ? DARK_COLORS$8 : LIGHT_COLORS$8;
    return (jsx(Chip, { variant: "outlined", onClick: onClick, label: jsxs(Stack$1, { direction: "row", alignItems: "center", gap: 1, children: [jsx(FaroText, { variant: "heading14", color: "inherit", children: label }), count !== undefined && jsx(ChipCounter, { count: count, dark: dark })] }), icon: showCheckmark ? (jsx(Checkmark2Icon, { sx: { fontSize: "16px" }, color: "inherit" })) : undefined, sx: {
            textTransform: "none",
            pointerEvents: disabled ? "none" : "auto",
            opacity: disabled ? 0.5 : 1,
            color: selected ? colors.selectedText : colors.color,
            backgroundColor: selected
                ? `${colors.selectedBackground}40`
                : colors.backgroundColor,
            borderColor: selected ? colors.selectedText : colors.borderColor,
            "&.MuiChip-root": {
                height: "30px",
                px: 0,
                py: "8px",
                "&:hover": {
                    borderColor: colors.selectedText,
                    color: colors.selectedText,
                    backgroundColor: selected
                        ? `${colors.selectedBackground}26`
                        : `color-mix(in srgb, ${colors.backgroundColor}, ${neutral[500]} 15%)`,
                },
                "&:active": {
                    borderColor: colors.selectedText,
                    color: colors.selectedText,
                    backgroundColor: selected
                        ? `${colors.selectedBackground}40`
                        : `${neutral[500]}40`,
                },
                "&:focus": {
                    color: colors.selectedText,
                    border: `2px solid ${colors.focusColor}`,
                },
            },
        } }));
}
/** @returns the optional counter in a filter chip */
function ChipCounter({ count, dark, }) {
    const background = dark ? cyan$1[600] : blue[400];
    const color = dark ? neutral[999] : neutral[0];
    return (jsx(FaroText, { variant: "bodyS", color: color, sx: {
            backgroundColor: background,
            borderRadius: 5,
            px: "4px",
            fontWeight: FontWeights.SemiBold,
            fontSize: "10px",
            height: "14px",
            minWidth: "14px",
            lineHeight: "14px",
        }, children: count }));
}

const LIGHT_COLORS$7 = Object.freeze({
    color: neutral[800],
    highlightColor: blue[500],
    backgroundColor: neutral[50],
    shadowColor: neutral[1000],
});
const DARK_COLORS$7 = Object.freeze({
    color: neutral[100],
    highlightColor: cyan$1[400],
    backgroundColor: neutral[950],
});
/**
 * Styles to correctly position the arrow tip in the popover.
 *
 * Inspired by:
 * - https://github.com/mui/material-ui/blob/v5.15.18/docs/data/material/components/popper/ScrollPlayground.js
 * - https://stackoverflow.com/a/76948170
 */
const ARROW_STYLE = {
    '&[data-popper-placement*="bottom"]': {
        "& > div": {
            marginTop: 1.5,
        },
        "& .MuiPopper-arrow": {
            top: 0,
            "&::before": {
                transform: "translateX(-50%) translateY(-50%) rotate(45deg)",
            },
        },
    },
    '&[data-popper-placement*="top"]': {
        "& > div": {
            marginBottom: 1.5,
        },
        "& .MuiPopper-arrow": {
            bottom: 0,
            "&::before": {
                transform: "translateX(-50%) translateY(-50%) rotate(-135deg)",
            },
        },
    },
    '&[data-popper-placement*="right"]': {
        "& > div": {
            marginLeft: 1.5,
        },
        "& .MuiPopper-arrow": {
            left: 0,
            "&::before": {
                transform: "translateX(-50%) translateY(-50%) rotate(-45deg)",
            },
        },
    },
    '&[data-popper-placement*="left"]': {
        "& > div": {
            marginRight: 1.5,
        },
        "& .MuiPopper-arrow": {
            right: 0,
            "&::before": {
                transform: "translateX(-50%) translateY(-50%) rotate(135deg)",
            },
        },
    },
};
/**
 * @returns The base popover element, which styles the outer container and takes care of correct positioning of the arrow tip.
 */
function BasePopover({ dark, titleBar, onClose, children, closeOnClickOutside = true, showCloseButton = true, isAnimated = false, open, sx, popperSx, modifiers, ...rest }) {
    const colors = dark ? DARK_COLORS$7 : LIGHT_COLORS$7;
    const popperRef = useRef(null);
    const [arrowRef, setArrowRef] = useState(null);
    const arrowSize = "10px";
    // Updates a popper's location periodically, if movement of the anchor is expected
    useEffect(() => {
        let isRunning = true;
        function update() {
            popperRef.current?.update();
            if (isRunning)
                requestAnimationFrame(update);
        }
        if (isAnimated && open) {
            requestAnimationFrame(update);
        }
        return () => {
            isRunning = false;
        };
    }, [popperRef, isAnimated, open]);
    return (jsx(Popper, { popperRef: popperRef, open: open, sx: [
            ARROW_STYLE,
            {
                zIndex: 1,
                "& > div": {
                    position: "relative",
                },
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ], modifiers: [
            {
                name: "arrow",
                options: {
                    element: arrowRef,
                },
            },
            {
                name: "preventOverflow",
                options: {
                    padding: 4,
                },
            },
            ...(modifiers ?? []),
        ], transition: true, ...rest, children: ({ TransitionProps }) => (jsx(Fade, { ...TransitionProps, timeout: { enter: 300, exit: 200 }, children: jsxs("div", { children: [jsx(Box, { component: "div", className: "MuiPopper-arrow", ref: setArrowRef, sx: {
                            // A pseudo element is used to avoid clashes with the styles set by MUI
                            "&:before": {
                                position: "absolute",
                                display: "block",
                                content: '""',
                                width: arrowSize,
                                height: arrowSize,
                                backgroundColor: colors.backgroundColor,
                                borderTop: `1px solid ${colors.color}33`,
                                borderLeft: `1px solid ${colors.color}33`,
                            },
                        } }), jsx(Paper, { sx: {
                            minWidth: "12rem",
                            maxWidth: "20rem",
                            color: colors.color,
                            backgroundColor: colors.backgroundColor,
                            outline: `1px solid ${colors.color}33`,
                            boxShadow: colors.shadowColor
                                ? `0px 2px 6px ${colors.shadowColor}19`
                                : "none",
                            p: 2.5,
                            overflow: "visible",
                            ...popperSx,
                        }, children: jsx(ClickAwayListener, { onClickAway: () => {
                                if (closeOnClickOutside && onClose) {
                                    onClose();
                                }
                            }, children: jsxs(Stack, { gap: 1.25, children: [(!!titleBar || showCloseButton) && (jsxs(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", gap: 1.25, children: [jsx(Stack, { direction: "row", alignItems: "center", gap: 1.25, children: titleBar }), showCloseButton && (jsx(FaroIconButton, { size: "s", onClick: onClose, color: colors.color, hoverColor: colors.highlightColor, sx: { "&>:first-of-type": { m: 0 } }, children: jsx(CloseIcon, {}) }))] })), children] }) }) })] }) })) }));
}

const DARK_COLORS$6 = {
    backgroundColor: neutral[900],
    color: neutral[100],
    borderColor: neutral[0],
};
const LIGHT_COLORS$6 = {
    backgroundColor: neutral[100],
    color: neutral[800],
    borderColor: neutral[999],
};
/**
 * @returns A chip representing tags for the elements in the project
 */
function FaroChipTag({ label, size, color, dark = false, tooltip, className, showSpinner, disabled, onClick, onDelete, }) {
    const colors = dark ? DARK_COLORS$6 : LIGHT_COLORS$6;
    return (jsx(FaroChip, { label: label, tooltip: tooltip, backgroundColor: colors.backgroundColor, borderColor: `${colors.borderColor}33`, color: colors.color, size: size, variant: "outlined", textTransform: "none", icon: color ? (jsx("div", { style: {
                width: size === "small" ? "10px" : "14px",
                height: size === "small" ? "10px" : "14px",
                backgroundColor: color,
                borderRadius: size === "small" ? "5px" : "7px",
            } })) : undefined, sx: {
            letterSpacing: 0,
            "&.MuiChip-sizeSmall": {
                fontSize: "12px",
                lineHeight: "18px",
                height: "22px",
                verticalAlign: "center",
                fontWeight: FontWeights.Bold,
            },
            "&.MuiChip-sizeLarge": {
                fontSize: "14px",
                lineHeight: "20px",
                height: "30px",
                verticalAlign: "center",
                fontWeight: FontWeights.SemiBold,
            },
            "& .MuiChip-label": {
                pl: color ? "6px" : 0,
                pr: onDelete || showSpinner ? "8px" : 0,
            },
            "& .MuiChip-icon": {
                marginLeft: 0,
                marginRight: 0,
            },
            "& .MuiChip-deleteIcon": {
                color: colors.color,
            },
            ...(onClick && {
                "&.MuiButtonBase-root": {
                    ":hover": {
                        backgroundColor: `color-mix(in srgb, ${colors.backgroundColor}, ${neutral[500]} 15%)`,
                    },
                    ":active": {
                        backgroundColor: `${neutral[500]}40`,
                        boxShadow: 0,
                    },
                    ":focus": {
                        backgroundColor: `${neutral[500]}40`,
                        border: `2px solid ${colors.borderColor}`,
                    },
                },
            }),
            px: "8px",
            py: size === "small" ? "2px" : "5px",
        }, showSpinner: showSpinner, disabled: disabled, onClick: onClick, onDelete: onDelete, className: className }));
}

/**
 * @returns a horizontal list of chips that handles overflows by showing an additional "+n" chip with a dropdown menu
 *
 * If only one chip is defined it will be always shown
 */
function FaroChipList({ chips, dark, size, sx, showSingleChip = true, reverse = false, }) {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [container, setContainer] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [numVisible, setNumVisible] = useState(0);
    // These wrapped chips are used to detect after which chip the "+n" chip should be inserted.
    const wrappedChips = container
        ? chips.map((c, index) => (jsx(HideWhenOverflown, { container: container, numElementsLeft: chips.length - (index + 1), onVisibilityChanged: (isVisible) => setNumVisible((prevNumVisible) => {
                // Knowing whether a single chip is visible doesn't give us the numVisible state directly,
                // but it gives us an upper/lower bound that we can use to update the state.
                if (isVisible) {
                    const minNumVisible = index + 1;
                    return Math.max(minNumVisible, prevNumVisible);
                }
                return Math.min(index, prevNumVisible);
            }), children: c }, index)))
        : [];
    const numOverflown = chips.length - numVisible;
    const firstChip = chips.at(0);
    if (showSingleChip && firstChip && chips.length === 1) {
        return (jsx(Box, { component: "div", sx: sx, children: firstChip }));
    }
    return (jsxs(Stack, { sx: sx, children: [jsx(Stack, { ref: setContainer, direction: "row", gap: 1, sx: { maxHeight: 0, visibility: "hidden", overflow: "hidden" }, children: wrappedChips }), jsxs(Stack, { direction: reverse ? "row-reverse" : "row", gap: 1, overflow: "hidden", children: [chips.slice(0, numVisible), numOverflown > 0 && (jsxs(Box, { ref: setAnchorEl, component: "div", children: [jsx(FaroChipTag, { color: undefined, label: `+${numOverflown}`, dark: dark, size: size, onClick: () => setIsPopoverOpen(!isPopoverOpen) }), anchorEl && (jsx(BasePopover, { anchorEl: anchorEl, isAnimated: true, open: isPopoverOpen, onClose: () => setIsPopoverOpen(false), showCloseButton: false, dark: dark, popperSx: {
                                    minWidth: 0,
                                    maxHeight: 300,
                                    overflowY: "auto",
                                    px: 1.5,
                                    py: 1,
                                }, popperOptions: {
                                    placement: "bottom-start",
                                }, children: jsx(Stack, { gap: 0.5, children: chips.slice(numVisible) }) }))] }))] })] }));
}
/** @returns wrapped component that hides itself, when it overflows its parent. */
function HideWhenOverflown({ numElementsLeft, container, onVisibilityChanged, children, }) {
    const measureRef = useRef(null);
    // Creates an ResizeObserver to detect how much the element intersects its container,
    // by comparing the width of parent with the current width + offset of the child
    useLayoutEffect(() => {
        function onIntersection() {
            if (!measureRef.current)
                return;
            const containerRect = container.getBoundingClientRect();
            const chipRect = measureRef.current.getBoundingClientRect();
            const LARGE_CHIP_MARGIN = 48;
            const SMALL_CHIP_MARGIN = 40;
            // Change the margin used for the intersection based on the width of the chip
            // containing the number of remaining tags
            let margin = 0;
            if (numElementsLeft > 9) {
                margin = LARGE_CHIP_MARGIN;
            }
            else if (numElementsLeft > 0) {
                margin = SMALL_CHIP_MARGIN;
            }
            const isInBounds = Math.floor(chipRect.left + chipRect.width + margin) <=
                Math.ceil(containerRect.left + containerRect.width);
            onVisibilityChanged?.(isInBounds);
        }
        const observer = new ResizeObserver(onIntersection);
        observer.observe(container);
        return () => observer.disconnect();
    }, [container, onVisibilityChanged, numElementsLeft]);
    return jsx("div", { ref: measureRef, children: children });
}

/** The possible values of a FaroChipStatus */
var FaroChipOptions;
(function (FaroChipOptions) {
    FaroChipOptions["open"] = "open";
    FaroChipOptions["inProgress"] = "in_progress";
    FaroChipOptions["pending"] = "pending";
    FaroChipOptions["toReview"] = "to_review";
    FaroChipOptions["resolved"] = "resolved";
    FaroChipOptions["unclassified"] = "unclassified";
})(FaroChipOptions || (FaroChipOptions = {}));
/** Project markup status to display in readable text */
const FaroStatusText = {
    [FaroChipOptions.open]: "To-do",
    [FaroChipOptions.inProgress]: "In progress",
    [FaroChipOptions.pending]: "Pending",
    [FaroChipOptions.toReview]: "In review",
    [FaroChipOptions.resolved]: "Resolved",
    [FaroChipOptions.unclassified]: "Unclassified",
};
/**
 * Renders a status-tag/-chip. Currently used for the status of a project annotation.
 *
 * @returns JSX.Element - The status of the project annotation as a tag/chip
 */
function FaroChipStatus({ status, dark = false, size = "small", sx, }) {
    let color = neutral[800];
    let backgroundColor = neutral[0];
    let borderColor = neutral[300];
    let label = "Unclassified";
    const darkThemeBgColor = `${neutral[0]}1A`;
    // TODO: Consolidate colors with status-filter (https://faro01.atlassian.net/browse/SWEB-5640)
    switch (status) {
        case FaroChipOptions.open:
            color = dark ? neutral[200] : neutral[700];
            backgroundColor = neutral[100];
            borderColor = neutral[300];
            label = FaroStatusText.open;
            break;
        case FaroChipOptions.inProgress:
            color = dark ? blue[300] : blue[500];
            backgroundColor = blue[50];
            borderColor = blue[100];
            label = FaroStatusText.in_progress;
            break;
        case FaroChipOptions.pending:
            color = yellow[500];
            backgroundColor = yellow[50];
            borderColor = yellow[100];
            label = FaroStatusText.pending;
            break;
        case FaroChipOptions.toReview:
            color = dark ? purple[300] : purple[500];
            backgroundColor = purple[50];
            borderColor = purple[100];
            label = FaroStatusText.to_review;
            break;
        case FaroChipOptions.resolved:
            color = dark ? green[600] : green[700];
            backgroundColor = green[50];
            borderColor = green[100];
            label = FaroStatusText.resolved;
            break;
        case FaroChipOptions.unclassified:
            color = dark ? neutral[400] : neutral[500];
            backgroundColor = neutral[0];
            borderColor = neutral[300];
            label = FaroStatusText.unclassified;
            break;
    }
    return (jsx(FaroChip, { label: label, color: color, backgroundColor: dark ? darkThemeBgColor : backgroundColor, borderColor: dark ? darkThemeBgColor : borderColor, variant: "outlined", size: size === "small" ? "small" : "medium", textTransform: size === "small" ? "uppercase" : "none", sx: {
            ...(size === "large" && {
                fontWeight: FontWeights.SemiBold,
                fontSize: "0.875rem",
                lineHeight: "1.25rem",
            }),
            "& .MuiChip-labelSmall": {
                px: 1,
                py: 0.5,
            },
            "& .MuiChip-labelMedium": {
                px: 1.5,
                py: 0.625,
            },
            "& .MuiChip-icon": {
                marginLeft: 1,
                marginRight: 0,
                color,
            },
            ...sx,
        } }));
}

const DARK_COLORS$5 = {
    backgroundColor: neutral[999],
    color: neutral[300],
    borderColor: neutral[300],
    focusColor: neutral[0],
    selectedBackground: neutral[100],
    selectedText: neutral[999],
};
const LIGHT_COLORS$5 = {
    backgroundColor: neutral[0],
    color: neutral[600],
    borderColor: neutral[300],
    focusColor: neutral[999],
    selectedBackground: neutral[800],
    selectedText: neutral[0],
};
/** @returns a custom FaroChip that can be used as a toggle selector */
function FaroChipToggle({ selected, disabled, dark, label, ...rest }) {
    const colors = dark ? DARK_COLORS$5 : LIGHT_COLORS$5;
    return (jsx(FaroChip, { variant: "outlined", label: jsx(FaroText, { variant: "heading14", color: "inherit", children: label }), borderColor: colors.borderColor, backgroundColor: selected ? colors.selectedBackground : colors.backgroundColor, color: selected ? colors.selectedText : colors.color, icon: selected ? jsx(Checkmark2Icon, {}) : undefined, ...rest, sx: {
            textTransform: "none",
            pointerEvents: disabled ? "none" : "auto",
            opacity: disabled ? 0.5 : 1,
            "&.MuiChip-root": {
                height: "30px",
                px: "5px",
                py: "8px",
                "&:hover": {
                    backgroundColor: selected
                        ? colors.selectedBackground
                        : `color-mix(in srgb, ${colors.backgroundColor}, ${neutral[500]} 15%)`,
                },
                "&:active": {
                    backgroundColor: selected
                        ? colors.selectedBackground
                        : `${neutral[500]}40`,
                },
                "&:focus": {
                    border: `2px solid ${colors.focusColor}`,
                },
            },
        } }));
}

/**
 * Enum representing the available language codes.
 */
var LanguageCodes;
(function (LanguageCodes) {
    LanguageCodes["English"] = "en";
    LanguageCodes["Spanish"] = "es";
    LanguageCodes["French"] = "fr";
    LanguageCodes["German"] = "de";
    LanguageCodes["Japanese"] = "ja";
})(LanguageCodes || (LanguageCodes = {}));
/**
 * Maps a string code to a LanguageCodes enum entry.
 *
 * Note: Localize supports more languages than our app.
 * Some codes (e.g. "pt") are valid in Localize but unsupported here.
 * To avoid crashes, unsupported codes fallback to English by default.
 *
 * @returns The corresponding entry in the LanguageCodes enum for the given string
 * @param code Code to map
 */
function codeToLanguageCodes(code) {
    switch (code) {
        case "en":
            return LanguageCodes.English;
        case "es":
            return LanguageCodes.Spanish;
        case "fr":
            return LanguageCodes.French;
        case "de":
            return LanguageCodes.German;
        case "ja":
            return LanguageCodes.Japanese;
        default:
            // eslint-disable-next-line
            console.error(`Language code ${code} not supported.`);
            return LanguageCodes.English;
    }
}
/** CSS class to be used in order to disable translations for parts of the UI */
const NO_TRANSLATE_CLASS = "notranslate";

/**
 * @returns a text node that will not overflow, instead will truncate and show a tooltip
 * @deprecated Use TruncatedFaroText instead to get the proper FaroText styling for the content
 */
function TruncatedText({ children, ...rest }) {
    const { hasOverflown, checkForOverflow } = useCheckForOverflow();
    return (jsx(Tooltip, { title: children, disableHoverListener: !hasOverflown, children: jsx(Typography, { onMouseEnter: (ev) => checkForOverflow(ev.currentTarget), noWrap: true, ...rest, children: children }) }));
}
/**
 * @returns Base component for where a truncated text is needed so that we will be able to
 * reuse the styling and tooltip logic for different use truncation use cases
 */
function BaseTruncatedFaroText({ children, containerSx, title, hasOverflown, }) {
    return (jsx(Tooltip, { title: hasOverflown && title, children: jsx(Box, { component: "div", sx: {
                minWidth: 0,
                // Making sure that all wrappers are getting the style for truncating text
                // This is important, for example, for text wrapped within <NoTranslate>
                "& *": {
                    overflow: "clip",
                    textOverflow: "ellipsis",
                },
                ...containerSx,
            }, children: children }) }));
}
/** @returns a text node that will not overflow, instead will truncate and show a tooltip */
function TruncatedFaroText({ children, containerSx, tooltip, ...rest }) {
    const { hasOverflown, checkForOverflow } = useCheckForOverflow();
    return (jsx(BaseTruncatedFaroText, { title: tooltip ?? children, hasOverflown: hasOverflown, containerSx: containerSx, ...rest, children: jsx(Box, { component: "div", onMouseEnter: (ev) => checkForOverflow(ev.currentTarget), children: jsx(FaroText, { component: "div", shouldElide: true, ...rest, children: children }) }) }));
}
/**
 * @returns a text node that will not overflow, instead will truncate and show a tooltip
 * it will also provide a suffix generated from the truncated text's last characters if needed
 */
function TruncatedFaroTextWithSuffix({ shouldTranslate, containerSx, lengthOfSuffix, text, ...rest }) {
    const { hasOverflown, checkForOverflow } = useCheckForOverflow();
    const { truncatedTextWithoutSuffix, generatedSuffix } = useMemo(() => {
        const truncatedTextWithoutSuffix = lengthOfSuffix
            ? text.slice(0, -lengthOfSuffix)
            : text;
        const generatedSuffix = lengthOfSuffix ? text.slice(-lengthOfSuffix) : "";
        return { truncatedTextWithoutSuffix, generatedSuffix };
    }, [lengthOfSuffix, text]);
    return (jsx(BaseTruncatedFaroText, { hasOverflown: hasOverflown, containerSx: containerSx, title: text, ...rest, children: jsxs(Box, { component: "div", onMouseEnter: (ev) => checkForOverflow(ev.currentTarget), className: shouldTranslate ? undefined : NO_TRANSLATE_CLASS, sx: {
                display: "flex",
                flexDirection: "row",
            }, children: [jsx(FaroText, { shouldElide: true, ...rest, children: truncatedTextWithoutSuffix }), jsx(FaroText, { shouldElide: false, ...rest, children: generatedSuffix })] }) }));
}

/** @returns a single card, to create a card list, used in CardSelector */
function SingleCardItem({ cardItem, isSelected, onSelect, cardDirection = "column", defaultBackgroundColor = neutral[50], selectedBackgroundColor = neutral[0], defaultBorderColor = "transparent", selectedBorderColor = blue[500], }) {
    return (jsxs(Stack, { onClick: () => onSelect(cardItem.value, cardItem), sx: {
            backgroundColor: isSelected
                ? selectedBackgroundColor
                : defaultBackgroundColor,
            border: isSelected
                ? `2px solid ${selectedBorderColor}`
                : `1px solid ${defaultBorderColor}`,
            borderRadius: "4px",
            transition: "border-color 0.3s ease",
            flexBasis: {
                xs: "100%",
                md: "calc(25% - 10px)",
            },
            flexGrow: 1,
            alignItems: cardDirection === "column" ? "center" : "end",
            flexDirection: cardDirection,
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers -- adding 20px of padding
            padding: (theme) => theme.spacing(2.5),
            gap: 1,
            cursor: isSelected ? "default" : "pointer",
            ...(!isSelected && {
                "&:hover": {
                    border: `1px solid ${neutral[100]}`,
                    backgroundColor: `color-mix(in srgb, ${neutral[50]}, ${neutral[500]} 15%)`,
                },
            }),
        }, children: [jsxs(Stack, { sx: {
                    alignItems: cardDirection === "column" ? "center" : "start",
                }, children: [jsx(Stack, { sx: { height: "2rem", maxWidth: "80%" }, children: cardItem.badgeText && (jsx(FaroChip, { backgroundColor: cardItem.badgeBackgroundColor ?? blue[50], borderColor: cardItem.badgeBorderColor ?? blue[100], color: cardItem.badgeColor ?? blue[500], label: jsx(TruncatedFaroText, { variant: "bodyS", sx: {
                                    // Text styles has inherited to have the design of FaroChip
                                    color: "inherit",
                                    fontSize: "inherit",
                                    fontWeight: "inherit",
                                    lineHeight: "inherit",
                                }, children: cardItem.badgeText }), variant: "outlined" })) }), jsx(Stack, { sx: {
                            width: "100%",
                            textAlign: cardDirection === "column" ? "center" : "start",
                        }, children: jsx(TruncatedFaroText, { variant: "heading20", children: cardItem.title }) })] }), jsx(Stack, { sx: {
                    width: "100%",
                    textAlign: cardDirection === "column" ? "center" : "end",
                }, children: cardItem.subtitle && (jsx(TruncatedFaroText, { variant: "heading14", sx: {
                        color: neutral[600],
                    }, children: cardItem.subtitle })) })] }));
}

/**
 * @returns a list of card rendered with ability to select one of them
 */
function CardSelector({ cardItems, selectedValue, cardDirection = "row", defaultBackgroundColor = neutral[50], selectedBackgroundColor = neutral[0], defaultBorderColor = "transparent", selectedBorderColor = blue[500], onSelect, }) {
    return (jsx(Stack, { sx: {
            gap: 1,
            flexWrap: "wrap",
            width: "100%",
            flexDirection: {
                xs: "column",
                md: cardDirection,
            },
        }, children: cardItems.map((cardItem, index) => (jsx(SingleCardItem, { cardItem: cardItem, isSelected: selectedValue === cardItem.value, onSelect: onSelect, 
            // According to the design, the card direction is always opposite for SingleCardItem compared to CardSelector
            // This is to ensure that the elements of cards are displayed in a row when CardSelector is in column and vice versa
            cardDirection: cardDirection === "column" ? "row" : "column", defaultBackgroundColor: defaultBackgroundColor, selectedBackgroundColor: selectedBackgroundColor, defaultBorderColor: defaultBorderColor, selectedBorderColor: selectedBorderColor }, index))) }));
}

/**
 * @returns a correctly positioned badge as per the design guideline
 */
function ChangeIndicatorBadge({ children, variant, sx, ...rest }) {
    return (jsx(Badge, { variant: variant ?? "dot", sx: {
            "& .MuiBadge-dot": {
                backgroundColor: orange[400],
                width: "6px",
                height: "6px",
                border: "none",
                outline: `1px solid ${neutral[0]}}`,
            },
            ...sx,
        }, ...rest, children: children }));
}

/**
 * @returns a button that will copy text to the clipboard on click
 * includes tooltip and toas notification of text coppied.
 */
function CopyToClipboardButton({ text, ...restProps }) {
    const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);
    const handleClick = useCallback(() => {
        if (text) {
            setIsTooltipOpen(false);
            setIsSnackbarOpen(true);
            navigator.clipboard.writeText(text);
        }
    }, [text]);
    if (!text)
        return null;
    return (jsxs(Fragment, { children: [jsx(Tooltip, { title: "Copy to clipboard", componentsProps: {
                    tooltip: {
                        sx: {
                            fontSize: "14pt",
                        },
                    },
                }, 
                // Disable Portal for when tooltip is used in 3d view, so it gets placed in the scene correctly.
                PopperProps: {
                    disablePortal: true,
                }, 
                // Set it up as a controlled tooltip, so we can close the tooltip when we open the toast
                open: isTooltipOpen, onOpen: () => setIsTooltipOpen(true), onClose: () => setIsTooltipOpen(false), children: jsx(IconButton$1, { onClick: handleClick, ...restProps, children: jsx(CopyAllIcon, {}) }) }), jsx(Snackbar, { message: jsxs(Typography, { fontSize: "2em", children: ["Copied ", jsx("b", { children: text }), " to clibboard"] }), anchorOrigin: { vertical: "top", horizontal: "center" }, autoHideDuration: 2000, onClose: () => setIsSnackbarOpen(false), open: isSnackbarOpen })] }));
}

/**
 * @param file file to get am image for
 * @returns the Image object for the file
 */
function parseImageFromFile(file) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => {
            resolve(image);
        };
        image.onerror = reject;
        image.src = URL.createObjectURL(file);
    });
}
/**
 *
 * @param rect original size of the image
 * @param angle angle to rotate image in degrees
 * @returns dimensions of rotated image
 *
 * Helper function to compute dimensions of rotated image
 */
function computeRotatedImageDimensions(rect, angle) {
    const angleInRadians = (angle * Math.PI) / 180;
    const width = Math.abs(rect.width * Math.cos(angleInRadians)) +
        Math.abs(rect.height * Math.sin(angleInRadians));
    const height = Math.abs(rect.height * Math.cos(angleInRadians)) +
        Math.abs(rect.width * Math.sin(angleInRadians));
    return { width, height };
}

/**
 * @returns an image file containing the resized image, can be a thumbnail file as well
 * @param file the image file to generate a thumbnail for or to resize
 * @param params The resizing parameters
 */
async function resizeImage(file, params) {
    const image = await parseImageFromFile(file);
    return new File([await generateThumbnailBlob({ ...params, image })], `${removeExtension(file.name)}-thumb.jpg`, { type: "image/jpeg" });
}
/**
 * @returns a thumbnail image for an image
 */
function generateThumbnailBlob({ compressRatio = 0.85, ...params }) {
    const canvas = generateThumbnailCanvas(params);
    return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            if (blob) {
                resolve(blob);
                return;
            }
            reject(Error("generateThumbnailBlob: Failed to convert thumbnail to blob"));
        }, "image/jpeg", compressRatio);
    });
}
/**
 * @returns a new canvas with a thumbnail of the image drawn on it.
 */
function generateThumbnailCanvas({ image, maxSize = 1024, }) {
    const originHeight = image.height;
    const originWidth = image.width;
    maxSize = Math.min(maxSize, Math.max(image.width, image.height));
    const aspectX = maxSize / originWidth;
    const aspectY = maxSize / originHeight;
    let newWidth, newHeight;
    if (aspectX > aspectY) {
        newWidth = Math.round(originWidth * aspectY);
        newHeight = Math.round(originHeight * aspectY);
    }
    else {
        newWidth = Math.round(originWidth * aspectX);
        newHeight = Math.round(originHeight * aspectX);
    }
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = newWidth;
    canvas.height = newHeight;
    if (!ctx)
        throw new Error("generateThumbnail: Failed to create context");
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    return canvas;
}

// Value used to convert RGB values to hexadecimal format
const MAX_COLOR_VALUE = 255;
// Length (bits) of a color string in hexadecimal format
const COLOR_STRING_LENGTH = 24;
// Regular expression to validate hexadecimal color strings
const HEX_REGEX = /^#[0-9A-Fa-f]{6}$/;
/**
 * Interpolates between two colors based on a given value.
 *
 * @param firstColor The first color in hexadecimal format.
 * @param secondColor The second color in hexadecimal format.
 * @param value The value between 0 and 1 representing the interpolation point.
 * @returns The interpolated color as a hexadecimal string.
 */
function interpolateColor(firstColor, secondColor, value) {
    assert(firstColor.match(HEX_REGEX), "First color must be a valid hexadecimal color string");
    assert(secondColor.match(HEX_REGEX), "Second color must be a valid hexadecimal color string");
    assert(value >= 0 && value <= 1, "Value must be between 0 and 1");
    // Remove the # from the string and convert number from hex to decimal
    const startRGB = parseInt(firstColor.slice(1), 16);
    // Each hex digit is 4 bits, so we shift the bits to the right by 16 (4 hex values) to get the red component (remaining 2 hex values)
    const startR = startRGB >> 16;
    // Now we shift the bits to the right by 8 (2 hex values),
    // so that only the green and red components are left in the number,
    // and use the bitwise AND operator with 255 (0xFF) to get the first two values (2 hex) of the remaining bits (green component)
    const startG = (startRGB >> 8) & MAX_COLOR_VALUE;
    // Use the bitwise AND operator with 255 (0xFF) to get the first two values (2 hex) (blue component)
    const startB = startRGB & MAX_COLOR_VALUE;
    const endRGB = parseInt(secondColor.slice(1), 16);
    const endR = endRGB >> 16;
    const endG = (endRGB >> 8) & MAX_COLOR_VALUE;
    const endB = endRGB & MAX_COLOR_VALUE;
    // Interpolate the red, green, and blue components separately
    const r = Math.round(startR + (endR - startR) * value);
    const g = Math.round(startG + (endG - startG) * value);
    const b = Math.round(startB + (endB - startB) * value);
    // Convert the interpolated RGB values back to a hex color string
    // Place the red in the first 2 hex values, green in the next 2, and blue in the last 2
    // 1 << 24 adds a one to the 25th bit, to make sure the number is at least 24 bits long (6 hex values),
    // so that the leading zeros are not removed.
    // The leading 1 is then removed with the slice method, and the number is converted to a hexadecimal string.
    return `#${((1 << COLOR_STRING_LENGTH) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
}

function isTwoColors(colors) {
    return colors.length === 2 && typeof colors[0] === "string";
}
/**
 * @returns A bar with a gradient from the first color to the second color
 */
function ColorBar({ colors, values, direction = "horizontal", sx, onPointerMove, onClick, onPointerEnter, }) {
    assert(colors.length > 1, "ColorBar: colors must have at least 2 colors");
    const isHorizontal = useMemo(() => direction === "horizontal", [direction]);
    const containerRef = useRef(null);
    const colorGradient = useMemo(() => isTwoColors(colors)
        ? `${colors[0]}, ${colors[1]}`
        : colors.map((c) => `${c.color} ${c.ratio * 100}%`).join(", "), [colors]);
    const computeInterpolatedColor = useCallback((e, callback) => {
        if (!containerRef.current || !callback)
            return;
        const rect = containerRef.current.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const normalizedValue = clamp(isHorizontal ? x / rect.width : 1 - y / rect.height, 0, 1);
        let interpolatedColor;
        if (isTwoColors(colors)) {
            interpolatedColor = interpolateColor(colors[0], colors[1], normalizedValue);
        }
        else {
            interpolatedColor = interpolateColorFromList(colors, normalizedValue);
        }
        callback(interpolatedColor, normalizedValue);
    }, [isHorizontal, colors]);
    return (jsxs(Stack, { direction: isHorizontal ? "column" : "row", 
        // Add small padding between the color bar and the values' text
        gap: 0.5, sx: sx, ref: containerRef, children: [jsx(Stack, { sx: {
                    p: 1,
                    borderRadius: 2,
                    outline: `1px solid ${neutral[0]}33`,
                    // Make the gradient go from left to right or from bot to top based on the direction prop
                    background: `linear-gradient(to ${isHorizontal ? "right" : "top"}, ${colorGradient})`,
                }, onPointerMove: (e) => computeInterpolatedColor(e, onPointerMove), onClick: (e) => computeInterpolatedColor(e, onClick), onPointerEnter: (e) => computeInterpolatedColor(e, onPointerEnter) }), values && (jsxs(Stack, { direction: isHorizontal ? "row" : "column-reverse", justifyContent: "space-between", children: [jsxs(FaroText, { color: neutral[400], variant: "bodyS", children: [values.startValue, values.unit] }), jsxs(FaroText, { color: neutral[400], variant: "bodyS", children: [values.endValue, values.unit] })] }))] }));
}
/**
 * Interpolates a color from a color gradient and a normalized value.
 *
 * @param colors The list of colors constituting the gradient
 * @param value the value of the color to pick from the gradient, between 0 and 1
 * @returns The interpolated color from the list of colors
 */
function interpolateColorFromList(colors, value) {
    let interpolatedColor;
    // find the sub range where the normalized value is
    for (let i = 0; i < colors.length - 1; i++) {
        assert(colors[i + 1].ratio >= colors[i].ratio, "Color ratios expected to be in non decreasing order");
        if (value <= colors[i + 1].ratio) {
            // deal with the case where two consecutive ratios are same
            if (colors[i].ratio === colors[i + 1].ratio) {
                interpolatedColor = colors[i].color;
            }
            else {
                // interpolate in the sub range
                interpolatedColor = interpolateColor(colors[i].color, colors[i + 1].color, (value - colors[i].ratio) / (colors[i + 1].ratio - colors[i].ratio));
            }
            break;
        }
    }
    return interpolatedColor;
}

/**
 * @returns a HTMLVarElement with extra properties used to control phrases translations
 *
 * Note: This components uses the LocalizeJS data prefixes because passing custom property in react does not work as expected
 * @see https://developers.localizejs.com/docs/using-html-syntax-to-prepare-phrases#variables
 */
function TranslateVar({ children, name, pluralize, isolate, }) {
    return (jsx("var", { "data-var": name, "data-pluralize": pluralize, "data-isolate": isolate, 
        // fix variables being italicized, e.g. in Storybook
        style: { fontStyle: "inherit" }, children: children }));
}

var DatePickerVariant;
(function (DatePickerVariant) {
    DatePickerVariant["Light"] = "Light";
    DatePickerVariant["Dark"] = "Dark";
})(DatePickerVariant || (DatePickerVariant = {}));
const lightVariant = {
    backgroundColor: neutral[0],
    selectedColor: blue[500],
    secondaryColor: neutral[1000],
    hoverColor: neutral[500],
    disabledPrimaryColor: `${neutral[800]}80`,
    disabledSecondaryColor: `${neutral[500]}80`,
    errorColor: red[300],
    readOnlyBackgroundColor: neutral[100],
    inputFieldDefaultColor: neutral[600],
    inputFieldHoverColor: neutral[800],
    iconColor: `${neutral[1000]}89`,
    textColorFooter: neutral[500],
    textColorWeekDay: neutral[500],
    textColorSelectedDay: neutral[0],
    textColorInputFieldLabel: neutral[800],
    textColorDayOutsideMonth: neutral[500],
};
const darkVariant = {
    backgroundColor: neutral[999],
    selectedColor: cyan$1[500],
    secondaryColor: neutral[0],
    hoverColor: neutral[100],
    disabledPrimaryColor: `${neutral[100]}80`,
    disabledSecondaryColor: `${neutral[500]}80`,
    errorColor: red[300],
    readOnlyBackgroundColor: neutral[900],
    inputFieldDefaultColor: neutral[500],
    inputFieldHoverColor: neutral[0],
    iconColor: neutral[100],
    textColorFooter: neutral[0],
    textColorWeekDay: neutral[300],
    textColorSelectedDay: neutral[0],
    textColorInputFieldLabel: neutral[100],
    textColorDayOutsideMonth: neutral[500],
};
const variantMap = {
    Light: lightVariant,
    Dark: darkVariant,
};

/**
 * @returns a customized MUI DatePicker that follow the FARO design guidelines
 */
function DatePicker({ label, initialDate: sourceInitialDate, date: sourceDate, variant = DatePickerVariant.Light, enableDot = false, readOnly = false, disabled = false, error = false, isClearable = false, onChange, formSx, }) {
    // isOpen is a reflection of the internal state of the MuiDatePicker. Its value is used to style the components.
    // updateIsOpen is only used in callbacks of the Mui component. It cannot be used to forcefully open the DatePicker.
    const [isOpen, updateIsOpen] = useState(false);
    // Convert the date objects to the luxon object MUI expects, if the date is available
    const initialDate = useMemo(() => sourceInitialDate ? DateTime.fromJSDate(sourceInitialDate) : undefined, [sourceInitialDate]);
    const date = useMemo(() => (sourceDate ? DateTime.fromJSDate(sourceDate) : undefined), [sourceDate]);
    /** Object containing all the colors to use for the current variant */
    const variantStyle = variantMap[variant];
    /** Color to apply to the input field text label */
    const labelColor = useMemo(() => {
        if (error) {
            return variantStyle.errorColor;
        }
        if (disabled) {
            return variantStyle.disabledPrimaryColor;
        }
        return variantStyle.textColorInputFieldLabel;
    }, [
        disabled,
        error,
        variantStyle.disabledPrimaryColor,
        variantStyle.errorColor,
        variantStyle.textColorInputFieldLabel,
    ]);
    /** Wrapper of the CustomPickersDay component, used to forward some custom props */
    const CustomPickersDayWrapper = useCallback((props) => (jsx(CustomPickersDay, { variantStyle: variantStyle, enableDot: enableDot, ...props })), [enableDot, variantStyle]);
    /** Wrapper of the CustomCalendarLayout component, used to forward some custom props */
    const CustomCalendarLayoutWrapper = useCallback((props) => (jsx(CustomCalendarLayout, { variantStyle: variantStyle, initialDate: initialDate, ...props })), [initialDate, variantStyle]);
    return (jsxs(FormControl, { variant: "outlined", sx: formSx, children: [jsx(InputLabel, { sx: {
                    color: labelColor,
                }, children: label }), jsx(DatePicker$1, { disabled: disabled, readOnly: readOnly, onOpen: () => updateIsOpen(true), onClose: () => updateIsOpen(false), sx: {
                    height: "56px",
                    // Pushing the label above the input
                    "label + &": {
                        marginTop: 3,
                    },
                    ".MuiInputBase": {
                        "&-root": {
                            // Set the height of the input field
                            height: "38px",
                            // Update color of text and background of the input field
                            backgroundColor: variantStyle.backgroundColor,
                            // Update the color of the input field's text value
                            color: isOpen
                                ? variantStyle.inputFieldHoverColor
                                : variantStyle.inputFieldDefaultColor,
                            // Change the style on hover of the entire input field, so that all its components are updated at the same time
                            ":hover": {
                                // Update the color of the input field's text value on hover
                                color: variantStyle.inputFieldHoverColor,
                                ">fieldset": {
                                    // Update border color of input field on hover
                                    borderColor: variantStyle.inputFieldHoverColor,
                                },
                                ">input::placeholder": {
                                    // Update the color of the input field's placeholder text on hover (if available)
                                    color: variantStyle.inputFieldHoverColor,
                                },
                                ">.MuiInputAdornment-root>button": {
                                    // Change the color of the calendar icon on hover
                                    color: variantStyle.inputFieldHoverColor,
                                },
                            },
                            // Update style of all components when the date picker is disabled
                            "&.Mui-disabled": {
                                ">input": {
                                    // Color the input field's text value when it's disabled
                                    color: variantStyle.disabledSecondaryColor,
                                    // This property is set to override an mui color that has priority over the "color" property
                                    WebkitTextFillColor: variantStyle.disabledSecondaryColor,
                                },
                                ">.MuiInputAdornment-root>button": {
                                    // Color the calendar icon when it's disabled
                                    color: variantStyle.disabledPrimaryColor,
                                },
                                ">fieldset": {
                                    // Color the input field's border when it's disabled
                                    border: `1px solid ${variantStyle.disabledSecondaryColor}`,
                                },
                            },
                            // Update style of all components when the date picker is in read only mode
                            "&.Mui-readOnly": {
                                // Change the color of the input field background when it's read only
                                backgroundColor: variantStyle.readOnlyBackgroundColor,
                                ">input": {
                                    // Color the input field's text value when it's read only
                                    color: variantStyle.inputFieldHoverColor,
                                    // This property is set to override an mui color that has priority over the "color" property
                                    WebkitTextFillColor: variantStyle.inputFieldHoverColor,
                                },
                                ">.MuiInputAdornment-root>button": {
                                    // Color the calendar icon when it's read only
                                    color: variantStyle.inputFieldHoverColor,
                                },
                                ">fieldset": {
                                    // Remove border in read only mode
                                    border: "none",
                                },
                            },
                            // Update style of all components when the date picker is in error state
                            "&.Mui-error": {
                                ">fieldset": {
                                    // Apply border to the input field when the date picker is in error state
                                    border: `2px solid ${variantStyle.errorColor}`,
                                },
                            },
                        },
                        "&-input": {
                            "::placeholder": {
                                // Update the color of the input field's placeholder
                                // It will have a different color if the DatePicker is opened
                                color: isOpen
                                    ? variantStyle.inputFieldHoverColor
                                    : variantStyle.inputFieldDefaultColor,
                            },
                        },
                    },
                    ".MuiIconButton-root": {
                        // Update the color of the calendar icon
                        color: isOpen
                            ? variantStyle.inputFieldHoverColor
                            : variantStyle.inputFieldDefaultColor,
                        ".MuiSvgIcon-root": {
                            // Resize the calendar icon
                            fontSize: "18px",
                        },
                    },
                    ".MuiOutlinedInput-notchedOutline": {
                        // Update border color of the input field (use important to override the mui class that is created)
                        // Since there is no CSS class to know if this element is "active" (it's active when the DatePicker is opened),
                        // we directly check the open property of the DatePicker
                        border: isOpen
                            ? `2px solid ${variantStyle.selectedColor} !important`
                            : `1px solid ${variantStyle.inputFieldDefaultColor}`,
                    },
                }, views: ["year", "month", "day"], slots: {
                    // Use correct icon for the calendar button
                    openPickerIcon: CalendarIcon,
                    // Hide the arrow to open the month selector
                    switchViewIcon: () => null,
                    // Inject our custom day picker renderer
                    day: CustomPickersDayWrapper,
                    // Inject our custom calendar layout to add the footer
                    layout: CustomCalendarLayoutWrapper,
                }, showDaysOutsideCurrentMonth: true, disableHighlightToday: true, slotProps: {
                    textField: {
                        error,
                    },
                    field: { clearable: isClearable },
                }, value: date, defaultValue: initialDate, onChange: (date) => onChange?.(date instanceof DateTime ? date.toJSDate() : undefined) })] }));
}
/**
 * @returns the color to use for the PickersDay
 * @param today true if this PickersDay is for today
 * @param outsideCurrentMonth true if this PickersDay is outside of the current month
 * @param variantStyle object with colors to use for the current variant of the DatePicker
 */
function computeDayLabelColor(today, outsideCurrentMonth, variantStyle) {
    if (today) {
        // Color of the current day
        return variantStyle.selectedColor;
    }
    if (outsideCurrentMonth) {
        // Color of the visible days that are outside the current month
        return variantStyle.textColorDayOutsideMonth;
    }
    // Color of the non selected days of the current month
    return variantStyle.secondaryColor;
}
/**
 * @returns a dot placed just below a PickersDay to identify the "today" picker
 */
function PickersDayTodayDot({ color }) {
    return (jsx(Stack, { direction: "row", alignItems: "center", justifyContent: "center", sx: {
            position: "relative",
            height: "10px",
            width: "auto",
            bottom: "10px",
            m: 0,
            p: 0,
        }, children: jsx(Box, { component: "span", sx: {
                height: "5px",
                width: "5px",
                backgroundColor: color,
                borderRadius: "50%",
                display: "inline-block",
            } }) }));
}
/**
 * @returns a custom PickersDay to match the FARO Design
 */
function CustomPickersDay({ outsideCurrentMonth, selected, today, variantStyle, enableDot, ...rest }) {
    const styles = {
        // Update colors of the focused day (can focus with tab)
        "&:focus-visible": {
            backgroundColor: `${variantStyle.hoverColor}1E`,
            color: variantStyle.selectedColor,
            border: `1px solid ${variantStyle.selectedColor}`,
        },
        // Update style on pressed state (this style is applied after long press and release, or after right click)
        "&:focus": {
            backgroundColor: `${variantStyle.hoverColor}1E`,
            color: variantStyle.selectedColor,
        },
        "&.Mui-selected": {
            // Update background color of the current selected day, when pressing another day (long press on new date)
            backgroundColor: variantStyle.selectedColor,
            // Update color of the text for the selected day
            color: variantStyle.textColorSelectedDay,
            // Add border to selected day
            border: `1px solid ${variantStyle.selectedColor}`,
            "&:focus": {
                // Update colors of the selected day when it's focused
                backgroundColor: variantStyle.selectedColor,
                border: variantStyle.selectedColor,
            },
        },
        ".MuiTouchRipple-child": {
            // Update color of ripple and add 40% opacity (between mouse press and mouse release)
            backgroundColor: `${variantStyle.hoverColor}66`,
        },
        "&:hover": {
            // Update day background color when hovered
            backgroundColor: `${variantStyle.hoverColor}26`,
        },
        // Update days text color if the selected date is outside the date range (before 1900 or after 2099)
        "&.Mui-disabled": {
            // Use color for the non selected and disabled days text of the current month
            color: `${variantStyle.disabledPrimaryColor} !important`,
            "&.Mui-selected": {
                // Use specific color for the selected and disabled day text
                color: `${variantStyle.textColorSelectedDay} !important`,
            },
            "&.MuiPickersDay-dayOutsideMonth": {
                // Use specific color for the disabled days text outside the current month
                color: `${variantStyle.disabledSecondaryColor} !important`,
            },
        },
        color: computeDayLabelColor(today, outsideCurrentMonth, variantStyle),
        fontSize: "0.875rem",
        fontWeight: outsideCurrentMonth
            ? FontWeights.Regular
            : FontWeights.SemiBold,
    };
    return (
    // Wrap PickersDay in a Box to overlay a little blue dot for the "today" picker
    jsxs(Box, { component: "div", sx: { height: "36px" }, children: [jsx(PickersDay, { sx: styles, tabIndex: 0, outsideCurrentMonth: outsideCurrentMonth, ...rest }), enableDot && today && !selected && (jsx(PickersDayTodayDot, { color: variantStyle.selectedColor }))] }));
}
/**
 * @returns a custom calendar layout with a Footer showing the initial date
 */
function CustomCalendarLayout({ variantStyle, initialDate, isLandscape, ...rest }) {
    const { content, actionBar } = usePickerLayout({ isLandscape, ...rest });
    return (jsxs(Stack, { direction: "column", 
        // Update background color of the date picker
        sx: { backgroundColor: variantStyle.backgroundColor }, children: [jsxs(PickersLayoutRoot
            // Localization should be handled by a LocalizationProvider context in the app
            , { 
                // Localization should be handled by a LocalizationProvider context in the app
                className: NO_TRANSLATE_CLASS, ownerState: { isLandscape, ...rest }, children: [jsx(PickersLayoutContentWrapper, { className: pickersLayoutClasses.contentWrapper, sx: {
                            // Change color of days labels
                            ".MuiDayCalendar-weekDayLabel": {
                                // Update text color of initials of week days
                                color: variantStyle.textColorWeekDay,
                                fontWeight: FontWeights.SemiBold,
                                fontSize: "0.875rem",
                            },
                            ".MuiPickersMonth-monthButton": {
                                // Update text color of months in "months" view
                                color: variantStyle.secondaryColor,
                            },
                            ".MuiPickersYear-yearButton": {
                                // Update text color of years in "years" view
                                color: variantStyle.secondaryColor,
                            },
                            // Adjust the position of the month change arrow to be
                            // at the side of the month-year label and not on the top right
                            // of the calendar
                            ".MuiPickersCalendarHeader-root": {
                                padding: 0,
                            },
                            ".MuiPickersArrowSwitcher": {
                                "&-spacer": {
                                    display: "flex",
                                    flex: 1,
                                },
                                "&-root": {
                                    width: "100%",
                                    // Leave some space to the left and right so that the arrow buttons are not on the edge
                                    mx: "25px",
                                },
                                "&-button": {
                                    // Resize the icons to change month
                                    fontSize: "16px",
                                    // Update color of arrow icons used to change current month
                                    color: variantStyle.iconColor,
                                },
                            },
                            ".MuiPickersCalendarHeader": {
                                "&-labelContainer": {
                                    position: "absolute",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    left: 0,
                                    right: 0,
                                    display: "flex",
                                    justifyContent: "center",
                                },
                                "&-label": {
                                    // Resize the current month text
                                    fontSize: "0.875rem",
                                    margin: 0,
                                    fontWeight: FontWeights.Bold,
                                    // Update text color of current month in the header
                                    color: variantStyle.secondaryColor,
                                },
                                "&-switchViewButton": {
                                    display: "none",
                                },
                            },
                        }, children: content }), actionBar] }), initialDate && (jsxs(Fragment, { children: [jsx(Divider, { sx: { mx: 1 } }), jsxs(Typography, { fontSize: "12px", 
                        // Update text color of the footer
                        sx: { m: 1, px: 1, color: variantStyle.textColorFooter }, children: ["Original Date:", " ", jsx(TranslateVar, { name: "originalDate", children: initialDate.toLocaleString(DateTime.DATE_FULL) })] })] }))] }));
}

/** All the supported sizes of the FaroDialog  */
var FaroDialogSizes;
(function (FaroDialogSizes) {
    FaroDialogSizes["s"] = "s";
    FaroDialogSizes["m"] = "m";
    FaroDialogSizes["l"] = "l";
})(FaroDialogSizes || (FaroDialogSizes = {}));

const LIGHT_FARO_DIALOG_PALETTE = {
    background: neutral[0],
    foreground: neutral[800],
};
const DARK_FARO_DIALOG_PALETTE = {
    background: neutral[999],
    foreground: neutral[100],
};
/**
 * @returns a dialog to ask the user to confirm or cancel an action
 */
function FaroDialog({ title, children, open, onConfirm, isConfirmDisabled = false, confirmText = "Confirm", confirmTooltip, cancelText = "Cancel", cancelTooltip, onCancel, onClose, variant = "info", size = FaroDialogSizes.m, showSpinner = false, disabled = false, cancelButtonActions, showXButton = false, dark = false, hideBackdrop = false, sx, height, }) {
    const colors = dark ? DARK_FARO_DIALOG_PALETTE : LIGHT_FARO_DIALOG_PALETTE;
    const sizeStyles = SIZE_STYLE_MAP[size];
    const shouldShowXButton = useMemo(() => size === FaroDialogSizes.l || showXButton, [showXButton, size]);
    return (jsx(Dialog, { open: open, 
        // Make sure the dialog is not closable while the spinner is shown
        onClose: showSpinner ? undefined : onClose, sx: sx, PaperProps: {
            sx: {
                p: "2rem",
                background: colors.background,
                color: colors.foreground,
                height,
                ...sizeStyles,
            },
        }, hideBackdrop: hideBackdrop, children: jsxs(Stack, { direction: "column", sx: {
                pointerEvents: disabled ? "none" : "auto",
                opacity: disabled ? 0.5 : 1,
                overflow: "auto",
            }, children: [jsx(FaroText, { variant: "heading20", children: jsxs(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", children: [title && (jsx(TruncatedFaroText, { variant: "heading20", component: "span", color: colors.foreground, children: title })), onClose && shouldShowXButton && (jsx(FaroIconButton, { size: "xs", color: colors.foreground, 
                                // The signature of onClose is defined by MUI and only allow "escapeKeyDown" and "backdropClick"
                                // as a X button is not part of the MUI specs
                                // I'm using escapeKeyDown as a reason for the dialog close here for now
                                onClick: (ev) => onClose(ev, "escapeKeyDown"), children: jsx(CloseCancelErrorIcon, { sx: { color: "black" } }) }))] }) }), jsx(DialogContent, { sx: {
                        p: 0,
                        marginTop: "1.5rem",
                        display: "flex",
                        flexDirection: "column",
                    }, children: children }), (onCancel ?? onConfirm) && (jsxs(DialogActions, { sx: { p: 0, marginTop: "2rem" }, children: [onCancel && (jsx(FaroTooltip, { title: cancelTooltip, children: jsx(FaroButton, { "aria-label": "cancel", variant: variant === "info" ? "ghost" : "secondary", dark: dark, action: cancelButtonActions, onClick: onCancel, disabled: disabled, children: cancelText }) })), onConfirm && (jsx(FaroTooltip, { title: confirmTooltip, children: jsx(FaroButton, { "aria-label": "confirm", variant: variant === "info" ? "primary" : "destructive", dark: dark, onClick: onConfirm, disabled: isConfirmDisabled || disabled, isLoading: showSpinner, children: confirmText }) }))] }))] }) }));
}
// Specific style for each dialog size as defined in the FARO Design System
const SIZE_STYLE_MAP = {
    [FaroDialogSizes.s]: {
        width: "19.375rem",
        maxWidth: "19.375rem",
        maxHeight: "45vh",
    },
    [FaroDialogSizes.m]: {
        width: "35rem",
        maxWidth: "35rem",
        maxHeight: "85vh",
    },
    [FaroDialogSizes.l]: {
        width: "54.375rem",
        maxWidth: "54.375rem",
        maxHeight: "95vh",
    },
};

/** A dialog context which provides the components with the function to create a dialog */
const DialogContext = createContext(undefined);
/**
 *  @returns A dialog provider which allows the components to create a dialog from anywhere
 */
function DialogProvider({ children, }) {
    const confirmPromiseRef = useRef();
    const [dialogOptions, setDialogOptions] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    // Update the isConfirmDisabled props in the active dialogOptions
    const setConfirmButtonDisabled = useCallback((isConfirmDisabled) => {
        setDialogOptions((prevOptions) => prevOptions && {
            ...prevOptions,
            isConfirmDisabled,
        });
    }, []);
    /**
     * @returns a promise with a boolean value, which is true if the dialog has been confirmed and false otherwise
     * @param options - object which sets the possible customization for the dialog
     */
    const createDialog = useCallback((options) => {
        setDialogOptions(options);
        return new Promise((resolve) => {
            confirmPromiseRef.current = { resolve };
        });
    }, []);
    const handleCancel = useCallback(() => {
        if (confirmPromiseRef.current) {
            confirmPromiseRef.current.resolve(false);
        }
        dialogOptions?.onCancel?.();
        setDialogOptions(null);
    }, [dialogOptions]);
    const cancelButtonActions = useRef(null);
    const handleClose = useCallback(() => {
        if (!dialogOptions?.allowToCloseWithoutCancelling &&
            !!cancelButtonActions.current) {
            cancelButtonActions.current.focusVisible();
        }
        else {
            handleCancel();
        }
    }, [dialogOptions, handleCancel]);
    const handleConfirm = useCallback(async () => {
        let success = true;
        if (dialogOptions?.onConfirm) {
            setIsProcessing(true);
            try {
                success = await dialogOptions.onConfirm();
            }
            catch {
                success = false;
            }
            setIsProcessing(false);
        }
        if (!success)
            return;
        if (confirmPromiseRef.current) {
            confirmPromiseRef.current.resolve(true);
        }
        setDialogOptions(null);
    }, [dialogOptions]);
    const showConfirmButton = dialogOptions?.showConfirmButton ?? true;
    const showCancelButton = dialogOptions?.showCancelButton ?? true;
    const value = useMemo(() => ({
        createDialog,
        setConfirmButtonDisabled,
    }), [createDialog, setConfirmButtonDisabled]);
    return (jsxs(DialogContext.Provider, { value: value, children: [dialogOptions && (jsx(FaroDialog, { open: !!dialogOptions, onConfirm: showConfirmButton ? handleConfirm : undefined, onCancel: showCancelButton ? handleCancel : undefined, onClose: handleClose, isConfirmDisabled: dialogOptions.isConfirmDisabled, showSpinner: isProcessing, disabled: isProcessing, cancelButtonActions: cancelButtonActions, ...omit(dialogOptions, ["content", "onConfirm", "onCancel"]), children: dialogOptions.content })), children] }));
}
/**
 * @returns Hook that returns the utility function to create a dialog
 */
function useDialog() {
    const ctx = useContext(DialogContext);
    if (!ctx) {
        throw Error("useDialog called outside the DialogContext");
    }
    return ctx;
}

/** @returns If there is a dragging event happening on the window */
function useIsUserDragging() {
    const [isAppDragging, setIsAppDragging] = useState(false);
    useEffect(() => {
        let timeoutId;
        function onDragEnterOrOver(e) {
            if (!e.dataTransfer)
                return;
            // By default, we forbid any dragging operation on the window
            // if not explicitly managed somewhere else
            e.preventDefault();
            e.dataTransfer.dropEffect = "none";
            e.dataTransfer.effectAllowed = "none";
            e.stopPropagation();
            if (timeoutId !== undefined) {
                clearTimeout(timeoutId);
                timeoutId = undefined;
            }
            setIsAppDragging(true);
        }
        function onDragLeave(e) {
            if (!e.dataTransfer)
                return;
            // By default, we forbid any dragging operation on the window
            // if not explicitly managed somewhere else
            e.preventDefault();
            e.dataTransfer.dropEffect = "none";
            e.dataTransfer.effectAllowed = "none";
            e.stopPropagation();
            // This timeout prevents flickering of the UI when
            // a react component not managed by us steals the events
            timeoutId = window.setTimeout(() => setIsAppDragging(false), 100);
        }
        window.addEventListener("dragenter", onDragEnterOrOver);
        window.addEventListener("dragover", onDragEnterOrOver);
        window.addEventListener("dragleave", onDragLeave);
        return () => {
            window.removeEventListener("dragenter", onDragEnterOrOver);
            window.removeEventListener("dragover", onDragEnterOrOver);
            window.removeEventListener("dragleave", onDragLeave);
        };
    }, []);
    return isAppDragging;
}

const VARIANT_MAP = {
    transparent: {
        root: {
            border: "solid",
            borderColor: "transparent",
            backgroundColor: "transparent",
            borderRadius: "0.25rem",
        },
        zoneDrag: {
            border: "dashed",
            borderColor: "primary.main",
            borderRadius: "0.25rem",
        },
    },
    dark: {
        root: {
            background: neutral[950],
            border: `1px dashed ${neutral[700]}`,
            borderRadius: "3px",
        },
        hover: {
            cursor: "pointer",
            background: `${neutral[500]}26`,
            borderColor: cyan$1[500],
        },
        active: {
            background: `${neutral[500]}40`,
            borderColor: cyan$1[500],
        },
        zoneDrag: {
            border: "dashed",
            background: `${neutral[500]}26`,
            borderColor: cyan$1[500],
        },
    },
};
/** @returns A dropzone with a predefined style */
function DropHandler({ children, sx, variant = "transparent", enabled = true, canBeDropped, onDrop: onClientDrop, onClick, }) {
    const isAppDragging = useIsUserDragging();
    /** Check if the current element is receiving dragging events */
    const [isDragging, setIsDragging] = useState(false);
    const onDragEnterAndOver = useCallback((e) => {
        e.preventDefault();
        if (canBeDropped(e)) {
            e.dataTransfer.dropEffect = "copy";
            e.dataTransfer.effectAllowed = "all";
        }
        else {
            e.dataTransfer.dropEffect = "none";
            e.dataTransfer.effectAllowed = "none";
        }
        e.stopPropagation();
        setIsDragging(true);
    }, [canBeDropped]);
    const onDragLeave = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    }, []);
    const onDrop = useCallback((e) => {
        onDragLeave(e);
        onClientDrop(e);
    }, [onClientDrop, onDragLeave]);
    const style = useMemo(() => {
        const rootStyle = {
            width: "100%",
            height: "100%",
            ...VARIANT_MAP[variant].root,
            "&:hover": VARIANT_MAP[variant].hover,
            "&:active": VARIANT_MAP[variant].active,
        };
        const appDraggingStyle = {
            ...rootStyle,
            zIndex: 1,
            ...VARIANT_MAP[variant].appDrag,
        };
        const dropZoneDraggingStyle = {
            ...rootStyle,
            zIndex: 1,
            ...VARIANT_MAP[variant].zoneDrag,
        };
        if (isDragging)
            return dropZoneDraggingStyle;
        if (isAppDragging)
            return appDraggingStyle;
        return rootStyle;
    }, [variant, isDragging, isAppDragging]);
    if (!enabled) {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return jsx(Fragment, { children: children });
    }
    return (jsx(Box, { component: "div", sx: {
            ...style,
            ...sx,
        }, onDragEnter: onDragEnterAndOver, onDragOver: onDragEnterAndOver, onDragLeave: onDragLeave, onDrop: onDrop, onClick: onClick, children: children }));
}

/** @returns a tag for a specific tag type to show next to the label */
function InputLabelTag({ tag, dark, }) {
    if (!tag)
        return null;
    if (tag === "star") {
        const color = dark ? cyan$1[500] : blue[500];
        return (jsx(Box, { component: "span", sx: { color, pl: 0.5 }, children: "*" }));
    }
    return (jsxs(Typography, { sx: { pl: 0.5, color: dark ? neutral[100] : neutral[800] }, component: "span", fontSize: "0.75rem", fontWeight: FontWeights.Regular, children: ["(", tag, ")"] }));
}

/**
 * @returns A component whose children will not be translated by localizeJS
 */
function NoTranslate({ children, sx, component = "div", }) {
    return (jsx(Box$1, { component: component, sx: sx, className: NO_TRANSLATE_CLASS, children: children }));
}

/**
 * @returns true if the DropdownOption is a normal Option
 * @param option the DropdownOption to check
 */
function isOption(option) {
    return "key" in option && "value" in option && "label" in option;
}
/**
 * @returns true if the DropdownOption is a DividerOption
 * @param option the DropdownOption to check
 */
function isDivider(option) {
    return "isDivider" in option && option.isDivider;
}

const LIGHT_COLORS$4 = Object.freeze({
    color: neutral[800],
    subTitleColor: neutral[600],
    highlightColor: blue[500],
    highlightBackground: neutral[500],
    focusBorder: neutral[999],
});
const DARK_COLORS$4 = Object.freeze({
    color: neutral[100],
    subTitleColor: neutral[300],
    highlightColor: cyan$1[400],
    highlightBackground: neutral[500],
    focusBorder: neutral[0],
});
/**
 * @returns an item in a selection menu, like a dropdown or button menu.
 *
 * For more complex menu items see `FaroMenuItem`.
 */
const SingleSelectItem = forwardRef(function SingleSelectItem({ dark, value: itemValue, "data-value": dataValue, selectedValue, Icon, iconBadgeData, label, secondaryText, shouldCapitalize, extraAction, sx, ...rest }, ref) {
    const colors = dark ? DARK_COLORS$4 : LIGHT_COLORS$4;
    // WORKAROUND: The `value` prop is renamed to `data-value` by the MUI `Select` component.
    // See https://stackoverflow.com/a/66948157
    const value = itemValue ?? dataValue;
    const isSelected = selectedValue === value;
    return (jsx(MenuItem, { ...rest, ref: ref, value: value, selected: isSelected, sx: [
            {
                paddingX: 1.5,
                paddingY: 1,
                display: "flex",
                gap: 1,
                justifyContent: "space-between",
                textTransform: shouldCapitalize ? "capitalize" : "none",
                color: colors.color,
                "&:hover": {
                    color: colors.highlightColor,
                    background: `${colors.highlightBackground}26`,
                },
                "&:focus-visible": {
                    color: colors.color,
                    outline: `1px solid ${colors.focusBorder}`,
                },
                "&.Mui-selected": {
                    color: colors.highlightColor,
                    background: `${colors.highlightBackground}40`,
                    "&:focus-visible": {
                        color: colors.highlightColor,
                        background: `${colors.highlightBackground}40`,
                        outline: `1px solid ${colors.focusBorder}`,
                    },
                },
                // Change ripple color when the option is pressed
                "&& .MuiTouchRipple-child": {
                    backgroundColor: `${colors.highlightBackground}40`,
                },
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ], children: jsxs(Stack, { width: "100%", children: [jsxs(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", width: "100%", children: [jsxs(Stack, { direction: "row", alignItems: "center", gap: 1, children: [Icon && (jsx(Badge, { badgeContent: iconBadgeData?.badgeContent, sx: {
                                        "& .MuiBadge-badge": {
                                            border: "none",
                                        },
                                    }, color: iconBadgeData?.badgeBackgroundColor, overlap: "circular", invisible: !iconBadgeData, anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "right",
                                    }, children: jsx(Icon, { sx: { height: "1rem", width: "1rem" } }) })), jsx(FaroText, { variant: "bodyM", color: "inherit", children: label ?? jsx(NoTranslate, { children: value }) })] }), isSelected && !extraAction && (jsx(Checkmark3Icon, { sx: { height: "1rem", width: "1rem" } })), extraAction] }), secondaryText && (jsx(FaroText, { variant: "bodyS", color: colors.subTitleColor, children: secondaryText }))] }) }));
});

const DARK_COLORS$3 = {
    color: neutral[100],
    inputColor: neutral[100],
    inputDisabledColor: neutral[500],
    selectColor: neutral[100],
    selectFocusColor: neutral[100],
    selectBackgroundColor: neutral[999],
    selectDisabledBackgroundColor: neutral[900],
    selectInputFillDisabledColor: neutral[500],
    outlineColor: neutral[500],
    outlineHoverColor: neutral[100],
    outlineFocusColor: cyan$1[400],
    outlineErrorColor: red[300],
    selectIconColor: neutral[100],
    selectIconDisabledColor: neutral[500],
    paperColor: neutral[100],
    paperBackgroundColor: neutral[999],
    paperShadowColor: neutral[500],
    paperBorderColor: neutral[800],
    helpColor: neutral[300],
};
const LIGHT_COLORS$3 = {
    color: neutral[800],
    inputColor: neutral[800],
    inputDisabledColor: neutral[500],
    selectColor: neutral[500],
    selectFocusColor: neutral[800],
    selectBackgroundColor: neutral[0],
    selectDisabledBackgroundColor: neutral[100],
    selectInputFillDisabledColor: neutral[500],
    outlineColor: neutral[500],
    outlineHoverColor: neutral[800],
    outlineFocusColor: blue[500],
    outlineErrorColor: red[500],
    selectIconColor: neutral[800],
    selectIconDisabledColor: neutral[500],
    paperColor: neutral[800],
    paperBackgroundColor: neutral[0],
    paperShadowColor: neutral[500],
    paperBorderColor: neutral[200],
    helpColor: neutral[600],
};
function Placeholder({ placeholder, }) {
    return (jsx(FaroText, { variant: "bodyM", sx: {
            fontStyle: "italic",
            mr: 1,
            p: 0,
            color: neutral[500],
            whiteSpace: "nowrap",
        }, children: placeholder ?? "Select option" }));
}
const DrowdownVariants = {
    outlined: (colors, isOpen, isDisabled, isError) => {
        const outlineColor = isError
            ? colors.outlineErrorColor
            : colors.outlineColor;
        const outlineFocusColor = isError
            ? colors.outlineErrorColor
            : colors.outlineFocusColor;
        const outlineHoverColor = isError
            ? colors.outlineErrorColor
            : colors.outlineHoverColor;
        const outlineWidth = isError ? "2px" : "1px";
        return {
            backgroundColor: isDisabled
                ? colors.selectDisabledBackgroundColor
                : colors.selectBackgroundColor,
            padding: "9px 12px 9px 12px",
            borderRadius: "4px",
            boxShadow: isOpen
                ? `inset 0px 0px 0px 2px ${isDisabled ? "transparent" : outlineFocusColor}`
                : `inset 0px 0px 0px ${outlineWidth} ${isDisabled ? "transparent" : outlineColor}`,
            "&:hover": {
                cursor: "pointer",
                boxShadow: `inset 0px 0px 0px ${outlineWidth} ${isDisabled ? "transparent" : outlineHoverColor}`,
            },
        };
    },
    underlined: (colors, isOpen, isDisabled, isError) => {
        const outlineColor = isError
            ? colors.outlineErrorColor
            : colors.outlineColor;
        const outlineFocusColor = isError
            ? colors.outlineErrorColor
            : colors.outlineFocusColor;
        const outlineHoverColor = isError
            ? colors.outlineErrorColor
            : colors.outlineHoverColor;
        const outlineWidth = isError ? "2px" : "1px";
        return {
            backgroundColor: "transparent",
            padding: "4px 2px 4px 2px",
            boxShadow: isOpen
                ? `inset 0 -2px 0  ${isDisabled ? "transparent" : outlineFocusColor}`
                : `inset 0 -${outlineWidth} 0  ${isDisabled ? "transparent" : outlineColor}`,
            "&:hover": {
                cursor: "pointer",
                boxShadow: `inset 0 -${outlineWidth} 0 ${isDisabled ? "transparent" : outlineHoverColor}`,
            },
        };
    },
};
/** @returns The select component of the dropdown */
function DropdownSelect({ value: selectedValue, label, disabled: isDisabled, error: isError, fullWidth = true, children, dark, helpText, tag, sx, renderValue, onClose, onOpen, variant = "outlined", }) {
    const colors = dark ? DARK_COLORS$3 : LIGHT_COLORS$3;
    const [isOpen, setIsOpen] = useState(false);
    const inputRef = useRef(null);
    useEffect(() => {
        setIsOpen(false);
    }, [selectedValue]);
    useEffect(() => {
        if (isOpen) {
            onOpen?.();
        }
    }, [isOpen, onOpen]);
    return (jsxs(Stack, { gap: "4px", sx: {
            float: fullWidth ? undefined : "left",
            opacity: isDisabled ? "50%" : "100%",
        }, children: [label &&
                (typeof label === "string" ? (jsxs(Stack, { direction: "row", children: [jsx(FaroText, { variant: "labelM", sx: {
                                color: isError ? colors.outlineErrorColor : colors.inputColor,
                            }, children: label }), tag && jsx(InputLabelTag, { tag: tag, dark: dark })] })) : (label)), jsxs(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", sx: {
                    ...DrowdownVariants[variant](colors, isOpen, isDisabled, isError),
                    ...sx,
                }, onClick: () => {
                    if (isDisabled) {
                        return;
                    }
                    setIsOpen(!isOpen);
                }, ref: inputRef, role: "combobox", children: [renderValue(selectedValue), jsx(ArrowDown2Icon, { sx: {
                            width: "16px",
                            height: "16px",
                            color: isDisabled
                                ? colors.selectIconDisabledColor
                                : colors.selectIconColor,
                            transform: isOpen ? "rotate(180deg);" : undefined,
                        } })] }), jsx(Menu, { id: "menu-", open: isOpen, anchorEl: inputRef.current, onClose: () => {
                    onClose?.();
                    setIsOpen(false);
                }, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                }, MenuListProps: {
                    "aria-labelledby": "basic-button",
                    sx: {
                        minWidth: fullWidth ? inputRef.current?.offsetWidth : undefined,
                    },
                }, sx: {
                    marginTop: 0.5,
                    "& .MuiPaper-root": {
                        color: colors.paperColor,
                        backgroundColor: colors.paperBackgroundColor,
                        boxShadow: "none",
                        border: `1px solid ${colors.paperBorderColor}`,
                        "& .MuiList-root": {
                            display: "flex",
                            flexFlow: "column",
                            p: 0.5,
                            gap: 0.5,
                        },
                    },
                }, children: children }), (!!isError || !!helpText) && (jsx(FaroText, { variant: "bodyS", sx: {
                    color: isError ? colors.outlineErrorColor : colors.helpColor,
                    lineHeight: "18px",
                }, children: isError ? "Enter a valid selection" : helpText }))] }));
}
/**
 * @returns The reusable dropdown component styled according to the design guidelines
 */
function Dropdown({ dark, options, placeholder, value: selectedValue, label, disabled, error, helpText, fullWidth = true, shouldCapitalize = true, onChange, ...props }) {
    const colors = dark ? DARK_COLORS$3 : LIGHT_COLORS$3;
    return (jsxs(DropdownSelect, { value: selectedValue, label: label, disabled: disabled, error: error, fullWidth: fullWidth, dark: dark, helpText: helpText, ...props, renderValue: (selected) => {
            if (!selected) {
                return jsx(Placeholder, { placeholder: placeholder });
            }
            const option = options.find((o) => isOption(o) && o.value === selected);
            return (jsx(FaroText, { component: "div", variant: "bodyM", sx: {
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    textTransform: shouldCapitalize ? "capitalize" : "none",
                    whiteSpace: "nowrap",
                    mr: 1.5,
                    color: colors.color,
                }, children: option?.label ?? jsx(NoTranslate, { children: selected }) }));
        }, children: [jsx(MenuItem, { sx: { display: "none" } }), options.map((option, index) => {
                if (isDivider(option)) {
                    return (jsx(Divider, { component: "li", sx: {
                            // !important is needed to override a competing style from MuiMenuItem
                            m: "0 !important",
                        } }, `divider-${index}`));
                }
                const { key, value, label, secondaryText, isDisabled, isHeader } = option;
                if (isHeader) {
                    // Header margin when there is a divider
                    const MARGIN_TOP_WITH_DIVIDER = 1.5;
                    return (jsxs(ListSubheader, { sx: { backgroundColor: "transparent", p: 0 }, children: [index !== 0 && jsx(Divider, {}), jsx(FaroText, { component: "div", variant: "bodyM", sx: {
                                    color: colors.color,
                                    fontSize: "0.75rem",
                                    textTransform: "uppercase",
                                    fontWeight: "bold",
                                    mx: 1.5,
                                    mt: index === 0 ? 1 : MARGIN_TOP_WITH_DIVIDER,
                                    mb: 1,
                                }, children: label })] }, key));
                }
                return (jsx(SingleSelectItem, { value: value, label: label, secondaryText: secondaryText, disabled: isDisabled, shouldCapitalize: shouldCapitalize, selectedValue: selectedValue, dark: dark, onClick: () => onChange?.({ target: { value } }) }, key));
            })] }));
}

var _defs, _g;
function _extends$4() { return _extends$4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4.apply(null, arguments); }
const SvgErrorPageBackground = props => /*#__PURE__*/React.createElement("svg", _extends$4({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 1222 1637"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "error-page-background_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h1222v1637H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#error-page-background_svg__a)",
  "data-name": "Artboard \\u2013 1"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  "data-name": "Group 160452"
}, /*#__PURE__*/React.createElement("path", {
  d: "M841.99 1636.996q4.331-.064 8.663-.17c-2.75.053-6.413.116-9.163.17Z",
  "data-name": "Path 118043"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.62 817.974c-.616 26.033 3.366 53.255 10.946 74.68 16.339 46.184 55.346 78.257 86.1 18.335 26.606-64.614 12.539-151.652-17.327-183.407-36.051-38.337-77.776 8.972-79.719 90.392",
  "data-name": "Path 118044"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.715 709.073c7.219 58.468 54.677 99.12 105.458 35.482 40.44-60.516 31.638-127.69 12.464-156.058-33.794-50-99.778-9.81-115.756 70.5-3.228 16.219-4.035 34.936-2.166 50.076",
  "data-name": "Path 118045"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.455 1008.18c20.087 64.54 84.139 115.745 119.26 52.405 24.483-58.287-1.762-135.271-41.586-165.178-48.5-36.406-93.291 7.825-84.1 83.035a192 192 0 0 0 6.426 29.738",
  "data-name": "Path 118046"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.794 742.847c25.247-53.032 33.22-144.071 14.98-170.9-17.134-25.194-48.22 17.592-61.608 84.776-7.687 38.6-7.75 77.642-.149 99.438 1.667 4.756 17.077 44.793 46.777-13.314",
  "data-name": "Path 118047"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.652 1061.594c6.19-63.234-23.187-152.533-49.623-173.035-25.523-19.789-38.762 24.972-26.723 90.361 6.848 37.223 21.064 74.435 36.214 94.809 5.192 6.975 31.565 39.251 40.132-12.135",
  "data-name": "Path 118048"
}), /*#__PURE__*/React.createElement("path", {
  d: "M242.826 819.759a158 158 0 0 0 .446 20.194c7.389 78.6 80.784 126.989 132.021 63.181 31.585-43.635 27.487-116.106-8.759-155.081-49.071-52.778-119.599-11.892-123.708 71.706",
  "data-name": "Path 118049"
}), /*#__PURE__*/React.createElement("path", {
  d: "M177.662 584.025c40.864-55.028 47.415-118.644 36.437-143.413-16.255-36.65-66.717-.318-93.1 67.014-13.6 34.707-13.239 59.72-12.454 68.861 2.814 32.775 26.724 57.831 69.117 7.538",
  "data-name": "Path 118050"
}), /*#__PURE__*/React.createElement("path", {
  d: "M234.612 1200.936c6.869-49.072-34.282-133.487-74.648-153.107-35.715-17.358-50.759 23.018-30.39 81.506a218.2 218.2 0 0 0 25.438 50.409c27.396 40.122 70.288 69.796 79.6 21.192",
  "data-name": "Path 118051"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.031 817.352c.51 52.787 7.432 102.124 15.766 112.317 8.08 9.874 12.114-18.271 13.441-27.519 7.411-58.33.255-160.3-12.358-175.986C7.324 714.28-.553 756.896.031 817.352",
  "data-name": "Path 118052"
}), /*#__PURE__*/React.createElement("path", {
  d: "M285.244 509.609a114.9 114.9 0 0 0-6.084 33.411c-1.444 59.338 51.354 89.225 105.309 37.382 32.743-34.123 43.933-89.256 24.95-122.9-27.614-48.956-100.733-18.273-124.175 52.107",
  "data-name": "Path 118053"
}), /*#__PURE__*/React.createElement("path", {
  d: "M423.129 1195.228c22.083-48.6-8.154-111.945-49.942-136.1-50.685-29.3-93.716 8.441-79.4 69.626 15.147 64.753 93.149 125.642 129.342 66.474",
  "data-name": "Path 118054"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.082 1050.009c-9.991-4.724-1.869 31.108 17.73 78.247 20.554 49.432 43.306 86.656 51.662 90.414 7.1 3.2 2.484-14.98.52-22.742-16.039-56.099-55.895-139.294-69.912-145.919",
  "data-name": "Path 118055"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.198 578.642c28.22-56.174 51.726-134.92 46.375-145.919-4.565-9.375-25.353 25.236-44.485 74.075-17.274 44.124-27.933 87.2-23.75 96.019s17.497-16.01 21.86-24.175",
  "data-name": "Path 118056"
}), /*#__PURE__*/React.createElement("path", {
  d: "M501.167 733.363c40.5-49.114 27.126-99.555 12.836-121.617-40.111-61.918-126.458-31.819-139.984 48.785a119 119 0 0 0-1.483 17.371c-.184 71.6 70.026 114.534 128.631 55.461",
  "data-name": "Path 118057"
}), /*#__PURE__*/React.createElement("path", {
  d: "M250.363 371.657c-9.5 17.135-15.214 35.259-15.649 49.708-1.03 33.475 26.51 54.295 73.692 12.156 33.38-31.744 53.764-84.33 43.625-112.529-13.707-38.082-72.291-2.313-101.668 50.665",
  "data-name": "Path 118058"
}), /*#__PURE__*/React.createElement("path", {
  d: "M516.154 1049.897c36.172-52.012 8.26-108.484-17.826-131.862-52.266-46.842-123.007-10.914-120.155 61.016 2.722 68.575 82.455 134.24 137.981 70.846",
  "data-name": "Path 118059"
}), /*#__PURE__*/React.createElement("path", {
  d: "M271.288 1278.867c27.413 43.944 92.633 91.815 103.526 43.487 4.661-47.489-40.992-108.409-80.243-123.114-38.189-14.312-53.86 18.813-31.054 65.633 2.102 4.323 5.234 9.917 7.771 13.994",
  "data-name": "Path 118060"
}), /*#__PURE__*/React.createElement("path", {
  d: "M224.568 1339.29c19.556 10.394 14.035-10.331 12.22-17.136-12.485-41.7-67.97-120.226-94.034-126.161-17.709-4.036-11.264 27.921 13.792 68.397 23.229 37.516 52.383 66.585 68.022 74.9",
  "data-name": "Path 118061"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.376 447.377c.69 6.147 5.6 23.283 39.633-14.057 39.961-47.479 63.967-107.412 60.027-123.1-4.5-17.953-41.5 13.844-70.7 60.75-21.975 35.308-30.384 63.815-28.96 76.407",
  "data-name": "Path 118062"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.704 889.045c38.815-46.714 20.575-98.249-1.168-121.489-48.562-51.926-128.401-19.918-133.476 53.519-.17 2.474-.255 5.786-.212 8.26 1.306 70.008 78.162 115.385 134.856 59.71",
  "data-name": "Path 118063"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.82 1428.495c-16.276-40.865-76.782-99.247-102.761-99.162-17.069.052-10.539 25.087 14.251 54.665 18.166 21.669 44.283 43.359 65 53.966 20.785 10.649 28.695 7.454 23.51-9.469",
  "data-name": "Path 118064"
}), /*#__PURE__*/React.createElement("path", {
  d: "M287.573 299.935c36.426-30.439 65.559-78.575 62.969-95.175-3.1-19.864-48.88 9.884-79.521 45.791-17.21 20.161-28.379 40.291-29.9 53.86-1.59 14.422 9.452 25.134 46.452-4.476",
  "data-name": "Path 118065"
}), /*#__PURE__*/React.createElement("path", {
  d: "M440.898 372.566a79.3 79.3 0 0 0-6.232 25.629c-3.111 50.494 51.089 67.757 93.545 29.781 37.34-36.3 33.932-73.8 26.033-90.233-22.846-47.522-90.935-18.941-113.346 34.823",
  "data-name": "Path 118066"
}), /*#__PURE__*/React.createElement("path", {
  d: "M567.039 1315.149c18.463-35.386-4.714-80.763-37.945-100.946-46.99-28.549-90.276.053-75.922 50.154 13.993 48.86 82.897 95.15 113.867 50.792",
  "data-name": "Path 118067"
}), /*#__PURE__*/React.createElement("path", {
  d: "M454.888 297.216c35.991-30.651 43.721-64.583 40.132-79.913-7.942-33.879-62.98-8.579-91.56 32.9-9.714 14.1-13.25 25.311-14.513 32.222-5.893 32.543 23.962 46.038 65.941 14.791",
  "data-name": "Path 118068"
}), /*#__PURE__*/React.createElement("path", {
  d: "M518.779 1426.19c3.865-33.751-36.947-83.7-75.3-92.155-31.224-6.88-42.4 17.294-23.017 49.762 24.307 40.673 88.262 79.287 98.317 42.393",
  "data-name": "Path 118069"
}), /*#__PURE__*/React.createElement("path", {
  d: "M662.389 1184.424c29.483-38.061 10.267-80.3-9.832-99.406-46.431-44.124-116.924-16.902-112.581 43.466 4.289 59.603 76.972 102.432 122.413 55.94",
  "data-name": "Path 118070"
}), /*#__PURE__*/React.createElement("path", {
  d: "M661.455 476.937c-30.912-54.018-114.011-32.53-128.854 33.337a87.4 87.4 0 0 0-1.879 13.972c-2.474 57.289 61.26 91.369 114.812 44.453 41.374-43.922 18.653-86.995 15.921-91.762",
  "data-name": "Path 118071"
}), /*#__PURE__*/React.createElement("path", {
  d: "M191.676 296.686c24.929-25.512 79.1-88.311 78.321-95.393-3.928-2.23-31.855 23.549-54.188 48.084-23.687 26.012-48.127 58.022-46.333 64.36 2.824 1.274 10.915-5.892 22.2-17.051",
  "data-name": "Path 118072"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194.308 1332.528c-1.248 4.969 19.344 29.851 39.368 50.751 30.354 31.681 62.544 58.053 66.632 56.62.234-1.72-2.017-5-9.64-14.057-17.402-20.015-88.386-96.276-96.36-93.314",
  "data-name": "Path 118073"
}), /*#__PURE__*/React.createElement("path", {
  d: "M673.501 980.106c-3.323 64.784 74.647 100.362 120.927 55.165 33.7-36.894 18.208-75.815 3.737-93-42.16-50.095-121.383-26.048-124.664 37.835",
  "data-name": "Path 118074"
}), /*#__PURE__*/React.createElement("path", {
  d: "M791.062 717.649c34.643-38.157 19.8-77.45 5.574-94.65-40.332-48.742-118.164-25.683-126.191 37.37a79 79 0 0 0-.531 6.742c-1.73 54.413 64.275 101.87 121.148 50.538",
  "data-name": "Path 118075"
}), /*#__PURE__*/React.createElement("path", {
  d: "M522.676 1514.332c-14.619-28.666-66.8-68.457-90.042-68.66-15.628-.137-10.182 17.571 11.679 37.913a206.8 206.8 0 0 0 53.233 35.184c14.846 6.573 31.26 11.149 25.13-4.437",
  "data-name": "Path 118076"
}), /*#__PURE__*/React.createElement("path", {
  d: "M431.213 1514.141c-28.793-26.023-87.43-68.915-99.969-68.755-7.687.106 5.17 16.34 33.868 37.913 31.713 23.846 70.613 44.251 74.074 40.631-.117-1.901-1.688-3.823-7.973-9.789",
  "data-name": "Path 118077"
}), /*#__PURE__*/React.createElement("path", {
  d: "M436.887 183.043c37.934-26.5 55.049-55.9 55.41-65.05.669-16.955-41.533 3.334-70.645 29.876-14 12.762-23.6 25.576-26.33 35.153-3.871 13.537 6.459 22.497 41.565.021",
  "data-name": "Path 118078"
}), /*#__PURE__*/React.createElement("path", {
  d: "M326.664 182.851c34.6-24.557 76.41-63.171 77.567-69.838 1.253-7.188-32.849 11.8-61.844 34.431-26.414 20.629-42.065 38.444-43.857 45.387-1.073 4.13 1.167 8.324 28.134-9.98",
  "data-name": "Path 118079"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600.398 251.685a60.3 60.3 0 0 0-3.652 13.473c-4.862 37.892 39.41 52.893 72.875 24.695 29.291-27.194 20.023-53.768 17.878-58.822-14.991-35.12-69.519-22.189-87.101 20.654",
  "data-name": "Path 118080"
}), /*#__PURE__*/React.createElement("path", {
  d: "M674.4 1348.708c-32.127-17.9-69.445-2.335-59.136 34.835 9.29 33.5 58.743 64.668 83.81 34.642 15.628-24.62-.138-55.8-24.674-69.477",
  "data-name": "Path 118081"
}), /*#__PURE__*/React.createElement("path", {
  d: "M706.365 1264.536c1.423 42.584 54.337 72.386 91.136 39.367 19.588-19.535 18.293-51.375-2.9-70.963-31.732-29.345-89.807-15.384-88.236 31.596",
  "data-name": "Path 118082"
}), /*#__PURE__*/React.createElement("path", {
  d: "M697.419 373.112c-.3 1.486-.6 3.5-.764 5.011-4.534 44.05 48.095 73.172 90.806 37.043 19.047-17.837 22.529-45.706 8.271-66.282-26.436-38.136-88.917-22.741-98.313 24.228",
  "data-name": "Path 118083"
}), /*#__PURE__*/React.createElement("path", {
  d: "M649.934 1510.807c4.342-19.2-23.134-53.754-53.562-59.349-20.608-3.791-32.477 9.608-16.913 32.562 17.249 25.418 63.022 49.699 70.475 26.787",
  "data-name": "Path 118084"
}), /*#__PURE__*/React.createElement("path", {
  d: "M597.818 178.361c31.352-24.3 28.241-48.466 28.092-49.486-3.694-25.48-45.727-9.852-67.64 19.153-7.05 9.333-9.492 16.701-10.3 21.245-4.118 23.208 23.359 28.219 49.848 9.088",
  "data-name": "Path 118085"
}), /*#__PURE__*/React.createElement("path", {
  d: "M479.383 89.137c22.219-11.371 66.99-40.016 66.8-44.623-3.153-2.357-31.224 9.035-54.6 22.158-23.191 13.019-36.547 24.429-37.747 28.973-.722 2.697 1.657 5.425 25.547-6.508",
  "data-name": "Path 118086"
}), /*#__PURE__*/React.createElement("path", {
  d: "M577.748 1579.391c-18.7-11.933-78.576-44.676-87.664-41.989-4.48 1.327 6.721 11.328 29.961 23.558 25.565 13.452 57.809 25.215 64.147 24.514.106-.222.244-.531.35-.754-.945-1.315-2.219-2.313-6.794-5.329",
  "data-name": "Path 118087"
}), /*#__PURE__*/React.createElement("path", {
  d: "M840.482 821.724c-4.64 52.883 58 91.348 104.375 48.6 24.928-25.884 20.65-61.822 3.96-82.494-34.643-42.887-103.484-21.345-108.335 33.894",
  "data-name": "Path 118088"
}), /*#__PURE__*/React.createElement("path", {
  d: "M846.167 1129.49c-4.2 41.937 46.9 72.248 86.655 38.922 19.248-17.762 22.359-46.916 7.071-66.4-27.891-35.523-89.214-17.549-93.726 27.478",
  "data-name": "Path 118089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M934.412 551.643c24.047-27.636 11.031-56.153-.457-68.649-31.32-34.049-87.834-16.923-91.624 27.774-3.679 43.413 53.503 76.421 92.081 40.875",
  "data-name": "Path 118090"
}), /*#__PURE__*/React.createElement("path", {
  d: "M589.614 1539.569c-8.547 1.21-3.514 10.617 11.477 21.414 13.951 10.054 32.456 18.388 43.519 21.425 15.426 4.247 11.806-1.975 10.436-4.311-11.933-16.467-50.409-40.653-65.432-38.528",
  "data-name": "Path 118091"
}), /*#__PURE__*/React.createElement("path", {
  d: "M583.049 87.449c25.057-14.631 39.257-32.435 39.845-37.882 1.04-9.683-28.4 2.007-49.146 17.231-10.129 7.432-17.442 15.151-19.557 20.651-3.121 8.164 5.16 12.7 28.858 0",
  "data-name": "Path 118092"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1014.083 981.545c-.16 1.2-.287 2.8-.33 4-1.252 33.635 35.98 55.421 65.867 28.655 15.267-15.182 17.964-39.081 6.286-55.6-20.693-29.227-67.004-14.437-71.823 22.945",
  "data-name": "Path 118093"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1013.456 661.631a51 51 0 0 0 0 4.035c1.582 35.121 42.415 58.138 70.2 29.77 14.365-16.361 12.974-42.988-3.1-59.359-24.717-25.173-65.486-9.652-67.1 25.554",
  "data-name": "Path 118094"
}), /*#__PURE__*/React.createElement("path", {
  d: "M631.313 20.042C643.077 15.785 674.025 2.8 677.083.411c0-.117.01-.276.01-.393-2.707-.34-19.588 4.236-34.717 9.852-15.532 5.766-27.274 11.892-26.743 13.951 1.688.881 7.495-.869 15.68-3.779",
  "data-name": "Path 118095"
}), /*#__PURE__*/React.createElement("path", {
  d: "M786.5 169.464c14.566-14.227 8.3-27.54 6.03-31.288-12.156-20.066-42.2-10.107-48.5 10.808a28.7 28.7 0 0 0-.956 4.725c-1.993 19.949 22.776 32.349 43.426 15.755",
  "data-name": "Path 118096"
}), /*#__PURE__*/React.createElement("path", {
  d: "M797.249 1466.674c-17.985-12.71-40.748-2.719-38.072 16.7 2.463 17.815 27.678 34.282 44.23 18.219 10.35-12.55 4.553-27.35-6.158-34.919",
  "data-name": "Path 118097"
}), /*#__PURE__*/React.createElement("path", {
  d: "M716.98 81.577c13.816-10.362 13.26-20.491 13.016-22.412-1.784-13.706-23.857-6.667-34.515 7.846a23.7 23.7 0 0 0-4.152 8.459c-2.527 11.224 9.927 16.384 25.651 6.107",
  "data-name": "Path 118098"
}), /*#__PURE__*/React.createElement("path", {
  d: "M857.157 1383.754c-2.707 21 22.667 40.621 47.054 21.319 15.426-14.535 10.617-30.163 5.914-36.384-14.662-19.45-49.813-9.459-52.968 15.065",
  "data-name": "Path 118099"
}), /*#__PURE__*/React.createElement("path", {
  d: "M903.174 275.134c14.015-16.743 2.2-32.838-.307-35.9-17.858-21.744-51.821-13.547-53.435 12.9-1.498 24.454 32.54 43.246 53.742 23",
  "data-name": "Path 118100"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.988 1546.258c-11.233-1.89-15.766 5.425-9.311 15.054 8.037 11.987 29.887 23.05 34.442 12.231 2.813-8.632-10.182-24.769-25.131-27.285",
  "data-name": "Path 118101"
}), /*#__PURE__*/React.createElement("path", {
  d: "M998.22 1265.3c-.17.722-.372 1.688-.488 2.421-3.153 20.5 18.007 33.687 38.794 17.677 14.566-13.419 11.881-27.965 8.43-33.783-9.747-16.435-40.738-10.627-46.736 13.685",
  "data-name": "Path 118102"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1043.894 394.762c7.995-10.076 4.735-26.956-7.114-36.851-18.038-15.055-41.841-5.51-40.429 16.212 1.444 22.39 31.065 38.931 47.543 20.639",
  "data-name": "Path 118103"
}), /*#__PURE__*/React.createElement("path", {
  d: "M708.285 17.387c10.054-4.8 17.9-11.286 18.675-13.462 1.253-3.525-11.668.786-21.053 6.253-5.171 3.015-8.706 5.977-9.438 7.92-.85 2.23 2.25 3.482 11.816-.711",
  "data-name": "Path 118104"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1216.95 809.793c-11.307-14.747-32.5-6.391-34.356 13.547a32 32 0 0 0-.063 4.491c1.253 19.609 21.69 28.475 33.645 14.609a27.28 27.28 0 0 0 .774-32.647",
  "data-name": "Path 118105"
})))));

/**
 * @returns a responsive page, that informs the user about a major error and provides guidance and actions towards resolving it.
 */
function ErrorDetailsPage({ errorName, errorMessage, errorStatement, helpText, actions, specialAction, showLogo = true, }) {
    const isMd = useBreakpointMdUp();
    return (jsxs(Fragment, { children: [showLogo && (jsx(SphereXGTextIcon, { sx: {
                    width: "125px",
                    height: "64px",
                    position: "absolute",
                    top: 16,
                    left: 0,
                    // Making sure the logo is not rendered left from the text (on the vertical axis)
                    ml: "21px",
                } })), jsxs(Stack, { direction: "row", width: "100%", minHeight: "100%", justifyContent: "center", spacing: {
                    xs: 0,
                    md: 3.5,
                    lg: 4,
                    xl: 6,
                }, children: [jsxs(Stack, { direction: "column", width: { md: "55%" }, justifyContent: "center", spacing: 2, textAlign: { xs: "center", md: "left" }, py: 3, px: {
                            xs: 2.5,
                            md: 3,
                            lg: 7.75,
                            xl: 15,
                        }, children: [jsx(Stack
                            // Grows to balance the bottom stack item
                            , { 
                                // Grows to balance the bottom stack item
                                flexGrow: isMd ? 0 : 1, minHeight: showLogo ? "64px" : 0, pb: { xs: 12 } }), jsx(ErrorInfo, { errorStatement: errorStatement, helpText: helpText }), jsx(Actions, { actions: actions }), jsx(SpecialAction, { action: specialAction }), jsx(Stack
                            // Grows to position the ErrorReasonInfor at flex end
                            , { 
                                // Grows to position the ErrorReasonInfor at flex end
                                flexGrow: isMd ? 0 : 1, children: jsx(ErrorReasonInfo, { errorName: errorName, errorMessage: errorMessage }) })] }), isMd ? (jsx(Box, { component: "div", flexGrow: 1, children: jsx(Background, {}) })) : (jsx(Box, { component: "div", 
                        // absolute removes it from the flex layout, moving it behind the elements
                        position: "absolute", zIndex: -1, width: "100%", height: "100%", children: jsx(Background, {}) }))] })] }));
}
function Background() {
    const isMd = useBreakpointMdUp();
    return (jsx(Box, { component: "div", width: "100%", height: "100%", 
        // The new relative root makes it possible to hide the overflow of the absolute background element
        position: "relative", overflow: "hidden", children: jsx(Box, { component: SvgErrorPageBackground, position: "absolute", height: "100%", width: isMd ? "auto" : "100%", color: "gray100", left: { xs: "50%", md: 0 }, sx: {
                opacity: 0.3,
                transform: { xs: "translateX(-50%)", md: "none" },
            } }) }));
}
/**
 * @returns the main error information for the user properly formatted
 */
function ErrorInfo({ errorStatement, helpText, }) {
    const isXL = useBreakpointXlUp();
    const isXS = useBreakpointXsUp();
    let errorStatementVariant = FaroTextVariant.heading24;
    if (isXL) {
        errorStatementVariant = FaroTextVariant.heading50;
    }
    else if (isXS) {
        errorStatementVariant = FaroTextVariant.heading20;
    }
    return (jsxs(Stack, { direction: "column", children: [jsx(FaroText, { variant: errorStatementVariant, children: errorStatement }), jsx(FaroText, { variant: "heading16", sx: { color: "gray600", mt: 2.5 }, children: helpText })] }));
}
/**
 * @returns a row of buttons one for each action the user can take to solve the error
 */
function Actions({ actions }) {
    const isSm = useBreakpointSmUp();
    if (actions.length === 0) {
        return null;
    }
    return (jsx(Stack, { direction: { xs: "column", sm: "row" }, spacing: isSm ? 4 : 3, justifyContent: { xs: "center", md: "flex-start" }, alignItems: "center", pt: 2, children: actions.map((action, index) => (jsx(FaroButton, { variant: action.primary ? "primary" : "secondary", size: "l", href: action.action instanceof URL ? action.action.toString() : undefined, onClick: typeof action.action === "function" ? action.action : undefined, children: action.label }, index))) }));
}
/** @returns the error special action formatted as a link */
function SpecialAction({ action }) {
    if (!action) {
        return null;
    }
    return (jsx(Link, { href: action.action instanceof URL ? action.action.toString() : undefined, onClick: typeof action.action === "function" ? action.action : undefined, target: "_blank", color: "blue500", sx: { mt: 2 }, children: jsx(Typography, { fontWeight: "600", fontSize: "1.25rem", children: action.label }) }));
}
/** @returns a small information box with the original error data */
function ErrorReasonInfo({ errorName, errorMessage, }) {
    const isMd = useBreakpointMdUp();
    const isXl = useBreakpointXlUp();
    let textVariant = FaroTextVariant.labelM;
    if (isXl) {
        textVariant = FaroTextVariant.heading16;
    }
    else if (isMd) {
        textVariant = FaroTextVariant.labelL;
    }
    return (jsxs(Stack, { direction: "column", height: "100%", pt: { xs: 0, md: 6 }, pb: { xs: 12 }, gap: 1, justifyContent: "flex-end", children: [jsx(FaroText, { variant: textVariant, sx: {
                    color: "gray600",
                    fontSize: { m: "1.125rem" },
                    fontWeight: FontWeights.SemiBold,
                }, children: errorName }), jsx(FaroText, { variant: textVariant, sx: {
                    color: "gray600",
                    fontSize: { m: "1.125rem" },
                    fontWeight: FontWeights.Regular,
                }, children: errorMessage })] }));
}

/**
 * @returns  A popover element styled according to the FARO design system.
 */
function FaroPopover({ title, media, description, chipLabel, page, actions, dark, sx, children, ...rest }) {
    return (jsxs(BasePopover, { titleBar: jsxs(Fragment, { children: [jsx(FaroText, { variant: "heading12", color: "inherit", sx: { textTransform: "uppercase" }, children: title }), chipLabel && jsx(PopoverChip, { chipLabel: chipLabel })] }), dark: dark, sx: {
            // Make sure the popover is treated as a tooltip (i.e., covering other content)
            zIndex: ({ zIndex }) => zIndex.tooltip,
            ...sx,
        }, ...rest, children: [media && jsx(CardMedia$1, { component: "img", width: "100%", ...media }), description && (jsx(FaroText, { variant: "bodyS", color: "inherit", children: description })), children, (!!page || !!actions) && (jsxs(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", gap: 1, children: [page ? (jsxs(FaroText, { variant: "bodyS", color: "inherit", children: [page.current, " of ", page.total] })) : (jsx("div", {})), actions && (jsx(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", gap: 1, children: actions.map((actionProps, index) => (jsx(FaroButton, { dark: dark, ...actionProps }, index))) }))] }))] }));
}
/** @returns Custom chip to use in the popover, until we have a complete design for a reusable component. */
function PopoverChip({ chipLabel, }) {
    return (jsx(Chip, { label: jsx(FaroText, { variant: "labelS", sx: {
                textTransform: "uppercase",
                color: neutral[950],
            }, children: chipLabel }), sx: {
            py: 0.125,
            px: 0.5,
            height: 16,
            backgroundColor: orange[500],
            width: "fit-content",
            "& .MuiChip-label": {
                p: 0,
            },
        } }));
}

const DEFAULT_SLIDER_VARIANT = {
    sliderColor: blue[500],
    secondarySliderColor: blue[200],
    labelColor: neutral[500],
};
const DARK_SLIDER_VARIANT = {
    sliderColor: cyan$1[400],
    secondarySliderColor: blue[200],
    labelColor: neutral[300],
};
/**
 * @returns a slider component
 */
function FaroSlider({ dark = false, sx, ...rest }) {
    const style = dark ? DARK_SLIDER_VARIANT : DEFAULT_SLIDER_VARIANT;
    return (
    // The box is present to avoid the slider from overflowing when the the max value is set https://github.com/mui/material-ui/issues/13455
    jsx(Box, { component: "div", sx: {
            px: 0.65,
        }, children: jsx(Slider, { sx: {
                "& .MuiSlider-thumb": {
                    color: style.sliderColor,
                },
                "& .MuiSlider-track": {
                    color: style.sliderColor,
                },
                "& .MuiSlider-rail": {
                    color: style.secondarySliderColor,
                },
                "& .MuiSlider-mark": {
                    color: style.sliderColor,
                    width: "4px",
                    height: "4px",
                    borderRadius: "50%",
                },
                "& .MuiSlider-markLabel": {
                    color: style.labelColor,
                },
                "& .MuiSlider-valueLabel": {
                    backgroundColor: neutral[950],
                },
                ...sx,
            }, ...rest }) }));
}

/**
 * Component allowing to wrap content in the var HTML element and setting the variable name of the content.
 * This is used for telling localize the variable name to show in the localize dashboard.
 *
 * Example usage:
 * `Hello <FaroVar userName>{name}</FaroVar>, you are <FaroVar age>{ageInYears}</FaroVar> old`
 *
 * See https://developers.localizejs.com/docs/using-html-syntax-to-prepare-phrases#variables
 *
 * @returns children wrapped in the var HTML element
 * @deprecated please use @see TranslateVar instead as passing custom property in react does not work
 */
function FaroVar({ children, ...varProps }) {
    return jsx("var", { ...varProps, children: children });
}

/**
 * @returns An underlined version of the Input base component
 * @param props The props forwarded to the Input
 */
const UnderlinedInput = styled(Input)(({ theme }) => createUnderlinedInputStyles(theme, INPUT_LIGHT_COLORS));
/**
 * @returns A dark variant of the Input
 * @param props The props forwarded to the Input
 */
const UnderlinedInputDark = styled(UnderlinedInput)(({ theme }) => createUnderlinedInputStyles(theme, INPUT_DARK_COLORS));
/**
 * @returns A dark variant of the OutlinedInput
 * @param props The props forwarded to the OutlinedInput
 */
const OutlinedInputDark = styled(OutlinedInput)(({ theme }) => createOutlinedInputStyles(theme, INPUT_DARK_COLORS));
/**
 * @returns A dark variant of the InputLabel
 * @param props The props forwarded to the InputLabel
 */
const InputLabelDark = styled(InputLabel)(() => ({
    color: INPUT_DARK_COLORS.text,
    "&.Mui-focused": {
        color: INPUT_DARK_COLORS.text,
    },
    "&.Mui-disabled": {
        color: INPUT_DARK_COLORS.text,
    },
    "&.Mui-error": {
        color: INPUT_DARK_COLORS.error,
    },
}));
/**
 * @returns Our custom variant of the FormHelperText component
 */
const FaroFormHelperText = styled(FormHelperText)(({ color }) => ({
    color,
    "&.Mui-disabled": {
        color,
        opacity: 0.5,
    },
}));
/**
 * @returns A dark variant of the FaroFormHelperText, using neutral[300] as default color
 */
function FormHelperTextDark({ color = INPUT_DARK_COLORS.helpText, ...rest }) {
    return jsx(FaroFormHelperText, { color: color, ...rest });
}
/**
 * @returns A dark variant of the FaroFormHelperText, using neutral[600] as default color
 */
function FormHelperTextLight({ color = INPUT_LIGHT_COLORS.helpText, ...rest }) {
    return jsx(FaroFormHelperText, { color: color, ...rest });
}
/**
 * @returns A dark variant of the FaroFormHelperText for errors, using red[300] as default color
 */
function FormHelperErrorTextDark({ color = INPUT_DARK_COLORS.error, ...rest }) {
    return jsx(FaroFormHelperText, { color: color, ...rest });
}
/**
 * @returns A light variant of the FaroFormHelperText for errors, using red[500] as default color
 */
function FormHelperErrorTextLight({ color = INPUT_LIGHT_COLORS.error, ...rest }) {
    return jsx(FaroFormHelperText, { color: color, ...rest });
}

/**
 * @returns A label to place above input components.
 */
function FaroInputLabel({ children, disabled, tag, error, dark, }) {
    if (!children) {
        return null;
    }
    const DISABLED_OPACITY = 0.6;
    const InputLabelVariant = dark ? InputLabelDark : InputLabel;
    return (jsxs(InputLabelVariant, { error: error, sx: {
            position: "unset",
            opacity: disabled ? DISABLED_OPACITY : 1,
        }, 
        // prevents MUI from hiding the placeholder, when there is a label above the input
        shrink: true, children: [children, jsx(InputLabelTag, { tag: tag, dark: dark })] }));
}

/** Default width for the text field */
const DEFAULT_FIELD_WIDTH = "13.75rem";
/** Maps a variant to a input component to use in the light theme */
const inputComponentMap = {
    outlined: OutlinedInput,
    underlined: UnderlinedInput,
};
/** Maps a variant to a input component to use in the dark theme */
const inputComponentMapDark = {
    outlined: OutlinedInputDark,
    underlined: UnderlinedInputDark,
};
/**
 * @returns An input element
 */
const TextField = forwardRef(function TextField({ label, tag, helpText, text, error, shouldShowCounter, maxCharacterCount, onCopy, onFocus, onBlur, onTextChanged, onKeyDown, controlStyle, InputProps, inputRef, disabled, readOnly, multiline, rows, fullWidth, placeholder, inputProps, type, variant = "outlined", dark = false, autoFocus = false, slots, startAdornment, endAdornment, sx, }, ref) {
    const DEFAULT_WIDTH = fullWidth ? "100%" : DEFAULT_FIELD_WIDTH;
    const DEFAULT_MIN_WIDTH = "3.75rem";
    const MULTILINE_MIN_WIDTH = "16rem";
    const minWidth = multiline ? MULTILINE_MIN_WIDTH : DEFAULT_MIN_WIDTH;
    const colors = dark ? INPUT_DARK_COLORS : INPUT_LIGHT_COLORS;
    const InputVariant = dark
        ? inputComponentMapDark[variant]
        : inputComponentMap[variant];
    const FormHelperTextVariant = dark
        ? FormHelperTextDark
        : FormHelperTextLight;
    const hasTooManyCharacters = !!maxCharacterCount && (text?.length ?? 0) > maxCharacterCount;
    if (!error && hasTooManyCharacters) {
        error = "Character limit exceeded";
    }
    return (jsxs(FormControl, { fullWidth: fullWidth, disabled: disabled, sx: { gap: 0.5, minWidth, width: DEFAULT_WIDTH, ...controlStyle }, children: [jsx(FaroInputLabel, { tag: tag, disabled: disabled, error: !!error, dark: dark, children: label }), jsx(InputVariant, { slots: slots, inputProps: inputProps, ref: ref, inputRef: inputRef, placeholder: placeholder, type: type, value: text, multiline: multiline, rows: rows, disabled: disabled, readOnly: readOnly, startAdornment: startAdornment, endAdornment: endAdornment, fullWidth: true, onCopy: onCopy, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, onChange: (ev) => onTextChanged?.(ev.target.value), autoFocus: autoFocus, error: !!error, sx: {
                    input: {
                        p: 3 / 2,
                        cursor: disabled ? "not-allowed" : undefined,
                        height: "auto",
                    },
                    "label + &.MuiInput-root": {
                        // Avoids there being a gap caused by a mui style for underlined inputs
                        mt: 0,
                    },
                    ...sx,
                }, ...InputProps }), jsxs(Stack, { direction: "row", children: [helpText && !error && (jsx(FormHelperTextVariant, { sx: {
                            m: 0,
                            overflow: "auto",
                            wordWrap: "break-word",
                        }, children: helpText })), error && (jsx(FormHelperTextVariant, { color: colors.error, sx: {
                            m: 0,
                            overflow: "auto",
                            wordWrap: "break-word",
                            fontWeight: FontWeights.SemiBold,
                        }, children: error })), shouldShowCounter && (jsxs(FormHelperTextVariant, { color: dark ? neutral[300] : neutral[600], error: hasTooManyCharacters, sx: {
                            m: 0,
                            ml: 1.5,
                            "&.Mui-error": {
                                color: colors.error,
                                fontWeight: FontWeights.SemiBold,
                            },
                            // Making sure the counter is sticking to the bottom right of the input
                            flex: 1,
                            textAlign: "end",
                        }, children: [text?.length ?? 0, maxCharacterCount ? `/${maxCharacterCount}` : ""] }))] })] }));
});

/** The class name for the label */
const RATE_LABEL_CLASS = "rateLabel";
/** The class name for the icon wrapper */
const RATE_ICON_WRAPPER_CLASS = "rateIconWrapper";
/** Default CSS style to apply when the button is hovered or rate is selected. */
const hoverAndSelectedStyle = {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    backgroundColor: alpha$1(neutral[500], 0.15),
    color: blue[500],
};
/**
 * @returns a rate element with an icon and a label.
 */
function RateElement({ label, selectedValue, value, onChange, iconComponent, sx, }) {
    /** Whether the rate element is selected */
    const isSelected = selectedValue === value;
    /** The properties to apply when the rate has been selected */
    const selectedStyle = isSelected ? hoverAndSelectedStyle : undefined;
    /** Reacts to clicks on the element */
    function onRateElementClick() {
        // If the value is the same as the selected value, then we want to deselect it
        if (isSelected) {
            onChange(null);
            return;
        }
        onChange(value);
    }
    return (jsxs(Box, { component: "div", onClick: onRateElementClick, sx: {
            ...sx,
            cursor: "pointer",
            "&:hover": {
                [`& .${RATE_ICON_WRAPPER_CLASS}`]: {
                    ...hoverAndSelectedStyle,
                },
                [`& .${RATE_LABEL_CLASS}`]: {
                    visibility: "visible",
                },
            },
            "&:active": {
                [`& .${RATE_ICON_WRAPPER_CLASS}`]: {
                    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
                    backgroundColor: alpha$1(neutral[500], 0.27),
                    color: blue[500],
                },
            },
        }, children: [jsx(Stack, { className: RATE_ICON_WRAPPER_CLASS, sx: {
                    width: "64px",
                    height: "64px",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    borderRadius: "50%",
                    margin: 0,
                    padding: 0,
                    ...selectedStyle,
                }, children: iconComponent }), jsx(Box, { component: "div", className: RATE_LABEL_CLASS, sx: {
                    visibility: isSelected ? "visible" : "hidden",
                    color: isSelected ? blue[500] : neutral[600],
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    fontSize: "10px",
                    marginTop: "8px",
                    textAlign: "center",
                }, children: label })] }));
}

/** The possible values for the rate */
var RateValue;
(function (RateValue) {
    RateValue["Unhappy"] = "NOT GOOD!";
    RateValue["Okay"] = "OKAY";
    RateValue["Great"] = "GREAT!";
})(RateValue || (RateValue = {}));
/** The maximum rating that can be given */
const MAX_RATING = 5;
/** The options for the rate element */
const RATE_OPTIONS = [
    {
        label: RateValue.Unhappy,
        value: 1,
        iconComponent: jsx(UnhappyFaceIcon, { sx: { height: "44px", width: "44px" } }),
    },
    {
        sx: { marginX: "12px" },
        label: RateValue.Okay,
        value: 3,
        iconComponent: jsx(RegularFaceIcon, { sx: { height: "44px", width: "44px" } }),
    },
    {
        label: `${RateValue.Great}!`,
        value: MAX_RATING,
        iconComponent: jsx(HappyFaceIcon, { sx: { height: "44px", width: "44px" } }),
    },
];
/**
 * The code snippet customizes the Material-UI Rating component using the styled function
 * from @mui/material/styles, creating a new component named StyledRating.
 */
const StyledRating = styled(Rating)(() => ({
    "&.feedback-rating": {
        gap: "32px",
        display: "flex",
        margin: "14px auto 0 auto",
    },
    "&.feedback-rating > label": {
        position: "relative",
    },
    "&.feedback-rating > label::after": {
        content: "''",
        position: "absolute",
        width: "32px",
        height: "1px",
        backgroundColor: neutral[200],
        top: "50%",
        transform: "translateY(-50%)",
        left: "100%",
    },
    "&.feedback-rating > label:nth-of-type(n + 5)::after": {
        display: "none",
    },
    "& .MuiRating-iconEmpty": {
        color: neutral[800],
    },
    "& .MuiRating-iconFilled.MuiRating-iconHover, .MuiRating-iconFilled, .MuiRating-iconEmpty": {
        minWidth: "50px",
        height: "50px",
        border: `1px solid ${neutral[200]}`,
        borderRadius: "100%",
        justifyContent: "center",
        alignItems: "center",
        transform: "scale(1)",
    },
    "& .MuiRating-iconFilled.MuiRating-iconHover, .MuiRating-iconFilled": {
        color: "white",
        background: blue[500],
        fontSize: "20px",
    },
}));
/**
 * IconContainer is a functional component responsible for rendering an icon based on the provided value.
 *
 * @param props - The props object containing the value to determine the icon.
 * @returns Returns a span element containing the corresponding icon based on the value.
 */
function IconContainer({ value, ...other }) {
    return jsx("span", { ...other, children: value });
}
/**
 * @returns the rate component for feedback dialog
 */
function FeedbackRate({ value, onChange, type = "emotion", }) {
    if (type === "numbered") {
        return (jsx(StyledRating, { classes: { root: "feedback-rating" }, IconContainerComponent: IconContainer, onChange: (_, value) => onChange(value ?? 1), value: value, highlightSelectedOnly: true }));
    }
    return (jsx(Stack, { sx: {
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
        }, children: RATE_OPTIONS.map((rateOption) => (jsx(RateElement, { sx: rateOption.sx, label: rateOption.label, value: rateOption.value, iconComponent: rateOption.iconComponent, selectedValue: value, onChange: onChange }, rateOption.value))) }));
}

/** @returns The feedback dialog */
function FeedbackDialog({ title = "How was your experience with Sphere XG?", isDialogOpen, onClose, feedbackQuestionText = "Want to tell us more?", onSubmitFeedback, supportMailAddress, onContactSupportClick, type, }) {
    const [selectedRating, setSelectedRating] = useState(null);
    const [feedbackText, setFeedbackText] = useState();
    /** Whether the submit button should disabled because the user didn't input anything yet */
    const isConfirmDisabled = !selectedRating && !feedbackText;
    const handleOnConfirm = useCallback(() => {
        if (selectedRating) {
            onSubmitFeedback(selectedRating, feedbackText);
        }
    }, [feedbackText, onSubmitFeedback, selectedRating]);
    return (jsx(FaroDialog, { open: isDialogOpen, onClose: onClose, title: title, isConfirmDisabled: isConfirmDisabled, onConfirm: handleOnConfirm, onCancel: onClose, children: jsxs(Box, { component: "div", children: [jsx(Box, { component: "div", sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        mb: "24px",
                    }, children: jsx(FeedbackRate, { value: selectedRating, onChange: setSelectedRating, type: type }) }), jsx(Box, { component: "div", sx: {
                        width: "100%",
                        fontSize: "14px",
                        color: neutral[800],
                        mb: "4px",
                    }, children: feedbackQuestionText }), jsxs(Box, { component: "div", sx: {
                        width: "100%",
                    }, children: [jsx(TextField, { fullWidth: true, multiline: true, rows: 4, placeholder: "Enter feedback\u2026", onTextChanged: setFeedbackText }), jsxs(Typography, { sx: {
                                fontSize: "12px",
                                marginTop: "4px",
                            }, children: ["If you need help with a specific problem, please contact", " ", jsx(Link, { fontWeight: "600", color: blue[500], onClick: onContactSupportClick, sx: { cursor: "pointer" }, children: supportMailAddress })] })] })] }) }));
}

const LIGHT_COLORS$2 = Object.freeze({
    backgroundColor: undefined,
    borderColor: neutral[200],
    shadowColor: neutral[500],
});
const DARK_COLORS$2 = Object.freeze({
    backgroundColor: neutral[950],
    borderColor: neutral[800],
    shadowColor: undefined,
});
/** @returns a Menu implementation following the FARO design system  */
const FaroMenu = forwardRef(function FaroMenu({ children, dark = false, visibleOverflow = false, sx, minWidth = "250px", ...rest }, ref) {
    const colors = dark ? DARK_COLORS$2 : LIGHT_COLORS$2;
    return (jsx(Menu, { ...rest, ref: ref, sx: [
            {
                ".MuiPaper-root": {
                    boxShadow: colors.shadowColor
                        ? `0px 3px 6px ${colors.shadowColor}33`
                        : "none",
                    overflow: visibleOverflow ? "visible" : undefined,
                },
                ".MuiMenu-paper": {
                    background: colors.backgroundColor,
                    border: `1px solid ${colors.borderColor}`,
                    minWidth,
                },
                ".MuiMenu-list": {
                    m: 0,
                    p: 0.5,
                },
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ], children: children }));
});

/** @returns a MenuItem for a FaroMenu that conforms to the FARO Design System guidelines */
function FaroMenuItem({ label, children, secondaryText, shortcut, footnoteText, onFootnoteClick, Icon, onClick, color, secondaryColor, highlightColor, dark = false, sx, ...rest }) {
    color ??= dark ? neutral[100] : neutral[800];
    secondaryColor ??= dark ? neutral[300] : neutral[600];
    highlightColor ??= dark ? cyan$1[400] : blue[500];
    const [isActive, setIsActive] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [isFootnoteHovered, setFootnoteIsHovered] = useState(false);
    const [isSubMenuHovered, setIsSubMenuHovered] = useState(false);
    const isSelected = (isActive || isHovered || isSubMenuHovered) && !isFootnoteHovered;
    const menuItem = useRef(null);
    return (jsxs(Fragment, { children: [jsx(MenuItem, { ...rest, onClick: (ev) => {
                    if (!isFootnoteHovered) {
                        if (children)
                            setIsActive(!isActive);
                        onClick?.(ev);
                    }
                }, ref: menuItem, onPointerEnter: () => setIsHovered(true), onPointerLeave: () => setIsHovered(false), selected: isSelected, sx: {
                    px: 1.5,
                    py: 1,
                    // Hover background
                    "&.Mui-selected, &.Mui-selected:hover": {
                        backgroundColor: `${neutral[500]}1A`,
                    },
                    ":hover": {
                        backgroundColor: `${neutral[500]}1A`,
                    },
                    // Pressed background
                    "&& .MuiTouchRipple-child": {
                        backgroundColor: `${neutral[500]}33`,
                    },
                    ...sx,
                }, children: jsxs(Stack, { direction: "column", sx: { width: "100%" }, children: [jsxs(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", gap: 1, sx: { width: "100%" }, children: [Icon && (jsx(Icon, { sx: {
                                        fontSize: "1rem",
                                        color: isSelected ? highlightColor : color,
                                        alignSelf: "center",
                                    } })), jsx(FaroText, { variant: "bodyM", sx: { color: isSelected ? highlightColor : color }, flexGrow: 1, children: label }), shortcut && (jsx(FaroText, { variant: "bodyS", color: secondaryColor, children: shortcut })), children && (jsx(ArrowDownIcon, { sx: {
                                        color,
                                        fontSize: "0.875rem",
                                        transform: "rotate(-90deg)",
                                        ml: "auto",
                                    } }))] }), secondaryText && (jsx(FaroText, { variant: "bodyS", color: secondaryColor, 
                            // Align secondary text with main text
                            // They can't be aligned in the same container as that will make it hard
                            // to align the main text with the icon instead
                            ml: Icon ? "1rem" : 0, pl: Icon ? 1 : 0, 
                            // Allow the secondary text to break, when the menu width is limited
                            whiteSpace: "normal", children: secondaryText })), footnoteText && (jsx(FaroText, { variant: "bodyS", onClick: () => onFootnoteClick?.(), color: onFootnoteClick ? highlightColor : secondaryColor, sx: {
                                mt: "1.5em",
                                ":hover": {
                                    textDecoration: "underline",
                                },
                            }, onMouseEnter: () => setFootnoteIsHovered(!!onFootnoteClick), onMouseLeave: () => setFootnoteIsHovered(false), children: footnoteText }))] }) }), children && (jsx(FaroMenu, { dark: dark, open: isSelected, anchorEl: menuItem.current, anchorOrigin: { horizontal: "right", vertical: "top" }, onClose: () => setIsActive(false), onPointerEnter: () => setIsSubMenuHovered(true), onPointerLeave: () => setIsSubMenuHovered(false), autoFocus: false, sx: {
                    ml: 1,
                    pointerEvents: isActive ? "auto" : "none",
                    "& .MuiMenu-paper": {
                        pointerEvents: isActive ? "auto" : "none",
                    },
                    "& .MuiMenu-list": {
                        pointerEvents: "auto",
                    },
                }, children: jsx(MenuList, { children: children }) }))] }));
}

/** @returns a MenuItem styled to be used as a Section header in a FaroMenu */
function FaroMenuSection({ children, dark = false, sx, ...rest }) {
    return (jsx(FaroText, { variant: "labelS", color: dark ? neutral[100] : neutral[800], ...rest, sx: {
            display: "inline-block",
            textTransform: "uppercase",
            userSelect: "none",
            p: 1.5,
            pt: 1,
            ...sx,
        }, children: children }));
}

/** @returns a divider properly styled to be used in a FaroMenu */
function FaroMenuSeparator({ dark, }) {
    const color = dark ? neutral[800] : neutral[200];
    return jsx(Divider, { sx: { borderColor: color } });
}

const LIGHT_COLORS$1 = Object.freeze({
    color: neutral[800],
    borderColor: neutral[200],
    backgroundColor: neutral[0],
    scrollbarThumbColor: neutral[999],
    checkBoxColor: blue[500],
});
const DARK_COLORS$1 = Object.freeze({
    color: neutral[100],
    borderColor: neutral[800],
    backgroundColor: neutral[999],
    scrollbarThumbColor: neutral[0],
    checkBoxColor: cyan$1[400],
});

/**
 * @returns The content of a filter menu
 */
function FilterMenuContent({ headingLabel, options, selectedOptions: selectedOptionsExternal, onFilterChange, onResetFilter, dark = false, disabled, optionsSx, headersSx, children, keepHeightOnSearch = false, }) {
    const colors = dark ? DARK_COLORS$1 : LIGHT_COLORS$1;
    const [searchText, setSearchText] = useState("");
    // List of displayed options filtered by searchText; headers are always displayed
    const filteredOptions = useMemo(() => {
        // first filter out the options that do not match the search text, but keep all headers
        const filteredOptionsWithHeader = options.filter((o) => o.isHeader ?? o.value.toLowerCase().includes(searchText.toLowerCase()));
        // second remove headers if they have no entries following them
        const filteredOptions = [];
        filteredOptionsWithHeader.forEach((o, index) => {
            if (!o.isHeader ||
                (index !== filteredOptionsWithHeader.length - 1 &&
                    !filteredOptionsWithHeader[index + 1].isHeader)) {
                filteredOptions.push(o);
            }
        });
        return filteredOptions;
    }, [searchText, options]);
    const updateSearchText = useCallback((newInputValue) => {
        setSearchText(newInputValue);
    }, []);
    const [selectedOptions, setSelectedOptions] = useSelectedOptions(selectedOptionsExternal);
    const updateSelectedOptions = useCallback((selectedOptions, enabledOption) => {
        setSelectedOptions?.(selectedOptions);
        onFilterChange?.(selectedOptions, enabledOption);
    }, [onFilterChange, setSelectedOptions]);
    const resetSelectedOptionsAndSearchText = useCallback(() => {
        setSearchText("");
        setSelectedOptions?.([]);
        onResetFilter?.();
    }, [onResetFilter, setSelectedOptions]);
    // Store the height of the list container once it's initialized and change
    // it if the list of input options changes
    const [container, setContainer] = useState(null);
    const [height, setHeight] = useState();
    useEffect(() => {
        if (container && keepHeightOnSearch) {
            setHeight(container.clientHeight);
        }
    }, [container, keepHeightOnSearch, options]);
    return (jsxs(Stack, { flexGrow: "1", direction: "column", p: 0.5, sx: { color: colors.color, maxWidth: "240px" }, children: [headingLabel && (jsx(FaroText, { variant: "labelS", color: "inherit", textTransform: "uppercase", children: headingLabel })), jsx(TextField, { disabled: disabled, text: searchText, onTextChanged: updateSearchText, placeholder: "Search", sx: { height: 38, mt: 2, py: 0.5 }, dark: dark, fullWidth: true }), children, jsx(Box, { component: "div", sx: {
                    maxHeight: "370px",
                    minHeight: 0,
                    overflowY: "auto",
                    height,
                }, children: jsxs(Stack, { ref: setContainer, sx: { py: filteredOptions.length > 0 || !keepHeightOnSearch ? 1 : 0 }, gap: 0, children: [filteredOptions.map((option) => option.isHeader ? (jsx(HeaderOption, { sx: headersSx, children: option.label }, option.key)) : (jsx(FilterMenuOption, { disabled: disabled, option: option, selected: !!selectedOptions.find((o) => o.key === option.key), onCheckboxChanged: (checked) => {
                                if (checked) {
                                    updateSelectedOptions([...selectedOptions, option], true);
                                }
                                else {
                                    updateSelectedOptions(selectedOptions.filter((o) => o.key !== option.key), false);
                                }
                            }, dark: dark, sx: optionsSx }, option.key))), filteredOptions.length === 0 && (jsx(FaroText, { variant: "bodyM", color: "inherit", sx: {
                                px: 2,
                                py: 0.75,
                            }, children: "No results found" }))] }) }), jsx(Divider, { sx: { bgcolor: neutral[0], opacity: 0.2 } }), jsx(Box, { component: "div", children: jsx(FaroButton, { variant: "ghost", disabled: disabled, dark: dark, onClick: resetSelectedOptionsAndSearchText, children: "Clear all" }) })] }));
}
/**
 * Defines the selected options property and its setter.
 * If the property is passed by the consumer of the component, the setter will be undefined
 * and the consumer will need to manage the property outside (controlled state).
 * If the property is not defined, the component will manage it internally using a useState
 * (uncontrolled state).
 *
 * @param selectedOptionsExternal The selected options defined externally, if defined
 * @returns The selected options property and the setter, if defined
 */
function useSelectedOptions(selectedOptionsExternal) {
    const [selectedOptionsInternal, setSelectedOptionsInternal] = useState([]);
    // If the selectedOptions have been defined from outside, than the value should be managed outside (controlled state)
    // If the selectedOptions have not been defined, they are managed internally (uncontrolled state)
    const selectedOptions = selectedOptionsExternal ?? selectedOptionsInternal;
    const setSelectedOptions = selectedOptionsExternal
        ? undefined
        : setSelectedOptionsInternal;
    return [selectedOptions, setSelectedOptions];
}
function HeaderOption({ children, sx }) {
    return (jsx(Stack, { component: "li", direction: "row", gap: 1, sx: { mb: 1.5, fontWeight: "bold", ...sx }, alignItems: "center", children: jsx(TruncatedFaroText, { variant: "bodyM", color: "inherit", containerSx: { width: "100%" }, children: children }) }));
}
function FilterMenuOption({ option, selected, dark, disabled, onCheckboxChanged, sx, ...rest }) {
    const colors = dark ? DARK_COLORS$1 : LIGHT_COLORS$1;
    return (jsxs(Stack, { component: "li", direction: "row", gap: 1, sx: { mb: 1.5, cursor: "pointer", ...sx }, alignItems: "center", onClick: () => onCheckboxChanged(!selected), ...rest, children: [jsx(Checkbox, { sx: {
                    color: "inherit",
                    p: 0,
                    my: 0.5,
                    "& .MuiSvgIcon-root": {
                        fontSize: 20,
                    },
                    "&.Mui-checked": {
                        "& .MuiSvgIcon-root": {
                            color: colors.checkBoxColor,
                        },
                    },
                }, disabled: disabled, checked: selected, onChange: (ev) => onCheckboxChanged(ev.target.checked) }), jsx(TruncatedFaroText, { variant: "bodyM", color: "inherit", tooltip: option.tooltip, containerSx: { width: "100%" }, children: option.label })] }));
}

/** @returns a button to trigger list of options which can be filtered with a search bar */
function FilterMenu({ open, headingLabel, options, selectedOptions, onFilterChange, onResetFilter, onFilterMenuClose, dark = false, ...rest }) {
    const colors = dark ? DARK_COLORS$1 : LIGHT_COLORS$1;
    return (jsx(FaroMenu, { open: open, ...rest, dark: dark, onClose: () => onFilterMenuClose?.(), sx: {
            [`& .${menuClasses.paper}`]: {
                p: 0.5,
                pb: 0.5,
                maxHeight: "fit-content",
            },
            [`& .${menuClasses.list}`]: {
                m: 0,
                [`& .${formControlClasses.root}`]: {
                    width: "100%",
                },
            },
            // scrollbar styles
            scrollbarWidth: "thin",
            ["&::-webkit-scrollbar-thumb"]: {
                bgcolor: `${colors.scrollbarThumbColor}33`,
                ["&:hover"]: {
                    bgcolor: `${colors.scrollbarThumbColor}66`,
                },
            },
            scrollbarColor: `${colors.scrollbarThumbColor}33 ${colors.backgroundColor}`,
        }, children: jsx(FilterMenuContent, { headingLabel: headingLabel, options: options, selectedOptions: selectedOptions, onFilterChange: onFilterChange, onResetFilter: onResetFilter, dark: dark }) }));
}

/**
 * @returns the GDPR Concent form if it has not been accepted already
 */
function DataCollectionConsent({ onClose, }) {
    const buttonSx = {
        color: "white",
        textTransform: "none",
        background: (theme) => theme.palette.laserBlue,
        "&:hover": {
            background: (theme) => theme.palette.laserBlue,
        },
    };
    return (jsxs(Dialog, { open: true, children: [jsx(DialogTitle, { sx: {
                    color: ({ palette }) => palette.primary.main,
                    fontSize: (theme) => theme.spacing(4),
                }, children: "Help Us Improve" }), jsxs(DialogContent, { color: "inherit", children: ["We want to create the most valuable experience for you and your business. The best way to do this is to learn from our users and how they use the Viewer.", jsxs("p", { children: ["Please ", jsx("b", { children: "allow us to collect basic data" }), " on how you interact with the Viewer. The data cannot be traced back to you and cannot be used to find out anything about your current project."] }), jsx("p", { children: "Thank you for helping us!" })] }), jsxs(DialogActions, { sx: { gap: 2, padding: 3 }, children: [jsx(FaroButton, { size: "l", onClick: () => onClose(false), sx: buttonSx, children: "No thanks" }), jsx(FaroButton, { size: "l", onClick: () => onClose(true), sx: buttonSx, children: "Agree" })] })] }));
}

/**
 * @returns A floater window with minimize and maximize functionality
 */
function FloatingWindow({ label, sx, children, }) {
    const draggableRef = useRef(null);
    const [accordionOpacity, setAccordionOpacity] = useState(0.5);
    const mapContainerId = useId();
    function handleAccordianOpacity(ev) {
        const opacity = ev.type === "mouseenter" ? 1 : 0.5;
        setAccordionOpacity(opacity);
    }
    return (jsx(Draggable, { onDrag: (ev) => {
            ev.stopPropagation();
        }, bounds: "parent", cancel: `#${mapContainerId}`, nodeRef: draggableRef, children: jsxs(Accordion, { defaultExpanded: true, sx: {
                position: "absolute",
                zIndex: "999",
                opacity: `${accordionOpacity}`,
                transition: "opacity 0.5s",
                cursor: "move",
                ...sx,
            }, onMouseEnter: handleAccordianOpacity, onMouseLeave: handleAccordianOpacity, ref: draggableRef, children: [jsx(AccordionSummary, { expandIcon: jsx(ExpandLessIcon, {}), children: jsx(Typography, { onClick: (event) => event.stopPropagation(), onFocus: (event) => event.stopPropagation(), sx: { width: "100%", height: "100%", cursor: "move" }, children: label }) }), jsx(AccordionDetails, { sx: {
                        display: "flex",
                    }, children: jsx(Box, { id: mapContainerId, component: "div", sx: {
                            width: "350px",
                            height: "300px",
                        }, children: children }) })] }) }));
}

/**
 * @returns a footer that renders its children.
 */
function Footer({ sx, children, }) {
    return (jsx(MaterialAppBar, { position: "static", sx: { top: "auto", bottom: 0 }, children: jsx(Toolbar$1, { disableGutters: true, sx: {
                backgroundColor: "white",
                height: "100px",
                paddingX: "24px",
                paddingY: "2px",
                ...sx,
            }, children: jsx(Stack, { sx: { width: "100%" }, alignItems: "center", children: children }) }) }));
}

/**
 * @returns A help banner displaying an informational message to the user.
 */
function HelpBanner({ children, sx }) {
    return (jsx(Paper, { sx: {
            backgroundColor: "gray950",
            color: "whiteGray",
            textAlign: "center",
            borderWidth: "1px",
            borderStyle: "solid",
            opacity: 0.8,
            borderColor: "white10",
            pointerEvents: "none",
            p: 2,
            ...sx,
        }, children: jsx(Typography, { children: children }) }));
}

/**
 * Renders a menu component that provides access to various resources, including the Help Center, walkthrough videos, and a feedback option.
 *
 * @returns JSX.Element The rendered menu component.
 */
function HelpCenterMenu({ helpCenterLanguages = LanguageCodes.English, sendFeedback, onOpenHelpCenter, onCloseHelpCenter, onOpenHelpLink, anchorOrigin = { horizontal: "left", vertical: "bottom" }, openChat, numUnreadMsg, }) {
    const ref = useRef(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    /**
     * Closes the help center menu.
     */
    const closeMenu = useCallback(() => {
        onCloseHelpCenter?.();
        setIsMenuOpen(false);
    }, [onCloseHelpCenter, setIsMenuOpen]);
    /**
     * Opens the Sphere XG "New Features" page in a new browser tab.
     */
    const openWhatsNew = useCallback(() => {
        onOpenHelpLink?.("whats-new");
        const url = "https://www.holobuilder.com/content-type/whats-new/";
        window.open(url, "_blank");
        setIsMenuOpen(false);
    }, [onOpenHelpLink]);
    /**
     * Opens the Sphere XG Help Center documentation in a new browser tab.
     *
     * This method constructs the URL for the Help Center documentation based on the selected language
     * and then opens it in a new tab. After opening the Help Center, it closes the current menu.
     */
    const openHelpCenter = useCallback(() => {
        onOpenHelpLink?.("help-center");
        const url = `https://help.holobuilder.com/${helpCenterLanguages}/collections/9864205-sphere-xg`;
        window.open(url, "_blank");
        setIsMenuOpen(false);
    }, [helpCenterLanguages, onOpenHelpLink]);
    /**
     * Opens the Sphere-XG walkthrough videos page in a new browser tab.
     *
     * This method is designed to be triggered when a user clicks a specific button or menu item.
     * It constructs the URL for the Sphere-XG walkthrough videos on the HoloBuilder website and
     * opens it in a new browser tab.
     */
    const openWalkthroughVideo = useCallback(() => {
        onOpenHelpLink?.("videos");
        const url = "https://www.holobuilder.com/sphere-xg-walkthrough-videos/";
        window.open(url, "_blank");
        setIsMenuOpen(false);
    }, [onOpenHelpLink]);
    /**
     * Triggers the app defined send feedback workflow
     */
    const triggerSendFeedback = useCallback(() => {
        if (!sendFeedback)
            return;
        onOpenHelpLink?.("send-feedback");
        sendFeedback();
        setIsMenuOpen(false);
    }, [onOpenHelpLink, sendFeedback]);
    return (jsxs(Fragment, { children: [jsxs(FaroIconButton, { "aria-label": "expand help center menu", ref: ref, onClick: () => {
                    onOpenHelpCenter?.();
                    setIsMenuOpen(true);
                }, color: isMenuOpen ? blue[500] : undefined, pressed: isMenuOpen, children: [jsx(HelpIcon, { sx: {
                            width: "24px",
                            height: "24px",
                        } }), !!openChat && !!numUnreadMsg && numUnreadMsg > 0 && (jsx(Box, { component: "div", "data-testid": "unread-messages-icon-1", sx: {
                            position: "absolute",
                            top: "-2px",
                            left: "14px",
                            // !important is needed to override a competing style from MuiButtonBase.
                            // We want the colored dot to be a child of FaroIconButton so that the mouse events are handled as desired.
                            width: "12px !important",
                            height: "12px !important",
                            border: "2px solid white",
                            borderRadius: "50%",
                            backgroundColor: orange[400],
                        } }))] }), jsxs(FaroMenu, { open: isMenuOpen, anchorEl: ref.current, onClose: () => closeMenu(), anchorOrigin: anchorOrigin, children: [jsx(FaroMenuSection, { children: "Resource center" }), jsx(FaroMenuItem, { label: "What's new", Icon: AnnouncementIcon, onClick: openWhatsNew }), jsx(FaroMenuItem, { label: "Help center", Icon: HelpCenterIcon, onClick: openHelpCenter }), jsx(FaroMenuItem, { label: "Videos", Icon: VideoIcon, onClick: openWalkthroughVideo }), !!openChat && (jsxs(Box, { component: "div", children: [jsx(FaroMenuItem, { label: "Chat with us", Icon: ChatIcon, onClick: () => {
                                    openChat();
                                    setIsMenuOpen(false);
                                } }), !!numUnreadMsg && numUnreadMsg > 0 && (jsx(Box, { component: "div", "data-testid": "unread-messages-icon-2", sx: {
                                    position: "absolute",
                                    right: "20px",
                                    marginTop: "-28px",
                                    paddingTop: "1px",
                                    width: "20px",
                                    height: "20px",
                                    textAlign: "center",
                                    borderRadius: "50%",
                                    fontSize: "12px",
                                    backgroundColor: orange[400],
                                    color: "white",
                                }, children: numUnreadMsg }))] })), sendFeedback && (jsx(FaroMenuItem, { label: "Send feedback", Icon: FeedbackIcon, onClick: triggerSendFeedback }))] })] }));
}

/** The direction to scroll the list */
var ScrollDirection;
(function (ScrollDirection) {
    ScrollDirection["next"] = "Next";
    ScrollDirection["previous"] = "Previous";
})(ScrollDirection || (ScrollDirection = {}));
/**
 * @returns a list of items in a horizontal layout with an ability to scroll
 * - Allows navigation through the items using the mouse wheel or the arrow buttons
 */
function HorizontalScrollList({ children, isPageScroll, shouldHideScrollbar, shouldShowButtons = true, scrollButtonProps, sx, wrapperSx, scrollBarSx, }) {
    const scrollContainerRef = useRef(null);
    const { sx: scrollButtonSx, ...restScrollButtonProps } = scrollButtonProps ?? {};
    // Logic to check if the scroll container has overflowed
    const { hasOverflown, checkForOverflow } = useCheckForOverflow();
    useEffect(() => {
        if (!scrollContainerRef.current)
            return;
        function onResize() {
            if (scrollContainerRef.current) {
                checkForOverflow(scrollContainerRef.current);
            }
        }
        const resizeObserver = new ResizeObserver(onResize);
        resizeObserver.observe(scrollContainerRef.current);
        return () => {
            resizeObserver.disconnect();
        };
    }, [checkForOverflow]);
    /** Callback when the wheel event occurs on the scrollable list */
    const onWheelOverScrollContainer = useCallback((event) => {
        if (!scrollContainerRef.current)
            return;
        scrollContainerRef.current.scrollLeft += event.deltaY;
    }, []);
    const handleScrollOnClick = useCallback((scrollDirection) => {
        if (!scrollContainerRef.current)
            return;
        const elements = Array.from(scrollContainerRef.current.children);
        if (isPageScroll) {
            const parentRect = scrollContainerRef.current.getBoundingClientRect();
            for (const element of elements) {
                const rect = element.getBoundingClientRect();
                // If the scroll direction is 'next' and the right edge of the child element is beyond the right edge of the parent,
                // calculate the scroll amount and scroll to the right by that amount.
                if (scrollDirection === ScrollDirection.next) {
                    if (rect.right > parentRect.right) {
                        const scrollAmount = rect.left - parentRect.left;
                        scrollContainerRef.current.scrollLeft += scrollAmount;
                        break;
                    }
                }
                // If the left edge of the child element is beyond the left edge of the parent,
                // calculate the scroll amount and scroll to the left by that amount.
                else if (rect.left > parentRect.left) {
                    const scrollAmount = parentRect.right - rect.left;
                    scrollContainerRef.current.scrollLeft -= scrollAmount;
                    break;
                }
            }
        }
        else {
            const childWidth = elements[0].getBoundingClientRect().width;
            // If the scroll direction is 'next', scroll to the right by the width of the child element.
            // If the scroll direction is 'previous', scroll to the left by the width of the child element.
            scrollContainerRef.current.scrollLeft =
                scrollDirection === ScrollDirection.next
                    ? scrollContainerRef.current.scrollLeft + childWidth
                    : scrollContainerRef.current.scrollLeft - childWidth;
        }
    }, [isPageScroll]);
    if (!children)
        return null;
    return (jsxs(Stack, { justifyContent: "center", alignItems: "center", position: "relative", sx: wrapperSx, children: [jsx(Box, { component: "div", gap: 1, ref: scrollContainerRef, onWheel: onWheelOverScrollContainer, sx: {
                    display: "grid",
                    gridAutoFlow: "column",
                    gridAutoColumns: "max-content",
                    gridTemplateRows: "1fr",
                    width: "100%",
                    overflowX: "auto",
                    padding: "1rem",
                    pb: hasOverflown ? 1 : undefined,
                    scrollBehavior: "smooth",
                    overscrollBehaviorInline: "contain",
                    scrollSnapType: "inline mandatory",
                    scrollPadding: "8px",
                    ["& > *"]: {
                        scrollSnapAlign: "start",
                    },
                    ...(shouldHideScrollbar
                        ? {
                            ["&::-webkit-scrollbar"]: {
                                display: "none",
                            },
                            msOverflowStyle: "none",
                            scrollbarWidth: "none",
                        }
                        : {
                            scrollbarWidth: "thin",
                            ...(scrollBarSx && {
                                ["&::-webkit-scrollbar-thumb"]: {
                                    background: scrollBarSx.backgroundColor,
                                    ["&:hover"]: {
                                        background: scrollBarSx.thumbHoverColor,
                                    },
                                },
                                scrollbarColor: `${scrollBarSx.thumbColor} ${scrollBarSx.backgroundColor}`,
                            }),
                        }),
                    ...sx,
                }, children: children }), shouldShowButtons && hasOverflown && (jsxs(Stack, { direction: "row", justifyContent: "space-between", position: "absolute", width: "fill-available", sx: { pointerEvents: "none" }, children: [jsx(FaroIconButton, { onClick: () => handleScrollOnClick(ScrollDirection.previous), sx: {
                            pointerEvents: "auto",
                            ...scrollButtonSx,
                        }, ...restScrollButtonProps, children: jsx(ArrowRightIcon, { sx: { transform: "rotate(180deg)" } }) }), jsx(FaroIconButton, { onClick: () => handleScrollOnClick(ScrollDirection.next), sx: {
                            pointerEvents: "auto",
                            ...scrollButtonSx,
                        }, ...restScrollButtonProps, children: jsx(ArrowRightIcon, {}) })] }))] }));
}

function FileCard({ id, fileName: fileNameWithExtension, urlOrFile, thumbnailUrl: thumbnail, date, onDelete, isLoading = false, deleteTooltipText, scrollIntoView = false, onAttachmentOpened, }) {
    const cardRef = useRef(null);
    const [isHoveringDeleteButton, setIsHoveringDeleteButton] = useState(false);
    const [isFileHovered, setIsFileHovered] = useState(false);
    const { fileName, extension } = splitFileNameAndExtension(fileNameWithExtension);
    const url = useMemo(() => typeof urlOrFile === "string"
        ? urlOrFile
        : URL.createObjectURL(urlOrFile), [urlOrFile]);
    // Scrolls the card into view if requested
    useEffect(() => {
        if (!cardRef.current || !scrollIntoView)
            return;
        cardRef.current.scrollIntoView();
    }, [scrollIntoView]);
    const thumbnailUrl = useMemo(() => {
        if (!thumbnail)
            return;
        if (typeof thumbnail === "string")
            return thumbnail;
        return URL.createObjectURL(thumbnail);
    }, [thumbnail]);
    return (jsx(Tooltip, { title: "Click to open in new tab", open: isFileHovered && !isHoveringDeleteButton, onOpen: () => setIsFileHovered(true), onClose: () => setIsFileHovered(false), children: jsx(Card$1, { ref: cardRef, sx: {
                width: 150,
                display: "flex",
                flexDirection: "column",
                background: neutral[950],
                position: "relative",
                "&:hover": {
                    cursor: "pointer",
                    background: `${neutral[500]}26`,
                },
                "&:active": {
                    background: `${neutral[500]}40`,
                },
            }, onClick: () => {
                onAttachmentOpened?.(extension ?? "unknown");
                window.open(url, "_blank");
            }, children: isLoading ? (jsxs(Fragment, { children: [jsx(Skeleton, { variant: "rectangular", sx: {
                            aspectRatio: "16/9",
                            m: 1,
                            height: 100,
                            background: neutral[800],
                        } }), jsxs(Stack, { gap: 0.75, m: 1, children: [jsx(Skeleton, { variant: "text", sx: {
                                    background: neutral[800],
                                } }), jsx(Skeleton, { variant: "text", sx: {
                                    background: neutral[800],
                                } })] })] })) : (jsxs(Fragment, { children: [jsx(CardMediaWithFallback, { component: "img", alt: fileName, src: thumbnailUrl ?? undefined, sx: { aspectRatio: "16/9", objectFit: "cover" }, loading: "lazy", fallback: jsx(FileThumbnailFallback, { extension: extension }) }), jsxs(CardContent$1, { sx: {
                            display: "flex",
                            flexDirection: "column",
                            gap: 0.25,
                            p: 1,
                        }, children: [jsxs(Stack, { direction: "row", children: [jsx(FaroText, { gutterBottom: true, variant: "labelS", fontWeight: FontWeights.SemiBold, color: neutral[100], margin: 0, shouldElide: true, className: NO_TRANSLATE_CLASS, children: fileName }), extension && (jsxs(FaroText, { gutterBottom: true, variant: "labelS", fontWeight: FontWeights.SemiBold, color: neutral[100], margin: 0, className: NO_TRANSLATE_CLASS, children: [".", extension] }))] }), jsx(FaroText, { variant: "labelS", fontWeight: FontWeights.Regular, color: neutral[400], className: NO_TRANSLATE_CLASS, children: convertToDateTimeString(date) })] }), jsx(CardActions, { sx: { position: "absolute", top: 0, right: 0 }, children: isFileHovered && onDelete && (jsx(Tooltip, { title: deleteTooltipText ?? "", open: isHoveringDeleteButton, onOpen: () => setIsHoveringDeleteButton(true), onClose: () => setIsHoveringDeleteButton(false), 
                            // This is needed if the tooltip text is not defined, because in that case onClose will not be called
                            onMouseLeave: () => setIsHoveringDeleteButton(false), children: jsx(FaroIconButton, { onClick: (e) => {
                                    e.stopPropagation();
                                    onDelete(id, extension ?? "unknown", urlOrFile instanceof File);
                                }, color: neutral[100], hoverColor: neutral[100], size: FaroIconButtonSizes.s, margin: 0.5, sx: {
                                    borderRadius: 1,
                                    background: `${neutral[999]}A6`,
                                    "&:hover": {
                                        background: cyan$1[600],
                                    },
                                    "&:active": {
                                        background: cyan$1[700],
                                    },
                                }, children: jsx(DeleteIcon, {}) }) })) })] })) }, id) }));
}
/**
 *  @returns a list of files with their details in a horizontally scrollable list
 */
function FileDetailsList({ files, deleteTooltipText, onAttachmentOpened, ...rest }) {
    // Keep track of the previous files state to detect newly added files
    const [prevFiles, setPrevFiles] = useState(files);
    useEffect(() => setPrevFiles(files), [files]);
    const firstNewFile = files === prevFiles
        ? undefined
        : files.find((file) => !prevFiles.includes(file));
    return (jsx(HorizontalScrollList, { scrollButtonProps: {
            size: FaroIconButtonSizes.s,
            color: neutral[100],
            hoverColor: blue[500],
            sx: {
                boxShadow: `0px 0px 4px ${neutral[100]}CC`,
                background: neutral[950],
                "&:hover": {
                    background: neutral[800],
                },
                "&:active": {
                    background: neutral[700],
                },
            },
        }, ...rest, scrollBarSx: {
            backgroundColor: neutral[800],
            thumbColor: neutral[600],
            thumbHoverColor: neutral[500],
        }, children: files.map((file) => (jsx(FileCard, { deleteTooltipText: deleteTooltipText, scrollIntoView: file === firstNewFile, onAttachmentOpened: onAttachmentOpened, ...file }, file.id))) }));
}
/**
 * @param props The CardMedia props to pass through to the Material-UI CardMedia
 * @returns A CardMedia if the image is successfully displayed, or a a fallback otherwise.
 */
function CardMediaWithFallback(props) {
    // Keep track of which src attribute failed, so the fetching can be retried if it changes.
    const [lastErroredSrc, setLastErroredSrc] = useState();
    const { src, fallback, onError, sx } = props;
    const handleError = useCallback((event) => {
        setLastErroredSrc(src);
        onError?.(event);
    }, [onError, src]);
    if (!src || lastErroredSrc === src) {
        return (jsx(CardMedia$1, { sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: neutral[900],
                ...sx,
            }, children: fallback }));
    }
    return (jsx(CardMedia$1, { ...props, onError: handleError, className: NO_TRANSLATE_CLASS }));
}
/**
 * @returns a fallback icon that visualizes the file type.
 */
function FileThumbnailFallback({ extension, }) {
    const Icon = useMemo(() => {
        if (isImageFileExtension(extension)) {
            return FileImageIcon;
        }
        else if (isDocumentFileExtension(extension)) {
            return FileDocumentIcon;
        }
        return AttachmentIcon;
    }, [extension]);
    return jsx(Icon, { sx: { fontSize: 32, color: neutral[300] } });
}

/** The height of the text field */
const TEXT_FIELD_HEIGHT = "36px";
/**
 * @returns a text component with action buttons to edit or delete the text
 */
function ActionTextField({ inputText, dark, disabled, isEditable = true, fullWidth, sx, validate, onDeleteButtonClick, onConfirmButtonClick, onCancelButtonClick, }) {
    const [isEditing, setIsEditing] = useState(false);
    if (isEditing && !disabled) {
        return (jsx(ActionTextFieldEdit, { inputText: inputText, dark: dark, fullWidth: fullWidth, sx: sx, validate: validate, setIsEditing: setIsEditing, isEditable: isEditable, onConfirmButtonClick: onConfirmButtonClick, onCancelButtonClick: onCancelButtonClick }));
    }
    return (jsx(ActionTextFieldIdle, { inputText: inputText, dark: dark, disabled: disabled, fullWidth: fullWidth, sx: sx, validate: validate, isEditable: isEditable, setIsEditing: setIsEditing, onDeleteButtonClick: onDeleteButtonClick }));
}
function ActionTextFieldIdle({ inputText, dark, disabled, isEditable, fullWidth, sx, validate, setIsEditing, onDeleteButtonClick, }) {
    /** Depending on the prop dark, this should be the color to use for the text and icons */
    const inputColor = useMemo(() => (dark ? neutral[100] : neutral[800]), [dark]);
    const errorMessage = useMemo(() => validate?.(inputText), [inputText, validate]);
    const FormHelperTextVariant = dark
        ? FormHelperErrorTextDark
        : FormHelperErrorTextLight;
    return (jsxs(Stack$1, { direction: "column", sx: {
            width: fullWidth ? "100%" : "fit-content",
        }, children: [jsxs(Stack$1, { direction: "row", alignItems: "center", justifyContent: "space-between", gap: 2, sx: {
                    width: fullWidth ? "100%" : DEFAULT_FIELD_WIDTH,
                    height: TEXT_FIELD_HEIGHT,
                    px: 1.5,
                    py: 0.5,
                    // Show the error line at the bottom even in the idle state, if there is an error
                    ...(errorMessage !== undefined && { boxShadow: "0 -1px  red inset" }),
                    ...sx,
                }, children: [jsx(TruncatedFaroText, { variant: "bodyM", dark: dark, 
                        // This is set so that the ellipse has the same color of the text
                        containerSx: { color: inputColor }, sx: {
                            // Change color opacity if the component is disabled
                            opacity: disabled ? 0.5 : 1,
                        }, children: inputText }), isEditable && (jsxs(Stack$1, { direction: "row", gap: 1, children: [jsx(FaroIconButton, { onClick: (ev) => {
                                    ev.stopPropagation();
                                    setIsEditing(true);
                                }, size: "s", color: inputColor, hoverColor: getIconButtonHoverColor(dark), margin: 0.5, disabled: disabled, children: jsx(EditIcon, {}) }), jsx(FaroIconButton, { onClick: (ev) => {
                                    ev.stopPropagation();
                                    onDeleteButtonClick?.();
                                }, size: "s", color: inputColor, hoverColor: getIconButtonHoverColor(dark), margin: 0.5, disabled: disabled, children: jsx(DeleteIcon, {}) })] }))] }), errorMessage !== undefined && (jsx(FormHelperTextVariant, { sx: {
                    // The margin is used to achieve the same style as the error shown in the TextField component
                    mt: "4px",
                    fontWeight: 600,
                }, children: errorMessage }))] }));
}
function ActionTextFieldEdit({ inputText, dark, fullWidth, isEditable, sx, validate, setIsEditing, onConfirmButtonClick, onCancelButtonClick, }) {
    const [text, setText] = useState(inputText);
    const iconColor = useMemo(() => (dark ? neutral[100] : neutral[800]), [dark]);
    // Validate the text when it changes
    const errorMessage = useMemo(() => validate?.(text), [validate, text]);
    return (jsx(Stack$1, { direction: "row", alignItems: "center", sx: {
            width: fullWidth ? "100%" : "fit-content",
            ...sx,
        }, onClick: (ev) => {
            // Prevent the click event from propagating to the parent when the user clicks on the text field in the editing state
            ev.stopPropagation();
        }, children: jsx(TextField, { fullWidth: fullWidth, variant: "underlined", text: text, autoFocus: true, dark: dark, onTextChanged: setText, error: errorMessage, sx: { ".MuiInputBase-input": { p: 0 }, px: 1.5, py: 0.5 }, endAdornment: isEditable && (jsxs(Stack$1, { direction: "row", gap: 1, ml: 2, children: [jsx(FaroIconButton, { size: "s", color: iconColor, hoverColor: getIconButtonHoverColor(dark), margin: 0.5, disabled: errorMessage !== undefined, onClick: (ev) => {
                            ev.stopPropagation();
                            onConfirmButtonClick?.(text);
                            setIsEditing(false);
                        }, children: jsx(Checkmark3Icon, {}) }), jsx(FaroIconButton, { onClick: (ev) => {
                            ev.stopPropagation();
                            onCancelButtonClick?.();
                            setIsEditing(false);
                        }, size: "s", color: iconColor, hoverColor: getIconButtonHoverColor(dark), margin: 0.5, children: jsx(CloseCancelErrorIcon, {}) })] })) }) }));
}
/**
 * @param dark - if true the dark colors are used
 * @returns the hover color for the icon button
 */
function getIconButtonHoverColor(dark) {
    return dark ? cyan$1[400] : "primary.main";
}

function _extends$3() { return _extends$3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3.apply(null, arguments); }
const SvgLoadingScreen = props => /*#__PURE__*/React.createElement("svg", _extends$3({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 158.7 206"
}, props), /*#__PURE__*/React.createElement("g", {
  className: "loading-screen_svg__Group1"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__a",
  x1: -1436.857,
  x2: -1472.453,
  y1: 24.188,
  y2: 24.188,
  gradientTransform: "matrix(4.1854 0 0 26.9455 6169.124 -544.188)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 106.2c.1 6.8 1 13.3 2 14.6s1.6-2.4 1.7-3.6c1-7.6 0-20.8-1.6-22.8C.9 92.8-.1 98.3 0 106.2",
  style: {
    fill: "url(#loading-screen_svg__a)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__b",
  x1: -1666.677,
  x2: -1676.996,
  y1: 21.907,
  y2: 21.907,
  gradientTransform: "matrix(14.4396 0 0 29.8168 24221.543 -545.496)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.6 106.3c-.1 3.3.4 6.6 1.4 9.7 2.1 6 7.2 10.2 11.2 2.4 3.5-8.4 1.6-19.7-2.2-23.8-4.7-5-10.1 1.1-10.4 11.7",
  style: {
    fill: "url(#loading-screen_svg__b)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__c",
  x1: -1625.487,
  x2: -1640.322,
  y1: 23.981,
  y2: 23.981,
  gradientTransform: "matrix(10.044 0 0 27.1816 16481.773 -564.891)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M10.4 96.5c3.3-6.9 4.3-18.7 1.9-22.2-2.2-3.3-6.3 2.3-8 11-1 5-1 10.1 0 12.9.2.6 2.2 5.8 6.1-1.7",
  style: {
    fill: "url(#loading-screen_svg__c)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__d",
  x1: -1632.62,
  x2: -1646.67,
  y1: 24.333,
  y2: 24.333,
  gradientTransform: "matrix(10.6021 0 0 26.7817 17464.49 -523.459)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M14.8 137.9c.8-8.2-3-19.8-6.4-22.5-3.3-2.6-5 3.2-3.5 11.7.9 4.8 2.7 9.7 4.7 12.3.6 1 4 5.2 5.2-1.5",
  style: {
    fill: "url(#loading-screen_svg__d)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__e",
  x1: -1625.906,
  x2: -1640.714,
  y1: 29.512,
  y2: 29.512,
  gradientTransform: "matrix(10.0603 0 0 21.9977 16512.41 -501.823)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M6.1 136.4c-1.3-.6-.2 4 2.3 10.2 2.7 6.4 5.6 11.2 6.7 11.7.9.4.3-1.9.1-2.9-2.1-7.3-7.3-18.1-9.1-19",
  style: {
    fill: "url(#loading-screen_svg__e)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__f",
  x1: -1611.229,
  x2: -1627.644,
  y1: 28.836,
  y2: 28.836,
  gradientTransform: "matrix(9.0753 0 0 22.5235 14777.684 -582.203)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M7 75.2c3.7-7.3 6.7-17.5 6-18.9-.6-1.2-3.3 3.3-5.8 9.6-2.2 5.7-3.5 11.3-3 12.4s2.3-2.1 2.8-3.1",
  style: {
    fill: "url(#loading-screen_svg__f)"
  }
})), /*#__PURE__*/React.createElement("g", {
  className: "loading-screen_svg__Group2"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__g",
  x1: -1683.688,
  x2: -1692.185,
  y1: 23.883,
  y2: 23.883,
  gradientTransform: "matrix(17.529 0 0 27.2971 29668.674 -564.687)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M19.7 92.1c.9 7.6 7.1 12.9 13.7 4.6 5.2-7.9 4.1-16.6 1.6-20.3-4.4-6.5-13-1.3-15 9.2-.4 2.1-.5 4.3-.3 6.5",
  style: {
    fill: "url(#loading-screen_svg__g)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__h",
  x1: -1684.478,
  x2: -1692.893,
  y1: 24.241,
  y2: 24.241,
  gradientTransform: "matrix(17.703 0 0 26.885 29975.604 -523.633)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M21.4 131c2.6 8.4 10.9 15 15.5 6.8 3.2-7.6-.2-17.6-5.4-21.4-6.3-4.7-12.1 1-10.9 10.8.1 1.2.4 2.5.8 3.8",
  style: {
    fill: "url(#loading-screen_svg__h)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__i",
  x1: -1693.592,
  x2: -1701.049,
  y1: 24.12,
  y2: 24.12,
  gradientTransform: "matrix(19.9769 0 0 27.0209 33988.012 -544.12)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M31.5 106.5c0 .9 0 1.8.1 2.6 1 10.2 10.5 16.5 17.1 8.2 4.1-5.7 3.6-15.1-1.1-20.1-6.4-6.9-15.5-1.6-16.1 9.3",
  style: {
    fill: "url(#loading-screen_svg__i)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__j",
  x1: -1666.41,
  x2: -1676.785,
  y1: 26.863,
  y2: 26.863,
  gradientTransform: "matrix(14.3376 0 0 24.2086 24047.467 -582.86)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M23.1 75.9c5.3-7.1 6.1-15.4 4.7-18.6-2.1-4.8-8.7 0-12.1 8.7-1.2 2.8-1.8 5.9-1.6 8.9.4 4.2 3.5 7.5 9 1",
  style: {
    fill: "url(#loading-screen_svg__j)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__k",
  x1: -1670.165,
  x2: -1680.147,
  y1: 27.454,
  y2: 27.454,
  gradientTransform: "matrix(14.9239 0 0 23.6788 25080.69 -502.64)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M30.5 156c.9-6.4-4.5-17.3-9.7-19.9-4.6-2.2-6.6 3-3.9 10.6.8 2.3 1.9 4.5 3.3 6.5 3.5 5.3 9 9.1 10.3 2.8",
  style: {
    fill: "url(#loading-screen_svg__k)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__l",
  x1: -1662.886,
  x2: -1673.693,
  y1: 34.057,
  y2: 34.057,
  gradientTransform: "matrix(13.7847 0 0 19.0185 23077.744 -482.87)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M29.1 174c2.5 1.4 1.8-1.3 1.6-2.2-1.6-5.4-8.8-15.6-12.2-16.4-2.3-.5-1.5 3.6 1.8 8.9 3 4.8 6.8 8.6 8.8 9.7",
  style: {
    fill: "url(#loading-screen_svg__l)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__m",
  x1: -1656.953,
  x2: -1668.401,
  y1: 32.938,
  y2: 32.938,
  gradientTransform: "matrix(13.0116 0 0 19.6736 21714.883 -598.531)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M14.9 58.1c.1.8.7 3 5.1-1.8 5.2-6.2 8.3-13.9 7.8-16-.6-2.3-5.4 1.8-9.2 7.9-2.8 4.6-3.9 8.3-3.7 9.9",
  style: {
    fill: "url(#loading-screen_svg__m)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__n",
  x1: -1657.906,
  x2: -1669.31,
  y1: 44.11,
  y2: 44.11,
  gradientTransform: "matrix(13.0632 0 0 14.6334 21812.842 -612.05)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M24.9 38.5C28.1 35.2 35.1 27 35 26.1c-.5-.3-4.1 3.1-7 6.2-3.1 3.4-6.2 7.5-6 8.3.4.3 1.4-.6 2.9-2.1",
  style: {
    fill: "url(#loading-screen_svg__n)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__o",
  x1: -1663.365,
  x2: -1674.183,
  y1: 46.227,
  y2: 46.227,
  gradientTransform: "matrix(13.7702 0 0 13.9562 23060.152 -465.04)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M25.2 173.1c-.2.6 2.5 3.9 5.1 6.6 3.9 4.1 8.1 7.5 8.6 7.4 0-.2-.3-.6-1.2-1.8-2.2-2.6-11.4-12.5-12.5-12.2",
  style: {
    fill: "url(#loading-screen_svg__o)"
  }
})), /*#__PURE__*/React.createElement("g", {
  className: "loading-screen_svg__Group3"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__p",
  x1: -1687.055,
  x2: -1695.279,
  y1: 28.848,
  y2: 28.848,
  gradientTransform: "matrix(18.1123 0 0 22.5144 30711.787 -581.893)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M37 66.2c-.5 1.4-.7 2.9-.8 4.3-.2 7.7 6.7 11.6 13.7 4.8 4.2-4.4 5.7-11.6 3.2-16-3.5-6.2-13-2.2-16.1 6.9",
  style: {
    fill: "url(#loading-screen_svg__p)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__q",
  x1: -1687.159,
  x2: -1695.382,
  y1: 29.381,
  y2: 29.381,
  gradientTransform: "matrix(18.1173 0 0 22.0988 30722.082 -501.94)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M55 155.3c2.9-6.3-1.1-14.5-6.5-17.7-6.6-3.8-12.2 1.1-10.3 9 1.9 8.4 12 16.4 16.8 8.7",
  style: {
    fill: "url(#loading-screen_svg__q)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__r",
  x1: -1695.155,
  x2: -1702.53,
  y1: 27.448,
  y2: 27.448,
  gradientTransform: "matrix(20.1995 0 0 23.6853 34396.594 -563.08)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M65.1 95.3c5.3-6.4 3.5-12.9 1.7-15.8-5.2-8-16.4-4.1-18.2 6.3-.1.8-.2 1.5-.2 2.2 0 9.4 9.1 14.9 16.7 7.3",
  style: {
    fill: "url(#loading-screen_svg__r)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__s",
  x1: -1674.842,
  x2: -1684.408,
  y1: 32.85,
  y2: 32.85,
  gradientTransform: "matrix(15.5717 0 0 19.7278 26235.46 -598.556)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M32.5 48.3c-1.2 2-1.9 4.2-2 6.5-.1 4.3 3.4 7 9.6 1.6 4.3-4.1 7-11 5.7-14.6-1.9-5-9.5-.4-13.3 6.5",
  style: {
    fill: "url(#loading-screen_svg__s)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__t",
  x1: -1695.088,
  x2: -1702.476,
  y1: 28.022,
  y2: 28.022,
  gradientTransform: "matrix(20.1675 0 0 23.1894 34341.031 -521.684)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M67 136.4c4.7-6.8 1.1-14.1-2.3-17.1-6.8-6.1-16-1.4-15.6 7.9.4 8.9 10.7 17.4 17.9 9.2",
  style: {
    fill: "url(#loading-screen_svg__t)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__u",
  x1: -1676.568,
  x2: -1685.956,
  y1: 34.012,
  y2: 34.012,
  gradientTransform: "matrix(15.8668 0 0 19.0439 26757.117 -482.828)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M35.2 166.1c3.6 5.7 12 11.9 13.4 5.6.6-6.2-5.3-14.1-10.4-16-5-1.9-7 2.4-4 8.5.3.7.7 1.4 1 1.9",
  style: {
    fill: "url(#loading-screen_svg__u)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__v",
  x1: -1696.793,
  x2: -1704.076,
  y1: 29.092,
  y2: 29.092,
  gradientTransform: "matrix(20.4434 0 0 22.3211 34843.5 -541.805)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M83.6 115.5c4-4.5 3.9-11.3-.2-15.8-6.3-6.7-16.7-2.6-17.3 6.9v1.1c.2 9.1 10.1 15 17.5 7.8",
  style: {
    fill: "url(#loading-screen_svg__v)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__w",
  x1: -1670.551,
  x2: -1680.632,
  y1: 43.327,
  y2: 43.327,
  gradientTransform: "matrix(14.7769 0 0 14.9013 24840.86 -465.454)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M49.1 185.6c-2.1-5.3-10-12.9-13.3-12.9-2.2 0-1.4 3.3 1.8 7.1 2.4 2.8 5.2 5.2 8.4 7 2.7 1.4 3.7 1 3.1-1.2",
  style: {
    fill: "url(#loading-screen_svg__w)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__x",
  x1: -1666.994,
  x2: -1677.451,
  y1: 41.336,
  y2: 41.336,
  gradientTransform: "matrix(14.2439 0 0 15.6269 23899.81 -612.385)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M37.3 38.9c4.7-4 8.5-10.2 8.2-12.4-.4-2.6-6.3 1.3-10.3 5.9-2.2 2.6-3.7 5.2-3.9 7-.2 2 1.2 3.4 6-.5",
  style: {
    fill: "url(#loading-screen_svg__x)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__y",
  x1: -1668.161,
  x2: -1678.58,
  y1: 62.745,
  y2: 62.745,
  gradientTransform: "matrix(14.301 0 0 10.2512 24011.676 -450.295)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M56 196.7c-3.7-3.4-11.3-8.9-13-8.9-1 0 .7 2.1 4.4 4.9 4.1 3.1 9.2 5.7 9.6 5.3 0-.3-.2-.5-1-1.3",
  style: {
    fill: "url(#loading-screen_svg__y)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__z",
  x1: -1664.228,
  x2: -1675.06,
  y1: 58.376,
  y2: 58.376,
  gradientTransform: "matrix(13.753 0 0 11.0256 23043.486 -623.647)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M42.4 23.7c4.5-3.2 9.9-8.2 10.1-9.1s-4.3 1.5-8 4.5c-3.4 2.7-5.5 5-5.7 5.9-.2.6.1 1.1 3.6-1.3",
  style: {
    fill: "url(#loading-screen_svg__z)"
  }
})), /*#__PURE__*/React.createElement("g", {
  className: "loading-screen_svg__Group4"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__A",
  x1: -1679.726,
  x2: -1688.921,
  y1: 36.928,
  y2: 36.928,
  gradientTransform: "matrix(16.1986 0 0 17.5183 27364.537 -597.4)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M57.3 48.4c-.5 1.1-.7 2.2-.8 3.3-.4 6.6 6.6 8.8 12.1 3.9C73.4 50.9 73 46 72 43.9c-3-6.2-11.8-2.5-14.7 4.5",
  style: {
    fill: "url(#loading-screen_svg__A)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__B",
  x1: -1678.834,
  x2: -1688.149,
  y1: 38.283,
  y2: 38.283,
  gradientTransform: "matrix(15.9946 0 0 16.8912 27007.644 -481.917)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M73.6 170.8c2.4-4.6-.6-10.5-4.9-13.1-6.1-3.7-11.7 0-9.9 6.5 1.9 6.4 10.8 12.4 14.8 6.6",
  style: {
    fill: "url(#loading-screen_svg__B)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__C",
  x1: -1666.549,
  x2: -1677.212,
  y1: 43.871,
  y2: 43.871,
  gradientTransform: "matrix(13.9705 0 0 14.714 23437.879 -612.003)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M59.1 38.6c4.7-4 5.7-8.4 5.2-10.4-1-4.4-8.2-1.1-11.9 4.3-.9 1.2-1.6 2.7-1.9 4.2-.7 4.2 3.1 5.9 8.6 1.9",
  style: {
    fill: "url(#loading-screen_svg__C)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__D",
  x1: -1667.204,
  x2: -1677.814,
  y1: 45.94,
  y2: 45.94,
  gradientTransform: "matrix(14.0374 0 0 14.0432 23558.502 -464.933)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M67.4 185.3c.5-4.4-4.8-10.9-9.8-12-4-.9-5.5 2.2-3 6.5 3.2 5.3 11.5 10.3 12.8 5.5",
  style: {
    fill: "url(#loading-screen_svg__D)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__E",
  x1: -1688.014,
  x2: -1696.344,
  y1: 35.411,
  y2: 35.411,
  gradientTransform: "matrix(17.8822 0 0 18.2812 30340.693 -500.075)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M86 153.9c3.8-4.9 1.3-10.4-1.3-12.9-6-5.7-15.2-2.2-14.6 5.6.6 7.7 10 13.3 15.9 7.3",
  style: {
    fill: "url(#loading-screen_svg__E)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__F",
  x1: -1688.834,
  x2: -1697.061,
  y1: 34.54,
  y2: 34.54,
  gradientTransform: "matrix(18.1059 0 0 18.7483 30733.135 -580.2)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M85.9 62c-4-7-14.8-4.2-16.7 4.3-.1.6-.2 1.2-.2 1.8-.3 7.4 7.9 11.9 14.9 5.8 5.3-5.7 2.4-11.3 2-11.9",
  style: {
    fill: "url(#loading-screen_svg__F)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__G",
  x1: -1690.703,
  x2: -1698.829,
  y1: 35.632,
  y2: 35.632,
  gradientTransform: "matrix(18.3277 0 0 18.1649 31141.965 -519.237)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M87.5 127.3c-.3 5.1 3.7 9.5 8.8 9.7 2.6.1 5.1-.8 6.9-2.6 3.3-3.3 3.5-8.5.5-12.1-5.5-6.4-15.8-3.3-16.2 5",
  style: {
    fill: "url(#loading-screen_svg__G)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__H",
  x1: -1691.296,
  x2: -1699.352,
  y1: 34.942,
  y2: 34.942,
  gradientTransform: "matrix(18.4938 0 0 18.5304 31433.85 -560.664)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M102.7 93.2c4.5-4.9 2.6-10.1.7-12.3-3.2-4-9.1-4.5-13.1-1.3-1.9 1.5-3.1 3.7-3.3 6.1 0 .3-.1.6-.1.9-.1 7.1 8.5 13.3 15.8 6.6",
  style: {
    fill: "url(#loading-screen_svg__H)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__I",
  x1: -1660.117,
  x2: -1671.558,
  y1: 62.574,
  y2: 62.574,
  gradientTransform: "matrix(13.0213 0 0 10.2796 21772.188 -450.27)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M67.9 196.7c-1.9-3.7-8.7-8.9-11.7-8.9-2 0-1.3 2.3 1.5 4.9 2 1.9 4.4 3.4 6.9 4.6 2 .9 4.1 1.5 3.3-.6",
  style: {
    fill: "url(#loading-screen_svg__I)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__J",
  x1: -1657.218,
  x2: -1668.957,
  y1: 58.354,
  y2: 58.354,
  gradientTransform: "matrix(12.6897 0 0 11.0293 21184.902 -623.576)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M56.7 23.8c4.9-3.4 7.2-7.3 7.2-8.4.1-2.2-5.4.4-9.2 3.9-1.5 1.2-2.7 2.8-3.4 4.6-.5 1.6.9 2.8 5.4-.1",
  style: {
    fill: "url(#loading-screen_svg__J)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__K",
  x1: -1651.989,
  x2: -1664.401,
  y1: 91.911,
  y2: 91.911,
  gradientTransform: "matrix(12.002 0 0 6.9803 19982.459 -632.34)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M62.3 11.6c2.9-1.5 8.7-5.2 8.7-5.8-.4-.3-4.1 1.2-7.1 2.9s-4.7 3.2-4.9 3.8c-.2.3.2.6 3.3-.9",
  style: {
    fill: "url(#loading-screen_svg__K)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__L",
  x1: -1655.709,
  x2: -1667.733,
  y1: 102.365,
  y2: 102.365,
  gradientTransform: "matrix(12.3872 0 0 6.2642 20664.902 -438.382)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M75 205.2c-2.4-1.6-10.2-5.8-11.4-5.4-.6.2.9 1.5 3.9 3.1 3.3 1.8 7.5 3.3 8.3 3.2v-.1c-.1-.4-.4-.6-.8-.8",
  style: {
    fill: "url(#loading-screen_svg__L)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__M",
  x1: -1681.379,
  x2: -1690.769,
  y1: 40.379,
  y2: 40.379,
  gradientTransform: "matrix(15.8677 0 0 16.0022 26834.916 -538.724)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M109.2 106.7c-.4 4.4 2.8 8.2 7.2 8.6 2.4.2 4.7-.6 6.4-2.3 2.8-2.9 3.1-7.5.5-10.7-2.8-3.4-7.8-3.9-11.2-1.2-1.7 1.5-2.8 3.5-2.9 5.6",
  style: {
    fill: "url(#loading-screen_svg__M)"
  }
})), /*#__PURE__*/React.createElement("g", {
  className: "loading-screen_svg__Group5"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__N",
  x1: -1655.505,
  x2: -1667.684,
  y1: 52.981,
  y2: 52.981,
  gradientTransform: "matrix(12.2291 0 0 12.1595 20400.639 -610.777)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M78 32.7c-.2.6-.4 1.2-.5 1.8-.6 4.9 5.1 6.9 9.5 3.2 3.8-3.5 2.6-7 2.3-7.6-2-4.7-9-3-11.3 2.6",
  style: {
    fill: "url(#loading-screen_svg__N)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__O",
  x1: -1652.965,
  x2: -1665.465,
  y1: 55.712,
  y2: 55.712,
  gradientTransform: "matrix(11.9171 0 0 11.5574 19853.84 -463.831)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M87.6 175.2c-4.2-2.3-9-.3-7.7 4.5 1.2 4.4 7.6 8.4 10.9 4.5 2-3.1 0-7.2-3.2-9",
  style: {
    fill: "url(#loading-screen_svg__O)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__P",
  x1: -1667.286,
  x2: -1678.21,
  y1: 49.452,
  y2: 49.452,
  gradientTransform: "matrix(13.6345 0 0 13.0362 22887.889 -479.956)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M91.8 164.3c.2 5.5 7.1 9.4 11.8 5.1 2.4-2.5 2.4-6.5-.1-9-.1-.1-.2-.2-.3-.2-4.1-3.8-11.7-2-11.4 4.1",
  style: {
    fill: "url(#loading-screen_svg__P)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__Q",
  x1: -1669.755,
  x2: -1680.371,
  y1: 47.736,
  y2: 47.736,
  gradientTransform: "matrix(14.023 0 0 13.5097 23570.234 -595.609)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M90.6 48.5c0 .2-.1.5-.1.7-.6 5.7 6.2 9.5 11.8 4.8 2.5-2.2 2.9-5.9 1.1-8.6-3.5-5-11.6-3-12.8 3.1",
  style: {
    fill: "url(#loading-screen_svg__Q)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__R",
  x1: -1633.667,
  x2: -1648.368,
  y1: 71.618,
  y2: 71.618,
  gradientTransform: "matrix(10.1341 0 0 8.9727 16711.102 -449.626)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M84.4 196.3c.6-2.5-3-7-6.9-7.7-2.7-.5-4.2 1.2-2.2 4.2 2.2 3.3 8.1 6.5 9.1 3.5",
  style: {
    fill: "url(#loading-screen_svg__R)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__S",
  x1: -1634.054,
  x2: -1648.672,
  y1: 66.843,
  y2: 66.843,
  gradientTransform: "matrix(10.1909 0 0 9.6183 16807.81 -623.048)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M77.6 23.1c4.1-3.2 3.7-6.3 3.7-6.4-.5-3.3-5.9-1.3-8.8 2.5-.7.8-1.1 1.8-1.3 2.8-.6 3 3 3.6 6.4 1.1",
  style: {
    fill: "url(#loading-screen_svg__S)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__T",
  x1: -1667.355,
  x2: -1678.425,
  y1: 49.942,
  y2: 49.942,
  gradientTransform: "matrix(13.448 0 0 12.9063 22577.894 -497.388)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M109.9 146.7c-.6 5.4 6.1 9.4 11.2 5.1 2.5-2.2 2.9-5.9.9-8.6-3.6-4.6-11.5-2.3-12.1 3.5",
  style: {
    fill: "url(#loading-screen_svg__T)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__U",
  x1: -1669.158,
  x2: -1680.004,
  y1: 48.839,
  y2: 48.839,
  gradientTransform: "matrix(13.7212 0 0 13.2012 23058.086 -577.726)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M121.4 71.7a6.5 6.5 0 0 0-.1-8.9c-4.1-4.4-11.4-2.2-11.9 3.6-.5 5.6 6.9 9.9 12 5.3",
  style: {
    fill: "url(#loading-screen_svg__U)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__V",
  x1: -1621.215,
  x2: -1637.387,
  y1: 111.156,
  y2: 111.156,
  gradientTransform: "matrix(9.21 0 0 5.7662 15086.705 -438.063)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M76.6 200c-1.1.2-.5 1.4 1.5 2.8 1.7 1.2 3.6 2.1 5.7 2.8 2 .6 1.5-.3 1.4-.6-1.7-2.1-6.7-5.3-8.6-5",
  style: {
    fill: "url(#loading-screen_svg__V)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__W",
  x1: -1617.597,
  x2: -1634.141,
  y1: 100.132,
  y2: 100.132,
  gradientTransform: "matrix(9.0047 0 0 6.4045 14721.258 -632.12)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M75.7 11.3c3.2-1.9 5.1-4.2 5.2-4.9.1-1.3-3.7.3-6.4 2.2-1.1.7-1.9 1.6-2.5 2.7-.4 1.1.7 1.7 3.7 0",
  style: {
    fill: "url(#loading-screen_svg__W)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__X",
  x1: -1641.292,
  x2: -1655.74,
  y1: 59.689,
  y2: 59.689,
  gradientTransform: "matrix(10.3023 0 0 10.7806 17064.37 -515.557)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M131.7 127.5v.5c-.2 4.4 4.7 7.2 8.6 3.7 2-1.9 2.3-4.9.8-7.2-2.7-3.8-8.7-1.8-9.4 3",
  style: {
    fill: "url(#loading-screen_svg__X)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__Y",
  x1: -1642.449,
  x2: -1656.763,
  y1: 58.648,
  y2: 58.648,
  gradientTransform: "matrix(10.4044 0 0 10.9738 17243.969 -557.093)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M131.6 85.9v.5c.2 4.6 5.5 7.6 9.1 3.9 1.9-2.3 1.7-5.6-.4-7.7-1.9-2-5.1-2.2-7.1-.3-1 1-1.5 2.3-1.6 3.6",
  style: {
    fill: "url(#loading-screen_svg__Y)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__Z",
  x1: -1600.442,
  x2: -1619.107,
  y1: 206.851,
  y2: 206.851,
  gradientTransform: "matrix(7.9839 0 0 3.092 12933.151 -638.04)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M82 2.6c2-.8 4-1.6 5.9-2.6v-.1c-1.5.3-3.1.7-4.5 1.3-2 .8-3.5 1.5-3.5 1.8.8.1 1.5-.1 2.1-.4",
  style: {
    fill: "url(#loading-screen_svg__Z)"
  }
})), /*#__PURE__*/React.createElement("g", {
  className: "loading-screen_svg__Group6"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__aa",
  x1: -1576.969,
  x2: -1598.674,
  y1: 98.969,
  y2: 98.969,
  gradientTransform: "matrix(6.8675 0 0 6.4798 10985.18 -621.536)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M102.2 22c1.2-1 1.6-2.7.8-4.1-1.6-2.6-5.5-1.3-6.3 1.4-.1.2-.1.4-.1.6-.4 2.6 2.9 4.2 5.6 2.1",
  style: {
    fill: "url(#loading-screen_svg__aa)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__ab",
  x1: -1565.601,
  x2: -1588.61,
  y1: 104.815,
  y2: 104.815,
  gradientTransform: "matrix(6.4533 0 0 6.1168 10258.44 -448.247)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M103.6 190.6c-2.3-1.6-5.3-.4-4.9 2.2.3 2.3 3.6 4.4 5.7 2.4 1.1-1.3.9-3.2-.4-4.3-.2-.2-.3-.3-.4-.3",
  style: {
    fill: "url(#loading-screen_svg__ab)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__ac",
  x1: -1511.005,
  x2: -1540.372,
  y1: 139.655,
  y2: 139.655,
  gradientTransform: "matrix(5.0725 0 0 4.585 7819.902 -631.303)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M93.1 10.6c1.8-1.4 1.7-2.7 1.7-2.9-.2-1.8-3.1-.9-4.5 1-.2.3-.4.7-.5 1.1-.3 1.4 1.3 2.1 3.3.8",
  style: {
    fill: "url(#loading-screen_svg__ac)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__ad",
  x1: -1594.279,
  x2: -1614.144,
  y1: 90.64,
  y2: 90.64,
  gradientTransform: "matrix(7.4965 0 0 7.0788 12106.85 -461.578)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M111.3 179.8c-.3 2.7 2.9 5.3 6.1 2.8 1.5-1.1 1.8-3.2.8-4.7-1.9-2.6-6.5-1.3-6.9 1.9",
  style: {
    fill: "url(#loading-screen_svg__ad)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__ae",
  x1: -1601.293,
  x2: -1620.253,
  y1: 86.791,
  y2: 86.791,
  gradientTransform: "matrix(7.8341 0 0 7.3946 12699.84 -608.65)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M117.3 35.7c1.2-1.3 1.1-3.3 0-4.7-2.3-2.8-6.7-1.8-6.9 1.7-.3 3.2 4.2 5.6 6.9 3",
  style: {
    fill: "url(#loading-screen_svg__ae)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__af",
  x1: -1503.215,
  x2: -1533.58,
  y1: 154.165,
  y2: 154.165,
  gradientTransform: "matrix(4.9059 0 0 4.1522 7529.925 -437.2)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M94.6 200.9c-1.5-.2-2.1.7-1.2 1.9 1 1.6 3.9 3 4.5 1.6.3-1.1-1.4-3.2-3.3-3.5",
  style: {
    fill: "url(#loading-screen_svg__af)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__ag",
  x1: -1572.434,
  x2: -1595.265,
  y1: 98.39,
  y2: 98.39,
  gradientTransform: "matrix(6.5243 0 0 6.5181 10414.321 -476.666)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M129.7 164.4c0 .1-.1.2-.1.3-.4 2.7 2.3 4.4 5 2.3 1.9-1.7 1.5-3.6 1.1-4.4-1.2-2.1-5.3-1.4-6 1.8",
  style: {
    fill: "url(#loading-screen_svg__ag)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__ah",
  x1: -1578.632,
  x2: -1600.704,
  y1: 95.033,
  y2: 95.033,
  gradientTransform: "matrix(6.7485 0 0 6.7498 10808.74 -592.531)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M135.6 51.3c1-1.3.6-3.5-.9-4.8-2.3-2-5.4-.7-5.2 2.1.1 2.9 3.9 5 6.1 2.7",
  style: {
    fill: "url(#loading-screen_svg__ah)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__ai",
  x1: -1443.453,
  x2: -1480.818,
  y1: 281.091,
  y2: 281.091,
  gradientTransform: "matrix(3.9866 0 0 2.2738 5909.808 -637.665)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M92 2.3c.9-.4 1.8-1 2.4-1.8.2-.5-1.5.1-2.7.8-.5.2-.9.6-1.2 1-.2.3.3.5 1.5 0",
  style: {
    fill: "url(#loading-screen_svg__ai)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loading-screen_svg__aj",
  x1: -1526.302,
  x2: -1555.338,
  y1: 105.319,
  y2: 105.319,
  gradientTransform: "matrix(5.1315 0 0 6.0871 7987.516 -533.816)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  style: {
    stopColor: "#01426a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.647,
  style: {
    stopColor: "#3455db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  style: {
    stopColor: "#2c60db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.874,
  style: {
    stopColor: "#177ddd"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#009cde"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M158.1 105.2c-1.5-1.9-4.2-.8-4.5 1.8v.6c.2 2.6 2.8 3.7 4.4 1.9.9-1.3 1-3 .1-4.3",
  style: {
    fill: "url(#loading-screen_svg__aj)"
  }
})));

/** @returns a looping loading animation for FARO applications */
function LoadingScreen() {
    return (jsx(Stack, { sx: { width: "100%", height: "100%", overflow: "hidden" }, alignItems: "center", justifyContent: "center", children: jsx(Box, { component: "div", sx: {
                minWidth: "200px",
                svg: {
                    width: "100%",
                    height: "100%",
                },
                // the svgo importer renames classes/ids of svg file
                // the only safe way to identify the group of circles is to use the g element selector
                "g:nth-of-type(1)": {
                    ...generateGroupAnimation(1),
                },
                "g:nth-of-type(2)": {
                    ...generateGroupAnimation(2),
                },
                "g:nth-of-type(3)": {
                    ...generateGroupAnimation(3),
                },
                "g:nth-of-type(4)": {
                    ...generateGroupAnimation(4),
                },
                "g:nth-of-type(5)": {
                    ...generateGroupAnimation(5),
                },
                "g:nth-of-type(6)": {
                    ...generateGroupAnimation(6),
                },
            }, children: jsx(SvgLoadingScreen, {}) }) }));
}
/**
 * @param groupId id of the group of points inside the logo svg
 * @returns the CSS style to animate that group of points
 *
 * The animation is done by group of points, but all the animations share the same duration.
 * What changes between one group of point and the other is how fast they reach the final opacity value
 *
 * When all of them reach the final value then they animate back fast to the start value and the animation restarts
 */
function generateGroupAnimation(groupId) {
    // Initial opacity value
    const startOpacity = 0.3;
    // Final opacity value
    const finalOpacity = 1;
    // At what percentage of the full animation the opacity of this group should reach the final value
    const fadeInEndPercentage = (90 / 6) * groupId;
    return {
        // A keyframe for the animation of this specific group of points
        [`@keyframes loop${groupId}`]: {
            // All the points starts at the start value
            "0%": {
                opacity: startOpacity,
            },
            // Each group reach the final opacity value at a different animation percentage
            [`${fadeInEndPercentage}%`]: {
                opacity: finalOpacity,
            },
            // Then all the groups remain stable until 90% of the full animation
            "90%": {
                opacity: finalOpacity,
            },
            // Then the're animated back to the start opacity value before the animation restarts
            "100%": {
                opacity: startOpacity,
            },
        },
        animationName: `loop${groupId}`,
        // Full animation duration
        animationDuration: "4.5s",
        // The animation is an infinite loop
        animationIterationCount: "infinite",
        // At the end of the animation restart from the beginning
        animationDirection: "forward",
        // Easing curve to start slow and end fast computed by trial and error with the designers
        animationTimingFunction: "cubic-bezier(1,-0.01,.67,1.01)",
    };
}

/**
 * The PasswordValidationCheckerItem component is used to display the status of an individual password validation rule.
 * It consists of an icon and a text description that visually represents whether a specific password requirement has been met or not.
 */
const PasswordValidationCheckerItem = memo(({ text, isError }) => (jsxs(Stack, { flexDirection: "row", alignItems: "center", gap: "0.75rem", children: [jsx(CheckmarkCircleFillIcon, { "data-testid": "password-validation-icon", sx: {
                fontSize: "1.125rem",
                color: isError ? neutral[300] : green[700],
            } }), jsx(FaroText, { variant: "bodyS", children: text })] })));
PasswordValidationCheckerItem.displayName = "PasswordValidationCheckerItem";

/**
 * Returns true if a sub-string from a given string has a valid email format
 *
 * @param password string to evaluate
 * @returns boolean True if there is a email in the password
 */
function passwordContainsEmail(password) {
    const textLength = password.length;
    return range(textLength)
        .flatMap((i) => range(i + 1, textLength + 1).map((j) => password.substring(i, j)))
        .some(mayBeEmail);
}

const MIN_PASSWORD_LENGTH = 14;
const passwordRules = [
    { text: "14 characters minimum", errorKey: "isMinCharLengthError" },
    { text: "1 uppercase character", errorKey: "isUppercaseLetterError" },
    { text: "1 lowercase character", errorKey: "isLowercaseLetterError" },
    { text: "1 number", errorKey: "isNumberError" },
    { text: "1 special character (!@#%$&)", errorKey: "isSpecialCharError" },
    {
        text: "No leading or trailing white spaces",
        errorKey: "isLeadingOrTrailingSpaceError",
    },
    { text: "Must not contain email address", errorKey: "isContainsEmailError" },
];
/**
 * The PasswordValidationChecker component is responsible for displaying password validation rules
 * and their status based on the provided password. It dynamically updates to reflect whether
 * the current password meets specific security criteria.
 *
 * @returns JSX.Element The rendered password validation component.
 */
function PasswordValidationChecker({ password, onValidationChange, }) {
    const [errors, setErrors] = useState({
        isMinCharLengthError: false,
        isUppercaseLetterError: false,
        isLowercaseLetterError: false,
        isNumberError: false,
        isSpecialCharError: false,
        isLeadingOrTrailingSpaceError: false,
        isContainsEmailError: false,
    });
    useEffect(() => {
        setErrors({
            isMinCharLengthError: password.length < MIN_PASSWORD_LENGTH,
            isUppercaseLetterError: !/[A-Z]/.test(password),
            isLowercaseLetterError: !/[a-z]/.test(password),
            isNumberError: !/[0-9]/.test(password),
            isSpecialCharError: !/[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/.test(password),
            isLeadingOrTrailingSpaceError: password.startsWith(" ") || password.endsWith(" "),
            isContainsEmailError: passwordContainsEmail(password),
        });
    }, [password]);
    // Check if all errors are false
    const allErrorsResolved = useMemo(() => Object.values(errors).every((error) => !error), [errors]);
    useEffect(() => {
        if (onValidationChange) {
            onValidationChange(allErrorsResolved);
        }
    }, [allErrorsResolved, onValidationChange]);
    // If all errors are resolved, do not render the component
    if (allErrorsResolved) {
        return null;
    }
    return (jsx(Stack$1, { sx: {
            padding: "1rem",
            backgroundColor: neutral[50],
            gap: "0.25rem",
        }, children: passwordRules.map(({ text, errorKey }) => (jsx(PasswordValidationCheckerItem, { text: text, isError: errors[errorKey] }, errorKey))) }));
}

/**
 * @returns a human readable string for the remaining time
 * @param expectedEnd the timestamp in ms from epoch of the expected end of the task
 */
function computeRemainingTime(expectedEnd) {
    // Compute the different between the expected end and now
    // TODO: Remove fixed local when we implement Intl support
    let remaining = DateTime.fromMillis(expectedEnd, { locale: "en-US" })
        .diffNow()
        .rescale();
    // Zero out the milliseconds and adjust the units to drop any one of them equal to 0
    remaining = remaining.minus(remaining.milliseconds).rescale();
    // If the remaining is less than 10 seconds show a fixed string
    // as this is an estimate we could go over the estimated expectedEnd and get
    // a negative remaining time
    if (remaining.as("seconds") < 10) {
        return "few seconds";
    }
    // If remaining is more than one day show only the number of days to give an idea
    // of the order of magnitude
    if (remaining.as("days") > 1) {
        remaining = remaining.mapUnits((value, unit) => unit === "days" ? value : 0);
    }
    // If remaining is more than one hour, don't show the seconds
    if (remaining.as("hours") > 1) {
        remaining = remaining.set({ seconds: 0 });
    }
    return remaining
        .rescale()
        .toHuman({
        unitDisplay: "narrow",
    })
        .replace(/,/g, "");
}
/**
 * @returns a label showing the remaining time to complete a task if an expected end is available
 */
function RemainingTimeLabel({ expectedEnd, sx, }) {
    // The current remaining time to the task completion
    const [remaining, setRemaining] = useState(() => computeRemainingTime(expectedEnd));
    // Update the remaining time once every second
    useEffect(() => {
        function update() {
            setRemaining(() => computeRemainingTime(expectedEnd));
        }
        const id = setInterval(update, 1000);
        return () => {
            clearInterval(id);
        };
    }, [expectedEnd]);
    return (jsxs(Box, { component: "span", sx: sx, children: [jsx(TranslateVar, { name: "remainingTime", children: remaining }), " left"] }));
}

/**
 * @returns the progress with file information and a cancel button.
 */
function FileProgress({ disabled, file, expectedEnd, progress, onCancel, }) {
    return (jsxs(Stack, { sx: { p: 1 }, children: [jsxs(Stack, { sx: { minHeight: "24px" }, direction: "row", justifyContent: "space-between", children: [jsx(FaroText, { sx: {
                            alignSelf: "end",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }, variant: "bodyM", className: NO_TRANSLATE_CLASS, children: file.name }), onCancel && (jsx(FaroIconButton, { size: FaroIconButtonSizes.xs, onClick: onCancel, disabled: disabled, children: jsx(CloseIcon, {}) }))] }), jsxs(Stack, { sx: { mt: 0.5 }, direction: "row", justifyContent: "space-between", children: [jsxs(FaroText, { variant: "labelM", sx: { opacity: 0.6 }, children: [jsx(TranslateVar, { name: "fileSize", children: humanReadableBytes(file.size) }), expectedEnd && jsx(NoTranslate, { children: " \u2022 " }), expectedEnd && (jsx(TranslateVar, { name: "remainingTime", children: jsx(RemainingTimeLabel, { expectedEnd: expectedEnd }) }))] }), progress !== undefined && (jsxs(FaroText, { variant: "bodyS", className: NO_TRANSLATE_CLASS, children: [Math.round(progress), "%"] }))] }), progress !== undefined && (jsx(LinearProgress, { sx: {
                    mt: 1,
                    "& .MuiLinearProgress-bar": {
                        background: (theme) => theme.palette.primary.main,
                    },
                }, variant: "determinate", value: progress }))] }));
}
/**
 * @returns the progress with file information and a cancel button.
 */
function FileProgressCircular({ disabled, file, fileName, expectedEnd, progress, onCancel, }) {
    return (jsxs(Stack, { alignItems: "center", justifyContent: "center", flexGrow: 1, children: [progress !== undefined && (jsx(CircularProgress, { variant: "determinate", sx: {
                    color: "blue500",
                    mb: 2.5,
                }, size: 60, value: progress, showPercentage: true })), jsxs(Stack, { sx: { minHeight: "24px" }, direction: "column", justifyContent: "space-between", children: [jsxs(FaroText, { sx: {
                            alignSelf: "end",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            mb: 1,
                        }, variant: "heading16", children: ["Uploading", " ", jsx(TranslateVar, { name: "fileName", children: fileName ?? file.name })] }), expectedEnd && (jsx(FaroText, { variant: "placeholder", children: jsx(RemainingTimeLabel, { expectedEnd: expectedEnd }) })), onCancel && (jsx(FaroButton, { variant: "ghost", sx: { mt: 5 }, onClick: onCancel, disabled: disabled, children: "Cancel" }))] })] }));
}

var _path$2, _path2$1;
function _extends$2() { return _extends$2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2.apply(null, arguments); }
const SvgRadioCheckedDark = props => /*#__PURE__*/React.createElement("svg", _extends$2({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M15.5 8a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z"
})), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
  fill: "#20252E",
  d: "M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
})));

var _path$1, _path2;
function _extends$1() { return _extends$1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1.apply(null, arguments); }
const SvgRadioCheckedLight = props => /*#__PURE__*/React.createElement("svg", _extends$1({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M15.5 8a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
})));

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgRadioUnchecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M15.5 8a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z"
})));

const LIGHT_COLORS = {
    idleColor: neutral[800],
    hoverColor: blue[500],
    error: red[500],
    fillUnchecked: neutral[0],
    fillUncheckedError: red[50],
    colorChecked: blue[600],
    colorCheckedError: red[600],
    fillChecked: blue[500],
    fillCheckedError: red[500],
    fillCheckedHover: blue[600],
    outlineFocused: neutral[999],
};
const DARK_COLORS = {
    idleColor: neutral[100],
    hoverColor: cyan$1[500],
    error: red[300],
    fillUnchecked: neutral[800],
    fillUncheckedError: red[900],
    colorChecked: cyan$1[300],
    colorCheckedError: red[200],
    fillChecked: cyan$1[400],
    fillCheckedError: red[300],
    fillCheckedHover: cyan$1[300],
    outlineFocused: neutral[100],
};
/**
 * @returns a single radio button. To create a full radio list, use multiple in a FaroRadioGroup.
 */
function FaroRadio({ value, label, dark, error, ...radioProps }) {
    const colors = dark ? DARK_COLORS : LIGHT_COLORS;
    const RadioChecked = dark ? SvgRadioCheckedDark : SvgRadioCheckedLight;
    return (jsx(FormControlLabel, { value: value, label: label, control: jsx(Radio, { icon: jsx(SvgRadioUnchecked, { className: "FaroRadio-radioIconUnchecked" }), checkedIcon: jsx(RadioChecked, { className: "FaroRadio-radioIconChecked" }), sx: {
                color: colors.idleColor,
                "&:hover": {
                    color: colors.hoverColor,
                },
            }, disableRipple: true, ...radioProps }), sx: {
            color: colors.idleColor,
            width: "fit-content",
            ml: 0,
            pr: 0.5,
            ".MuiRadio-root": {
                p: 1,
                pl: 0,
            },
            ".MuiFormControlLabel-label": {
                fontSize: "0.875rem",
            },
            ".FaroRadio-radioIconUnchecked": {
                color: error ? colors.error : colors.idleColor,
                fill: error ? colors.fillUncheckedError : colors.fillUnchecked,
            },
            ".FaroRadio-radioIconChecked": {
                color: error ? colors.colorCheckedError : colors.colorChecked,
                fill: error ? colors.fillCheckedError : colors.fillChecked,
            },
            "&:hover:not(&.Mui-disabled)": {
                color: colors.hoverColor,
                ".FaroRadio-radioIconUnchecked": {
                    color: colors.hoverColor,
                },
                ".FaroRadio-radioIconChecked": {
                    color: colors.fillCheckedHover,
                    fill: colors.fillCheckedHover,
                },
            },
            // only shown on keyboard navigation
            "&:has(:focus-visible)": {
                outline: "1px solid",
                outlineColor: colors.outlineFocused,
                borderRadius: "4px",
            },
            "&.Mui-disabled": {
                opacity: 0.5,
            },
            "& .MuiFormControlLabel-label.Mui-disabled": {
                // MUI sets a different color in the disabled state, which doesn't work for the `dark` variant
                // Overwrite it with the default color, because the opacity is already set to 50%
                color: colors.idleColor,
            },
        } }));
}

/**
 * @returns a radio group that can coordinates FaroRadio components in its children
 */
function FaroRadioGroup({ dark, label, tag, helpText, error, disabled, children, radioGroupSx, ...radioGroupProps }) {
    const FormHelperTextVariant = dark ? FormHelperTextDark : FormHelperTextLight;
    const hasError = !!error;
    const errorOrHelpText = hasError ? error : helpText;
    return (jsxs(Fragment, { children: [label && (jsx(FaroInputLabel, { tag: tag, dark: dark, disabled: disabled, error: hasError, children: label })), jsx(RadioGroup, { sx: radioGroupSx, ...radioGroupProps, children: children }), errorOrHelpText && (jsx(FormHelperTextVariant, { sx: { m: 0 }, error: !!error, disabled: disabled, children: errorOrHelpText }))] }));
}

const HORIZONTAL_PADDING = 1.5;
/**
 * @returns The component that is used by lexical to modify the content
 */
const ContentEditable = forwardRef(function ContentEditable({ placeholder, readOnly, dark, sx, onFocus, onBlur }, externalRef) {
    const [editor] = useLexicalComposerContext();
    const [isEditable, setEditable] = useState(false);
    const isEmpty = useLexicalIsTextContentEmpty(editor);
    // Hand control of div over to lexical
    const internalRef = useCallback((rootElement) => {
        // defaultView is required for a root element.
        // In multi-window setups, the defaultView may not exist at certain points.
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- FIXME
        if (rootElement?.ownerDocument?.defaultView) {
            editor.setRootElement(rootElement);
        }
    }, [editor]);
    const ref = useForkRef(internalRef, externalRef);
    // Sync editable state between editor and this component
    useLayoutEffect(() => {
        setEditable(editor.isEditable());
        return editor.registerEditableListener((currentIsEditable) => {
            setEditable(currentIsEditable);
        });
    }, [editor]);
    return (jsx(Box, { component: "div", ref: ref, contentEditable: isEditable, sx: {
            width: "100%",
            height: "100%",
            overflow: "auto",
            // Removes the browser's default outline when focused/hovered
            outline: "none",
            // Adjusting styling here as lexical will override styles set on other levels
            "& p, &:before": {
                m: 0,
                py: 1.25,
                px: readOnly ? 0 : HORIZONTAL_PADDING,
            },
            "& a": {
                color: dark ? cyan$1[400] : blue[500],
            },
            // Add a placeholder
            "&:not(:focus):before": {
                content: isEmpty && placeholder ? `"${placeholder}"` : "unset",
                fontStyle: "italic",
                color: neutral[500],
                position: "absolute",
            },
            ...sx,
        }, onFocus: onFocus, onBlur: onBlur }));
});

const ANCHOR_POINTS = [
    createAnchorPoint(DEFAULT_URL_REGEX, (text) => text.startsWith("http") ? text : `https://${text}`),
];
/** List of markdown strings we want to support for rendering */
const MARKDOWN_TRANSFORMERS = [LINK];
/**
 * @returns Renderer for rich text, that also allows the user to edit the content
 */
function FaroRichTextCore({ readOnly, onError, initialText, onChange, dark, placeholder, label, sx, children, lexicalPlugins, }) {
    const editorRef = useRef(null);
    const initialConfig = {
        namespace: "FaroRichText",
        onError,
        nodes: [AutoLinkNode, LinkNode],
    };
    // Adding initial text to the editor
    useEffect(() => {
        if (!initialText)
            return;
        // Get the current active element in the DOM
        const { activeElement } = document;
        // Update the editor with the initial text
        // This will focus the editor after updating
        editorRef.current?.update(() => {
            $convertFromMarkdownString(initialText, MARKDOWN_TRANSFORMERS);
        }, {
            // Restore the original active element after updating
            onUpdate: () => {
                if (activeElement instanceof HTMLElement) {
                    // Remove selection to avoid issues with the focus
                    window.getSelection()?.removeAllRanges();
                    // Focus the original element
                    activeElement.focus();
                }
            },
        });
    }, [initialText]);
    // Update edit-mode
    useEffect(() => {
        editorRef.current?.setEditable(!readOnly);
    }, [readOnly]);
    // Attach event listener for updating parent component
    useEffect(() => {
        editorRef.current?.registerUpdateListener(({ editorState }) => {
            editorState.read(() => {
                onChange?.($convertToMarkdownString(MARKDOWN_TRANSFORMERS));
            });
        });
    }, [onChange]);
    // Adjust links to always open in a new tab
    useEffect(() => {
        if (!editorRef.current)
            return;
        const removeLinkListener = editorRef.current.registerNodeTransform(LinkNode, (node) => {
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- FIXME
            if (!node)
                return;
            node.__target = "_blank";
        });
        const removeAutoLinkListener = editorRef.current.registerNodeTransform(AutoLinkNode, (node) => {
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- FIXME
            if (!node)
                return;
            node.__target = "_blank";
        });
        return () => {
            removeLinkListener();
            removeAutoLinkListener();
        };
    }, [editorRef]);
    return (jsxs(LexicalComposer, { initialConfig: initialConfig, children: [jsx(RichTextPlugin, { contentEditable: cloneElement(children, {
                    onError,
                    initialText,
                    onChange,
                    dark,
                    placeholder,
                    label,
                    sx,
                }), 
                // The placeholder is rendered below the text field, which makes it kinda useless (hence passing null)
                // A custom placeholder is implemented in ContentEditable
                placeholder: null, ErrorBoundary: LexicalErrorBoundary }), jsx(EditorRefPlugin, { editorRef: editorRef }), jsx(HistoryPlugin, {}), jsx(MarkdownShortcutPlugin, { transformers: MARKDOWN_TRANSFORMERS }), jsx(AnchorPointPlugin, { points: ANCHOR_POINTS }), lexicalPlugins] }));
}

/**
 * @returns Version of the FaroRichText component that is specialized for editing the content
 */
function FaroRichTextEditor({ fullWidth, dark, sx, label, tag, placeholder, error, onError, onChange, onBlur, readOnly, initialText, }) {
    return (jsx(FaroRichTextCore, { onError: onError, initialText: initialText, onChange: onChange, label: label, dark: dark, sx: sx, children: jsx(TextField, { multiline: true, fullWidth: fullWidth, disabled: readOnly, label: label, tag: tag, error: error, onBlur: onBlur, slots: {
                input: ContentEditable,
            }, inputProps: { placeholder, dark } }) }));
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
// Copy from (with small modifications):
// https://github.com/facebook/lexical/blob/2e26b744ce2ccaa5c43a6db0c1861ce574632075/packages/lexical-playground/src/plugins/MaxLengthPlugin/index.tsx
/**
 * @returns Lexical plugin allowing to shorten the rendered content
 */
function MaxLengthPlugin({ maxLength, onTextShortened, }) {
    const [editor] = useLexicalComposerContext();
    useEffect(() => {
        let lastRestoredEditorState = null;
        return editor.registerNodeTransform(RootNode, (rootNode) => {
            if (maxLength === undefined)
                return;
            const selection = $getSelection();
            if (!$isRangeSelection(selection) || !selection.isCollapsed()) {
                return;
            }
            const prevEditorState = editor.getEditorState();
            const prevTextContentSize = prevEditorState.read(() => rootNode.getTextContentSize());
            const textContentSize = rootNode.getTextContentSize();
            if (prevTextContentSize !== textContentSize) {
                const delCount = textContentSize - maxLength;
                const { anchor } = selection;
                if (delCount > 0) {
                    // Restore the old editor state instead if the last
                    // text content was already at the limit.
                    if (prevTextContentSize === maxLength &&
                        lastRestoredEditorState !== prevEditorState) {
                        lastRestoredEditorState = prevEditorState;
                        $restoreEditorState(editor, prevEditorState);
                    }
                    else {
                        $trimTextContentFromAnchor(editor, anchor, delCount);
                    }
                    onTextShortened?.();
                }
            }
        });
    }, [editor, maxLength, onTextShortened]);
    return null;
}

/** Map of label text size to the corresponding variant */
const LABEL_VARIANT = {
    s: "heading12",
    m: "heading14",
};
/** Map of content text size to the corresponding variant */
const CONTENT_VARIANT = {
    s: "bodyS",
    m: "bodyM",
};
/**
 * @returns Version of the FaroRichText component that is specialized for rendering read only content
 */
function FaroRichTextViewer({ onError, initialText, dark, label, maxLength, textSize = "m", onTextShortened, }) {
    return (jsx(FaroRichTextCore, { onError: onError, initialText: initialText, readOnly: true, lexicalPlugins: jsx(MaxLengthPlugin, { maxLength: maxLength, onTextShortened: onTextShortened }), children: jsxs(Box, { component: "div", children: [jsx(FaroText, { variant: LABEL_VARIANT[textSize], dark: dark, sx: { pb: 0 }, children: label }), jsx(FaroText, { variant: CONTENT_VARIANT[textSize], dark: dark, className: NO_TRANSLATE_CLASS, children: jsx(ContentEditable, { readOnly: true, dark: dark, 
                        // Make sure the space between the label and the content is not too big
                        sx: { "& p, &:before": { m: 0, pt: 0.5 } } }) })] }) }));
}

/**
 * @returns A container for components in the sidebar.
 *
 * This applies the background and scales it to the full height
 * of the parent component.
 */
function SidebarContainer({ style, children, }) {
    return (jsx(Box, { component: "div", sx: {
            backgroundColor: (theme) => theme.palette.customGrey,
            height: "100%",
            ...style,
        }, children: children }));
}

/**
 * @returns A menu button in the sidebar.
 *
 * When this is clicked, the corresponding sidebar content
 * is toggled on and expanded.
 */
function SidebarMenuButton({ entry, isActive, onEntryClick, }) {
    return (jsxs(Stack, { alignItems: "center", justifyContent: "center", sx: [
            {
                cursor: "pointer",
                color: (theme) => isActive ? theme.palette.primary.dark : theme.palette.primary.main,
                padding: 1,
            },
            {
                "&:hover": {
                    color: (theme) => theme.palette.primary.light,
                },
                "> p": {
                    whiteSpace: "nowrap",
                    color: "inherit",
                },
            },
        ], onClick: () => onEntryClick(entry.id), children: [entry.icon, jsx(Typography, { children: entry.name })] }));
}

/**
 * @returns A list of clickable menu buttons in the sidebar.
 */
function SidebarMenuButtonList({ entries, activeEntryId, onEntryClick, }) {
    return (jsx(Stack, { component: SidebarContainer, alignItems: "center", children: entries.map((entry) => (jsx(SidebarMenuButton, { entry: entry, isActive: entry.id === activeEntryId, onEntryClick: onEntryClick }, entry.id))) }));
}

/**
 * @returns A menu in the sidebar.
 *
 * Composed of multiple entries that can be clicked to be toggled on
 * and expanded, revealing more content.
 *
 * The entries can contain further submenus themselves, creating a nested structure.
 */
function SidebarMenu({ entries }) {
    const [activeEntryId, setActiveEntryId] = useState(null);
    const activeEntry = entries.find((entry) => entry.id === activeEntryId);
    function onEntryClick(id) {
        if (id === activeEntryId) {
            // If the user clicks the same entry again, deactivate it
            setActiveEntryId(null);
        }
        else {
            setActiveEntryId(id);
        }
    }
    return (jsxs(Stack, { flexDirection: "row-reverse", children: [jsx(SidebarMenuButtonList, { entries: entries, activeEntryId: activeEntryId, onEntryClick: onEntryClick }), activeEntry?.content] }));
}

/**
 * @returns Icon used for showing the state of the current step
 */
function FaroStepIcon({ active, completed, icon, }) {
    const iconColor = useMemo(() => {
        if (active)
            return blue[500];
        if (completed)
            return neutral[800];
        return neutral[100];
    }, [active, completed]);
    const isFutureStep = !active && !completed;
    return (jsx(Stack, { component: "span", justifyContent: "center", alignItems: "center", sx: {
            borderRadius: "50%",
            width: "36px",
            height: "36px",
            backgroundColor: iconColor,
        }, children: jsx(FaroText, { variant: "heading20", color: isFutureStep ? neutral[800] : neutral[0], sx: { opacity: isFutureStep ? 0.5 : 1 }, children: icon }) }));
}

/** @returns A progress indicator for multiple steps through a workflow. */
function FaroStepper({ steps, activeStepKey, onStepChange, lastStepButtonText, hideStepNumbers = false, onLastStepButtonClicked, }) {
    const activeStepIndex = useMemo(() => steps.findIndex((step) => step.key === activeStepKey), [steps, activeStepKey]);
    const activeStep = steps[activeStepIndex];
    const allowNext = activeStep.allowNext ? activeStep.allowNext() : true;
    const allowBack = activeStep.allowBack ? activeStep.allowBack() : true;
    const [isLoadingBack, setIsLoadingBack] = useState(false);
    const [isLoadingNext, setIsLoadingNext] = useState(false);
    const onBack = useCallback(async () => {
        setIsLoadingBack(true);
        try {
            await activeStep.onBeforeBack?.();
            onStepChange(steps[activeStepIndex - 1]);
        }
        catch {
            /* empty */
        }
        setIsLoadingBack(false);
    }, [activeStep, activeStepIndex, onStepChange, steps]);
    const onNext = useCallback(async () => {
        if (onLastStepButtonClicked &&
            lastStepButtonText &&
            activeStepIndex === steps.length - 1) {
            // if it's action on last step, only onLastStepButtonClicked should be executed
            onLastStepButtonClicked();
            return;
        }
        setIsLoadingNext(true);
        try {
            await activeStep.onBeforeNext?.();
            onStepChange(steps[activeStepIndex + 1]);
        }
        catch {
            /* empty */
        }
        setIsLoadingNext(false);
    }, [
        activeStep,
        activeStepIndex,
        lastStepButtonText,
        onLastStepButtonClicked,
        onStepChange,
        steps,
    ]);
    return (jsxs(Stack$1, { direction: "row", justifyContent: "space-between", alignItems: "center", sx: { width: "100%", p: 1, backgroundColor: neutral[50] }, children: [jsx(Box$1, { component: "div", flexBasis: 180, flexGrow: 1, flexShrink: 1 }), jsx(Stepper, { activeStep: activeStepIndex, sx: {
                    flexGrow: 0.5,
                    flexShrink: 0,
                    justifyContent: steps.length === 1 ? "center" : undefined,
                }, children: steps.map((step, index) => (jsx(Step, { children: jsx(StepLabel, { StepIconComponent: hideStepNumbers ? NonVisibleStepperIcon : FaroStepIcon, children: jsx(FaroText, { variant: "heading16", color: index === activeStepIndex && steps.length > 1
                                ? blue[500]
                                : neutral[800], sx: { opacity: index > activeStepIndex ? 0.5 : 1 }, children: step.label }) }) }, `${step.key}`))) }), jsxs(Stack$1, { direction: "row", justifyContent: "flex-end", flexBasis: 180, flexGrow: 1, flexShrink: 0.1, children: [activeStepIndex > 0 && (jsx(FaroButton, { variant: "ghost", disabled: !allowBack, isLoading: isLoadingBack, sx: { width: "content" }, onClick: onBack, children: "Back" })), (activeStepIndex < steps.length - 1 || lastStepButtonText) && (jsx(FaroButton, { variant: "ghost", disabled: !allowNext, isLoading: isLoadingNext, sx: { width: "content" }, onClick: onNext, children: lastStepButtonText && activeStepIndex === steps.length - 1
                            ? lastStepButtonText
                            : "Next" }))] })] }));
}
/**
 * @returns non-visible icon for stepper
 */
function NonVisibleStepperIcon() {
    return (jsx(Stack$1, { sx: {
            width: "0px",
            height: "0px",
        } }));
}

const LIGHT_PALETTE = {
    thumb: neutral[0],
    main: neutral[800],
    helpText: neutral[600],
    track: neutral[200],
    trackBorder: neutral[300],
    checkedTrackBorder: blue[600],
    hoverTrack: neutral[400],
    checkedTrack: blue[500],
};
const DARK_PALETTE = {
    thumb: neutral[950],
    main: neutral[100],
    helpText: neutral[300],
    track: neutral[800],
    trackBorder: neutral[300],
    checkedTrackBorder: cyan$1[300],
    hoverTrack: neutral[400],
    checkedTrack: cyan$1[400],
};
/** @returns a Switch styled following the FARO Design System with an optional label and help text */
function FaroSwitch({ checked, disabled, onToggle, label, labelPlacement = "start", helpText, dark = false, fullWidth = false, inputProps, sx, }) {
    const palette = dark ? DARK_PALETTE : LIGHT_PALETTE;
    const hoverStyle = {
        ":hover": {
            color: palette.checkedTrack,
            cursor: "pointer",
            background: `${neutral[500]}26`,
            "& .MuiSwitch-switchBase": {
                background: "unset",
                "& +.MuiSwitch-track": {
                    backgroundColor: palette.hoverTrack,
                    border: `1px solid ${palette.hoverTrack}`,
                },
                "&.Mui-checked +.MuiSwitch-track": {
                    backgroundColor: palette.checkedTrackBorder,
                    border: `1px solid ${palette.checkedTrackBorder}`,
                },
            },
        },
    };
    return (jsxs(Stack, { sx: [
            disabled ? { color: palette.main, opacity: 0.5 } : {},
            {
                width: fullWidth ? "100%" : "fit-content",
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ], children: [jsxs(Stack, { direction: labelPlacement === "start" ? "row" : "row-reverse", alignItems: "center", gap: 1, minHeight: "1.75rem", 
                // Note: When user pressed the space bar while the switch has focus, `onClick` will be triggered
                onClick: (ev) => !disabled && onToggle?.(ev), onKeyDown: (ev) => {
                    if (!disabled && ev.key === "Enter") {
                        onToggle?.(ev);
                    }
                }, tabIndex: 0, sx: [
                    disabled ? {} : hoverStyle,
                    {
                        color: palette.main,
                        boxSizing: "border-box",
                        borderRadius: "4px",
                        userSelect: "none",
                        px: "2px",
                        py: "4px",
                        "&:focus-visible": {
                            px: "1px",
                            py: "3px",
                            border: `solid 1px ${palette.main}`,
                            outline: 0,
                        },
                    },
                ], children: [jsx(FaroText, { variant: "bodyM", color: "inherit", flexGrow: 1, textAlign: labelPlacement === "start" ? "left" : "right", children: label }), jsx(Switch, { focusVisibleClassName: ".Mui-focusVisible", disableRipple: true, checked: checked, disabled: disabled, autoFocus: false, focusRipple: false, 
                        // Disable internal focus handling as the focus is handled outside
                        // to outline together the switch and the label
                        inputProps: {
                            ...inputProps,
                            tabIndex: -1,
                        }, sx: {
                            width: "2rem",
                            height: "1rem",
                            padding: 0,
                            overflow: "visible",
                            "& .MuiSwitch-switchBase": {
                                width: "2rem",
                                height: "1rem",
                                padding: 0,
                                "& .MuiSwitch-input": {
                                    // Make sure the input does not stretch over the provided space
                                    width: "100%",
                                    // Remove any left setting that the input might have to make sure it's put into the correct position
                                    left: "unset",
                                },
                                "&.Mui-checked": {
                                    transform: "translateX(16px)",
                                    ":hover": {
                                        background: "unset",
                                    },
                                    "& + .MuiSwitch-track": {
                                        backgroundColor: palette.checkedTrack,
                                        border: `1px solid ${palette.checkedTrackBorder}`,
                                        opacity: 1,
                                    },
                                },
                                "&.Mui-disabled + .MuiSwitch-track": {
                                    opacity: 0.5,
                                },
                                "&.Mui-disabled .MuiSwitch-thumb": {
                                    opacity: 1,
                                    color: `${palette.thumb}`,
                                    border: `1px solid ${palette.main}80`,
                                },
                            },
                            "& .MuiSwitch-thumb": {
                                boxSizing: "border-box",
                                color: palette.thumb,
                                border: `1px solid ${palette.main}`,
                                width: "1rem",
                                height: "1rem",
                                borderRadius: "0.5rem",
                                padding: 0,
                                margin: 0,
                                transform: "translateX(-8px)",
                                boxShadow: "unset",
                            },
                            "& .MuiSwitch-track": {
                                maxWidth: "2rem",
                                maxHeight: "1rem",
                                padding: 0,
                                boxSizing: "border-box",
                                borderRadius: "0.5rem",
                                background: palette.track,
                                border: `1px solid ${palette.trackBorder}`,
                                opacity: 1,
                                transition: (theme) => theme.transitions.create(["background-color"], {
                                    duration: 500,
                                }),
                            },
                        } })] }), helpText && (jsx(FaroText, { variant: "bodyS", color: disabled ? palette.main : palette.helpText, children: helpText }))] }));
}

/**
 * FaroTabsItem component renders a toggle button styled tab item with optional icon.
 *
 * @returns JSX.Element - The rendered FaroTabsItem component.
 */
function FaroTabsItem({ isDisabled = false, title, description, value, icon, color = blue[500], backgroundColor = neutral[50], }) {
    const styles = {
        "&.MuiButtonBase-root": {
            backgroundColor: neutral[0],
            borderRadius: "initial",
            textAlign: "left",
            color: neutral[800],
            textTransform: "none",
            border: "none",
        },
        "&.Mui-selected *, &.MuiButtonBase-root:hover *, &.MuiStack-root": {
            color,
        },
        "&.MuiButtonBase-root:hover, &.Mui-selected": {
            backgroundColor,
            color,
        },
        "&.Mui-disabled": {
            border: "none",
            opacity: 0.5,
        },
    };
    return (jsx(ToggleButton$1, { value: value, "aria-label": `tab button ${value}`, fullWidth: true, disableRipple: true, disabled: isDisabled, sx: styles, "data-testid": "faro-tab-item", children: jsxs(Stack, { width: "100%", children: [jsx(FaroText, { variant: "heading12", sx: {
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        width: "100%",
                    }, children: title }), jsxs(Stack, { direction: "row", spacing: 2, alignItems: "center", children: [description && (jsx(FaroText, { variant: "heading20", sx: {
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }, children: description })), icon && jsx(Stack, { "data-testid": "faro-tabs-item-icon", children: icon })] })] }) }));
}

/**
 * FaroTabs Component
 *
 * This component renders a group of toggle buttons representing tabs.
 * Each tab can display a title, description, and an optional icon.
 * The tabs can be styled with custom colors and sx properties.
 *
 * @param {FaroTabsProps} props - The props for the FaroTabs component
 * @returns JSX.Element - A group of toggle buttons styled as tabs
 */
function FaroTabs({ items, initialValue, color, backgroundColor, sx, onTabChange, }) {
    const [selectedTab, setSelectedTab] = useState(initialValue);
    /**
     * Handles the change event when a new tab button is selected.
     *
     * This function is called whenever a tab is selected. It updates the state
     * to reflect the currently selected tab and invokes the provided callback
     * function `onTabChange` with the new tab value.
     *
     * @param {MouseEvent<HTMLElement>} _ - The mouse event triggering the change.
     * @param {string | null} newValue - The value of the newly selected tab.
     *    If no tab is selected, this value will be `null`.
     */
    const handleTabChange = useCallback((_, newValue) => {
        if (newValue !== null) {
            setSelectedTab(newValue);
            onTabChange(newValue);
        }
    }, [onTabChange]);
    return (jsx(ToggleButtonGroup, { value: selectedTab, fullWidth: true, exclusive: true, onChange: handleTabChange, "aria-label": "multiple tab buttons", "data-testid": "faro-tabs", sx: {
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(15rem, 1fr))",
            gap: "0.625rem",
            ...sx,
        }, children: items.map((item, index) => (jsx(FaroTabsItem, { ...item, color: color, backgroundColor: backgroundColor }, index))) }));
}

/** The size of the spinner in pixels */
const SPINNER_SIZE = 18;
/** The thickness of the spinner in pixels */
const SPINNER_THICKNESS = 2;
/** @returns A custom ToggleButton that can be disabled while preserving the ToolTip */
const ToggleButton = forwardRef(function ToggleButton({ children, value, disabled, onClick, sx, showSpinner, neverPropagateOnClick, ...props }, ref) {
    const extraSx = disabled
        ? {
            ":hover": {
                backgroundColor: "transparent",
                cursor: "default",
            },
            backgroundColor: "transparent",
        }
        : {};
    return (jsxs(ToggleButton$1, { ref: ref, value: value, sx: [extraSx, ...(Array.isArray(sx) ? sx : [sx])], "aria-disabled": disabled, disableRipple: disabled, onClick: (event, value) => {
            if (neverPropagateOnClick) {
                event.stopPropagation();
            }
            if (!disabled && onClick)
                onClick(event, value);
        }, ...props, children: [jsx("div", { style: { opacity: disabled ? 0.5 : 1, lineHeight: 0 }, children: children }), showSpinner && jsx(Spinner, {})] }));
});
/** @returns A partial circle rotating in loop */
function Spinner() {
    return (jsx(Box, { component: "div", sx: {
            display: "inline-block",
            width: SPINNER_SIZE,
            height: SPINNER_SIZE,
            position: "absolute",
            "@keyframes rotation": {
                "0%": {
                    transform: "rotate(0deg)",
                },
                "100%": {
                    transform: "rotate(360deg)",
                },
            },
            animation: "rotation 1.4s linear infinite",
        }, children: jsxs("svg", { style: { display: "block", color: cyan$1[400] }, viewBox: `${SPINNER_SIZE / 2} ${SPINNER_SIZE / 2} ${SPINNER_SIZE} ${SPINNER_SIZE}`, children: [jsx("circle", { cx: SPINNER_SIZE, cy: SPINNER_SIZE, r: (SPINNER_SIZE - 2 * SPINNER_THICKNESS) / 2, fill: "none", stroke: neutral[999], strokeWidth: SPINNER_THICKNESS * 2, strokeDasharray: "80px, 200px", strokeDashoffset: -15 }), jsx("circle", { cx: SPINNER_SIZE, cy: SPINNER_SIZE, r: (SPINNER_SIZE - 2 * SPINNER_THICKNESS) / 2, fill: "none", stroke: "currentColor", strokeWidth: SPINNER_THICKNESS, strokeDasharray: "80px, 200px", strokeDashoffset: -15 })] }) }));
}

/**
 * @returns A round toggle with optimized styles for icons
 */
function ToggleIconButton({ children, ...props }) {
    return (jsx(ToggleButton, { sx: {
            borderRadius: "50%",
            color: (theme) => theme.palette.primary.main,
            ["&:hover"]: {
                color: (theme) => theme.palette.white,
            },
            ...props.sx,
        }, ...props, children: children }));
}

/** @returns a wrapper for a related group of ToolButton with the proper FARO style */
function ToolGroup({ children, orientation = "vertical", sx = [], ...rest }) {
    return (jsx(ToggleButtonGroup, { orientation: orientation, exclusive: true, sx: [
            {
                "&:first-of-type": {
                    "> *:first-of-type, > *:first-of-type:hover": {
                        "&.MuiButtonBase-root, .MuiButtonBase-root": {
                            borderTopLeftRadius: "6px",
                            borderTopRightRadius: "6px",
                        },
                    },
                },
                "&:last-of-type": {
                    "> *:last-of-type, > *:last-of-type:hover": {
                        "&.MuiButtonBase-root, .MuiButtonBase-root": {
                            borderBottomLeftRadius: "6px",
                            borderBottomRightRadius: "6px",
                        },
                    },
                },
            },
            // You cannot spread `sx` directly because `SxProps` (typeof sx) can be an array.
            ...(Array.isArray(sx) ? sx : [sx]),
        ], ...rest, children: children }));
}

/**
 * @returns a wrapper for ToolGroups with the proper FARO style
 */
const Toolbar = forwardRef(function Toolbar({ children, sx = [], allowOverflow, direction = "column" }, ref) {
    // Don't add separators when there are empty children
    const filteredChildren = useMemo(() => {
        if (!children)
            return EMPTY_ARRAY;
        if (Array.isArray(children)) {
            return children.filter((child) => !!child);
        }
        return [children];
    }, [children]);
    return (jsx(Stack, { ref: ref, direction: direction, sx: [
            {
                backdropFilter: "blur(4px) brightness(40%)",
                borderRadius: 1.5,
                overflow: allowOverflow ? undefined : "hidden",
                backgroundColor: neutral[999],
            },
            // You cannot spread `sx` directly because `SxProps` (typeof sx) can be an array.
            ...(Array.isArray(sx) ? sx : [sx]),
        ], children: filteredChildren.map((group, index) => (jsxs(Fragment$1, { children: [group, filteredChildren.length > 1 &&
                    index !== filteredChildren.length - 1 && (jsx(Separator, { direction: direction }))] }, index))) }));
});
/** @returns a separator that can be used to separate ToolGroups in a Toolbar */
function Separator({ direction = "column" }) {
    const columnDirection = direction === "column" || direction === "column-reverse";
    return (jsx(Stack, { sx: columnDirection
            ? {
                width: "100%",
                my: 0.25,
            }
            : {
                // height: "100%" does not work in this direction
                alignSelf: "stretch",
                mx: 0.25,
            }, justifyContent: "center", children: jsx(Divider, { orientation: columnDirection ? "horizontal" : "vertical", sx: {
                width: columnDirection ? "80%" : undefined,
                height: columnDirection ? undefined : "80%",
                margin: "auto",
                opacity: 0.2,
                backgroundColor: "white",
                borderWidth: "1px",
            } }) }));
}

/**
 * @returns A toolbar offering contextual actions on the selected elements.
 *
 * It offers:
 * - A label, e.g. showing the number of selected elements.
 * - Optionally, a set of actions to perform on the selected elements.
 *    This can be provided via the `children` prop, which should be a set of `ToolGroup` components.
 * - A button to clear the selection.
 */
function ContextualToolbar({ label, clearSelection, children, }) {
    return (jsxs(Toolbar, { direction: "row", sx: { alignItems: "center" }, children: [jsx(FaroText, { sx: { p: 1.5 }, variant: "bodyM", dark: true, children: label }), children, jsx(ToolGroup, { sx: { p: 0.5 }, children: jsx(FaroTooltip, { title: "Clear selection", sx: { borderRadius: "50%", overflow: "hidden" }, children: jsx(FaroIconButton, { "aria-label": "contextual-toolbar-clear-selection", dark: true, onClick: clearSelection, children: jsx(CloseIcon, {}) }) }) })] }));
}

/** @returns a Badge styled to be used on a Tool in a Toolbar */
function ToolBadge({ children, badgeContent, }) {
    return (jsx(Badge, { sx: {
            "& .MuiBadge-badge": {
                border: `1px solid ${neutral[999]}`,
                height: "18px",
                width: "18px",
                backgroundColor: orange[400],
                color: neutral[950],
                fontWeight: FontWeights.SemiBold,
                px: (badgeContent?.toString().length ?? 0) > 1 ? "4px" : "1px",
                py: "1px",
            },
        }, badgeContent: badgeContent, children: children }));
}

/** @returns a single ToolButton of a ToolGroup with the proper FARO style */
const ToolButton = forwardRef(function ToolButton({ children, selected, sx, value = "default", ...rest }, ref) {
    return (jsx(ToggleButton, { ref: ref, value: value, selected: selected, sx: [
            {
                borderRadius: 0,
                border: 0,
                backdropFilter: "none",
                ".MuiBadge-badge": {
                    borderColor: neutral[999],
                },
                "&:hover .MuiBadge-badge": {
                    borderColor: `color-mix(in srgb, ${neutral[900]}, ${neutral[500]} 25%)`,
                },
                "&.Mui-selected .MuiBadge-badge": {
                    borderColor: blue[500],
                },
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ], ...rest, children: children }));
});

/** @returns The header for the application */
function AppBar({ sx, logoUrl, shouldShowLogo = true, children, }) {
    return (jsx(MaterialAppBar, { position: "static", elevation: 0, sx: {
            backgroundColor: "gray50",
            height: "60px",
            paddingLeft: 0,
            paddingRight: 0,
            ...sx,
        }, children: jsxs(Toolbar$2, { disableGutters: true, sx: {
                height: "60px",
                pl: 0.75,
                pr: 1,
                py: 0.5,
            }, children: [shouldShowLogo && (jsx(Link, { sx: { display: "contents" }, href: logoUrl, children: jsx(SphereXGTextIcon, { sx: { width: "125px", height: "100%" } }) })), jsx(Box$2, { component: "div", sx: { width: "100%" }, children: children })] }) }));
}

/**
 * Gets the initials for a user.
 * If both first name and last name are available, it will use the first letter of each.
 * If only either the first or last name is available, it will use the first two letters.
 * If none of them are available, the first two letter of the email will be used.
 *
 * @param user Object containing the user information
 * @returns The two letters of the user name in uppercase or one letter if only one is available.
 */
function getUserInitials(user) {
    let initials = "";
    const maxDigits = 2;
    if (!user) {
        return "";
    }
    const { firstName, lastName, email, name } = user;
    if (firstName && lastName) {
        initials = `${firstName[0]}${lastName[0]}`;
    }
    else if (firstName) {
        initials = firstName.substring(0, maxDigits);
    }
    else if (lastName) {
        initials = lastName.substring(0, maxDigits);
    }
    else if (name) {
        // When fetching the logged in user, the response includes first and last name properties.
        // However, when fetching the users list, only a combined name property is included.
        // Therefore we try to infer the first and last name splitting the name separated by a space.
        const split = removeExtraSpaces(name).split(" ");
        if (split.length >= 2) {
            initials = (split[0][0] || "") + (split[1][0] || "");
        }
        else {
            initials = name.substring(0, maxDigits);
        }
    }
    else if (email) {
        initials = email.substring(0, maxDigits);
    }
    return initials.toLocaleUpperCase();
}
/**
 * Removes all extra spaces from a string to have maximum one space and trims the text.
 * E.g. From " Test   Method " the three spaces are combined and trimmed into "Test Method"
 *
 * @param str The string to remove its spaces.
 * @returns New string with removed spaces.
 */
function removeExtraSpaces(str) {
    return (str ?? "").replace(/ +(?= )/g, "").trim();
}

var UserAvatarSizes;
(function (UserAvatarSizes) {
    /** When avatar size should be extra small */
    UserAvatarSizes["xs"] = "xs";
    /** When avatar size should be small */
    UserAvatarSizes["s"] = "s";
    /** When avatar size should be medium */
    UserAvatarSizes["m"] = "m";
    /** When avatar size should be large */
    UserAvatarSizes["l"] = "l";
})(UserAvatarSizes || (UserAvatarSizes = {}));
/** Display options for avatar if the name and email should be shown */
var UserAvatarDisplayOptions;
(function (UserAvatarDisplayOptions) {
    /** Only name will be shown beside the avatar */
    UserAvatarDisplayOptions["nameOnly"] = "nameOnly";
    /** Both name and email will be shown beside the avatar */
    UserAvatarDisplayOptions["nameAndEmail"] = "nameAndEmail";
})(UserAvatarDisplayOptions || (UserAvatarDisplayOptions = {}));
/**
 * @returns The avatar for a user.
 * Contains the users image if present,
 * Falls back to the users initials if available,
 * Falls back to the first two letters of the users email if there is one,
 * Falls back to the default avatar otherwise.
 */
function UserAvatar({ userDisplayInfo, size = "m", icon, iconStyle, shouldShowGradientBorder = false, shouldShowWhiteRim = true, dark = false, displayOption, }) {
    const { profileImageUrl } = userDisplayInfo ?? {};
    let name = "";
    if (displayOption && userDisplayInfo) {
        name =
            userDisplayInfo.name ??
                `${userDisplayInfo.firstName} ${userDisplayInfo.lastName}`;
        if (displayOption === UserAvatarDisplayOptions.nameAndEmail) {
            name = `${name} (${userDisplayInfo.email})`;
        }
    }
    // Contains style based on the avatar size
    const sizeStyles = USER_AVATAR_STYLE_MAP[size];
    const initials = useMemo(() => getUserInitials(userDisplayInfo), [userDisplayInfo]);
    return (jsxs(Stack, { className: NO_TRANSLATE_CLASS, component: "span", direction: "row", mx: 0.25, gap: name ? 1 : 0, alignItems: "center", width: "fit-content", height: "fit-content", children: [jsx(Box, { component: "span", style: {
                    width: sizeStyles.wrapperSize,
                    height: sizeStyles.wrapperSize,
                    borderRadius: "50px",
                    background: shouldShowGradientBorder
                        ? "transparent linear-gradient(159deg, #009CDE 0%, #3455DB 38%, #3354D8 52%, #2E53CE 64%, #2650BD 74%, #1C4CA5 84%, #0E4787 93%, #01426A 100%) 0% 0% no-repeat padding-box"
                        : "none",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }, children: jsxs(Avatar, { sx: {
                        bgcolor: dark ? neutral[900] : neutral[400],
                        width: shouldShowGradientBorder
                            ? sizeStyles.avatarSize
                            : sizeStyles.wrapperSize,
                        height: shouldShowGradientBorder
                            ? sizeStyles.avatarSize
                            : sizeStyles.wrapperSize,
                        fontSize: sizeStyles.avatarFontSize,
                        fontWeight: sizeStyles.avatarFontWeight,
                        letterSpacing: "0.6px",
                        outline: shouldShowWhiteRim ? "2px solid white" : "none",
                    }, src: profileImageUrl, alt: initials, component: "span", children: [icon && (jsx(Box, { component: "span", sx: iconStyle, children: icon })), !icon && initials] }) }), name ?? ""] }));
}
// Specific style for each button size as defined in the FARO Design System
const USER_AVATAR_STYLE_MAP = {
    [UserAvatarSizes.xs]: {
        avatarFontSize: "10px",
        avatarFontWeight: "400",
        avatarSize: "18px",
        wrapperSize: "24px",
    },
    [UserAvatarSizes.s]: {
        avatarFontSize: "12px",
        avatarFontWeight: "400",
        avatarSize: "28px",
        wrapperSize: "36px",
    },
    [UserAvatarSizes.m]: {
        avatarFontSize: "16px",
        avatarFontWeight: "400",
        avatarSize: "40px",
        wrapperSize: "48px",
    },
    [UserAvatarSizes.l]: {
        avatarFontSize: "22px",
        avatarFontWeight: "500",
        avatarSize: "52px",
        wrapperSize: "60px",
    },
};

/** Current year */
const YEAR = new Date().getFullYear();
/**
 * @returns a simple link that says "About" and when clicked it opens a dialog to give more details about the application,
 * like the version and the copyright.
 */
function AboutDialog({ appVersion, lastPageUpdate, additionalAboutInfo, onOpen, sx, textSx, }) {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    function openDialog() {
        onOpen?.();
        setIsDialogOpen(true);
    }
    return (jsxs(Fragment, { children: [jsx(FaroText, { variant: "bodyS", sx: textSx, onClick: openDialog, title: "About", children: "About" }), jsx(FaroDialog, { open: isDialogOpen, onClose: () => setIsDialogOpen(false), showXButton: true, title: jsx(Box, { component: "div", sx: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }, children: jsx(Box, { component: "div", children: jsx(SphereXGTextIcon, { sx: {
                                height: "60px",
                                width: "125px",
                            } }) }) }), children: jsx(Box, { component: "div", sx: {
                        minWidth: "400px",
                        ...sx,
                    }, children: jsxs(Box, { component: "div", children: [jsxs(Box, { component: "div", sx: {
                                    fontSize: "14px",
                                    color: "gray850",
                                    marginBottom: "12px",
                                }, children: [jsx(FaroText, { variant: "bodyM", children: " Version \u00A0" }), jsx(Tooltip
                                    // Don't show tooltip if lastPageUpdate is not defined
                                    , { 
                                        // Don't show tooltip if lastPageUpdate is not defined
                                        title: lastPageUpdate ? (jsxs("span", { children: ["Updated: ", lastPageUpdate.toString()] })) : null, enterDelay: 0, sx: {
                                            textDecoration: "none",
                                            // Disable effect that it can be hovered if there's no last update date.
                                            color: lastPageUpdate ? "blue500" : "gray850",
                                            fontWeight: "600",
                                            letterSpacing: "1px",
                                        }, children: jsx(Box, { component: "span", sx: { boxShadow: "none" }, children: jsx(FaroText, { variant: "buttonM", className: NO_TRANSLATE_CLASS, children: appVersion }) }) })] }), additionalAboutInfo && (jsx(Box, { component: "div", sx: { mb: 2.5 }, children: additionalAboutInfo })), jsxs(FaroText, { variant: "bodyM", children: ["Copyright \u00A9 ", YEAR, " FARO. All Rights Reserved"] })] }) }) })] }));
}

const linkHoverStyle = {
    ":hover": { color: blue[500], cursor: "pointer" },
};
/**
 * @returns a list of menu options separated by a divider and a list of links properly styled.
 */
function UserMenuBody({ links, linkStyle, appVersion, lastPageUpdate, additionalAboutInfo, onOpenAbout, children, }) {
    /** Width of each link in the list, it depends on how many links are passed */
    const linkWidth = useMemo(() => (!!links && links.length > 0) || appVersion
        ? `${100 / ((links?.length ?? 0) + (appVersion ? 1 : 0))}%`
        : "100%", [appVersion, links]);
    return (jsxs(Box, { component: "div", padding: "8px", paddingTop: "0", children: [jsx(SphereDivider, {}), jsx(Box, { component: "div", sx: {
                    ".MuiMenuItem-root:hover": {
                        color: "primary.main",
                        ".MuiListItemIcon-root>*": {
                            color: "primary.main",
                        },
                        ".MuiTypography-root ": {
                            color: "primary.main",
                        },
                    },
                }, children: Array.isArray(children) ? (children.filter(isValid).map((child, index) => (jsxs(Fragment$1, { children: [child, jsx(SphereDivider, {})] }, index)))) : (jsxs(Fragment, { children: [children, children && jsx(SphereDivider, {})] })) }), jsxs(Box, { component: "div", display: "flex", alignItems: "center", justifyContent: "space-evenly", width: "100%", height: "32px", paddingX: "4px", paddingY: "4px", sx: {
                    "& .MuiListItemText-root": {
                        "& .MuiTypography-root": {
                            color: "gray",
                            fontSize: "14px",
                        },
                    },
                    "& .MuiMenuItem-root": {
                        "&. MuiButtonBase-root:active": {
                            backgroundColor: "gray",
                        },
                    },
                }, children: [appVersion && (jsx(AboutDialog, { appVersion: appVersion, lastPageUpdate: lastPageUpdate, additionalAboutInfo: additionalAboutInfo, onOpen: onOpenAbout, textSx: {
                            ...linkHoverStyle,
                            ...linkStyle,
                            width: linkWidth,
                            textAlign: "center",
                            px: "5px",
                        } })), appVersion && links && links.length > 0 && jsx(LinkDivider, {}), links?.map((link, index) => (jsxs(Fragment$1, { children: [jsx(Box, { component: "div", width: linkWidth, textAlign: "center", sx: {
                                    fontSize: "11px",
                                    paddingX: "5px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }, children: link.href && (jsx(FaroText, { variant: "bodyS", sx: { ...linkHoverStyle, ...linkStyle }, title: link.title ?? link.text, onClick: () => {
                                        link.callback?.();
                                        window.open(link.href, "_blank");
                                    }, 
                                    // To be more secure, links are set to noreferrer which means that the target page
                                    // will not know from where the visitor came from and additionally the target page will not be
                                    // able to take control of the original tab with the window.opener property
                                    rel: "noreferrer", children: link.text })) }), index !== links.length - 1 && jsx(LinkDivider, {})] }, `menu-link-${index}`)))] })] }));
}
/**
 * @returns a gray line used to separate menu items
 */
function SphereDivider({ sx }) {
    return (jsx(Divider, { sx: {
            my: "8px",
            borderColor: neutral[100],
            ...sx,
        } }));
}
/**
 * @returns a small dot used to separate links in the menu
 */
function LinkDivider() {
    return jsx(Box, { component: "div", children: "\u00B7" });
}

/** Defines the default size for all icons */
const ICONS_SIZE = "20px";
const hoverEffectCss = {
    backgroundColor: neutral[100],
    borderColor: blue[500],
    ["& .MuiTypography-root"]: {
        color: blue[500],
    },
};
/**
 * @returns the user menu without its options inside. Pass the options/items as children of the component.
 */
function UserMenu({ userDisplayInfo, anchorElement, open, links, appVersion, lastPageUpdate, additionalAboutInfo, onOpenAbout, linkStyle, closeMenu, sx, children, }) {
    const { email, firstName, lastName } = userDisplayInfo;
    const fullName = useMemo(() => `${firstName} ${lastName}`, [firstName, lastName]);
    return (jsxs(Menu, { anchorEl: anchorElement, id: "account-menu", open: open, onClose: closeMenu, sx: {
            "& .MuiPaper-root": {
                boxShadow: "none",
                border: `1px solid ${neutral[200]}`,
                borderRadius: 0,
                elevation: 0,
                overflow: "visible",
                width: "275px",
                "& .MuiList-root": {
                    padding: 0,
                },
            },
            ...sx,
        }, transformOrigin: { horizontal: "right", vertical: "top" }, anchorOrigin: { horizontal: "right", vertical: "bottom" }, children: [jsxs(Box, { component: "div", sx: { display: "flex", alignItems: "center", padding: "16px" }, children: [jsx(Box, { component: "div", children: jsx(UserAvatar, { userDisplayInfo: userDisplayInfo, size: "l", shouldShowGradientBorder: true }) }), jsxs(Box, { component: "div", sx: {
                            paddingLeft: "16px",
                            overflow: "hidden",
                        }, children: [jsx(Box, { component: "div", sx: {
                                    color: neutral[800],
                                    fontSize: "14px",
                                    fontWeight: 500,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }, children: jsx(Tooltip, { title: jsx(TranslateVar, { name: "fullName", children: fullName }), children: jsx(Box, { component: "div", children: jsx(FaroText, { variant: "bodyS", children: jsx(TranslateVar, { name: "fullName", children: fullName }) }) }) }) }), jsx(Box, { component: "div", sx: {
                                    color: neutral[800],
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }, children: jsx(Tooltip, { title: jsx(TranslateVar, { name: "email", children: email }), children: jsx(Box, { component: "div", children: jsx(FaroText, { variant: "bodyS", children: jsx(TranslateVar, { name: "email", children: email }) }) }) }) })] })] }), jsx(UserMenuBody, { links: links, linkStyle: linkStyle, appVersion: appVersion, lastPageUpdate: lastPageUpdate, additionalAboutInfo: additionalAboutInfo, onOpenAbout: onOpenAbout, children: children })] }));
}
/**
 * @returns the Account & Security menu item
 */
function MenuAccountSecurityOption({ onClick, }) {
    return (jsx(MenuItem, { onClick: onClick, children: jsx(ListItemText, { children: jsx(FaroText, { variant: "bodyM", children: "Account & Security" }) }) }));
}
/**
 * @returns the Sign Out menu item with the icon
 */
function MenuSignOutOption({ onClick }) {
    return (jsxs(MenuItem, { onClick: onClick, children: [jsx(ListItemText, { children: jsx(FaroText, { variant: "bodyM", children: "Log Out" }) }), jsx(ListItemIcon, { sx: { justifyContent: "end" }, children: jsx(ExportIcon, { sx: {
                        rotate: "-90deg",
                        color: neutral[800],
                        height: ICONS_SIZE,
                        width: ICONS_SIZE,
                    } }) })] }));
}
/**
 * @returns true if that language object maps to one of the supported languages in the app
 */
function isSupportedLanguageObject(language) {
    return includes(Object.values(LanguageCodes), language.code);
}
/**
 * @returns the language selector menu
 */
function LanguageSelectOption({ selectedLanguage, languages, onLanguageChange, }) {
    const [anchorEl, setAnchorEl] = useState(null);
    return (jsxs(Fragment, { children: [jsxs(MenuItem, { onClick: (event) => {
                    setAnchorEl(event.currentTarget);
                }, children: [jsx(ListItemText, { children: jsx(FaroText, { variant: "bodyM", children: "Language" }) }), jsxs(ListItemIcon, { sx: {
                            fontSize: "14px",
                            fontWeight: "normal",
                            color: neutral[800],
                            alignItems: "flex-start",
                            justifyContent: "end",
                            // The icon svg has too much margin that does not look aligned.
                            marginRight: "-5px",
                        }, children: [jsx(TranslateVar, { name: "selectedLanguage", children: selectedLanguage }), jsx(ChevronRightIcon, { style: {
                                    width: ICONS_SIZE,
                                    height: ICONS_SIZE,
                                    // The icon svg has too much margin that does not look aligned.
                                    marginTop: "1px",
                                } })] })] }), jsx(Menu, { anchorEl: anchorEl, open: !!anchorEl, onClose: () => setAnchorEl(null), anchorOrigin: {
                    vertical: "top",
                    horizontal: "left",
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "right",
                }, children: languages.map((language) => (jsxs(MenuItem, { disableRipple: true, sx: {
                        minWidth: "140px",
                        "&:hover": {
                            ...hoverEffectCss,
                        },
                        "&.Mui-selected": {
                            ...hoverEffectCss,
                        },
                    }, onClick: () => onLanguageChange(language.code), selected: language.code === selectedLanguage, children: [jsx(Stack$1, { sx: {
                                border: `solid ${neutral[800]} 1px`,
                                borderRadius: "2px",
                                marginRight: "8px",
                                padding: "2px",
                                width: "16px",
                                height: "16px",
                                fontSize: "10px",
                                justifyContent: "center",
                                alignItems: "center",
                                color: neutral[800],
                            }, children: jsx(TranslateVar, { name: "languageCode", children: language.code }) }), jsx(ListItemText, { sx: {
                                "& .MuiTypography-root": {
                                    fontSize: "14px",
                                    color: neutral[800],
                                },
                            }, children: jsx(TranslateVar, { name: "languageName", children: language.name }) })] }, language.code))) })] }));
}

/**
 * @returns A header bar that contains some utility buttons.
 */
function HeaderBar({ children, content, links, isQuickHelpOpen, onQuickHelpClick, showProfileButton = true, userDisplayInfo, appVersion, onLogInClick, onLogOutClick, onAccountAndSecurityClick, drawerContent, userMenuContent, }) {
    const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
    const profileButtonRef = useRef(null);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const menuLinks = useMemo(() => [
        { href: links?.termsOfServiceUrl, text: "Terms" },
        { href: links?.privacyPolicyUrl, text: "Privacy" },
        { href: links?.imprintUrl, text: "Imprint" },
    ], [links?.imprintUrl, links?.privacyPolicyUrl, links?.termsOfServiceUrl]);
    const handleDrawerToggle = useCallback(() => {
        setIsDrawerOpen(!isDrawerOpen);
    }, [isDrawerOpen]);
    return (jsxs(Fragment, { children: [jsx(AppBar, { logoUrl: links?.dashboardUrl, sx: { zIndex: 1 }, shouldShowLogo: !drawerContent, children: jsxs(Stack, { direction: "row", width: "100%", justifyContent: "space-between", alignItems: "center", children: [drawerContent && (jsx(FaroIconButton, { color: "inherit", "aria-label": "open drawer", onClick: handleDrawerToggle, children: jsx(HamburgerMenuIcon, {}) })), jsx(Typography, { component: "div", variant: "body2", sx: { p: 0, m: 0, ml: 2, color: "black" }, children: content }), jsxs(Stack, { flexDirection: "row", alignItems: "center", gap: 2, children: [children, isQuickHelpOpen !== undefined && (jsx(FaroIconButton, { size: FaroIconButtonSizes.m, onClick: onQuickHelpClick, color: isQuickHelpOpen ? "primary.main" : "secondary.main", children: jsx(QuestionMarkInCircleIcon, {}) })), showProfileButton && (jsx(Tooltip, { title: userDisplayInfo?.email ? (jsx(NoTranslate, { children: userDisplayInfo.email })) : ("Login"), children: jsx(IconButton, { "aria-label": "open user menu", onClick: () => userDisplayInfo?.email
                                            ? setIsProfileMenuOpen(true)
                                            : onLogInClick(), ref: profileButtonRef, children: jsx(UserAvatar, { userDisplayInfo: userDisplayInfo, shouldShowGradientBorder: true, size: "s" }) }) }))] }), profileButtonRef.current && userDisplayInfo && (jsxs(UserMenu, { anchorElement: profileButtonRef.current, open: isProfileMenuOpen, closeMenu: () => setIsProfileMenuOpen(false), userDisplayInfo: userDisplayInfo, links: menuLinks, appVersion: appVersion, children: [jsx(MenuAccountSecurityOption, { onClick: onAccountAndSecurityClick }), userMenuContent, jsx(MenuSignOutOption, { onClick: onLogOutClick })] }))] }) }), drawerContent && (jsxs(Drawer, { open: isDrawerOpen, onClose: handleDrawerToggle, variant: "temporary", ModalProps: {
                    // Better open performance on mobile as the content are always available in the DOM tree
                    // and saves the overhead of unmounting and mounting of the content
                    keepMounted: true,
                }, PaperProps: {
                    sx: { pl: 2.5, pr: 1, pt: 2, width: "85%" },
                }, children: [jsx(Link, { sx: { display: "contents" }, href: links?.dashboardUrl, children: jsx(SphereXGTextIcon, { sx: { width: "6.5rem", height: "3rem" } }) }), drawerContent] }))] }));
}

/** @returns A header bar for an application tool. */
function ToolHeaderBar({ toolName, userDisplayInfo, onLogin, onLogout, onAccountAndSecurity, exitHref, onExit, exitText = "Exit", appVersion, menuLinks, contentRight, userMenuContent, disableNavigation, }) {
    const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
    const profileButtonRef = useRef(null);
    return (jsxs(Stack$1, { direction: "row", justifyContent: "space-between", alignItems: "center", sx: {
            borderBottom: `1px solid ${neutral[200]}`,
            backgroundColor: neutral[0],
        }, children: [jsx(Stack$1, { alignSelf: "stretch", sx: {
                    borderRight: `1px solid ${neutral[200]}`,
                }, children: jsx(FaroButton, { "aria-label": "exit tool", variant: "ghost", size: "l", sx: { height: "100%", borderRadius: 0, px: 3 }, href: exitHref, onClick: onExit, disabled: disableNavigation, children: jsxs(FaroText, { variant: "heading16", display: "inline-flex", alignItems: "center", gap: 1, children: [jsx(ArrowBack, {}), exitText] }) }) }), jsx(FaroText, { variant: "heading16", children: toolName }), jsxs(Stack$1, { direction: "row", alignItems: "center", gap: 1, children: [contentRight, jsx(FaroTooltip, { title: userDisplayInfo?.email ?? "Login", children: jsx(FaroIconButton, { onClick: () => userDisplayInfo?.email ? setIsProfileMenuOpen(true) : onLogin(), ref: profileButtonRef, sx: {
                                // Let the user avatar determine the size
                                [">:first-of-type"]: {
                                    width: "auto",
                                    height: "auto",
                                },
                            }, children: jsx(UserAvatar, { userDisplayInfo: userDisplayInfo, shouldShowGradientBorder: true, size: "s" }) }) })] }), profileButtonRef.current && userDisplayInfo && (jsxs(UserMenu, { anchorElement: profileButtonRef.current, open: isProfileMenuOpen, closeMenu: () => setIsProfileMenuOpen(false), userDisplayInfo: userDisplayInfo, links: menuLinks, appVersion: appVersion, children: [jsx(MenuAccountSecurityOption, { onClick: onAccountAndSecurity }), userMenuContent, jsx(MenuSignOutOption, { onClick: onLogout })] }))] }));
}

var clock = "data:image/svg+xml,%3Csvg%20%20id%3D%22Clock%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2236%22%20%20height%3D%2236%22%20%20viewBox%3D%220%200%2036%2036%22%3E%20%20%3Cpath%20%20%20%20id%3D%22Tracciato_4268%22%20%20%20%20data-name%3D%22Tracciato%204268%22%20%20%20%20d%3D%22M5638%2C1126a12%2C12%2C0%2C1%2C1-12%2C12%2C12.013%2C12.013%2C0%2C0%2C1%2C12-12m0-2a14%2C14%2C0%2C1%2C0%2C14%2C14%2C14%2C14%2C0%2C0%2C0-14-14%22%20%20%20%20transform%3D%22translate%28-5620%20-1120%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20id%3D%22Tracciato_4269%22%20%20%20%20data-name%3D%22Tracciato%204269%22%20%20%20%20d%3D%22M5642.516%2C1144.049l-5.516-5.642v-6.428h2v5.613l4.945%2C5.058Z%22%20%20%20%20transform%3D%22translate%28-5620%20-1120%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_6242%22%20%20%20%20data-name%3D%22Rettangolo%206242%22%20%20%20%20width%3D%2236%22%20%20%20%20height%3D%2236%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%3C%2Fsvg%3E";

var clusterLocation = "data:image/svg+xml,%3Csvg%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2252%22%20%20height%3D%2252%22%20%20viewBox%3D%220%200%2052%2052%22%3E%20%20%3Cg%20%20%20%20id%3D%22Group_waypoints_overview%22%20%20%20%20fill%3D%22%230077b3%22%20%20%20%20stroke%3D%22%23eaeaea%22%20%20%20%20stroke-width%3D%220.5%22%20%20%3E%20%20%20%20%3Ccircle%20cx%3D%2226%22%20cy%3D%2226%22%20r%3D%2226%22%20stroke%3D%22none%22%20%2F%3E%20%20%20%20%3Ccircle%20cx%3D%2226%22%20cy%3D%2226%22%20r%3D%2225.75%22%20fill%3D%22none%22%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var crosshair_marker_blue = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20%20version%3D%221.1%22%20%20id%3D%22svg1%22%20%20xmlns%3Asvg%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20%20x%3D%220px%22%20%20y%3D%220px%22%20%20width%3D%2290%22%20%20height%3D%2290%22%20%20viewBox%3D%220%200%2090%2090%22%20%20style%3D%22enable-background%3A%20new%200%200%2090%2090%22%20%20xml%3Aspace%3D%22preserve%22%3E%20%20%3Cg%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M45%2C89C20.7%2C89%2C1%2C69.3%2C1%2C45S20.7%2C1%2C45%2C1s44%2C19.7%2C44%2C44S69.3%2C89%2C45%2C89z%20M45%2C4C22.4%2C4%2C4%2C22.4%2C4%2C45%20%20c0%2C22.6%2C18.4%2C41%2C41%2C41c22.6%2C0%2C41-18.4%2C41-41C86%2C22.4%2C67.6%2C4%2C45%2C4z%22%20%20%20%20%20%20fill%3D%22%231F65F0%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M45%2C1c24.3%2C0%2C44%2C19.7%2C44%2C44S69.3%2C89%2C45%2C89S1%2C69.3%2C1%2C45S20.7%2C1%2C45%2C1%20M45%2C86c22.6%2C0%2C41-18.4%2C41-41%20%20C86%2C22.4%2C67.6%2C4%2C45%2C4C22.4%2C4%2C4%2C22.4%2C4%2C45C4%2C67.6%2C22.4%2C86%2C45%2C86%20M45%2C0C20.2%2C0%2C0%2C20.2%2C0%2C45s20.2%2C45%2C45%2C45s45-20.2%2C45-45S69.8%2C0%2C45%2C0%20%20L45%2C0z%20M45%2C85C22.9%2C85%2C5%2C67.1%2C5%2C45S22.9%2C5%2C45%2C5s40%2C17.9%2C40%2C40S67.1%2C85%2C45%2C85L45%2C85z%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M62.1%2C35.7h-3.6v-9.9l0-1.6l0.1-1.8c-0.6%2C0.6-1%2C1-1.3%2C1.2l-2%2C1.6L53.6%2C23l5.5-4.4h3V35.7z%22%20%20%20%20%20%20%20%20fill%3D%22%231F65F0%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M62.1%2C18.6v17.1h-3.6v-9.9l0-1.6l0.1-1.8c-0.6%2C0.6-1%2C1-1.3%2C1.2l-2%2C1.6L53.6%2C23l5.5-4.4H62.1%20M63.1%2C17.6h-1h-3%20%20%20h-0.3l-0.3%2C0.2L53%2C22.2l-0.8%2C0.6l0.6%2C0.8l1.7%2C2.2l0.6%2C0.8l0.8-0.6l1.5-1.2l0%2C1.1l0%2C9.9v1h1h3.6h1v-1V18.6V17.6L63.1%2C17.6z%22%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%20%3Cg%20display%3D%22none%22%3E%20%20%20%20%3Cg%20display%3D%22inline%22%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M65.1%2C35.7h-12v-2.5l4.3-4.3c1.3-1.3%2C2.1-2.2%2C2.5-2.7s0.7-1%2C0.8-1.4s0.3-0.9%2C0.3-1.3c0-0.7-0.2-1.2-0.6-1.5%20%20%20s-0.9-0.5-1.5-0.5c-0.7%2C0-1.3%2C0.2-1.9%2C0.5s-1.3%2C0.7-2%2C1.3l-2-2.3c0.8-0.7%2C1.5-1.2%2C2.1-1.5s1.2-0.5%2C1.8-0.7s1.4-0.2%2C2.2-0.2%20%20%20c1.1%2C0%2C2%2C0.2%2C2.8%2C0.6s1.5%2C0.9%2C1.9%2C1.6c0.5%2C0.7%2C0.7%2C1.5%2C0.7%2C2.4c0%2C0.8-0.1%2C1.5-0.4%2C2.2c-0.3%2C0.7-0.7%2C1.4-1.3%2C2.1s-1.6%2C1.8-3.1%2C3.1%20%20%20l-2.2%2C2.1v0.2h7.5V35.7z%22%20%20%20%20%20%20%20%20fill%3D%22%23F26005%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M59.2%2C18.3c1.1%2C0%2C2%2C0.2%2C2.8%2C0.6c0.8%2C0.4%2C1.5%2C0.9%2C1.9%2C1.6c0.5%2C0.7%2C0.7%2C1.5%2C0.7%2C2.4c0%2C0.8-0.1%2C1.5-0.4%2C2.2%20%20%20c-0.3%2C0.7-0.7%2C1.4-1.3%2C2.1c-0.6%2C0.7-1.6%2C1.8-3.1%2C3.1l-2.2%2C2.1v0.2h7.5v3h-12v-2.5l4.3-4.3c1.3-1.3%2C2.1-2.2%2C2.5-2.7%20%20%20c0.4-0.5%2C0.7-1%2C0.8-1.4c0.2-0.4%2C0.3-0.9%2C0.3-1.3c0-0.7-0.2-1.2-0.6-1.5c-0.4-0.3-0.9-0.5-1.5-0.5c-0.7%2C0-1.3%2C0.2-1.9%2C0.5%20%20%20c-0.6%2C0.3-1.3%2C0.7-2%2C1.3l-2-2.3c0.8-0.7%2C1.5-1.2%2C2.1-1.5c0.6-0.3%2C1.2-0.5%2C1.8-0.7C57.7%2C18.4%2C58.4%2C18.3%2C59.2%2C18.3%20M59.2%2C17.3%20%20%20c-0.9%2C0-1.7%2C0.1-2.4%2C0.3c-0.7%2C0.2-1.4%2C0.4-2.1%2C0.8c-0.6%2C0.3-1.4%2C0.9-2.3%2C1.6l-0.8%2C0.6l0.6%2C0.8l2%2C2.3l0.6%2C0.8l0.8-0.6%20%20%20c0.6-0.5%2C1.2-0.9%2C1.8-1.2c0.5-0.2%2C1-0.4%2C1.5-0.4c0.4%2C0%2C0.7%2C0.1%2C0.9%2C0.3C60%2C22.7%2C60%2C23%2C60%2C23.4c0%2C0.3-0.1%2C0.7-0.2%2C1%20%20%20c-0.1%2C0.3-0.4%2C0.7-0.7%2C1.2c-0.4%2C0.5-1.2%2C1.4-2.4%2C2.6l-4.3%2C4.3l-0.3%2C0.3v0.4v2.5v1h1h12h1v-1v-3v-1h-1H60l0.5-0.5%20%20%20c1.5-1.4%2C2.6-2.4%2C3.2-3.2c0.6-0.8%2C1.1-1.6%2C1.4-2.4c0.3-0.8%2C0.5-1.7%2C0.5-2.6c0-1.1-0.3-2.1-0.8-3c-0.6-0.9-1.3-1.5-2.3-2%20%20%20C61.5%2C17.6%2C60.4%2C17.3%2C59.2%2C17.3L59.2%2C17.3z%22%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22Layer_2%22%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M48.5%2C43.7h8.1c0.6%2C0%2C0.9%2C0.4%2C0.9%2C0.9v1c0%2C0.6-0.4%2C0.9-0.9%2C0.9h-8.1c-0.6%2C0-0.9-0.4-0.9-0.9v-1%20%20%20C47.6%2C44%2C48%2C43.7%2C48.5%2C43.7z%22%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Crect%20x%3D%2247.6%22%20y%3D%2244.6%22%20class%3D%22st0%22%20width%3D%229%22%20height%3D%221%22%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M46.5%2C48.5v8.1c0%2C0.6-0.4%2C0.9-0.9%2C0.9h-1c-0.6%2C0-0.9-0.4-0.9-0.9v-8.1c0-0.6%2C0.4-0.9%2C0.9-0.9h1%20%20%20C46.1%2C47.6%2C46.5%2C48.1%2C46.5%2C48.5z%22%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Crect%20x%3D%2244.6%22%20y%3D%2247.6%22%20class%3D%22st0%22%20width%3D%221%22%20height%3D%229%22%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M41.6%2C46.5l-8.1%2C0c-0.6%2C0-0.9-0.4-0.9-0.9v-1c0-0.6%2C0.4-0.9%2C0.9-0.9l8.1%2C0c0.6%2C0%2C0.9%2C0.4%2C0.9%2C0.9v1%20%20%20C42.6%2C46.2%2C42.1%2C46.5%2C41.6%2C46.5z%22%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Crect%20x%3D%2233.6%22%20y%3D%2244.6%22%20class%3D%22st0%22%20width%3D%229%22%20height%3D%221%22%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M43.6%2C41.7v-8.1c0-0.6%2C0.4-0.9%2C0.9-0.9h1c0.6%2C0%2C0.9%2C0.4%2C0.9%2C0.9v8.1c0%2C0.6-0.4%2C0.9-0.9%2C0.9h-1%20%20%20C44%2C42.6%2C43.6%2C42.1%2C43.6%2C41.7z%22%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Crect%20x%3D%2244.6%22%20y%3D%2233.6%22%20class%3D%22st0%22%20width%3D%221%22%20height%3D%229%22%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var crosshair_marker_orange = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20%20version%3D%221.1%22%20%20id%3D%22svg1%22%20%20xmlns%3Asvg%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20%20x%3D%220px%22%20%20y%3D%220px%22%20%20height%3D%2290%22%20%20width%3D%2290%22%20%20viewBox%3D%220%200%2090%2090%22%20%20style%3D%22enable-background%3A%20new%200%200%2090%2090%22%20%20xml%3Aspace%3D%22preserve%22%3E%20%20%3Cg%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M45%2C89C20.7%2C89%2C1%2C69.3%2C1%2C45S20.7%2C1%2C45%2C1s44%2C19.7%2C44%2C44S69.3%2C89%2C45%2C89z%20M45%2C4C22.4%2C4%2C4%2C22.4%2C4%2C45%20%20c0%2C22.6%2C18.4%2C41%2C41%2C41c22.6%2C0%2C41-18.4%2C41-41C86%2C22.4%2C67.6%2C4%2C45%2C4z%22%20%20%20%20%20%20fill%3D%22%23F26005%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M45%2C1c24.3%2C0%2C44%2C19.7%2C44%2C44S69.3%2C89%2C45%2C89S1%2C69.3%2C1%2C45S20.7%2C1%2C45%2C1%20M45%2C86c22.6%2C0%2C41-18.4%2C41-41%20%20C86%2C22.4%2C67.6%2C4%2C45%2C4C22.4%2C4%2C4%2C22.4%2C4%2C45C4%2C67.6%2C22.4%2C86%2C45%2C86%20M45%2C0C20.2%2C0%2C0%2C20.2%2C0%2C45s20.2%2C45%2C45%2C45s45-20.2%2C45-45S69.8%2C0%2C45%2C0%20%20L45%2C0z%20M45%2C85C22.9%2C85%2C5%2C67.1%2C5%2C45S22.9%2C5%2C45%2C5s40%2C17.9%2C40%2C40S67.1%2C85%2C45%2C85L45%2C85z%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%20display%3D%22none%22%3E%20%20%20%20%3Cg%20display%3D%22inline%22%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M62.1%2C35.7h-3.6v-9.9l0-1.6l0.1-1.8c-0.6%2C0.6-1%2C1-1.3%2C1.2l-2%2C1.6L53.6%2C23l5.5-4.4h3V35.7z%22%20%20%20%20%20%20%20%20fill%3D%22%231F65F0%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M62.1%2C18.6v17.1h-3.6v-9.9l0-1.6l0.1-1.8c-0.6%2C0.6-1%2C1-1.3%2C1.2l-2%2C1.6L53.6%2C23l5.5-4.4H62.1%20M63.1%2C17.6h-1h-3%20%20%20h-0.3l-0.3%2C0.2L53%2C22.2l-0.8%2C0.6l0.6%2C0.8l1.7%2C2.2l0.6%2C0.8l0.8-0.6l1.5-1.2l0%2C1.1l0%2C9.9v1h1h3.6h1v-1V18.6V17.6L63.1%2C17.6z%22%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%20%3Cg%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M65.1%2C35.7h-12v-2.5l4.3-4.3c1.3-1.3%2C2.1-2.2%2C2.5-2.7s0.7-1%2C0.8-1.4s0.3-0.9%2C0.3-1.3c0-0.7-0.2-1.2-0.6-1.5%20%20%20s-0.9-0.5-1.5-0.5c-0.7%2C0-1.3%2C0.2-1.9%2C0.5s-1.3%2C0.7-2%2C1.3l-2-2.3c0.8-0.7%2C1.5-1.2%2C2.1-1.5s1.2-0.5%2C1.8-0.7s1.4-0.2%2C2.2-0.2%20%20%20c1.1%2C0%2C2%2C0.2%2C2.8%2C0.6s1.5%2C0.9%2C1.9%2C1.6c0.5%2C0.7%2C0.7%2C1.5%2C0.7%2C2.4c0%2C0.8-0.1%2C1.5-0.4%2C2.2c-0.3%2C0.7-0.7%2C1.4-1.3%2C2.1s-1.6%2C1.8-3.1%2C3.1%20%20%20l-2.2%2C2.1v0.2h7.5V35.7z%22%20%20%20%20%20%20%20%20fill%3D%22%23F26005%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M59.2%2C18.3c1.1%2C0%2C2%2C0.2%2C2.8%2C0.6c0.8%2C0.4%2C1.5%2C0.9%2C1.9%2C1.6c0.5%2C0.7%2C0.7%2C1.5%2C0.7%2C2.4c0%2C0.8-0.1%2C1.5-0.4%2C2.2%20%20%20c-0.3%2C0.7-0.7%2C1.4-1.3%2C2.1c-0.6%2C0.7-1.6%2C1.8-3.1%2C3.1l-2.2%2C2.1v0.2h7.5v3h-12v-2.5l4.3-4.3c1.3-1.3%2C2.1-2.2%2C2.5-2.7%20%20%20c0.4-0.5%2C0.7-1%2C0.8-1.4c0.2-0.4%2C0.3-0.9%2C0.3-1.3c0-0.7-0.2-1.2-0.6-1.5c-0.4-0.3-0.9-0.5-1.5-0.5c-0.7%2C0-1.3%2C0.2-1.9%2C0.5%20%20%20c-0.6%2C0.3-1.3%2C0.7-2%2C1.3l-2-2.3c0.8-0.7%2C1.5-1.2%2C2.1-1.5c0.6-0.3%2C1.2-0.5%2C1.8-0.7C57.7%2C18.4%2C58.4%2C18.3%2C59.2%2C18.3%20M59.2%2C17.3%20%20%20c-0.9%2C0-1.7%2C0.1-2.4%2C0.3c-0.7%2C0.2-1.4%2C0.4-2.1%2C0.8c-0.6%2C0.3-1.4%2C0.9-2.3%2C1.6l-0.8%2C0.6l0.6%2C0.8l2%2C2.3l0.6%2C0.8l0.8-0.6%20%20%20c0.6-0.5%2C1.2-0.9%2C1.8-1.2c0.5-0.2%2C1-0.4%2C1.5-0.4c0.4%2C0%2C0.7%2C0.1%2C0.9%2C0.3C60%2C22.7%2C60%2C23%2C60%2C23.4c0%2C0.3-0.1%2C0.7-0.2%2C1%20%20%20c-0.1%2C0.3-0.4%2C0.7-0.7%2C1.2c-0.4%2C0.5-1.2%2C1.4-2.4%2C2.6l-4.3%2C4.3l-0.3%2C0.3v0.4v2.5v1h1h12h1v-1v-3v-1h-1H60l0.5-0.5%20%20%20c1.5-1.4%2C2.6-2.4%2C3.2-3.2c0.6-0.8%2C1.1-1.6%2C1.4-2.4c0.3-0.8%2C0.5-1.7%2C0.5-2.6c0-1.1-0.3-2.1-0.8-3c-0.6-0.9-1.3-1.5-2.3-2%20%20%20C61.5%2C17.6%2C60.4%2C17.3%2C59.2%2C17.3L59.2%2C17.3z%22%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%20%20%3Cg%20id%3D%22Layer_2%22%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M48.5%2C43.7h8.1c0.6%2C0%2C0.9%2C0.4%2C0.9%2C0.9v1c0%2C0.6-0.4%2C0.9-0.9%2C0.9h-8.1c-0.6%2C0-0.9-0.4-0.9-0.9v-1%20%20%20C47.6%2C44%2C48%2C43.7%2C48.5%2C43.7z%22%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Crect%20x%3D%2247.6%22%20y%3D%2244.6%22%20class%3D%22st0%22%20width%3D%229%22%20height%3D%221%22%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M46.5%2C48.5v8.1c0%2C0.6-0.4%2C0.9-0.9%2C0.9h-1c-0.6%2C0-0.9-0.4-0.9-0.9v-8.1c0-0.6%2C0.4-0.9%2C0.9-0.9h1%20%20%20C46.1%2C47.6%2C46.5%2C48.1%2C46.5%2C48.5z%22%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Crect%20x%3D%2244.6%22%20y%3D%2247.6%22%20class%3D%22st0%22%20width%3D%221%22%20height%3D%229%22%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M41.6%2C46.5l-8.1%2C0c-0.6%2C0-0.9-0.4-0.9-0.9v-1c0-0.6%2C0.4-0.9%2C0.9-0.9l8.1%2C0c0.6%2C0%2C0.9%2C0.4%2C0.9%2C0.9v1%20%20%20C42.6%2C46.2%2C42.1%2C46.5%2C41.6%2C46.5z%22%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Crect%20x%3D%2233.6%22%20y%3D%2244.6%22%20class%3D%22st0%22%20width%3D%229%22%20height%3D%221%22%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M43.6%2C41.7v-8.1c0-0.6%2C0.4-0.9%2C0.9-0.9h1c0.6%2C0%2C0.9%2C0.4%2C0.9%2C0.9v8.1c0%2C0.6-0.4%2C0.9-0.9%2C0.9h-1%20%20%20C44%2C42.6%2C43.6%2C42.1%2C43.6%2C41.7z%22%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Crect%20x%3D%2244.6%22%20y%3D%2233.6%22%20class%3D%22st0%22%20width%3D%221%22%20height%3D%229%22%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var crosshair_with_circle = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20%20version%3D%221.1%22%20%20id%3D%22svg1%22%20%20xmlns%3Asvg%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20%20width%3D%2290%22%20%20height%3D%2290%22%20%20viewBox%3D%220%200%2090%2090%22%20%20style%3D%22enable-background%3A%20new%200%200%2090%2090%22%20%20xml%3Aspace%3D%22preserve%22%3E%20%20%3Cg%20id%3D%22path19%22%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M45%2C89C20.7%2C89%2C1%2C69.3%2C1%2C45S20.7%2C1%2C45%2C1s44%2C19.7%2C44%2C44S69.3%2C89%2C45%2C89z%20M45%2C2C21.3%2C2%2C2%2C21.3%2C2%2C45s19.3%2C43%2C43%2C43%20%20s43-19.3%2C43-43S68.7%2C2%2C45%2C2z%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M45%2C1c24.3%2C0%2C44%2C19.7%2C44%2C44S69.3%2C89%2C45%2C89S1%2C69.3%2C1%2C45S20.7%2C1%2C45%2C1%20M45%2C88c23.7%2C0%2C43-19.3%2C43-43S68.7%2C2%2C45%2C2%20%20S2%2C21.3%2C2%2C45S21.3%2C88%2C45%2C88%20M45%2C0C20.2%2C0%2C0%2C20.2%2C0%2C45s20.2%2C45%2C45%2C45s45-20.2%2C45-45S69.8%2C0%2C45%2C0L45%2C0z%20M45%2C87C21.8%2C87%2C3%2C68.2%2C3%2C45%20%20S21.8%2C3%2C45%2C3s42%2C18.8%2C42%2C42S68.2%2C87%2C45%2C87L45%2C87z%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M48.4%2C43.6h8.1c0.6%2C0%2C0.9%2C0.4%2C0.9%2C0.9v1c0%2C0.6-0.4%2C0.9-0.9%2C0.9h-8.1c-0.6%2C0-0.9-0.4-0.9-0.9v-1%20%20C47.5%2C43.9%2C48%2C43.6%2C48.4%2C43.6z%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%20%20%3Crect%20x%3D%2247.5%22%20y%3D%2244.5%22%20width%3D%229%22%20height%3D%221%22%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M46.4%2C48.4v8.1c0%2C0.6-0.4%2C0.9-0.9%2C0.9h-1c-0.6%2C0-0.9-0.4-0.9-0.9v-8.1c0-0.6%2C0.4-0.9%2C0.9-0.9h1%20%20C46.1%2C47.5%2C46.4%2C48%2C46.4%2C48.4z%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%20%20%3Crect%20x%3D%2244.5%22%20y%3D%2247.5%22%20width%3D%221%22%20height%3D%229%22%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M41.6%2C46.4h-8.1c-0.6%2C0-0.9-0.4-0.9-0.9v-1c0-0.6%2C0.4-0.9%2C0.9-0.9h8.1c0.6%2C0%2C0.9%2C0.4%2C0.9%2C0.9v1%20%20C42.5%2C46.1%2C42%2C46.4%2C41.6%2C46.4z%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%20%20%3Crect%20x%3D%2233.5%22%20y%3D%2244.5%22%20width%3D%229%22%20height%3D%221%22%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M43.6%2C41.6v-8.1c0-0.6%2C0.4-0.9%2C0.9-0.9h1c0.6%2C0%2C0.9%2C0.4%2C0.9%2C0.9v8.1c0%2C0.6-0.4%2C0.9-0.9%2C0.9h-1%20%20C43.9%2C42.5%2C43.6%2C42%2C43.6%2C41.6z%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%20%20%3Crect%20x%3D%2244.5%22%20y%3D%2233.5%22%20width%3D%221%22%20height%3D%229%22%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var flagMarkerHovered = "data:image/svg+xml,%3Csvg%20%20width%3D%2217%22%20%20height%3D%2217%22%20%20viewBox%3D%220%200%2017%2017%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20d%3D%22M14.0247%205.07739L5.15358%201.47295C5.15358%201.47295%205.15358%201.47295%205.14913%201.47295H5.1358C5.1358%201.47295%205.11358%201.46406%205.10469%201.45962C5.02469%201.42851%204.94024%201.40628%204.8558%201.39295C4.82024%201.38851%204.78913%201.38406%204.75358%201.38406C4.71358%201.38406%204.67802%201.37073%204.63358%201.37073C4.60691%201.37073%204.58024%201.37517%204.55358%201.37962C4.51802%201.37962%204.48247%201.38406%204.44691%201.38851C4.3758%201.39739%204.30913%201.41517%204.24247%201.43739C4.2158%201.44628%204.18469%201.45073%204.15802%201.46406C3.96691%201.53517%203.80247%201.65073%203.66469%201.79739C3.64247%201.81962%203.62913%201.84184%203.60691%201.86406C3.56247%201.91739%203.52247%201.97517%203.48691%202.03739C3.46913%202.06406%203.4558%202.09517%203.44247%202.12184C3.41135%202.18406%203.38469%202.25517%203.36691%202.32184C3.35802%202.34851%203.34913%202.37517%203.34024%202.40184C3.31802%202.49962%203.30469%202.59739%203.30469%202.70406V14.2596C3.30469%2014.9974%203.90024%2015.5929%204.63802%2015.5929C5.3758%2015.5929%205.97135%2014.9974%205.97135%2014.2596V10.8241L14.0291%207.55295C14.5314%207.34851%2014.8602%206.85962%2014.8602%206.31739C14.8602%205.77517%2014.5314%205.28628%2014.0291%205.08184L14.0247%205.07739Z%22%20%20%20%20fill%3D%22%23082A6E%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M5.9668%207.28184V5.34407C5.9668%205.02851%206.2868%204.81518%206.58013%204.93073L10.2157%206.09962C10.4201%206.16629%2010.4201%206.45518%2010.2157%206.52184L6.58013%207.69073C6.2868%207.81073%205.9668%207.59295%205.9668%207.2774V7.28184Z%22%20%20%20%20fill%3D%22white%22%20%20%2F%3E%3C%2Fsvg%3E";

var flagMarkerSelected = "data:image/svg+xml,%3Csvg%20%20width%3D%2217%22%20%20height%3D%2217%22%20%20viewBox%3D%220%200%2017%2017%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20d%3D%22M13.9466%205.07739L5.07545%201.47295C5.07545%201.47295%205.07545%201.47295%205.07101%201.47295H5.05767C5.05767%201.47295%205.03545%201.46406%205.02656%201.45962C4.94656%201.42851%204.86212%201.40628%204.77767%201.39295C4.74212%201.38851%204.71101%201.38406%204.67545%201.38406C4.63545%201.38406%204.5999%201.37073%204.55545%201.37073C4.52878%201.37073%204.50212%201.37517%204.47545%201.37962C4.4399%201.37962%204.40434%201.38406%204.36878%201.38851C4.29767%201.39739%204.23101%201.41517%204.16434%201.43739C4.13767%201.44628%204.10656%201.45073%204.0799%201.46406C3.88878%201.53517%203.72434%201.65073%203.58656%201.79739C3.56434%201.81962%203.55101%201.84184%203.52878%201.86406C3.48434%201.91739%203.44434%201.97517%203.40878%202.03739C3.39101%202.06406%203.37767%202.09517%203.36434%202.12184C3.33323%202.18406%203.30656%202.25517%203.28878%202.32184C3.2799%202.34851%203.27101%202.37517%203.26212%202.40184C3.2399%202.49962%203.22656%202.59739%203.22656%202.70406V14.2596C3.22656%2014.9974%203.82212%2015.5929%204.5599%2015.5929C5.29767%2015.5929%205.89323%2014.9974%205.89323%2014.2596V10.8241L13.951%207.55295C14.4532%207.34851%2014.7821%206.85962%2014.7821%206.31739C14.7821%205.77517%2014.4532%205.28628%2013.951%205.08184L13.9466%205.07739Z%22%20%20%20%20fill%3D%22%231F65F0%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M5.88867%207.28184V5.34407C5.88867%205.02851%206.20867%204.81518%206.50201%204.93073L10.1376%206.09962C10.342%206.16629%2010.342%206.45518%2010.1376%206.52184L6.50201%207.69073C6.20867%207.81073%205.88867%207.59295%205.88867%207.2774V7.28184Z%22%20%20%20%20fill%3D%22white%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M4.55513%201.36631C4.59513%201.36631%204.63513%201.37519%204.67513%201.37964C4.71069%201.37964%204.7418%201.38408%204.77735%201.38853C4.86624%201.40186%204.94624%201.42408%205.02624%201.45519C5.03513%201.45519%205.04846%201.45519%205.05735%201.46408H5.07069C5.07069%201.46408%205.07069%201.47297%205.07513%201.47297L13.9462%205.07742C14.4485%205.28186%2014.7774%205.77075%2014.7774%206.31297C14.7774%206.8552%2014.4485%207.34408%2013.9462%207.54853L5.88846%2010.8196V14.2552C5.88846%2014.993%205.29291%2015.5885%204.55513%2015.5885C3.81735%2015.5885%203.2218%2014.993%203.2218%2014.2552V2.69964C3.2218%202.59742%203.23513%202.49519%203.25735%202.39742C3.2618%202.37075%203.27513%202.34408%203.28402%202.31742C3.30624%202.24631%203.32846%202.17964%203.35957%202.11742C3.37291%202.08631%203.39069%202.05964%203.40402%202.03297C3.43957%201.97075%203.47957%201.91297%203.52402%201.85964C3.5418%201.83742%203.55957%201.81519%203.5818%201.79297C3.71957%201.64631%203.88402%201.53519%204.07513%201.45964C4.1018%201.45075%204.12846%201.44186%204.15957%201.43297C4.22624%201.41075%204.29291%201.39742%204.36402%201.38408C4.39957%201.37964%204.43513%201.37519%204.47069%201.37519C4.49735%201.37519%204.52402%201.36631%204.55069%201.36631M4.55513%200.477417C4.5018%200.477417%204.44846%200.481861%204.39513%200.49075C4.3418%200.49075%204.29291%200.499639%204.24402%200.508528C4.12846%200.526306%204.01735%200.548528%203.9018%200.584084C3.84846%200.597417%203.80402%200.615195%203.76402%200.628528C3.45291%200.748528%203.16846%200.939639%202.9418%201.17964C2.91069%201.21519%202.87957%201.25075%202.85291%201.28631C2.77291%201.38408%202.70624%201.48186%202.64846%201.57964C2.6218%201.62853%202.59513%201.67297%202.57291%201.72186C2.52402%201.82408%202.47957%201.93075%202.44402%202.05519C2.42624%202.10408%202.41291%202.14853%202.40402%202.19297C2.36402%202.37075%202.3418%202.53519%202.3418%202.69964V14.2552C2.3418%2015.4819%203.33735%2016.4774%204.56402%2016.4774C5.79069%2016.4774%206.78624%2015.4819%206.78624%2014.2552V11.4196L14.2885%208.37075C15.1285%208.02853%2015.6751%207.21964%2015.6751%206.31297C15.6751%205.40631%2015.1329%204.59742%2014.2885%204.25519L5.41291%200.65075L5.39069%200.641861C5.35513%200.628528%205.31957%200.615195%205.28846%200.606306C5.16846%200.566306%205.04846%200.535195%204.91957%200.512973C4.87069%200.504084%204.81735%200.499639%204.76846%200.495195C4.68846%200.481861%204.6218%200.477417%204.55513%200.477417Z%22%20%20%20%20fill%3D%22black%22%20%20%2F%3E%3C%2Fsvg%3E";

var flagMarker = "data:image/svg+xml,%3Csvg%20%20width%3D%2217%22%20%20height%3D%2217%22%20%20viewBox%3D%220%200%2017%2017%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20d%3D%22M14.0247%205.07739L5.15358%201.47295C5.15358%201.47295%205.15358%201.47295%205.14913%201.47295H5.1358C5.1358%201.47295%205.11358%201.46406%205.10469%201.45962C5.02469%201.42851%204.94024%201.40628%204.8558%201.39295C4.82024%201.38851%204.78913%201.38406%204.75358%201.38406C4.71358%201.38406%204.67802%201.37073%204.63358%201.37073C4.60691%201.37073%204.58024%201.37517%204.55358%201.37962C4.51802%201.37962%204.48247%201.38406%204.44691%201.38851C4.3758%201.39739%204.30913%201.41517%204.24247%201.43739C4.2158%201.44628%204.18469%201.45073%204.15802%201.46406C3.96691%201.53517%203.80247%201.65073%203.66469%201.79739C3.64247%201.81962%203.62913%201.84184%203.60691%201.86406C3.56247%201.91739%203.52247%201.97517%203.48691%202.03739C3.46913%202.06406%203.4558%202.09517%203.44247%202.12184C3.41135%202.18406%203.38469%202.25517%203.36691%202.32184C3.35802%202.34851%203.34913%202.37517%203.34024%202.40184C3.31802%202.49962%203.30469%202.59739%203.30469%202.70406V14.2596C3.30469%2014.9974%203.90024%2015.5929%204.63802%2015.5929C5.3758%2015.5929%205.97135%2014.9974%205.97135%2014.2596V10.8241L14.0291%207.55295C14.5314%207.34851%2014.8602%206.85962%2014.8602%206.31739C14.8602%205.77517%2014.5314%205.28628%2014.0291%205.08184L14.0247%205.07739Z%22%20%20%20%20fill%3D%22%231F65F0%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M5.9668%207.28184V5.34407C5.9668%205.02851%206.2868%204.81518%206.58013%204.93073L10.2157%206.09962C10.4201%206.16629%2010.4201%206.45518%2010.2157%206.52184L6.58013%207.69073C6.2868%207.81073%205.9668%207.59295%205.9668%207.2774V7.28184Z%22%20%20%20%20fill%3D%22white%22%20%20%2F%3E%3C%2Fsvg%3E";

var folder = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20%20version%3D%221.1%22%20%20id%3D%22Layer_1%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20%20x%3D%220px%22%20%20y%3D%220px%22%20%20width%3D%2236px%22%20%20height%3D%2236px%22%20%20viewBox%3D%220%200%2036%2036%22%20%20enable-background%3D%22new%200%200%2036%2036%22%20%20xml%3Aspace%3D%22preserve%22%3E%20%20%3Cg%3E%20%20%20%20%3Crect%20fill%3D%22none%22%20width%3D%2236%22%20height%3D%2236%22%20%2F%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%20%20%20%20d%3D%22M11.17%2C8l4%2C4H32v16H4V8.5C4%2C8.22%2C4.22%2C8%2C4.5%2C8H11.17%20M12%2C6H4C2.9%2C6%2C2%2C6.9%2C2%2C8v22h32V10H16L12%2C6L12%2C6z%22%20%20%20%20%20%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var lensActive = "data:image/svg+xml,%3Csvg%20%20width%3D%22128%22%20%20height%3D%22128%22%20%20viewBox%3D%220%200%20128%20128%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M126%2064C126%2029.81%2098.19%202%2064%202C29.81%202%202%2029.81%202%2064C2%2098.19%2029.81%20126%2064%20126C98.19%20126%20126%2098.19%20126%2064ZM0%2064C0%2028.65%2028.65%200%2064%200C99.35%200%20128%2028.65%20128%2064C128%2099.35%2099.35%20128%2064%20128C28.65%20128%200%2099.35%200%2064ZM119.23%2063.78C119.23%2033.45%2094.56%208.78003%2064.23%208.78003C33.9%208.78003%209.23%2033.45%209.23%2063.78C9.23%2094.11%2033.9%20118.78%2064.23%20118.78C94.56%20118.78%20119.23%2094.11%20119.23%2063.78ZM7.23%2063.78C7.23%2032.3%2032.75%206.78003%2064.23%206.78003C95.71%206.78003%20121.23%2032.3%20121.23%2063.78C121.23%2095.26%2095.71%20120.78%2064.23%20120.78C32.75%20120.78%207.23%2095.26%207.23%2063.78ZM69.67%2061.04H80.33C81.11%2061.04%2081.5%2061.81%2081.5%2062.98V65.11C81.5%2066.27%2080.98%2067.05%2080.33%2067.05H69.67C68.89%2067.05%2068.5%2066.28%2068.5%2065.11V62.98C68.5%2061.63%2069.15%2061.04%2069.67%2061.04ZM47.67%2067.04H58.33C58.85%2067.04%2059.5%2066.45%2059.5%2065.1V62.97C59.5%2061.8%2059.11%2061.03%2058.33%2061.03H47.67C47.02%2061.03%2046.5%2061.81%2046.5%2062.97V65.1C46.5%2066.27%2046.89%2067.04%2047.67%2067.04ZM61%2058.37V47.71C61%2046.93%2061.77%2046.54%2062.94%2046.54H65.07C66.23%2046.54%2067.01%2047.06%2067.01%2047.71V58.37C67.01%2059.15%2066.24%2059.54%2065.07%2059.54H62.94C61.59%2059.54%2061%2058.89%2061%2058.37ZM61%2069.63V80.29C61%2080.81%2061.59%2081.46%2062.94%2081.46H65.07C66.24%2081.46%2067.01%2081.07%2067.01%2080.29V69.63C67.01%2068.98%2066.23%2068.46%2065.07%2068.46H62.94C61.77%2068.46%2061%2068.85%2061%2069.63Z%22%20%20%20%20fill%3D%22white%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20d%3D%22M64.23%206.78003C95.66%206.78003%20121.23%2032.35%20121.23%2063.78C121.23%2095.21%2095.66%20120.78%2064.23%20120.78C32.8%20120.78%207.23%2095.21%207.23%2063.78C7.23%2032.35%2032.8%206.78003%2064.23%206.78003ZM64.23%201.78003C29.99%201.78003%202.23%2029.54%202.23%2063.78C2.23%2098.02%2029.99%20125.78%2064.23%20125.78C98.47%20125.78%20126.23%2098.02%20126.23%2063.78C126.23%2029.54%2098.47%201.78003%2064.23%201.78003ZM81%2062.54H69V65.54H81V62.54ZM47%2062.54H59V65.54H47V62.54ZM65.5%2047.04H62.5V59.04H65.5V47.04ZM62.5%2068.96H65.5V80.96H62.5V68.96Z%22%20%20%20%20fill%3D%22black%22%20%20%2F%3E%3C%2Fsvg%3E";

var lensDefault = "data:image/svg+xml,%3Csvg%20%20width%3D%22128%22%20%20height%3D%22128%22%20%20viewBox%3D%220%200%20128%20128%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cg%20clip-path%3D%22url%28%23clip0_1687_38205%29%22%3E%20%20%20%20%3Cpath%20%20%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20%20%20d%3D%22M126%2064C126%2029.81%2098.19%202%2064%202C29.81%202%202%2029.81%202%2064C2%2098.19%2029.81%20126%2064%20126C98.19%20126%20126%2098.19%20126%2064ZM0%2064C0%2028.65%2028.65%200%2064%200C99.35%200%20128%2028.65%20128%2064C128%2099.35%2099.35%20128%2064%20128C28.65%20128%200%2099.35%200%2064ZM80.33%2061.04H69.67C69.15%2061.04%2068.5%2061.63%2068.5%2062.98V65.11C68.5%2066.28%2068.89%2067.05%2069.67%2067.05H80.33C80.98%2067.05%2081.5%2066.27%2081.5%2065.11V62.98C81.5%2061.81%2081.11%2061.04%2080.33%2061.04ZM58.33%2067.04H47.67C46.89%2067.04%2046.5%2066.27%2046.5%2065.1V62.97C46.5%2061.81%2047.02%2061.03%2047.67%2061.03H58.33C59.11%2061.03%2059.5%2061.8%2059.5%2062.97V65.1C59.5%2066.45%2058.85%2067.04%2058.33%2067.04ZM61%2047.71V58.37C61%2058.89%2061.59%2059.54%2062.94%2059.54H65.07C66.24%2059.54%2067.01%2059.15%2067.01%2058.37V47.71C67.01%2047.06%2066.23%2046.54%2065.07%2046.54H62.94C61.77%2046.54%2061%2046.93%2061%2047.71ZM61%2080.29V69.63C61%2068.85%2061.77%2068.46%2062.94%2068.46H65.07C66.23%2068.46%2067.01%2068.98%2067.01%2069.63V80.29C67.01%2081.07%2066.24%2081.46%2065.07%2081.46H62.94C61.59%2081.46%2061%2080.81%2061%2080.29ZM121%2064C121%2032.57%2095.43%207%2064%207C32.57%207%207%2032.57%207%2064C7%2095.43%2032.57%20121%2064%20121C95.43%20121%20121%2095.43%20121%2064ZM5%2064C5%2031.42%2031.42%205%2064%205C96.58%205%20123%2031.42%20123%2064C123%2096.58%2096.58%20123%2064%20123C31.42%20123%205%2096.58%205%2064Z%22%20%20%20%20%20%20fill%3D%22white%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20%20%20clip-rule%3D%22evenodd%22%20%20%20%20%20%20d%3D%22M64%205C96.53%205%20123%2031.47%20123%2064C123%2096.53%2096.53%20123%2064%20123C31.47%20123%205%2096.53%205%2064C5%2031.47%2031.47%205%2064%205ZM64%202C29.76%202%202%2029.76%202%2064C2%2098.24%2029.76%20126%2064%20126C98.24%20126%20126%2098.24%20126%2064C126%2029.76%2098.24%202%2064%202ZM81%2062.54H69V65.54H81V62.54ZM47%2062.54H59V65.54H47V62.54ZM62.5%2047.04V59.04H65.5V47.04H62.5ZM62.5%2080.96V68.96H65.5V80.96H62.5Z%22%20%20%20%20%20%20fill%3D%22black%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cdefs%3E%20%20%20%20%3CclipPath%20id%3D%22clip0_1687_38205%22%3E%20%20%20%20%20%20%3Crect%20width%3D%22128%22%20height%3D%22128%22%20fill%3D%22white%22%20%2F%3E%20%20%20%20%3C%2FclipPath%3E%20%20%3C%2Fdefs%3E%3C%2Fsvg%3E";

var lensNoCircle = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20%20id%3D%22Layer_1%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20%20version%3D%221.1%22%20%20width%3D%22128%22%20%20height%3D%22128%22%20%20viewBox%3D%220%200%20128%20128%22%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%3CclipPath%20id%3D%22clippath%22%3E%20%20%20%20%20%20%3Crect%20width%3D%22128%22%20height%3D%22128%22%20fill%3D%22none%22%20%2F%3E%20%20%20%20%3C%2FclipPath%3E%20%20%3C%2Fdefs%3E%20%20%3Cg%20clip-path%3D%22url%28%23clippath%29%22%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M80.3%2C61h-10.7c-.5%2C0-1.2.6-1.2%2C1.9v2.1c0%2C1.2.4%2C1.9%2C1.2%2C1.9h10.7c.7%2C0%2C1.2-.8%2C1.2-1.9v-2.1c0-1.2-.4-1.9-1.2-1.9Z%22%20%20%20%20%20%20%20%20fill%3D%22%23fff%22%20%20%20%20%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M58.3%2C67h-10.7c-.8%2C0-1.2-.8-1.2-1.9v-2.1c0-1.2.5-1.9%2C1.2-1.9h10.7c.8%2C0%2C1.2.8%2C1.2%2C1.9v2.1c0%2C1.3-.7%2C1.9-1.2%2C1.9Z%22%20%20%20%20%20%20%20%20fill%3D%22%23fff%22%20%20%20%20%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M61%2C47.7v10.7c0%2C.5.6%2C1.2%2C1.9%2C1.2h2.1c1.2%2C0%2C1.9-.4%2C1.9-1.2v-10.7c0-.6-.8-1.2-1.9-1.2h-2.1c-1.2%2C0-1.9.4-1.9%2C1.2Z%22%20%20%20%20%20%20%20%20fill%3D%22%23fff%22%20%20%20%20%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20d%3D%22M61%2C80.3v-10.7c0-.8.8-1.2%2C1.9-1.2h2.1c1.2%2C0%2C1.9.5%2C1.9%2C1.2v10.7c0%2C.8-.8%2C1.2-1.9%2C1.2h-2.1c-1.3%2C0-1.9-.7-1.9-1.2Z%22%20%20%20%20%20%20%20%20fill%3D%22%23fff%22%20%20%20%20%20%20%20%20fill-rule%3D%22evenodd%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Crect%20x%3D%2269%22%20y%3D%2262.5%22%20width%3D%2212%22%20height%3D%223%22%20%2F%3E%20%20%20%20%20%20%3Crect%20x%3D%2247%22%20y%3D%2262.5%22%20width%3D%2212%22%20height%3D%223%22%20%2F%3E%20%20%20%20%20%20%3Crect%20x%3D%2262.5%22%20y%3D%2247%22%20width%3D%223%22%20height%3D%2212%22%20%2F%3E%20%20%20%20%20%20%3Crect%20x%3D%2262.5%22%20y%3D%2269%22%20width%3D%223%22%20height%3D%2212%22%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var lineHandler = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20%20version%3D%221.1%22%20%20id%3D%22Layer_1%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20%20x%3D%220px%22%20%20y%3D%220px%22%20%20width%3D%229px%22%20%20height%3D%229px%22%20%20viewBox%3D%220%200%209%209%22%20%20enable-background%3D%22new%200%200%209%209%22%20%20xml%3Aspace%3D%22preserve%22%3E%20%20%3Cg%20id%3D%22Start_Point%22%20transform%3D%22translate%281%201%29%22%3E%20%20%20%20%3Ccircle%20opacity%3D%220.5%22%20fill%3D%22%23363C4D%22%20cx%3D%223.5%22%20cy%3D%223.5%22%20r%3D%224.5%22%20%2F%3E%20%20%20%20%3Ccircle%20fill%3D%22%23FFFFFF%22%20cx%3D%223.5%22%20cy%3D%223.5%22%20r%3D%224%22%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var locationMarkerPopover = "data:image/svg+xml,%3Csvg%20%20width%3D%2248%22%20%20height%3D%2248%22%20%20viewBox%3D%220%200%2048%2048%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Crect%20width%3D%2248%22%20height%3D%2248%22%20rx%3D%224%22%20fill%3D%22%2315191F%22%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M38.7681%2020.3064L13.4453%209.19141V38.7786H15.5564V30.4925L38.7681%2020.3064ZM15.5564%2028.1914V12.4214L33.5114%2020.3064L15.5564%2028.1914Z%22%20%20%20%20fill%3D%22%23F0F2F5%22%20%20%2F%3E%3C%2Fsvg%3E";

var Location = "data:image/svg+xml,%3Csvg%20%20id%3D%22Location%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2236%22%20%20height%3D%2236%22%20%20viewBox%3D%220%200%2036%2036%22%3E%20%20%3Cg%20%20%20%20id%3D%22Raggruppa_2850%22%20%20%20%20data-name%3D%22Raggruppa%202850%22%20%20%20%20transform%3D%22translate%28-8648%20-50%29%22%20%20%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22Tracciato_10223%22%20%20%20%20%20%20data-name%3D%22Tracciato%2010223%22%20%20%20%20%20%20d%3D%22M10%2C.8C15.523.8%2C20%2C4.477%2C20%2C10c0%2C3.822-1.789%2C8.739-5.217%2C10.565C13.754%2C23.245%2C11.7%2C28.082%2C10%2C28.082c-1.856%2C0-3.359-5.1-5.162-7.517C2.153%2C18.982%2C0%2C13.667%2C0%2C10%2C0%2C4.477%2C4.477.8%2C10%2C.8Z%22%20%20%20%20%20%20transform%3D%22translate%288656%2053%29%22%20%20%20%20%20%20fill%3D%22%23ff4500%22%20%20%20%20%20%20opacity%3D%220.8%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22Tracciato_2787%22%20%20%20%20%20%20data-name%3D%22Tracciato%202787%22%20%20%20%20%20%20d%3D%22M8666%2C83.32l-.771-.933a61.375%2C61.375%2C0%2C0%2C1-8.4-14.169c-1.683-4.094-1.535-8.089.405-10.962%2C1.765-2.612%2C4.881-4.068%2C8.776-4.006%2C3.893-.044%2C7%2C1.4%2C8.761%2C4.006%2C1.94%2C2.873%2C2.088%2C6.868.405%2C10.962a61.375%2C61.375%2C0%2C0%2C1-8.4%2C14.169Zm-.1-28.07c-3.212%2C0-5.63%2C1.08-7.013%2C3.126-1.559%2C2.308-1.637%2C5.618-.213%2C9.081A60.541%2C60.541%2C0%2C0%2C0%2C8666%2C80.122a60.541%2C60.541%2C0%2C0%2C0%2C7.324-12.665c1.424-3.463%2C1.346-6.773-.213-9.081-1.4-2.069-3.9-3.157-7.1-3.126Z%22%20%20%20%20%20%20fill%3D%22%23252527%22%20%20%20%20%2F%3E%20%20%20%20%3Ccircle%20%20%20%20%20%20id%3D%22Ellisse_3117%22%20%20%20%20%20%20data-name%3D%22Ellisse%203117%22%20%20%20%20%20%20cx%3D%224%22%20%20%20%20%20%20cy%3D%224%22%20%20%20%20%20%20r%3D%224%22%20%20%20%20%20%20transform%3D%22translate%288662%2059%29%22%20%20%20%20%20%20fill%3D%22%23f9fbfc%22%20%20%20%20%20%20opacity%3D%220.8%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_4240%22%20%20%20%20data-name%3D%22Rettangolo%204240%22%20%20%20%20width%3D%2236%22%20%20%20%20height%3D%2236%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%3C%2Fsvg%3E";

var Location_FullOpaque = "data:image/svg+xml,%3Csvg%20%20id%3D%22Location%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2236%22%20%20height%3D%2236%22%20%20viewBox%3D%220%200%2036%2036%22%3E%20%20%3Cg%20%20%20%20id%3D%22Raggruppa_2850%22%20%20%20%20data-name%3D%22Raggruppa%202850%22%20%20%20%20transform%3D%22translate%28-8648%20-50%29%22%20%20%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22Tracciato_10223%22%20%20%20%20%20%20data-name%3D%22Tracciato%2010223%22%20%20%20%20%20%20d%3D%22M10%2C.8C15.523.8%2C20%2C4.477%2C20%2C10c0%2C3.822-1.789%2C8.739-5.217%2C10.565C13.754%2C23.245%2C11.7%2C28.082%2C10%2C28.082c-1.856%2C0-3.359-5.1-5.162-7.517C2.153%2C18.982%2C0%2C13.667%2C0%2C10%2C0%2C4.477%2C4.477.8%2C10%2C.8Z%22%20%20%20%20%20%20transform%3D%22translate%288656%2053%29%22%20%20%20%20%20%20fill%3D%22%23ff4500%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22Tracciato_2787%22%20%20%20%20%20%20data-name%3D%22Tracciato%202787%22%20%20%20%20%20%20d%3D%22M8666%2C83.32l-.771-.933a61.375%2C61.375%2C0%2C0%2C1-8.4-14.169c-1.683-4.094-1.535-8.089.405-10.962%2C1.765-2.612%2C4.881-4.068%2C8.776-4.006%2C3.893-.044%2C7%2C1.4%2C8.761%2C4.006%2C1.94%2C2.873%2C2.088%2C6.868.405%2C10.962a61.375%2C61.375%2C0%2C0%2C1-8.4%2C14.169Zm-.1-28.07c-3.212%2C0-5.63%2C1.08-7.013%2C3.126-1.559%2C2.308-1.637%2C5.618-.213%2C9.081A60.541%2C60.541%2C0%2C0%2C0%2C8666%2C80.122a60.541%2C60.541%2C0%2C0%2C0%2C7.324-12.665c1.424-3.463%2C1.346-6.773-.213-9.081-1.4-2.069-3.9-3.157-7.1-3.126Z%22%20%20%20%20%20%20fill%3D%22%23252527%22%20%20%20%20%2F%3E%20%20%20%20%3Ccircle%20%20%20%20%20%20id%3D%22Ellisse_3117%22%20%20%20%20%20%20data-name%3D%22Ellisse%203117%22%20%20%20%20%20%20cx%3D%224%22%20%20%20%20%20%20cy%3D%224%22%20%20%20%20%20%20r%3D%224%22%20%20%20%20%20%20transform%3D%22translate%288662%2059%29%22%20%20%20%20%20%20fill%3D%22%23f9fbfc%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_4240%22%20%20%20%20data-name%3D%22Rettangolo%204240%22%20%20%20%20width%3D%2236%22%20%20%20%20height%3D%2236%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%3C%2Fsvg%3E";

var location_placeholder_default = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20%20id%3D%22Livello_2%22%20%20data-name%3D%22Livello%202%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%22100%22%20%20height%3D%22100%22%20%20viewBox%3D%220%200%20100%20100%22%3E%20%20%3Cg%20id%3D%22Livello_1-2%22%20data-name%3D%22Livello%201-2%22%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%3Ccircle%20%20%20%20%20%20%20%20r%3D%2230%22%20%20%20%20%20%20%20%20cx%3D%2250%22%20%20%20%20%20%20%20%20cy%3D%2250%22%20%20%20%20%20%20%20%20stroke%3D%22black%22%20%20%20%20%20%20%20%20opacity%3D%220.25%22%20%20%20%20%20%20%20%20stroke-width%3D%2220%22%20%20%20%20%20%20%20%20fill%3D%22none%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Ccircle%20%20%20%20%20%20%20%20r%3D%2230%22%20%20%20%20%20%20%20%20cx%3D%2250%22%20%20%20%20%20%20%20%20cy%3D%2250%22%20%20%20%20%20%20%20%20stroke%3D%22white%22%20%20%20%20%20%20%20%20stroke-width%3D%2214%22%20%20%20%20%20%20%20%20fill%3D%22none%22%20%20%20%20%20%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var location_placeholder_hover = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20%20id%3D%22Livello_2%22%20%20data-name%3D%22Livello%202%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%22100%22%20%20height%3D%22100%22%20%20viewBox%3D%220%200%20100%20100%22%3E%20%20%3Cg%20id%3D%22Livello_1-2%22%20data-name%3D%22Livello%201-2%22%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%3Ccircle%20%20%20%20%20%20%20%20r%3D%2230%22%20%20%20%20%20%20%20%20cx%3D%2250%22%20%20%20%20%20%20%20%20cy%3D%2250%22%20%20%20%20%20%20%20%20stroke%3D%22black%22%20%20%20%20%20%20%20%20opacity%3D%220.25%22%20%20%20%20%20%20%20%20stroke-width%3D%2220%22%20%20%20%20%20%20%20%20fill%3D%22none%22%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3Ccircle%20%20%20%20%20%20%20%20r%3D%2230%22%20%20%20%20%20%20%20%20cx%3D%2250%22%20%20%20%20%20%20%20%20cy%3D%2250%22%20%20%20%20%20%20%20%20stroke%3D%22white%22%20%20%20%20%20%20%20%20stroke-width%3D%2214%22%20%20%20%20%20%20%20%20fill%3D%22none%22%20%20%20%20%20%20%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var map = "data:image/svg+xml,%3Csvg%20%20id%3D%22Map%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2216%22%20%20height%3D%2216%22%20%20viewBox%3D%220%200%2016%2016%22%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_6242%22%20%20%20%20data-name%3D%22Rettangolo%206242%22%20%20%20%20width%3D%2216%22%20%20%20%20height%3D%2216%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%20%20%3Cg%20%20%20%20id%3D%22Raggruppa_11825%22%20%20%20%20data-name%3D%22Raggruppa%2011825%22%20%20%20%20transform%3D%22translate%281%201.381%29%22%20%20%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22Tracciato_10097%22%20%20%20%20%20%20data-name%3D%22Tracciato%2010097%22%20%20%20%20%20%20d%3D%22M26.368%2C5.754%2C30.157%2C6.97v8.488l-3.492-1.122-.44-.141-.391.246-3.813%2C2.392-3.778-1.04v-8.5l3.523.969.421.116.37-.232Zm-.136-1.087L22.029%2C7.3%2C17.25%2C5.991V16.548l4.928%2C1.357%2C4.183-2.625L31.15%2C16.82V6.246Z%22%20%20%20%20%20%20transform%3D%22translate%28-17.25%20-4.667%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22Tracciato_10256%22%20%20%20%20%20%20data-name%3D%22Tracciato%2010256%22%20%20%20%20%20%20d%3D%22M36.75%2C13a1.5%2C1.5%2C0%2C1%2C1-1.5-1.5%2C1.5%2C1.5%2C0%2C0%2C1%2C1.5%2C1.5%22%20%20%20%20%20%20transform%3D%22translate%28-26.12%20-8.112%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%20%20%3Cpath%20%20%20%20%20%20id%3D%22Tracciato_10257%22%20%20%20%20%20%20data-name%3D%22Tracciato%2010257%22%20%20%20%20%20%20d%3D%22M36.75%2C13a1.5%2C1.5%2C0%2C1%2C1-1.5-1.5%2C1.5%2C1.5%2C0%2C0%2C1%2C1.5%2C1.5%22%20%20%20%20%20%20transform%3D%22translate%28-30.916%20-4.651%29%22%20%20%20%20%20%20fill%3D%22currentColor%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var markup = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20%20id%3D%22Livello_2%22%20%20data-name%3D%22Livello%202%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2224.88%22%20%20height%3D%2224.14%22%20%20viewBox%3D%220%200%2024.88%2024.14%22%3E%20%20%3Cdefs%3E%20%20%20%20%3Cstyle%3E%20%20%20%20%20%20.markup-1%20%7B%20%20%20%20%20%20%20%20fill%3A%20%23fff%3B%20%20%20%20%20%20%7D%20%20%20%20%20%20.markup-2%20%7B%20%20%20%20%20%20%20%20fill%3A%20%233a3c3e%3B%20%20%20%20%20%20%7D%20%20%20%20%3C%2Fstyle%3E%20%20%3C%2Fdefs%3E%20%20%3Cg%20id%3D%22Livello_1-2%22%20data-name%3D%22Livello%201%22%3E%20%20%20%20%3Cg%20id%3D%22Symbol%22%3E%20%20%20%20%20%20%3Cg%20id%3D%22Unione_2-2%22%20data-name%3D%22Unione%202-2%22%3E%20%20%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20%20class%3D%22markup-2%22%20%20%20%20%20%20%20%20%20%20d%3D%22m2.79%2C23.63h0c-1.37-.12-2.39-1.34-2.28-2.71l.76-9.18c0-.23.02-.47.04-.7.27-3.07%2C1.72-5.86%2C4.08-7.84C7.76%2C1.22%2C10.76.28%2C13.83.55s5.86%2C1.72%2C7.84%2C4.08c1.98%2C2.36%2C2.93%2C5.36%2C2.66%2C8.43s-1.68%2C5.78-3.99%2C7.76c-2.3%2C1.97-5.22%2C2.95-8.24%2C2.76-.61%2C0-1.37%2C0-2.27-.03-2.31-.06-6.73.09-6.77.09h0s0%2C0%2C0%2C0c-.08%2C0-.17%2C0-.25%2C0h0Z%22%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20%20class%3D%22markup-1%22%20%20%20%20%20%20%20%20%20%20d%3D%22m2.84%2C23.13c.07%2C0%2C.14%2C0%2C.2%2C0%2C0%2C0%2C4.45-.15%2C6.81-.09%2C1.07.03%2C1.79.03%2C2.27.03%2C5.97.39%2C11.19-4.07%2C11.71-10.06.53-6.08-3.96-11.44-10.04-11.97S2.35%2C5.01%2C1.82%2C11.09c-.02.23-.03.46-.04.68l-.77%2C9.19c-.09%2C1.11.74%2C2.07%2C1.82%2C2.17m-.09%2C1h0c-1.65-.14-2.87-1.6-2.74-3.25l.76-9.16c0-.24.02-.48.04-.71.28-3.21%2C1.8-6.11%2C4.26-8.18S10.67-.23%2C13.88.05s6.11%2C1.8%2C8.18%2C4.26c2.07%2C2.47%2C3.05%2C5.59%2C2.77%2C8.8s-1.76%2C6.03-4.16%2C8.1c-2.39%2C2.05-5.44%2C3.07-8.58%2C2.88-.61%2C0-1.37%2C0-2.27-.03-2.3-.06-6.7.09-6.74.09h-.02c-.1%2C0-.2%2C0-.3-.01h0Z%22%20%20%20%20%20%20%20%20%2F%3E%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%3Cg%20id%3D%22Ellisse_3272%22%20data-name%3D%22Ellisse%203272%22%3E%20%20%20%20%20%20%20%20%3Ccircle%20class%3D%22markup-1%22%20cx%3D%2212.43%22%20cy%3D%2212.1%22%20r%3D%226.71%22%20%2F%3E%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var panorama = "data:image/svg+xml,%3Csvg%20%20id%3D%22Panorama%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%2216%22%20%20height%3D%2216%22%20%20viewBox%3D%220%200%2016%2016%22%3E%20%20%3Crect%20%20%20%20id%3D%22Rettangolo_1401%22%20%20%20%20data-name%3D%22Rettangolo%201401%22%20%20%20%20width%3D%2216%22%20%20%20%20height%3D%2216%22%20%20%20%20fill%3D%22none%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20id%3D%22Tracciato_985%22%20%20%20%20data-name%3D%22Tracciato%20985%22%20%20%20%20d%3D%22M11235.762%2C896.649a14.238%2C14.238%2C0%2C0%2C0-13.3%2C0%2C.88.88%2C0%2C0%2C0-.46.78v9.127a14.236%2C14.236%2C0%2C0%2C1%2C14.222%2C0v-9.127A.878.878%2C0%2C0%2C0%2C11235.762%2C896.649Zm-6.65-.76a13.333%2C13.333%2C0%2C0%2C1%2C6.1%2C1.476.227.227%2C0%2C0%2C1%2C.121.2v3.985l-3.265.656-2.465-1.324-1.681.9-2.686-1.79-2.355%2C1.571-.006-4a.229.229%2C0%2C0%2C1%2C.122-.2A13.358%2C13.358%2C0%2C0%2C1%2C11229.111%2C895.889Zm0%2C7.875a15.13%2C15.13%2C0%2C0%2C0-6.225%2C1.339l0-3%2C2.354-1.571%2C2.66%2C1.773%2C1.706-.917%2C2.4%2C1.287%2C3.334-.67v3.1A15.125%2C15.125%2C0%2C0%2C0%2C11229.111%2C903.764Z%22%20%20%20%20transform%3D%22translate%28-11221.111%20-892.778%29%22%20%20%20%20fill%3D%22currentColor%22%20%20%2F%3E%3C%2Fsvg%3E";

var pivot = "data:image/svg+xml,%3Csvg%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20width%3D%22300%22%20%20height%3D%22300%22%20%20viewBox%3D%220%200%20300%20300%22%3E%20%20%3Ccircle%20%20%20%20id%3D%22Ellisse_3115%22%20%20%20%20data-name%3D%22Ellisse%203116%22%20%20%20%20cx%3D%22150%22%20%20%20%20cy%3D%22150%22%20%20%20%20r%3D%22150%22%20%20%20%20fill%3D%22%23ffffff%22%20%20%2F%3E%20%20%3Ccircle%20%20%20%20id%3D%22Ellisse_3116%22%20%20%20%20data-name%3D%22Ellisse%203116%22%20%20%20%20cx%3D%22150%22%20%20%20%20cy%3D%22150%22%20%20%20%20r%3D%22100%22%20%20%20%20fill%3D%22%23FF7F00%22%20%20%2F%3E%3C%2Fsvg%3E";

var userLocationNoFov = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20%20version%3D%221.1%22%20%20id%3D%22Layer_1%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20%20x%3D%220px%22%20%20y%3D%220px%22%20%20width%3D%224059.9px%22%20%20height%3D%224059.9px%22%20%20viewBox%3D%220%200%204059.9%204059.9%22%20%20style%3D%22enable-background%3A%20new%200%200%204059.9%204059.9%22%20%20xml%3Aspace%3D%22preserve%22%3E%20%20%3Cg%20fill%3D%22%23FFFFFF%22%3E%20%20%20%20%3Ccircle%20cx%3D%222029.9%22%20cy%3D%222029.9%22%20r%3D%22725%22%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%20fill%3D%22%23082A6E%22%3E%20%20%20%20%3Ccircle%20cx%3D%222029.9%22%20cy%3D%222029.9%22%20r%3D%22660.5%22%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%20fill%3D%22%23FFFFFF%22%3E%20%20%20%20%3Ccircle%20cx%3D%222029.9%22%20cy%3D%222029.9%22%20r%3D%22330%22%20%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var waypoint_flashscan_selected = "data:image/svg+xml,%3Csvg%20%20width%3D%2232%22%20%20height%3D%2232%22%20%20viewBox%3D%220%200%2032%2032%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20d%3D%22M16%2032C24.8366%2032%2032%2024.8366%2032%2016C32%207.16344%2024.8366%200%2016%200C7.16344%200%200%207.16344%200%2016C0%2024.8366%207.16344%2032%2016%2032Z%22%20%20%20%20fill%3D%22black%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M16.0001%2029.4405C23.4228%2029.4405%2029.4401%2023.4233%2029.4401%2016.0005C29.4401%208.57784%2023.4228%202.56055%2016.0001%202.56055C8.57735%202.56055%202.56006%208.57784%202.56006%2016.0005C2.56006%2023.4233%208.57735%2029.4405%2016.0001%2029.4405Z%22%20%20%20%20fill%3D%22%231F65F0%22%20%20%2F%3E%20%20%3Cg%20clip-path%3D%22url%28%23clip0_13582_148448%29%22%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M21.2346%207.04004L18.1146%2014.27H22.0266L10.8186%2025.04L13.9386%2017.8101H10.0266L21.2346%207.04004Z%22%20%20%20%20%20%20fill%3D%22white%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cdefs%3E%20%20%20%20%3CclipPath%20id%3D%22clip0_13582_148448%22%3E%20%20%20%20%20%20%3Crect%20width%3D%2232%22%20height%3D%2232%22%20fill%3D%22white%22%20%2F%3E%20%20%20%20%3C%2FclipPath%3E%20%20%3C%2Fdefs%3E%3C%2Fsvg%3E";

var waypoint_selected = "data:image/svg+xml,%3Csvg%20%20width%3D%22350%22%20%20height%3D%22350%22%20%20viewBox%3D%220%200%20350%20350%22%20%20fill%3D%22none%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20%20%20%20d%3D%22M175%20350C271.65%20350%20350%20271.65%20350%20175C350%2078.3502%20271.65%200%20175%200C78.3502%200%200%2078.3502%200%20175C0%20271.65%2078.3502%20350%20175%20350Z%22%20%20%20%20fill%3D%22black%22%20%20%2F%3E%20%20%3Cpath%20%20%20%20d%3D%22M175%20312C250.663%20312%20312%20250.663%20312%20175C312%2099.337%20250.663%2038%20175%2038C99.337%2038%2038%2099.337%2038%20175C38%20250.663%2099.337%20312%20175%20312Z%22%20%20%20%20fill%3D%22%231F65F0%22%20%20%2F%3E%20%20%3Cg%20clip-path%3D%22url%28%23clip0_13532_207309%29%22%3E%20%20%20%20%3Cpath%20%20%20%20%20%20d%3D%22M175%20221.666C200.773%20221.666%20221.667%20200.773%20221.667%20175C221.667%20149.226%20200.773%20128.333%20175%20128.333C149.227%20128.333%20128.333%20149.226%20128.333%20175C128.333%20200.773%20149.227%20221.666%20175%20221.666Z%22%20%20%20%20%20%20fill%3D%22white%22%20%20%20%20%2F%3E%20%20%3C%2Fg%3E%20%20%3Cdefs%3E%20%20%20%20%3CclipPath%20id%3D%22clip0_13532_207309%22%3E%20%20%20%20%20%20%3Crect%20width%3D%22350%22%20height%3D%22350%22%20fill%3D%22white%22%20%2F%3E%20%20%20%20%3C%2FclipPath%3E%20%20%3C%2Fdefs%3E%3C%2Fsvg%3E";

// These center offsets will put the origin of the cursor at the center of the svg
// The height and width of the svg CrosshairWithCircle is 90
const CROSSHAIR_CENTER = 45;
// The height and width of the svgs LensDefault & LensActive is 128.
const LENS_CENTER = 64;

/**
 * @returns Content for toast notifications
 *
 * forwardRef has to be used to get compatibility with notistack
 */
const ToastContainer = forwardRef(function ToastContainer({ children, variant, title, sx, onClose }, ref) {
    return (jsxs(Stack, { direction: "column", ref: ref, sx: {
            backgroundColor: `${variant}.light`,
            maxWidth: "480px",
            width: "fit-content",
            border: `1px solid ${neutral[1000]}20`,
            // Make sure the background color does not affect (blend) with the border color
            backgroundClip: "padding-box",
            borderRadius: "4px",
            filter: `drop-shadow(0px 2px 6px ${neutral[1000]}40)`,
        }, children: [jsx(Alert, { title: title, variant: variant, action: jsx(FaroIconButton, { size: "xs", color: neutral[600], onClick: onClose, children: jsx(CloseIcon, {}) }), 
                // Add more space between the icon and the title, by changing the alert's container gap value
                sx: {
                    pt: 2,
                    ">*>.MuiStack-root": { gap: 2 },
                    ">.MuiAlert-message": {
                        // Align the title and icon with the X button
                        display: "flex",
                        alignItems: "center",
                        py: 0,
                    },
                    ">.MuiAlert-action": {
                        // Remove top padding from X button so that it is aligned with the rest of the content of the alert
                        pt: 0,
                        alignSelf: "center",
                        mr: 0,
                    },
                    ...sx,
                } }), jsx(Box, { component: "div", children: children })] }));
});
/** @returns A common UI for snackbars */
const FaroToast = forwardRef(function Toast({ title, variant = "success", message, onClose, image, action }, ref) {
    const isEmpty = useMemo(() => !message && !image && !action, [action, image, message]);
    return (jsx(ToastContainer, { ref: ref, title: title, variant: variant, 
        // Remove extra padding between title and the toast's content if it's present
        sx: { pb: isEmpty ? 2 : 0 }, onClose: onClose, children: jsxs(Stack, { direction: "column", 
            // Add margin left so that the content starts at the same place as the title
            sx: { ml: "52px", mt: isEmpty ? 0 : 1, mb: isEmpty ? 0 : 2 }, children: [message && (jsx(FaroText, { variant: "bodyM", sx: {
                        mr: "52px",
                        mb: !!image || !!action ? 2 : 0,
                        whiteSpace: "pre-line",
                    }, children: message })), jsxs(Stack, { direction: "row", justifyContent: "end", 
                    // Keep the distance between the title or message and the image/action always 16px
                    sx: { mt: !isEmpty && !message ? 1 : 0, mr: 2 }, children: [image && (jsx(SvgIcon, { component: image, inheritViewBox: true, sx: { ml: 0, mr: "auto", mt: "auto", mb: 0 } })), action && (jsx(FaroButton, { "aria-label": action.label, variant: "ghost", onClick: () => {
                                action.onClicked();
                                onClose();
                            }, children: action.label }))] })] }) }));
});

/** A context to be able to expose notistack functions inside R3F using a ContextBridge */
const ToastContext = createContext(undefined);
/** @returns the current bound ToastContext */
function useToastContext() {
    const ctx = useContext(ToastContext);
    assert(ctx, "useToastContext should be used only inside a ToastContext");
    return ctx;
}

/**
 * @returns Necessary context to allow usage of the useToast hook
 */
function ToastProvider({ children, }) {
    return (jsx(SnackbarProvider, { children: jsx(NotistackContextBridge, { children: children }) }));
}
/** @returns a component that will bridge the notistack hidden context in our own ToastContext */
function NotistackContextBridge({ children }) {
    const snackbarContext = useSnackbar();
    return (jsx(ToastContext.Provider, { value: snackbarContext, children: children }));
}

/**
 * Hook providing the means to open and close toast notifications, opening in centered at the top of the screen
 *
 * Important: can only be used within a React tree that is wrapped inside the ToastProvider component (at some point above)
 *
 * @returns Two functions two handle toasts
 */
function useToast() {
    const { enqueueSnackbar, closeSnackbar } = useToastContext();
    const openToast = useCallback(({ message, key, variant = "success", title, persist = variant === "error", image, action, preventDuplicate = true, onClose, }) => enqueueSnackbar(message ?? "", {
        preventDuplicate,
        anchorOrigin: {
            vertical: "top",
            horizontal: "center",
        },
        key,
        // TODO: Remove use of the deprecated content property (https://faro01.atlassian.net/browse/SWEB-4818)
        content: (key, message) => (jsx(FaroToast, { title: title, variant: variant, message: message, image: image, action: action, onClose: () => closeSnackbar(key) }, key)),
        persist,
        onClose,
    }), [closeSnackbar, enqueueSnackbar]);
    const closeToast = useCallback((toastKey) => {
        closeSnackbar(toastKey);
    }, [closeSnackbar]);
    return {
        openToast,
        closeToast,
    };
}

export { ActionTextField, AddLabelIcon, Alert, AlertVariants, AlignIcon, AlignToModelIcon, AlignToPointCloudIcon, AlignToSheetIcon, AnalysisMarkerIcon, AnchorIcon, AnnotationIcon, AnnouncementIcon, AppBar, area as Area, area2 as Area2, Area2Icon, AreaIcon, arrowDown as ArrowDown, ArrowDown2Icon, ArrowDownIcon, arrowRight as ArrowRight, ArrowRightIcon, attachment as Attachment, AttachmentIcon, AutoClipCurrentViewIcon, AutodeskIcon, Banner, BaseAvatarIcon, BreadcrumbItem, buildingElevation as BuildingElevation, BuildingElevationIcon, Button, CROSSHAIR_CENTER, CadSmallIcon, CalendarIcon, cameraOrthographic as CameraOrthographic, cameraPerspective as CameraPerspective, CameraVideoTrajectorySmallIcon, CardItem, CardList, CardSelector, ChangeIndicatorBadge, chat as Chat, ChatIcon, checkmark2 as CheckMark2, checkmarkCircleFill as CheckMarkCircleFill, Checkmark2Icon, Checkmark3Icon, Checkmark4Icon, CheckmarkCircleFillIcon, CheckmarkIcon, CircularProgress, ClipboxExportIcon, ClippingBoxIcon, clock as Clock, ClockSmallIcon, close as Close, closeCancelError as CloseCancelError, CloseCancelErrorIcon, CloseIcon, CloudConnectionIcon, CloudIcon, CloudProcessingGraphicIcon, CloudUploadIcon, clusterLocation as ClusterLocation, ColorBar, CompassGoToIcon, ContextualToolbar, CoordinatesGearIcon, CoordinatesIcon, coordinatesX as CoordinatesX, CoordinatesXIcon, coordinatesY as CoordinatesY, CoordinatesYIcon, coordinatesZ as CoordinatesZ, CoordinatesZIcon, copy as Copy, copyFile as CopyFile, CopyFileIcon, CopyIcon, CopyToClipboardButton, CropIcon, crosshair_marker_blue as CrosshairMarkerBlue, crosshair_marker_orange as CrosshairMarkerOrange, crosshair_with_circle as CrosshairWithCircle, CursorStyle, DEFAULT_FIELD_WIDTH, _3dData as Data3d, Data3dIcon, DataCollectionConsent, DatePicker, DatePickerVariant, _delete as Delete, DeleteIcon, DialogContext, DialogProvider, disabled as Disabled, DisabledIcon, distanceHorizontal as DistanceHorizontal, DistanceHorizontalIcon, distanceVertical as DistanceVertical, DistanceVerticalIcon, dollhouse as Dollhouse, DollhouseIcon, DollhouseWarningIcon, dots_vertical as DotsVertical, download as Download, DownloadIcon, DropHandler, Dropdown, DropdownSelect, edit as Edit, EditIcon, email_sent as EmailSent, SvgEmailSent as EmailSentSvg, ErrorDetailsPage, ErrorIcon, error_page as ErrorPage, SvgErrorPage as ErrorPageSvg, ExchangeArrowsIcon, exclamationmark as ExclamationMark, exclamationMarkCircleFill as ExclamationMarkCircleFill, ExclamationMarkCircleFillIcon, ExclamationMarkIcon, ExitFullScreenIcon, expand as Expand, ExpandIcon, ExperimentalIcon, ExportIcon, exportPointCloud as ExportPointCloud, ExportPointCloudIcon, ExtractCrossSectionIcon, FaroBreadcrumbs, FaroButton, FaroButtonSizes, FaroButtonVariants, FaroChip, FaroChipFilter, FaroChipList, FaroChipOptions, FaroChipStatus, FaroChipTag, FaroChipToggle, FaroDialog, FaroDialogSizes, FaroIconButton, FaroIconButtonSizes, faroLogo as FaroLogo, FaroLogoCompactIcon, FaroLogoIcon, FaroMenu, FaroMenuItem, FaroMenuSection, FaroMenuSeparator, FaroPopover, FaroRadio, FaroRadioGroup, FaroRichTextEditor, FaroRichTextViewer, FaroSlider, FaroChipStatus as FaroStatusTag, FaroStatusText, FaroStepIcon, FaroStepper, FaroSvgIcon, FaroSwitch, FaroTabs, FaroTabsItem, FaroChip as FaroTag, FaroText, FaroTextVariant, FaroThemeOptions, FaroToast, FaroTooltip, FaroVar, feedback as Feedback, FeedbackDialog, FeedbackIcon, FileDetailsList, FileDocumentIcon, FileImageIcon, FileProgress, FileProgressCircular, FilterIcon, FilterMenu, FilterMenuContent, FindCheckmarkIcon, flagMarker as FlagMarker, flagMarkerHovered as FlagMarkerHovered, flagMarkerSelected as FlagMarkerSelected, FlagSmallIcon, FloatingWindow, folder as Folder, FolderSmallIcon, FontWeights, Footer, FullScreenIcon, GeoReferenceIcon, grid as Grid, GridIcon, hblogo_blacktext as HBLogoBlackText, HBLogoBlackTextIcon, HamburgerMenuIcon, HappyFaceIcon, HeaderBar, HeatmapIcon, help as Help, HelpBanner, HelpCenterIcon, HelpCenterMenu, HelpIcon, HistoryRedoIcon, HistoryUndoIcon, home as Home, HomeIcon, HorizontalScrollList, IconButton, Img360SmallIcon, inprogress as InProgress, InProgressIcon, info as Info, infoCircleFill as InfoCircleFill, InfoCircleFillIcon, InfoIcon, IntensityPanoIcon, LENS_CENTER, LanguageCodes, LanguageSelectOption, LayersIcon, LayoutSheetSmallIcon, length as Length, LengthIcon, lensActive as LensActive, lensDefault as LensDefault, lensNoCircle as LensNoCircle, lineHandler as LineHandler, linkiconHorizontal as LinkHorizontal, LinkHorizontalIcon, LoadingScreen, locationMap as LocationMap, LocationMapIcon, locationMarkerPopover as LocationMarkerPopoverImg, Location_FullOpaque as LocationOpaque, location_placeholder_default as LocationPlaceholderDefault, location_placeholder_hover as LocationPlaceholderHover, Location as LocationTransparent, LockRotationIcon, MIN_PASSWORD_LENGTH, map as Map, mapLarge as MapLarge, MapLargeIcon, mapPlaceholderDefault as MapPlaceholderDefault, MapPlaceholderDefaultIcon, mapPlaceholderHover as MapPlaceholderHovered, MapPlaceholderHoveredIcon, mapPlaceholderSelected as MapPlaceholderSelected, mapPlaceholderSelectedHover as MapPlaceholderSelectedHovered, MapPlaceholderSelectedHoveredIcon, MapPlaceholderSelectedIcon, markup as Markup, markupPolygon as MarkupPolygon, MarkupPolygonIcon, MeasurePointIcon, measureShowAxes as MeasureShowAxes, MeasureShowAxesIcon, MeasurementIcon, MeasurementMarkerIcon, measures as Measures, MeasuresIcon, MenuAccountSecurityOption, MenuSignOutOption, ModelDollhouseIcon, MoveElementIcon, NO_TRANSLATE_CLASS, NoTranslate, NonVisibleIcon, OpacitySettingsIcon, OpenLinkIcon, OrthographicCameraIcon, OverlayDataIcon, panorama as Panorama, PasswordValidationChecker, perimeter as Perimeter, PerimeterIcon, PerspectiveCameraIcon, phone as Phone, PhoneIcon, pin as Pin, pin_colored as PinColored, PinColoredIcon, PinIcon, pivot as Pivot, plusCircle as PlusCircle, PlusCircleIcon, PlusIcon, pointCloud as PointCloud, PointCloudAnalysisColormapIcon, PointCloudAnalysisIcon, PointCloudAnalysisReferencePlaneIcon, PointCloudFlashSmallIcon, PointCloudIcon, PointCloudImageSmallIcon, PointCloudSmallIcon, PointCloudTrajectorySmallIcon, PointCloudWarningSmallIcon, PointCloudZAxisIcon, PopoverChip, ProcoreIcon, questionMarkInCircle as QuestionMarkInCircle, QuestionMarkInCircleIcon, RecenterViewIcon, RegistrationInteractiveIcon, RegularFaceIcon, RemainingTimeLabel, ResetIcon, ResetScaleIcon, RevitIcon, RotateClockwiseIcon, RulerIcon, running as Running, RunningIcon, ScanClusterIcon, ScanIcon, school as School, SchoolIcon, search as Search, SearchIcon, SettingsIcon, ShareLinkIcon, SheetNewIcon, SheetSaturationToggleIcon, shieldWarning as ShieldWarning, ShieldWarningIcon, SidebarContainer, SidebarMenu, SidebarMenuButton, SidebarMenuButtonList, SingleCardItem, SingleSelectItem, sliderHandler as SliderHandler, SliderHandlerIcon, SortDownIcon, SortIcon, SortUpIcon, SphereXGIcon, SphereXGTextIcon, splitscreenStart as SplitscreenStart, SplitscreenStartIcon, SyncCamerasOnWaypointIcon, TagsAddIcon, TagsDeleteIcon, TagsIcon, TagsManageIcon, TextField, ThreeDotsIcon, TimeDistanceIcon, ToastContext, ToastProvider, ToggleButton, ToggleIconButton, ToolBadge, ToolButton, ToolGroup, ToolHeaderBar, ToolIcon, Toolbar, TooltipLight, TrajectoryAlignIcon, TrajectoryCorrectionIcon, TranslateVar, TruncatedFaroText, TruncatedFaroTextWithSuffix, TruncatedText, USER_AVATAR_STYLE_MAP, UnhappyFaceIcon, Update360TransformationIcon, upload as Upload, UploadIcon, UserAvatar, UserAvatarDisplayOptions, UserAvatarSizes, userLocation as UserLocation, UserLocationIcon, userLocationNoFov as UserLocationNoFov, UserMenu, videoCamera as VideoCamera, VideoCameraIcon, VideoIcon, ViewOptionsIcon, viewPredefinedBack as ViewPredefinedBack, ViewPredefinedBackIcon, viewPredefinedBottom as ViewPredefinedBottom, ViewPredefinedBottomIcon, viewPredefinedFront as ViewPredefinedFront, ViewPredefinedFrontIcon, viewPredefinedLeft as ViewPredefinedLeft, ViewPredefinedLeftIcon, viewPredefinedRight as ViewPredefinedRight, ViewPredefinedRightIcon, viewPredefinedTop as ViewPredefinedTop, ViewPredefinedTopIcon, views as Views, ViewsIcon, VisibleIcon, warning as Warning, WarningIcon, waypoint_flashscan_selected as WaypointFlashScanSelected, waypoint_selected as WaypointSelected, WorldCoordinateIcon, xmarkCircleFill as XMarkCircleFill, XMarkCircleFillIcon, ZoomAllIcon, blue, codeToLanguageCodes, computeRotatedImageDimensions, cyan$1 as cyan, dataComparisonColors, dataComparisonColorsSorted, generateThumbnailBlob, generateThumbnailCanvas, getUserInitials, green, interpolateColor, interpolateColorFromList, isDivider, isOption, isSupportedLanguageObject, neutral, orange, parseImageFromFile, purple, red, removeExtraSpaces, resizeImage, useBreakpointLgUp, useBreakpointMdUp, useBreakpointSmUp, useBreakpointXXlUp, useBreakpointXlUp, useBreakpointXsUp, useCheckForOverflow, useCustomCursor, useDialog, useHorizontalResize, useToast, useToastContext, variantMap, yellow };
